/**
 * Third-party vendor bundle, converted to readable identifiers in place
 * (renaming-only; behaviour verified unchanged by AST alpha-equivalence
 * against the shipped minified build). Naming derives from the bundle's own
 * setFunctionName debug labels, i.e. the original source names.
 *
 * Contents: Swiper 11.1.15 (+modules), Plyr 3.7.8, axios 1.7.7 (exported)
 * and 0.21.4 (internal cart transport), noUiSlider 15.8.1, biggerPicture
 * 1.1.17, strongly-typed-events, query-string 6.x, lodash debounce/throttle,
 * @googlemaps/js-api-loader, punycode, React 17.0.2 (bundled, unreferenced),
 * and the ESC/SALVO component framework (registration, cart, logging).
 *
 * Contract keeps: window.__SALVO__, __SALVO_EXPECT_CART_REQUESTS, the
 * fetch/XHR patching that detects third-party cart requests, and the
 * registerComponent filename->kebab tag derivation. Do not rename these.
 */
var Rb = Object.defineProperty;
var o = (t, e) => Rb(t, "name", {
  value: e,
  configurable: !0
});
var On = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
o(getDefaultExportFromCjs, "getDefaultExportFromCjs");
function getAugmentedNamespace(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var a = o(function r() {
      if (this instanceof r) {
        var i = [null];
        i.push.apply(i, arguments);
        var s = Function.bind.apply(e, i);
        return new s();
      }
      return e.apply(this, arguments);
    }, "a");
    a.prototype = e.prototype;
  } else a = {};
  return Object.defineProperty(a, "__esModule", {
    value: !0
  }), Object.keys(t).forEach(function (r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(a, r, i.get ? i : {
      enumerable: !0,
      get: function () {
        return t[r];
      }
    });
  }), a;
}
o(getAugmentedNamespace, "getAugmentedNamespace");
var dist = {},
  Yl = {},
  Xi = {},
  Sp;
function requireDispatcherBase() {
  if (Sp) return Xi;
  Sp = 1, Object.defineProperty(Xi, "__esModule", {
    value: !0
  }), Xi.DispatcherBase = void 0;
  const t = requireDist();
  let DispatcherBase = o(class {
    constructor() {
      this._subscriptions = new Array();
    }
    get count() {
      return this._subscriptions.length;
    }
    get onSubscriptionChange() {
      return this._onSubscriptionChange == null && (this._onSubscriptionChange = new t.SubscriptionChangeEventDispatcher()), this._onSubscriptionChange.asEvent();
    }
    subscribe(r) {
      return r && (this._subscriptions.push(this.createSubscription(r, !1)), this.triggerSubscriptionChange()), () => {
        this.unsubscribe(r);
      };
    }
    sub(r) {
      return this.subscribe(r);
    }
    one(r) {
      return r && (this._subscriptions.push(this.createSubscription(r, !0)), this.triggerSubscriptionChange()), () => {
        this.unsubscribe(r);
      };
    }
    has(r) {
      return r ? this._subscriptions.some(i => i.handler == r) : !1;
    }
    unsubscribe(r) {
      if (!r) return;
      let i = !1;
      for (let s = 0; s < this._subscriptions.length; s++) if (this._subscriptions[s].handler == r) {
        this._subscriptions.splice(s, 1), i = !0;
        break;
      }
      i && this.triggerSubscriptionChange();
    }
    unsub(r) {
      this.unsubscribe(r);
    }
    _dispatch(r, i, s) {
      for (let a of [...this._subscriptions]) {
        let l = new t.EventManagement(() => this.unsub(a.handler)),
          u = Array.prototype.slice.call(s);
        if (u.push(l), a.execute(r, i, u), this.cleanup(a), !r && l.propagationStopped) return {
          propagationStopped: !0
        };
      }
      return r ? null : {
        propagationStopped: !1
      };
    }
    createSubscription(r, i) {
      return new t.Subscription(r, i);
    }
    cleanup(r) {
      let i = !1;
      if (r.isOnce && r.isExecuted) {
        let s = this._subscriptions.indexOf(r);
        s > -1 && (this._subscriptions.splice(s, 1), i = !0);
      }
      i && this.triggerSubscriptionChange();
    }
    asEvent() {
      return this._wrap == null && (this._wrap = new t.DispatcherWrapper(this)), this._wrap;
    }
    clear() {
      this._subscriptions.length != 0 && (this._subscriptions.splice(0, this._subscriptions.length), this.triggerSubscriptionChange());
    }
    triggerSubscriptionChange() {
      this._onSubscriptionChange != null && this._onSubscriptionChange.dispatch(this.count);
    }
  }, "DispatcherBase");
  return Xi.DispatcherBase = DispatcherBase, Xi;
}
o(requireDispatcherBase, "requireDispatcherBase");
var nl = {};
Object.defineProperty(nl, "__esModule", {
  value: !0
});
nl.DispatchError = void 0;
class DispatchError extends Error {
  constructor(e) {
    super(e);
  }
}
o(DispatchError, "DispatchError");
nl.DispatchError = DispatchError;
var rl = {};
Object.defineProperty(rl, "__esModule", {
  value: !0
});
rl.DispatcherWrapper = void 0;
class DispatcherWrapper {
  constructor(e) {
    this._subscribe = n => e.subscribe(n), this._unsubscribe = n => e.unsubscribe(n), this._one = n => e.one(n), this._has = n => e.has(n), this._clear = () => e.clear(), this._count = () => e.count, this._onSubscriptionChange = () => e.onSubscriptionChange;
  }
  get onSubscriptionChange() {
    return this._onSubscriptionChange();
  }
  get count() {
    return this._count();
  }
  subscribe(e) {
    return this._subscribe(e);
  }
  sub(e) {
    return this.subscribe(e);
  }
  unsubscribe(e) {
    this._unsubscribe(e);
  }
  unsub(e) {
    this.unsubscribe(e);
  }
  one(e) {
    return this._one(e);
  }
  has(e) {
    return this._has(e);
  }
  clear() {
    this._clear();
  }
}
o(DispatcherWrapper, "DispatcherWrapper");
rl.DispatcherWrapper = DispatcherWrapper;
var il = {};
Object.defineProperty(il, "__esModule", {
  value: !0
});
il.EventListBase = void 0;
class EventListBase {
  constructor() {
    this._events = {};
  }
  get(e) {
    let n = this._events[e];
    return n || (n = this.createDispatcher(), this._events[e] = n, n);
  }
  remove(e) {
    delete this._events[e];
  }
}
o(EventListBase, "EventListBase");
il.EventListBase = EventListBase;
var sl = {};
Object.defineProperty(sl, "__esModule", {
  value: !0
});
sl.EventManagement = void 0;
class EventManagement {
  constructor(e) {
    this.unsub = e, this.propagationStopped = !1;
  }
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
o(EventManagement, "EventManagement");
sl.EventManagement = EventManagement;
var ol = {};
Object.defineProperty(ol, "__esModule", {
  value: !0
});
ol.HandlingBase = void 0;
class HandlingBase {
  constructor(e) {
    this.events = e;
  }
  one(e, n) {
    this.events.get(e).one(n);
  }
  has(e, n) {
    return this.events.get(e).has(n);
  }
  subscribe(e, n) {
    this.events.get(e).subscribe(n);
  }
  sub(e, n) {
    this.subscribe(e, n);
  }
  unsubscribe(e, n) {
    this.events.get(e).unsubscribe(n);
  }
  unsub(e, n) {
    this.unsubscribe(e, n);
  }
}
o(HandlingBase, "HandlingBase");
ol.HandlingBase = HandlingBase;
var Yi = {},
  Ep;
function requirePromiseDispatcherBase() {
  if (Ep) return Yi;
  Ep = 1, Object.defineProperty(Yi, "__esModule", {
    value: !0
  }), Yi.PromiseDispatcherBase = void 0;
  const t = requireDist();
  let PromiseDispatcherBase = o(class extends t.DispatcherBase {
    _dispatch(r, i, s) {
      throw new t.DispatchError("_dispatch not supported. Use _dispatchAsPromise.");
    }
    createSubscription(r, i) {
      return new t.PromiseSubscription(r, i);
    }
    async _dispatchAsPromise(r, i, s) {
      for (let a of [...this._subscriptions]) {
        let l = new t.EventManagement(() => this.unsub(a.handler)),
          u = Array.prototype.slice.call(s);
        if (u.push(l), await a.execute(r, i, u), this.cleanup(a), !r && l.propagationStopped) return {
          propagationStopped: !0
        };
      }
      return r ? null : {
        propagationStopped: !1
      };
    }
  }, "PromiseDispatcherBase");
  return Yi.PromiseDispatcherBase = PromiseDispatcherBase, Yi;
}
o(requirePromiseDispatcherBase, "requirePromiseDispatcherBase");
var al = {};
Object.defineProperty(al, "__esModule", {
  value: !0
});
al.PromiseSubscription = void 0;
class PromiseSubscription {
  constructor(e, n) {
    this.handler = e, this.isOnce = n, this.isExecuted = !1;
  }
  async execute(e, n, r) {
    if (!this.isOnce || !this.isExecuted) {
      this.isExecuted = !0;
      var i = this.handler;
      if (e) {
        setTimeout(() => {
          i.apply(n, r);
        }, 1);
        return;
      }
      await i.apply(n, r);
    }
  }
}
o(PromiseSubscription, "PromiseSubscription");
al.PromiseSubscription = PromiseSubscription;
var ll = {};
Object.defineProperty(ll, "__esModule", {
  value: !0
});
ll.Subscription = void 0;
class Subscription {
  constructor(e, n) {
    this.handler = e, this.isOnce = n, this.isExecuted = !1;
  }
  execute(e, n, r) {
    if (!this.isOnce || !this.isExecuted) {
      this.isExecuted = !0;
      var i = this.handler;
      e ? setTimeout(() => {
        i.apply(n, r);
      }, 1) : i.apply(n, r);
    }
  }
}
o(Subscription, "Subscription");
ll.Subscription = Subscription;
var Ki = {},
  Tp;
function requireSubscriptionChangeEventHandler() {
  if (Tp) return Ki;
  Tp = 1, Object.defineProperty(Ki, "__esModule", {
    value: !0
  }), Ki.SubscriptionChangeEventDispatcher = void 0;
  const t = requireDist();
  class SubscriptionChangeEventDispatcher extends t.DispatcherBase {
    dispatch(r) {
      this._dispatch(!1, this, arguments);
    }
  }
  return o(SubscriptionChangeEventDispatcher, "SubscriptionChangeEventDispatcher"), Ki.SubscriptionChangeEventDispatcher = SubscriptionChangeEventDispatcher, Ki;
}
o(requireSubscriptionChangeEventHandler, "requireSubscriptionChangeEventHandler");
var Pp;
function requireDist() {
  return Pp || (Pp = 1, function (t) {
    /*!
    * Strongly Typed Events for TypeScript - Core
    * https://github.com/KeesCBakker/StronlyTypedEvents/
    * http://keestalkstech.com
    *
    * Copyright Kees C. Bakker / KeesTalksTech
    * Released under the MIT license
    */
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SubscriptionChangeEventDispatcher = t.HandlingBase = t.PromiseDispatcherBase = t.PromiseSubscription = t.DispatchError = t.EventManagement = t.EventListBase = t.DispatcherWrapper = t.DispatcherBase = t.Subscription = void 0;
    const e = requireDispatcherBase();
    Object.defineProperty(t, "DispatcherBase", {
      enumerable: !0,
      get: function () {
        return e.DispatcherBase;
      }
    });
    const n = nl;
    Object.defineProperty(t, "DispatchError", {
      enumerable: !0,
      get: function () {
        return n.DispatchError;
      }
    });
    const r = rl;
    Object.defineProperty(t, "DispatcherWrapper", {
      enumerable: !0,
      get: function () {
        return r.DispatcherWrapper;
      }
    });
    const i = il;
    Object.defineProperty(t, "EventListBase", {
      enumerable: !0,
      get: function () {
        return i.EventListBase;
      }
    });
    const s = sl;
    Object.defineProperty(t, "EventManagement", {
      enumerable: !0,
      get: function () {
        return s.EventManagement;
      }
    });
    const a = ol;
    Object.defineProperty(t, "HandlingBase", {
      enumerable: !0,
      get: function () {
        return a.HandlingBase;
      }
    });
    const l = requirePromiseDispatcherBase();
    Object.defineProperty(t, "PromiseDispatcherBase", {
      enumerable: !0,
      get: function () {
        return l.PromiseDispatcherBase;
      }
    });
    const u = al;
    Object.defineProperty(t, "PromiseSubscription", {
      enumerable: !0,
      get: function () {
        return u.PromiseSubscription;
      }
    });
    const c = ll;
    Object.defineProperty(t, "Subscription", {
      enumerable: !0,
      get: function () {
        return c.Subscription;
      }
    });
    const p = requireSubscriptionChangeEventHandler();
    Object.defineProperty(t, "SubscriptionChangeEventDispatcher", {
      enumerable: !0,
      get: function () {
        return p.SubscriptionChangeEventDispatcher;
      }
    });
  }(Yl)), Yl;
}
o(requireDist, "requireDist$2");
var fy = {},
  ki = {};
Object.defineProperty(ki, "__esModule", {
  value: !0
});
ki.EventDispatcher = void 0;
const Cp = requireDist();
class EventDispatcher extends Cp.DispatcherBase {
  constructor() {
    super();
  }
  dispatch(e, n) {
    const r = this._dispatch(!1, this, arguments);
    if (r == null) throw new Cp.DispatchError("Got `null` back from dispatch.");
    return r;
  }
  dispatchAsync(e, n) {
    this._dispatch(!0, this, arguments);
  }
  asEvent() {
    return super.asEvent();
  }
}
o(EventDispatcher, "EventDispatcher");
ki.EventDispatcher = EventDispatcher;
var ul = {},
  go = {};
Object.defineProperty(go, "__esModule", {
  value: !0
});
go.EventList = void 0;
const Bb = requireDist(),
  zb = ki;
class EventList extends Bb.EventListBase {
  constructor() {
    super();
  }
  createDispatcher() {
    return new zb.EventDispatcher();
  }
}
o(EventList, "EventList");
go.EventList = EventList;
Object.defineProperty(ul, "__esModule", {
  value: !0
});
ul.EventHandlingBase = void 0;
const Hb = requireDist(),
  Ub = go;
class EventHandlingBase extends Hb.HandlingBase {
  constructor() {
    super(new Ub.EventList());
  }
}
o(EventHandlingBase, "EventHandlingBase");
ul.EventHandlingBase = EventHandlingBase;
var cl = {};
Object.defineProperty(cl, "__esModule", {
  value: !0
});
cl.NonUniformEventList = void 0;
const qb = ki;
class NonUniformEventList {
  constructor() {
    this._events = {};
  }
  get(e) {
    if (this._events[e]) return this._events[e];
    const n = this.createDispatcher();
    return this._events[e] = n, n;
  }
  remove(e) {
    delete this._events[e];
  }
  createDispatcher() {
    return new qb.EventDispatcher();
  }
}
o(NonUniformEventList, "NonUniformEventList");
cl.NonUniformEventList = NonUniformEventList;
(function (t) {
  /*!
  * Strongly Typed Events for TypeScript - Core
  * https://github.com/KeesCBakker/StronlyTypedEvents/
  * http://keestalkstech.com
  *
  * Copyright Kees C. Bakker / KeesTalksTech
  * Released under the MIT license
  */
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NonUniformEventList = t.EventList = t.EventHandlingBase = t.EventDispatcher = void 0;
  const e = ki;
  Object.defineProperty(t, "EventDispatcher", {
    enumerable: !0,
    get: function () {
      return e.EventDispatcher;
    }
  });
  const n = ul;
  Object.defineProperty(t, "EventHandlingBase", {
    enumerable: !0,
    get: function () {
      return n.EventHandlingBase;
    }
  });
  const r = go;
  Object.defineProperty(t, "EventList", {
    enumerable: !0,
    get: function () {
      return r.EventList;
    }
  });
  const i = cl;
  Object.defineProperty(t, "NonUniformEventList", {
    enumerable: !0,
    get: function () {
      return i.NonUniformEventList;
    }
  });
})(fy);
var gy = {},
  _i = {};
Object.defineProperty(_i, "__esModule", {
  value: !0
});
_i.SimpleEventDispatcher = void 0;
const xp = requireDist();
class SimpleEventDispatcher extends xp.DispatcherBase {
  constructor() {
    super();
  }
  dispatch(e) {
    const n = this._dispatch(!1, this, arguments);
    if (n == null) throw new xp.DispatchError("Got `null` back from dispatch.");
    return n;
  }
  dispatchAsync(e) {
    this._dispatch(!0, this, arguments);
  }
  asEvent() {
    return super.asEvent();
  }
}
o(SimpleEventDispatcher, "SimpleEventDispatcher");
_i.SimpleEventDispatcher = SimpleEventDispatcher;
var fl = {},
  yo = {};
Object.defineProperty(yo, "__esModule", {
  value: !0
});
yo.SimpleEventList = void 0;
const Vb = requireDist(),
  Wb = _i;
class SimpleEventList extends Vb.EventListBase {
  constructor() {
    super();
  }
  createDispatcher() {
    return new Wb.SimpleEventDispatcher();
  }
}
o(SimpleEventList, "SimpleEventList");
yo.SimpleEventList = SimpleEventList;
Object.defineProperty(fl, "__esModule", {
  value: !0
});
fl.SimpleEventHandlingBase = void 0;
const Gb = requireDist(),
  Xb = yo;
class SimpleEventHandlingBase extends Gb.HandlingBase {
  constructor() {
    super(new Xb.SimpleEventList());
  }
}
o(SimpleEventHandlingBase, "SimpleEventHandlingBase");
fl.SimpleEventHandlingBase = SimpleEventHandlingBase;
var dl = {};
Object.defineProperty(dl, "__esModule", {
  value: !0
});
dl.NonUniformSimpleEventList = void 0;
const Yb = _i;
class NonUniformSimpleEventList {
  constructor() {
    this._events = {};
  }
  get(e) {
    if (this._events[e]) return this._events[e];
    const n = this.createDispatcher();
    return this._events[e] = n, n;
  }
  remove(e) {
    delete this._events[e];
  }
  createDispatcher() {
    return new Yb.SimpleEventDispatcher();
  }
}
o(NonUniformSimpleEventList, "NonUniformSimpleEventList");
dl.NonUniformSimpleEventList = NonUniformSimpleEventList;
(function (t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NonUniformSimpleEventList = t.SimpleEventList = t.SimpleEventHandlingBase = t.SimpleEventDispatcher = void 0;
  const e = _i;
  Object.defineProperty(t, "SimpleEventDispatcher", {
    enumerable: !0,
    get: function () {
      return e.SimpleEventDispatcher;
    }
  });
  const n = fl;
  Object.defineProperty(t, "SimpleEventHandlingBase", {
    enumerable: !0,
    get: function () {
      return n.SimpleEventHandlingBase;
    }
  });
  const r = dl;
  Object.defineProperty(t, "NonUniformSimpleEventList", {
    enumerable: !0,
    get: function () {
      return r.NonUniformSimpleEventList;
    }
  });
  const i = yo;
  Object.defineProperty(t, "SimpleEventList", {
    enumerable: !0,
    get: function () {
      return i.SimpleEventList;
    }
  });
})(gy);
var Kl = {},
  pl = {};
Object.defineProperty(pl, "__esModule", {
  value: !0
});
pl.SignalDispatcher = void 0;
const kp = requireDist();
class SignalDispatcher extends kp.DispatcherBase {
  dispatch() {
    const e = this._dispatch(!1, this, arguments);
    if (e == null) throw new kp.DispatchError("Got `null` back from dispatch.");
    return e;
  }
  dispatchAsync() {
    this._dispatch(!0, this, arguments);
  }
  asEvent() {
    return super.asEvent();
  }
}
o(SignalDispatcher, "SignalDispatcher");
pl.SignalDispatcher = SignalDispatcher;
var Qi = {},
  _p;
function requireSignalHandlingBase() {
  if (_p) return Qi;
  _p = 1, Object.defineProperty(Qi, "__esModule", {
    value: !0
  }), Qi.SignalHandlingBase = void 0;
  const t = requireDist(),
    e = requireDist$1();
  let SignalHandlingBase = o(class extends t.HandlingBase {
    constructor() {
      super(new e.SignalList());
    }
  }, "SignalHandlingBase");
  return Qi.SignalHandlingBase = SignalHandlingBase, Qi;
}
o(requireSignalHandlingBase, "requireSignalHandlingBase");
var Ji = {},
  Op;
function requireSignalList() {
  if (Op) return Ji;
  Op = 1, Object.defineProperty(Ji, "__esModule", {
    value: !0
  }), Ji.SignalList = void 0;
  const t = requireDist(),
    e = requireDist$1();
  let SignalList = o(class extends t.EventListBase {
    constructor() {
      super();
    }
    createDispatcher() {
      return new e.SignalDispatcher();
    }
  }, "SignalList");
  return Ji.SignalList = SignalList, Ji;
}
o(requireSignalList, "requireSignalList");
var Ap;
function requireDist$1() {
  return Ap || (Ap = 1, function (t) {
    /*!
    * Strongly Typed Events for TypeScript - Promise Signals
    * https://github.com/KeesCBakker/StronlyTypedEvents/
    * http://keestalkstech.com
    *
    * Copyright Kees C. Bakker / KeesTalksTech
    * Released under the MIT license
    */
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SignalList = t.SignalHandlingBase = t.SignalDispatcher = void 0;
    const e = pl;
    Object.defineProperty(t, "SignalDispatcher", {
      enumerable: !0,
      get: function () {
        return e.SignalDispatcher;
      }
    });
    const n = requireSignalHandlingBase();
    Object.defineProperty(t, "SignalHandlingBase", {
      enumerable: !0,
      get: function () {
        return n.SignalHandlingBase;
      }
    });
    const r = requireSignalList();
    Object.defineProperty(t, "SignalList", {
      enumerable: !0,
      get: function () {
        return r.SignalList;
      }
    });
  }(Kl)), Kl;
}
o(requireDist$1, "requireDist$1");
var Ey = {},
  Oi = {};
Object.defineProperty(Oi, "__esModule", {
  value: !0
});
Oi.PromiseEventDispatcher = void 0;
const Lp = requireDist();
class PromiseEventDispatcher extends Lp.PromiseDispatcherBase {
  constructor() {
    super();
  }
  async dispatch(e, n) {
    const r = await this._dispatchAsPromise(!1, this, arguments);
    if (r == null) throw new Lp.DispatchError("Got `null` back from dispatch.");
    return r;
  }
  dispatchAsync(e, n) {
    this._dispatchAsPromise(!0, this, arguments);
  }
  asEvent() {
    return super.asEvent();
  }
}
o(PromiseEventDispatcher, "PromiseEventDispatcher");
Oi.PromiseEventDispatcher = PromiseEventDispatcher;
var hl = {},
  vo = {};
Object.defineProperty(vo, "__esModule", {
  value: !0
});
vo.PromiseEventList = void 0;
const Jb = requireDist(),
  Zb = Oi;
class PromiseEventList extends Jb.EventListBase {
  constructor() {
    super();
  }
  createDispatcher() {
    return new Zb.PromiseEventDispatcher();
  }
}
o(PromiseEventList, "PromiseEventList");
vo.PromiseEventList = PromiseEventList;
Object.defineProperty(hl, "__esModule", {
  value: !0
});
hl.PromiseEventHandlingBase = void 0;
const e1 = requireDist(),
  t1 = vo;
class PromiseEventHandlingBase extends e1.HandlingBase {
  constructor() {
    super(new t1.PromiseEventList());
  }
}
o(PromiseEventHandlingBase, "PromiseEventHandlingBase");
hl.PromiseEventHandlingBase = PromiseEventHandlingBase;
var ml = {};
Object.defineProperty(ml, "__esModule", {
  value: !0
});
ml.NonUniformPromiseEventList = void 0;
const n1 = Oi;
class NonUniformPromiseEventList {
  constructor() {
    this._events = {};
  }
  get(e) {
    if (this._events[e]) return this._events[e];
    const n = this.createDispatcher();
    return this._events[e] = n, n;
  }
  remove(e) {
    delete this._events[e];
  }
  createDispatcher() {
    return new n1.PromiseEventDispatcher();
  }
}
o(NonUniformPromiseEventList, "NonUniformPromiseEventList");
ml.NonUniformPromiseEventList = NonUniformPromiseEventList;
(function (t) {
  /*!
  * Strongly Typed Events for TypeScript - Core
  * https://github.com/KeesCBakker/StronlyTypedEvents/
  * http://keestalkstech.com
  *
  * Copyright Kees C. Bakker / KeesTalksTech
  * Released under the MIT license
  */
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NonUniformPromiseEventList = t.PromiseEventList = t.PromiseEventHandlingBase = t.PromiseEventDispatcher = void 0;
  const e = Oi;
  Object.defineProperty(t, "PromiseEventDispatcher", {
    enumerable: !0,
    get: function () {
      return e.PromiseEventDispatcher;
    }
  });
  const n = hl;
  Object.defineProperty(t, "PromiseEventHandlingBase", {
    enumerable: !0,
    get: function () {
      return n.PromiseEventHandlingBase;
    }
  });
  const r = vo;
  Object.defineProperty(t, "PromiseEventList", {
    enumerable: !0,
    get: function () {
      return r.PromiseEventList;
    }
  });
  const i = ml;
  Object.defineProperty(t, "NonUniformPromiseEventList", {
    enumerable: !0,
    get: function () {
      return i.NonUniformPromiseEventList;
    }
  });
})(Ey);
var Ql = {},
  gl = {};
Object.defineProperty(gl, "__esModule", {
  value: !0
});
gl.PromiseSignalDispatcher = void 0;
const Mp = requireDist();
class PromiseSignalDispatcher extends Mp.PromiseDispatcherBase {
  constructor() {
    super();
  }
  async dispatch() {
    const e = await this._dispatchAsPromise(!1, this, arguments);
    if (e == null) throw new Mp.DispatchError("Got `null` back from dispatch.");
    return e;
  }
  dispatchAsync() {
    this._dispatchAsPromise(!0, this, arguments);
  }
  asEvent() {
    return super.asEvent();
  }
}
o(PromiseSignalDispatcher, "PromiseSignalDispatcher");
gl.PromiseSignalDispatcher = PromiseSignalDispatcher;
var Zi = {},
  es = {},
  Dp;
function requirePromiseSignalList() {
  if (Dp) return es;
  Dp = 1, Object.defineProperty(es, "__esModule", {
    value: !0
  }), es.PromiseSignalList = void 0;
  const t = requireDist(),
    e = requireDist$2();
  let PromiseSignalList = o(class extends t.EventListBase {
    constructor() {
      super();
    }
    createDispatcher() {
      return new e.PromiseSignalDispatcher();
    }
  }, "PromiseSignalList");
  return es.PromiseSignalList = PromiseSignalList, es;
}
o(requirePromiseSignalList, "requirePromiseSignalList");
var Ip;
function requirePromiseSignalHandlingBase() {
  if (Ip) return Zi;
  Ip = 1, Object.defineProperty(Zi, "__esModule", {
    value: !0
  }), Zi.PromiseSignalHandlingBase = void 0;
  const t = requireDist(),
    e = requirePromiseSignalList();
  let PromiseSignalHandlingBase = o(class extends t.HandlingBase {
    constructor() {
      super(new e.PromiseSignalList());
    }
  }, "PromiseSignalHandlingBase");
  return Zi.PromiseSignalHandlingBase = PromiseSignalHandlingBase, Zi;
}
o(requirePromiseSignalHandlingBase, "requirePromiseSignalHandlingBase");
var Rp;
function requireDist$2() {
  return Rp || (Rp = 1, function (t) {
    /*!
    * Strongly Typed Events for TypeScript - Promise Signals
    * https://github.com/KeesCBakker/StronlyTypedEvents/
    * http://keestalkstech.com
    *
    * Copyright Kees C. Bakker / KeesTalksTech
    * Released under the MIT license
    */
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PromiseSignalList = t.PromiseSignalHandlingBase = t.PromiseSignalDispatcher = void 0;
    const e = gl;
    Object.defineProperty(t, "PromiseSignalDispatcher", {
      enumerable: !0,
      get: function () {
        return e.PromiseSignalDispatcher;
      }
    });
    const n = requirePromiseSignalHandlingBase();
    Object.defineProperty(t, "PromiseSignalHandlingBase", {
      enumerable: !0,
      get: function () {
        return n.PromiseSignalHandlingBase;
      }
    });
    const r = requirePromiseSignalList();
    Object.defineProperty(t, "PromiseSignalList", {
      enumerable: !0,
      get: function () {
        return r.PromiseSignalList;
      }
    });
  }(Ql)), Ql;
}
o(requireDist$2, "requireDist");
var Ay = {},
  yl = {},
  Ai = {};
Object.defineProperty(Ai, "__esModule", {
  value: !0
});
Ai.PromiseSimpleEventDispatcher = void 0;
const Np = requireDist();
class PromiseSimpleEventDispatcher extends Np.PromiseDispatcherBase {
  constructor() {
    super();
  }
  async dispatch(e) {
    const n = await this._dispatchAsPromise(!1, this, arguments);
    if (n == null) throw new Np.DispatchError("Got `null` back from dispatch.");
    return n;
  }
  dispatchAsync(e) {
    this._dispatchAsPromise(!0, this, arguments);
  }
  asEvent() {
    return super.asEvent();
  }
}
o(PromiseSimpleEventDispatcher, "PromiseSimpleEventDispatcher");
Ai.PromiseSimpleEventDispatcher = PromiseSimpleEventDispatcher;
Object.defineProperty(yl, "__esModule", {
  value: !0
});
yl.NonUniformPromiseSimpleEventList = void 0;
const i1 = Ai;
class NonUniformPromiseSimpleEventList {
  constructor() {
    this._events = {};
  }
  get(e) {
    if (this._events[e]) return this._events[e];
    const n = this.createDispatcher();
    return this._events[e] = n, n;
  }
  remove(e) {
    delete this._events[e];
  }
  createDispatcher() {
    return new i1.PromiseSimpleEventDispatcher();
  }
}
o(NonUniformPromiseSimpleEventList, "NonUniformPromiseSimpleEventList");
yl.NonUniformPromiseSimpleEventList = NonUniformPromiseSimpleEventList;
var vl = {},
  wo = {};
Object.defineProperty(wo, "__esModule", {
  value: !0
});
wo.PromiseSimpleEventList = void 0;
const s1 = requireDist(),
  o1 = Ai;
class PromiseSimpleEventList extends s1.EventListBase {
  constructor() {
    super();
  }
  createDispatcher() {
    return new o1.PromiseSimpleEventDispatcher();
  }
}
o(PromiseSimpleEventList, "PromiseSimpleEventList");
wo.PromiseSimpleEventList = PromiseSimpleEventList;
Object.defineProperty(vl, "__esModule", {
  value: !0
});
vl.PromiseSimpleEventHandlingBase = void 0;
const a1 = requireDist(),
  l1 = wo;
class PromiseSimpleEventHandlingBase extends a1.HandlingBase {
  constructor() {
    super(new l1.PromiseSimpleEventList());
  }
}
o(PromiseSimpleEventHandlingBase, "PromiseSimpleEventHandlingBase");
vl.PromiseSimpleEventHandlingBase = PromiseSimpleEventHandlingBase;
(function (t) {
  /*!
  * Strongly Typed Events for TypeScript - Core
  * https://github.com/KeesCBakker/StronlyTypedEvents/
  * http://keestalkstech.com
  *
  * Copyright Kees C. Bakker / KeesTalksTech
  * Released under the MIT license
  */
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NonUniformPromiseSimpleEventList = t.PromiseSimpleEventList = t.PromiseSimpleEventHandlingBase = t.PromiseSimpleEventDispatcher = void 0;
  const e = yl;
  Object.defineProperty(t, "NonUniformPromiseSimpleEventList", {
    enumerable: !0,
    get: function () {
      return e.NonUniformPromiseSimpleEventList;
    }
  });
  const n = Ai;
  Object.defineProperty(t, "PromiseSimpleEventDispatcher", {
    enumerable: !0,
    get: function () {
      return n.PromiseSimpleEventDispatcher;
    }
  });
  const r = vl;
  Object.defineProperty(t, "PromiseSimpleEventHandlingBase", {
    enumerable: !0,
    get: function () {
      return r.PromiseSimpleEventHandlingBase;
    }
  });
  const i = wo;
  Object.defineProperty(t, "PromiseSimpleEventList", {
    enumerable: !0,
    get: function () {
      return i.PromiseSimpleEventList;
    }
  });
})(Ay);
(function (t) {
  /*!
  * Strongly Typed Events for TypeScript
  * https://github.com/KeesCBakker/StronlyTypedEvents/
  * http://keestalkstech.com
  *
  * Copyright Kees C. Bakker / KeesTalksTech
  * Released under the MIT license
  */
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NonUniformPromiseSimpleEventList = t.PromiseSimpleEventList = t.PromiseSimpleEventHandlingBase = t.PromiseSimpleEventDispatcher = t.PromiseSignalList = t.PromiseSignalHandlingBase = t.PromiseSignalDispatcher = t.NonUniformPromiseEventList = t.PromiseEventList = t.PromiseEventHandlingBase = t.PromiseEventDispatcher = t.SignalList = t.SignalHandlingBase = t.SignalDispatcher = t.NonUniformSimpleEventList = t.SimpleEventList = t.SimpleEventHandlingBase = t.SimpleEventDispatcher = t.NonUniformEventList = t.EventList = t.EventHandlingBase = t.EventDispatcher = t.HandlingBase = t.PromiseDispatcherBase = t.PromiseSubscription = t.DispatchError = t.EventManagement = t.EventListBase = t.DispatcherWrapper = t.DispatcherBase = t.Subscription = void 0;
  var e = requireDist();
  Object.defineProperty(t, "Subscription", {
    enumerable: !0,
    get: function () {
      return e.Subscription;
    }
  }), Object.defineProperty(t, "DispatcherBase", {
    enumerable: !0,
    get: function () {
      return e.DispatcherBase;
    }
  }), Object.defineProperty(t, "DispatcherWrapper", {
    enumerable: !0,
    get: function () {
      return e.DispatcherWrapper;
    }
  }), Object.defineProperty(t, "EventListBase", {
    enumerable: !0,
    get: function () {
      return e.EventListBase;
    }
  }), Object.defineProperty(t, "EventManagement", {
    enumerable: !0,
    get: function () {
      return e.EventManagement;
    }
  }), Object.defineProperty(t, "DispatchError", {
    enumerable: !0,
    get: function () {
      return e.DispatchError;
    }
  }), Object.defineProperty(t, "PromiseSubscription", {
    enumerable: !0,
    get: function () {
      return e.PromiseSubscription;
    }
  }), Object.defineProperty(t, "PromiseDispatcherBase", {
    enumerable: !0,
    get: function () {
      return e.PromiseDispatcherBase;
    }
  }), Object.defineProperty(t, "HandlingBase", {
    enumerable: !0,
    get: function () {
      return e.HandlingBase;
    }
  });
  var n = fy;
  Object.defineProperty(t, "EventDispatcher", {
    enumerable: !0,
    get: function () {
      return n.EventDispatcher;
    }
  }), Object.defineProperty(t, "EventHandlingBase", {
    enumerable: !0,
    get: function () {
      return n.EventHandlingBase;
    }
  }), Object.defineProperty(t, "EventList", {
    enumerable: !0,
    get: function () {
      return n.EventList;
    }
  }), Object.defineProperty(t, "NonUniformEventList", {
    enumerable: !0,
    get: function () {
      return n.NonUniformEventList;
    }
  });
  var r = gy;
  Object.defineProperty(t, "SimpleEventDispatcher", {
    enumerable: !0,
    get: function () {
      return r.SimpleEventDispatcher;
    }
  }), Object.defineProperty(t, "SimpleEventHandlingBase", {
    enumerable: !0,
    get: function () {
      return r.SimpleEventHandlingBase;
    }
  }), Object.defineProperty(t, "SimpleEventList", {
    enumerable: !0,
    get: function () {
      return r.SimpleEventList;
    }
  }), Object.defineProperty(t, "NonUniformSimpleEventList", {
    enumerable: !0,
    get: function () {
      return r.NonUniformSimpleEventList;
    }
  });
  var i = requireDist$1();
  Object.defineProperty(t, "SignalDispatcher", {
    enumerable: !0,
    get: function () {
      return i.SignalDispatcher;
    }
  }), Object.defineProperty(t, "SignalHandlingBase", {
    enumerable: !0,
    get: function () {
      return i.SignalHandlingBase;
    }
  }), Object.defineProperty(t, "SignalList", {
    enumerable: !0,
    get: function () {
      return i.SignalList;
    }
  });
  var s = Ey;
  Object.defineProperty(t, "PromiseEventDispatcher", {
    enumerable: !0,
    get: function () {
      return s.PromiseEventDispatcher;
    }
  }), Object.defineProperty(t, "PromiseEventHandlingBase", {
    enumerable: !0,
    get: function () {
      return s.PromiseEventHandlingBase;
    }
  }), Object.defineProperty(t, "PromiseEventList", {
    enumerable: !0,
    get: function () {
      return s.PromiseEventList;
    }
  }), Object.defineProperty(t, "NonUniformPromiseEventList", {
    enumerable: !0,
    get: function () {
      return s.NonUniformPromiseEventList;
    }
  });
  var a = requireDist$2();
  Object.defineProperty(t, "PromiseSignalDispatcher", {
    enumerable: !0,
    get: function () {
      return a.PromiseSignalDispatcher;
    }
  }), Object.defineProperty(t, "PromiseSignalHandlingBase", {
    enumerable: !0,
    get: function () {
      return a.PromiseSignalHandlingBase;
    }
  }), Object.defineProperty(t, "PromiseSignalList", {
    enumerable: !0,
    get: function () {
      return a.PromiseSignalList;
    }
  });
  var l = Ay;
  Object.defineProperty(t, "PromiseSimpleEventDispatcher", {
    enumerable: !0,
    get: function () {
      return l.PromiseSimpleEventDispatcher;
    }
  }), Object.defineProperty(t, "PromiseSimpleEventHandlingBase", {
    enumerable: !0,
    get: function () {
      return l.PromiseSimpleEventHandlingBase;
    }
  }), Object.defineProperty(t, "PromiseSimpleEventList", {
    enumerable: !0,
    get: function () {
      return l.PromiseSimpleEventList;
    }
  }), Object.defineProperty(t, "NonUniformPromiseSimpleEventList", {
    enumerable: !0,
    get: function () {
      return l.NonUniformPromiseSimpleEventList;
    }
  });
})(dist);
var Vf = {
    exports: {}
  },
  bind = o(function (e, n) {
    return o(function () {
      for (var i = new Array(arguments.length), s = 0; s < i.length; s++) i[s] = arguments[s];
      return e.apply(n, i);
    }, "wrap");
  }, "bind"),
  u1 = bind,
  $r = Object.prototype.toString;
function isArray(t) {
  return $r.call(t) === "[object Array]";
}
o(isArray, "isArray$3");
function isUndefined(t) {
  return typeof t > "u";
}
o(isUndefined, "isUndefined$1");
function isBuffer(t) {
  return t !== null && !isUndefined(t) && t.constructor !== null && !isUndefined(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
o(isBuffer, "isBuffer$1");
function isArrayBuffer(t) {
  return $r.call(t) === "[object ArrayBuffer]";
}
o(isArrayBuffer, "isArrayBuffer$1");
function isFormData(t) {
  return typeof FormData < "u" && t instanceof FormData;
}
o(isFormData, "isFormData$1");
function isArrayBufferView(t) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && t.buffer instanceof ArrayBuffer, e;
}
o(isArrayBufferView, "isArrayBufferView$1");
function isString(t) {
  return typeof t == "string";
}
o(isString, "isString$3");
function isNumber$1(t) {
  return typeof t == "number";
}
o(isNumber$1, "isNumber$5");
function isObject(t) {
  return t !== null && typeof t == "object";
}
o(isObject, "isObject$9");
function isPlainObject(t) {
  if ($r.call(t) !== "[object Object]") return !1;
  var e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
o(isPlainObject, "isPlainObject$1");
function isDate(t) {
  return $r.call(t) === "[object Date]";
}
o(isDate, "isDate$1");
function isFile(t) {
  return $r.call(t) === "[object File]";
}
o(isFile, "isFile$1");
function isBlob(t) {
  return $r.call(t) === "[object Blob]";
}
o(isBlob, "isBlob$1");
function isFunction(t) {
  return $r.call(t) === "[object Function]";
}
o(isFunction, "isFunction$3");
function isStream(t) {
  return isObject(t) && isFunction(t.pipe);
}
o(isStream, "isStream$1");
function isURLSearchParams(t) {
  return typeof URLSearchParams < "u" && t instanceof URLSearchParams;
}
o(isURLSearchParams, "isURLSearchParams$1");
function trim(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
o(trim, "trim$1");
function isStandardBrowserEnv() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
o(isStandardBrowserEnv, "isStandardBrowserEnv");
function forEach(t, e) {
  if (!(t === null || typeof t > "u")) if (typeof t != "object" && (t = [t]), isArray(t)) for (var n = 0, r = t.length; n < r; n++) e.call(null, t[n], n, t);else for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && e.call(null, t[i], i, t);
}
o(forEach, "forEach$1");
function merge() {
  var t = {};
  function assignValue(i, s) {
    isPlainObject(t[s]) && isPlainObject(i) ? t[s] = merge(t[s], i) : isPlainObject(i) ? t[s] = merge({}, i) : isArray(i) ? t[s] = i.slice() : t[s] = i;
  }
  o(assignValue, "assignValue");
  for (var n = 0, r = arguments.length; n < r; n++) forEach(arguments[n], assignValue);
  return t;
}
o(merge, "merge$1");
function extend(t, e, n) {
  return forEach(e, o(function (i, s) {
    n && typeof i == "function" ? t[s] = u1(i, n) : t[s] = i;
  }, "assignValue")), t;
}
o(extend, "extend$4");
function stripBOM(t) {
  return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t;
}
o(stripBOM, "stripBOM$1");
var Ht = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber$1,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM
  },
  Wr = Ht;
function encode(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
o(encode, "encode$2");
var buildURL = o(function (e, n, r) {
    if (!n) return e;
    var i;
    if (r) i = r(n);else if (Wr.isURLSearchParams(n)) i = n.toString();else {
      var s = [];
      Wr.forEach(n, o(function (u, c) {
        u === null || typeof u > "u" || (Wr.isArray(u) ? c = c + "[]" : u = [u], Wr.forEach(u, o(function (m) {
          Wr.isDate(m) ? m = m.toISOString() : Wr.isObject(m) && (m = JSON.stringify(m)), s.push(encode(c) + "=" + encode(m));
        }, "parseValue")));
      }, "serialize")), i = s.join("&");
    }
    if (i) {
      var a = e.indexOf("#");
      a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
    }
    return e;
  }, "buildURL"),
  C1 = Ht;
function InterceptorManager() {
  this.handlers = [];
}
o(InterceptorManager, "InterceptorManager$3");
InterceptorManager.prototype.use = o(function (e, n, r) {
  return this.handlers.push({
    fulfilled: e,
    rejected: n,
    synchronous: r ? r.synchronous : !1,
    runWhen: r ? r.runWhen : null
  }), this.handlers.length - 1;
}, "use");
InterceptorManager.prototype.eject = o(function (e) {
  this.handlers[e] && (this.handlers[e] = null);
}, "eject");
InterceptorManager.prototype.forEach = o(function (e) {
  C1.forEach(this.handlers, o(function (r) {
    r !== null && e(r);
  }, "forEachHandler"));
}, "forEach");
var x1 = InterceptorManager,
  k1 = Ht,
  normalizeHeaderName = o(function (e, n) {
    k1.forEach(e, o(function (i, s) {
      s !== n && s.toUpperCase() === n.toUpperCase() && (e[n] = i, delete e[s]);
    }, "processHeader"));
  }, "normalizeHeaderName"),
  enhanceError = o(function (e, n, r, i, s) {
    return e.config = n, r && (e.code = r), e.request = i, e.response = s, e.isAxiosError = !0, e.toJSON = o(function () {
      return {
        message: this.message,
        name: this.name,
        description: this.description,
        number: this.number,
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        config: this.config,
        code: this.code
      };
    }, "toJSON"), e;
  }, "enhanceError"),
  Jl,
  Fp;
function requireCreateError() {
  if (Fp) return Jl;
  Fp = 1;
  var t = enhanceError;
  return Jl = o(function (n, r, i, s, a) {
    var l = new Error(n);
    return t(l, r, i, s, a);
  }, "createError"), Jl;
}
o(requireCreateError, "requireCreateError");
var Zl, jp;
function requireSettle() {
  if (jp) return Zl;
  jp = 1;
  var t = requireCreateError();
  return Zl = o(function (n, r, i) {
    var s = i.config.validateStatus;
    !i.status || !s || s(i.status) ? n(i) : r(t("Request failed with status code " + i.status, i.config, null, i.request, i));
  }, "settle"), Zl;
}
o(requireSettle, "requireSettle");
var eu, Bp;
function requireCookies() {
  if (Bp) return eu;
  Bp = 1;
  var t = Ht;
  return eu = t.isStandardBrowserEnv() ? o(function () {
    return {
      write: o(function (r, i, s, a, l, u) {
        var c = [];
        c.push(r + "=" + encodeURIComponent(i)), t.isNumber(s) && c.push("expires=" + new Date(s).toGMTString()), t.isString(a) && c.push("path=" + a), t.isString(l) && c.push("domain=" + l), u === !0 && c.push("secure"), document.cookie = c.join("; ");
      }, "write"),
      read: o(function (r) {
        var i = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
        return i ? decodeURIComponent(i[3]) : null;
      }, "read"),
      remove: o(function (r) {
        this.write(r, "", Date.now() - 864e5);
      }, "remove")
    };
  }, "standardBrowserEnv")() : o(function () {
    return {
      write: o(function () {}, "write"),
      read: o(function () {
        return null;
      }, "read"),
      remove: o(function () {}, "remove")
    };
  }, "nonStandardBrowserEnv")(), eu;
}
o(requireCookies, "requireCookies");
var tu, zp;
function requireIsAbsoluteURL() {
  return zp || (zp = 1, tu = o(function (e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  }, "isAbsoluteURL")), tu;
}
o(requireIsAbsoluteURL, "requireIsAbsoluteURL");
var nu, Hp;
function requireCombineURLs() {
  return Hp || (Hp = 1, nu = o(function (e, n) {
    return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e;
  }, "combineURLs")), nu;
}
o(requireCombineURLs, "requireCombineURLs");
var ru, Up;
function requireBuildFullPath() {
  if (Up) return ru;
  Up = 1;
  var t = requireIsAbsoluteURL(),
    e = requireCombineURLs();
  return ru = o(function (r, i) {
    return r && !t(i) ? e(r, i) : i;
  }, "buildFullPath"), ru;
}
o(requireBuildFullPath, "requireBuildFullPath");
var iu, qp;
function requireParseHeaders() {
  if (qp) return iu;
  qp = 1;
  var t = Ht,
    e = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
  return iu = o(function (r) {
    var i = {},
      s,
      a,
      l;
    return r && t.forEach(r.split(`
`), o(function (c) {
      if (l = c.indexOf(":"), s = t.trim(c.substr(0, l)).toLowerCase(), a = t.trim(c.substr(l + 1)), s) {
        if (i[s] && e.indexOf(s) >= 0) return;
        s === "set-cookie" ? i[s] = (i[s] ? i[s] : []).concat([a]) : i[s] = i[s] ? i[s] + ", " + a : a;
      }
    }, "parser")), i;
  }, "parseHeaders"), iu;
}
o(requireParseHeaders, "requireParseHeaders");
var su, Vp;
function requireIsURLSameOrigin() {
  if (Vp) return su;
  Vp = 1;
  var t = Ht;
  return su = t.isStandardBrowserEnv() ? o(function () {
    var n = /(msie|trident)/i.test(navigator.userAgent),
      r = document.createElement("a"),
      i;
    function resolveURL(a) {
      var l = a;
      return n && (r.setAttribute("href", l), l = r.href), r.setAttribute("href", l), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return o(resolveURL, "resolveURL"), i = resolveURL(window.location.href), o(function (l) {
      var u = t.isString(l) ? resolveURL(l) : l;
      return u.protocol === i.protocol && u.host === i.host;
    }, "isURLSameOrigin");
  }, "standardBrowserEnv")() : o(function () {
    return o(function () {
      return !0;
    }, "isURLSameOrigin");
  }, "nonStandardBrowserEnv")(), su;
}
o(requireIsURLSameOrigin, "requireIsURLSameOrigin");
var ou, Wp;
function requireXhr() {
  if (Wp) return ou;
  Wp = 1;
  var t = Ht,
    e = requireSettle(),
    n = requireCookies(),
    r = buildURL,
    i = requireBuildFullPath(),
    s = requireParseHeaders(),
    a = requireIsURLSameOrigin(),
    l = requireCreateError();
  return ou = o(function (c) {
    return new Promise(o(function (m, d) {
      var y = c.data,
        S = c.headers,
        w = c.responseType;
      t.isFormData(y) && delete S["Content-Type"];
      var g = new XMLHttpRequest();
      if (c.auth) {
        var h = c.auth.username || "",
          f = c.auth.password ? unescape(encodeURIComponent(c.auth.password)) : "";
        S.Authorization = "Basic " + btoa(h + ":" + f);
      }
      var v = i(c.baseURL, c.url);
      g.open(c.method.toUpperCase(), r(v, c.params, c.paramsSerializer), !0), g.timeout = c.timeout;
      function onloadend() {
        if (g) {
          var P = "getAllResponseHeaders" in g ? s(g.getAllResponseHeaders()) : null,
            T = !w || w === "text" || w === "json" ? g.responseText : g.response,
            O = {
              data: T,
              status: g.status,
              statusText: g.statusText,
              headers: P,
              config: c,
              request: g
            };
          e(m, d, O), g = null;
        }
      }
      if (o(onloadend, "onloadend"), "onloadend" in g ? g.onloadend = onloadend : g.onreadystatechange = o(function () {
        !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(onloadend);
      }, "handleLoad"), g.onabort = o(function () {
        g && (d(l("Request aborted", c, "ECONNABORTED", g)), g = null);
      }, "handleAbort"), g.onerror = o(function () {
        d(l("Network Error", c, null, g)), g = null;
      }, "handleError"), g.ontimeout = o(function () {
        var T = "timeout of " + c.timeout + "ms exceeded";
        c.timeoutErrorMessage && (T = c.timeoutErrorMessage), d(l(T, c, c.transitional && c.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", g)), g = null;
      }, "handleTimeout"), t.isStandardBrowserEnv()) {
        var b = (c.withCredentials || a(v)) && c.xsrfCookieName ? n.read(c.xsrfCookieName) : void 0;
        b && (S[c.xsrfHeaderName] = b);
      }
      "setRequestHeader" in g && t.forEach(S, o(function (T, O) {
        typeof y > "u" && O.toLowerCase() === "content-type" ? delete S[O] : g.setRequestHeader(O, T);
      }, "setRequestHeader")), t.isUndefined(c.withCredentials) || (g.withCredentials = !!c.withCredentials), w && w !== "json" && (g.responseType = c.responseType), typeof c.onDownloadProgress == "function" && g.addEventListener("progress", c.onDownloadProgress), typeof c.onUploadProgress == "function" && g.upload && g.upload.addEventListener("progress", c.onUploadProgress), c.cancelToken && c.cancelToken.promise.then(o(function (T) {
        g && (g.abort(), d(T), g = null);
      }, "onCanceled")), y || (y = null), g.send(y);
    }, "dispatchXhrRequest"));
  }, "xhrAdapter"), ou;
}
o(requireXhr, "requireXhr");
var ut = Ht,
  Xp = normalizeHeaderName,
  N1 = enhanceError,
  $1 = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
function setContentTypeIfUnset(t, e) {
  !ut.isUndefined(t) && ut.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
}
o(setContentTypeIfUnset, "setContentTypeIfUnset");
function getDefaultAdapter() {
  var t;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (t = requireXhr()), t;
}
o(getDefaultAdapter, "getDefaultAdapter");
function stringifySafely(t, e, n) {
  if (ut.isString(t)) try {
    return (e || JSON.parse)(t), ut.trim(t);
  } catch (r) {
    if (r.name !== "SyntaxError") throw r;
  }
  return (n || JSON.stringify)(t);
}
o(stringifySafely, "stringifySafely$1");
var bl = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: getDefaultAdapter(),
  transformRequest: [o(function (e, Accept) {
    return Xp(Accept, "Accept"), Xp(Accept, "Content-Type"), ut.isFormData(e) || ut.isArrayBuffer(e) || ut.isBuffer(e) || ut.isStream(e) || ut.isFile(e) || ut.isBlob(e) ? e : ut.isArrayBufferView(e) ? e.buffer : ut.isURLSearchParams(e) ? (setContentTypeIfUnset(Accept, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : ut.isObject(e) || Accept && Accept["Content-Type"] === "application/json" ? (setContentTypeIfUnset(Accept, "application/json"), stringifySafely(e)) : e;
  }, "transformRequest")],
  transformResponse: [o(function (e) {
    var n = this.transitional,
      r = n && n.silentJSONParsing,
      i = n && n.forcedJSONParsing,
      s = !r && this.responseType === "json";
    if (s || i && ut.isString(e) && e.length) try {
      return JSON.parse(e);
    } catch (a) {
      if (s) throw a.name === "SyntaxError" ? N1(a, this, "E_JSON_PARSE") : a;
    }
    return e;
  }, "transformResponse")],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: o(function (e) {
    return e >= 200 && e < 300;
  }, "validateStatus")
};
bl.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
ut.forEach(["delete", "get", "head"], o(function (e) {
  bl.headers[e] = {};
}, "forEachMethodNoData"));
ut.forEach(["post", "put", "patch"], o(function (e) {
  bl.headers[e] = ut.merge($1);
}, "forEachMethodWithData"));
var Xf = bl,
  B1 = Ht,
  z1 = Xf,
  transformData = o(function (e, n, r) {
    var i = this || z1;
    return B1.forEach(r, o(function (a) {
      e = a.call(i, e, n);
    }, "transform")), e;
  }, "transformData"),
  au,
  Kp;
function requireIsCancel() {
  return Kp || (Kp = 1, au = o(function (e) {
    return !!(e && e.__CANCEL__);
  }, "isCancel")), au;
}
o(requireIsCancel, "requireIsCancel");
var Qp = Ht,
  lu = transformData,
  U1 = requireIsCancel(),
  q1 = Xf;
function throwIfCancellationRequested(t) {
  t.cancelToken && t.cancelToken.throwIfRequested();
}
o(throwIfCancellationRequested, "throwIfCancellationRequested$1");
var dispatchRequest = o(function (e) {
    throwIfCancellationRequested(e), e.headers = e.headers || {}, e.data = lu.call(e, e.data, e.headers, e.transformRequest), e.headers = Qp.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), Qp.forEach(["delete", "get", "head", "post", "put", "patch", "common"], o(function (i) {
      delete e.headers[i];
    }, "cleanHeaderConfig"));
    var n = e.adapter || q1.adapter;
    return n(e).then(o(function (i) {
      return throwIfCancellationRequested(e), i.data = lu.call(e, i.data, i.headers, e.transformResponse), i;
    }, "onAdapterResolution"), o(function (i) {
      return U1(i) || (throwIfCancellationRequested(e), i && i.response && (i.response.data = lu.call(e, i.response.data, i.response.headers, e.transformResponse))), Promise.reject(i);
    }, "onAdapterRejection"));
  }, "dispatchRequest"),
  gt = Ht,
  mergeConfig = o(function (e, n) {
    n = n || {};
    var r = {},
      i = ["url", "method", "data"],
      s = ["headers", "auth", "proxy", "params"],
      a = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"],
      l = ["validateStatus"];
    function getMergedValue(d, y) {
      return gt.isPlainObject(d) && gt.isPlainObject(y) ? gt.merge(d, y) : gt.isPlainObject(y) ? gt.merge({}, y) : gt.isArray(y) ? y.slice() : y;
    }
    o(getMergedValue, "getMergedValue");
    function mergeDeepProperties(d) {
      gt.isUndefined(n[d]) ? gt.isUndefined(e[d]) || (r[d] = getMergedValue(void 0, e[d])) : r[d] = getMergedValue(e[d], n[d]);
    }
    o(mergeDeepProperties, "mergeDeepProperties"), gt.forEach(i, o(function (y) {
      gt.isUndefined(n[y]) || (r[y] = getMergedValue(void 0, n[y]));
    }, "valueFromConfig2")), gt.forEach(s, mergeDeepProperties), gt.forEach(a, o(function (y) {
      gt.isUndefined(n[y]) ? gt.isUndefined(e[y]) || (r[y] = getMergedValue(void 0, e[y])) : r[y] = getMergedValue(void 0, n[y]);
    }, "defaultToConfig2")), gt.forEach(l, o(function (y) {
      y in n ? r[y] = getMergedValue(e[y], n[y]) : y in e && (r[y] = getMergedValue(void 0, e[y]));
    }, "merge"));
    var p = i.concat(s).concat(a).concat(l),
      m = Object.keys(e).concat(Object.keys(n)).filter(o(function (y) {
        return p.indexOf(y) === -1;
      }, "filterAxiosKeys"));
    return gt.forEach(m, mergeDeepProperties), r;
  }, "mergeConfig");
const W1 = "axios",
  G1 = "0.21.4",
  X1 = "Promise based HTTP client for the browser and node.js",
  Y1 = "index.js",
  K1 = {
    test: "grunt test",
    start: "node ./sandbox/server.js",
    build: "NODE_ENV=production grunt build",
    preversion: "npm test",
    version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
    postversion: "git push && git push --tags",
    examples: "node ./examples/server.js",
    coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
    fix: "eslint --fix lib/**/*.js"
  },
  Q1 = {
    type: "git",
    url: "https://github.com/axios/axios.git"
  },
  J1 = ["xhr", "http", "ajax", "promise", "node"],
  Z1 = "Matt Zabriskie",
  eS = "MIT",
  tS = {
    url: "https://github.com/axios/axios/issues"
  },
  nS = "https://axios-http.com",
  rS = {
    coveralls: "^3.0.0",
    "es6-promise": "^4.2.4",
    grunt: "^1.3.0",
    "grunt-banner": "^0.6.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-clean": "^1.1.0",
    "grunt-contrib-watch": "^1.0.0",
    "grunt-eslint": "^23.0.0",
    "grunt-karma": "^4.0.0",
    "grunt-mocha-test": "^0.13.3",
    "grunt-ts": "^6.0.0-beta.19",
    "grunt-webpack": "^4.0.2",
    "istanbul-instrumenter-loader": "^1.0.0",
    "jasmine-core": "^2.4.1",
    karma: "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^1.1.1",
    "karma-jasmine-ajax": "^0.1.13",
    "karma-safari-launcher": "^1.0.0",
    "karma-sauce-launcher": "^4.3.6",
    "karma-sinon": "^1.0.5",
    "karma-sourcemap-loader": "^0.3.8",
    "karma-webpack": "^4.0.2",
    "load-grunt-tasks": "^3.5.2",
    minimist: "^1.2.0",
    mocha: "^8.2.1",
    sinon: "^4.5.0",
    "terser-webpack-plugin": "^4.2.3",
    typescript: "^4.0.5",
    "url-search-params": "^0.10.0",
    webpack: "^4.44.2",
    "webpack-dev-server": "^3.11.0"
  },
  iS = {
    "./lib/adapters/http.js": "./lib/adapters/xhr.js"
  },
  sS = "dist/axios.min.js",
  oS = "dist/axios.min.js",
  aS = "./index.d.ts",
  lS = {
    "follow-redirects": "^1.14.0"
  },
  uS = [{
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }],
  cS = {
    name: W1,
    version: G1,
    description: X1,
    main: Y1,
    scripts: K1,
    repository: Q1,
    keywords: J1,
    author: Z1,
    license: eS,
    bugs: tS,
    homepage: nS,
    devDependencies: rS,
    browser: iS,
    jsdelivr: sS,
    unpkg: oS,
    typings: aS,
    dependencies: lS,
    bundlesize: uS
  };
var Uy = cS,
  Yf = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function (t, e) {
  Yf[t] = o(function (r) {
    return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
  }, "validator");
});
var Jp = {},
  fS = Uy.version.split(".");
function isOlderVersion(t, e) {
  for (var n = e ? e.split(".") : fS, r = t.split("."), i = 0; i < 3; i++) {
    if (n[i] > r[i]) return !0;
    if (n[i] < r[i]) return !1;
  }
  return !1;
}
o(isOlderVersion, "isOlderVersion");
Yf.transitional = o(function (e, n, r) {
  var i = n && isOlderVersion(n);
  function formatMessage(a, l) {
    return "[Axios v" + Uy.version + "] Transitional option '" + a + "'" + l + (r ? ". " + r : "");
  }
  return o(formatMessage, "formatMessage"), function (a, l, u) {
    if (e === !1) throw new Error(formatMessage(l, " has been removed in " + n));
    return i && !Jp[l] && (Jp[l] = !0, console.warn(formatMessage(l, " has been deprecated since v" + n + " and will be removed in the near future"))), e ? e(a, l, u) : !0;
  };
}, "transitional");
function assertOptions(t, e, n) {
  if (typeof t != "object") throw new TypeError("options must be an object");
  for (var r = Object.keys(t), i = r.length; i-- > 0;) {
    var s = r[i],
      a = e[s];
    if (a) {
      var l = t[s],
        u = l === void 0 || a(l, s, t);
      if (u !== !0) throw new TypeError("option " + s + " must be " + u);
      continue;
    }
    if (n !== !0) throw Error("Unknown option " + s);
  }
}
o(assertOptions, "assertOptions$1");
var pS = {
    isOlderVersion: isOlderVersion,
    assertOptions: assertOptions,
    validators: Yf
  },
  Vy = Ht,
  hS = buildURL,
  Zp = x1,
  eh = dispatchRequest,
  Sl = mergeConfig,
  Wy = pS,
  Gr = Wy.validators;
function Axios(t) {
  this.defaults = t, this.interceptors = {
    request: new Zp(),
    response: new Zp()
  };
}
o(Axios, "Axios$3");
Axios.prototype.request = o(function (e) {
  typeof e == "string" ? (e = arguments[1] || {}, e.url = arguments[0]) : e = e || {}, e = Sl(this.defaults, e), e.method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
  var n = e.transitional;
  n !== void 0 && Wy.assertOptions(n, {
    silentJSONParsing: Gr.transitional(Gr.boolean, "1.0.0"),
    forcedJSONParsing: Gr.transitional(Gr.boolean, "1.0.0"),
    clarifyTimeoutError: Gr.transitional(Gr.boolean, "1.0.0")
  }, !1);
  var r = [],
    i = !0;
  this.interceptors.request.forEach(o(function (d) {
    typeof d.runWhen == "function" && d.runWhen(e) === !1 || (i = i && d.synchronous, r.unshift(d.fulfilled, d.rejected));
  }, "unshiftRequestInterceptors"));
  var s = [];
  this.interceptors.response.forEach(o(function (d) {
    s.push(d.fulfilled, d.rejected);
  }, "pushResponseInterceptors"));
  var a;
  if (!i) {
    var l = [eh, void 0];
    for (Array.prototype.unshift.apply(l, r), l = l.concat(s), a = Promise.resolve(e); l.length;) a = a.then(l.shift(), l.shift());
    return a;
  }
  for (var u = e; r.length;) {
    var c = r.shift(),
      p = r.shift();
    try {
      u = c(u);
    } catch (m) {
      p(m);
      break;
    }
  }
  try {
    a = eh(u);
  } catch (m) {
    return Promise.reject(m);
  }
  for (; s.length;) a = a.then(s.shift(), s.shift());
  return a;
}, "request");
Axios.prototype.getUri = o(function (e) {
  return e = Sl(this.defaults, e), hS(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
}, "getUri");
Vy.forEach(["delete", "get", "head", "options"], o(function (e) {
  Axios.prototype[e] = function (n, r) {
    return this.request(Sl(r || {}, {
      method: e,
      url: n,
      data: (r || {}).data
    }));
  };
}, "forEachMethodNoData"));
Vy.forEach(["post", "put", "patch"], o(function (e) {
  Axios.prototype[e] = function (n, r, i) {
    return this.request(Sl(i || {}, {
      method: e,
      url: n,
      data: r
    }));
  };
}, "forEachMethodWithData"));
var mS = Axios,
  cu,
  th;
function requireCancel() {
  if (th) return cu;
  th = 1;
  function Cancel(e) {
    this.message = e;
  }
  return o(Cancel, "Cancel"), Cancel.prototype.toString = o(function () {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, "toString"), Cancel.prototype.__CANCEL__ = !0, cu = Cancel, cu;
}
o(requireCancel, "requireCancel");
var fu, nh;
function requireCancelToken() {
  if (nh) return fu;
  nh = 1;
  var t = requireCancel();
  function CancelToken(n) {
    if (typeof n != "function") throw new TypeError("executor must be a function.");
    var r;
    this.promise = new Promise(o(function (a) {
      r = a;
    }, "promiseExecutor"));
    var i = this;
    n(o(function (a) {
      i.reason || (i.reason = new t(a), r(i.reason));
    }, "cancel"));
  }
  return o(CancelToken, "CancelToken"), CancelToken.prototype.throwIfRequested = o(function () {
    if (this.reason) throw this.reason;
  }, "throwIfRequested"), CancelToken.source = o(function () {
    var r,
      i = new CancelToken(o(function (a) {
        r = a;
      }, "executor"));
    return {
      token: i,
      cancel: r
    };
  }, "source"), fu = CancelToken, fu;
}
o(requireCancelToken, "requireCancelToken");
var du, rh;
function requireSpread() {
  return rh || (rh = 1, du = o(function (e) {
    return o(function (r) {
      return e.apply(null, r);
    }, "wrap");
  }, "spread")), du;
}
o(requireSpread, "requireSpread");
var pu, ih;
function requireIsAxiosError() {
  return ih || (ih = 1, pu = o(function (e) {
    return typeof e == "object" && e.isAxiosError === !0;
  }, "isAxiosError")), pu;
}
o(requireIsAxiosError, "requireIsAxiosError");
var sh = Ht,
  wS = bind,
  Zo = mS,
  bS = mergeConfig,
  SS = Xf;
function createInstance(t) {
  var e = new Zo(t),
    n = wS(Zo.prototype.request, e);
  return sh.extend(n, Zo.prototype, e), sh.extend(n, e), n;
}
o(createInstance, "createInstance$1");
var cn = createInstance(SS);
cn.Axios = Zo;
cn.create = o(function (e) {
  return createInstance(bS(cn.defaults, e));
}, "create");
cn.Cancel = requireCancel();
cn.CancelToken = requireCancelToken();
cn.isCancel = requireIsCancel();
cn.all = o(function (e) {
  return Promise.all(e);
}, "all");
cn.spread = requireSpread();
cn.isAxiosError = requireIsAxiosError();
Vf.exports = cn;
Vf.exports.default = cn;
var ES = Vf.exports,
  TS = ES;
const PS = getDefaultExportFromCjs(TS);
var protocols = o(function (e, n) {
    n === !0 && (n = 0);
    var r = e.indexOf("://"),
      i = e.substring(0, r).split("+").filter(Boolean);
    return typeof n == "number" ? i[n] : i;
  }, "protocols"),
  protocols$1 = o(function (e, n) {
    n === !0 && (n = 0);
    var r = "";
    if (typeof e == "string") try {
      r = new URL(e).protocol;
    } catch {} else e && e.constructor === URL && (r = e.protocol);
    var i = r.split(/\:|\+/).filter(Boolean);
    return typeof n == "number" ? i[n] : i;
  }, "protocols"),
  kS = protocols$1;
function isSsh(t) {
  if (Array.isArray(t)) return t.indexOf("ssh") !== -1 || t.indexOf("rsync") !== -1;
  if (typeof t != "string") return !1;
  var e = kS(t);
  if (t = t.substring(t.indexOf("://") + 3), isSsh(e)) return !0;
  var n = new RegExp(".([a-zA-Z\\d]+):(\\d+)/");
  return !t.match(n) && t.indexOf("@") < t.indexOf(":");
}
o(isSsh, "isSsh$1");
var _S = isSsh,
  queryString = {},
  strictUriEncode = o(t => encodeURIComponent(t).replace(/[!'()*]/g, e => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), "strictUriEncode"),
  Qy = "%[a-f0-9]{2}",
  oh = new RegExp("(" + Qy + ")|([^%]+?)", "gi"),
  ah = new RegExp("(" + Qy + ")+", "gi");
function decodeComponents(t, e) {
  try {
    return [decodeURIComponent(t.join(""))];
  } catch {}
  if (t.length === 1) return t;
  e = e || 1;
  var n = t.slice(0, e),
    r = t.slice(e);
  return Array.prototype.concat.call([], decodeComponents(n), decodeComponents(r));
}
o(decodeComponents, "decodeComponents");
function decode(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    for (var e = t.match(oh) || [], n = 1; n < e.length; n++) t = decodeComponents(e, n).join(""), e = t.match(oh) || [];
    return t;
  }
}
o(decode, "decode");
function customDecodeURIComponent(t) {
  for (var e = {
      "%FE%FF": "��",
      "%FF%FE": "��"
    }, n = ah.exec(t); n;) {
    try {
      e[n[0]] = decodeURIComponent(n[0]);
    } catch {
      var r = decode(n[0]);
      r !== n[0] && (e[n[0]] = r);
    }
    n = ah.exec(t);
  }
  e["%C2"] = "�";
  for (var i = Object.keys(e), s = 0; s < i.length; s++) {
    var a = i[s];
    t = t.replace(new RegExp(a, "g"), e[a]);
  }
  return t;
}
o(customDecodeURIComponent, "customDecodeURIComponent");
var decodeUriComponent = o(function (t) {
    if (typeof t != "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof t + "`");
    try {
      return t = t.replace(/\+/g, " "), decodeURIComponent(t);
    } catch {
      return customDecodeURIComponent(t);
    }
  }, "decodeUriComponent"),
  splitOnFirst = o((t, e) => {
    if (!(typeof t == "string" && typeof e == "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (e === "") return [t];
    const n = t.indexOf(e);
    return n === -1 ? [t] : [t.slice(0, n), t.slice(n + e.length)];
  }, "splitOnFirst"),
  filterObj = o(function (t, e) {
    for (var n = {}, r = Object.keys(t), i = Array.isArray(e), s = 0; s < r.length; s++) {
      var a = r[s],
        l = t[a];
      (i ? e.indexOf(a) !== -1 : e(a, l, t)) && (n[a] = l);
    }
    return n;
  }, "filterObj");
(function (t) {
  const e = strictUriEncode,
    n = decodeUriComponent,
    r = splitOnFirst,
    i = filterObj,
    isNullOrUndefined = o(h => h == null, "isNullOrUndefined");
  function encoderForArrayFormat(h) {
    switch (h.arrayFormat) {
      case "index":
        return f => (v, E) => {
          const b = v.length;
          return E === void 0 || h.skipNull && E === null || h.skipEmptyString && E === "" ? v : E === null ? [...v, [encode$1(f, h), "[", b, "]"].join("")] : [...v, [encode$1(f, h), "[", encode$1(b, h), "]=", encode$1(E, h)].join("")];
        };
      case "bracket":
        return f => (v, E) => E === void 0 || h.skipNull && E === null || h.skipEmptyString && E === "" ? v : E === null ? [...v, [encode$1(f, h), "[]"].join("")] : [...v, [encode$1(f, h), "[]=", encode$1(E, h)].join("")];
      case "comma":
      case "separator":
        return f => (v, E) => E == null || E.length === 0 ? v : v.length === 0 ? [[encode$1(f, h), "=", encode$1(E, h)].join("")] : [[v, encode$1(E, h)].join(h.arrayFormatSeparator)];
      default:
        return f => (v, E) => E === void 0 || h.skipNull && E === null || h.skipEmptyString && E === "" ? v : E === null ? [...v, encode$1(f, h)] : [...v, [encode$1(f, h), "=", encode$1(E, h)].join("")];
    }
  }
  o(encoderForArrayFormat, "encoderForArrayFormat");
  function parserForArrayFormat(h) {
    let f;
    switch (h.arrayFormat) {
      case "index":
        return (v, E, b) => {
          if (f = /\[(\d*)\]$/.exec(v), v = v.replace(/\[\d*\]$/, ""), !f) {
            b[v] = E;
            return;
          }
          b[v] === void 0 && (b[v] = {}), b[v][f[1]] = E;
        };
      case "bracket":
        return (v, E, b) => {
          if (f = /(\[\])$/.exec(v), v = v.replace(/\[\]$/, ""), !f) {
            b[v] = E;
            return;
          }
          if (b[v] === void 0) {
            b[v] = [E];
            return;
          }
          b[v] = [].concat(b[v], E);
        };
      case "comma":
      case "separator":
        return (v, E, b) => {
          const P = typeof E == "string" && E.includes(h.arrayFormatSeparator),
            T = typeof E == "string" && !P && decode$1(E, h).includes(h.arrayFormatSeparator);
          E = T ? decode$1(E, h) : E;
          const O = P || T ? E.split(h.arrayFormatSeparator).map(M => decode$1(M, h)) : E === null ? E : decode$1(E, h);
          b[v] = O;
        };
      default:
        return (v, E, b) => {
          if (b[v] === void 0) {
            b[v] = E;
            return;
          }
          b[v] = [].concat(b[v], E);
        };
    }
  }
  o(parserForArrayFormat, "parserForArrayFormat");
  function validateArrayFormatSeparator(h) {
    if (typeof h != "string" || h.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  o(validateArrayFormatSeparator, "validateArrayFormatSeparator");
  function encode$1(h, f) {
    return f.encode ? f.strict ? e(h) : encodeURIComponent(h) : h;
  }
  o(encode$1, "encode");
  function decode$1(h, f) {
    return f.decode ? n(h) : h;
  }
  o(decode$1, "decode");
  function keysSorter(h) {
    return Array.isArray(h) ? h.sort() : typeof h == "object" ? keysSorter(Object.keys(h)).sort((f, v) => Number(f) - Number(v)).map(f => h[f]) : h;
  }
  o(keysSorter, "keysSorter");
  function removeHash(h) {
    const f = h.indexOf("#");
    return f !== -1 && (h = h.slice(0, f)), h;
  }
  o(removeHash, "removeHash");
  function getHash(h) {
    let f = "";
    const v = h.indexOf("#");
    return v !== -1 && (f = h.slice(v)), f;
  }
  o(getHash, "getHash");
  function extract(h) {
    h = removeHash(h);
    const f = h.indexOf("?");
    return f === -1 ? "" : h.slice(f + 1);
  }
  o(extract, "extract");
  function parseValue(h, f) {
    return f.parseNumbers && !Number.isNaN(Number(h)) && typeof h == "string" && h.trim() !== "" ? h = Number(h) : f.parseBooleans && h !== null && (h.toLowerCase() === "true" || h.toLowerCase() === "false") && (h = h.toLowerCase() === "true"), h;
  }
  o(parseValue, "parseValue");
  function parse(h, f) {
    f = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, f), validateArrayFormatSeparator(f.arrayFormatSeparator);
    const v = parserForArrayFormat(f),
      E = Object.create(null);
    if (typeof h != "string" || (h = h.trim().replace(/^[?#&]/, ""), !h)) return E;
    for (const b of h.split("&")) {
      if (b === "") continue;
      let [P, T] = r(f.decode ? b.replace(/\+/g, " ") : b, "=");
      T = T === void 0 ? null : ["comma", "separator"].includes(f.arrayFormat) ? T : decode$1(T, f), v(decode$1(P, f), T, E);
    }
    for (const b of Object.keys(E)) {
      const P = E[b];
      if (typeof P == "object" && P !== null) for (const T of Object.keys(P)) P[T] = parseValue(P[T], f);else E[b] = parseValue(P, f);
    }
    return f.sort === !1 ? E : (f.sort === !0 ? Object.keys(E).sort() : Object.keys(E).sort(f.sort)).reduce((b, P) => {
      const T = E[P];
      return T && typeof T == "object" && !Array.isArray(T) ? b[P] = keysSorter(T) : b[P] = T, b;
    }, Object.create(null));
  }
  o(parse, "parse"), t.extract = extract, t.parse = parse, t.stringify = (h, f) => {
    if (!h) return "";
    f = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, f), validateArrayFormatSeparator(f.arrayFormatSeparator);
    const shouldFilter = o(T => f.skipNull && isNullOrUndefined(h[T]) || f.skipEmptyString && h[T] === "", "shouldFilter"),
      E = encoderForArrayFormat(f),
      b = {};
    for (const T of Object.keys(h)) shouldFilter(T) || (b[T] = h[T]);
    const P = Object.keys(b);
    return f.sort !== !1 && P.sort(f.sort), P.map(T => {
      const O = h[T];
      return O === void 0 ? "" : O === null ? encode$1(T, f) : Array.isArray(O) ? O.reduce(E(T), []).join("&") : encode$1(T, f) + "=" + encode$1(O, f);
    }).filter(T => T.length > 0).join("&");
  }, t.parseUrl = (h, f) => {
    f = Object.assign({
      decode: !0
    }, f);
    const [v, E] = r(h, "#");
    return Object.assign({
      url: v.split("?")[0] || "",
      query: parse(extract(h), f)
    }, f && f.parseFragmentIdentifier && E ? {
      fragmentIdentifier: decode$1(E, f)
    } : {});
  }, t.stringifyUrl = (h, f) => {
    f = Object.assign({
      encode: !0,
      strict: !0
    }, f);
    const v = removeHash(h.url).split("?")[0] || "",
      E = t.extract(h.url),
      b = t.parse(E, {
        sort: !1
      }),
      P = Object.assign(b, h.query);
    let T = t.stringify(P, f);
    T && (T = `?${T}`);
    let O = getHash(h.url);
    return h.fragmentIdentifier && (O = `#${encode$1(h.fragmentIdentifier, f)}`), `${v}${T}${O}`;
  }, t.pick = (h, f, v) => {
    v = Object.assign({
      parseFragmentIdentifier: !0
    }, v);
    const {
      url: E,
      query: b,
      fragmentIdentifier: P
    } = t.parseUrl(h, v);
    return t.stringifyUrl({
      url: E,
      query: i(b, f),
      fragmentIdentifier: P
    }, v);
  }, t.exclude = (h, f, v) => {
    const E = Array.isArray(f) ? b => !f.includes(b) : (b, P) => !f(b, P);
    return t.pick(h, E, v);
  };
})(queryString);
var RS = protocols,
  NS = _S,
  $S = queryString;
function parsePath(t) {
  t = (t || "").trim().replace(/\r?\n|\r/gm, "");
  var e = {
      protocols: RS(t),
      protocol: null,
      port: null,
      resource: "",
      user: "",
      pathname: "",
      hash: "",
      search: "",
      href: t,
      query: Object.create(null)
    },
    n = t.indexOf("://"),
    r = null,
    i = null;
  t.startsWith(".") && (t.startsWith("./") && (t = t.substring(2)), e.pathname = t, e.protocol = "file");
  var s = t.charAt(1);
  if (e.protocol || (e.protocol = e.protocols[0], e.protocol || (NS(t) ? e.protocol = "ssh" : ((s === "/" || s === "~") && (t = t.substring(2)), e.protocol = "file"))), n !== -1 && (t = t.substring(n + 3)), i = t.split(/\/|\\/), e.protocol !== "file" ? e.resource = i.shift() : e.resource = "", r = e.resource.split("@"), r.length === 2 && (e.user = r[0], e.resource = r[1]), r = e.resource.split(":"), r.length === 2) {
    e.resource = r[0];
    var a = r[1];
    a ? (e.port = Number(a), (isNaN(e.port) || a.match(/^\d+$/) === null) && (e.port = null, i.unshift(a))) : e.port = null;
  }
  return i = i.filter(Boolean), e.protocol === "file" ? e.pathname = e.href : e.pathname = e.pathname || (e.protocol !== "file" || e.href[0] === "/" ? "/" : "") + i.join("/"), r = e.pathname.split("#"), r.length === 2 && (e.pathname = r[0], e.hash = r[1]), r = e.pathname.split("?"), r.length === 2 && (e.pathname = r[0], e.search = r[1]), e.query = $S.parse(e.search), e.href = e.href.replace(/\/$/, ""), e.pathname = e.pathname.replace(/\/$/, ""), e;
}
o(parsePath, "parsePath$1");
var jS = parsePath,
  Kf = {
    exports: {}
  },
  vr = {},
  vs = {
    exports: {}
  }; /*! https://mths.be/punycode v1.4.1 by @mathias */
vs.exports;
var lh;
function requirePunycode() {
  return lh || (lh = 1, function (t, e) {
    (function (n) {
      var r = e && !e.nodeType && e,
        i = t && !t.nodeType && t,
        s = typeof On == "object" && On;
      (s.global === s || s.window === s || s.self === s) && (n = s);
      var a,
        l = 2147483647,
        u = 36,
        c = 1,
        p = 26,
        m = 38,
        d = 700,
        y = 72,
        S = 128,
        w = "-",
        g = /^xn--/,
        h = /[^\x20-\x7E]/,
        f = /[\x2E\u3002\uFF0E\uFF61]/g,
        v = {
          overflow: "Overflow: input needs wider integers to process",
          "not-basic": "Illegal input >= 0x80 (not a basic code point)",
          "invalid-input": "Invalid input"
        },
        E = u - c,
        b = Math.floor,
        P = String.fromCharCode,
        T;
      function error(q) {
        throw new RangeError(v[q]);
      }
      o(error, "error");
      function map(q, C) {
        for (var A = q.length, L = []; A--;) L[A] = C(q[A]);
        return L;
      }
      o(map, "map");
      function mapDomain(q, C) {
        var A = q.split("@"),
          L = "";
        A.length > 1 && (L = A[0] + "@", q = A[1]), q = q.replace(f, ".");
        var V = q.split("."),
          Y = map(V, C).join(".");
        return L + Y;
      }
      o(mapDomain, "mapDomain");
      function ucs2decode(q) {
        for (var C = [], A = 0, L = q.length, V, Y; A < L;) V = q.charCodeAt(A++), V >= 55296 && V <= 56319 && A < L ? (Y = q.charCodeAt(A++), (Y & 64512) == 56320 ? C.push(((V & 1023) << 10) + (Y & 1023) + 65536) : (C.push(V), A--)) : C.push(V);
        return C;
      }
      o(ucs2decode, "ucs2decode");
      function ucs2encode(q) {
        return map(q, function (C) {
          var A = "";
          return C > 65535 && (C -= 65536, A += P(C >>> 10 & 1023 | 55296), C = 56320 | C & 1023), A += P(C), A;
        }).join("");
      }
      o(ucs2encode, "ucs2encode");
      function basicToDigit(q) {
        return q - 48 < 10 ? q - 22 : q - 65 < 26 ? q - 65 : q - 97 < 26 ? q - 97 : u;
      }
      o(basicToDigit, "basicToDigit");
      function digitToBasic(q, C) {
        return q + 22 + 75 * (q < 26) - ((C != 0) << 5);
      }
      o(digitToBasic, "digitToBasic");
      function adapt(q, C, A) {
        var L = 0;
        for (q = A ? b(q / d) : q >> 1, q += b(q / C); q > E * p >> 1; L += u) q = b(q / E);
        return b(L + (E + 1) * q / (q + m));
      }
      o(adapt, "adapt");
      function decode$2(q) {
        var C = [],
          A = q.length,
          L,
          V = 0,
          Y = S,
          re = y,
          ae,
          le,
          ce,
          W,
          ie,
          de,
          fe,
          ge,
          we;
        for (ae = q.lastIndexOf(w), ae < 0 && (ae = 0), le = 0; le < ae; ++le) q.charCodeAt(le) >= 128 && error("not-basic"), C.push(q.charCodeAt(le));
        for (ce = ae > 0 ? ae + 1 : 0; ce < A;) {
          for (W = V, ie = 1, de = u; ce >= A && error("invalid-input"), fe = basicToDigit(q.charCodeAt(ce++)), (fe >= u || fe > b((l - V) / ie)) && error("overflow"), V += fe * ie, ge = de <= re ? c : de >= re + p ? p : de - re, !(fe < ge); de += u) we = u - ge, ie > b(l / we) && error("overflow"), ie *= we;
          L = C.length + 1, re = adapt(V - W, L, W == 0), b(V / L) > l - Y && error("overflow"), Y += b(V / L), V %= L, C.splice(V++, 0, Y);
        }
        return ucs2encode(C);
      }
      o(decode$2, "decode");
      function encode$2(q) {
        var C,
          A,
          L,
          V,
          Y,
          re,
          ae,
          le,
          ce,
          W,
          ie,
          de = [],
          fe,
          ge,
          we,
          ke;
        for (q = ucs2decode(q), fe = q.length, C = S, A = 0, Y = y, re = 0; re < fe; ++re) ie = q[re], ie < 128 && de.push(P(ie));
        for (L = V = de.length, V && de.push(w); L < fe;) {
          for (ae = l, re = 0; re < fe; ++re) ie = q[re], ie >= C && ie < ae && (ae = ie);
          for (ge = L + 1, ae - C > b((l - A) / ge) && error("overflow"), A += (ae - C) * ge, C = ae, re = 0; re < fe; ++re) if (ie = q[re], ie < C && ++A > l && error("overflow"), ie == C) {
            for (le = A, ce = u; W = ce <= Y ? c : ce >= Y + p ? p : ce - Y, !(le < W); ce += u) ke = le - W, we = u - W, de.push(P(digitToBasic(W + ke % we, 0))), le = b(ke / we);
            de.push(P(digitToBasic(le, 0))), Y = adapt(A, ge, L == V), A = 0, ++L;
          }
          ++A, ++C;
        }
        return de.join("");
      }
      o(encode$2, "encode");
      function toUnicode(q) {
        return mapDomain(q, function (C) {
          return g.test(C) ? decode$2(C.slice(4).toLowerCase()) : C;
        });
      }
      o(toUnicode, "toUnicode");
      function toASCII(q) {
        return mapDomain(q, function (C) {
          return h.test(C) ? "xn--" + encode$2(C) : C;
        });
      }
      if (o(toASCII, "toASCII"), a = {
        version: "1.4.1",
        ucs2: {
          decode: ucs2decode,
          encode: ucs2encode
        },
        decode: decode$2,
        encode: encode$2,
        toASCII: toASCII,
        toUnicode: toUnicode
      }, r && i) {
        if (t.exports == r) i.exports = a;else for (T in a) a.hasOwnProperty(T) && (r[T] = a[T]);
      } else n.punycode = a;
    })(On);
  }(vs, vs.exports)), vs.exports;
}
o(requirePunycode, "requirePunycode");
var hu, uh;
function requireEsErrors() {
  return uh || (uh = 1, hu = Error), hu;
}
o(requireEsErrors, "requireEsErrors");
var mu, ch;
function require_eval() {
  return ch || (ch = 1, mu = EvalError), mu;
}
o(require_eval, "require_eval");
var gu, fh;
function requireRange() {
  return fh || (fh = 1, gu = RangeError), gu;
}
o(requireRange, "requireRange");
var yu, dh;
function requireRef() {
  return dh || (dh = 1, yu = ReferenceError), yu;
}
o(requireRef, "requireRef");
var vu, ph;
function requireSyntax() {
  return ph || (ph = 1, vu = SyntaxError), vu;
}
o(requireSyntax, "requireSyntax");
var wu, hh;
function requireType() {
  return hh || (hh = 1, wu = TypeError), wu;
}
o(requireType, "requireType");
var bu, mh;
function requireUri() {
  return mh || (mh = 1, bu = URIError), bu;
}
o(requireUri, "requireUri");
var Su, gh;
function requireShams() {
  return gh || (gh = 1, Su = o(function () {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
    if (typeof Symbol.iterator == "symbol") return !0;
    var e = {},
      n = Symbol("test"),
      r = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]") return !1;
    var i = 42;
    e[n] = i;
    for (n in e) return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0) return !1;
    var s = Object.getOwnPropertySymbols(e);
    if (s.length !== 1 || s[0] !== n || !Object.prototype.propertyIsEnumerable.call(e, n)) return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var a = Object.getOwnPropertyDescriptor(e, n);
      if (a.value !== i || a.enumerable !== !0) return !1;
    }
    return !0;
  }, "hasSymbols")), Su;
}
o(requireShams, "requireShams");
var Eu, yh;
function requireHasSymbols() {
  if (yh) return Eu;
  yh = 1;
  var t = typeof Symbol < "u" && Symbol,
    e = requireShams();
  return Eu = o(function () {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, "hasNativeSymbols"), Eu;
}
o(requireHasSymbols, "requireHasSymbols");
var Tu, vh;
function requireHasProto() {
  if (vh) return Tu;
  vh = 1;
  var t = {
      __proto__: null,
      foo: {}
    },
    e = Object;
  return Tu = o(function () {
    return {
      __proto__: t
    }.foo === t.foo && !(t instanceof e);
  }, "hasProto"), Tu;
}
o(requireHasProto, "requireHasProto");
var Pu, wh;
function requireImplementation() {
  if (wh) return Pu;
  wh = 1;
  var t = "Function.prototype.bind called on incompatible ",
    e = Object.prototype.toString,
    n = Math.max,
    r = "[object Function]",
    concatty = o(function (u, c) {
      for (var p = [], m = 0; m < u.length; m += 1) p[m] = u[m];
      for (var d = 0; d < c.length; d += 1) p[d + u.length] = c[d];
      return p;
    }, "concatty"),
    slicy = o(function (u, c) {
      for (var p = [], m = c || 0, d = 0; m < u.length; m += 1, d += 1) p[d] = u[m];
      return p;
    }, "slicy"),
    joiny = o(function (l, u) {
      for (var c = "", p = 0; p < l.length; p += 1) c += l[p], p + 1 < l.length && (c += u);
      return c;
    }, "joiny");
  return Pu = o(function (u) {
    var c = this;
    if (typeof c != "function" || e.apply(c) !== r) throw new TypeError(t + c);
    for (var p = slicy(arguments, 1), m, binder = o(function () {
        if (this instanceof m) {
          var h = c.apply(this, concatty(p, arguments));
          return Object(h) === h ? h : this;
        }
        return c.apply(u, concatty(p, arguments));
      }, "binder"), y = n(0, c.length - p.length), S = [], w = 0; w < y; w++) S[w] = "$" + w;
    if (m = Function("binder", "return function (" + joiny(S, ",") + "){ return binder.apply(this,arguments); }")(binder), c.prototype) {
      var Empty = o(function () {}, "Empty");
      Empty.prototype = c.prototype, m.prototype = new Empty(), Empty.prototype = null;
    }
    return m;
  }, "bind"), Pu;
}
o(requireImplementation, "requireImplementation");
var Cu, bh;
function requireFunctionBind() {
  if (bh) return Cu;
  bh = 1;
  var t = requireImplementation();
  return Cu = Function.prototype.bind || t, Cu;
}
o(requireFunctionBind, "requireFunctionBind");
var xu, Sh;
function requireHasown() {
  if (Sh) return xu;
  Sh = 1;
  var t = Function.prototype.call,
    e = Object.prototype.hasOwnProperty,
    n = requireFunctionBind();
  return xu = n.call(t, e), xu;
}
o(requireHasown, "requireHasown");
var ku, Eh;
function requireGetIntrinsic() {
  if (Eh) return ku;
  Eh = 1;
  var t,
    e = requireEsErrors(),
    n = require_eval(),
    r = requireRange(),
    i = requireRef(),
    s = requireSyntax(),
    a = requireType(),
    l = requireUri(),
    u = Function,
    getEvalledConstructor = o(function (te) {
      try {
        return u('"use strict"; return (' + te + ").constructor;")();
      } catch {}
    }, "getEvalledConstructor"),
    p = Object.getOwnPropertyDescriptor;
  if (p) try {
    p({}, "");
  } catch {
    p = null;
  }
  var throwTypeError = o(function () {
      throw new a();
    }, "throwTypeError"),
    d = p ? function () {
      try {
        return arguments.callee, throwTypeError;
      } catch {
        try {
          return p(arguments, "callee").get;
        } catch {
          return throwTypeError;
        }
      }
    }() : throwTypeError,
    y = requireHasSymbols()(),
    S = requireHasProto()(),
    w = Object.getPrototypeOf || (S ? function (te) {
      return te.__proto__;
    } : null),
    g = {},
    h = typeof Uint8Array > "u" || !w ? t : w(Uint8Array),
    f = {
      __proto__: null,
      "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
      "%ArrayIteratorPrototype%": y && w ? w([][Symbol.iterator]()) : t,
      "%AsyncFromSyncIteratorPrototype%": t,
      "%AsyncFunction%": g,
      "%AsyncGenerator%": g,
      "%AsyncGeneratorFunction%": g,
      "%AsyncIteratorPrototype%": g,
      "%Atomics%": typeof Atomics > "u" ? t : Atomics,
      "%BigInt%": typeof BigInt > "u" ? t : BigInt,
      "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
      "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView > "u" ? t : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": e,
      "%eval%": eval,
      "%EvalError%": n,
      "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
      "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
      "%Function%": u,
      "%GeneratorFunction%": g,
      "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
      "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
      "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": y && w ? w(w([][Symbol.iterator]())) : t,
      "%JSON%": typeof JSON == "object" ? JSON : t,
      "%Map%": typeof Map > "u" ? t : Map,
      "%MapIteratorPrototype%": typeof Map > "u" || !y || !w ? t : w(new Map()[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise > "u" ? t : Promise,
      "%Proxy%": typeof Proxy > "u" ? t : Proxy,
      "%RangeError%": r,
      "%ReferenceError%": i,
      "%Reflect%": typeof Reflect > "u" ? t : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set > "u" ? t : Set,
      "%SetIteratorPrototype%": typeof Set > "u" || !y || !w ? t : w(new Set()[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": y && w ? w(""[Symbol.iterator]()) : t,
      "%Symbol%": y ? Symbol : t,
      "%SyntaxError%": s,
      "%ThrowTypeError%": d,
      "%TypedArray%": h,
      "%TypeError%": a,
      "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
      "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
      "%URIError%": l,
      "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
      "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
      "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet
    };
  if (w) try {
    null.error;
  } catch (te) {
    var v = w(w(te));
    f["%Error.prototype%"] = v;
  }
  var doEval = o(function te(j) {
      var X;
      if (j === "%AsyncFunction%") X = getEvalledConstructor("async function () {}");else if (j === "%GeneratorFunction%") X = getEvalledConstructor("function* () {}");else if (j === "%AsyncGeneratorFunction%") X = getEvalledConstructor("async function* () {}");else if (j === "%AsyncGenerator%") {
        var q = te("%AsyncGeneratorFunction%");
        q && (X = q.prototype);
      } else if (j === "%AsyncIteratorPrototype%") {
        var C = te("%AsyncGenerator%");
        C && w && (X = w(C.prototype));
      }
      return f[j] = X, X;
    }, "doEval"),
    b = {
      __proto__: null,
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    },
    P = requireFunctionBind(),
    T = requireHasown(),
    O = P.call(Function.call, Array.prototype.concat),
    M = P.call(Function.apply, Array.prototype.splice),
    I = P.call(Function.call, String.prototype.replace),
    U = P.call(Function.call, String.prototype.slice),
    _ = P.call(Function.call, RegExp.prototype.exec),
    R = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
    B = /\\(\\)?/g,
    stringToPath = o(function (j) {
      var X = U(j, 0, 1),
        q = U(j, -1);
      if (X === "%" && q !== "%") throw new s("invalid intrinsic syntax, expected closing `%`");
      if (q === "%" && X !== "%") throw new s("invalid intrinsic syntax, expected opening `%`");
      var C = [];
      return I(j, R, function (A, L, V, Y) {
        C[C.length] = V ? I(Y, B, "$1") : L || A;
      }), C;
    }, "stringToPath"),
    getBaseIntrinsic = o(function (j, X) {
      var q = j,
        C;
      if (T(b, q) && (C = b[q], q = "%" + C[0] + "%"), T(f, q)) {
        var A = f[q];
        if (A === g && (A = doEval(q)), typeof A > "u" && !X) throw new a("intrinsic " + j + " exists, but is not available. Please file an issue!");
        return {
          alias: C,
          name: q,
          value: A
        };
      }
      throw new s("intrinsic " + j + " does not exist!");
    }, "getBaseIntrinsic");
  return ku = o(function (j, X) {
    if (typeof j != "string" || j.length === 0) throw new a("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof X != "boolean") throw new a('"allowMissing" argument must be a boolean');
    if (_(/^%?[^%]*%?$/, j) === null) throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var q = stringToPath(j),
      C = q.length > 0 ? q[0] : "",
      A = getBaseIntrinsic("%" + C + "%", X),
      L = A.name,
      V = A.value,
      Y = !1,
      re = A.alias;
    re && (C = re[0], M(q, O([0, 1], re)));
    for (var ae = 1, le = !0; ae < q.length; ae += 1) {
      var ce = q[ae],
        W = U(ce, 0, 1),
        ie = U(ce, -1);
      if ((W === '"' || W === "'" || W === "`" || ie === '"' || ie === "'" || ie === "`") && W !== ie) throw new s("property names with quotes must have matching quotes");
      if ((ce === "constructor" || !le) && (Y = !0), C += "." + ce, L = "%" + C + "%", T(f, L)) V = f[L];else if (V != null) {
        if (!(ce in V)) {
          if (!X) throw new a("base intrinsic for " + j + " exists, but the property is not available.");
          return;
        }
        if (p && ae + 1 >= q.length) {
          var de = p(V, ce);
          le = !!de, le && "get" in de && !("originalValue" in de.get) ? V = de.get : V = V[ce];
        } else le = T(V, ce), V = V[ce];
        le && !Y && (f[L] = V);
      }
    }
    return V;
  }, "GetIntrinsic"), ku;
}
o(requireGetIntrinsic, "requireGetIntrinsic");
var _u = {
    exports: {}
  },
  Ou,
  Th;
function requireEsDefineProperty() {
  if (Th) return Ou;
  Th = 1;
  var t = requireGetIntrinsic(),
    e = t("%Object.defineProperty%", !0) || !1;
  if (e) try {
    e({}, "a", {
      value: 1
    });
  } catch {
    e = !1;
  }
  return Ou = e, Ou;
}
o(requireEsDefineProperty, "requireEsDefineProperty");
var Au, Ph;
function requireGopd() {
  if (Ph) return Au;
  Ph = 1;
  var t = requireGetIntrinsic(),
    e = t("%Object.getOwnPropertyDescriptor%", !0);
  if (e) try {
    e([], "length");
  } catch {
    e = null;
  }
  return Au = e, Au;
}
o(requireGopd, "requireGopd");
var Lu, Ch;
function requireDefineDataProperty() {
  if (Ch) return Lu;
  Ch = 1;
  var t = requireEsDefineProperty(),
    e = requireSyntax(),
    n = requireType(),
    r = requireGopd();
  return Lu = o(function (s, a, l) {
    if (!s || typeof s != "object" && typeof s != "function") throw new n("`obj` must be an object or a function`");
    if (typeof a != "string" && typeof a != "symbol") throw new n("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null) throw new n("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null) throw new n("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null) throw new n("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean") throw new n("`loose`, if provided, must be a boolean");
    var u = arguments.length > 3 ? arguments[3] : null,
      c = arguments.length > 4 ? arguments[4] : null,
      p = arguments.length > 5 ? arguments[5] : null,
      m = arguments.length > 6 ? arguments[6] : !1,
      d = !!r && r(s, a);
    if (t) t(s, a, {
      configurable: p === null && d ? d.configurable : !p,
      enumerable: u === null && d ? d.enumerable : !u,
      value: l,
      writable: c === null && d ? d.writable : !c
    });else if (m || !u && !c && !p) s[a] = l;else throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, "defineDataProperty"), Lu;
}
o(requireDefineDataProperty, "requireDefineDataProperty");
var Mu, xh;
function requireHasPropertyDescriptors() {
  if (xh) return Mu;
  xh = 1;
  var t = requireEsDefineProperty(),
    hasPropertyDescriptors = o(function () {
      return !!t;
    }, "hasPropertyDescriptors");
  return hasPropertyDescriptors.hasArrayLengthDefineBug = o(function () {
    if (!t) return null;
    try {
      return t([], "length", {
        value: 1
      }).length !== 1;
    } catch {
      return !0;
    }
  }, "hasArrayLengthDefineBug"), Mu = hasPropertyDescriptors, Mu;
}
o(requireHasPropertyDescriptors, "requireHasPropertyDescriptors");
var Du, kh;
function requireSetFunctionLength() {
  if (kh) return Du;
  kh = 1;
  var t = requireGetIntrinsic(),
    e = requireDefineDataProperty(),
    n = requireHasPropertyDescriptors()(),
    r = requireGopd(),
    i = requireType(),
    s = t("%Math.floor%");
  return Du = o(function (length, u) {
    if (typeof length != "function") throw new i("`fn` is not a function");
    if (typeof u != "number" || u < 0 || u > 4294967295 || s(u) !== u) throw new i("`length` must be a positive 32-bit integer");
    var c = arguments.length > 2 && !!arguments[2],
      p = !0,
      m = !0;
    if ("length" in length && r) {
      var length$1 = r(length, "length");
      length$1 && !length$1.configurable && (p = !1), length$1 && !length$1.writable && (m = !1);
    }
    return (p || m || !c) && (n ? e(length, "length", u, !0, !0) : e(length, "length", u)), length;
  }, "setFunctionLength"), Du;
}
o(requireSetFunctionLength, "requireSetFunctionLength");
var _h;
function requireCallBind() {
  return _h || (_h = 1, function (t) {
    var e = requireFunctionBind(),
      n = requireGetIntrinsic(),
      r = requireSetFunctionLength(),
      i = requireType(),
      s = n("%Function.prototype.apply%"),
      a = n("%Function.prototype.call%"),
      l = n("%Reflect.apply%", !0) || e.call(a, s),
      u = requireEsDefineProperty(),
      c = n("%Math.max%");
    t.exports = o(function (d) {
      if (typeof d != "function") throw new i("a function is required");
      var y = l(e, a, arguments);
      return r(y, 1 + c(0, d.length - (arguments.length - 1)), !0);
    }, "callBind");
    var applyBind = o(function () {
      return l(e, s, arguments);
    }, "applyBind");
    u ? u(t.exports, "apply", {
      value: applyBind
    }) : t.exports.apply = applyBind;
  }(_u)), _u.exports;
}
o(requireCallBind, "requireCallBind");
var Iu, Oh;
function requireCallBound() {
  if (Oh) return Iu;
  Oh = 1;
  var t = requireGetIntrinsic(),
    e = requireCallBind(),
    n = e(t("String.prototype.indexOf"));
  return Iu = o(function (i, s) {
    var a = t(i, !!s);
    return typeof a == "function" && n(i, ".prototype.") > -1 ? e(a) : a;
  }, "callBoundIntrinsic"), Iu;
}
o(requireCallBound, "requireCallBound");
const nE = {},
  rE = Object.freeze(Object.defineProperty({
    __proto__: null,
    default: nE
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  iE = getAugmentedNamespace(rE);
var Ru, Ah;
function requireObjectInspect() {
  if (Ah) return Ru;
  Ah = 1;
  var t = typeof Map == "function" && Map.prototype,
    e = Object.getOwnPropertyDescriptor && t ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
    n = t && e && typeof e.get == "function" ? e.get : null,
    r = t && Map.prototype.forEach,
    i = typeof Set == "function" && Set.prototype,
    s = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
    a = i && s && typeof s.get == "function" ? s.get : null,
    l = i && Set.prototype.forEach,
    u = typeof WeakMap == "function" && WeakMap.prototype,
    c = u ? WeakMap.prototype.has : null,
    p = typeof WeakSet == "function" && WeakSet.prototype,
    m = p ? WeakSet.prototype.has : null,
    d = typeof WeakRef == "function" && WeakRef.prototype,
    y = d ? WeakRef.prototype.deref : null,
    S = Boolean.prototype.valueOf,
    w = Object.prototype.toString,
    g = Function.prototype.toString,
    h = String.prototype.match,
    f = String.prototype.slice,
    v = String.prototype.replace,
    E = String.prototype.toUpperCase,
    b = String.prototype.toLowerCase,
    P = RegExp.prototype.test,
    T = Array.prototype.concat,
    O = Array.prototype.join,
    M = Array.prototype.slice,
    I = Math.floor,
    U = typeof BigInt == "function" ? BigInt.prototype.valueOf : null,
    _ = Object.getOwnPropertySymbols,
    R = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null,
    B = typeof Symbol == "function" && typeof Symbol.iterator == "object",
    H = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === B || "symbol") ? Symbol.toStringTag : null,
    Q = Object.prototype.propertyIsEnumerable,
    te = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function ($) {
      return $.__proto__;
    } : null);
  function addNumericSeparator($, F) {
    if ($ === 1 / 0 || $ === -1 / 0 || $ !== $ || $ && $ > -1e3 && $ < 1e3 || P.call(/e/, F)) return F;
    var be = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof $ == "number") {
      var Oe = $ < 0 ? -I(-$) : I($);
      if (Oe !== $) {
        var Me = String(Oe),
          ve = f.call(F, Me.length + 1);
        return v.call(Me, be, "$&_") + "." + v.call(v.call(ve, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return v.call(F, be, "$&_");
  }
  o(addNumericSeparator, "addNumericSeparator");
  var X = iE,
    q = X.custom,
    C = isSymbol(q) ? q : null,
    A = {
      __proto__: null,
      double: '"',
      single: "'"
    },
    L = {
      __proto__: null,
      double: /(["\\])/g,
      single: /(['\\])/g
    };
  Ru = o(function $(F, be, Oe, Me) {
    var quoteStyle = be || {};
    if (has(quoteStyle, "quoteStyle") && !has(A, quoteStyle.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(quoteStyle, "maxStringLength") && (typeof quoteStyle.maxStringLength == "number" ? quoteStyle.maxStringLength < 0 && quoteStyle.maxStringLength !== 1 / 0 : quoteStyle.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var rn = has(quoteStyle, "customInspect") ? quoteStyle.customInspect : !0;
    if (typeof rn != "boolean" && rn !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (has(quoteStyle, "indent") && quoteStyle.indent !== null && quoteStyle.indent !== "	" && !(parseInt(quoteStyle.indent, 10) === quoteStyle.indent && quoteStyle.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(quoteStyle, "numericSeparator") && typeof quoteStyle.numericSeparator != "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var Cn = quoteStyle.numericSeparator;
    if (typeof F > "u") return "undefined";
    if (F === null) return "null";
    if (typeof F == "boolean") return F ? "true" : "false";
    if (typeof F == "string") return inspectString(F, quoteStyle);
    if (typeof F == "number") {
      if (F === 0) return 1 / 0 / F > 0 ? "0" : "-0";
      var Tt = String(F);
      return Cn ? addNumericSeparator(F, Tt) : Tt;
    }
    if (typeof F == "bigint") {
      var Nt = String(F) + "n";
      return Cn ? addNumericSeparator(F, Nt) : Nt;
    }
    var k = typeof quoteStyle.depth > "u" ? 5 : quoteStyle.depth;
    if (typeof Oe > "u" && (Oe = 0), Oe >= k && k > 0 && typeof F == "object") return isArray$1(F) ? "[Array]" : "[Object]";
    var D = getIndent(quoteStyle, Oe);
    if (typeof Me > "u") Me = [];else if (indexOf(Me, F) >= 0) return "[Circular]";
    function inspect(mn, yr, Wi) {
      if (yr && (Me = M.call(Me), Me.push(yr)), Wi) {
        var Gi = {
          depth: quoteStyle.depth
        };
        return has(quoteStyle, "quoteStyle") && (Gi.quoteStyle = quoteStyle.quoteStyle), $(mn, Gi, Oe + 1, Me);
      }
      return $(mn, quoteStyle, Oe + 1, Me);
    }
    if (o(inspect, "inspect"), typeof F == "function" && !isRegExp(F)) {
      var G = nameOf(F),
        J = arrObjKeys(F, inspect);
      return "[Function" + (G ? ": " + G : " (anonymous)") + "]" + (J.length > 0 ? " { " + O.call(J, ", ") + " }" : "");
    }
    if (isSymbol(F)) {
      var Z = B ? v.call(String(F), /^(Symbol\(.*\))_[^)]*$/, "$1") : R.call(F);
      return typeof F == "object" && !B ? markBoxed(Z) : Z;
    }
    if (isElement(F)) {
      for (var ue = "<" + b.call(String(F.nodeName)), se = F.attributes || [], Pe = 0; Pe < se.length; Pe++) ue += " " + se[Pe].name + "=" + wrapQuotes(quote(se[Pe].value), "double", quoteStyle);
      return ue += ">", F.childNodes && F.childNodes.length && (ue += "..."), ue += "</" + b.call(String(F.nodeName)) + ">", ue;
    }
    if (isArray$1(F)) {
      if (F.length === 0) return "[]";
      var xe = arrObjKeys(F, inspect);
      return D && !singleLineValues(xe) ? "[" + indentedJoin(xe, D) + "]" : "[ " + O.call(xe, ", ") + " ]";
    }
    if (isError(F)) {
      var De = arrObjKeys(F, inspect);
      return !("cause" in Error.prototype) && "cause" in F && !Q.call(F, "cause") ? "{ [" + String(F) + "] " + O.call(T.call("[cause]: " + inspect(F.cause), De), ", ") + " }" : De.length === 0 ? "[" + String(F) + "]" : "{ [" + String(F) + "] " + O.call(De, ", ") + " }";
    }
    if (typeof F == "object" && rn) {
      if (C && typeof F[C] == "function" && X) return X(F, {
        depth: k - Oe
      });
      if (rn !== "symbol" && typeof F.inspect == "function") return F.inspect();
    }
    if (isMap(F)) {
      var Re = [];
      return r && r.call(F, function (mn, yr) {
        Re.push(inspect(yr, F, !0) + " => " + inspect(mn, F));
      }), collectionOf("Map", n.call(F), Re, D);
    }
    if (isSet(F)) {
      var Se = [];
      return l && l.call(F, function (mn) {
        Se.push(inspect(mn, F));
      }), collectionOf("Set", a.call(F), Se, D);
    }
    if (isWeakMap(F)) return weakCollectionOf("WeakMap");
    if (isWeakSet(F)) return weakCollectionOf("WeakSet");
    if (isWeakRef(F)) return weakCollectionOf("WeakRef");
    if (isNumber$2(F)) return markBoxed(inspect(Number(F)));
    if (isBigInt(F)) return markBoxed(inspect(U.call(F)));
    if (isBoolean(F)) return markBoxed(S.call(F));
    if (isString$1(F)) return markBoxed(inspect(String(F)));
    if (typeof window < "u" && F === window) return "{ [object Window] }";
    if (typeof globalThis < "u" && F === globalThis || typeof On < "u" && F === On) return "{ [object globalThis] }";
    if (!isDate$1(F) && !isRegExp(F)) {
      var Be = arrObjKeys(F, inspect),
        et = te ? te(F) === Object.prototype : F instanceof Object || F.constructor === Object,
        Ue = F instanceof Object ? "" : "null prototype",
        Ke = !et && H && Object(F) === F && H in F ? f.call(toStr(F), 8, -1) : Ue ? "Object" : "",
        Vi = et || typeof F.constructor != "function" ? "" : F.constructor.name ? F.constructor.name + " " : "",
        gr = Vi + (Ke || Ue ? "[" + O.call(T.call([], Ke || [], Ue || []), ": ") + "] " : "");
      return Be.length === 0 ? gr + "{}" : D ? gr + "{" + indentedJoin(Be, D) + "}" : gr + "{ " + O.call(Be, ", ") + " }";
    }
    return String(F);
  }, "inspect_");
  function wrapQuotes($, F, be) {
    var Oe = be.quoteStyle || F,
      Me = A[Oe];
    return Me + $ + Me;
  }
  o(wrapQuotes, "wrapQuotes");
  function quote($) {
    return v.call(String($), /"/g, "&quot;");
  }
  o(quote, "quote");
  function isArray$1($) {
    return toStr($) === "[object Array]" && (!H || !(typeof $ == "object" && H in $));
  }
  o(isArray$1, "isArray");
  function isDate$1($) {
    return toStr($) === "[object Date]" && (!H || !(typeof $ == "object" && H in $));
  }
  o(isDate$1, "isDate");
  function isRegExp($) {
    return toStr($) === "[object RegExp]" && (!H || !(typeof $ == "object" && H in $));
  }
  o(isRegExp, "isRegExp");
  function isError($) {
    return toStr($) === "[object Error]" && (!H || !(typeof $ == "object" && H in $));
  }
  o(isError, "isError");
  function isString$1($) {
    return toStr($) === "[object String]" && (!H || !(typeof $ == "object" && H in $));
  }
  o(isString$1, "isString");
  function isNumber$2($) {
    return toStr($) === "[object Number]" && (!H || !(typeof $ == "object" && H in $));
  }
  o(isNumber$2, "isNumber");
  function isBoolean($) {
    return toStr($) === "[object Boolean]" && (!H || !(typeof $ == "object" && H in $));
  }
  o(isBoolean, "isBoolean");
  function isSymbol($) {
    if (B) return $ && typeof $ == "object" && $ instanceof Symbol;
    if (typeof $ == "symbol") return !0;
    if (!$ || typeof $ != "object" || !R) return !1;
    try {
      return R.call($), !0;
    } catch {}
    return !1;
  }
  o(isSymbol, "isSymbol");
  function isBigInt($) {
    if (!$ || typeof $ != "object" || !U) return !1;
    try {
      return U.call($), !0;
    } catch {}
    return !1;
  }
  o(isBigInt, "isBigInt");
  var we = Object.prototype.hasOwnProperty || function ($) {
    return $ in this;
  };
  function has($, F) {
    return we.call($, F);
  }
  o(has, "has");
  function toStr($) {
    return w.call($);
  }
  o(toStr, "toStr");
  function nameOf($) {
    if ($.name) return $.name;
    var F = h.call(g.call($), /^function\s*([\w$]+)/);
    return F ? F[1] : null;
  }
  o(nameOf, "nameOf");
  function indexOf($, F) {
    if ($.indexOf) return $.indexOf(F);
    for (var be = 0, Oe = $.length; be < Oe; be++) if ($[be] === F) return be;
    return -1;
  }
  o(indexOf, "indexOf");
  function isMap($) {
    if (!n || !$ || typeof $ != "object") return !1;
    try {
      n.call($);
      try {
        a.call($);
      } catch {
        return !0;
      }
      return $ instanceof Map;
    } catch {}
    return !1;
  }
  o(isMap, "isMap");
  function isWeakMap($) {
    if (!c || !$ || typeof $ != "object") return !1;
    try {
      c.call($, c);
      try {
        m.call($, m);
      } catch {
        return !0;
      }
      return $ instanceof WeakMap;
    } catch {}
    return !1;
  }
  o(isWeakMap, "isWeakMap");
  function isWeakRef($) {
    if (!y || !$ || typeof $ != "object") return !1;
    try {
      return y.call($), !0;
    } catch {}
    return !1;
  }
  o(isWeakRef, "isWeakRef");
  function isSet($) {
    if (!a || !$ || typeof $ != "object") return !1;
    try {
      a.call($);
      try {
        n.call($);
      } catch {
        return !0;
      }
      return $ instanceof Set;
    } catch {}
    return !1;
  }
  o(isSet, "isSet");
  function isWeakSet($) {
    if (!m || !$ || typeof $ != "object") return !1;
    try {
      m.call($, m);
      try {
        c.call($, c);
      } catch {
        return !0;
      }
      return $ instanceof WeakSet;
    } catch {}
    return !1;
  }
  o(isWeakSet, "isWeakSet");
  function isElement($) {
    return !$ || typeof $ != "object" ? !1 : typeof HTMLElement < "u" && $ instanceof HTMLElement ? !0 : typeof $.nodeName == "string" && typeof $.getAttribute == "function";
  }
  o(isElement, "isElement");
  function inspectString($, F) {
    if ($.length > F.maxStringLength) {
      var be = $.length - F.maxStringLength,
        Oe = "... " + be + " more character" + (be > 1 ? "s" : "");
      return inspectString(f.call($, 0, F.maxStringLength), F) + Oe;
    }
    var Me = L[F.quoteStyle || "single"];
    Me.lastIndex = 0;
    var ve = v.call(v.call($, Me, "\\$1"), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(ve, "single", F);
  }
  o(inspectString, "inspectString");
  function lowbyte($) {
    var F = $.charCodeAt(0),
      be = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
      }[F];
    return be ? "\\" + be : "\\x" + (F < 16 ? "0" : "") + E.call(F.toString(16));
  }
  o(lowbyte, "lowbyte");
  function markBoxed($) {
    return "Object(" + $ + ")";
  }
  o(markBoxed, "markBoxed");
  function weakCollectionOf($) {
    return $ + " { ? }";
  }
  o(weakCollectionOf, "weakCollectionOf");
  function collectionOf($, F, be, Oe) {
    var Me = Oe ? indentedJoin(be, Oe) : O.call(be, ", ");
    return $ + " (" + F + ") {" + Me + "}";
  }
  o(collectionOf, "collectionOf");
  function singleLineValues($) {
    for (var F = 0; F < $.length; F++) if (indexOf($[F], `
`) >= 0) return !1;
    return !0;
  }
  o(singleLineValues, "singleLineValues");
  function getIndent($, F) {
    var be;
    if ($.indent === "	") be = "	";else if (typeof $.indent == "number" && $.indent > 0) be = O.call(Array($.indent + 1), " ");else return null;
    return {
      base: be,
      prev: O.call(Array(F + 1), be)
    };
  }
  o(getIndent, "getIndent");
  function indentedJoin($, F) {
    if ($.length === 0) return "";
    var be = `
` + F.prev + F.base;
    return be + O.call($, "," + be) + `
` + F.prev;
  }
  o(indentedJoin, "indentedJoin");
  function arrObjKeys($, F) {
    var be = isArray$1($),
      Oe = [];
    if (be) {
      Oe.length = $.length;
      for (var Me = 0; Me < $.length; Me++) Oe[Me] = has($, Me) ? F($[Me], $) : "";
    }
    var ve = typeof _ == "function" ? _($) : [],
      rn;
    if (B) {
      rn = {};
      for (var Cn = 0; Cn < ve.length; Cn++) rn["$" + ve[Cn]] = ve[Cn];
    }
    for (var Tt in $) has($, Tt) && (be && String(Number(Tt)) === Tt && Tt < $.length || B && rn["$" + Tt] instanceof Symbol || (P.call(/[^\w$]/, Tt) ? Oe.push(F(Tt, $) + ": " + F($[Tt], $)) : Oe.push(Tt + ": " + F($[Tt], $))));
    if (typeof _ == "function") for (var Nt = 0; Nt < ve.length; Nt++) Q.call($, ve[Nt]) && Oe.push("[" + F(ve[Nt]) + "]: " + F($[ve[Nt]], $));
    return Oe;
  }
  return o(arrObjKeys, "arrObjKeys"), Ru;
}
o(requireObjectInspect, "requireObjectInspect");
var Nu, Lh;
function requireSideChannel() {
  if (Lh) return Nu;
  Lh = 1;
  var t = requireGetIntrinsic(),
    e = requireCallBound(),
    n = requireObjectInspect(),
    r = requireType(),
    i = t("%WeakMap%", !0),
    s = t("%Map%", !0),
    a = e("WeakMap.prototype.get", !0),
    l = e("WeakMap.prototype.set", !0),
    u = e("WeakMap.prototype.has", !0),
    c = e("Map.prototype.get", !0),
    p = e("Map.prototype.set", !0),
    m = e("Map.prototype.has", !0),
    listGetNode = o(function (g, h) {
      for (var f = g, v; (v = f.next) !== null; f = v) if (v.key === h) return f.next = v.next, v.next = g.next, g.next = v, v;
    }, "listGetNode"),
    listGet = o(function (g, h) {
      var f = listGetNode(g, h);
      return f && f.value;
    }, "listGet"),
    listSet = o(function (g, h, f) {
      var v = listGetNode(g, h);
      v ? v.value = f : g.next = {
        key: h,
        next: g.next,
        value: f
      };
    }, "listSet"),
    listHas = o(function (g, h) {
      return !!listGetNode(g, h);
    }, "listHas");
  return Nu = o(function () {
    var h,
      f,
      v,
      E = {
        assert: function (b) {
          if (!E.has(b)) throw new r("Side channel does not contain " + n(b));
        },
        get: function (b) {
          if (i && b && (typeof b == "object" || typeof b == "function")) {
            if (h) return a(h, b);
          } else if (s) {
            if (f) return c(f, b);
          } else if (v) return listGet(v, b);
        },
        has: function (b) {
          if (i && b && (typeof b == "object" || typeof b == "function")) {
            if (h) return u(h, b);
          } else if (s) {
            if (f) return m(f, b);
          } else if (v) return listHas(v, b);
          return !1;
        },
        set: function (b, P) {
          i && b && (typeof b == "object" || typeof b == "function") ? (h || (h = new i()), l(h, b, P)) : s ? (f || (f = new s()), p(f, b, P)) : (v || (v = {
            key: {},
            next: null
          }), listSet(v, b, P));
        }
      };
    return E;
  }, "getSideChannel"), Nu;
}
o(requireSideChannel, "requireSideChannel");
var $u, Mh;
function requireFormats() {
  if (Mh) return $u;
  Mh = 1;
  var t = String.prototype.replace,
    e = /%20/g,
    n = {
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
  return $u = {
    default: n.RFC3986,
    formatters: {
      RFC1738: function (r) {
        return t.call(r, e, "+");
      },
      RFC3986: function (r) {
        return String(r);
      }
    },
    RFC1738: n.RFC1738,
    RFC3986: n.RFC3986
  }, $u;
}
o(requireFormats, "requireFormats");
var Fu, Dh;
function requireUtils() {
  if (Dh) return Fu;
  Dh = 1;
  var t = requireFormats(),
    e = Object.prototype.hasOwnProperty,
    n = Array.isArray,
    r = function () {
      for (var g = [], h = 0; h < 256; ++h) g.push("%" + ((h < 16 ? "0" : "") + h.toString(16)).toUpperCase());
      return g;
    }(),
    compactQueue = o(function (h) {
      for (; h.length > 1;) {
        var f = h.pop(),
          v = f.obj[f.prop];
        if (n(v)) {
          for (var E = [], b = 0; b < v.length; ++b) typeof v[b] < "u" && E.push(v[b]);
          f.obj[f.prop] = E;
        }
      }
    }, "compactQueue"),
    arrayToObject = o(function (h, f) {
      for (var v = f && f.plainObjects ? {
          __proto__: null
        } : {}, E = 0; E < h.length; ++E) typeof h[E] < "u" && (v[E] = h[E]);
      return v;
    }, "arrayToObject"),
    merge$1 = o(function g(h, f, v) {
      if (!f) return h;
      if (typeof f != "object" && typeof f != "function") {
        if (n(h)) h.push(f);else if (h && typeof h == "object") (v && (v.plainObjects || v.allowPrototypes) || !e.call(Object.prototype, f)) && (h[f] = !0);else return [h, f];
        return h;
      }
      if (!h || typeof h != "object") return [h].concat(f);
      var E = h;
      return n(h) && !n(f) && (E = arrayToObject(h, v)), n(h) && n(f) ? (f.forEach(function (b, P) {
        if (e.call(h, P)) {
          var T = h[P];
          T && typeof T == "object" && b && typeof b == "object" ? h[P] = g(T, b, v) : h.push(b);
        } else h[P] = b;
      }), h) : Object.keys(f).reduce(function (b, P) {
        var T = f[P];
        return e.call(b, P) ? b[P] = g(b[P], T, v) : b[P] = T, b;
      }, E);
    }, "merge"),
    assignSingleSource = o(function (h, f) {
      return Object.keys(f).reduce(function (v, E) {
        return v[E] = f[E], v;
      }, h);
    }, "assignSingleSource"),
    decode$3 = o(function (g, h, f) {
      var v = g.replace(/\+/g, " ");
      if (f === "iso-8859-1") return v.replace(/%[0-9a-f]{2}/gi, unescape);
      try {
        return decodeURIComponent(v);
      } catch {
        return v;
      }
    }, "decode"),
    c = 1024,
    encode$3 = o(function (h, f, v, E, b) {
      if (h.length === 0) return h;
      var P = h;
      if (typeof h == "symbol" ? P = Symbol.prototype.toString.call(h) : typeof h != "string" && (P = String(h)), v === "iso-8859-1") return escape(P).replace(/%u[0-9a-f]{4}/gi, function (R) {
        return "%26%23" + parseInt(R.slice(2), 16) + "%3B";
      });
      for (var T = "", O = 0; O < P.length; O += c) {
        for (var M = P.length >= c ? P.slice(O, O + c) : P, I = [], U = 0; U < M.length; ++U) {
          var _ = M.charCodeAt(U);
          if (_ === 45 || _ === 46 || _ === 95 || _ === 126 || _ >= 48 && _ <= 57 || _ >= 65 && _ <= 90 || _ >= 97 && _ <= 122 || b === t.RFC1738 && (_ === 40 || _ === 41)) {
            I[I.length] = M.charAt(U);
            continue;
          }
          if (_ < 128) {
            I[I.length] = r[_];
            continue;
          }
          if (_ < 2048) {
            I[I.length] = r[192 | _ >> 6] + r[128 | _ & 63];
            continue;
          }
          if (_ < 55296 || _ >= 57344) {
            I[I.length] = r[224 | _ >> 12] + r[128 | _ >> 6 & 63] + r[128 | _ & 63];
            continue;
          }
          U += 1, _ = 65536 + ((_ & 1023) << 10 | M.charCodeAt(U) & 1023), I[I.length] = r[240 | _ >> 18] + r[128 | _ >> 12 & 63] + r[128 | _ >> 6 & 63] + r[128 | _ & 63];
        }
        T += I.join("");
      }
      return T;
    }, "encode"),
    compact = o(function (h) {
      for (var f = [{
          obj: {
            o: h
          },
          prop: "o"
        }], v = [], E = 0; E < f.length; ++E) for (var b = f[E], P = b.obj[b.prop], T = Object.keys(P), O = 0; O < T.length; ++O) {
        var M = T[O],
          I = P[M];
        typeof I == "object" && I !== null && v.indexOf(I) === -1 && (f.push({
          obj: P,
          prop: M
        }), v.push(I));
      }
      return compactQueue(f), h;
    }, "compact"),
    isRegExp$1 = o(function (h) {
      return Object.prototype.toString.call(h) === "[object RegExp]";
    }, "isRegExp"),
    isBuffer$1 = o(function (h) {
      return !h || typeof h != "object" ? !1 : !!(h.constructor && h.constructor.isBuffer && h.constructor.isBuffer(h));
    }, "isBuffer"),
    combine = o(function (h, f) {
      return [].concat(h, f);
    }, "combine"),
    maybeMap = o(function (h, f) {
      if (n(h)) {
        for (var v = [], E = 0; E < h.length; E += 1) v.push(f(h[E]));
        return v;
      }
      return f(h);
    }, "maybeMap");
  return Fu = {
    arrayToObject: arrayToObject,
    assign: assignSingleSource,
    combine: combine,
    compact: compact,
    decode: decode$3,
    encode: encode$3,
    isBuffer: isBuffer$1,
    isRegExp: isRegExp$1,
    maybeMap: maybeMap,
    merge: merge$1
  }, Fu;
}
o(requireUtils, "requireUtils");
var ju, Ih;
function requireStringify() {
  if (Ih) return ju;
  Ih = 1;
  var t = requireSideChannel(),
    e = requireUtils(),
    n = requireFormats(),
    r = Object.prototype.hasOwnProperty,
    i = {
      brackets: o(function (g) {
        return g + "[]";
      }, "brackets"),
      comma: "comma",
      indices: o(function (g, h) {
        return g + "[" + h + "]";
      }, "indices"),
      repeat: o(function (g) {
        return g;
      }, "repeat")
    },
    s = Array.isArray,
    a = Array.prototype.push,
    pushToArray = o(function (w, g) {
      a.apply(w, s(g) ? g : [g]);
    }, "pushToArray"),
    u = Date.prototype.toISOString,
    c = n.default,
    p = {
      addQueryPrefix: !1,
      allowDots: !1,
      allowEmptyArrays: !1,
      arrayFormat: "indices",
      charset: "utf-8",
      charsetSentinel: !1,
      commaRoundTrip: !1,
      delimiter: "&",
      encode: !0,
      encodeDotInKeys: !1,
      encoder: e.encode,
      encodeValuesOnly: !1,
      filter: void 0,
      format: c,
      formatter: n.formatters[c],
      indices: !1,
      serializeDate: o(function (g) {
        return u.call(g);
      }, "serializeDate"),
      skipNulls: !1,
      strictNullHandling: !1
    },
    isNonNullishPrimitive = o(function (g) {
      return typeof g == "string" || typeof g == "number" || typeof g == "boolean" || typeof g == "symbol" || typeof g == "bigint";
    }, "isNonNullishPrimitive"),
    d = {},
    stringify = o(function w(g, h, f, v, E, b, P, T, O, M, I, U, _, R, B, H, Q, te) {
      for (var j = g, X = te, q = 0, C = !1; (X = X.get(d)) !== void 0 && !C;) {
        var A = X.get(g);
        if (q += 1, typeof A < "u") {
          if (A === q) throw new RangeError("Cyclic object value");
          C = !0;
        }
        typeof X.get(d) > "u" && (q = 0);
      }
      if (typeof M == "function" ? j = M(h, j) : j instanceof Date ? j = _(j) : f === "comma" && s(j) && (j = e.maybeMap(j, function (we) {
        return we instanceof Date ? _(we) : we;
      })), j === null) {
        if (b) return O && !H ? O(h, p.encoder, Q, "key", R) : h;
        j = "";
      }
      if (isNonNullishPrimitive(j) || e.isBuffer(j)) {
        if (O) {
          var L = H ? h : O(h, p.encoder, Q, "key", R);
          return [B(L) + "=" + B(O(j, p.encoder, Q, "value", R))];
        }
        return [B(h) + "=" + B(String(j))];
      }
      var V = [];
      if (typeof j > "u") return V;
      var Y;
      if (f === "comma" && s(j)) H && O && (j = e.maybeMap(j, O)), Y = [{
        value: j.length > 0 ? j.join(",") || null : void 0
      }];else if (s(M)) Y = M;else {
        var re = Object.keys(j);
        Y = I ? re.sort(I) : re;
      }
      var ae = T ? String(h).replace(/\./g, "%2E") : String(h),
        le = v && s(j) && j.length === 1 ? ae + "[]" : ae;
      if (E && s(j) && j.length === 0) return le + "[]";
      for (var ce = 0; ce < Y.length; ++ce) {
        var W = Y[ce],
          ie = typeof W == "object" && W && typeof W.value < "u" ? W.value : j[W];
        if (!(P && ie === null)) {
          var de = U && T ? String(W).replace(/\./g, "%2E") : String(W),
            fe = s(j) ? typeof f == "function" ? f(le, de) : le : le + (U ? "." + de : "[" + de + "]");
          te.set(g, q);
          var ge = t();
          ge.set(d, te), pushToArray(V, w(ie, fe, f, v, E, b, P, T, f === "comma" && H && s(j) ? null : O, M, I, U, _, R, B, H, Q, ge));
        }
      }
      return V;
    }, "stringify"),
    normalizeStringifyOptions = o(function (g) {
      if (!g) return p;
      if (typeof g.allowEmptyArrays < "u" && typeof g.allowEmptyArrays != "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
      if (typeof g.encodeDotInKeys < "u" && typeof g.encodeDotInKeys != "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
      if (g.encoder !== null && typeof g.encoder < "u" && typeof g.encoder != "function") throw new TypeError("Encoder has to be a function.");
      var h = g.charset || p.charset;
      if (typeof g.charset < "u" && g.charset !== "utf-8" && g.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      var f = n.default;
      if (typeof g.format < "u") {
        if (!r.call(n.formatters, g.format)) throw new TypeError("Unknown format option provided.");
        f = g.format;
      }
      var v = n.formatters[f],
        E = p.filter;
      (typeof g.filter == "function" || s(g.filter)) && (E = g.filter);
      var b;
      if (g.arrayFormat in i ? b = g.arrayFormat : "indices" in g ? b = g.indices ? "indices" : "repeat" : b = p.arrayFormat, "commaRoundTrip" in g && typeof g.commaRoundTrip != "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
      var P = typeof g.allowDots > "u" ? g.encodeDotInKeys === !0 ? !0 : p.allowDots : !!g.allowDots;
      return {
        addQueryPrefix: typeof g.addQueryPrefix == "boolean" ? g.addQueryPrefix : p.addQueryPrefix,
        allowDots: P,
        allowEmptyArrays: typeof g.allowEmptyArrays == "boolean" ? !!g.allowEmptyArrays : p.allowEmptyArrays,
        arrayFormat: b,
        charset: h,
        charsetSentinel: typeof g.charsetSentinel == "boolean" ? g.charsetSentinel : p.charsetSentinel,
        commaRoundTrip: !!g.commaRoundTrip,
        delimiter: typeof g.delimiter > "u" ? p.delimiter : g.delimiter,
        encode: typeof g.encode == "boolean" ? g.encode : p.encode,
        encodeDotInKeys: typeof g.encodeDotInKeys == "boolean" ? g.encodeDotInKeys : p.encodeDotInKeys,
        encoder: typeof g.encoder == "function" ? g.encoder : p.encoder,
        encodeValuesOnly: typeof g.encodeValuesOnly == "boolean" ? g.encodeValuesOnly : p.encodeValuesOnly,
        filter: E,
        format: f,
        formatter: v,
        serializeDate: typeof g.serializeDate == "function" ? g.serializeDate : p.serializeDate,
        skipNulls: typeof g.skipNulls == "boolean" ? g.skipNulls : p.skipNulls,
        sort: typeof g.sort == "function" ? g.sort : null,
        strictNullHandling: typeof g.strictNullHandling == "boolean" ? g.strictNullHandling : p.strictNullHandling
      };
    }, "normalizeStringifyOptions");
  return ju = o(function (w, g) {
    var h = w,
      f = normalizeStringifyOptions(g),
      v,
      E;
    typeof f.filter == "function" ? (E = f.filter, h = E("", h)) : s(f.filter) && (E = f.filter, v = E);
    var b = [];
    if (typeof h != "object" || h === null) return "";
    var P = i[f.arrayFormat],
      T = P === "comma" && f.commaRoundTrip;
    v || (v = Object.keys(h)), f.sort && v.sort(f.sort);
    for (var O = t(), M = 0; M < v.length; ++M) {
      var I = v[M],
        U = h[I];
      f.skipNulls && U === null || pushToArray(b, stringify(U, I, P, T, f.allowEmptyArrays, f.strictNullHandling, f.skipNulls, f.encodeDotInKeys, f.encode ? f.encoder : null, f.filter, f.sort, f.allowDots, f.serializeDate, f.format, f.formatter, f.encodeValuesOnly, f.charset, O));
    }
    var _ = b.join(f.delimiter),
      R = f.addQueryPrefix === !0 ? "?" : "";
    return f.charsetSentinel && (f.charset === "iso-8859-1" ? R += "utf8=%26%2310003%3B&" : R += "utf8=%E2%9C%93&"), _.length > 0 ? R + _ : "";
  }, "stringify_1"), ju;
}
o(requireStringify, "requireStringify");
var Bu, Rh;
function requireParse() {
  if (Rh) return Bu;
  Rh = 1;
  var t = requireUtils(),
    e = Object.prototype.hasOwnProperty,
    n = Array.isArray,
    r = {
      allowDots: !1,
      allowEmptyArrays: !1,
      allowPrototypes: !1,
      allowSparse: !1,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: !1,
      comma: !1,
      decodeDotInKeys: !1,
      decoder: t.decode,
      delimiter: "&",
      depth: 5,
      duplicates: "combine",
      ignoreQueryPrefix: !1,
      interpretNumericEntities: !1,
      parameterLimit: 1e3,
      parseArrays: !0,
      plainObjects: !1,
      strictDepth: !1,
      strictNullHandling: !1
    },
    interpretNumericEntities = o(function (d) {
      return d.replace(/&#(\d+);/g, function (y, S) {
        return String.fromCharCode(parseInt(S, 10));
      });
    }, "interpretNumericEntities"),
    parseArrayValue = o(function (d, y) {
      return d && typeof d == "string" && y.comma && d.indexOf(",") > -1 ? d.split(",") : d;
    }, "parseArrayValue"),
    a = "utf8=%26%2310003%3B",
    l = "utf8=%E2%9C%93",
    parseQueryStringValues = o(function (y, S) {
      var w = {
          __proto__: null
        },
        g = S.ignoreQueryPrefix ? y.replace(/^\?/, "") : y;
      g = g.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
      var h = S.parameterLimit === 1 / 0 ? void 0 : S.parameterLimit,
        f = g.split(S.delimiter, h),
        v = -1,
        E,
        b = S.charset;
      if (S.charsetSentinel) for (E = 0; E < f.length; ++E) f[E].indexOf("utf8=") === 0 && (f[E] === l ? b = "utf-8" : f[E] === a && (b = "iso-8859-1"), v = E, E = f.length);
      for (E = 0; E < f.length; ++E) if (E !== v) {
        var P = f[E],
          T = P.indexOf("]="),
          O = T === -1 ? P.indexOf("=") : T + 1,
          M,
          I;
        O === -1 ? (M = S.decoder(P, r.decoder, b, "key"), I = S.strictNullHandling ? null : "") : (M = S.decoder(P.slice(0, O), r.decoder, b, "key"), I = t.maybeMap(parseArrayValue(P.slice(O + 1), S), function (_) {
          return S.decoder(_, r.decoder, b, "value");
        })), I && S.interpretNumericEntities && b === "iso-8859-1" && (I = interpretNumericEntities(String(I))), P.indexOf("[]=") > -1 && (I = n(I) ? [I] : I);
        var U = e.call(w, M);
        U && S.duplicates === "combine" ? w[M] = t.combine(w[M], I) : (!U || S.duplicates === "last") && (w[M] = I);
      }
      return w;
    }, "parseQueryStringValues"),
    parseObject = o(function (d, y, S, w) {
      for (var g = w ? y : parseArrayValue(y, S), h = d.length - 1; h >= 0; --h) {
        var f,
          v = d[h];
        if (v === "[]" && S.parseArrays) f = S.allowEmptyArrays && (g === "" || S.strictNullHandling && g === null) ? [] : [].concat(g);else {
          f = S.plainObjects ? {
            __proto__: null
          } : {};
          var E = v.charAt(0) === "[" && v.charAt(v.length - 1) === "]" ? v.slice(1, -1) : v,
            b = S.decodeDotInKeys ? E.replace(/%2E/g, ".") : E,
            P = parseInt(b, 10);
          !S.parseArrays && b === "" ? f = {
            0: g
          } : !isNaN(P) && v !== b && String(P) === b && P >= 0 && S.parseArrays && P <= S.arrayLimit ? (f = [], f[P] = g) : b !== "__proto__" && (f[b] = g);
        }
        g = f;
      }
      return g;
    }, "parseObject"),
    parseQueryStringKeys = o(function (y, S, w, g) {
      if (y) {
        var h = w.allowDots ? y.replace(/\.([^.[]+)/g, "[$1]") : y,
          f = /(\[[^[\]]*])/,
          v = /(\[[^[\]]*])/g,
          E = w.depth > 0 && f.exec(h),
          b = E ? h.slice(0, E.index) : h,
          P = [];
        if (b) {
          if (!w.plainObjects && e.call(Object.prototype, b) && !w.allowPrototypes) return;
          P.push(b);
        }
        for (var T = 0; w.depth > 0 && (E = v.exec(h)) !== null && T < w.depth;) {
          if (T += 1, !w.plainObjects && e.call(Object.prototype, E[1].slice(1, -1)) && !w.allowPrototypes) return;
          P.push(E[1]);
        }
        if (E) {
          if (w.strictDepth === !0) throw new RangeError("Input depth exceeded depth option of " + w.depth + " and strictDepth is true");
          P.push("[" + h.slice(E.index) + "]");
        }
        return parseObject(P, S, w, g);
      }
    }, "parseQueryStringKeys"),
    normalizeParseOptions = o(function (y) {
      if (!y) return r;
      if (typeof y.allowEmptyArrays < "u" && typeof y.allowEmptyArrays != "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
      if (typeof y.decodeDotInKeys < "u" && typeof y.decodeDotInKeys != "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
      if (y.decoder !== null && typeof y.decoder < "u" && typeof y.decoder != "function") throw new TypeError("Decoder has to be a function.");
      if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      var S = typeof y.charset > "u" ? r.charset : y.charset,
        w = typeof y.duplicates > "u" ? r.duplicates : y.duplicates;
      if (w !== "combine" && w !== "first" && w !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
      var g = typeof y.allowDots > "u" ? y.decodeDotInKeys === !0 ? !0 : r.allowDots : !!y.allowDots;
      return {
        allowDots: g,
        allowEmptyArrays: typeof y.allowEmptyArrays == "boolean" ? !!y.allowEmptyArrays : r.allowEmptyArrays,
        allowPrototypes: typeof y.allowPrototypes == "boolean" ? y.allowPrototypes : r.allowPrototypes,
        allowSparse: typeof y.allowSparse == "boolean" ? y.allowSparse : r.allowSparse,
        arrayLimit: typeof y.arrayLimit == "number" ? y.arrayLimit : r.arrayLimit,
        charset: S,
        charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : r.charsetSentinel,
        comma: typeof y.comma == "boolean" ? y.comma : r.comma,
        decodeDotInKeys: typeof y.decodeDotInKeys == "boolean" ? y.decodeDotInKeys : r.decodeDotInKeys,
        decoder: typeof y.decoder == "function" ? y.decoder : r.decoder,
        delimiter: typeof y.delimiter == "string" || t.isRegExp(y.delimiter) ? y.delimiter : r.delimiter,
        depth: typeof y.depth == "number" || y.depth === !1 ? +y.depth : r.depth,
        duplicates: w,
        ignoreQueryPrefix: y.ignoreQueryPrefix === !0,
        interpretNumericEntities: typeof y.interpretNumericEntities == "boolean" ? y.interpretNumericEntities : r.interpretNumericEntities,
        parameterLimit: typeof y.parameterLimit == "number" ? y.parameterLimit : r.parameterLimit,
        parseArrays: y.parseArrays !== !1,
        plainObjects: typeof y.plainObjects == "boolean" ? y.plainObjects : r.plainObjects,
        strictDepth: typeof y.strictDepth == "boolean" ? !!y.strictDepth : r.strictDepth,
        strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : r.strictNullHandling
      };
    }, "normalizeParseOptions");
  return Bu = o(function (d, y) {
    var S = normalizeParseOptions(y);
    if (d === "" || d === null || typeof d > "u") return S.plainObjects ? {
      __proto__: null
    } : {};
    for (var w = typeof d == "string" ? parseQueryStringValues(d, S) : d, g = S.plainObjects ? {
        __proto__: null
      } : {}, h = Object.keys(w), f = 0; f < h.length; ++f) {
      var v = h[f],
        E = parseQueryStringKeys(v, w[v], S, typeof d == "string");
      g = t.merge(g, E, S);
    }
    return S.allowSparse === !0 ? g : t.compact(g);
  }, "parse"), Bu;
}
o(requireParse, "requireParse");
var zu, Nh;
function requireLib() {
  if (Nh) return zu;
  Nh = 1;
  var t = requireStringify(),
    e = requireParse(),
    n = requireFormats();
  return zu = {
    formats: n,
    parse: e,
    stringify: t
  }, zu;
}
o(requireLib, "requireLib");
var $h;
function requireUrl() {
  if ($h) return vr;
  $h = 1;
  var t = requirePunycode();
  function Url() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }
  o(Url, "Url");
  var n = /^([a-z0-9.+-]+:)/i,
    r = /:[0-9]*$/,
    i = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,
    s = ["<", ">", '"', "`", " ", "\r", `
`, "	"],
    a = ["{", "}", "|", "\\", "^", "`"].concat(s),
    l = ["'"].concat(a),
    u = ["%", "/", "?", ";", "#"].concat(l),
    c = ["/", "?", "#"],
    p = 255,
    m = /^[+a-z0-9A-Z_-]{0,63}$/,
    d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    y = {
      javascript: !0,
      "javascript:": !0
    },
    S = {
      javascript: !0,
      "javascript:": !0
    },
    w = {
      http: !0,
      https: !0,
      ftp: !0,
      gopher: !0,
      file: !0,
      "http:": !0,
      "https:": !0,
      "ftp:": !0,
      "gopher:": !0,
      "file:": !0
    },
    g = requireLib();
  function urlParse(b, P, T) {
    if (b && typeof b == "object" && b instanceof Url) return b;
    var O = new Url();
    return O.parse(b, P, T), O;
  }
  o(urlParse, "urlParse"), Url.prototype.parse = function (b, P, T) {
    if (typeof b != "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof b);
    var O = b.indexOf("?"),
      M = O !== -1 && O < b.indexOf("#") ? "?" : "#",
      I = b.split(M),
      U = /\\/g;
    I[0] = I[0].replace(U, "/"), b = I.join(M);
    var _ = b;
    if (_ = _.trim(), !T && b.split("#").length === 1) {
      var R = i.exec(_);
      if (R) return this.path = _, this.href = _, this.pathname = R[1], R[2] ? (this.search = R[2], P ? this.query = g.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : P && (this.search = "", this.query = {}), this;
    }
    var B = n.exec(_);
    if (B) {
      B = B[0];
      var H = B.toLowerCase();
      this.protocol = H, _ = _.substr(B.length);
    }
    if (T || B || _.match(/^\/\/[^@/]+@[^@/]+/)) {
      var Q = _.substr(0, 2) === "//";
      Q && !(B && S[B]) && (_ = _.substr(2), this.slashes = !0);
    }
    if (!S[B] && (Q || B && !w[B])) {
      for (var te = -1, j = 0; j < c.length; j++) {
        var X = _.indexOf(c[j]);
        X !== -1 && (te === -1 || X < te) && (te = X);
      }
      var q, C;
      te === -1 ? C = _.lastIndexOf("@") : C = _.lastIndexOf("@", te), C !== -1 && (q = _.slice(0, C), _ = _.slice(C + 1), this.auth = decodeURIComponent(q)), te = -1;
      for (var j = 0; j < u.length; j++) {
        var X = _.indexOf(u[j]);
        X !== -1 && (te === -1 || X < te) && (te = X);
      }
      te === -1 && (te = _.length), this.host = _.slice(0, te), _ = _.slice(te), this.parseHost(), this.hostname = this.hostname || "";
      var A = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
      if (!A) for (var L = this.hostname.split(/\./), j = 0, V = L.length; j < V; j++) {
        var Y = L[j];
        if (Y && !Y.match(m)) {
          for (var re = "", ae = 0, le = Y.length; ae < le; ae++) Y.charCodeAt(ae) > 127 ? re += "x" : re += Y[ae];
          if (!re.match(m)) {
            var ce = L.slice(0, j),
              W = L.slice(j + 1),
              ie = Y.match(d);
            ie && (ce.push(ie[1]), W.unshift(ie[2])), W.length && (_ = "/" + W.join(".") + _), this.hostname = ce.join(".");
            break;
          }
        }
      }
      this.hostname.length > p ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), A || (this.hostname = t.toASCII(this.hostname));
      var de = this.port ? ":" + this.port : "",
        fe = this.hostname || "";
      this.host = fe + de, this.href += this.host, A && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), _[0] !== "/" && (_ = "/" + _));
    }
    if (!y[H]) for (var j = 0, V = l.length; j < V; j++) {
      var ge = l[j];
      if (_.indexOf(ge) !== -1) {
        var we = encodeURIComponent(ge);
        we === ge && (we = escape(ge)), _ = _.split(ge).join(we);
      }
    }
    var ke = _.indexOf("#");
    ke !== -1 && (this.hash = _.substr(ke), _ = _.slice(0, ke));
    var He = _.indexOf("?");
    if (He !== -1 ? (this.search = _.substr(He), this.query = _.substr(He + 1), P && (this.query = g.parse(this.query)), _ = _.slice(0, He)) : P && (this.search = "", this.query = {}), _ && (this.pathname = _), w[H] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      var de = this.pathname || "",
        qt = this.search || "";
      this.path = de + qt;
    }
    return this.href = this.format(), this;
  };
  function urlFormat(b) {
    return typeof b == "string" && (b = urlParse(b)), b instanceof Url ? b.format() : Url.prototype.format.call(b);
  }
  o(urlFormat, "urlFormat"), Url.prototype.format = function () {
    var b = this.auth || "";
    b && (b = encodeURIComponent(b), b = b.replace(/%3A/i, ":"), b += "@");
    var P = this.protocol || "",
      T = this.pathname || "",
      O = this.hash || "",
      M = !1,
      I = "";
    this.host ? M = b + this.host : this.hostname && (M = b + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (M += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (I = g.stringify(this.query, {
      arrayFormat: "repeat",
      addQueryPrefix: !1
    }));
    var U = this.search || I && "?" + I || "";
    return P && P.substr(-1) !== ":" && (P += ":"), this.slashes || (!P || w[P]) && M !== !1 ? (M = "//" + (M || ""), T && T.charAt(0) !== "/" && (T = "/" + T)) : M || (M = ""), O && O.charAt(0) !== "#" && (O = "#" + O), U && U.charAt(0) !== "?" && (U = "?" + U), T = T.replace(/[?#]/g, function (_) {
      return encodeURIComponent(_);
    }), U = U.replace("#", "%23"), P + M + T + U + O;
  };
  function urlResolve(b, P) {
    return urlParse(b, !1, !0).resolve(P);
  }
  o(urlResolve, "urlResolve"), Url.prototype.resolve = function (b) {
    return this.resolveObject(urlParse(b, !1, !0)).format();
  };
  function urlResolveObject(b, P) {
    return b ? urlParse(b, !1, !0).resolveObject(P) : P;
  }
  return o(urlResolveObject, "urlResolveObject"), Url.prototype.resolveObject = function (b) {
    if (typeof b == "string") {
      var P = new Url();
      P.parse(b, !1, !0), b = P;
    }
    for (var T = new Url(), O = Object.keys(this), M = 0; M < O.length; M++) {
      var I = O[M];
      T[I] = this[I];
    }
    if (T.hash = b.hash, b.href === "") return T.href = T.format(), T;
    if (b.slashes && !b.protocol) {
      for (var U = Object.keys(b), _ = 0; _ < U.length; _++) {
        var R = U[_];
        R !== "protocol" && (T[R] = b[R]);
      }
      return w[T.protocol] && T.hostname && !T.pathname && (T.pathname = "/", T.path = T.pathname), T.href = T.format(), T;
    }
    if (b.protocol && b.protocol !== T.protocol) {
      if (!w[b.protocol]) {
        for (var B = Object.keys(b), H = 0; H < B.length; H++) {
          var Q = B[H];
          T[Q] = b[Q];
        }
        return T.href = T.format(), T;
      }
      if (T.protocol = b.protocol, !b.host && !S[b.protocol]) {
        for (var V = (b.pathname || "").split("/"); V.length && !(b.host = V.shift()););
        b.host || (b.host = ""), b.hostname || (b.hostname = ""), V[0] !== "" && V.unshift(""), V.length < 2 && V.unshift(""), T.pathname = V.join("/");
      } else T.pathname = b.pathname;
      if (T.search = b.search, T.query = b.query, T.host = b.host || "", T.auth = b.auth, T.hostname = b.hostname || b.host, T.port = b.port, T.pathname || T.search) {
        var te = T.pathname || "",
          j = T.search || "";
        T.path = te + j;
      }
      return T.slashes = T.slashes || b.slashes, T.href = T.format(), T;
    }
    var X = T.pathname && T.pathname.charAt(0) === "/",
      q = b.host || b.pathname && b.pathname.charAt(0) === "/",
      C = q || X || T.host && b.pathname,
      A = C,
      L = T.pathname && T.pathname.split("/") || [],
      V = b.pathname && b.pathname.split("/") || [],
      Y = T.protocol && !w[T.protocol];
    if (Y && (T.hostname = "", T.port = null, T.host && (L[0] === "" ? L[0] = T.host : L.unshift(T.host)), T.host = "", b.protocol && (b.hostname = null, b.port = null, b.host && (V[0] === "" ? V[0] = b.host : V.unshift(b.host)), b.host = null), C = C && (V[0] === "" || L[0] === "")), q) T.host = b.host || b.host === "" ? b.host : T.host, T.hostname = b.hostname || b.hostname === "" ? b.hostname : T.hostname, T.search = b.search, T.query = b.query, L = V;else if (V.length) L || (L = []), L.pop(), L = L.concat(V), T.search = b.search, T.query = b.query;else if (b.search != null) {
      if (Y) {
        T.host = L.shift(), T.hostname = T.host;
        var re = T.host && T.host.indexOf("@") > 0 ? T.host.split("@") : !1;
        re && (T.auth = re.shift(), T.hostname = re.shift(), T.host = T.hostname);
      }
      return T.search = b.search, T.query = b.query, (T.pathname !== null || T.search !== null) && (T.path = (T.pathname ? T.pathname : "") + (T.search ? T.search : "")), T.href = T.format(), T;
    }
    if (!L.length) return T.pathname = null, T.search ? T.path = "/" + T.search : T.path = null, T.href = T.format(), T;
    for (var ae = L.slice(-1)[0], le = (T.host || b.host || L.length > 1) && (ae === "." || ae === "..") || ae === "", ce = 0, W = L.length; W >= 0; W--) ae = L[W], ae === "." ? L.splice(W, 1) : ae === ".." ? (L.splice(W, 1), ce++) : ce && (L.splice(W, 1), ce--);
    if (!C && !A) for (; ce--; ce) L.unshift("..");
    C && L[0] !== "" && (!L[0] || L[0].charAt(0) !== "/") && L.unshift(""), le && L.join("/").substr(-1) !== "/" && L.push("");
    var ie = L[0] === "" || L[0] && L[0].charAt(0) === "/";
    if (Y) {
      T.hostname = ie ? "" : L.length ? L.shift() : "", T.host = T.hostname;
      var re = T.host && T.host.indexOf("@") > 0 ? T.host.split("@") : !1;
      re && (T.auth = re.shift(), T.hostname = re.shift(), T.host = T.hostname);
    }
    return C = C || T.host && L.length, C && !ie && L.unshift(""), L.length > 0 ? T.pathname = L.join("/") : (T.pathname = null, T.path = null), (T.pathname !== null || T.search !== null) && (T.path = (T.pathname ? T.pathname : "") + (T.search ? T.search : "")), T.auth = b.auth || T.auth, T.slashes = T.slashes || b.slashes, T.href = T.format(), T;
  }, Url.prototype.parseHost = function () {
    var b = this.host,
      P = r.exec(b);
    P && (P = P[0], P !== ":" && (this.port = P.substr(1)), b = b.substr(0, b.length - P.length)), b && (this.hostname = b);
  }, vr.parse = urlParse, vr.resolve = urlResolve, vr.resolveObject = urlResolveObject, vr.format = urlFormat, vr.Url = Url, vr;
}
o(requireUrl, "requireUrl");
const fE = typeof URL > "u" ? requireUrl().URL : URL,
  dE = "text/plain",
  pE = "us-ascii",
  testParameter = o((t, e) => e.some(n => n instanceof RegExp ? n.test(t) : n === t), "testParameter"),
  normalizeDataURL = o((t, {
    stripHash: e
  }) => {
    const n = t.match(/^data:([^,]*?),([^#]*?)(?:#(.*))?$/);
    if (!n) throw new Error(`Invalid URL: ${t}`);
    const r = n[1].split(";"),
      i = n[2],
      s = e ? "" : n[3];
    let a = !1;
    r[r.length - 1] === "base64" && (r.pop(), a = !0);
    const l = (r.shift() || "").toLowerCase(),
      c = [...r.map(p => {
        let [m, d = ""] = p.split("=").map(y => y.trim());
        return m === "charset" && (d = d.toLowerCase(), d === pE) ? "" : `${m}${d ? `=${d}` : ""}`;
      }).filter(Boolean)];
    return a && c.push("base64"), (c.length !== 0 || l && l !== dE) && c.unshift(l), `data:${c.join(";")},${a ? i.trim() : i}${s ? `#${s}` : ""}`;
  }, "normalizeDataURL"),
  normalizeUrl = o((t, e) => {
    if (e = {
      defaultProtocol: "http:",
      normalizeProtocol: !0,
      forceHttp: !1,
      forceHttps: !1,
      stripAuthentication: !0,
      stripHash: !1,
      stripWWW: !0,
      removeQueryParameters: [/^utm_\w+/i],
      removeTrailingSlash: !0,
      removeDirectoryIndex: !1,
      sortQueryParameters: !0,
      ...e
    }, Reflect.has(e, "normalizeHttps")) throw new Error("options.normalizeHttps is renamed to options.forceHttp");
    if (Reflect.has(e, "normalizeHttp")) throw new Error("options.normalizeHttp is renamed to options.forceHttps");
    if (Reflect.has(e, "stripFragment")) throw new Error("options.stripFragment is renamed to options.stripHash");
    if (t = t.trim(), /^data:/i.test(t)) return normalizeDataURL(t, e);
    const n = t.startsWith("//");
    !n && /^\.*\//.test(t) || (t = t.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, e.defaultProtocol));
    const i = new fE(t);
    if (e.forceHttp && e.forceHttps) throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
    if (e.forceHttp && i.protocol === "https:" && (i.protocol = "http:"), e.forceHttps && i.protocol === "http:" && (i.protocol = "https:"), e.stripAuthentication && (i.username = "", i.password = ""), e.stripHash && (i.hash = ""), i.pathname && (i.pathname = i.pathname.replace(/((?!:).|^)\/{2,}/g, (s, a) => /^(?!\/)/g.test(a) ? `${a}/` : "/")), i.pathname && (i.pathname = decodeURI(i.pathname)), e.removeDirectoryIndex === !0 && (e.removeDirectoryIndex = [/^index\.[a-z]+$/]), Array.isArray(e.removeDirectoryIndex) && e.removeDirectoryIndex.length > 0) {
      let s = i.pathname.split("/");
      const a = s[s.length - 1];
      testParameter(a, e.removeDirectoryIndex) && (s = s.slice(0, s.length - 1), i.pathname = s.slice(1).join("/") + "/");
    }
    if (i.hostname && (i.hostname = i.hostname.replace(/\.$/, ""), e.stripWWW && /^www\.([a-z\-\d]{2,63})\.([a-z.]{2,5})$/.test(i.hostname) && (i.hostname = i.hostname.replace(/^www\./, ""))), Array.isArray(e.removeQueryParameters)) for (const s of [...i.searchParams.keys()]) testParameter(s, e.removeQueryParameters) && i.searchParams.delete(s);
    return e.sortQueryParameters && i.searchParams.sort(), e.removeTrailingSlash && (i.pathname = i.pathname.replace(/\/$/, "")), t = i.toString(), (e.removeTrailingSlash || i.pathname === "/") && i.hash === "" && (t = t.replace(/\/$/, "")), n && !e.normalizeProtocol && (t = t.replace(/^http:\/\//, "//")), e.stripProtocol && (t = t.replace(/^(?:https?:)?\/\//, "")), t;
  }, "normalizeUrl$1");
Kf.exports = normalizeUrl;
Kf.exports.default = normalizeUrl;
var mE = Kf.exports;
const gE = jS,
  yE = mE;
function parseUrl(t, e = !1) {
  if (typeof t != "string" || !t.trim()) throw new Error("Invalid url.");
  return e && (typeof e != "object" && (e = {
    stripHash: !1
  }), t = yE(t, e)), gE(t);
}
o(parseUrl, "parseUrl$1");
var wE = parseUrl;
const nv = getDefaultExportFromCjs(wE);
function monitorForCartChanges(t) {
  const callback = o(n => {
    t.notifyCartUpdatedExternally();
  }, "callback");
  detectViaXhrPatch(callback), detectViaFetchPatch(callback), detectViaLegacyShopifyGlobalCallback(callback);
}
o(monitorForCartChanges, "monitorForCartChanges");
const rv = /\/cart\/(?:add|update|change|clear)(?:\.js|\.json)?$/i,
  iv = "__SALVO_EXPECT_CART_REQUESTS";
function detectViaXhrPatch(t) {
  function handleResponse(a) {
    if (a.__expected) return;
    const {
      pathname: l
    } = nv(a.__url);
    l.match(rv) && t();
  }
  if (o(handleResponse, "handleResponse"), !window.XMLHttpRequest) return !1;
  const n = window.XMLHttpRequest.prototype.open;
  function patchedOpen(a, l, u, c, p) {
    this.__expected = !1, this.__url = l, this.addEventListener("load", function () {
      handleResponse(this);
    });
    const m = [a, l];
    return u !== void 0 && m.push(u), c !== void 0 && m.push(c), p !== void 0 && m.push(p), n.apply(this, m);
  }
  o(patchedOpen, "patchedOpen");
  const i = window.XMLHttpRequest.prototype.setRequestHeader;
  function patchedSetRequestHeader(a, l) {
    if (a == iv) {
      this.__expected = !0;
      return;
    }
    return i.apply(this, [a, l]);
  }
  return o(patchedSetRequestHeader, "patchedSetRequestHeader"), window.XMLHttpRequest.prototype.open = patchedOpen, window.XMLHttpRequest.prototype.setRequestHeader = patchedSetRequestHeader, !0;
}
o(detectViaXhrPatch, "detectViaXhrPatch");
function detectViaFetchPatch(t) {
  function handleResponse$1(r) {
    const {
      pathname: i
    } = nv(r.url);
    i.match(rv) && t();
  }
  if (o(handleResponse$1, "handleResponse"), !window.fetch || typeof window.fetch != "function") return !1;
  const n = window.fetch;
  return window.fetch = async function (...r) {
    const i = await n.apply(this, r);
    return handleResponse$1(i), i;
  }, !0;
}
o(detectViaFetchPatch, "detectViaFetchPatch");
function detectViaLegacyShopifyGlobalCallback(t) {
  const e = window;
  if (!e.Shopify) return !1;
  const n = e.Shopify.onCartUpdate;
  return e.Shopify.onCartUpdate = r => {
    n && n(r), t(r);
  }, !0;
}
o(detectViaLegacyShopifyGlobalCallback, "detectViaLegacyShopifyGlobalCallback");
class AjaxApi {
  constructor() {
    this.http = PS.create({
      baseURL: "/",
      headers: {
        [iv]: 1
      }
    });
  }
  handleError(e) {
    var r, i, s, a;
    const n = e;
    throw (i = (r = n.response) == null ? void 0 : r.data) != null && i.description ? new Error(`${n.response.data.message} - ${n.response.data.description}`) : (a = (s = n.response) == null ? void 0 : s.data) != null && a.message ? new Error(`${n.response.data.message}`) : e;
  }
  async cartAdd(e) {
    try {
      return (await this.http.post("/cart/add.js", e)).data;
    } catch (n) {
      this.handleError(n);
    }
  }
  async cartGet() {
    try {
      return (await this.http.get("/cart.js")).data;
    } catch (e) {
      this.handleError(e);
    }
  }
  async cartClear() {
    try {
      return (await this.http.get("/cart/clear.js")).data;
    } catch (e) {
      this.handleError(e);
    }
  }
  async cartUpdate(e) {
    try {
      return (await this.http.post("/cart/update.js", e)).data;
    } catch (n) {
      this.handleError(n);
    }
  }
  async cartChange(e) {
    try {
      return (await this.http.post("/cart/change.js", e)).data;
    } catch (n) {
      this.handleError(n);
    }
  }
}
o(AjaxApi, "AjaxApi");
class CartItem {
  constructor(e, n) {
    this.cart = e, this.id = n.id, this.variantId = n.variant_id, this.quantity = n.quantity, this.properties = n.properties, this.productId = n.product_id, this.key = n.key, this.title = n.title, this.price = n.price, this.linePrice = n.line_price, this.finalPrice = n.final_price, this.finalLinePrice = n.final_line_price, this.sku = n.sku, this.grams = n.grams, this.vendor = n.vendor, this.taxable = n.taxable, this.productHasOnlyDefaultVariant = n.product_has_only_default_variant, this.giftCard = n.gift_card, this.url = n.url, this.featuredImage = n.featured_image ? {
      url: n.featured_image.url,
      aspectRatio: n.featured_image.aspect_ratio,
      alt: n.featured_image.alt
    } : null, this.image = n.image, this.handle = n.handle, this.requiresShipping = n.requires_shipping, this.productTitle = n.product_title, this.productDescription = n.product_description, this.productType = n.product_type, this.variantTitle = n.variant_title, this.variantOptions = n.variant_options, this.optionsWithValues = n.options_with_values;
  }
  changeQuantity(e) {
    return this.change(e, null);
  }
  changeProperties(e) {
    return this.change(null, e);
  }
  change(e, n) {
    return this.cart.changeItem(this, e, n);
  }
  remove() {
    return this.cart.removeItem(this);
  }
}
o(CartItem, "CartItem");
const PE = {
  variantId: (t, e) => t.filter(n => n.variantId === e),
  productId: (t, e) => t.filter(n => n.productId === e),
  sku: (t, e) => t.filter(n => n.sku === e),
  hasProperties: (t, e) => t.filter(n => e.every(r => Object.keys(n.properties).includes(r))),
  properties: (t, e) => t.filter(n => Object.entries(e).every(([r, i]) => n.properties[r] === i))
};
class BaseCart {
  constructor() {
    this.items = [], this.attributes = {}, this.note = "", this.totalPrice = 0, this.totalWeight = 0, this.requiresShipping = !1, this.currency = "GBP", this.token = "unknown", this._onChange = new dist.SimpleEventDispatcher(), this.api = new AjaxApi(), this._$log = null, this.queryTypes = PE, monitorForCartChanges(this);
  }
  get onChange() {
    return this._onChange;
  }
  get $log() {
    return this._$log || (this._$log = new TaggedLog(Sn, "Cart")), this._$log;
  }
  addQueryType(e, n) {
    this.queryTypes[e] = n;
  }
  async addItem(e) {
    const n = await this.addItems([e]);
    if (!n[0]) throw new Error("Added item not returned from add call");
    return n[0];
  }
  async addItems(e) {
    const n = await this.api.cartAdd({
        items: e.map(s => ({
          quantity: 1,
          ...s
        }))
      }),
      r = [],
      i = {};
    for (const s of this.items) i[s.key] = s;
    for (const s of n.items) {
      const a = new CartItem(this, s);
      r.push(a);
      const l = i[s.key];
      l ? this.items.splice(this.items.indexOf(l), 1, a) : this.items.push(a);
    }
    return this.reload(), this.onChange.dispatch(), r;
  }
  updateNote(e) {
    return this.update(e, null);
  }
  updateAttributes(e) {
    return this.update(null, e);
  }
  async update(e, n) {
    const r = await this.api.cartUpdate({
      note: e || void 0,
      attributes: n || void 0
    });
    this.populate(r);
  }
  async updateItemQuantities(e) {
    if (e.length != this.items.length) throw new Error("Number of updates must match the number of items in the cart.");
    const n = await this.api.cartUpdate({
      updates: e
    });
    this.populate(n);
  }
  async updateItemQuantitiesByKey(e) {
    const n = await this.api.cartUpdate({
      updates: e
    });
    this.populate(n);
  }
  async updateItemQuantitiesByVariantId(e) {
    const n = await this.api.cartUpdate({
      updates: e
    });
    this.populate(n);
  }
  queryItems(e) {
    let n = this.items;
    for (const r of Object.keys(e)) {
      const i = this.queryTypes[r];
      if (!i) throw new Error(`Unknown query type '${r}`);
      const s = e[r];
      if (n = i(n, s), n.length < 1) break;
    }
    return n;
  }
  async clear() {
    const e = await this.api.cartClear();
    this.populate(e);
  }
  async reload() {
    const e = await this.api.cartGet();
    this.populate(e);
  }
  populate(e) {
    this.items = e.items.map(n => new CartItem(this, n)), this.attributes = e.attributes, this.note = e.note, this.token = e.token, this.totalPrice = e.total_price, this.totalWeight = e.total_weight, this.requiresShipping = e.requires_shipping, this.currency = e.currency, this.onChange.dispatch();
  }
  async removeItem(e) {
    const n = this.items.indexOf(e);
    if (n < 0) throw new Error("That item isn't in the cart.");
    const r = await this.api.cartChange({
      line: n + 1,
      quantity: 0
    });
    this.populate(r);
  }
  async changeItem(e, n, r) {
    const i = this.items.indexOf(e);
    if (i < 0) throw new Error("That item isn't in the cart.");
    const s = await this.api.cartChange({
      line: i + 1,
      quantity: n || void 0,
      properties: r || void 0
    });
    this.populate(s);
  }
  async notifyCartUpdatedExternally() {
    this.$log.internal("Cart was updated externally, updating."), await this.reload();
  }
}
o(BaseCart, "BaseCart");
var __assign = o(function () {
  return __assign = Object.assign || o(function (e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, "__assign"), __assign.apply(this, arguments);
}, "__assign");
function lowerCase(t) {
  return t.toLowerCase();
}
o(lowerCase, "lowerCase");
var kE = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g],
  _E = /[^A-Z0-9]+/gi;
function noCase(t, e) {
  e === void 0 && (e = {});
  for (var n = e.splitRegexp, r = n === void 0 ? kE : n, i = e.stripRegexp, s = i === void 0 ? _E : i, a = e.transform, l = a === void 0 ? lowerCase : a, u = e.delimiter, c = u === void 0 ? " " : u, p = replace(replace(t, r, "$1\0$2"), s, "\0"), m = 0, d = p.length; p.charAt(m) === "\0";) m++;
  for (; p.charAt(d - 1) === "\0";) d--;
  return p.slice(m, d).split("\0").map(l).join(c);
}
o(noCase, "noCase");
function replace(t, e, n) {
  return e instanceof RegExp ? t.replace(e, n) : e.reduce(function (r, i) {
    return r.replace(i, n);
  }, t);
}
o(replace, "replace");
function pascalCaseTransform(t, e) {
  var n = t.charAt(0),
    r = t.substr(1).toLowerCase();
  return e > 0 && n >= "0" && n <= "9" ? "_" + n + r : "" + n.toUpperCase() + r;
}
o(pascalCaseTransform, "pascalCaseTransform");
function pascalCase(t, e) {
  return e === void 0 && (e = {}), noCase(t, __assign({
    delimiter: "",
    transform: pascalCaseTransform
  }, e));
}
o(pascalCase, "pascalCase");
function dotCase(t, e) {
  return e === void 0 && (e = {}), noCase(t, __assign({
    delimiter: "."
  }, e));
}
o(dotCase, "dotCase");
function paramCase(t, e) {
  return e === void 0 && (e = {}), dotCase(t, __assign({
    delimiter: "-"
  }, e));
}
o(paramCase, "paramCase");
function isComponent(t) {
  return t.$type == pv;
}
o(isComponent, "isComponent");
function normalizeComponentName(t) {
  t = t.replace(/^\.\//, "");
  const [e, ...n] = t.split("/").reverse(),
    r = n.reverse(),
    i = e.match(/\.tsx?$/),
    s = e.replace(/\.tsx?$/, ""),
    a = [];
  for (const p of r) {
    const m = pascalCase(p);
    if (p != m) {
      const d = [...a, p].join("/"),
        y = [...a, m].join("/");
      throw new Error(`Folder './components/${d}' should be './components/${y}'`);
    }
    a.push(p);
  }
  const l = r.join("");
  if (s.indexOf(l) !== 0) throw new Error(`File './components/${t}' should have filename starting with '${l}'.`);
  const u = s.substring(l.length),
    c = pascalCase(u);
  if (u != c) throw new Error(`File './components/${t}' should use filename '${l}${c}${i}'.`);
  if (s.length < 4) throw new Error(`File './components/${t}' filename is too short.`);
  if (paramCase(s).indexOf("-") === -1) throw new Error(`File './components/${t}' filename must contain two words be a valid component.`);
  return s;
}
o(normalizeComponentName, "normalizeComponentName");
class ComponentStorage {
  constructor() {
    this.definitions = [], this.definitionsByCtor = new Map(), this.definitionsByName = new Map();
  }
  all() {
    return this.definitions.slice();
  }
  push(e) {
    this.definitions.push(e), this.definitionsByCtor.set(e.component, e), this.definitionsByName.set(e.name, e);
  }
  remove(e) {
    const n = this.definitions.indexOf(e);
    n !== -1 && this.definitions.splice(n, 1), this.definitionsByCtor.delete(e.component), this.definitionsByName.delete(e.name);
  }
  findByCtor(e) {
    return this.definitionsByCtor.get(e) || null;
  }
  findByName(e) {
    return this.definitionsByName.get(e) || null;
  }
}
o(ComponentStorage, "ComponentStorage");
class InstanceStorage {
  constructor() {
    this.instances = [], this.instancesByElement = new Map();
  }
  all() {
    return this.instances.slice();
  }
  push(e) {
    this.instances.push(e), isComponent(e) && this.instancesByElement.set(e, e);
  }
  remove(e) {
    const n = this.instances.indexOf(e);
    n !== -1 && this.instances.splice(n, 1), isComponent(e) && this.instancesByElement.delete(e);
  }
  findByElement(e) {
    const n = this.instancesByElement.get(e) || null;
    return n || !isComponent(e) || !e.isConnected ? n : (this.push(e), e);
  }
}
o(InstanceStorage, "InstanceStorage");
var El = (t => (t.INTERNAL = "INTERNAL", t.DEBUG = "DEBUG", t.INFO = "INFO", t.WARN = "WARN", t.ERROR = "ERROR", t.FATAL = "FATAL", t))(El || {});
const ws = {
    INTERNAL: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    FATAL: 6
  },
  isLogLevel = o(t => !!(typeof t == "string" && ws[t]), "isLogLevel");
class TaggedLog {
  constructor(e, n) {
    this.log = e, this.tag = n;
  }
  send(e, n) {
    return this.log.send(e, this.tag, n);
  }
  sendObject(e, n, r) {
    return this.log.sendObject(e, this.tag, n, r);
  }
  setLogLevel(e) {
    return this.log.setLogLevel(e);
  }
  internal(e, n) {
    return this.log.internal(this.tag, e, n);
  }
  debug(e, n) {
    return this.log.debug(this.tag, e, n);
  }
  info(e, n) {
    return this.log.info(this.tag, e, n);
  }
  warn(e, n) {
    return this.log.warn(this.tag, e, n);
  }
  error(e, n) {
    return this.log.error(this.tag, e, n);
  }
  fatal(e, n) {
    return this.log.fatal(this.tag, e, n);
  }
  time(e) {
    return this.log.time(this.tag, e);
  }
  timeLog(e) {
    return this.log.timeLog(this.tag, e);
  }
  timeEnd(e) {
    return this.log.timeEnd(this.tag, e);
  }
  table(e, n) {
    return this.log.table(this.tag, e, n);
  }
}
o(TaggedLog, "TaggedLog");
class DefaultLog {
  constructor() {
    this.prefix = "Log", this.level = "DEBUG", this.useFancyStyling = DefaultLog.canUseFancyStyling();
  }
  static canUseFancyStyling() {
    if (typeof window > "u") return !1;
    const e = /firefox/i.test(window.navigator.userAgent);
    return !!window.chrome || !!e;
  }
  setLogLevel(e) {
    this.level = e;
  }
  setLogPrefix(e) {
    this.prefix = e;
  }
  internal(e, n, r) {
    r != null ? this.sendObject("INTERNAL", e, n, r) : this.send("INTERNAL", e, n);
  }
  debug(e, n, r) {
    r != null ? this.sendObject("DEBUG", e, n, r) : this.send("DEBUG", e, n);
  }
  info(e, n, r) {
    r != null ? this.sendObject("INFO", e, n, r) : this.send("INFO", e, n);
  }
  warn(e, n, r) {
    r != null ? this.sendObject("WARN", e, n, r) : this.send("WARN", e, n);
  }
  error(e, n, r) {
    r != null ? this.sendObject("ERROR", e, n, r) : this.send("ERROR", e, n);
  }
  fatal(e, n, r) {
    r != null ? this.sendObject("FATAL", e, n, r) : this.send("FATAL", e, n);
  }
  send(e, n, r) {
    if (ws[e] < ws[this.level]) return;
    let i = console.log;
    if ((console.error && e == "ERROR" || console.error && e == "FATAL") && (i = console.error), console.warn && e == "WARN" && (i = console.warn), console.info && e == "INFO" && (i = console.info), console.debug && e == "DEBUG" && (i = console.debug), console.debug && e == "INTERNAL" && (i = console.debug), this.useFancyStyling) {
      let s = "%c" + this.prefix + "%c" + e;
      s += "%c %c" + n + "%c" + r;
      const l = ["background: #202E78; border-top-left-radius: 4px; border-bottom-left-radius: 4px; padding: 0 8px;color: white", "width: 55px; text-align: center; padding: 0 8px; border-bottom-right-radius: 4px; border-top-right-radius: 4px;background:" + {
        INTERNAL: "#999999; color: white;",
        DEBUG: "#454F5B; color: white;",
        INFO: "#007ACE; color: white;",
        WARN: "#EEC200; color: white;",
        ERROR: "#BF0711; color: white;",
        FATAL: "linear-gradient(to top, #EEC200 0, #BF0711 100%); color: white;"
      }[e], "padding: 0 2px;", "background: #084E8A;padding:0 8px; color: white;border-radius: 8px;", "padding:0 8px;"];
      i.bind(console)(s, ...l);
    } else i.bind(console)(`[${this.prefix}] ${e}: [${n}] ${r}`);
  }
  sendObject(e, n, r, i) {
    if (ws[e] < ws[this.level]) return;
    let s = console.log;
    if ((console.error && e == "ERROR" || console.error && e == "FATAL") && (s = console.error), console.warn && e == "WARN" && (s = console.warn), console.info && e == "INFO" && (s = console.info), console.debug && e == "DEBUG" && (s = console.debug), console.debug && e == "INTERNAL" && (s = console.debug), this.useFancyStyling) {
      let a = "%c" + this.prefix + "%c" + e;
      a += "%c %c" + n + "%c" + r + " %o";
      const u = ["background: #202E78; border-top-left-radius: 4px; border-bottom-left-radius: 4px; padding: 0 8px;color: white", "width: 55px; text-align: center; padding: 0 8px; border-bottom-right-radius: 4px; border-top-right-radius: 4px;background:" + {
        INTERNAL: "#999999; color: white;",
        DEBUG: "#454F5B; color: white;",
        INFO: "#007ACE; color: white;",
        WARN: "#EEC200; color: white;",
        ERROR: "#BF0711; color: white;",
        FATAL: "linear-gradient(to top, #EEC200 0, #BF0711 100%); color: white;"
      }[e], "padding: 0 2px;", "background: #084E8A;padding:1px 8px; color: white;border-radius: 8px;", "padding-left: 8px;"];
      s.bind(console)(a, ...u, i);
    } else s.bind(console)(`[${this.prefix}] ${e}: [${n}] ${r}`, i);
  }
  time(e, n) {
    if (this.level === "DEBUG") return console.time(`[${e}] ${n}`);
  }
  timeLog(e, n) {
    if (this.level === "DEBUG") return console.timeLog(`[${e}] ${n}`);
  }
  timeEnd(e, n) {
    if (this.level === "DEBUG") return console.timeEnd(`[${e}] ${n}`);
  }
  table(e, n, r) {
    if (this.level === "DEBUG") return console.table(n, r);
  }
}
o(DefaultLog, "DefaultLog");
const fv = new DefaultLog();
fv.setLogPrefix("Theme-LegacySalvoLiteComponent");
fv.setLogLevel(El.INFO);
function promiseWithCallbacks(t) {
  let e = null,
    n = null;
  const r = new Promise((i, s) => {
    e = i, n = s, t(i, s);
  });
  if (!e || !n) throw new Error("promiseWithCallbacks did not init properly.");
  return [r, e, n];
}
o(promiseWithCallbacks, "promiseWithCallbacks");
class ComponentService {
  constructor() {
    this.components = new ComponentStorage(), this.instances = new InstanceStorage(), this.legacySupport = !1, this.bootstrapPromise = promiseWithCallbacks(() => {}), this.readyPromise = promiseWithCallbacks(() => {}), this.definedComponents = [];
  }
  bootstrapCompleted() {
    this.bootstrapPromise[1]();
  }
  get bootstrapped() {
    return this.bootstrapPromise[0];
  }
  readyCompleted() {
    this.readyPromise[1]();
  }
  get ready() {
    return this.readyPromise[0];
  }
  register(e) {
    Sn.internal(this.constructor.name, `Register ${e.name} (${e.variant || "base variant"})`, {
      componentDef: e
    }), this.components.push(e);
  }
  enableLegacySupport() {
    this.legacySupport = !0;
  }
  bootstrap() {
    for (const e of this.components.all()) {
      const n = e.meta.selector || paramCase(e.name);
      if (this.definedComponents.indexOf(n) === -1) if (this.definedComponents.push(n), e.meta.isLegacy) {
        if (!this.legacySupport) throw new Error(`Legacy component ${e.name} found, but legacy componentsupport is not enabled. Pass enableLegacySalvoLiteComponentSupport to main().`);
        const r = Array.from(document.querySelectorAll(e.meta.selector));
        for (const i of r) {
          Sn.internal(this.constructor.name, `Bootstrapping legacy component ${e.name}`);
          const s = new e.component();
          this.instances.push(s), Promise.resolve(s.init(i)).catch(a => {
            Sn.error(this.constructor.name, "Error in component init", {
              e: a
            });
          });
        }
      } else Sn.internal(this.constructor.name, `Bootstrapping ${e.name}`), window.customElements.define(n, e.component);
    }
    this.bootstrapCompleted(), this.readyCompleted();
  }
  instanceConnected(e) {
    this.instances.push(e);
  }
  instanceDisconnected(e) {
    this.instances.remove(e);
  }
  registerComponent(e, n, r) {
    const i = normalizeComponentName(e),
      s = pascalCase(i);
    if (i != s) throw new Error(`File './components/${e}' should use filename ${s}.ts (for element name ${i})`);
    const a = n[i];
    if (!a) throw new Error(`File './components/${e}' must export a class named '${i}' for component auto-registration.`);
    const l = a.prototype.$info;
    if (!l) throw new Error(`Component ${i} must use the @Component() decorator.`);
    this.register(l);
  }
}
o(ComponentService, "ComponentService");
const $t = new ComponentService();
window.componentService = $t;
const pv = Symbol("SalvoComponent"),
  ME = typeof window < "u" && window.HTMLElement || o(class {}, "NodeDummyClass");
class BaseComponent extends ME {
  constructor() {
    if (super(), this.$type = pv, this.$isInit = !1, this.$propWatchers = {}, this._$log = null, this.$eventListeners = [], this.$unsubCallbacks = [], !$t.components.findByCtor(this.constructor)) throw new Error(`Cannot create instance of component ${this.constructor.name} - not registered.`);
    this.$log.internal("Constructed", {
      instance: this
    });
  }
  $onPropUpdated(e, n) {
    this.$log.internal("PROP UPDATED", {
      propDef: e,
      value: n,
      direct: this[e.propertyKey]
    }), e.reflectAttr && n.toString() && (this.$log.internal("SET ATTR", {
      propDef: e,
      value: n
    }), this.setAttribute(e.attr, n.toString()));
    const r = this.$propWatchers[e.propertyKey] || [];
    for (const i of r) i(n);
  }
  $resolvePropValue(e) {
    const n = this.getAttribute(e.attr);
    let r;
    if (n !== null) {
      if (["String", "Number", "Date", "Function", "string", "number", "date", "function"].indexOf(e.propertyTypeName) > -1 && typeof e.propertyType == "function") r = e.propertyType(n);else if (e.propertyTypeName == "Boolean") {
        if (n === "true" || n === "1") r = !0;else if (n === "false" || n === "0") r = !1;else throw new Error(`Boolean prop ${e.attr} passed invalid value "${n}"`);
      } else {
        let s;
        try {
          s = JSON.parse(n);
        } catch {
          throw new Error(`Prop ${e.attr} passed invalid JSON!`);
        }
        const a = e.propertyType;
        if (a.fromSalvoPropValue && (r = a.fromSalvoPropValue(s)), ["object", "array"].indexOf(typeof s) == -1) r = s;else {
          const l = new e.propertyType();
          return Object.assign(l, s), l;
        }
      }
    } else {
      if (e.default === void 0) throw new Error(`Required prop ${e.attr} (${e.propertyKey}) not passed!`);
      r = e.default;
    }
    return r;
  }
  $resolveRefValue(e, n) {
    const r = this.querySelectorAll(e.selector) || [],
      resolveRef = o(s => {
        if (!isComponent(s) && s.tagName.indexOf("-") > -1) throw new Error(`Ref ${e.selector} (${e.propertyKey}) has issues - Element was found and type was interpreted as component ref - element looks like a component, but isn't registered. Maybe you have a typo in the component tag?`);
        return this.$log.internal("resolve ref", {
          ref: e,
          el: s
        }), s;
      }, "resolveRef");
    if (e.propertyTypeName == "Array") {
      if (r.length < 1 && e.required) throw new Error(`Required ref ${e.selector} (${e.propertyKey}) not found! (This is an array ref - if you want to allow an empty array set required to false in the Ref options)`);
      return Array.from(r).map(s => resolveRef(s));
    } else {
      if (!r[0]) {
        if (e.required) throw new Error(`Required ref ${e.selector} (${e.propertyKey}) not found!`);
        return null;
      }
      if (r.length > 1) throw new Error(`Duplicate elements with same ref: ${e.selector}. If this is intention, change the ref to an array type to reflect this.`);
      return resolveRef(r[0]);
    }
  }
  async connectedCallback() {
    if ($t.instanceConnected(this), await $t.bootstrapped, !this.isConnected) {
      $t.instanceDisconnected(this);
      return;
    }
    await this.$beforeInit(), await $t.ready, this.$isInit || (await this.$init());
  }
  static get observedAttributes() {
    const e = $t.components.findByCtor(this);
    return (e == null ? void 0 : e.props.map(n => n.attr)) || [];
  }
  attributeChangedCallback(e, n, r) {
    for (const i of this.$info.props) if (i.attr == e && i.reflectAttr && r !== null) {
      const s = ["String", "Number", "Date", "Function", "string", "number", "date", "function"];
      let a;
      if (s.indexOf(i.propertyTypeName) > -1 && typeof i.propertyType == "function") a = i.propertyType(r);else if (prop.propertyTypeName == "Boolean") {
        if (propVal === "true" || propVal === "1") a = !0;else if (propVal === "false" || propVal === "0") a = !1;else throw new Error(`Boolean prop ${prop.attr} passed invalid value "${propVal}"`);
      } else {
        let l;
        try {
          l = JSON.parse(r);
        } catch {
          throw new Error(`Prop ${i.attr} passed invalid JSON!`);
        }
        const u = i.propertyType;
        u.fromSalvoPropValue ? a = u.fromSalvoPropValue(l) : (a = new i.propertyType(), Object.assign(a, l));
      }
      this[i.propertyKey] !== a && (this[i.propertyKey] = a);
    }
    this.attributeChanged(e, n, r);
  }
  attributeChanged(e, n, r) {}
  $watchProp(e, n) {
    this.$propWatchers[e.toString()] || (this.$propWatchers[e.toString()] = []), this.$propWatchers[e.toString()].push(n);
  }
  get $log() {
    return this._$log || (this._$log = new TaggedLog(Sn, this.$name)), this._$log;
  }
  $listen(e, n, r) {
    const wrappedCallback = o(s => {
      r(s);
    }, "wrappedCallback");
    this.$eventListeners.push({
      el: e,
      eventName: n.toString(),
      wrappedCallback: wrappedCallback
    }), e.addEventListener(n.toString(), wrappedCallback);
  }
  $unregisterEventListeners() {
    for (const {
      el: e,
      eventName: n,
      wrappedCallback: r
    } of this.$eventListeners) e.removeEventListener(n, r);
    for (const e of this.$unsubCallbacks) e();
  }
  $subscribe(e, n) {
    const r = e.subscribe(n);
    return this.$unsubCallbacks.push(r), r;
  }
  $beforeInit() {
    this.$log.internal("Initing refs");
    try {
      for (const e of this.$info.refs) {
        const n = this.$resolveRefValue(e, $t.instances.findByElement.bind($t.instances));
        this[e.propertyKey] = n, this.$log.internal("SET REF VAL", {
          prop: e.propertyKey,
          val: n
        });
      }
    } catch (e) {
      this.$log.error(`${e}`, {
        componentName: this.$name,
        el: this
      });
    }
    this.$log.internal("Initing props");
    try {
      this.$log.internal("initing props", {
        t: this,
        props: this.$info.props
      });
      for (const e of this.$info.props) {
        const n = this.$resolvePropValue(e);
        this[e.propertyKey] = n, this.$log.internal("SET PROP VAL", {
          prop: e.propertyKey,
          val: n
        });
      }
    } catch (e) {
      this.$log.error(`${e}`, {
        componentName: this.$name,
        el: this
      });
    }
    this.$log.internal("ready");
  }
  init() {}
  $init() {
    return this.$isInit = !0, this.init();
  }
  disconnectedCallback() {
    $t.instanceDisconnected(this), this.$isInit && (this.$isInit = !1, this.$destroy());
  }
  $destroy() {
    this.$unregisterEventListeners(), this.$isInit = !1;
  }
  destroy() {}
}
o(BaseComponent, "BaseComponent");
var hv = {
    exports: {}
  },
  Te = {}; /*
           object-assign
           (c) Sindre Sorhus
           @license MIT
           */
var zh = Object.getOwnPropertySymbols,
  IE = Object.prototype.hasOwnProperty,
  RE = Object.prototype.propertyIsEnumerable;
function toObject(t) {
  if (t == null) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}
o(toObject, "toObject");
function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var t = new String("abc");
    if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5") return !1;
    for (var e = {}, n = 0; n < 10; n++) e["_" + String.fromCharCode(n)] = n;
    var r = Object.getOwnPropertyNames(e).map(function (s) {
      return e[s];
    });
    if (r.join("") !== "0123456789") return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (s) {
      i[s] = s;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
o(shouldUseNative, "shouldUseNative");
var mv = shouldUseNative() ? Object.assign : function (t, e) {
  for (var n, r = toObject(t), i, s = 1; s < arguments.length; s++) {
    n = Object(arguments[s]);
    for (var a in n) IE.call(n, a) && (r[a] = n[a]);
    if (zh) {
      i = zh(n);
      for (var l = 0; l < i.length; l++) RE.call(n, i[l]) && (r[i[l]] = n[i[l]]);
    }
  }
  return r;
}; /** @license React v17.0.2
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
var td = mv,
  Mi = 60103,
  gv = 60106;
Te.Fragment = 60107;
Te.StrictMode = 60108;
Te.Profiler = 60114;
var yv = 60109,
  vv = 60110,
  wv = 60112;
Te.Suspense = 60113;
var bv = 60115,
  Sv = 60116;
if (typeof Symbol == "function" && Symbol.for) {
  var sn = Symbol.for;
  Mi = sn("react.element"), gv = sn("react.portal"), Te.Fragment = sn("react.fragment"), Te.StrictMode = sn("react.strict_mode"), Te.Profiler = sn("react.profiler"), yv = sn("react.provider"), vv = sn("react.context"), wv = sn("react.forward_ref"), Te.Suspense = sn("react.suspense"), bv = sn("react.memo"), Sv = sn("react.lazy");
}
var Hh = typeof Symbol == "function" && Symbol.iterator;
function y(t) {
  return t === null || typeof t != "object" ? null : (t = Hh && t[Hh] || t["@@iterator"], typeof t == "function" ? t : null);
}
o(y, "y$1");
function z$1(t) {
  for (var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, n = 1; n < arguments.length; n++) e += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
o(z$1, "z");
var Ev = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {}
  },
  Tv = {};
function C(t, e, n) {
  this.props = t, this.context = e, this.refs = Tv, this.updater = n || Ev;
}
o(C, "C");
C.prototype.isReactComponent = {};
C.prototype.setState = function (t, e) {
  if (typeof t != "object" && typeof t != "function" && t != null) throw Error(z$1(85));
  this.updater.enqueueSetState(this, t, e, "setState");
};
C.prototype.forceUpdate = function (t) {
  this.updater.enqueueForceUpdate(this, t, "forceUpdate");
};
function D() {}
o(D, "D$1");
D.prototype = C.prototype;
function E(t, e, n) {
  this.props = t, this.context = e, this.refs = Tv, this.updater = n || Ev;
}
o(E, "E$1");
var rd = E.prototype = new D();
rd.constructor = E;
td(rd, C.prototype);
rd.isPureReactComponent = !0;
var id = {
    current: null
  },
  Cv = Object.prototype.hasOwnProperty,
  xv = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function J(t, e, n) {
  var r,
    i = {},
    s = null,
    a = null;
  if (e != null) for (r in e.ref !== void 0 && (a = e.ref), e.key !== void 0 && (s = "" + e.key), e) Cv.call(e, r) && !xv.hasOwnProperty(r) && (i[r] = e[r]);
  var l = arguments.length - 2;
  if (l === 1) i.children = n;else if (1 < l) {
    for (var u = Array(l), c = 0; c < l; c++) u[c] = arguments[c + 2];
    i.children = u;
  }
  if (t && t.defaultProps) for (r in l = t.defaultProps, l) i[r] === void 0 && (i[r] = l[r]);
  return {
    $$typeof: Mi,
    type: t,
    key: s,
    ref: a,
    props: i,
    _owner: id.current
  };
}
o(J, "J");
function K$1(t, e) {
  return {
    $$typeof: Mi,
    type: t.type,
    key: e,
    ref: t.ref,
    props: t.props,
    _owner: t._owner
  };
}
o(K$1, "K");
function L(t) {
  return typeof t == "object" && t !== null && t.$$typeof === Mi;
}
o(L, "L");
function escape$1(t) {
  var e = {
    "=": "=0",
    ":": "=2"
  };
  return "$" + t.replace(/[=:]/g, function (n) {
    return e[n];
  });
}
o(escape$1, "escape$1");
var Uh = /\/+/g;
function N(t, e) {
  return typeof t == "object" && t !== null && t.key != null ? escape$1("" + t.key) : e.toString(36);
}
o(N, "N$1");
function O(t, e, n, r, i) {
  var s = typeof t;
  (s === "undefined" || s === "boolean") && (t = null);
  var a = !1;
  if (t === null) a = !0;else switch (s) {
    case "string":
    case "number":
      a = !0;
      break;
    case "object":
      switch (t.$$typeof) {
        case Mi:
        case gv:
          a = !0;
      }
  }
  if (a) return a = t, i = i(a), t = r === "" ? "." + N(a, 0) : r, Array.isArray(i) ? (n = "", t != null && (n = t.replace(Uh, "$&/") + "/"), O(i, e, n, "", function (c) {
    return c;
  })) : i != null && (L(i) && (i = K$1(i, n + (!i.key || a && a.key === i.key ? "" : ("" + i.key).replace(Uh, "$&/") + "/") + t)), e.push(i)), 1;
  if (a = 0, r = r === "" ? "." : r + ":", Array.isArray(t)) for (var l = 0; l < t.length; l++) {
    s = t[l];
    var u = r + N(s, l);
    a += O(s, e, n, u, i);
  } else if (u = y(t), typeof u == "function") for (t = u.call(t), l = 0; !(s = t.next()).done;) s = s.value, u = r + N(s, l++), a += O(s, e, n, u, i);else if (s === "object") throw e = "" + t, Error(z$1(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
  return a;
}
o(O, "O$1");
function P(t, e, n) {
  if (t == null) return t;
  var r = [],
    i = 0;
  return O(t, r, "", "", function (s) {
    return e.call(n, s, i++);
  }), r;
}
o(P, "P$1");
function Q(t) {
  if (t._status === -1) {
    var e = t._result;
    e = e(), t._status = 0, t._result = e, e.then(function (n) {
      t._status === 0 && (n = n.default, t._status = 1, t._result = n);
    }, function (n) {
      t._status === 0 && (t._status = 2, t._result = n);
    });
  }
  if (t._status === 1) return t._result;
  throw t._result;
}
o(Q, "Q");
var _v = {
  current: null
};
function S() {
  var t = _v.current;
  if (t === null) throw Error(z$1(321));
  return t;
}
o(S, "S$1");
var HE = {
  ReactCurrentDispatcher: _v,
  ReactCurrentBatchConfig: {
    transition: 0
  },
  ReactCurrentOwner: id,
  IsSomeRendererActing: {
    current: !1
  },
  assign: td
};
Te.Children = {
  map: P,
  forEach: function (t, e, n) {
    P(t, function () {
      e.apply(this, arguments);
    }, n);
  },
  count: function (t) {
    var e = 0;
    return P(t, function () {
      e++;
    }), e;
  },
  toArray: function (t) {
    return P(t, function (e) {
      return e;
    }) || [];
  },
  only: function (t) {
    if (!L(t)) throw Error(z$1(143));
    return t;
  }
};
Te.Component = C;
Te.PureComponent = E;
Te.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = HE;
Te.cloneElement = function (t, e, n) {
  if (t == null) throw Error(z$1(267, t));
  var r = td({}, t.props),
    i = t.key,
    s = t.ref,
    a = t._owner;
  if (e != null) {
    if (e.ref !== void 0 && (s = e.ref, a = id.current), e.key !== void 0 && (i = "" + e.key), t.type && t.type.defaultProps) var l = t.type.defaultProps;
    for (u in e) Cv.call(e, u) && !xv.hasOwnProperty(u) && (r[u] = e[u] === void 0 && l !== void 0 ? l[u] : e[u]);
  }
  var u = arguments.length - 2;
  if (u === 1) r.children = n;else if (1 < u) {
    l = Array(u);
    for (var c = 0; c < u; c++) l[c] = arguments[c + 2];
    r.children = l;
  }
  return {
    $$typeof: Mi,
    type: t.type,
    key: i,
    ref: s,
    props: r,
    _owner: a
  };
};
Te.createContext = function (t, e) {
  return e === void 0 && (e = null), t = {
    $$typeof: vv,
    _calculateChangedBits: e,
    _currentValue: t,
    _currentValue2: t,
    _threadCount: 0,
    Provider: null,
    Consumer: null
  }, t.Provider = {
    $$typeof: yv,
    _context: t
  }, t.Consumer = t;
};
Te.createElement = J;
Te.createFactory = function (t) {
  var e = J.bind(null, t);
  return e.type = t, e;
};
Te.createRef = function () {
  return {
    current: null
  };
};
Te.forwardRef = function (t) {
  return {
    $$typeof: wv,
    render: t
  };
};
Te.isValidElement = L;
Te.lazy = function (t) {
  return {
    $$typeof: Sv,
    _payload: {
      _status: -1,
      _result: t
    },
    _init: Q
  };
};
Te.memo = function (t, e) {
  return {
    $$typeof: bv,
    type: t,
    compare: e === void 0 ? null : e
  };
};
Te.useCallback = function (t, e) {
  return S().useCallback(t, e);
};
Te.useContext = function (t, e) {
  return S().useContext(t, e);
};
Te.useDebugValue = function () {};
Te.useEffect = function (t, e) {
  return S().useEffect(t, e);
};
Te.useImperativeHandle = function (t, e, n) {
  return S().useImperativeHandle(t, e, n);
};
Te.useLayoutEffect = function (t, e) {
  return S().useLayoutEffect(t, e);
};
Te.useMemo = function (t, e) {
  return S().useMemo(t, e);
};
Te.useReducer = function (t, e, n) {
  return S().useReducer(t, e, n);
};
Te.useRef = function (t) {
  return S().useRef(t);
};
Te.useState = function (t) {
  return S().useState(t);
};
Te.version = "17.0.2";
hv.exports = Te;
var UE = hv.exports,
  fn = {},
  Ov = {
    exports: {}
  },
  Av = {}; /** @license React v0.20.2
           * scheduler.production.min.js
           *
           * Copyright (c) Facebook, Inc. and its affiliates.
           *
           * This source code is licensed under the MIT license found in the
           * LICENSE file in the root directory of this source tree.
           */
(function (t) {
  var e, n, r, i;
  if (typeof performance == "object" && typeof performance.now == "function") {
    var s = performance;
    t.unstable_now = function () {
      return s.now();
    };
  } else {
    var a = Date,
      l = a.now();
    t.unstable_now = function () {
      return a.now() - l;
    };
  }
  if (typeof window > "u" || typeof MessageChannel != "function") {
    var u = null,
      c = null,
      w$1 = o(function () {
        if (u !== null) try {
          var C = t.unstable_now();
          u(!0, C), u = null;
        } catch (A) {
          throw setTimeout(w$1, 0), A;
        }
      }, "w");
    e = o(function (C) {
      u !== null ? setTimeout(e, 0, C) : (u = C, setTimeout(w$1, 0));
    }, "f"), n = o(function (C, A) {
      c = setTimeout(C, A);
    }, "g"), r = o(function () {
      clearTimeout(c);
    }, "h"), t.unstable_shouldYield = function () {
      return !1;
    }, i = t.unstable_forceFrameRate = function () {};
  } else {
    var m = window.setTimeout,
      d = window.clearTimeout;
    if (typeof console < "u") {
      var y = window.cancelAnimationFrame;
      typeof window.requestAnimationFrame != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), typeof y != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var S = !1,
      w = null,
      g = -1,
      h = 5,
      f = 0;
    t.unstable_shouldYield = function () {
      return t.unstable_now() >= f;
    }, i = o(function () {}, "k"), t.unstable_forceFrameRate = function (C) {
      0 > C || 125 < C ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : h = 0 < C ? Math.floor(1e3 / C) : 5;
    };
    var v = new MessageChannel(),
      E = v.port2;
    v.port1.onmessage = function () {
      if (w !== null) {
        var C = t.unstable_now();
        f = C + h;
        try {
          w(!0, C) ? E.postMessage(null) : (S = !1, w = null);
        } catch (A) {
          throw E.postMessage(null), A;
        }
      } else S = !1;
    }, e = o(function (C) {
      w = C, S || (S = !0, E.postMessage(null));
    }, "f"), n = o(function (C, A) {
      g = m(function () {
        C(t.unstable_now());
      }, A);
    }, "g"), r = o(function () {
      d(g), g = -1;
    }, "h");
  }
  function H$1(C, A) {
    var L = C.length;
    C.push(A);
    e: for (;;) {
      var V = L - 1 >>> 1,
        Y = C[V];
      if (Y !== void 0 && 0 < I$1(Y, A)) C[V] = A, C[L] = Y, L = V;else break e;
    }
  }
  o(H$1, "H");
  function J$1(C) {
    return C = C[0], C === void 0 ? null : C;
  }
  o(J$1, "J");
  function K$2(C) {
    var A = C[0];
    if (A !== void 0) {
      var L = C.pop();
      if (L !== A) {
        C[0] = L;
        e: for (var V = 0, Y = C.length; V < Y;) {
          var re = 2 * (V + 1) - 1,
            ae = C[re],
            le = re + 1,
            ce = C[le];
          if (ae !== void 0 && 0 > I$1(ae, L)) ce !== void 0 && 0 > I$1(ce, ae) ? (C[V] = ce, C[le] = L, V = le) : (C[V] = ae, C[re] = L, V = re);else if (ce !== void 0 && 0 > I$1(ce, L)) C[V] = ce, C[le] = L, V = le;else break e;
        }
      }
      return A;
    }
    return null;
  }
  o(K$2, "K");
  function I$1(C, A) {
    var L = C.sortIndex - A.sortIndex;
    return L !== 0 ? L : C.id - A.id;
  }
  o(I$1, "I");
  var M = [],
    I = [],
    U = 1,
    _ = null,
    R = 3,
    B = !1,
    H = !1,
    Q = !1;
  function T(C) {
    for (var A = J$1(I); A !== null;) {
      if (A.callback === null) K$2(I);else if (A.startTime <= C) K$2(I), A.sortIndex = A.expirationTime, H$1(M, A);else break;
      A = J$1(I);
    }
  }
  o(T, "T");
  function U$1(C) {
    if (Q = !1, T(C), !H) if (J$1(M) !== null) H = !0, e(V$1);else {
      var A = J$1(I);
      A !== null && n(U$1, A.startTime - C);
    }
  }
  o(U$1, "U");
  function V$1(C, A) {
    H = !1, Q && (Q = !1, r()), B = !0;
    var L = R;
    try {
      for (T(A), _ = J$1(M); _ !== null && (!(_.expirationTime > A) || C && !t.unstable_shouldYield());) {
        var V = _.callback;
        if (typeof V == "function") {
          _.callback = null, R = _.priorityLevel;
          var Y = V(_.expirationTime <= A);
          A = t.unstable_now(), typeof Y == "function" ? _.callback = Y : _ === J$1(M) && K$2(M), T(A);
        } else K$2(M);
        _ = J$1(M);
      }
      if (_ !== null) var re = !0;else {
        var ae = J$1(I);
        ae !== null && n(U$1, ae.startTime - A), re = !1;
      }
      return re;
    } finally {
      _ = null, R = L, B = !1;
    }
  }
  o(V$1, "V");
  var q = i;
  t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function (C) {
    C.callback = null;
  }, t.unstable_continueExecution = function () {
    H || B || (H = !0, e(V$1));
  }, t.unstable_getCurrentPriorityLevel = function () {
    return R;
  }, t.unstable_getFirstCallbackNode = function () {
    return J$1(M);
  }, t.unstable_next = function (C) {
    switch (R) {
      case 1:
      case 2:
      case 3:
        var A = 3;
        break;
      default:
        A = R;
    }
    var L = R;
    R = A;
    try {
      return C();
    } finally {
      R = L;
    }
  }, t.unstable_pauseExecution = function () {}, t.unstable_requestPaint = q, t.unstable_runWithPriority = function (C, A) {
    switch (C) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        C = 3;
    }
    var L = R;
    R = C;
    try {
      return A();
    } finally {
      R = L;
    }
  }, t.unstable_scheduleCallback = function (C, A, L) {
    var V = t.unstable_now();
    switch (typeof L == "object" && L !== null ? (L = L.delay, L = typeof L == "number" && 0 < L ? V + L : V) : L = V, C) {
      case 1:
        var Y = -1;
        break;
      case 2:
        Y = 250;
        break;
      case 5:
        Y = 1073741823;
        break;
      case 4:
        Y = 1e4;
        break;
      default:
        Y = 5e3;
    }
    return Y = L + Y, C = {
      id: U++,
      callback: A,
      priorityLevel: C,
      startTime: L,
      expirationTime: Y,
      sortIndex: -1
    }, L > V ? (C.sortIndex = L, H$1(I, C), J$1(M) === null && C === J$1(I) && (Q ? r() : Q = !0, n(U$1, L - V))) : (C.sortIndex = Y, H$1(M, C), H || B || (H = !0, e(V$1))), C;
  }, t.unstable_wrapCallback = function (C) {
    var A = R;
    return function () {
      var L = R;
      R = A;
      try {
        return C.apply(this, arguments);
      } finally {
        R = L;
      }
    };
  };
})(Av);
Ov.exports = Av;
var qE = Ov.exports; /** @license React v17.0.2
                     * react-dom.production.min.js
                     *
                     * Copyright (c) Facebook, Inc. and its affiliates.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     */
var Tl = UE,
  ze = mv,
  lt = qE;
function y$1(t) {
  for (var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, n = 1; n < arguments.length; n++) e += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
o(y$1, "y");
if (!Tl) throw Error(y$1(227));
var Lv = new Set(),
  Vs = {};
function da$1(t, e) {
  ea(t, e), ea(t + "Capture", e);
}
o(da$1, "da");
function ea(t, e) {
  for (Vs[t] = e, t = 0; t < e.length; t++) Lv.add(e[t]);
}
o(ea, "ea");
var In = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"),
  VE = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  qh = Object.prototype.hasOwnProperty,
  Vh = {},
  Wh = {};
function la$1(t) {
  return qh.call(Wh, t) ? !0 : qh.call(Vh, t) ? !1 : VE.test(t) ? Wh[t] = !0 : (Vh[t] = !0, !1);
}
o(la$1, "la");
function ma$1(t, e, n, r) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof e) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r ? !1 : n !== null ? !n.acceptsBooleans : (t = t.toLowerCase().slice(0, 5), t !== "data-" && t !== "aria-");
    default:
      return !1;
  }
}
o(ma$1, "ma");
function na$1(t, e, n, r) {
  if (e === null || typeof e > "u" || ma$1(t, e, n, r)) return !0;
  if (r) return !1;
  if (n !== null) switch (n.type) {
    case 3:
      return !e;
    case 4:
      return e === !1;
    case 5:
      return isNaN(e);
    case 6:
      return isNaN(e) || 1 > e;
  }
  return !1;
}
o(na$1, "na");
function B(t, e, n, r, i, s, a) {
  this.acceptsBooleans = e === 2 || e === 3 || e === 4, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = t, this.type = e, this.sanitizeURL = s, this.removeEmptyString = a;
}
o(B, "B");
var ht = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (t) {
  ht[t] = new B(t, 0, !1, t, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (t) {
  var e = t[0];
  ht[e] = new B(e, 1, !1, t[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (t) {
  ht[t] = new B(t, 2, !1, t.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (t) {
  ht[t] = new B(t, 2, !1, t, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (t) {
  ht[t] = new B(t, 3, !1, t.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (t) {
  ht[t] = new B(t, 3, !0, t, null, !1, !1);
});
["capture", "download"].forEach(function (t) {
  ht[t] = new B(t, 4, !1, t, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (t) {
  ht[t] = new B(t, 6, !1, t, null, !1, !1);
});
["rowSpan", "start"].forEach(function (t) {
  ht[t] = new B(t, 5, !1, t.toLowerCase(), null, !1, !1);
});
var od = /[\-:]([a-z])/g;
function pa$1(t) {
  return t[1].toUpperCase();
}
o(pa$1, "pa");
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (t) {
  var e = t.replace(od, pa$1);
  ht[e] = new B(e, 1, !1, t, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (t) {
  var e = t.replace(od, pa$1);
  ht[e] = new B(e, 1, !1, t, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (t) {
  var e = t.replace(od, pa$1);
  ht[e] = new B(e, 1, !1, t, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (t) {
  ht[t] = new B(t, 1, !1, t.toLowerCase(), null, !1, !1);
});
ht.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function (t) {
  ht[t] = new B(t, 1, !1, t.toLowerCase(), null, !0, !0);
});
function qa$1(t, e, n, r) {
  var i = ht.hasOwnProperty(e) ? ht[e] : null,
    s = i !== null ? i.type === 0 : r ? !1 : !(!(2 < e.length) || e[0] !== "o" && e[0] !== "O" || e[1] !== "n" && e[1] !== "N");
  s || (na$1(e, n, i, r) && (n = null), r || i === null ? la$1(e) && (n === null ? t.removeAttribute(e) : t.setAttribute(e, "" + n)) : i.mustUseProperty ? t[i.propertyName] = n === null ? i.type === 3 ? !1 : "" : n : (e = i.attributeName, r = i.attributeNamespace, n === null ? t.removeAttribute(e) : (i = i.type, n = i === 3 || i === 4 && n === !0 ? "" : "" + n, r ? t.setAttributeNS(r, e, n) : t.setAttribute(e, n))));
}
o(qa$1, "qa");
var jr = Tl.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  bs = 60103,
  Sr = 60106,
  Un = 60107,
  ud = 60108,
  _s = 60114,
  cd = 60109,
  fd = 60110,
  Pl = 60112,
  Os = 60113,
  Ea = 60120,
  Cl = 60115,
  dd = 60116,
  pd = 60121,
  hd = 60128,
  Mv = 60129,
  md = 60130,
  Rc = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var st = Symbol.for;
  bs = st("react.element"), Sr = st("react.portal"), Un = st("react.fragment"), ud = st("react.strict_mode"), _s = st("react.profiler"), cd = st("react.provider"), fd = st("react.context"), Pl = st("react.forward_ref"), Os = st("react.suspense"), Ea = st("react.suspense_list"), Cl = st("react.memo"), dd = st("react.lazy"), pd = st("react.block"), st("react.scope"), hd = st("react.opaque.id"), Mv = st("react.debug_trace_mode"), md = st("react.offscreen"), Rc = st("react.legacy_hidden");
}
var Gh = typeof Symbol == "function" && Symbol.iterator;
function La$1(t) {
  return t === null || typeof t != "object" ? null : (t = Gh && t[Gh] || t["@@iterator"], typeof t == "function" ? t : null);
}
o(La$1, "La");
var Uu;
function Na$1(t) {
  if (Uu === void 0) try {
    throw Error();
  } catch (n) {
    var e = n.stack.trim().match(/\n( *(at )?)/);
    Uu = e && e[1] || "";
  }
  return `
` + Uu + t;
}
o(Na$1, "Na");
var qu = !1;
function Pa$1(t, e) {
  if (!t || qu) return "";
  qu = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (e) {
      if (e = o(function () {
        throw Error();
      }, "b"), Object.defineProperty(e.prototype, "props", {
        set: function () {
          throw Error();
        }
      }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(e, []);
        } catch (u) {
          var r = u;
        }
        Reflect.construct(t, [], e);
      } else {
        try {
          e.call();
        } catch (u) {
          r = u;
        }
        t.call(e.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (u) {
        r = u;
      }
      t();
    }
  } catch (u) {
    if (u && r && typeof u.stack == "string") {
      for (var i = u.stack.split(`
`), s = r.stack.split(`
`), a = i.length - 1, l = s.length - 1; 1 <= a && 0 <= l && i[a] !== s[l];) l--;
      for (; 1 <= a && 0 <= l; a--, l--) if (i[a] !== s[l]) {
        if (a !== 1 || l !== 1) do if (a--, l--, 0 > l || i[a] !== s[l]) return `
` + i[a].replace(" at new ", " at "); while (1 <= a && 0 <= l);
        break;
      }
    }
  } finally {
    qu = !1, Error.prepareStackTrace = n;
  }
  return (t = t ? t.displayName || t.name : "") ? Na$1(t) : "";
}
o(Pa$1, "Pa");
function Qa$1(t) {
  switch (t.tag) {
    case 5:
      return Na$1(t.type);
    case 16:
      return Na$1("Lazy");
    case 13:
      return Na$1("Suspense");
    case 19:
      return Na$1("SuspenseList");
    case 0:
    case 2:
    case 15:
      return t = Pa$1(t.type, !1), t;
    case 11:
      return t = Pa$1(t.type.render, !1), t;
    case 22:
      return t = Pa$1(t.type._render, !1), t;
    case 1:
      return t = Pa$1(t.type, !0), t;
    default:
      return "";
  }
}
o(Qa$1, "Qa");
function Ra$1(t) {
  if (t == null) return null;
  if (typeof t == "function") return t.displayName || t.name || null;
  if (typeof t == "string") return t;
  switch (t) {
    case Un:
      return "Fragment";
    case Sr:
      return "Portal";
    case _s:
      return "Profiler";
    case ud:
      return "StrictMode";
    case Os:
      return "Suspense";
    case Ea:
      return "SuspenseList";
  }
  if (typeof t == "object") switch (t.$$typeof) {
    case fd:
      return (t.displayName || "Context") + ".Consumer";
    case cd:
      return (t._context.displayName || "Context") + ".Provider";
    case Pl:
      var e = t.render;
      return e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case Cl:
      return Ra$1(t.type);
    case pd:
      return Ra$1(t._render);
    case dd:
      e = t._payload, t = t._init;
      try {
        return Ra$1(t(e));
      } catch {}
  }
  return null;
}
o(Ra$1, "Ra");
function Sa$1(t) {
  switch (typeof t) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return t;
    default:
      return "";
  }
}
o(Sa$1, "Sa");
function Ta$1(t) {
  var e = t.type;
  return (t = t.nodeName) && t.toLowerCase() === "input" && (e === "checkbox" || e === "radio");
}
o(Ta$1, "Ta");
function Ua$1(t) {
  var e = Ta$1(t) ? "checked" : "value",
    n = Object.getOwnPropertyDescriptor(t.constructor.prototype, e),
    r = "" + t[e];
  if (!t.hasOwnProperty(e) && typeof n < "u" && typeof n.get == "function" && typeof n.set == "function") {
    var i = n.get,
      s = n.set;
    return Object.defineProperty(t, e, {
      configurable: !0,
      get: function () {
        return i.call(this);
      },
      set: function (a) {
        r = "" + a, s.call(this, a);
      }
    }), Object.defineProperty(t, e, {
      enumerable: n.enumerable
    }), {
      getValue: function () {
        return r;
      },
      setValue: function (a) {
        r = "" + a;
      },
      stopTracking: function () {
        t._valueTracker = null, delete t[e];
      }
    };
  }
}
o(Ua$1, "Ua");
function Va$1(t) {
  t._valueTracker || (t._valueTracker = Ua$1(t));
}
o(Va$1, "Va");
function Wa$1(t) {
  if (!t) return !1;
  var e = t._valueTracker;
  if (!e) return !0;
  var n = e.getValue(),
    r = "";
  return t && (r = Ta$1(t) ? t.checked ? "true" : "false" : t.value), t = r, t !== n ? (e.setValue(t), !0) : !1;
}
o(Wa$1, "Wa");
function Xa$1(t) {
  if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u") return null;
  try {
    return t.activeElement || t.body;
  } catch {
    return t.body;
  }
}
o(Xa$1, "Xa");
function Ya$1(t, e) {
  var n = e.checked;
  return ze({}, e, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: n ?? t._wrapperState.initialChecked
  });
}
o(Ya$1, "Ya");
function Za$1(t, e) {
  var n = e.defaultValue == null ? "" : e.defaultValue,
    r = e.checked != null ? e.checked : e.defaultChecked;
  n = Sa$1(e.value != null ? e.value : n), t._wrapperState = {
    initialChecked: r,
    initialValue: n,
    controlled: e.type === "checkbox" || e.type === "radio" ? e.checked != null : e.value != null
  };
}
o(Za$1, "Za");
function $a$1(t, e) {
  e = e.checked, e != null && qa$1(t, "checked", e, !1);
}
o($a$1, "$a");
function ab$1(t, e) {
  $a$1(t, e);
  var n = Sa$1(e.value),
    r = e.type;
  if (n != null) r === "number" ? (n === 0 && t.value === "" || t.value != n) && (t.value = "" + n) : t.value !== "" + n && (t.value = "" + n);else if (r === "submit" || r === "reset") {
    t.removeAttribute("value");
    return;
  }
  e.hasOwnProperty("value") ? bb$1(t, e.type, n) : e.hasOwnProperty("defaultValue") && bb$1(t, e.type, Sa$1(e.defaultValue)), e.checked == null && e.defaultChecked != null && (t.defaultChecked = !!e.defaultChecked);
}
o(ab$1, "ab");
function cb$1(t, e, n) {
  if (e.hasOwnProperty("value") || e.hasOwnProperty("defaultValue")) {
    var r = e.type;
    if (!(r !== "submit" && r !== "reset" || e.value !== void 0 && e.value !== null)) return;
    e = "" + t._wrapperState.initialValue, n || e === t.value || (t.value = e), t.defaultValue = e;
  }
  n = t.name, n !== "" && (t.name = ""), t.defaultChecked = !!t._wrapperState.initialChecked, n !== "" && (t.name = n);
}
o(cb$1, "cb");
function bb$1(t, e, n) {
  (e !== "number" || Xa$1(t.ownerDocument) !== t) && (n == null ? t.defaultValue = "" + t._wrapperState.initialValue : t.defaultValue !== "" + n && (t.defaultValue = "" + n));
}
o(bb$1, "bb");
function db$1(t) {
  var e = "";
  return Tl.Children.forEach(t, function (n) {
    n != null && (e += n);
  }), e;
}
o(db$1, "db");
function eb$1(t, e) {
  return t = ze({
    children: void 0
  }, e), (e = db$1(e.children)) && (t.children = e), t;
}
o(eb$1, "eb");
function fb$1(t, e, n, r) {
  if (t = t.options, e) {
    e = {};
    for (var i = 0; i < n.length; i++) e["$" + n[i]] = !0;
    for (n = 0; n < t.length; n++) i = e.hasOwnProperty("$" + t[n].value), t[n].selected !== i && (t[n].selected = i), i && r && (t[n].defaultSelected = !0);
  } else {
    for (n = "" + Sa$1(n), e = null, i = 0; i < t.length; i++) {
      if (t[i].value === n) {
        t[i].selected = !0, r && (t[i].defaultSelected = !0);
        return;
      }
      e !== null || t[i].disabled || (e = t[i]);
    }
    e !== null && (e.selected = !0);
  }
}
o(fb$1, "fb");
function gb$1(t, e) {
  if (e.dangerouslySetInnerHTML != null) throw Error(y$1(91));
  return ze({}, e, {
    value: void 0,
    defaultValue: void 0,
    children: "" + t._wrapperState.initialValue
  });
}
o(gb$1, "gb");
function hb$1(t, e) {
  var n = e.value;
  if (n == null) {
    if (n = e.children, e = e.defaultValue, n != null) {
      if (e != null) throw Error(y$1(92));
      if (Array.isArray(n)) {
        if (!(1 >= n.length)) throw Error(y$1(93));
        n = n[0];
      }
      e = n;
    }
    e == null && (e = ""), n = e;
  }
  t._wrapperState = {
    initialValue: Sa$1(n)
  };
}
o(hb$1, "hb");
function ib$1(t, e) {
  var n = Sa$1(e.value),
    r = Sa$1(e.defaultValue);
  n != null && (n = "" + n, n !== t.value && (t.value = n), e.defaultValue == null && t.defaultValue !== n && (t.defaultValue = n)), r != null && (t.defaultValue = "" + r);
}
o(ib$1, "ib");
function jb(t) {
  var e = t.textContent;
  e === t._wrapperState.initialValue && e !== "" && e !== null && (t.value = e);
}
o(jb, "jb");
var zc = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg"
};
function lb$1(t) {
  switch (t) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
o(lb$1, "lb");
function mb$1(t, e) {
  return t == null || t === "http://www.w3.org/1999/xhtml" ? lb$1(e) : t === "http://www.w3.org/2000/svg" && e === "foreignObject" ? "http://www.w3.org/1999/xhtml" : t;
}
o(mb$1, "mb");
var zo,
  Fv = function (t) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function (e, n, r, i) {
      MSApp.execUnsafeLocalFunction(function () {
        return t(e, n, r, i);
      });
    } : t;
  }(function (t, e) {
    if (t.namespaceURI !== zc.svg || "innerHTML" in t) t.innerHTML = e;else {
      for (zo = zo || document.createElement("div"), zo.innerHTML = "<svg>" + e.valueOf().toString() + "</svg>", e = zo.firstChild; t.firstChild;) t.removeChild(t.firstChild);
      for (; e.firstChild;) t.appendChild(e.firstChild);
    }
  });
function pb$1(t, e) {
  if (e) {
    var n = t.firstChild;
    if (n && n === t.lastChild && n.nodeType === 3) {
      n.nodeValue = e;
      return;
    }
  }
  t.textContent = e;
}
o(pb$1, "pb");
var As = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
  JE = ["Webkit", "ms", "Moz", "O"];
Object.keys(As).forEach(function (t) {
  JE.forEach(function (e) {
    e = e + t.charAt(0).toUpperCase() + t.substring(1), As[e] = As[t];
  });
});
function sb$1(t, e, n) {
  return e == null || typeof e == "boolean" || e === "" ? "" : n || typeof e != "number" || e === 0 || As.hasOwnProperty(t) && As[t] ? ("" + e).trim() : e + "px";
}
o(sb$1, "sb");
function tb$1(t, e) {
  t = t.style;
  for (var n in e) if (e.hasOwnProperty(n)) {
    var r = n.indexOf("--") === 0,
      i = sb$1(n, e[n], r);
    n === "float" && (n = "cssFloat"), r ? t.setProperty(n, i) : t[n] = i;
  }
}
o(tb$1, "tb");
var ZE = ze({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});
function vb$1(t, e) {
  if (e) {
    if (ZE[t] && (e.children != null || e.dangerouslySetInnerHTML != null)) throw Error(y$1(137, t));
    if (e.dangerouslySetInnerHTML != null) {
      if (e.children != null) throw Error(y$1(60));
      if (!(typeof e.dangerouslySetInnerHTML == "object" && "__html" in e.dangerouslySetInnerHTML)) throw Error(y$1(61));
    }
    if (e.style != null && typeof e.style != "object") throw Error(y$1(62));
  }
}
o(vb$1, "vb");
function wb$1(t, e) {
  if (t.indexOf("-") === -1) return typeof e.is == "string";
  switch (t) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
o(wb$1, "wb");
function xb$1(t) {
  return t = t.target || t.srcElement || window, t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
}
o(xb$1, "xb");
var Vc = null,
  ui = null,
  ci = null;
function Bb$1(t) {
  if (t = Cb$1(t)) {
    if (typeof Vc != "function") throw Error(y$1(280));
    var e = t.stateNode;
    e && (e = Db$1(e), Vc(t.stateNode, t.type, e));
  }
}
o(Bb$1, "Bb");
function Eb$1(t) {
  ui ? ci ? ci.push(t) : ci = [t] : ui = t;
}
o(Eb$1, "Eb");
function Fb() {
  if (ui) {
    var t = ui,
      e = ci;
    if (ci = ui = null, Bb$1(t), e) for (t = 0; t < e.length; t++) Bb$1(e[t]);
  }
}
o(Fb, "Fb");
function Gb$1(t, e) {
  return t(e);
}
o(Gb$1, "Gb");
function Hb$1(t, e, n, r, i) {
  return t(e, n, r, i);
}
o(Hb$1, "Hb");
function Ib$1() {}
o(Ib$1, "Ib");
var qv = Gb$1,
  Er = !1,
  Vu = !1;
function Mb$1() {
  (ui !== null || ci !== null) && (Ib$1(), Fb());
}
o(Mb$1, "Mb");
function Nb(t, e, n) {
  if (Vu) return t(e, n);
  Vu = !0;
  try {
    return qv(t, e, n);
  } finally {
    Vu = !1, Mb$1();
  }
}
o(Nb, "Nb");
function Ob$1(t, e) {
  var n = t.stateNode;
  if (n === null) return null;
  var r = Db$1(n);
  if (r === null) return null;
  n = r[e];
  e: switch (e) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) || (t = t.type, r = !(t === "button" || t === "input" || t === "select" || t === "textarea")), t = !r;
      break e;
    default:
      t = !1;
  }
  if (t) return null;
  if (n && typeof n != "function") throw Error(y$1(231, e, typeof n));
  return n;
}
o(Ob$1, "Ob");
var Wc = !1;
if (In) try {
  var ns = {};
  Object.defineProperty(ns, "passive", {
    get: function () {
      Wc = !0;
    }
  }), window.addEventListener("test", ns, ns), window.removeEventListener("test", ns, ns);
} catch {
  Wc = !1;
}
function Rb$1(t, e, n, r, i, s, a, l, u) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    e.apply(n, c);
  } catch (p) {
    this.onError(p);
  }
}
o(Rb$1, "Rb");
var Ls = !1,
  Pa = null,
  Ca = !1,
  Gc = null,
  nT = {
    onError: function (t) {
      Ls = !0, Pa = t;
    }
  };
function Xb$1(t, e, n, r, i, s, a, l, u) {
  Ls = !1, Pa = null, Rb$1.apply(nT, arguments);
}
o(Xb$1, "Xb");
function Yb$1(t, e, n, r, i, s, a, l, u) {
  if (Xb$1.apply(this, arguments), Ls) {
    if (Ls) {
      var c = Pa;
      Ls = !1, Pa = null;
    } else throw Error(y$1(198));
    Ca || (Ca = !0, Gc = c);
  }
}
o(Yb$1, "Yb");
function Zb$1(t) {
  var e = t,
    n = t;
  if (t.alternate) for (; e.return;) e = e.return;else {
    t = e;
    do e = t, e.flags & 1026 && (n = e.return), t = e.return; while (t);
  }
  return e.tag === 3 ? n : null;
}
o(Zb$1, "Zb");
function $b(t) {
  if (t.tag === 13) {
    var e = t.memoizedState;
    if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
  }
  return null;
}
o($b, "$b");
function ac$1(t) {
  if (Zb$1(t) !== t) throw Error(y$1(188));
}
o(ac$1, "ac");
function bc$1(t) {
  var e = t.alternate;
  if (!e) {
    if (e = Zb$1(t), e === null) throw Error(y$1(188));
    return e !== t ? null : t;
  }
  for (var n = t, r = e;;) {
    var i = n.return;
    if (i === null) break;
    var s = i.alternate;
    if (s === null) {
      if (r = i.return, r !== null) {
        n = r;
        continue;
      }
      break;
    }
    if (i.child === s.child) {
      for (s = i.child; s;) {
        if (s === n) return ac$1(i), t;
        if (s === r) return ac$1(i), e;
        s = s.sibling;
      }
      throw Error(y$1(188));
    }
    if (n.return !== r.return) n = i, r = s;else {
      for (var a = !1, l = i.child; l;) {
        if (l === n) {
          a = !0, n = i, r = s;
          break;
        }
        if (l === r) {
          a = !0, r = i, n = s;
          break;
        }
        l = l.sibling;
      }
      if (!a) {
        for (l = s.child; l;) {
          if (l === n) {
            a = !0, n = s, r = i;
            break;
          }
          if (l === r) {
            a = !0, r = s, n = i;
            break;
          }
          l = l.sibling;
        }
        if (!a) throw Error(y$1(189));
      }
    }
    if (n.alternate !== r) throw Error(y$1(190));
  }
  if (n.tag !== 3) throw Error(y$1(188));
  return n.stateNode.current === n ? t : e;
}
o(bc$1, "bc");
function cc$1(t) {
  if (t = bc$1(t), !t) return null;
  for (var e = t;;) {
    if (e.tag === 5 || e.tag === 6) return e;
    if (e.child) e.child.return = e, e = e.child;else {
      if (e === t) break;
      for (; !e.sibling;) {
        if (!e.return || e.return === t) return null;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
  }
  return null;
}
o(cc$1, "cc");
function dc$1(t, e) {
  for (var n = t.alternate; e !== null;) {
    if (e === t || e === n) return !0;
    e = e.return;
  }
  return !1;
}
o(dc$1, "dc");
var Gv,
  bd,
  Xv,
  Yv,
  Xc = !1,
  vn = [],
  Qn = null,
  Jn = null,
  Zn = null,
  Xs = new Map(),
  Ys = new Map(),
  rs = [],
  tm = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc$1(t, e, n, r, i) {
  return {
    blockedOn: t,
    domEventName: e,
    eventSystemFlags: n | 16,
    nativeEvent: i,
    targetContainers: [r]
  };
}
o(rc$1, "rc");
function sc$1(t, e) {
  switch (t) {
    case "focusin":
    case "focusout":
      Qn = null;
      break;
    case "dragenter":
    case "dragleave":
      Jn = null;
      break;
    case "mouseover":
    case "mouseout":
      Zn = null;
      break;
    case "pointerover":
    case "pointerout":
      Xs.delete(e.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Ys.delete(e.pointerId);
  }
}
o(sc$1, "sc");
function tc$1(t, e, n, r, i, s) {
  return t === null || t.nativeEvent !== s ? (t = rc$1(e, n, r, i, s), e !== null && (e = Cb$1(e), e !== null && bd(e)), t) : (t.eventSystemFlags |= r, e = t.targetContainers, i !== null && e.indexOf(i) === -1 && e.push(i), t);
}
o(tc$1, "tc");
function uc$1(t, e, n, r, i) {
  switch (e) {
    case "focusin":
      return Qn = tc$1(Qn, t, e, n, r, i), !0;
    case "dragenter":
      return Jn = tc$1(Jn, t, e, n, r, i), !0;
    case "mouseover":
      return Zn = tc$1(Zn, t, e, n, r, i), !0;
    case "pointerover":
      var s = i.pointerId;
      return Xs.set(s, tc$1(Xs.get(s) || null, t, e, n, r, i)), !0;
    case "gotpointercapture":
      return s = i.pointerId, Ys.set(s, tc$1(Ys.get(s) || null, t, e, n, r, i)), !0;
  }
  return !1;
}
o(uc$1, "uc");
function vc$1(t) {
  var e = wc$1(t.target);
  if (e !== null) {
    var n = Zb$1(e);
    if (n !== null) {
      if (e = n.tag, e === 13) {
        if (e = $b(n), e !== null) {
          t.blockedOn = e, Yv(t.lanePriority, function () {
            lt.unstable_runWithPriority(t.priority, function () {
              Xv(n);
            });
          });
          return;
        }
      } else if (e === 3 && n.stateNode.hydrate) {
        t.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  t.blockedOn = null;
}
o(vc$1, "vc");
function xc$1(t) {
  if (t.blockedOn !== null) return !1;
  for (var e = t.targetContainers; 0 < e.length;) {
    var n = yc$1(t.domEventName, t.eventSystemFlags, e[0], t.nativeEvent);
    if (n !== null) return e = Cb$1(n), e !== null && bd(e), t.blockedOn = n, !1;
    e.shift();
  }
  return !0;
}
o(xc$1, "xc");
function zc$1(t, e, n) {
  xc$1(t) && n.delete(e);
}
o(zc$1, "zc");
function Ac() {
  for (Xc = !1; 0 < vn.length;) {
    var t = vn[0];
    if (t.blockedOn !== null) {
      t = Cb$1(t.blockedOn), t !== null && Gv(t);
      break;
    }
    for (var e = t.targetContainers; 0 < e.length;) {
      var n = yc$1(t.domEventName, t.eventSystemFlags, e[0], t.nativeEvent);
      if (n !== null) {
        t.blockedOn = n;
        break;
      }
      e.shift();
    }
    t.blockedOn === null && vn.shift();
  }
  Qn !== null && xc$1(Qn) && (Qn = null), Jn !== null && xc$1(Jn) && (Jn = null), Zn !== null && xc$1(Zn) && (Zn = null), Xs.forEach(zc$1), Ys.forEach(zc$1);
}
o(Ac, "Ac");
function Bc(t, e) {
  t.blockedOn === e && (t.blockedOn = null, Xc || (Xc = !0, lt.unstable_scheduleCallback(lt.unstable_NormalPriority, Ac)));
}
o(Bc, "Bc");
function Cc$1(t) {
  function b(i) {
    return Bc(i, t);
  }
  if (o(b, "b"), 0 < vn.length) {
    Bc(vn[0], t);
    for (var n = 1; n < vn.length; n++) {
      var r = vn[n];
      r.blockedOn === t && (r.blockedOn = null);
    }
  }
  for (Qn !== null && Bc(Qn, t), Jn !== null && Bc(Jn, t), Zn !== null && Bc(Zn, t), Xs.forEach(b), Ys.forEach(b), n = 0; n < rs.length; n++) r = rs[n], r.blockedOn === t && (r.blockedOn = null);
  for (; 0 < rs.length && (n = rs[0], n.blockedOn === null);) vc$1(n), n.blockedOn === null && rs.shift();
}
o(Cc$1, "Cc");
function Dc(t, e) {
  var n = {};
  return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit" + t] = "webkit" + e, n["Moz" + t] = "moz" + e, n;
}
o(Dc, "Dc");
var Zr = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
  },
  Wu = {},
  Qv = {};
In && (Qv = document.createElement("div").style, "AnimationEvent" in window || (delete Zr.animationend.animation, delete Zr.animationiteration.animation, delete Zr.animationstart.animation), "TransitionEvent" in window || delete Zr.transitionend.transition);
function Hc(t) {
  if (Wu[t]) return Wu[t];
  if (!Zr[t]) return t;
  var e = Zr[t],
    n;
  for (n in e) if (e.hasOwnProperty(n) && n in Qv) return Wu[t] = e[n];
  return t;
}
o(Hc, "Hc");
var Jv = Hc("animationend"),
  Zv = Hc("animationiteration"),
  e0 = Hc("animationstart"),
  t0 = Hc("transitionend"),
  n0 = new Map(),
  Sd = new Map(),
  uT = ["abort", "abort", Jv, "animationEnd", Zv, "animationIteration", e0, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", t0, "transitionEnd", "waiting", "waiting"];
function Pc$1(t, e) {
  for (var n = 0; n < t.length; n += 2) {
    var r = t[n],
      i = t[n + 1];
    i = "on" + (i[0].toUpperCase() + i.slice(1)), Sd.set(r, e), n0.set(r, i), da$1(i, [r]);
  }
}
o(Pc$1, "Pc");
var cT = lt.unstable_now;
cT();
var Ne = 8;
function Rc$1(t) {
  if (1 & t) return Ne = 15, 1;
  if (2 & t) return Ne = 14, 2;
  if (4 & t) return Ne = 13, 4;
  var e = 24 & t;
  return e !== 0 ? (Ne = 12, e) : t & 32 ? (Ne = 11, 32) : (e = 192 & t, e !== 0 ? (Ne = 10, e) : t & 256 ? (Ne = 9, 256) : (e = 3584 & t, e !== 0 ? (Ne = 8, e) : t & 4096 ? (Ne = 7, 4096) : (e = 4186112 & t, e !== 0 ? (Ne = 6, e) : (e = 62914560 & t, e !== 0 ? (Ne = 5, e) : t & 67108864 ? (Ne = 4, 67108864) : t & 134217728 ? (Ne = 3, 134217728) : (e = 805306368 & t, e !== 0 ? (Ne = 2, e) : 1073741824 & t ? (Ne = 1, 1073741824) : (Ne = 8, t))))));
}
o(Rc$1, "Rc");
function Sc$1(t) {
  switch (t) {
    case 99:
      return 15;
    case 98:
      return 10;
    case 97:
    case 96:
      return 8;
    case 95:
      return 2;
    default:
      return 0;
  }
}
o(Sc$1, "Sc");
function Tc$1(t) {
  switch (t) {
    case 15:
    case 14:
      return 99;
    case 13:
    case 12:
    case 11:
    case 10:
      return 98;
    case 9:
    case 8:
    case 7:
    case 6:
    case 4:
    case 5:
      return 97;
    case 3:
    case 2:
    case 1:
      return 95;
    case 0:
      return 90;
    default:
      throw Error(y$1(358, t));
  }
}
o(Tc$1, "Tc");
function Uc(t, e) {
  var n = t.pendingLanes;
  if (n === 0) return Ne = 0;
  var r = 0,
    i = 0,
    s = t.expiredLanes,
    a = t.suspendedLanes,
    l = t.pingedLanes;
  if (s !== 0) r = s, i = Ne = 15;else if (s = n & 134217727, s !== 0) {
    var u = s & ~a;
    u !== 0 ? (r = Rc$1(u), i = Ne) : (l &= s, l !== 0 && (r = Rc$1(l), i = Ne));
  } else s = n & ~a, s !== 0 ? (r = Rc$1(s), i = Ne) : l !== 0 && (r = Rc$1(l), i = Ne);
  if (r === 0) return 0;
  if (r = 31 - or(r), r = n & ((0 > r ? 0 : 1 << r) << 1) - 1, e !== 0 && e !== r && !(e & a)) {
    if (Rc$1(e), i <= Ne) return e;
    Ne = i;
  }
  if (e = t.entangledLanes, e !== 0) for (t = t.entanglements, e &= r; 0 < e;) n = 31 - or(e), i = 1 << n, r |= t[n], e &= ~i;
  return r;
}
o(Uc, "Uc");
function Wc$1(t) {
  return t = t.pendingLanes & -1073741825, t !== 0 ? t : t & 1073741824 ? 1073741824 : 0;
}
o(Wc$1, "Wc");
function Xc$1(t, e) {
  switch (t) {
    case 15:
      return 1;
    case 14:
      return 2;
    case 12:
      return t = Yc(24 & ~e), t === 0 ? Xc$1(10, e) : t;
    case 10:
      return t = Yc(192 & ~e), t === 0 ? Xc$1(8, e) : t;
    case 8:
      return t = Yc(3584 & ~e), t === 0 && (t = Yc(4186112 & ~e), t === 0 && (t = 512)), t;
    case 2:
      return e = Yc(805306368 & ~e), e === 0 && (e = 268435456), e;
  }
  throw Error(y$1(358, t));
}
o(Xc$1, "Xc");
function Yc(t) {
  return t & -t;
}
o(Yc, "Yc");
function Zc$1(t) {
  for (var e = [], n = 0; 31 > n; n++) e.push(t);
  return e;
}
o(Zc$1, "Zc");
function $c(t, e, n) {
  t.pendingLanes |= e;
  var r = e - 1;
  t.suspendedLanes &= r, t.pingedLanes &= r, t = t.eventTimes, e = 31 - or(e), t[e] = n;
}
o($c, "$c");
var or = Math.clz32 ? Math.clz32 : ad,
  pT = Math.log,
  hT = Math.LN2;
function ad(t) {
  return t === 0 ? 32 : 31 - (pT(t) / hT | 0) | 0;
}
o(ad, "ad");
var gT = lt.unstable_UserBlockingPriority,
  yT = lt.unstable_runWithPriority,
  ra = !0;
function gd(t, e, n, r) {
  Er || Ib$1();
  var i = hd$1,
    s = Er;
  Er = !0;
  try {
    Hb$1(i, t, e, n, r);
  } finally {
    (Er = s) || Mb$1();
  }
}
o(gd, "gd");
function id$1(t, e, n, r) {
  yT(gT, hd$1.bind(null, t, e, n, r));
}
o(id$1, "id");
function hd$1(t, e, n, r) {
  if (ra) {
    var i;
    if ((i = (e & 4) === 0) && 0 < vn.length && -1 < tm.indexOf(t)) t = rc$1(null, t, e, n, r), vn.push(t);else {
      var s = yc$1(t, e, n, r);
      if (s === null) i && sc$1(t, r);else {
        if (i) {
          if (-1 < tm.indexOf(t)) {
            t = rc$1(s, t, e, n, r), vn.push(t);
            return;
          }
          if (uc$1(s, t, e, n, r)) return;
          sc$1(t, r);
        }
        jd$1(t, e, r, null, n);
      }
    }
  }
}
o(hd$1, "hd");
function yc$1(t, e, n, r) {
  var i = xb$1(r);
  if (i = wc$1(i), i !== null) {
    var s = Zb$1(i);
    if (s === null) i = null;else {
      var a = s.tag;
      if (a === 13) {
        if (i = $b(s), i !== null) return i;
        i = null;
      } else if (a === 3) {
        if (s.stateNode.hydrate) return s.tag === 3 ? s.stateNode.containerInfo : null;
        i = null;
      } else s !== i && (i = null);
    }
  }
  return jd$1(t, e, r, i, n), null;
}
o(yc$1, "yc");
var Vn = null,
  Cd = null,
  ia = null;
function nd() {
  if (ia) return ia;
  var t,
    e = Cd,
    n = e.length,
    r,
    i = "value" in Vn ? Vn.value : Vn.textContent,
    s = i.length;
  for (t = 0; t < n && e[t] === i[t]; t++);
  var a = n - t;
  for (r = 1; r <= a && e[n - r] === i[s - r]; r++);
  return ia = i.slice(t, 1 < r ? 1 - r : void 0);
}
o(nd, "nd");
function od$1(t) {
  var e = t.keyCode;
  return "charCode" in t ? (t = t.charCode, t === 0 && e === 13 && (t = 13)) : t = e, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
}
o(od$1, "od");
function pd$1() {
  return !0;
}
o(pd$1, "pd");
function qd$1() {
  return !1;
}
o(qd$1, "qd");
function rd$1(t) {
  function b$1(n, r, i, s, a) {
    this._reactName = n, this._targetInst = i, this.type = r, this.nativeEvent = s, this.target = a, this.currentTarget = null;
    for (var l in t) t.hasOwnProperty(l) && (n = t[l], this[l] = n ? n(s) : s[l]);
    return this.isDefaultPrevented = (s.defaultPrevented != null ? s.defaultPrevented : s.returnValue === !1) ? pd$1 : qd$1, this.isPropagationStopped = qd$1, this;
  }
  return o(b$1, "b"), ze(b$1.prototype, {
    preventDefault: function () {
      this.defaultPrevented = !0;
      var n = this.nativeEvent;
      n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = pd$1);
    },
    stopPropagation: function () {
      var n = this.nativeEvent;
      n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = pd$1);
    },
    persist: function () {},
    isPersistent: pd$1
  }), b$1;
}
o(rd$1, "rd");
var Ii = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (t) {
      return t.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  },
  xd = rd$1(Ii),
  Po = ze({}, Ii, {
    view: 0,
    detail: 0
  }),
  bT = rd$1(Po),
  Xu,
  Yu,
  os,
  _l = ze({}, Po, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd$1,
    button: 0,
    buttons: 0,
    relatedTarget: function (t) {
      return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
    },
    movementX: function (t) {
      return "movementX" in t ? t.movementX : (t !== os && (os && t.type === "mousemove" ? (Xu = t.screenX - os.screenX, Yu = t.screenY - os.screenY) : Yu = Xu = 0, os = t), Xu);
    },
    movementY: function (t) {
      return "movementY" in t ? t.movementY : Yu;
    }
  }),
  sm = rd$1(_l),
  ST = ze({}, _l, {
    dataTransfer: 0
  }),
  ET = rd$1(ST),
  TT = ze({}, Po, {
    relatedTarget: 0
  }),
  Ku = rd$1(TT),
  PT = ze({}, Ii, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }),
  CT = rd$1(PT),
  xT = ze({}, Ii, {
    clipboardData: function (t) {
      return "clipboardData" in t ? t.clipboardData : window.clipboardData;
    }
  }),
  kT = rd$1(xT),
  _T = ze({}, Ii, {
    data: 0
  }),
  om = rd$1(_T),
  OT = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
  AT = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
  LT = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
function Pd(t) {
  var e = this.nativeEvent;
  return e.getModifierState ? e.getModifierState(t) : (t = LT[t]) ? !!e[t] : !1;
}
o(Pd, "Pd");
function zd$1() {
  return Pd;
}
o(zd$1, "zd");
var DT = ze({}, Po, {
    key: function (t) {
      if (t.key) {
        var e = OT[t.key] || t.key;
        if (e !== "Unidentified") return e;
      }
      return t.type === "keypress" ? (t = od$1(t), t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? AT[t.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd$1,
    charCode: function (t) {
      return t.type === "keypress" ? od$1(t) : 0;
    },
    keyCode: function (t) {
      return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    },
    which: function (t) {
      return t.type === "keypress" ? od$1(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    }
  }),
  IT = rd$1(DT),
  RT = ze({}, _l, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }),
  am = rd$1(RT),
  NT = ze({}, Po, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd$1
  }),
  $T = rd$1(NT),
  FT = ze({}, Ii, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }),
  jT = rd$1(FT),
  BT = ze({}, _l, {
    deltaX: function (t) {
      return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
    },
    deltaY: function (t) {
      return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }),
  zT = rd$1(BT),
  HT = [9, 13, 27, 32],
  _d = In && "CompositionEvent" in window,
  Ms = null;
In && "documentMode" in document && (Ms = document.documentMode);
var UT = In && "TextEvent" in window && !Ms,
  s0 = In && (!_d || Ms && 8 < Ms && 11 >= Ms),
  lm = String.fromCharCode(32),
  um = !1;
function ge(t, e) {
  switch (t) {
    case "keyup":
      return HT.indexOf(e.keyCode) !== -1;
    case "keydown":
      return e.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
o(ge, "ge");
function he$1(t) {
  return t = t.detail, typeof t == "object" && "data" in t ? t.data : null;
}
o(he$1, "he");
var ei = !1;
function je$1(t, e) {
  switch (t) {
    case "compositionend":
      return he$1(e);
    case "keypress":
      return e.which !== 32 ? null : (um = !0, lm);
    case "textInput":
      return t = e.data, t === lm && um ? null : t;
    default:
      return null;
  }
}
o(je$1, "je");
function ke(t, e) {
  if (ei) return t === "compositionend" || !_d && ge(t, e) ? (t = nd(), ia = Cd = Vn = null, ei = !1, t) : null;
  switch (t) {
    case "paste":
      return null;
    case "keypress":
      if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
        if (e.char && 1 < e.char.length) return e.char;
        if (e.which) return String.fromCharCode(e.which);
      }
      return null;
    case "compositionend":
      return s0 && e.locale !== "ko" ? null : e.data;
    default:
      return null;
  }
}
o(ke, "ke");
var WT = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0
};
function me$1(t) {
  var e = t && t.nodeName && t.nodeName.toLowerCase();
  return e === "input" ? !!WT[t.type] : e === "textarea";
}
o(me$1, "me");
function ne$1(t, onChange, n, r) {
  Eb$1(r), onChange = oe$1(onChange, "onChange"), 0 < onChange.length && (n = new xd("onChange", "change", null, n, r), t.push({
    event: n,
    listeners: onChange
  }));
}
o(ne$1, "ne");
var Ds = null,
  Qs = null;
function re(t) {
  se(t, 0);
}
o(re, "re");
function te(t) {
  var e = ue(t);
  if (Wa$1(e)) return t;
}
o(te, "te");
function ve(t, e) {
  if (t === "change") return e;
}
o(ve, "ve");
var u0 = !1;
if (In) {
  var Qu;
  if (In) {
    var Ju = "oninput" in document;
    if (!Ju) {
      var fm = document.createElement("div");
      fm.setAttribute("oninput", "return;"), Ju = typeof fm.oninput == "function";
    }
    Qu = Ju;
  } else Qu = !1;
  u0 = Qu && (!document.documentMode || 9 < document.documentMode);
}
function Ae$1() {
  Ds && (Ds.detachEvent("onpropertychange", Be), Qs = Ds = null);
}
o(Ae$1, "Ae");
function Be(t) {
  if (t.propertyName === "value" && te(Qs)) {
    var e = [];
    if (ne$1(e, Qs, t, xb$1(t)), t = re, Er) t(e);else {
      Er = !0;
      try {
        Gb$1(t, e);
      } finally {
        Er = !1, Mb$1();
      }
    }
  }
}
o(Be, "Be");
function Ce$1(t, e, n) {
  t === "focusin" ? (Ae$1(), Ds = e, Qs = n, Ds.attachEvent("onpropertychange", Be)) : t === "focusout" && Ae$1();
}
o(Ce$1, "Ce");
function De(t) {
  if (t === "selectionchange" || t === "keyup" || t === "keydown") return te(Qs);
}
o(De, "De");
function Ee$1(t, e) {
  if (t === "click") return te(e);
}
o(Ee$1, "Ee");
function Fe$1(t, e) {
  if (t === "input" || t === "change") return te(e);
}
o(Fe$1, "Fe");
function Ge$1(t, e) {
  return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
}
o(Ge$1, "Ge");
var Kt = typeof Object.is == "function" ? Object.is : Ge$1,
  eP = Object.prototype.hasOwnProperty;
function Je$1(t, e) {
  if (Kt(t, e)) return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null) return !1;
  var n = Object.keys(t),
    r = Object.keys(e);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) if (!eP.call(e, n[r]) || !Kt(t[n[r]], e[n[r]])) return !1;
  return !0;
}
o(Je$1, "Je");
function Ke(t) {
  for (; t && t.firstChild;) t = t.firstChild;
  return t;
}
o(Ke, "Ke");
function Le$1(t, e) {
  var n = Ke(t);
  t = 0;
  for (var r; n;) {
    if (n.nodeType === 3) {
      if (r = t + n.textContent.length, t <= e && r >= e) return {
        node: n,
        offset: e - t
      };
      t = r;
    }
    e: {
      for (; n;) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = Ke(n);
  }
}
o(Le$1, "Le");
function Me(t, e) {
  return t && e ? t === e ? !0 : t && t.nodeType === 3 ? !1 : e && e.nodeType === 3 ? Me(t, e.parentNode) : "contains" in t ? t.contains(e) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(e) & 16) : !1 : !1;
}
o(Me, "Me");
function Ne$1() {
  for (var t = window, e = Xa$1(); e instanceof t.HTMLIFrameElement;) {
    try {
      var n = typeof e.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n) t = e.contentWindow;else break;
    e = Xa$1(t.document);
  }
  return e;
}
o(Ne$1, "Ne");
function Oe(t) {
  var e = t && t.nodeName && t.nodeName.toLowerCase();
  return e && (e === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || e === "textarea" || t.contentEditable === "true");
}
o(Oe, "Oe");
var tP = In && "documentMode" in document && 11 >= document.documentMode,
  ti = null,
  onSelect = null,
  Is = null,
  Jc = !1;
function Ue(t, e, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  Jc || ti == null || ti !== Xa$1(r) || (r = ti, "selectionStart" in r && Oe(r) ? r = {
    start: r.selectionStart,
    end: r.selectionEnd
  } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
    anchorNode: r.anchorNode,
    anchorOffset: r.anchorOffset,
    focusNode: r.focusNode,
    focusOffset: r.focusOffset
  }), Is && Je$1(Is, r) || (Is = r, r = oe$1(onSelect, "onSelect"), 0 < r.length && (e = new xd("onSelect", "select", null, e, n), t.push({
    event: e,
    listeners: r
  }), e.target = ti)));
}
o(Ue, "Ue");
Pc$1("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc$1("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc$1(uT, 2);
for (var ym = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Zu = 0; Zu < ym.length; Zu++) Sd.set(ym[Zu], 0);
ea("onMouseEnter", ["mouseout", "mouseover"]);
ea("onMouseLeave", ["mouseout", "mouseover"]);
ea("onPointerEnter", ["pointerout", "pointerover"]);
ea("onPointerLeave", ["pointerout", "pointerover"]);
da$1("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da$1("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da$1("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
da$1("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da$1("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da$1("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Es = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
  d0 = new Set("cancel close invalid load scroll toggle".split(" ").concat(Es));
function Ze$1(t, e, n) {
  var r = t.type || "unknown-event";
  t.currentTarget = n, Yb$1(r, e, void 0, t), t.currentTarget = null;
}
o(Ze$1, "Ze");
function se(t, e) {
  e = (e & 4) !== 0;
  for (var n = 0; n < t.length; n++) {
    var r = t[n],
      i = r.event;
    r = r.listeners;
    e: {
      var s = void 0;
      if (e) for (var a = r.length - 1; 0 <= a; a--) {
        var l = r[a],
          u = l.instance,
          c = l.currentTarget;
        if (l = l.listener, u !== s && i.isPropagationStopped()) break e;
        Ze$1(i, l, c), s = u;
      } else for (a = 0; a < r.length; a++) {
        if (l = r[a], u = l.instance, c = l.currentTarget, l = l.listener, u !== s && i.isPropagationStopped()) break e;
        Ze$1(i, l, c), s = u;
      }
    }
  }
  if (Ca) throw t = Gc, Ca = !1, Gc = null, t;
}
o(se, "se");
function G(t, e) {
  var n = $e$1(e),
    r = t + "__bubble";
  n.has(r) || (af$1(e, t, 2, !1), n.add(r));
}
o(G, "G");
var wm = "_reactListening" + Math.random().toString(36).slice(2);
function cf$1(t) {
  t[wm] || (t[wm] = !0, Lv.forEach(function (e) {
    d0.has(e) || df$1(e, !1, t, null), df$1(e, !0, t, null);
  }));
}
o(cf$1, "cf");
function df$1(t, e, n, r) {
  var i = 4 < arguments.length && arguments[4] !== void 0 ? arguments[4] : 0,
    s = n;
  if (t === "selectionchange" && n.nodeType !== 9 && (s = n.ownerDocument), r !== null && !e && d0.has(t)) {
    if (t !== "scroll") return;
    i |= 2, s = r;
  }
  var a = $e$1(s),
    l = t + "__" + (e ? "capture" : "bubble");
  a.has(l) || (e && (i |= 4), af$1(s, t, i, e), a.add(l));
}
o(df$1, "df");
function af$1(t, e, n, r) {
  var i = Sd.get(e);
  switch (i === void 0 ? 2 : i) {
    case 0:
      i = gd;
      break;
    case 1:
      i = id$1;
      break;
    default:
      i = hd$1;
  }
  n = i.bind(null, e, n, t), i = void 0, !Wc || e !== "touchstart" && e !== "touchmove" && e !== "wheel" || (i = !0), r ? i !== void 0 ? t.addEventListener(e, n, {
    capture: !0,
    passive: i
  }) : t.addEventListener(e, n, !0) : i !== void 0 ? t.addEventListener(e, n, {
    passive: i
  }) : t.addEventListener(e, n, !1);
}
o(af$1, "af");
function jd$1(t, e, n, r, i) {
  var s = r;
  if (!(e & 1) && !(e & 2) && r !== null) e: for (;;) {
    if (r === null) return;
    var a = r.tag;
    if (a === 3 || a === 4) {
      var l = r.stateNode.containerInfo;
      if (l === i || l.nodeType === 8 && l.parentNode === i) break;
      if (a === 4) for (a = r.return; a !== null;) {
        var u = a.tag;
        if ((u === 3 || u === 4) && (u = a.stateNode.containerInfo, u === i || u.nodeType === 8 && u.parentNode === i)) return;
        a = a.return;
      }
      for (; l !== null;) {
        if (a = wc$1(l), a === null) return;
        if (u = a.tag, u === 5 || u === 6) {
          r = s = a;
          continue e;
        }
        l = l.parentNode;
      }
    }
    r = r.return;
  }
  Nb(function () {
    var onBeforeInput = s,
      p = xb$1(n),
      m = [];
    e: {
      var d = n0.get(t);
      if (d !== void 0) {
        var y = xd,
          S = t;
        switch (t) {
          case "keypress":
            if (od$1(n) === 0) break e;
          case "keydown":
          case "keyup":
            y = IT;
            break;
          case "focusin":
            S = "focus", y = Ku;
            break;
          case "focusout":
            S = "blur", y = Ku;
            break;
          case "beforeblur":
          case "afterblur":
            y = Ku;
            break;
          case "click":
            if (n.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            y = sm;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            y = ET;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            y = $T;
            break;
          case Jv:
          case Zv:
          case e0:
            y = CT;
            break;
          case t0:
            y = jT;
            break;
          case "scroll":
            y = bT;
            break;
          case "wheel":
            y = zT;
            break;
          case "copy":
          case "cut":
          case "paste":
            y = kT;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            y = am;
        }
        var w = (e & 4) !== 0,
          g = !w && t === "scroll",
          h = w ? d !== null ? d + "Capture" : null : d;
        w = [];
        for (var f = onBeforeInput, v; f !== null;) {
          v = f;
          var E = v.stateNode;
          if (v.tag === 5 && E !== null && (v = E, h !== null && (E = Ob$1(f, h), E != null && w.push(ef$1(f, E, v)))), g) break;
          f = f.return;
        }
        0 < w.length && (d = new y(d, S, null, n, p), m.push({
          event: d,
          listeners: w
        }));
      }
    }
    if (!(e & 7)) {
      e: {
        if (d = t === "mouseover" || t === "pointerover", y = t === "mouseout" || t === "pointerout", d && !(e & 16) && (S = n.relatedTarget || n.fromElement) && (wc$1(S) || S[Ri])) break e;
        if ((y || d) && (d = p.window === p ? p : (d = p.ownerDocument) ? d.defaultView || d.parentWindow : window, y ? (S = n.relatedTarget || n.toElement, y = onBeforeInput, S = S ? wc$1(S) : null, S !== null && (g = Zb$1(S), S !== g || S.tag !== 5 && S.tag !== 6) && (S = null)) : (y = null, S = onBeforeInput), y !== S)) {
          if (w = sm, E = "onMouseLeave", h = "onMouseEnter", f = "mouse", (t === "pointerout" || t === "pointerover") && (w = am, E = "onPointerLeave", h = "onPointerEnter", f = "pointer"), g = y == null ? d : ue(y), v = S == null ? d : ue(S), d = new w(E, f + "leave", y, n, p), d.target = g, d.relatedTarget = v, E = null, wc$1(p) === onBeforeInput && (w = new w(h, f + "enter", S, n, p), w.target = v, w.relatedTarget = g, E = w), g = E, y && S) t: {
            for (w = y, h = S, f = 0, v = w; v; v = gf$1(v)) f++;
            for (v = 0, E = h; E; E = gf$1(E)) v++;
            for (; 0 < f - v;) w = gf$1(w), f--;
            for (; 0 < v - f;) h = gf$1(h), v--;
            for (; f--;) {
              if (w === h || h !== null && w === h.alternate) break t;
              w = gf$1(w), h = gf$1(h);
            }
            w = null;
          } else w = null;
          y !== null && hf$1(m, d, y, w, !1), S !== null && g !== null && hf$1(m, g, S, w, !0);
        }
      }
      e: {
        if (d = onBeforeInput ? ue(onBeforeInput) : window, y = d.nodeName && d.nodeName.toLowerCase(), y === "select" || y === "input" && d.type === "file") var b = ve;else if (me$1(d)) {
          if (u0) b = Fe$1;else {
            b = De;
            var P = Ce$1;
          }
        } else (y = d.nodeName) && y.toLowerCase() === "input" && (d.type === "checkbox" || d.type === "radio") && (b = Ee$1);
        if (b && (b = b(t, onBeforeInput))) {
          ne$1(m, b, n, p);
          break e;
        }
        P && P(t, d, onBeforeInput), t === "focusout" && (P = d._wrapperState) && P.controlled && d.type === "number" && bb$1(d, "number", d.value);
      }
      switch (P = onBeforeInput ? ue(onBeforeInput) : window, t) {
        case "focusin":
          (me$1(P) || P.contentEditable === "true") && (ti = P, onSelect = onBeforeInput, Is = null);
          break;
        case "focusout":
          Is = onSelect = ti = null;
          break;
        case "mousedown":
          Jc = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Jc = !1, Ue(m, n, p);
          break;
        case "selectionchange":
          if (tP) break;
        case "keydown":
        case "keyup":
          Ue(m, n, p);
      }
      var T;
      if (_d) e: {
        switch (t) {
          case "compositionstart":
            var O = "onCompositionStart";
            break e;
          case "compositionend":
            O = "onCompositionEnd";
            break e;
          case "compositionupdate":
            O = "onCompositionUpdate";
            break e;
        }
        O = void 0;
      } else ei ? ge(t, n) && (O = "onCompositionEnd") : t === "keydown" && n.keyCode === 229 && (O = "onCompositionStart");
      O && (s0 && n.locale !== "ko" && (ei || O !== "onCompositionStart" ? O === "onCompositionEnd" && ei && (T = nd()) : (Vn = p, Cd = "value" in Vn ? Vn.value : Vn.textContent, ei = !0)), P = oe$1(onBeforeInput, O), 0 < P.length && (O = new om(O, t, null, n, p), m.push({
        event: O,
        listeners: P
      }), T ? O.data = T : (T = he$1(n), T !== null && (O.data = T)))), (T = UT ? je$1(t, n) : ke(t, n)) && (onBeforeInput = oe$1(onBeforeInput, "onBeforeInput"), 0 < onBeforeInput.length && (p = new om("onBeforeInput", "beforeinput", null, n, p), m.push({
        event: p,
        listeners: onBeforeInput
      }), p.data = T));
    }
    se(m, e);
  });
}
o(jd$1, "jd");
function ef$1(t, e, n) {
  return {
    instance: t,
    listener: e,
    currentTarget: n
  };
}
o(ef$1, "ef");
function oe$1(t, e) {
  for (var n = e + "Capture", r = []; t !== null;) {
    var i = t,
      s = i.stateNode;
    i.tag === 5 && s !== null && (i = s, s = Ob$1(t, n), s != null && r.unshift(ef$1(t, s, i)), s = Ob$1(t, e), s != null && r.push(ef$1(t, s, i))), t = t.return;
  }
  return r;
}
o(oe$1, "oe");
function gf$1(t) {
  if (t === null) return null;
  do t = t.return; while (t && t.tag !== 5);
  return t || null;
}
o(gf$1, "gf");
function hf$1(t, e, n, r, i) {
  for (var s = e._reactName, a = []; n !== null && n !== r;) {
    var l = n,
      u = l.alternate,
      c = l.stateNode;
    if (u !== null && u === r) break;
    l.tag === 5 && c !== null && (l = c, i ? (u = Ob$1(n, s), u != null && a.unshift(ef$1(n, u, l))) : i || (u = Ob$1(n, s), u != null && a.push(ef$1(n, u, l)))), n = n.return;
  }
  a.length !== 0 && t.push({
    event: e,
    listeners: a
  });
}
o(hf$1, "hf");
function jf$1() {}
o(jf$1, "jf");
var ec = null,
  tc = null;
function mf$1(t, e) {
  switch (t) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!e.autoFocus;
  }
  return !1;
}
o(mf$1, "mf");
function nf$1(t, e) {
  return t === "textarea" || t === "option" || t === "noscript" || typeof e.children == "string" || typeof e.children == "number" || typeof e.dangerouslySetInnerHTML == "object" && e.dangerouslySetInnerHTML !== null && e.dangerouslySetInnerHTML.__html != null;
}
o(nf$1, "nf");
var Em = typeof setTimeout == "function" ? setTimeout : void 0,
  nP = typeof clearTimeout == "function" ? clearTimeout : void 0;
function qf(t) {
  t.nodeType === 1 ? t.textContent = "" : t.nodeType === 9 && (t = t.body, t != null && (t.textContent = ""));
}
o(qf, "qf");
function rf$1(t) {
  for (; t != null; t = t.nextSibling) {
    var e = t.nodeType;
    if (e === 1 || e === 3) break;
  }
  return t;
}
o(rf$1, "rf");
function sf$1(t) {
  t = t.previousSibling;
  for (var e = 0; t;) {
    if (t.nodeType === 8) {
      var n = t.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (e === 0) return t;
        e--;
      } else n === "/$" && e++;
    }
    t = t.previousSibling;
  }
  return null;
}
o(sf$1, "sf");
var nc = 0;
function uf$1(t) {
  return {
    $$typeof: hd,
    toString: t,
    valueOf: t
  };
}
o(uf$1, "uf");
var Al = Math.random().toString(36).slice(2),
  Wn = "__reactFiber$" + Al,
  Oa = "__reactProps$" + Al,
  Ri = "__reactContainer$" + Al,
  Pm = "__reactEvents$" + Al;
function wc$1(t) {
  var e = t[Wn];
  if (e) return e;
  for (var n = t.parentNode; n;) {
    if (e = n[Ri] || n[Wn]) {
      if (n = e.alternate, e.child !== null || n !== null && n.child !== null) for (t = sf$1(t); t !== null;) {
        if (n = t[Wn]) return n;
        t = sf$1(t);
      }
      return e;
    }
    t = n, n = t.parentNode;
  }
  return null;
}
o(wc$1, "wc");
function Cb$1(t) {
  return t = t[Wn] || t[Ri], !t || t.tag !== 5 && t.tag !== 6 && t.tag !== 13 && t.tag !== 3 ? null : t;
}
o(Cb$1, "Cb");
function ue(t) {
  if (t.tag === 5 || t.tag === 6) return t.stateNode;
  throw Error(y$1(33));
}
o(ue, "ue");
function Db$1(t) {
  return t[Oa] || null;
}
o(Db$1, "Db");
function $e$1(t) {
  var e = t[Pm];
  return e === void 0 && (e = t[Pm] = new Set()), e;
}
o($e$1, "$e");
var ef = [],
  ri = -1;
function Bf$1(t) {
  return {
    current: t
  };
}
o(Bf$1, "Bf");
function H$1(t) {
  0 > ri || (t.current = ef[ri], ef[ri] = null, ri--);
}
o(H$1, "H");
function I$1(t, e) {
  ri++, ef[ri] = t.current, t.current = e;
}
o(I$1, "I");
var ar = {},
  Et = Bf$1(ar),
  Mt = Bf$1(!1),
  Or = ar;
function Ef$1(t, e) {
  var n = t.type.contextTypes;
  if (!n) return ar;
  var r = t.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === e) return r.__reactInternalMemoizedMaskedChildContext;
  var i = {},
    s;
  for (s in n) i[s] = e[s];
  return r && (t = t.stateNode, t.__reactInternalMemoizedUnmaskedChildContext = e, t.__reactInternalMemoizedMaskedChildContext = i), i;
}
o(Ef$1, "Ef");
function Ff$1(t) {
  return t = t.childContextTypes, t != null;
}
o(Ff$1, "Ff");
function Gf() {
  H$1(Mt), H$1(Et);
}
o(Gf, "Gf");
function Hf$1(t, e, n) {
  if (Et.current !== ar) throw Error(y$1(168));
  I$1(Et, e), I$1(Mt, n);
}
o(Hf$1, "Hf");
function If$1(t, e, n) {
  var r = t.stateNode;
  if (t = e.childContextTypes, typeof r.getChildContext != "function") return n;
  r = r.getChildContext();
  for (var i in r) if (!(i in t)) throw Error(y$1(108, Ra$1(e) || "Unknown", i));
  return ze({}, n, r);
}
o(If$1, "If");
function Jf(t) {
  return t = (t = t.stateNode) && t.__reactInternalMemoizedMergedChildContext || ar, Or = Et.current, I$1(Et, t), I$1(Mt, Mt.current), !0;
}
o(Jf, "Jf");
function Kf$1(t, e, n) {
  var r = t.stateNode;
  if (!r) throw Error(y$1(169));
  n ? (t = If$1(t, e, Or), r.__reactInternalMemoizedMergedChildContext = t, H$1(Mt), H$1(Et), I$1(Et, t)) : H$1(Mt), I$1(Mt, n);
}
o(Kf$1, "Kf");
var Ad = null,
  _r = null,
  iP = lt.unstable_runWithPriority,
  Ld = lt.unstable_scheduleCallback,
  tf = lt.unstable_cancelCallback,
  sP = lt.unstable_shouldYield,
  km = lt.unstable_requestPaint,
  nf = lt.unstable_now,
  oP = lt.unstable_getCurrentPriorityLevel,
  Ml = lt.unstable_ImmediatePriority,
  b0 = lt.unstable_UserBlockingPriority,
  S0 = lt.unstable_NormalPriority,
  E0 = lt.unstable_LowPriority,
  T0 = lt.unstable_IdlePriority,
  rc = {},
  aP = km !== void 0 ? km : function () {},
  xn = null,
  aa = null,
  ic = !1,
  _m = nf(),
  bt = 1e4 > _m ? nf : function () {
    return nf() - _m;
  };
function eg$1() {
  switch (oP()) {
    case Ml:
      return 99;
    case b0:
      return 98;
    case S0:
      return 97;
    case E0:
      return 96;
    case T0:
      return 95;
    default:
      throw Error(y$1(332));
  }
}
o(eg$1, "eg");
function fg$1(t) {
  switch (t) {
    case 99:
      return Ml;
    case 98:
      return b0;
    case 97:
      return S0;
    case 96:
      return E0;
    case 95:
      return T0;
    default:
      throw Error(y$1(332));
  }
}
o(fg$1, "fg");
function gg$1(t, e) {
  return t = fg$1(t), iP(t, e);
}
o(gg$1, "gg");
function hg$1(t, e, n) {
  return t = fg$1(t), Ld(t, e, n);
}
o(hg$1, "hg");
function ig$1() {
  if (aa !== null) {
    var t = aa;
    aa = null, tf(t);
  }
  jg$1();
}
o(ig$1, "ig");
function jg$1() {
  if (!ic && xn !== null) {
    ic = !0;
    var t = 0;
    try {
      var e = xn;
      gg$1(99, function () {
        for (; t < e.length; t++) {
          var n = e[t];
          do n = n(!0); while (n !== null);
        }
      }), xn = null;
    } catch (n) {
      throw xn !== null && (xn = xn.slice(t + 1)), Ld(Ml, ig$1), n;
    } finally {
      ic = !1;
    }
  }
}
o(jg$1, "jg");
var lP = jr.ReactCurrentBatchConfig;
function lg$1(t, e) {
  if (t && t.defaultProps) {
    e = ze({}, e), t = t.defaultProps;
    for (var n in t) e[n] === void 0 && (e[n] = t[n]);
    return e;
  }
  return e;
}
o(lg$1, "lg");
var La = Bf$1(null),
  Ma = null,
  ii = null,
  Da = null;
function qg$1() {
  Da = ii = Ma = null;
}
o(qg$1, "qg");
function rg$1(t) {
  var e = La.current;
  H$1(La), t.type._context._currentValue = e;
}
o(rg$1, "rg");
function sg$1(t, e) {
  for (; t !== null;) {
    var n = t.alternate;
    if ((t.childLanes & e) === e) {
      if (n === null || (n.childLanes & e) === e) break;
      n.childLanes |= e;
    } else t.childLanes |= e, n !== null && (n.childLanes |= e);
    t = t.return;
  }
}
o(sg$1, "sg");
function tg$1(t, e) {
  Ma = t, Da = ii = null, t = t.dependencies, t !== null && t.firstContext !== null && (t.lanes & e && (an = !0), t.firstContext = null);
}
o(tg$1, "tg");
function vg$1(t, e) {
  if (Da !== t && e !== !1 && e !== 0) if ((typeof e != "number" || e === 1073741823) && (Da = t, e = 1073741823), e = {
    context: t,
    observedBits: e,
    next: null
  }, ii === null) {
    if (Ma === null) throw Error(y$1(308));
    ii = e, Ma.dependencies = {
      lanes: 0,
      firstContext: e,
      responders: null
    };
  } else ii = ii.next = e;
  return t._currentValue;
}
o(vg$1, "vg");
var zn = !1;
function xg$1(t) {
  t.updateQueue = {
    baseState: t.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null
    },
    effects: null
  };
}
o(xg$1, "xg");
function yg$1(t, e) {
  t = t.updateQueue, e.updateQueue === t && (e.updateQueue = {
    baseState: t.baseState,
    firstBaseUpdate: t.firstBaseUpdate,
    lastBaseUpdate: t.lastBaseUpdate,
    shared: t.shared,
    effects: t.effects
  });
}
o(yg$1, "yg");
function zg$1(t, e) {
  return {
    eventTime: t,
    lane: e,
    tag: 0,
    payload: null,
    callback: null,
    next: null
  };
}
o(zg$1, "zg");
function Ag$1(t, e) {
  if (t = t.updateQueue, t !== null) {
    t = t.shared;
    var n = t.pending;
    n === null ? e.next = e : (e.next = n.next, n.next = e), t.pending = e;
  }
}
o(Ag$1, "Ag");
function Bg$1(t, e) {
  var n = t.updateQueue,
    r = t.alternate;
  if (r !== null && (r = r.updateQueue, n === r)) {
    var i = null,
      s = null;
    if (n = n.firstBaseUpdate, n !== null) {
      do {
        var a = {
          eventTime: n.eventTime,
          lane: n.lane,
          tag: n.tag,
          payload: n.payload,
          callback: n.callback,
          next: null
        };
        s === null ? i = s = a : s = s.next = a, n = n.next;
      } while (n !== null);
      s === null ? i = s = e : s = s.next = e;
    } else i = s = e;
    n = {
      baseState: r.baseState,
      firstBaseUpdate: i,
      lastBaseUpdate: s,
      shared: r.shared,
      effects: r.effects
    }, t.updateQueue = n;
    return;
  }
  t = n.lastBaseUpdate, t === null ? n.firstBaseUpdate = e : t.next = e, n.lastBaseUpdate = e;
}
o(Bg$1, "Bg");
function Cg$1(t, e, n, r) {
  var i = t.updateQueue;
  zn = !1;
  var s = i.firstBaseUpdate,
    a = i.lastBaseUpdate,
    l = i.shared.pending;
  if (l !== null) {
    i.shared.pending = null;
    var u = l,
      c = u.next;
    u.next = null, a === null ? s = c : a.next = c, a = u;
    var p = t.alternate;
    if (p !== null) {
      p = p.updateQueue;
      var m = p.lastBaseUpdate;
      m !== a && (m === null ? p.firstBaseUpdate = c : m.next = c, p.lastBaseUpdate = u);
    }
  }
  if (s !== null) {
    m = i.baseState, a = 0, p = c = u = null;
    do {
      l = s.lane;
      var d = s.eventTime;
      if ((r & l) === l) {
        p !== null && (p = p.next = {
          eventTime: d,
          lane: 0,
          tag: s.tag,
          payload: s.payload,
          callback: s.callback,
          next: null
        });
        e: {
          var y = t,
            S = s;
          switch (l = e, d = n, S.tag) {
            case 1:
              if (y = S.payload, typeof y == "function") {
                m = y.call(d, m, l);
                break e;
              }
              m = y;
              break e;
            case 3:
              y.flags = y.flags & -4097 | 64;
            case 0:
              if (y = S.payload, l = typeof y == "function" ? y.call(d, m, l) : y, l == null) break e;
              m = ze({}, m, l);
              break e;
            case 2:
              zn = !0;
          }
        }
        s.callback !== null && (t.flags |= 32, l = i.effects, l === null ? i.effects = [s] : l.push(s));
      } else d = {
        eventTime: d,
        lane: l,
        tag: s.tag,
        payload: s.payload,
        callback: s.callback,
        next: null
      }, p === null ? (c = p = d, u = m) : p = p.next = d, a |= l;
      if (s = s.next, s === null) {
        if (l = i.shared.pending, l === null) break;
        s = l.next, l.next = null, i.lastBaseUpdate = l, i.shared.pending = null;
      }
    } while (1);
    p === null && (u = m), i.baseState = u, i.firstBaseUpdate = c, i.lastBaseUpdate = p, ko |= a, t.lanes = a, t.memoizedState = m;
  }
}
o(Cg$1, "Cg");
function Eg$1(t, e, n) {
  if (t = e.effects, e.effects = null, t !== null) for (e = 0; e < t.length; e++) {
    var r = t[e],
      i = r.callback;
    if (i !== null) {
      if (r.callback = null, r = n, typeof i != "function") throw Error(y$1(191, i));
      i.call(r);
    }
  }
}
o(Eg$1, "Eg");
var _0 = new Tl.Component().refs;
function Gg$1(t, e, n, r) {
  e = t.memoizedState, n = n(r, e), n = n == null ? e : ze({}, e, n), t.memoizedState = n, t.lanes === 0 && (t.updateQueue.baseState = n);
}
o(Gg$1, "Gg");
var Dl = {
  isMounted: function (t) {
    return (t = t._reactInternals) ? Zb$1(t) === t : !1;
  },
  enqueueSetState: function (t, e, n) {
    t = t._reactInternals;
    var r = Hg$1(),
      i = Ig$1(t),
      s = zg$1(r, i);
    s.payload = e, n != null && (s.callback = n), Ag$1(t, s), Jg$1(t, i, r);
  },
  enqueueReplaceState: function (t, e, n) {
    t = t._reactInternals;
    var r = Hg$1(),
      i = Ig$1(t),
      s = zg$1(r, i);
    s.tag = 1, s.payload = e, n != null && (s.callback = n), Ag$1(t, s), Jg$1(t, i, r);
  },
  enqueueForceUpdate: function (t, e) {
    t = t._reactInternals;
    var n = Hg$1(),
      r = Ig$1(t),
      i = zg$1(n, r);
    i.tag = 2, e != null && (i.callback = e), Ag$1(t, i), Jg$1(t, r, n);
  }
};
function Lg$1(t, e, n, r, i, s, a) {
  return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(r, s, a) : e.prototype && e.prototype.isPureReactComponent ? !Je$1(n, r) || !Je$1(i, s) : !0;
}
o(Lg$1, "Lg");
function Mg$1(t, e, n) {
  var r = !1,
    i = ar,
    s = e.contextType;
  return typeof s == "object" && s !== null ? s = vg$1(s) : (i = Ff$1(e) ? Or : Et.current, r = e.contextTypes, s = (r = r != null) ? Ef$1(t, i) : ar), e = new e(n, s), t.memoizedState = e.state !== null && e.state !== void 0 ? e.state : null, e.updater = Dl, t.stateNode = e, e._reactInternals = t, r && (t = t.stateNode, t.__reactInternalMemoizedUnmaskedChildContext = i, t.__reactInternalMemoizedMaskedChildContext = s), e;
}
o(Mg$1, "Mg");
function Ng$1(t, e, n, r) {
  t = e.state, typeof e.componentWillReceiveProps == "function" && e.componentWillReceiveProps(n, r), typeof e.UNSAFE_componentWillReceiveProps == "function" && e.UNSAFE_componentWillReceiveProps(n, r), e.state !== t && Dl.enqueueReplaceState(e, e.state, null);
}
o(Ng$1, "Ng");
function Og$1(t, e, n, r) {
  var i = t.stateNode;
  i.props = n, i.state = t.memoizedState, i.refs = _0, xg$1(t);
  var s = e.contextType;
  typeof s == "object" && s !== null ? i.context = vg$1(s) : (s = Ff$1(e) ? Or : Et.current, i.context = Ef$1(t, s)), Cg$1(t, n, i, r), i.state = t.memoizedState, s = e.getDerivedStateFromProps, typeof s == "function" && (Gg$1(t, e, s, n), i.state = t.memoizedState), typeof e.getDerivedStateFromProps == "function" || typeof i.getSnapshotBeforeUpdate == "function" || typeof i.UNSAFE_componentWillMount != "function" && typeof i.componentWillMount != "function" || (e = i.state, typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), e !== i.state && Dl.enqueueReplaceState(i, i.state, null), Cg$1(t, n, i, r), i.state = t.memoizedState), typeof i.componentDidMount == "function" && (t.flags |= 4);
}
o(Og$1, "Og");
var qo = Array.isArray;
function Qg$1(t, e, n) {
  if (t = n.ref, t !== null && typeof t != "function" && typeof t != "object") {
    if (n._owner) {
      if (n = n._owner, n) {
        if (n.tag !== 1) throw Error(y$1(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(y$1(147, t));
      var i = "" + t;
      return e !== null && e.ref !== null && typeof e.ref == "function" && e.ref._stringRef === i ? e.ref : (e = o(function (s) {
        var a = r.refs;
        a === _0 && (a = r.refs = {}), s === null ? delete a[i] : a[i] = s;
      }, "b"), e._stringRef = i, e);
    }
    if (typeof t != "string") throw Error(y$1(284));
    if (!n._owner) throw Error(y$1(290, t));
  }
  return t;
}
o(Qg$1, "Qg");
function Rg$1(t, e) {
  if (t.type !== "textarea") throw Error(y$1(31, Object.prototype.toString.call(e) === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : e));
}
o(Rg$1, "Rg");
function Sg$1(t) {
  function b$2(g, h) {
    if (t) {
      var f = g.lastEffect;
      f !== null ? (f.nextEffect = h, g.lastEffect = h) : g.firstEffect = g.lastEffect = h, h.nextEffect = null, h.flags = 8;
    }
  }
  o(b$2, "b");
  function c$1(g, h) {
    if (!t) return null;
    for (; h !== null;) b$2(g, h), h = h.sibling;
    return null;
  }
  o(c$1, "c");
  function d$1(g, h) {
    for (g = new Map(); h !== null;) h.key !== null ? g.set(h.key, h) : g.set(h.index, h), h = h.sibling;
    return g;
  }
  o(d$1, "d");
  function e(g, h) {
    return g = Tg$1(g, h), g.index = 0, g.sibling = null, g;
  }
  o(e, "e");
  function f$1(g, h, f) {
    return g.index = f, t ? (f = g.alternate, f !== null ? (f = f.index, f < h ? (g.flags = 2, h) : f) : (g.flags = 2, h)) : h;
  }
  o(f$1, "f");
  function g$1(g) {
    return t && g.alternate === null && (g.flags = 2), g;
  }
  o(g$1, "g");
  function h$1(g, h, f, v) {
    return h === null || h.tag !== 6 ? (h = Ug$1(f, g.mode, v), h.return = g, h) : (h = e(h, f), h.return = g, h);
  }
  o(h$1, "h");
  function k(g, h, f, v) {
    return h !== null && h.elementType === f.type ? (v = e(h, f.props), v.ref = Qg$1(g, h, f), v.return = g, v) : (v = Vg$1(f.type, f.key, f.props, null, g.mode, v), v.ref = Qg$1(g, h, f), v.return = g, v);
  }
  o(k, "k");
  function l(g, h, f, v) {
    return h === null || h.tag !== 4 || h.stateNode.containerInfo !== f.containerInfo || h.stateNode.implementation !== f.implementation ? (h = Wg$1(f, g.mode, v), h.return = g, h) : (h = e(h, f.children || []), h.return = g, h);
  }
  o(l, "l");
  function n(g, h, f, v, E) {
    return h === null || h.tag !== 7 ? (h = Xg$1(f, g.mode, v, E), h.return = g, h) : (h = e(h, f), h.return = g, h);
  }
  o(n, "n");
  function A(g, h, f) {
    if (typeof h == "string" || typeof h == "number") return h = Ug$1("" + h, g.mode, f), h.return = g, h;
    if (typeof h == "object" && h !== null) {
      switch (h.$$typeof) {
        case bs:
          return f = Vg$1(h.type, h.key, h.props, null, g.mode, f), f.ref = Qg$1(g, null, h), f.return = g, f;
        case Sr:
          return h = Wg$1(h, g.mode, f), h.return = g, h;
      }
      if (qo(h) || La$1(h)) return h = Xg$1(h, g.mode, f, null), h.return = g, h;
      Rg$1(g, h);
    }
    return null;
  }
  o(A, "A");
  function p(g, h, f, v) {
    var E = h !== null ? h.key : null;
    if (typeof f == "string" || typeof f == "number") return E !== null ? null : h$1(g, h, "" + f, v);
    if (typeof f == "object" && f !== null) {
      switch (f.$$typeof) {
        case bs:
          return f.key === E ? f.type === Un ? n(g, h, f.props.children, v, E) : k(g, h, f, v) : null;
        case Sr:
          return f.key === E ? l(g, h, f, v) : null;
      }
      if (qo(f) || La$1(f)) return E !== null ? null : n(g, h, f, v, null);
      Rg$1(g, f);
    }
    return null;
  }
  o(p, "p");
  function C$1(g, h, f, v, E) {
    if (typeof v == "string" || typeof v == "number") return g = g.get(f) || null, h$1(h, g, "" + v, E);
    if (typeof v == "object" && v !== null) {
      switch (v.$$typeof) {
        case bs:
          return g = g.get(v.key === null ? f : v.key) || null, v.type === Un ? n(h, g, v.props.children, E, v.key) : k(h, g, v, E);
        case Sr:
          return g = g.get(v.key === null ? f : v.key) || null, l(h, g, v, E);
      }
      if (qo(v) || La$1(v)) return g = g.get(f) || null, n(h, g, v, E, null);
      Rg$1(h, v);
    }
    return null;
  }
  o(C$1, "C");
  function x$1(g, h, f, v) {
    for (var E = null, b = null, P = h, T = h = 0, O = null; P !== null && T < f.length; T++) {
      P.index > T ? (O = P, P = null) : O = P.sibling;
      var M = p(g, P, f[T], v);
      if (M === null) {
        P === null && (P = O);
        break;
      }
      t && P && M.alternate === null && b$2(g, P), h = f$1(M, h, T), b === null ? E = M : b.sibling = M, b = M, P = O;
    }
    if (T === f.length) return c$1(g, P), E;
    if (P === null) {
      for (; T < f.length; T++) P = A(g, f[T], v), P !== null && (h = f$1(P, h, T), b === null ? E = P : b.sibling = P, b = P);
      return E;
    }
    for (P = d$1(g, P); T < f.length; T++) O = C$1(P, g, T, f[T], v), O !== null && (t && O.alternate !== null && P.delete(O.key === null ? T : O.key), h = f$1(O, h, T), b === null ? E = O : b.sibling = O, b = O);
    return t && P.forEach(function (I) {
      return b$2(g, I);
    }), E;
  }
  o(x$1, "x");
  function w(g, h, f, v) {
    var E = La$1(f);
    if (typeof E != "function") throw Error(y$1(150));
    if (f = E.call(f), f == null) throw Error(y$1(151));
    for (var b = E = null, P = h, T = h = 0, O = null, M = f.next(); P !== null && !M.done; T++, M = f.next()) {
      P.index > T ? (O = P, P = null) : O = P.sibling;
      var I = p(g, P, M.value, v);
      if (I === null) {
        P === null && (P = O);
        break;
      }
      t && P && I.alternate === null && b$2(g, P), h = f$1(I, h, T), b === null ? E = I : b.sibling = I, b = I, P = O;
    }
    if (M.done) return c$1(g, P), E;
    if (P === null) {
      for (; !M.done; T++, M = f.next()) M = A(g, M.value, v), M !== null && (h = f$1(M, h, T), b === null ? E = M : b.sibling = M, b = M);
      return E;
    }
    for (P = d$1(g, P); !M.done; T++, M = f.next()) M = C$1(P, g, T, M.value, v), M !== null && (t && M.alternate !== null && P.delete(M.key === null ? T : M.key), h = f$1(M, h, T), b === null ? E = M : b.sibling = M, b = M);
    return t && P.forEach(function (U) {
      return b$2(g, U);
    }), E;
  }
  return o(w, "w"), function (g, h, f, v) {
    var E = typeof f == "object" && f !== null && f.type === Un && f.key === null;
    E && (f = f.props.children);
    var b = typeof f == "object" && f !== null;
    if (b) switch (f.$$typeof) {
      case bs:
        e: {
          for (b = f.key, E = h; E !== null;) {
            if (E.key === b) {
              switch (E.tag) {
                case 7:
                  if (f.type === Un) {
                    c$1(g, E.sibling), h = e(E, f.props.children), h.return = g, g = h;
                    break e;
                  }
                  break;
                default:
                  if (E.elementType === f.type) {
                    c$1(g, E.sibling), h = e(E, f.props), h.ref = Qg$1(g, E, f), h.return = g, g = h;
                    break e;
                  }
              }
              c$1(g, E);
              break;
            } else b$2(g, E);
            E = E.sibling;
          }
          f.type === Un ? (h = Xg$1(f.props.children, g.mode, v, f.key), h.return = g, g = h) : (v = Vg$1(f.type, f.key, f.props, null, g.mode, v), v.ref = Qg$1(g, h, f), v.return = g, g = v);
        }
        return g$1(g);
      case Sr:
        e: {
          for (E = f.key; h !== null;) {
            if (h.key === E) {
              if (h.tag === 4 && h.stateNode.containerInfo === f.containerInfo && h.stateNode.implementation === f.implementation) {
                c$1(g, h.sibling), h = e(h, f.children || []), h.return = g, g = h;
                break e;
              } else {
                c$1(g, h);
                break;
              }
            } else b$2(g, h);
            h = h.sibling;
          }
          h = Wg$1(f, g.mode, v), h.return = g, g = h;
        }
        return g$1(g);
    }
    if (typeof f == "string" || typeof f == "number") return f = "" + f, h !== null && h.tag === 6 ? (c$1(g, h.sibling), h = e(h, f), h.return = g, g = h) : (c$1(g, h), h = Ug$1(f, g.mode, v), h.return = g, g = h), g$1(g);
    if (qo(f)) return x$1(g, h, f, v);
    if (La$1(f)) return w(g, h, f, v);
    if (b && Rg$1(g, f), typeof f > "u" && !E) switch (g.tag) {
      case 1:
      case 22:
      case 0:
      case 11:
      case 15:
        throw Error(y$1(152, Ra$1(g.type) || "Component"));
    }
    return c$1(g, h);
  };
}
o(Sg$1, "Sg");
var Ra = Sg$1(!0),
  L0 = Sg$1(!1),
  xo = {},
  En = Bf$1(xo),
  no = Bf$1(xo),
  ro = Bf$1(xo);
function dh$1(t) {
  if (t === xo) throw Error(y$1(174));
  return t;
}
o(dh$1, "dh");
function eh$1(t, e) {
  switch (I$1(ro, e), I$1(no, t), I$1(En, xo), t = e.nodeType, t) {
    case 9:
    case 11:
      e = (e = e.documentElement) ? e.namespaceURI : mb$1(null, "");
      break;
    default:
      t = t === 8 ? e.parentNode : e, e = t.namespaceURI || null, t = t.tagName, e = mb$1(e, t);
  }
  H$1(En), I$1(En, e);
}
o(eh$1, "eh");
function fh$1() {
  H$1(En), H$1(no), H$1(ro);
}
o(fh$1, "fh");
function gh$1(t) {
  dh$1(ro.current);
  var e = dh$1(En.current),
    n = mb$1(e, t.type);
  e !== n && (I$1(no, t), I$1(En, n));
}
o(gh$1, "gh");
function hh$1(t) {
  no.current === t && (H$1(En), H$1(no));
}
o(hh$1, "hh");
var qe = Bf$1(0);
function ih$1(t) {
  for (var e = t; e !== null;) {
    if (e.tag === 13) {
      var n = e.memoizedState;
      if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return e;
    } else if (e.tag === 19 && e.memoizedProps.revealOrder !== void 0) {
      if (e.flags & 64) return e;
    } else if (e.child !== null) {
      e.child.return = e, e = e.child;
      continue;
    }
    if (e === t) break;
    for (; e.sibling === null;) {
      if (e.return === null || e.return === t) return null;
      e = e.return;
    }
    e.sibling.return = e.return, e = e.sibling;
  }
  return null;
}
o(ih$1, "ih");
var An = null,
  Gn = null,
  Tn = !1;
function mh$1(t, e) {
  var n = nh$1(5, null, null, 0);
  n.elementType = "DELETED", n.type = "DELETED", n.stateNode = e, n.return = t, n.flags = 8, t.lastEffect !== null ? (t.lastEffect.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n;
}
o(mh$1, "mh");
function oh$1(t, e) {
  switch (t.tag) {
    case 5:
      var n = t.type;
      return e = e.nodeType !== 1 || n.toLowerCase() !== e.nodeName.toLowerCase() ? null : e, e !== null ? (t.stateNode = e, !0) : !1;
    case 6:
      return e = t.pendingProps === "" || e.nodeType !== 3 ? null : e, e !== null ? (t.stateNode = e, !0) : !1;
    case 13:
      return !1;
    default:
      return !1;
  }
}
o(oh$1, "oh");
function ph$1(t) {
  if (Tn) {
    var e = Gn;
    if (e) {
      var n = e;
      if (!oh$1(t, e)) {
        if (e = rf$1(n.nextSibling), !e || !oh$1(t, e)) {
          t.flags = t.flags & -1025 | 2, Tn = !1, An = t;
          return;
        }
        mh$1(An, n);
      }
      An = t, Gn = rf$1(e.firstChild);
    } else t.flags = t.flags & -1025 | 2, Tn = !1, An = t;
  }
}
o(ph$1, "ph");
function qh$1(t) {
  for (t = t.return; t !== null && t.tag !== 5 && t.tag !== 3 && t.tag !== 13;) t = t.return;
  An = t;
}
o(qh$1, "qh");
function rh$1(t) {
  if (t !== An) return !1;
  if (!Tn) return qh$1(t), Tn = !0, !1;
  var e = t.type;
  if (t.tag !== 5 || e !== "head" && e !== "body" && !nf$1(e, t.memoizedProps)) for (e = Gn; e;) mh$1(t, e), e = rf$1(e.nextSibling);
  if (qh$1(t), t.tag === 13) {
    if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(y$1(317));
    e: {
      for (t = t.nextSibling, e = 0; t;) {
        if (t.nodeType === 8) {
          var n = t.data;
          if (n === "/$") {
            if (e === 0) {
              Gn = rf$1(t.nextSibling);
              break e;
            }
            e--;
          } else n !== "$" && n !== "$!" && n !== "$?" || e++;
        }
        t = t.nextSibling;
      }
      Gn = null;
    }
  } else Gn = An ? rf$1(t.stateNode.nextSibling) : null;
  return !0;
}
o(rh$1, "rh");
function sh$1() {
  Gn = An = null, Tn = !1;
}
o(sh$1, "sh");
var pi = [];
function uh$1() {
  for (var t = 0; t < pi.length; t++) pi[t]._workInProgressVersionPrimary = null;
  pi.length = 0;
}
o(uh$1, "uh");
var Rs = jr.ReactCurrentDispatcher,
  Zt = jr.ReactCurrentBatchConfig,
  io = 0,
  Ye = null,
  wt = null,
  ct = null,
  $a = !1,
  Ns = !1;
function Ah$1() {
  throw Error(y$1(321));
}
o(Ah$1, "Ah");
function Bh(t, e) {
  if (e === null) return !1;
  for (var n = 0; n < e.length && n < t.length; n++) if (!Kt(t[n], e[n])) return !1;
  return !0;
}
o(Bh, "Bh");
function Ch$1(t, e, n, r, i, s) {
  if (io = s, Ye = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, Rs.current = t === null || t.memoizedState === null ? cP : fP, t = n(r, i), Ns) {
    s = 0;
    do {
      if (Ns = !1, !(25 > s)) throw Error(y$1(301));
      s += 1, ct = wt = null, e.updateQueue = null, Rs.current = dP, t = n(r, i);
    } while (Ns);
  }
  if (Rs.current = za, e = wt !== null && wt.next !== null, io = 0, ct = wt = Ye = null, $a = !1, e) throw Error(y$1(300));
  return t;
}
o(Ch$1, "Ch");
function Hh$1() {
  var t = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  return ct === null ? Ye.memoizedState = ct = t : ct = ct.next = t, ct;
}
o(Hh$1, "Hh");
function Ih$1() {
  if (wt === null) {
    var t = Ye.alternate;
    t = t !== null ? t.memoizedState : null;
  } else t = wt.next;
  var e = ct === null ? Ye.memoizedState : ct.next;
  if (e !== null) ct = e, wt = t;else {
    if (t === null) throw Error(y$1(310));
    wt = t, t = {
      memoizedState: wt.memoizedState,
      baseState: wt.baseState,
      baseQueue: wt.baseQueue,
      queue: wt.queue,
      next: null
    }, ct === null ? Ye.memoizedState = ct = t : ct = ct.next = t;
  }
  return ct;
}
o(Ih$1, "Ih");
function Jh(t, e) {
  return typeof e == "function" ? e(t) : e;
}
o(Jh, "Jh");
function Kh(t) {
  var e = Ih$1(),
    n = e.queue;
  if (n === null) throw Error(y$1(311));
  n.lastRenderedReducer = t;
  var r = wt,
    i = r.baseQueue,
    s = n.pending;
  if (s !== null) {
    if (i !== null) {
      var a = i.next;
      i.next = s.next, s.next = a;
    }
    r.baseQueue = i = s, n.pending = null;
  }
  if (i !== null) {
    i = i.next, r = r.baseState;
    var l = a = s = null,
      u = i;
    do {
      var c = u.lane;
      if ((io & c) === c) l !== null && (l = l.next = {
        lane: 0,
        action: u.action,
        eagerReducer: u.eagerReducer,
        eagerState: u.eagerState,
        next: null
      }), r = u.eagerReducer === t ? u.eagerState : t(r, u.action);else {
        var p = {
          lane: c,
          action: u.action,
          eagerReducer: u.eagerReducer,
          eagerState: u.eagerState,
          next: null
        };
        l === null ? (a = l = p, s = r) : l = l.next = p, Ye.lanes |= c, ko |= c;
      }
      u = u.next;
    } while (u !== null && u !== i);
    l === null ? s = r : l.next = a, Kt(r, e.memoizedState) || (an = !0), e.memoizedState = r, e.baseState = s, e.baseQueue = l, n.lastRenderedState = r;
  }
  return [e.memoizedState, n.dispatch];
}
o(Kh, "Kh");
function Lh$1(t) {
  var e = Ih$1(),
    n = e.queue;
  if (n === null) throw Error(y$1(311));
  n.lastRenderedReducer = t;
  var r = n.dispatch,
    i = n.pending,
    s = e.memoizedState;
  if (i !== null) {
    n.pending = null;
    var a = i = i.next;
    do s = t(s, a.action), a = a.next; while (a !== i);
    Kt(s, e.memoizedState) || (an = !0), e.memoizedState = s, e.baseQueue === null && (e.baseState = s), n.lastRenderedState = s;
  }
  return [s, r];
}
o(Lh$1, "Lh");
function Mh$1(t, e, n) {
  var r = e._getVersion;
  r = r(e._source);
  var i = e._workInProgressVersionPrimary;
  if (i !== null ? t = i === r : (t = t.mutableReadLanes, (t = (io & t) === t) && (e._workInProgressVersionPrimary = r, pi.push(e))), t) return n(e._source);
  throw pi.push(e), Error(y$1(350));
}
o(Mh$1, "Mh");
function Nh$1(t, e, n, r) {
  var i = Ct;
  if (i === null) throw Error(y$1(349));
  var s = e._getVersion,
    a = s(e._source),
    l = Rs.current,
    u = l.useState(function () {
      return Mh$1(i, e, n);
    }),
    c = u[1],
    p = u[0];
  u = ct;
  var m = t.memoizedState,
    d = m.refs,
    y = d.getSnapshot,
    S = m.source;
  m = m.subscribe;
  var w = Ye;
  return t.memoizedState = {
    refs: d,
    source: e,
    subscribe: r
  }, l.useEffect(function () {
    d.getSnapshot = n, d.setSnapshot = c;
    var g = s(e._source);
    if (!Kt(a, g)) {
      g = n(e._source), Kt(p, g) || (c(g), g = Ig$1(w), i.mutableReadLanes |= g & i.pendingLanes), g = i.mutableReadLanes, i.entangledLanes |= g;
      for (var h = i.entanglements, f = g; 0 < f;) {
        var v = 31 - or(f),
          E = 1 << v;
        h[v] |= g, f &= ~E;
      }
    }
  }, [n, e, r]), l.useEffect(function () {
    return r(e._source, function () {
      var g = d.getSnapshot,
        h = d.setSnapshot;
      try {
        h(g(e._source));
        var f = Ig$1(w);
        i.mutableReadLanes |= f & i.pendingLanes;
      } catch (v) {
        h(function () {
          throw v;
        });
      }
    });
  }, [e, r]), Kt(y, n) && Kt(S, e) && Kt(m, r) || (t = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: Jh,
    lastRenderedState: p
  }, t.dispatch = c = Oh$1.bind(null, Ye, t), u.queue = t, u.baseQueue = null, p = Mh$1(i, e, n), u.memoizedState = u.baseState = p), p;
}
o(Nh$1, "Nh");
function Ph$1(t, e, n) {
  var r = Ih$1();
  return Nh$1(r, t, e, n);
}
o(Ph$1, "Ph");
function Qh(t) {
  var e = Hh$1();
  return typeof t == "function" && (t = t()), e.memoizedState = e.baseState = t, t = e.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: Jh,
    lastRenderedState: t
  }, t = t.dispatch = Oh$1.bind(null, Ye, t), [e.memoizedState, t];
}
o(Qh, "Qh");
function Rh$1(t, e, n, r) {
  return t = {
    tag: t,
    create: e,
    destroy: n,
    deps: r,
    next: null
  }, e = Ye.updateQueue, e === null ? (e = {
    lastEffect: null
  }, Ye.updateQueue = e, e.lastEffect = t.next = t) : (n = e.lastEffect, n === null ? e.lastEffect = t.next = t : (r = n.next, n.next = t, t.next = r, e.lastEffect = t)), t;
}
o(Rh$1, "Rh");
function Sh$1(t) {
  var e = Hh$1();
  return t = {
    current: t
  }, e.memoizedState = t;
}
o(Sh$1, "Sh");
function Th$1() {
  return Ih$1().memoizedState;
}
o(Th$1, "Th");
function Uh$1(t, e, n, r) {
  var i = Hh$1();
  Ye.flags |= t, i.memoizedState = Rh$1(1 | e, n, void 0, r === void 0 ? null : r);
}
o(Uh$1, "Uh");
function Vh$1(t, e, n, r) {
  var i = Ih$1();
  r = r === void 0 ? null : r;
  var s = void 0;
  if (wt !== null) {
    var a = wt.memoizedState;
    if (s = a.destroy, r !== null && Bh(r, a.deps)) {
      Rh$1(e, n, s, r);
      return;
    }
  }
  Ye.flags |= t, i.memoizedState = Rh$1(1 | e, n, s, r);
}
o(Vh$1, "Vh");
function Wh$1(t, e) {
  return Uh$1(516, 4, t, e);
}
o(Wh$1, "Wh");
function Xh(t, e) {
  return Vh$1(516, 4, t, e);
}
o(Xh, "Xh");
function Yh(t, e) {
  return Vh$1(4, 2, t, e);
}
o(Yh, "Yh");
function Zh(t, e) {
  if (typeof e == "function") return t = t(), e(t), function () {
    e(null);
  };
  if (e != null) return t = t(), e.current = t, function () {
    e.current = null;
  };
}
o(Zh, "Zh");
function $h$1(t, e, n) {
  return n = n != null ? n.concat([t]) : null, Vh$1(4, 2, Zh.bind(null, e, t), n);
}
o($h$1, "$h");
function ai() {}
o(ai, "ai");
function bi(t, e) {
  var n = Ih$1();
  e = e === void 0 ? null : e;
  var r = n.memoizedState;
  return r !== null && e !== null && Bh(e, r[1]) ? r[0] : (n.memoizedState = [t, e], t);
}
o(bi, "bi");
function ci$1(t, e) {
  var n = Ih$1();
  e = e === void 0 ? null : e;
  var r = n.memoizedState;
  return r !== null && e !== null && Bh(e, r[1]) ? r[0] : (t = t(), n.memoizedState = [t, e], t);
}
o(ci$1, "ci");
function di(t, e) {
  var n = eg$1();
  gg$1(98 > n ? 98 : n, function () {
    t(!0);
  }), gg$1(97 < n ? 97 : n, function () {
    var r = Zt.transition;
    Zt.transition = 1;
    try {
      t(!1), e();
    } finally {
      Zt.transition = r;
    }
  });
}
o(di, "di");
function Oh$1(t, e, n) {
  var r = Hg$1(),
    i = Ig$1(t),
    s = {
      lane: i,
      action: n,
      eagerReducer: null,
      eagerState: null,
      next: null
    },
    a = e.pending;
  if (a === null ? s.next = s : (s.next = a.next, a.next = s), e.pending = s, a = t.alternate, t === Ye || a !== null && a === Ye) Ns = $a = !0;else {
    if (t.lanes === 0 && (a === null || a.lanes === 0) && (a = e.lastRenderedReducer, a !== null)) try {
      var l = e.lastRenderedState,
        u = a(l, n);
      if (s.eagerReducer = a, s.eagerState = u, Kt(u, l)) return;
    } catch {} finally {}
    Jg$1(t, i, r);
  }
}
o(Oh$1, "Oh");
var za = {
    readContext: vg$1,
    useCallback: Ah$1,
    useContext: Ah$1,
    useEffect: Ah$1,
    useImperativeHandle: Ah$1,
    useLayoutEffect: Ah$1,
    useMemo: Ah$1,
    useReducer: Ah$1,
    useRef: Ah$1,
    useState: Ah$1,
    useDebugValue: Ah$1,
    useDeferredValue: Ah$1,
    useTransition: Ah$1,
    useMutableSource: Ah$1,
    useOpaqueIdentifier: Ah$1,
    unstable_isNewReconciler: !1
  },
  cP = {
    readContext: vg$1,
    useCallback: function (t, e) {
      return Hh$1().memoizedState = [t, e === void 0 ? null : e], t;
    },
    useContext: vg$1,
    useEffect: Wh$1,
    useImperativeHandle: function (t, e, n) {
      return n = n != null ? n.concat([t]) : null, Uh$1(4, 2, Zh.bind(null, e, t), n);
    },
    useLayoutEffect: function (t, e) {
      return Uh$1(4, 2, t, e);
    },
    useMemo: function (t, e) {
      var n = Hh$1();
      return e = e === void 0 ? null : e, t = t(), n.memoizedState = [t, e], t;
    },
    useReducer: function (t, e, n) {
      var r = Hh$1();
      return e = n !== void 0 ? n(e) : e, r.memoizedState = r.baseState = e, t = r.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: e
      }, t = t.dispatch = Oh$1.bind(null, Ye, t), [r.memoizedState, t];
    },
    useRef: Sh$1,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function (t) {
      var e = Qh(t),
        n = e[0],
        r = e[1];
      return Wh$1(function () {
        var i = Zt.transition;
        Zt.transition = 1;
        try {
          r(t);
        } finally {
          Zt.transition = i;
        }
      }, [t]), n;
    },
    useTransition: function () {
      var t = Qh(!1),
        e = t[0];
      return t = di.bind(null, t[1]), Sh$1(t), [t, e];
    },
    useMutableSource: function (t, e, n) {
      var r = Hh$1();
      return r.memoizedState = {
        refs: {
          getSnapshot: e,
          setSnapshot: null
        },
        source: t,
        subscribe: n
      }, Nh$1(r, t, e, n);
    },
    useOpaqueIdentifier: function () {
      if (Tn) {
        var t = !1,
          e = uf$1(function () {
            throw t || (t = !0, n("r:" + (nc++).toString(36))), Error(y$1(355));
          }),
          n = Qh(e)[1];
        return !(Ye.mode & 2) && (Ye.flags |= 516, Rh$1(5, function () {
          n("r:" + (nc++).toString(36));
        }, void 0, null)), e;
      }
      return e = "r:" + (nc++).toString(36), Qh(e), e;
    },
    unstable_isNewReconciler: !1
  },
  fP = {
    readContext: vg$1,
    useCallback: bi,
    useContext: vg$1,
    useEffect: Xh,
    useImperativeHandle: $h$1,
    useLayoutEffect: Yh,
    useMemo: ci$1,
    useReducer: Kh,
    useRef: Th$1,
    useState: function () {
      return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function (t) {
      var e = Kh(Jh),
        n = e[0],
        r = e[1];
      return Xh(function () {
        var i = Zt.transition;
        Zt.transition = 1;
        try {
          r(t);
        } finally {
          Zt.transition = i;
        }
      }, [t]), n;
    },
    useTransition: function () {
      var t = Kh(Jh)[0];
      return [Th$1().current, t];
    },
    useMutableSource: Ph$1,
    useOpaqueIdentifier: function () {
      return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
  },
  dP = {
    readContext: vg$1,
    useCallback: bi,
    useContext: vg$1,
    useEffect: Xh,
    useImperativeHandle: $h$1,
    useLayoutEffect: Yh,
    useMemo: ci$1,
    useReducer: Lh$1,
    useRef: Th$1,
    useState: function () {
      return Lh$1(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function (t) {
      var e = Lh$1(Jh),
        n = e[0],
        r = e[1];
      return Xh(function () {
        var i = Zt.transition;
        Zt.transition = 1;
        try {
          r(t);
        } finally {
          Zt.transition = i;
        }
      }, [t]), n;
    },
    useTransition: function () {
      var t = Lh$1(Jh)[0];
      return [Th$1().current, t];
    },
    useMutableSource: Ph$1,
    useOpaqueIdentifier: function () {
      return Lh$1(Jh)[0];
    },
    unstable_isNewReconciler: !1
  },
  pP = jr.ReactCurrentOwner,
  an = !1;
function fi(t, e, n, r) {
  e.child = t === null ? L0(e, null, n, r) : Ra(e, t.child, n, r);
}
o(fi, "fi");
function gi$1(t, e, n, r, i) {
  n = n.render;
  var s = e.ref;
  return tg$1(e, i), r = Ch$1(t, e, n, r, s, i), t !== null && !an ? (e.updateQueue = t.updateQueue, e.flags &= -517, t.lanes &= ~i, hi$1(t, e, i)) : (e.flags |= 1, fi(t, e, r, i), e.child);
}
o(gi$1, "gi");
function ii$1(t, e, n, r, i, s) {
  if (t === null) {
    var a = n.type;
    return typeof a == "function" && !ji$1(a) && a.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (e.tag = 15, e.type = a, ki$1(t, e, a, r, i, s)) : (t = Vg$1(n.type, null, r, e, e.mode, s), t.ref = e.ref, t.return = e, e.child = t);
  }
  return a = t.child, !(i & s) && (i = a.memoizedProps, n = n.compare, n = n !== null ? n : Je$1, n(i, r) && t.ref === e.ref) ? hi$1(t, e, s) : (e.flags |= 1, t = Tg$1(a, r), t.ref = e.ref, t.return = e, e.child = t);
}
o(ii$1, "ii");
function ki$1(t, e, n, r, i, s) {
  if (t !== null && Je$1(t.memoizedProps, r) && t.ref === e.ref) if (an = !1, (s & i) !== 0) t.flags & 16384 && (an = !0);else return e.lanes = t.lanes, hi$1(t, e, s);
  return li(t, e, n, r, s);
}
o(ki$1, "ki");
function mi$1(t, e, n) {
  var r = e.pendingProps,
    i = r.children,
    s = t !== null ? t.memoizedState : null;
  if (r.mode === "hidden" || r.mode === "unstable-defer-without-hiding") {
    if (!(e.mode & 4)) e.memoizedState = {
      baseLanes: 0
    }, ni(e, n);else if (n & 1073741824) e.memoizedState = {
      baseLanes: 0
    }, ni(e, s !== null ? s.baseLanes : n);else return t = s !== null ? s.baseLanes | n : n, e.lanes = e.childLanes = 1073741824, e.memoizedState = {
      baseLanes: t
    }, ni(e, t), null;
  } else s !== null ? (r = s.baseLanes | n, e.memoizedState = null) : r = n, ni(e, r);
  return fi(t, e, i, n), e.child;
}
o(mi$1, "mi");
function oi$1(t, e) {
  var n = e.ref;
  (t === null && n !== null || t !== null && t.ref !== n) && (e.flags |= 128);
}
o(oi$1, "oi");
function li(t, e, n, r, i) {
  var s = Ff$1(n) ? Or : Et.current;
  return s = Ef$1(e, s), tg$1(e, i), n = Ch$1(t, e, n, r, s, i), t !== null && !an ? (e.updateQueue = t.updateQueue, e.flags &= -517, t.lanes &= ~i, hi$1(t, e, i)) : (e.flags |= 1, fi(t, e, n, i), e.child);
}
o(li, "li");
function pi$1(t, e, n, r, i) {
  if (Ff$1(n)) {
    var s = !0;
    Jf(e);
  } else s = !1;
  if (tg$1(e, i), e.stateNode === null) t !== null && (t.alternate = null, e.alternate = null, e.flags |= 2), Mg$1(e, n, r), Og$1(e, n, r, i), r = !0;else if (t === null) {
    var a = e.stateNode,
      l = e.memoizedProps;
    a.props = l;
    var u = a.context,
      c = n.contextType;
    typeof c == "object" && c !== null ? c = vg$1(c) : (c = Ff$1(n) ? Or : Et.current, c = Ef$1(e, c));
    var p = n.getDerivedStateFromProps,
      m = typeof p == "function" || typeof a.getSnapshotBeforeUpdate == "function";
    m || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (l !== r || u !== c) && Ng$1(e, a, r, c), zn = !1;
    var d = e.memoizedState;
    a.state = d, Cg$1(e, r, a, i), u = e.memoizedState, l !== r || d !== u || Mt.current || zn ? (typeof p == "function" && (Gg$1(e, n, p, r), u = e.memoizedState), (l = zn || Lg$1(e, n, l, r, d, u, c)) ? (m || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (e.flags |= 4)) : (typeof a.componentDidMount == "function" && (e.flags |= 4), e.memoizedProps = r, e.memoizedState = u), a.props = r, a.state = u, a.context = c, r = l) : (typeof a.componentDidMount == "function" && (e.flags |= 4), r = !1);
  } else {
    a = e.stateNode, yg$1(t, e), l = e.memoizedProps, c = e.type === e.elementType ? l : lg$1(e.type, l), a.props = c, m = e.pendingProps, d = a.context, u = n.contextType, typeof u == "object" && u !== null ? u = vg$1(u) : (u = Ff$1(n) ? Or : Et.current, u = Ef$1(e, u));
    var y = n.getDerivedStateFromProps;
    (p = typeof y == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (l !== m || d !== u) && Ng$1(e, a, r, u), zn = !1, d = e.memoizedState, a.state = d, Cg$1(e, r, a, i);
    var S = e.memoizedState;
    l !== m || d !== S || Mt.current || zn ? (typeof y == "function" && (Gg$1(e, n, y, r), S = e.memoizedState), (c = zn || Lg$1(e, n, c, r, d, S, u)) ? (p || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, S, u), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, S, u)), typeof a.componentDidUpdate == "function" && (e.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (e.flags |= 256)) : (typeof a.componentDidUpdate != "function" || l === t.memoizedProps && d === t.memoizedState || (e.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || l === t.memoizedProps && d === t.memoizedState || (e.flags |= 256), e.memoizedProps = r, e.memoizedState = S), a.props = r, a.state = S, a.context = u, r = c) : (typeof a.componentDidUpdate != "function" || l === t.memoizedProps && d === t.memoizedState || (e.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || l === t.memoizedProps && d === t.memoizedState || (e.flags |= 256), r = !1);
  }
  return qi(t, e, n, r, s, i);
}
o(pi$1, "pi");
function qi(t, e, n, r, i, s) {
  oi$1(t, e);
  var a = (e.flags & 64) !== 0;
  if (!r && !a) return i && Kf$1(e, n, !1), hi$1(t, e, s);
  r = e.stateNode, pP.current = e;
  var l = a && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return e.flags |= 1, t !== null && a ? (e.child = Ra(e, t.child, null, s), e.child = Ra(e, null, l, s)) : fi(t, e, l, s), e.memoizedState = r.state, i && Kf$1(e, n, !0), e.child;
}
o(qi, "qi");
function ri$1(t) {
  var e = t.stateNode;
  e.pendingContext ? Hf$1(t, e.pendingContext, e.pendingContext !== e.context) : e.context && Hf$1(t, e.context, !1), eh$1(t, e.containerInfo);
}
o(ri$1, "ri");
var Go = {
  dehydrated: null,
  retryLane: 0
};
function ti$1(t, e, n) {
  var r = e.pendingProps,
    i = qe.current,
    s = !1,
    a;
  return (a = (e.flags & 64) !== 0) || (a = t !== null && t.memoizedState === null ? !1 : (i & 2) !== 0), a ? (s = !0, e.flags &= -65) : t !== null && t.memoizedState === null || r.fallback === void 0 || r.unstable_avoidThisFallback === !0 || (i |= 1), I$1(qe, i & 1), t === null ? (r.fallback !== void 0 && ph$1(e), t = r.children, i = r.fallback, s ? (t = ui$1(e, t, i, n), e.child.memoizedState = {
    baseLanes: n
  }, e.memoizedState = Go, t) : typeof r.unstable_expectedLoadTime == "number" ? (t = ui$1(e, t, i, n), e.child.memoizedState = {
    baseLanes: n
  }, e.memoizedState = Go, e.lanes = 33554432, t) : (n = vi$1({
    mode: "visible",
    children: t
  }, e.mode, n, null), n.return = e, e.child = n)) : t.memoizedState !== null ? s ? (r = wi(t, e, r.children, r.fallback, n), s = e.child, i = t.child.memoizedState, s.memoizedState = i === null ? {
    baseLanes: n
  } : {
    baseLanes: i.baseLanes | n
  }, s.childLanes = t.childLanes & ~n, e.memoizedState = Go, r) : (n = xi$1(t, e, r.children, n), e.memoizedState = null, n) : s ? (r = wi(t, e, r.children, r.fallback, n), s = e.child, i = t.child.memoizedState, s.memoizedState = i === null ? {
    baseLanes: n
  } : {
    baseLanes: i.baseLanes | n
  }, s.childLanes = t.childLanes & ~n, e.memoizedState = Go, r) : (n = xi$1(t, e, r.children, n), e.memoizedState = null, n);
}
o(ti$1, "ti");
function ui$1(t, e, n, r) {
  var i = t.mode,
    s = t.child;
  return e = {
    mode: "hidden",
    children: e
  }, !(i & 2) && s !== null ? (s.childLanes = 0, s.pendingProps = e) : s = vi$1(e, i, 0, null), n = Xg$1(n, i, r, null), s.return = t, n.return = t, s.sibling = n, t.child = s, n;
}
o(ui$1, "ui$1");
function xi$1(t, e, n, r) {
  var i = t.child;
  return t = i.sibling, n = Tg$1(i, {
    mode: "visible",
    children: n
  }), !(e.mode & 2) && (n.lanes = r), n.return = e, n.sibling = null, t !== null && (t.nextEffect = null, t.flags = 8, e.firstEffect = e.lastEffect = t), e.child = n;
}
o(xi$1, "xi");
function wi(t, e, n, r, i) {
  var s = e.mode,
    a = t.child;
  t = a.sibling;
  var l = {
    mode: "hidden",
    children: n
  };
  return !(s & 2) && e.child !== a ? (n = e.child, n.childLanes = 0, n.pendingProps = l, a = n.lastEffect, a !== null ? (e.firstEffect = n.firstEffect, e.lastEffect = a, a.nextEffect = null) : e.firstEffect = e.lastEffect = null) : n = Tg$1(a, l), t !== null ? r = Tg$1(t, r) : (r = Xg$1(r, s, i, null), r.flags |= 2), r.return = e, n.return = e, n.sibling = r, e.child = n, r;
}
o(wi, "wi");
function yi$1(t, e) {
  t.lanes |= e;
  var n = t.alternate;
  n !== null && (n.lanes |= e), sg$1(t.return, e);
}
o(yi$1, "yi");
function zi$1(t, e, n, r, i, s) {
  var a = t.memoizedState;
  a === null ? t.memoizedState = {
    isBackwards: e,
    rendering: null,
    renderingStartTime: 0,
    last: r,
    tail: n,
    tailMode: i,
    lastEffect: s
  } : (a.isBackwards = e, a.rendering = null, a.renderingStartTime = 0, a.last = r, a.tail = n, a.tailMode = i, a.lastEffect = s);
}
o(zi$1, "zi");
function Ai$1(t, e, n) {
  var r = e.pendingProps,
    i = r.revealOrder,
    s = r.tail;
  if (fi(t, e, r.children, n), r = qe.current, r & 2) r = r & 1 | 2, e.flags |= 64;else {
    if (t !== null && t.flags & 64) e: for (t = e.child; t !== null;) {
      if (t.tag === 13) t.memoizedState !== null && yi$1(t, n);else if (t.tag === 19) yi$1(t, n);else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === e) break e;
      for (; t.sibling === null;) {
        if (t.return === null || t.return === e) break e;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    r &= 1;
  }
  if (I$1(qe, r), !(e.mode & 2)) e.memoizedState = null;else switch (i) {
    case "forwards":
      for (n = e.child, i = null; n !== null;) t = n.alternate, t !== null && ih$1(t) === null && (i = n), n = n.sibling;
      n = i, n === null ? (i = e.child, e.child = null) : (i = n.sibling, n.sibling = null), zi$1(e, !1, i, n, s, e.lastEffect);
      break;
    case "backwards":
      for (n = null, i = e.child, e.child = null; i !== null;) {
        if (t = i.alternate, t !== null && ih$1(t) === null) {
          e.child = i;
          break;
        }
        t = i.sibling, i.sibling = n, n = i, i = t;
      }
      zi$1(e, !0, n, null, s, e.lastEffect);
      break;
    case "together":
      zi$1(e, !1, null, null, void 0, e.lastEffect);
      break;
    default:
      e.memoizedState = null;
  }
  return e.child;
}
o(Ai$1, "Ai");
function hi$1(t, e, n) {
  if (t !== null && (e.dependencies = t.dependencies), ko |= e.lanes, n & e.childLanes) {
    if (t !== null && e.child !== t.child) throw Error(y$1(153));
    if (e.child !== null) {
      for (t = e.child, n = Tg$1(t, t.pendingProps), e.child = n, n.return = e; t.sibling !== null;) t = t.sibling, n = n.sibling = Tg$1(t, t.pendingProps), n.return = e;
      n.sibling = null;
    }
    return e.child;
  }
  return null;
}
o(hi$1, "hi");
var H0, cf, U0, q0;
H0 = o(function (t, e) {
  for (var n = e.child; n !== null;) {
    if (n.tag === 5 || n.tag === 6) t.appendChild(n.stateNode);else if (n.tag !== 4 && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === e) break;
    for (; n.sibling === null;) {
      if (n.return === null || n.return === e) return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
}, "Bi");
cf = o(function () {}, "Ci");
U0 = o(function (t, e, n, r) {
  var i = t.memoizedProps;
  if (i !== r) {
    t = e.stateNode, dh$1(En.current);
    var s = null;
    switch (n) {
      case "input":
        i = Ya$1(t, i), r = Ya$1(t, r), s = [];
        break;
      case "option":
        i = eb$1(t, i), r = eb$1(t, r), s = [];
        break;
      case "select":
        i = ze({}, i, {
          value: void 0
        }), r = ze({}, r, {
          value: void 0
        }), s = [];
        break;
      case "textarea":
        i = gb$1(t, i), r = gb$1(t, r), s = [];
        break;
      default:
        typeof i.onClick != "function" && typeof r.onClick == "function" && (t.onclick = jf$1);
    }
    vb$1(n, r);
    var a;
    n = null;
    for (c in i) if (!r.hasOwnProperty(c) && i.hasOwnProperty(c) && i[c] != null) if (c === "style") {
      var l = i[c];
      for (a in l) l.hasOwnProperty(a) && (n || (n = {}), n[a] = "");
    } else c !== "dangerouslySetInnerHTML" && c !== "children" && c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && c !== "autoFocus" && (Vs.hasOwnProperty(c) ? s || (s = []) : (s = s || []).push(c, null));
    for (c in r) {
      var u = r[c];
      if (l = i != null ? i[c] : void 0, r.hasOwnProperty(c) && u !== l && (u != null || l != null)) if (c === "style") {
        if (l) {
          for (a in l) !l.hasOwnProperty(a) || u && u.hasOwnProperty(a) || (n || (n = {}), n[a] = "");
          for (a in u) u.hasOwnProperty(a) && l[a] !== u[a] && (n || (n = {}), n[a] = u[a]);
        } else n || (s || (s = []), s.push(c, n)), n = u;
      } else c === "dangerouslySetInnerHTML" ? (u = u ? u.__html : void 0, l = l ? l.__html : void 0, u != null && l !== u && (s = s || []).push(c, u)) : c === "children" ? typeof u != "string" && typeof u != "number" || (s = s || []).push(c, "" + u) : c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && (Vs.hasOwnProperty(c) ? (u != null && c === "onScroll" && G("scroll", t), s || l === u || (s = [])) : typeof u == "object" && u !== null && u.$$typeof === hd ? u.toString() : (s = s || []).push(c, u));
    }
    n && (s = s || []).push("style", n);
    var c = s;
    (e.updateQueue = c) && (e.flags |= 4);
  }
}, "Di");
q0 = o(function (t, e, n, r) {
  n !== r && (e.flags |= 4);
}, "Ei");
function Fi$1(t, e) {
  if (!Tn) switch (t.tailMode) {
    case "hidden":
      e = t.tail;
      for (var n = null; e !== null;) e.alternate !== null && (n = e), e = e.sibling;
      n === null ? t.tail = null : n.sibling = null;
      break;
    case "collapsed":
      n = t.tail;
      for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
      r === null ? e || t.tail === null ? t.tail = null : t.tail.sibling = null : r.sibling = null;
  }
}
o(Fi$1, "Fi");
function Gi(t, e, n) {
  var r = e.pendingProps;
  switch (e.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;
    case 1:
      return Ff$1(e.type) && Gf(), null;
    case 3:
      return fh$1(), H$1(Mt), H$1(Et), uh$1(), r = e.stateNode, r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (t === null || t.child === null) && (rh$1(e) ? e.flags |= 4 : r.hydrate || (e.flags |= 256)), cf(e), null;
    case 5:
      hh$1(e);
      var i = dh$1(ro.current);
      if (n = e.type, t !== null && e.stateNode != null) U0(t, e, n, r, i), t.ref !== e.ref && (e.flags |= 128);else {
        if (!r) {
          if (e.stateNode === null) throw Error(y$1(166));
          return null;
        }
        if (t = dh$1(En.current), rh$1(e)) {
          r = e.stateNode, n = e.type;
          var s = e.memoizedProps;
          switch (r[Wn] = e, r[Oa] = s, n) {
            case "dialog":
              G("cancel", r), G("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              G("load", r);
              break;
            case "video":
            case "audio":
              for (t = 0; t < Es.length; t++) G(Es[t], r);
              break;
            case "source":
              G("error", r);
              break;
            case "img":
            case "image":
            case "link":
              G("error", r), G("load", r);
              break;
            case "details":
              G("toggle", r);
              break;
            case "input":
              Za$1(r, s), G("invalid", r);
              break;
            case "select":
              r._wrapperState = {
                wasMultiple: !!s.multiple
              }, G("invalid", r);
              break;
            case "textarea":
              hb$1(r, s), G("invalid", r);
          }
          vb$1(n, s), t = null;
          for (var a in s) s.hasOwnProperty(a) && (i = s[a], a === "children" ? typeof i == "string" ? r.textContent !== i && (t = ["children", i]) : typeof i == "number" && r.textContent !== "" + i && (t = ["children", "" + i]) : Vs.hasOwnProperty(a) && i != null && a === "onScroll" && G("scroll", r));
          switch (n) {
            case "input":
              Va$1(r), cb$1(r, s, !0);
              break;
            case "textarea":
              Va$1(r), jb(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof s.onClick == "function" && (r.onclick = jf$1);
          }
          r = t, e.updateQueue = r, r !== null && (e.flags |= 4);
        } else {
          switch (a = i.nodeType === 9 ? i : i.ownerDocument, t === zc.html && (t = lb$1(n)), t === zc.html ? n === "script" ? (t = a.createElement("div"), t.innerHTML = "<script><\/script>", t = t.removeChild(t.firstChild)) : typeof r.is == "string" ? t = a.createElement(n, {
            is: r.is
          }) : (t = a.createElement(n), n === "select" && (a = t, r.multiple ? a.multiple = !0 : r.size && (a.size = r.size))) : t = a.createElementNS(t, n), t[Wn] = e, t[Oa] = r, H0(t, e, !1, !1), e.stateNode = t, a = wb$1(n, r), n) {
            case "dialog":
              G("cancel", t), G("close", t), i = r;
              break;
            case "iframe":
            case "object":
            case "embed":
              G("load", t), i = r;
              break;
            case "video":
            case "audio":
              for (i = 0; i < Es.length; i++) G(Es[i], t);
              i = r;
              break;
            case "source":
              G("error", t), i = r;
              break;
            case "img":
            case "image":
            case "link":
              G("error", t), G("load", t), i = r;
              break;
            case "details":
              G("toggle", t), i = r;
              break;
            case "input":
              Za$1(t, r), i = Ya$1(t, r), G("invalid", t);
              break;
            case "option":
              i = eb$1(t, r);
              break;
            case "select":
              t._wrapperState = {
                wasMultiple: !!r.multiple
              }, i = ze({}, r, {
                value: void 0
              }), G("invalid", t);
              break;
            case "textarea":
              hb$1(t, r), i = gb$1(t, r), G("invalid", t);
              break;
            default:
              i = r;
          }
          vb$1(n, i);
          var l = i;
          for (s in l) if (l.hasOwnProperty(s)) {
            var u = l[s];
            s === "style" ? tb$1(t, u) : s === "dangerouslySetInnerHTML" ? (u = u ? u.__html : void 0, u != null && Fv(t, u)) : s === "children" ? typeof u == "string" ? (n !== "textarea" || u !== "") && pb$1(t, u) : typeof u == "number" && pb$1(t, "" + u) : s !== "suppressContentEditableWarning" && s !== "suppressHydrationWarning" && s !== "autoFocus" && (Vs.hasOwnProperty(s) ? u != null && s === "onScroll" && G("scroll", t) : u != null && qa$1(t, s, u, a));
          }
          switch (n) {
            case "input":
              Va$1(t), cb$1(t, r, !1);
              break;
            case "textarea":
              Va$1(t), jb(t);
              break;
            case "option":
              r.value != null && t.setAttribute("value", "" + Sa$1(r.value));
              break;
            case "select":
              t.multiple = !!r.multiple, s = r.value, s != null ? fb$1(t, !!r.multiple, s, !1) : r.defaultValue != null && fb$1(t, !!r.multiple, r.defaultValue, !0);
              break;
            default:
              typeof i.onClick == "function" && (t.onclick = jf$1);
          }
          mf$1(n, r) && (e.flags |= 4);
        }
        e.ref !== null && (e.flags |= 128);
      }
      return null;
    case 6:
      if (t && e.stateNode != null) q0(t, e, t.memoizedProps, r);else {
        if (typeof r != "string" && e.stateNode === null) throw Error(y$1(166));
        n = dh$1(ro.current), dh$1(En.current), rh$1(e) ? (r = e.stateNode, n = e.memoizedProps, r[Wn] = e, r.nodeValue !== n && (e.flags |= 4)) : (r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[Wn] = e, e.stateNode = r);
      }
      return null;
    case 13:
      return H$1(qe), r = e.memoizedState, e.flags & 64 ? (e.lanes = n, e) : (r = r !== null, n = !1, t === null ? e.memoizedProps.fallback !== void 0 && rh$1(e) : n = t.memoizedState !== null, r && !n && e.mode & 2 && (t === null && e.memoizedProps.unstable_avoidThisFallback !== !0 || qe.current & 1 ? ft === 0 && (ft = 3) : ((ft === 0 || ft === 3) && (ft = 4), Ct === null || !(ko & 134217727) && !($i & 134217727) || Ii$1(Ct, St))), (r || n) && (e.flags |= 4), null);
    case 4:
      return fh$1(), cf(e), t === null && cf$1(e.stateNode.containerInfo), null;
    case 10:
      return rg$1(e), null;
    case 17:
      return Ff$1(e.type) && Gf(), null;
    case 19:
      if (H$1(qe), r = e.memoizedState, r === null) return null;
      if (s = (e.flags & 64) !== 0, a = r.rendering, a === null) {
        if (s) Fi$1(r, !1);else {
          if (ft !== 0 || t !== null && t.flags & 64) for (t = e.child; t !== null;) {
            if (a = ih$1(t), a !== null) {
              for (e.flags |= 64, Fi$1(r, !1), s = a.updateQueue, s !== null && (e.updateQueue = s, e.flags |= 4), r.lastEffect === null && (e.firstEffect = null), e.lastEffect = r.lastEffect, r = n, n = e.child; n !== null;) s = n, t = r, s.flags &= 2, s.nextEffect = null, s.firstEffect = null, s.lastEffect = null, a = s.alternate, a === null ? (s.childLanes = 0, s.lanes = t, s.child = null, s.memoizedProps = null, s.memoizedState = null, s.updateQueue = null, s.dependencies = null, s.stateNode = null) : (s.childLanes = a.childLanes, s.lanes = a.lanes, s.child = a.child, s.memoizedProps = a.memoizedProps, s.memoizedState = a.memoizedState, s.updateQueue = a.updateQueue, s.type = a.type, t = a.dependencies, s.dependencies = t === null ? null : {
                lanes: t.lanes,
                firstContext: t.firstContext
              }), n = n.sibling;
              return I$1(qe, qe.current & 1 | 2), e.child;
            }
            t = t.sibling;
          }
          r.tail !== null && bt() > gf && (e.flags |= 64, s = !0, Fi$1(r, !1), e.lanes = 33554432);
        }
      } else {
        if (!s) if (t = ih$1(a), t !== null) {
          if (e.flags |= 64, s = !0, n = t.updateQueue, n !== null && (e.updateQueue = n, e.flags |= 4), Fi$1(r, !0), r.tail === null && r.tailMode === "hidden" && !a.alternate && !Tn) return e = e.lastEffect = r.lastEffect, e !== null && (e.nextEffect = null), null;
        } else 2 * bt() - r.renderingStartTime > gf && n !== 1073741824 && (e.flags |= 64, s = !0, Fi$1(r, !1), e.lanes = 33554432);
        r.isBackwards ? (a.sibling = e.child, e.child = a) : (n = r.last, n !== null ? n.sibling = a : e.child = a, r.last = a);
      }
      return r.tail !== null ? (n = r.tail, r.rendering = n, r.tail = n.sibling, r.lastEffect = e.lastEffect, r.renderingStartTime = bt(), n.sibling = null, e = qe.current, I$1(qe, s ? e & 1 | 2 : e & 1), n) : null;
    case 23:
    case 24:
      return Ki$1(), t !== null && t.memoizedState !== null != (e.memoizedState !== null) && r.mode !== "unstable-defer-without-hiding" && (e.flags |= 4), null;
  }
  throw Error(y$1(156, e.tag));
}
o(Gi, "Gi");
function Li(t) {
  switch (t.tag) {
    case 1:
      Ff$1(t.type) && Gf();
      var e = t.flags;
      return e & 4096 ? (t.flags = e & -4097 | 64, t) : null;
    case 3:
      if (fh$1(), H$1(Mt), H$1(Et), uh$1(), e = t.flags, e & 64) throw Error(y$1(285));
      return t.flags = e & -4097 | 64, t;
    case 5:
      return hh$1(t), null;
    case 13:
      return H$1(qe), e = t.flags, e & 4096 ? (t.flags = e & -4097 | 64, t) : null;
    case 19:
      return H$1(qe), null;
    case 4:
      return fh$1(), null;
    case 10:
      return rg$1(t), null;
    case 23:
    case 24:
      return Ki$1(), null;
    default:
      return null;
  }
}
o(Li, "Li");
function Mi$1(t, e) {
  try {
    var n = "",
      r = e;
    do n += Qa$1(r), r = r.return; while (r);
    var i = n;
  } catch (s) {
    i = `
Error generating stack: ` + s.message + `
` + s.stack;
  }
  return {
    value: t,
    source: e,
    stack: i
  };
}
o(Mi$1, "Mi");
function Ni$1(t, e) {
  try {
    console.error(e.value);
  } catch (n) {
    setTimeout(function () {
      throw n;
    });
  }
}
o(Ni$1, "Ni");
var gP = typeof WeakMap == "function" ? WeakMap : Map;
function Pi$1(t, e, n) {
  n = zg$1(-1, n), n.tag = 3, n.payload = {
    element: null
  };
  var r = e.value;
  return n.callback = function () {
    Ua || (Ua = !0, yf = r), Ni$1(t, e);
  }, n;
}
o(Pi$1, "Pi");
function Si(t, e, n) {
  n = zg$1(-1, n), n.tag = 3;
  var r = t.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var i = e.value;
    n.payload = function () {
      return Ni$1(t, e), r(i);
    };
  }
  var s = t.stateNode;
  return s !== null && typeof s.componentDidCatch == "function" && (n.callback = function () {
    typeof r != "function" && (bn === null ? bn = new Set([this]) : bn.add(this), Ni$1(t, e));
    var a = e.stack;
    this.componentDidCatch(e.value, {
      componentStack: a !== null ? a : ""
    });
  }), n;
}
o(Si, "Si");
var yP = typeof WeakSet == "function" ? WeakSet : Set;
function Vi(t) {
  var e = t.ref;
  if (e !== null) if (typeof e == "function") try {
    e(null);
  } catch (n) {
    Wi(t, n);
  } else e.current = null;
}
o(Vi, "Vi");
function Xi$1(t, e) {
  switch (e.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      return;
    case 1:
      if (e.flags & 256 && t !== null) {
        var n = t.memoizedProps,
          r = t.memoizedState;
        t = e.stateNode, e = t.getSnapshotBeforeUpdate(e.elementType === e.type ? n : lg$1(e.type, n), r), t.__reactInternalSnapshotBeforeUpdate = e;
      }
      return;
    case 3:
      e.flags & 256 && qf(e.stateNode.containerInfo);
      return;
    case 5:
    case 6:
    case 4:
    case 17:
      return;
  }
  throw Error(y$1(163));
}
o(Xi$1, "Xi");
function Yi$1(t, e, n) {
  switch (n.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      if (e = n.updateQueue, e = e !== null ? e.lastEffect : null, e !== null) {
        t = e = e.next;
        do {
          if ((t.tag & 3) === 3) {
            var r = t.create;
            t.destroy = r();
          }
          t = t.next;
        } while (t !== e);
      }
      if (e = n.updateQueue, e = e !== null ? e.lastEffect : null, e !== null) {
        t = e = e.next;
        do {
          var i = t;
          r = i.next, i = i.tag, i & 4 && i & 1 && (Zi$1(n, t), $i$1(n, t)), t = r;
        } while (t !== e);
      }
      return;
    case 1:
      t = n.stateNode, n.flags & 4 && (e === null ? t.componentDidMount() : (r = n.elementType === n.type ? e.memoizedProps : lg$1(n.type, e.memoizedProps), t.componentDidUpdate(r, e.memoizedState, t.__reactInternalSnapshotBeforeUpdate))), e = n.updateQueue, e !== null && Eg$1(n, e, t);
      return;
    case 3:
      if (e = n.updateQueue, e !== null) {
        if (t = null, n.child !== null) switch (n.child.tag) {
          case 5:
            t = n.child.stateNode;
            break;
          case 1:
            t = n.child.stateNode;
        }
        Eg$1(n, e, t);
      }
      return;
    case 5:
      t = n.stateNode, e === null && n.flags & 4 && mf$1(n.type, n.memoizedProps) && t.focus();
      return;
    case 6:
      return;
    case 4:
      return;
    case 12:
      return;
    case 13:
      n.memoizedState === null && (n = n.alternate, n !== null && (n = n.memoizedState, n !== null && (n = n.dehydrated, n !== null && Cc$1(n))));
      return;
    case 19:
    case 17:
    case 20:
    case 21:
    case 23:
    case 24:
      return;
  }
  throw Error(y$1(163));
}
o(Yi$1, "Yi");
function aj(t, e) {
  for (var n = t;;) {
    if (n.tag === 5) {
      var r = n.stateNode;
      if (e) r = r.style, typeof r.setProperty == "function" ? r.setProperty("display", "none", "important") : r.display = "none";else {
        r = n.stateNode;
        var i = n.memoizedProps.style;
        i = i != null && i.hasOwnProperty("display") ? i.display : null, r.style.display = sb$1("display", i);
      }
    } else if (n.tag === 6) n.stateNode.nodeValue = e ? "" : n.memoizedProps;else if ((n.tag !== 23 && n.tag !== 24 || n.memoizedState === null || n === t) && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null;) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
}
o(aj, "aj");
function bj(t, e) {
  if (_r && typeof _r.onCommitFiberUnmount == "function") try {
    _r.onCommitFiberUnmount(Ad, e);
  } catch {}
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      if (t = e.updateQueue, t !== null && (t = t.lastEffect, t !== null)) {
        var n = t = t.next;
        do {
          var r = n,
            i = r.destroy;
          if (r = r.tag, i !== void 0) if (r & 4) Zi$1(e, n);else {
            r = e;
            try {
              i();
            } catch (s) {
              Wi(r, s);
            }
          }
          n = n.next;
        } while (n !== t);
      }
      break;
    case 1:
      if (Vi(e), t = e.stateNode, typeof t.componentWillUnmount == "function") try {
        t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
      } catch (s) {
        Wi(e, s);
      }
      break;
    case 5:
      Vi(e);
      break;
    case 4:
      cj(t, e);
  }
}
o(bj, "bj");
function dj(t) {
  t.alternate = null, t.child = null, t.dependencies = null, t.firstEffect = null, t.lastEffect = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.return = null, t.updateQueue = null;
}
o(dj, "dj");
function ej(t) {
  return t.tag === 5 || t.tag === 3 || t.tag === 4;
}
o(ej, "ej");
function fj(t) {
  e: {
    for (var e = t.return; e !== null;) {
      if (ej(e)) break e;
      e = e.return;
    }
    throw Error(y$1(160));
  }
  var n = e;
  switch (e = n.stateNode, n.tag) {
    case 5:
      var r = !1;
      break;
    case 3:
      e = e.containerInfo, r = !0;
      break;
    case 4:
      e = e.containerInfo, r = !0;
      break;
    default:
      throw Error(y$1(161));
  }
  n.flags & 16 && (pb$1(e, ""), n.flags &= -17);
  e: t: for (n = t;;) {
    for (; n.sibling === null;) {
      if (n.return === null || ej(n.return)) {
        n = null;
        break e;
      }
      n = n.return;
    }
    for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18;) {
      if (n.flags & 2 || n.child === null || n.tag === 4) continue t;
      n.child.return = n, n = n.child;
    }
    if (!(n.flags & 2)) {
      n = n.stateNode;
      break e;
    }
  }
  r ? gj(t, n, e) : hj(t, n, e);
}
o(fj, "fj");
function gj(t, e, n) {
  var r = t.tag,
    i = r === 5 || r === 6;
  if (i) t = i ? t.stateNode : t.stateNode.instance, e ? n.nodeType === 8 ? n.parentNode.insertBefore(t, e) : n.insertBefore(t, e) : (n.nodeType === 8 ? (e = n.parentNode, e.insertBefore(t, n)) : (e = n, e.appendChild(t)), n = n._reactRootContainer, n != null || e.onclick !== null || (e.onclick = jf$1));else if (r !== 4 && (t = t.child, t !== null)) for (gj(t, e, n), t = t.sibling; t !== null;) gj(t, e, n), t = t.sibling;
}
o(gj, "gj");
function hj(t, e, n) {
  var r = t.tag,
    i = r === 5 || r === 6;
  if (i) t = i ? t.stateNode : t.stateNode.instance, e ? n.insertBefore(t, e) : n.appendChild(t);else if (r !== 4 && (t = t.child, t !== null)) for (hj(t, e, n), t = t.sibling; t !== null;) hj(t, e, n), t = t.sibling;
}
o(hj, "hj");
function cj(t, e) {
  for (var n = e, r = !1, i, s;;) {
    if (!r) {
      r = n.return;
      e: for (;;) {
        if (r === null) throw Error(y$1(160));
        switch (i = r.stateNode, r.tag) {
          case 5:
            s = !1;
            break e;
          case 3:
            i = i.containerInfo, s = !0;
            break e;
          case 4:
            i = i.containerInfo, s = !0;
            break e;
        }
        r = r.return;
      }
      r = !0;
    }
    if (n.tag === 5 || n.tag === 6) {
      e: for (var a = t, l = n, u = l;;) if (bj(a, u), u.child !== null && u.tag !== 4) u.child.return = u, u = u.child;else {
        if (u === l) break e;
        for (; u.sibling === null;) {
          if (u.return === null || u.return === l) break e;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      s ? (a = i, l = n.stateNode, a.nodeType === 8 ? a.parentNode.removeChild(l) : a.removeChild(l)) : i.removeChild(n.stateNode);
    } else if (n.tag === 4) {
      if (n.child !== null) {
        i = n.stateNode.containerInfo, s = !0, n.child.return = n, n = n.child;
        continue;
      }
    } else if (bj(t, n), n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === e) break;
    for (; n.sibling === null;) {
      if (n.return === null || n.return === e) return;
      n = n.return, n.tag === 4 && (r = !1);
    }
    n.sibling.return = n.return, n = n.sibling;
  }
}
o(cj, "cj");
function ij(t, e) {
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      var n = e.updateQueue;
      if (n = n !== null ? n.lastEffect : null, n !== null) {
        var r = n = n.next;
        do (r.tag & 3) === 3 && (t = r.destroy, r.destroy = void 0, t !== void 0 && t()), r = r.next; while (r !== n);
      }
      return;
    case 1:
      return;
    case 5:
      if (n = e.stateNode, n != null) {
        r = e.memoizedProps;
        var i = t !== null ? t.memoizedProps : r;
        t = e.type;
        var s = e.updateQueue;
        if (e.updateQueue = null, s !== null) {
          for (n[Oa] = r, t === "input" && r.type === "radio" && r.name != null && $a$1(n, r), wb$1(t, i), e = wb$1(t, r), i = 0; i < s.length; i += 2) {
            var a = s[i],
              l = s[i + 1];
            a === "style" ? tb$1(n, l) : a === "dangerouslySetInnerHTML" ? Fv(n, l) : a === "children" ? pb$1(n, l) : qa$1(n, a, l, e);
          }
          switch (t) {
            case "input":
              ab$1(n, r);
              break;
            case "textarea":
              ib$1(n, r);
              break;
            case "select":
              t = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!r.multiple, s = r.value, s != null ? fb$1(n, !!r.multiple, s, !1) : t !== !!r.multiple && (r.defaultValue != null ? fb$1(n, !!r.multiple, r.defaultValue, !0) : fb$1(n, !!r.multiple, r.multiple ? [] : "", !1));
          }
        }
      }
      return;
    case 6:
      if (e.stateNode === null) throw Error(y$1(162));
      e.stateNode.nodeValue = e.memoizedProps;
      return;
    case 3:
      n = e.stateNode, n.hydrate && (n.hydrate = !1, Cc$1(n.containerInfo));
      return;
    case 12:
      return;
    case 13:
      e.memoizedState !== null && (Vd = bt(), aj(e.child, !0)), kj(e);
      return;
    case 19:
      kj(e);
      return;
    case 17:
      return;
    case 23:
    case 24:
      aj(e, e.memoizedState !== null);
      return;
  }
  throw Error(y$1(163));
}
o(ij, "ij");
function kj(t) {
  var e = t.updateQueue;
  if (e !== null) {
    t.updateQueue = null;
    var n = t.stateNode;
    n === null && (n = t.stateNode = new yP()), e.forEach(function (r) {
      var i = lj.bind(null, t, r);
      n.has(r) || (n.add(r), r.then(i, i));
    });
  }
}
o(kj, "kj");
function mj(t, e) {
  return t !== null && (t = t.memoizedState, t === null || t.dehydrated !== null) ? (e = e.memoizedState, e !== null && e.dehydrated === null) : !1;
}
o(mj, "mj");
var SP = Math.ceil,
  Ha = jr.ReactCurrentDispatcher,
  Ud = jr.ReactCurrentOwner,
  me = 0,
  Ct = null,
  rt = null,
  St = 0,
  Lr = 0,
  hf = Bf$1(0),
  ft = 0,
  Il = null,
  Ni = 0,
  ko = 0,
  $i = 0,
  qd = 0,
  mf = null,
  Vd = 0,
  gf = 1 / 0;
function wj() {
  gf = bt() + 500;
}
o(wj, "wj");
var oe = null,
  Ua = !1,
  yf = null,
  bn = null,
  lr = !1,
  $s = null,
  Ts = 90,
  vf = [],
  wf = [],
  Dn = null,
  Fs = 0,
  bf = null,
  la = -1,
  kn = 0,
  ua = 0,
  js = null,
  ca = !1;
function Hg$1() {
  return me & 48 ? bt() : la !== -1 ? la : la = bt();
}
o(Hg$1, "Hg");
function Ig$1(t) {
  if (t = t.mode, !(t & 2)) return 1;
  if (!(t & 4)) return eg$1() === 99 ? 1 : 2;
  if (kn === 0 && (kn = Ni), lP.transition !== 0) {
    ua !== 0 && (ua = mf !== null ? mf.pendingLanes : 0), t = kn;
    var e = 4186112 & ~ua;
    return e &= -e, e === 0 && (t = 4186112 & ~t, e = t & -t, e === 0 && (e = 8192)), e;
  }
  return t = eg$1(), me & 4 && t === 98 ? t = Xc$1(12, kn) : (t = Sc$1(t), t = Xc$1(t, kn)), t;
}
o(Ig$1, "Ig");
function Jg$1(t, e, n) {
  if (50 < Fs) throw Fs = 0, bf = null, Error(y$1(185));
  if (t = Kj(t, e), t === null) return null;
  $c(t, e, n), t === Ct && ($i |= e, ft === 4 && Ii$1(t, St));
  var r = eg$1();
  e === 1 ? me & 8 && !(me & 48) ? Lj(t) : (Mj(t, n), me === 0 && (wj(), ig$1())) : (!(me & 4) || r !== 98 && r !== 99 || (Dn === null ? Dn = new Set([t]) : Dn.add(t)), Mj(t, n)), mf = t;
}
o(Jg$1, "Jg");
function Kj(t, e) {
  t.lanes |= e;
  var n = t.alternate;
  for (n !== null && (n.lanes |= e), n = t, t = t.return; t !== null;) t.childLanes |= e, n = t.alternate, n !== null && (n.childLanes |= e), n = t, t = t.return;
  return n.tag === 3 ? n.stateNode : null;
}
o(Kj, "Kj");
function Mj(t, e) {
  for (var n = t.callbackNode, r = t.suspendedLanes, i = t.pingedLanes, s = t.expirationTimes, a = t.pendingLanes; 0 < a;) {
    var l = 31 - or(a),
      u = 1 << l,
      c = s[l];
    if (c === -1) {
      if (!(u & r) || u & i) {
        c = e, Rc$1(u);
        var p = Ne;
        s[l] = 10 <= p ? c + 250 : 6 <= p ? c + 5e3 : -1;
      }
    } else c <= e && (t.expiredLanes |= u);
    a &= ~u;
  }
  if (r = Uc(t, t === Ct ? St : 0), e = Ne, r === 0) n !== null && (n !== rc && tf(n), t.callbackNode = null, t.callbackPriority = 0);else {
    if (n !== null) {
      if (t.callbackPriority === e) return;
      n !== rc && tf(n);
    }
    e === 15 ? (n = Lj.bind(null, t), xn === null ? (xn = [n], aa = Ld(Ml, jg$1)) : xn.push(n), n = rc) : e === 14 ? n = hg$1(99, Lj.bind(null, t)) : (n = Tc$1(e), n = hg$1(n, Nj.bind(null, t))), t.callbackPriority = e, t.callbackNode = n;
  }
}
o(Mj, "Mj");
function Nj(t) {
  if (la = -1, ua = kn = 0, me & 48) throw Error(y$1(327));
  var e = t.callbackNode;
  if (Oj() && t.callbackNode !== e) return null;
  var n = Uc(t, t === Ct ? St : 0);
  if (n === 0) return null;
  var r = n,
    i = me;
  me |= 16;
  var s = Pj();
  (Ct !== t || St !== r) && (wj(), Qj(t, r));
  do try {
    Rj();
    break;
  } catch (l) {
    Sj(t, l);
  } while (1);
  if (qg$1(), Ha.current = s, me = i, rt !== null ? r = 0 : (Ct = null, St = 0, r = ft), Ni & $i) Qj(t, 0);else if (r !== 0) {
    if (r === 2 && (me |= 64, t.hydrate && (t.hydrate = !1, qf(t.containerInfo)), n = Wc$1(t), n !== 0 && (r = Tj(t, n))), r === 1) throw e = Il, Qj(t, 0), Ii$1(t, n), Mj(t, bt()), e;
    switch (t.finishedWork = t.current.alternate, t.finishedLanes = n, r) {
      case 0:
      case 1:
        throw Error(y$1(345));
      case 2:
        Uj(t);
        break;
      case 3:
        if (Ii$1(t, n), (n & 62914560) === n && (r = Vd + 500 - bt(), 10 < r)) {
          if (Uc(t, 0) !== 0) break;
          if (i = t.suspendedLanes, (i & n) !== n) {
            Hg$1(), t.pingedLanes |= t.suspendedLanes & i;
            break;
          }
          t.timeoutHandle = Em(Uj.bind(null, t), r);
          break;
        }
        Uj(t);
        break;
      case 4:
        if (Ii$1(t, n), (n & 4186112) === n) break;
        for (r = t.eventTimes, i = -1; 0 < n;) {
          var a = 31 - or(n);
          s = 1 << a, a = r[a], a > i && (i = a), n &= ~s;
        }
        if (n = i, n = bt() - n, n = (120 > n ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * SP(n / 1960)) - n, 10 < n) {
          t.timeoutHandle = Em(Uj.bind(null, t), n);
          break;
        }
        Uj(t);
        break;
      case 5:
        Uj(t);
        break;
      default:
        throw Error(y$1(329));
    }
  }
  return Mj(t, bt()), t.callbackNode === e ? Nj.bind(null, t) : null;
}
o(Nj, "Nj");
function Ii$1(t, e) {
  for (e &= ~qd, e &= ~$i, t.suspendedLanes |= e, t.pingedLanes &= ~e, t = t.expirationTimes; 0 < e;) {
    var n = 31 - or(e),
      r = 1 << n;
    t[n] = -1, e &= ~r;
  }
}
o(Ii$1, "Ii");
function Lj(t) {
  if (me & 48) throw Error(y$1(327));
  if (Oj(), t === Ct && t.expiredLanes & St) {
    var e = St,
      n = Tj(t, e);
    Ni & $i && (e = Uc(t, e), n = Tj(t, e));
  } else e = Uc(t, 0), n = Tj(t, e);
  if (t.tag !== 0 && n === 2 && (me |= 64, t.hydrate && (t.hydrate = !1, qf(t.containerInfo)), e = Wc$1(t), e !== 0 && (n = Tj(t, e))), n === 1) throw n = Il, Qj(t, 0), Ii$1(t, e), Mj(t, bt()), n;
  return t.finishedWork = t.current.alternate, t.finishedLanes = e, Uj(t), Mj(t, bt()), null;
}
o(Lj, "Lj");
function Vj() {
  if (Dn !== null) {
    var t = Dn;
    Dn = null, t.forEach(function (e) {
      e.expiredLanes |= 24 & e.pendingLanes, Mj(e, bt());
    });
  }
  ig$1();
}
o(Vj, "Vj");
function Wj(t, e) {
  var n = me;
  me |= 1;
  try {
    return t(e);
  } finally {
    me = n, me === 0 && (wj(), ig$1());
  }
}
o(Wj, "Wj");
function Xj(t, e) {
  var n = me;
  me &= -2, me |= 8;
  try {
    return t(e);
  } finally {
    me = n, me === 0 && (wj(), ig$1());
  }
}
o(Xj, "Xj");
function ni(t, e) {
  I$1(hf, Lr), Lr |= e, Ni |= e;
}
o(ni, "ni");
function Ki$1() {
  Lr = hf.current, H$1(hf);
}
o(Ki$1, "Ki");
function Qj(t, e) {
  t.finishedWork = null, t.finishedLanes = 0;
  var n = t.timeoutHandle;
  if (n !== -1 && (t.timeoutHandle = -1, nP(n)), rt !== null) for (n = rt.return; n !== null;) {
    var r = n;
    switch (r.tag) {
      case 1:
        r = r.type.childContextTypes, r != null && Gf();
        break;
      case 3:
        fh$1(), H$1(Mt), H$1(Et), uh$1();
        break;
      case 5:
        hh$1(r);
        break;
      case 4:
        fh$1();
        break;
      case 13:
        H$1(qe);
        break;
      case 19:
        H$1(qe);
        break;
      case 10:
        rg$1(r);
        break;
      case 23:
      case 24:
        Ki$1();
    }
    n = n.return;
  }
  Ct = t, rt = Tg$1(t.current, null), St = Lr = Ni = e, ft = 0, Il = null, qd = $i = ko = 0;
}
o(Qj, "Qj");
function Sj(t, e) {
  do {
    var n = rt;
    try {
      if (qg$1(), Rs.current = za, $a) {
        for (var r = Ye.memoizedState; r !== null;) {
          var i = r.queue;
          i !== null && (i.pending = null), r = r.next;
        }
        $a = !1;
      }
      if (io = 0, ct = wt = Ye = null, Ns = !1, Ud.current = null, n === null || n.return === null) {
        ft = 1, Il = e, rt = null;
        break;
      }
      e: {
        var s = t,
          a = n.return,
          l = n,
          u = e;
        if (e = St, l.flags |= 2048, l.firstEffect = l.lastEffect = null, u !== null && typeof u == "object" && typeof u.then == "function") {
          var c = u;
          if (!(l.mode & 2)) {
            var p = l.alternate;
            p ? (l.updateQueue = p.updateQueue, l.memoizedState = p.memoizedState, l.lanes = p.lanes) : (l.updateQueue = null, l.memoizedState = null);
          }
          var m = (qe.current & 1) !== 0,
            d = a;
          do {
            var y;
            if (y = d.tag === 13) {
              var S = d.memoizedState;
              if (S !== null) y = S.dehydrated !== null;else {
                var w = d.memoizedProps;
                y = w.fallback === void 0 ? !1 : w.unstable_avoidThisFallback !== !0 ? !0 : !m;
              }
            }
            if (y) {
              var g = d.updateQueue;
              if (g === null) {
                var h = new Set();
                h.add(c), d.updateQueue = h;
              } else g.add(c);
              if (!(d.mode & 2)) {
                if (d.flags |= 64, l.flags |= 16384, l.flags &= -2981, l.tag === 1) if (l.alternate === null) l.tag = 17;else {
                  var f = zg$1(-1, 1);
                  f.tag = 2, Ag$1(l, f);
                }
                l.lanes |= 1;
                break e;
              }
              u = void 0, l = e;
              var v = s.pingCache;
              if (v === null ? (v = s.pingCache = new gP(), u = new Set(), v.set(c, u)) : (u = v.get(c), u === void 0 && (u = new Set(), v.set(c, u))), !u.has(l)) {
                u.add(l);
                var E = Yj.bind(null, s, c, l);
                c.then(E, E);
              }
              d.flags |= 4096, d.lanes = e;
              break e;
            }
            d = d.return;
          } while (d !== null);
          u = Error((Ra$1(l.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.`);
        }
        ft !== 5 && (ft = 2), u = Mi$1(u, l), d = a;
        do {
          switch (d.tag) {
            case 3:
              s = u, d.flags |= 4096, e &= -e, d.lanes |= e;
              var b = Pi$1(d, s, e);
              Bg$1(d, b);
              break e;
            case 1:
              s = u;
              var P = d.type,
                T = d.stateNode;
              if (!(d.flags & 64) && (typeof P.getDerivedStateFromError == "function" || T !== null && typeof T.componentDidCatch == "function" && (bn === null || !bn.has(T)))) {
                d.flags |= 4096, e &= -e, d.lanes |= e;
                var O = Si(d, s, e);
                Bg$1(d, O);
                break e;
              }
          }
          d = d.return;
        } while (d !== null);
      }
      Zj(n);
    } catch (M) {
      e = M, rt === n && n !== null && (rt = n = n.return);
      continue;
    }
    break;
  } while (1);
}
o(Sj, "Sj");
function Pj() {
  var t = Ha.current;
  return Ha.current = za, t === null ? za : t;
}
o(Pj, "Pj");
function Tj(t, e) {
  var n = me;
  me |= 16;
  var r = Pj();
  Ct === t && St === e || Qj(t, e);
  do try {
    ak$1();
    break;
  } catch (i) {
    Sj(t, i);
  } while (1);
  if (qg$1(), me = n, Ha.current = r, rt !== null) throw Error(y$1(261));
  return Ct = null, St = 0, ft;
}
o(Tj, "Tj");
function ak$1() {
  for (; rt !== null;) bk$1(rt);
}
o(ak$1, "ak");
function Rj() {
  for (; rt !== null && !sP();) bk$1(rt);
}
o(Rj, "Rj");
function bk$1(t) {
  var e = nw(t.alternate, t, Lr);
  t.memoizedProps = t.pendingProps, e === null ? Zj(t) : rt = e, Ud.current = null;
}
o(bk$1, "bk");
function Zj(t) {
  var e = t;
  do {
    var n = e.alternate;
    if (t = e.return, e.flags & 2048) {
      if (n = Li(e), n !== null) {
        n.flags &= 2047, rt = n;
        return;
      }
      t !== null && (t.firstEffect = t.lastEffect = null, t.flags |= 2048);
    } else {
      if (n = Gi(n, e, Lr), n !== null) {
        rt = n;
        return;
      }
      if (n = e, n.tag !== 24 && n.tag !== 23 || n.memoizedState === null || Lr & 1073741824 || !(n.mode & 4)) {
        for (var r = 0, i = n.child; i !== null;) r |= i.lanes | i.childLanes, i = i.sibling;
        n.childLanes = r;
      }
      t !== null && !(t.flags & 2048) && (t.firstEffect === null && (t.firstEffect = e.firstEffect), e.lastEffect !== null && (t.lastEffect !== null && (t.lastEffect.nextEffect = e.firstEffect), t.lastEffect = e.lastEffect), 1 < e.flags && (t.lastEffect !== null ? t.lastEffect.nextEffect = e : t.firstEffect = e, t.lastEffect = e));
    }
    if (e = e.sibling, e !== null) {
      rt = e;
      return;
    }
    rt = e = t;
  } while (e !== null);
  ft === 0 && (ft = 5);
}
o(Zj, "Zj");
function Uj(t) {
  var e = eg$1();
  return gg$1(99, dk$1.bind(null, t, e)), null;
}
o(Uj, "Uj");
function dk$1(t, e) {
  do Oj(); while ($s !== null);
  if (me & 48) throw Error(y$1(327));
  var n = t.finishedWork;
  if (n === null) return null;
  if (t.finishedWork = null, t.finishedLanes = 0, n === t.current) throw Error(y$1(177));
  t.callbackNode = null;
  var r = n.lanes | n.childLanes,
    i = r,
    s = t.pendingLanes & ~i;
  t.pendingLanes = i, t.suspendedLanes = 0, t.pingedLanes = 0, t.expiredLanes &= i, t.mutableReadLanes &= i, t.entangledLanes &= i, i = t.entanglements;
  for (var a = t.eventTimes, l = t.expirationTimes; 0 < s;) {
    var u = 31 - or(s),
      c = 1 << u;
    i[u] = 0, a[u] = -1, l[u] = -1, s &= ~c;
  }
  if (Dn !== null && !(r & 24) && Dn.has(t) && Dn.delete(t), t === Ct && (rt = Ct = null, St = 0), 1 < n.flags ? n.lastEffect !== null ? (n.lastEffect.nextEffect = n, r = n.firstEffect) : r = n : r = n.firstEffect, r !== null) {
    if (i = me, me |= 32, Ud.current = null, ec = ra, a = Ne$1(), Oe(a)) {
      if ("selectionStart" in a) l = {
        start: a.selectionStart,
        end: a.selectionEnd
      };else e: if (l = (l = a.ownerDocument) && l.defaultView || window, (c = l.getSelection && l.getSelection()) && c.rangeCount !== 0) {
        l = c.anchorNode, s = c.anchorOffset, u = c.focusNode, c = c.focusOffset;
        try {
          l.nodeType, u.nodeType;
        } catch {
          l = null;
          break e;
        }
        var p = 0,
          m = -1,
          d = -1,
          y = 0,
          S = 0,
          w = a,
          g = null;
        t: for (;;) {
          for (var h; w !== l || s !== 0 && w.nodeType !== 3 || (m = p + s), w !== u || c !== 0 && w.nodeType !== 3 || (d = p + c), w.nodeType === 3 && (p += w.nodeValue.length), (h = w.firstChild) !== null;) g = w, w = h;
          for (;;) {
            if (w === a) break t;
            if (g === l && ++y === s && (m = p), g === u && ++S === c && (d = p), (h = w.nextSibling) !== null) break;
            w = g, g = w.parentNode;
          }
          w = h;
        }
        l = m === -1 || d === -1 ? null : {
          start: m,
          end: d
        };
      } else l = null;
      l = l || {
        start: 0,
        end: 0
      };
    } else l = null;
    tc = {
      focusedElem: a,
      selectionRange: l
    }, ra = !1, js = null, ca = !1, oe = r;
    do try {
      ek$1();
    } catch (M) {
      if (oe === null) throw Error(y$1(330));
      Wi(oe, M), oe = oe.nextEffect;
    } while (oe !== null);
    js = null, oe = r;
    do try {
      for (a = t; oe !== null;) {
        var f = oe.flags;
        if (f & 16 && pb$1(oe.stateNode, ""), f & 128) {
          var v = oe.alternate;
          if (v !== null) {
            var E = v.ref;
            E !== null && (typeof E == "function" ? E(null) : E.current = null);
          }
        }
        switch (f & 1038) {
          case 2:
            fj(oe), oe.flags &= -3;
            break;
          case 6:
            fj(oe), oe.flags &= -3, ij(oe.alternate, oe);
            break;
          case 1024:
            oe.flags &= -1025;
            break;
          case 1028:
            oe.flags &= -1025, ij(oe.alternate, oe);
            break;
          case 4:
            ij(oe.alternate, oe);
            break;
          case 8:
            l = oe, cj(a, l);
            var b = l.alternate;
            dj(l), b !== null && dj(b);
        }
        oe = oe.nextEffect;
      }
    } catch (M) {
      if (oe === null) throw Error(y$1(330));
      Wi(oe, M), oe = oe.nextEffect;
    } while (oe !== null);
    if (E = tc, v = Ne$1(), f = E.focusedElem, a = E.selectionRange, v !== f && f && f.ownerDocument && Me(f.ownerDocument.documentElement, f)) {
      for (a !== null && Oe(f) && (v = a.start, E = a.end, E === void 0 && (E = v), "selectionStart" in f ? (f.selectionStart = v, f.selectionEnd = Math.min(E, f.value.length)) : (E = (v = f.ownerDocument || document) && v.defaultView || window, E.getSelection && (E = E.getSelection(), l = f.textContent.length, b = Math.min(a.start, l), a = a.end === void 0 ? b : Math.min(a.end, l), !E.extend && b > a && (l = a, a = b, b = l), l = Le$1(f, b), s = Le$1(f, a), l && s && (E.rangeCount !== 1 || E.anchorNode !== l.node || E.anchorOffset !== l.offset || E.focusNode !== s.node || E.focusOffset !== s.offset) && (v = v.createRange(), v.setStart(l.node, l.offset), E.removeAllRanges(), b > a ? (E.addRange(v), E.extend(s.node, s.offset)) : (v.setEnd(s.node, s.offset), E.addRange(v)))))), v = [], E = f; E = E.parentNode;) E.nodeType === 1 && v.push({
        element: E,
        left: E.scrollLeft,
        top: E.scrollTop
      });
      for (typeof f.focus == "function" && f.focus(), f = 0; f < v.length; f++) E = v[f], E.element.scrollLeft = E.left, E.element.scrollTop = E.top;
    }
    ra = !!ec, tc = ec = null, t.current = n, oe = r;
    do try {
      for (f = t; oe !== null;) {
        var P = oe.flags;
        if (P & 36 && Yi$1(f, oe.alternate, oe), P & 128) {
          v = void 0;
          var T = oe.ref;
          if (T !== null) {
            var O = oe.stateNode;
            switch (oe.tag) {
              case 5:
                v = O;
                break;
              default:
                v = O;
            }
            typeof T == "function" ? T(v) : T.current = v;
          }
        }
        oe = oe.nextEffect;
      }
    } catch (M) {
      if (oe === null) throw Error(y$1(330));
      Wi(oe, M), oe = oe.nextEffect;
    } while (oe !== null);
    oe = null, aP(), me = i;
  } else t.current = n;
  if (lr) lr = !1, $s = t, Ts = e;else for (oe = r; oe !== null;) e = oe.nextEffect, oe.nextEffect = null, oe.flags & 8 && (P = oe, P.sibling = null, P.stateNode = null), oe = e;
  if (r = t.pendingLanes, r === 0 && (bn = null), r === 1 ? t === bf ? Fs++ : (Fs = 0, bf = t) : Fs = 0, n = n.stateNode, _r && typeof _r.onCommitFiberRoot == "function") try {
    _r.onCommitFiberRoot(Ad, n, void 0, (n.current.flags & 64) === 64);
  } catch {}
  if (Mj(t, bt()), Ua) throw Ua = !1, t = yf, yf = null, t;
  return me & 8 || ig$1(), null;
}
o(dk$1, "dk");
function ek$1() {
  for (; oe !== null;) {
    var t = oe.alternate;
    ca || js === null || (oe.flags & 8 ? dc$1(oe, js) && (ca = !0) : oe.tag === 13 && mj(t, oe) && dc$1(oe, js) && (ca = !0));
    var e = oe.flags;
    e & 256 && Xi$1(t, oe), !(e & 512) || lr || (lr = !0, hg$1(97, function () {
      return Oj(), null;
    })), oe = oe.nextEffect;
  }
}
o(ek$1, "ek");
function Oj() {
  if (Ts !== 90) {
    var t = 97 < Ts ? 97 : Ts;
    return Ts = 90, gg$1(t, fk$1);
  }
  return !1;
}
o(Oj, "Oj");
function $i$1(t, e) {
  vf.push(e, t), lr || (lr = !0, hg$1(97, function () {
    return Oj(), null;
  }));
}
o($i$1, "$i");
function Zi$1(t, e) {
  wf.push(e, t), lr || (lr = !0, hg$1(97, function () {
    return Oj(), null;
  }));
}
o(Zi$1, "Zi");
function fk$1() {
  if ($s === null) return !1;
  var t = $s;
  if ($s = null, me & 48) throw Error(y$1(331));
  var e = me;
  me |= 32;
  var n = wf;
  wf = [];
  for (var r = 0; r < n.length; r += 2) {
    var i = n[r],
      s = n[r + 1],
      a = i.destroy;
    if (i.destroy = void 0, typeof a == "function") try {
      a();
    } catch (u) {
      if (s === null) throw Error(y$1(330));
      Wi(s, u);
    }
  }
  for (n = vf, vf = [], r = 0; r < n.length; r += 2) {
    i = n[r], s = n[r + 1];
    try {
      var l = i.create;
      i.destroy = l();
    } catch (u) {
      if (s === null) throw Error(y$1(330));
      Wi(s, u);
    }
  }
  for (l = t.current.firstEffect; l !== null;) t = l.nextEffect, l.nextEffect = null, l.flags & 8 && (l.sibling = null, l.stateNode = null), l = t;
  return me = e, ig$1(), !0;
}
o(fk$1, "fk");
function gk$1(t, e, n) {
  e = Mi$1(n, e), e = Pi$1(t, e, 1), Ag$1(t, e), e = Hg$1(), t = Kj(t, 1), t !== null && ($c(t, 1, e), Mj(t, e));
}
o(gk$1, "gk");
function Wi(t, e) {
  if (t.tag === 3) gk$1(t, t, e);else for (var n = t.return; n !== null;) {
    if (n.tag === 3) {
      gk$1(n, t, e);
      break;
    } else if (n.tag === 1) {
      var r = n.stateNode;
      if (typeof n.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (bn === null || !bn.has(r))) {
        t = Mi$1(e, t);
        var i = Si(n, t, 1);
        if (Ag$1(n, i), i = Hg$1(), n = Kj(n, 1), n !== null) $c(n, 1, i), Mj(n, i);else if (typeof r.componentDidCatch == "function" && (bn === null || !bn.has(r))) try {
          r.componentDidCatch(e, t);
        } catch {}
        break;
      }
    }
    n = n.return;
  }
}
o(Wi, "Wi");
function Yj(t, e, n) {
  var r = t.pingCache;
  r !== null && r.delete(e), e = Hg$1(), t.pingedLanes |= t.suspendedLanes & n, Ct === t && (St & n) === n && (ft === 4 || ft === 3 && (St & 62914560) === St && 500 > bt() - Vd ? Qj(t, 0) : qd |= n), Mj(t, e);
}
o(Yj, "Yj");
function lj(t, e) {
  var n = t.stateNode;
  n !== null && n.delete(e), e = 0, e === 0 && (e = t.mode, e & 2 ? e & 4 ? (kn === 0 && (kn = Ni), e = Yc(62914560 & ~kn), e === 0 && (e = 4194304)) : e = eg$1() === 99 ? 1 : 2 : e = 1), n = Hg$1(), t = Kj(t, e), t !== null && ($c(t, e, n), Mj(t, n));
}
o(lj, "lj");
var nw;
nw = o(function (t, e, n) {
  var r = e.lanes;
  if (t !== null) {
    if (t.memoizedProps !== e.pendingProps || Mt.current) an = !0;else if (n & r) an = !!(t.flags & 16384);else {
      switch (an = !1, e.tag) {
        case 3:
          ri$1(e), sh$1();
          break;
        case 5:
          gh$1(e);
          break;
        case 1:
          Ff$1(e.type) && Jf(e);
          break;
        case 4:
          eh$1(e, e.stateNode.containerInfo);
          break;
        case 10:
          r = e.memoizedProps.value;
          var i = e.type._context;
          I$1(La, i._currentValue), i._currentValue = r;
          break;
        case 13:
          if (e.memoizedState !== null) return n & e.child.childLanes ? ti$1(t, e, n) : (I$1(qe, qe.current & 1), e = hi$1(t, e, n), e !== null ? e.sibling : null);
          I$1(qe, qe.current & 1);
          break;
        case 19:
          if (r = (n & e.childLanes) !== 0, t.flags & 64) {
            if (r) return Ai$1(t, e, n);
            e.flags |= 64;
          }
          if (i = e.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), I$1(qe, qe.current), r) break;
          return null;
        case 23:
        case 24:
          return e.lanes = 0, mi$1(t, e, n);
      }
      return hi$1(t, e, n);
    }
  } else an = !1;
  switch (e.lanes = 0, e.tag) {
    case 2:
      if (r = e.type, t !== null && (t.alternate = null, e.alternate = null, e.flags |= 2), t = e.pendingProps, i = Ef$1(e, Et.current), tg$1(e, n), i = Ch$1(null, e, r, t, i, n), e.flags |= 1, typeof i == "object" && i !== null && typeof i.render == "function" && i.$$typeof === void 0) {
        if (e.tag = 1, e.memoizedState = null, e.updateQueue = null, Ff$1(r)) {
          var s = !0;
          Jf(e);
        } else s = !1;
        e.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null, xg$1(e);
        var a = r.getDerivedStateFromProps;
        typeof a == "function" && Gg$1(e, r, a, t), i.updater = Dl, e.stateNode = i, i._reactInternals = e, Og$1(e, r, t, n), e = qi(null, e, r, !0, s, n);
      } else e.tag = 0, fi(null, e, i, n), e = e.child;
      return e;
    case 16:
      i = e.elementType;
      e: {
        switch (t !== null && (t.alternate = null, e.alternate = null, e.flags |= 2), t = e.pendingProps, s = i._init, i = s(i._payload), e.type = i, s = e.tag = hk$1(i), t = lg$1(i, t), s) {
          case 0:
            e = li(null, e, i, t, n);
            break e;
          case 1:
            e = pi$1(null, e, i, t, n);
            break e;
          case 11:
            e = gi$1(null, e, i, t, n);
            break e;
          case 14:
            e = ii$1(null, e, i, lg$1(i.type, t), r, n);
            break e;
        }
        throw Error(y$1(306, i, ""));
      }
      return e;
    case 0:
      return r = e.type, i = e.pendingProps, i = e.elementType === r ? i : lg$1(r, i), li(t, e, r, i, n);
    case 1:
      return r = e.type, i = e.pendingProps, i = e.elementType === r ? i : lg$1(r, i), pi$1(t, e, r, i, n);
    case 3:
      if (ri$1(e), r = e.updateQueue, t === null || r === null) throw Error(y$1(282));
      if (r = e.pendingProps, i = e.memoizedState, i = i !== null ? i.element : null, yg$1(t, e), Cg$1(e, r, null, n), r = e.memoizedState.element, r === i) sh$1(), e = hi$1(t, e, n);else {
        if (i = e.stateNode, (s = i.hydrate) && (Gn = rf$1(e.stateNode.containerInfo.firstChild), An = e, s = Tn = !0), s) {
          if (t = i.mutableSourceEagerHydrationData, t != null) for (i = 0; i < t.length; i += 2) s = t[i], s._workInProgressVersionPrimary = t[i + 1], pi.push(s);
          for (n = L0(e, null, r, n), e.child = n; n;) n.flags = n.flags & -3 | 1024, n = n.sibling;
        } else fi(t, e, r, n), sh$1();
        e = e.child;
      }
      return e;
    case 5:
      return gh$1(e), t === null && ph$1(e), r = e.type, i = e.pendingProps, s = t !== null ? t.memoizedProps : null, a = i.children, nf$1(r, i) ? a = null : s !== null && nf$1(r, s) && (e.flags |= 16), oi$1(t, e), fi(t, e, a, n), e.child;
    case 6:
      return t === null && ph$1(e), null;
    case 13:
      return ti$1(t, e, n);
    case 4:
      return eh$1(e, e.stateNode.containerInfo), r = e.pendingProps, t === null ? e.child = Ra(e, null, r, n) : fi(t, e, r, n), e.child;
    case 11:
      return r = e.type, i = e.pendingProps, i = e.elementType === r ? i : lg$1(r, i), gi$1(t, e, r, i, n);
    case 7:
      return fi(t, e, e.pendingProps, n), e.child;
    case 8:
      return fi(t, e, e.pendingProps.children, n), e.child;
    case 12:
      return fi(t, e, e.pendingProps.children, n), e.child;
    case 10:
      e: {
        r = e.type._context, i = e.pendingProps, a = e.memoizedProps, s = i.value;
        var l = e.type._context;
        if (I$1(La, l._currentValue), l._currentValue = s, a !== null) if (l = a.value, s = Kt(l, s) ? 0 : (typeof r._calculateChangedBits == "function" ? r._calculateChangedBits(l, s) : 1073741823) | 0, s === 0) {
          if (a.children === i.children && !Mt.current) {
            e = hi$1(t, e, n);
            break e;
          }
        } else for (l = e.child, l !== null && (l.return = e); l !== null;) {
          var u = l.dependencies;
          if (u !== null) {
            a = l.child;
            for (var c = u.firstContext; c !== null;) {
              if (c.context === r && c.observedBits & s) {
                l.tag === 1 && (c = zg$1(-1, n & -n), c.tag = 2, Ag$1(l, c)), l.lanes |= n, c = l.alternate, c !== null && (c.lanes |= n), sg$1(l.return, n), u.lanes |= n;
                break;
              }
              c = c.next;
            }
          } else a = l.tag === 10 && l.type === e.type ? null : l.child;
          if (a !== null) a.return = l;else for (a = l; a !== null;) {
            if (a === e) {
              a = null;
              break;
            }
            if (l = a.sibling, l !== null) {
              l.return = a.return, a = l;
              break;
            }
            a = a.return;
          }
          l = a;
        }
        fi(t, e, i.children, n), e = e.child;
      }
      return e;
    case 9:
      return i = e.type, s = e.pendingProps, r = s.children, tg$1(e, n), i = vg$1(i, s.unstable_observedBits), r = r(i), e.flags |= 1, fi(t, e, r, n), e.child;
    case 14:
      return i = e.type, s = lg$1(i, e.pendingProps), s = lg$1(i.type, s), ii$1(t, e, i, s, r, n);
    case 15:
      return ki$1(t, e, e.type, e.pendingProps, r, n);
    case 17:
      return r = e.type, i = e.pendingProps, i = e.elementType === r ? i : lg$1(r, i), t !== null && (t.alternate = null, e.alternate = null, e.flags |= 2), e.tag = 1, Ff$1(r) ? (t = !0, Jf(e)) : t = !1, tg$1(e, n), Mg$1(e, r, i), Og$1(e, r, i, n), qi(null, e, r, !0, t, n);
    case 19:
      return Ai$1(t, e, n);
    case 23:
      return mi$1(t, e, n);
    case 24:
      return mi$1(t, e, n);
  }
  throw Error(y$1(156, e.tag));
}, "ck");
function ik$1(t, e, n, r) {
  this.tag = t, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
o(ik$1, "ik");
function nh$1(t, e, n, r) {
  return new ik$1(t, e, n, r);
}
o(nh$1, "nh");
function ji$1(t) {
  return t = t.prototype, !(!t || !t.isReactComponent);
}
o(ji$1, "ji");
function hk$1(t) {
  if (typeof t == "function") return ji$1(t) ? 1 : 0;
  if (t != null) {
    if (t = t.$$typeof, t === Pl) return 11;
    if (t === Cl) return 14;
  }
  return 2;
}
o(hk$1, "hk");
function Tg$1(t, e) {
  var n = t.alternate;
  return n === null ? (n = nh$1(t.tag, e, t.key, t.mode), n.elementType = t.elementType, n.type = t.type, n.stateNode = t.stateNode, n.alternate = t, t.alternate = n) : (n.pendingProps = e, n.type = t.type, n.flags = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childLanes = t.childLanes, n.lanes = t.lanes, n.child = t.child, n.memoizedProps = t.memoizedProps, n.memoizedState = t.memoizedState, n.updateQueue = t.updateQueue, e = t.dependencies, n.dependencies = e === null ? null : {
    lanes: e.lanes,
    firstContext: e.firstContext
  }, n.sibling = t.sibling, n.index = t.index, n.ref = t.ref, n;
}
o(Tg$1, "Tg");
function Vg$1(t, e, n, r, i, s) {
  var a = 2;
  if (r = t, typeof t == "function") ji$1(t) && (a = 1);else if (typeof t == "string") a = 5;else e: switch (t) {
    case Un:
      return Xg$1(n.children, i, s, e);
    case Mv:
      a = 8, i |= 16;
      break;
    case ud:
      a = 8, i |= 1;
      break;
    case _s:
      return t = nh$1(12, n, e, i | 8), t.elementType = _s, t.type = _s, t.lanes = s, t;
    case Os:
      return t = nh$1(13, n, e, i), t.type = Os, t.elementType = Os, t.lanes = s, t;
    case Ea:
      return t = nh$1(19, n, e, i), t.elementType = Ea, t.lanes = s, t;
    case md:
      return vi$1(n, i, s, e);
    case Rc:
      return t = nh$1(24, n, e, i), t.elementType = Rc, t.lanes = s, t;
    default:
      if (typeof t == "object" && t !== null) switch (t.$$typeof) {
        case cd:
          a = 10;
          break e;
        case fd:
          a = 9;
          break e;
        case Pl:
          a = 11;
          break e;
        case Cl:
          a = 14;
          break e;
        case dd:
          a = 16, r = null;
          break e;
        case pd:
          a = 22;
          break e;
      }
      throw Error(y$1(130, t == null ? t : typeof t, ""));
  }
  return e = nh$1(a, n, e, i), e.elementType = t, e.type = r, e.lanes = s, e;
}
o(Vg$1, "Vg");
function Xg$1(t, e, n, r) {
  return t = nh$1(7, t, r, e), t.lanes = n, t;
}
o(Xg$1, "Xg");
function vi$1(t, e, n, r) {
  return t = nh$1(23, t, r, e), t.elementType = md, t.lanes = n, t;
}
o(vi$1, "vi");
function Ug$1(t, e, n) {
  return t = nh$1(6, t, null, e), t.lanes = n, t;
}
o(Ug$1, "Ug");
function Wg$1(t, e, n) {
  return e = nh$1(4, t.children !== null ? t.children : [], t.key, e), e.lanes = n, e.stateNode = {
    containerInfo: t.containerInfo,
    pendingChildren: null,
    implementation: t.implementation
  }, e;
}
o(Wg$1, "Wg");
function jk$1(t, e, n) {
  this.tag = e, this.containerInfo = t, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = Zc$1(0), this.expirationTimes = Zc$1(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Zc$1(0), this.mutableSourceEagerHydrationData = null;
}
o(jk$1, "jk");
function kk$1(t, e, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return {
    $$typeof: Sr,
    key: r == null ? null : "" + r,
    children: t,
    containerInfo: e,
    implementation: n
  };
}
o(kk$1, "kk");
function lk$1(t, e, n, r) {
  var i = e.current,
    s = Hg$1(),
    a = Ig$1(i);
  e: if (n) {
    n = n._reactInternals;
    t: {
      if (Zb$1(n) !== n || n.tag !== 1) throw Error(y$1(170));
      var l = n;
      do {
        switch (l.tag) {
          case 3:
            l = l.stateNode.context;
            break t;
          case 1:
            if (Ff$1(l.type)) {
              l = l.stateNode.__reactInternalMemoizedMergedChildContext;
              break t;
            }
        }
        l = l.return;
      } while (l !== null);
      throw Error(y$1(171));
    }
    if (n.tag === 1) {
      var u = n.type;
      if (Ff$1(u)) {
        n = If$1(n, u, l);
        break e;
      }
    }
    n = l;
  } else n = ar;
  return e.context === null ? e.context = n : e.pendingContext = n, e = zg$1(s, a), e.payload = {
    element: t
  }, r = r === void 0 ? null : r, r !== null && (e.callback = r), Ag$1(i, e), Jg$1(i, a, s), a;
}
o(lk$1, "lk");
function mk$1(t) {
  if (t = t.current, !t.child) return null;
  switch (t.child.tag) {
    case 5:
      return t.child.stateNode;
    default:
      return t.child.stateNode;
  }
}
o(mk$1, "mk");
function nk$1(t, e) {
  if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
    var n = t.retryLane;
    t.retryLane = n !== 0 && n < e ? n : e;
  }
}
o(nk$1, "nk");
function ok$1(t, e) {
  nk$1(t, e), (t = t.alternate) && nk$1(t, e);
}
o(ok$1, "ok");
function pk$1() {
  return null;
}
o(pk$1, "pk");
function qk$1(t, e, n) {
  var r = n != null && n.hydrationOptions != null && n.hydrationOptions.mutableSources || null;
  if (n = new jk$1(t, e, n != null && n.hydrate === !0), e = nh$1(3, null, null, e === 2 ? 7 : e === 1 ? 3 : 0), n.current = e, e.stateNode = n, xg$1(e), t[Ri] = n.current, cf$1(t.nodeType === 8 ? t.parentNode : t), r) for (t = 0; t < r.length; t++) {
    e = r[t];
    var i = e._getVersion;
    i = i(e._source), n.mutableSourceEagerHydrationData == null ? n.mutableSourceEagerHydrationData = [e, i] : n.mutableSourceEagerHydrationData.push(e, i);
  }
  this._internalRoot = n;
}
o(qk$1, "qk");
qk$1.prototype.render = function (t) {
  lk$1(t, this._internalRoot, null, null);
};
qk$1.prototype.unmount = function () {
  var t = this._internalRoot,
    e = t.containerInfo;
  lk$1(null, t, null, function () {
    e[Ri] = null;
  });
};
function rk$1(t) {
  return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11 && (t.nodeType !== 8 || t.nodeValue !== " react-mount-point-unstable "));
}
o(rk$1, "rk");
function sk$1(t, e) {
  if (e || (e = t ? t.nodeType === 9 ? t.documentElement : t.firstChild : null, e = !(!e || e.nodeType !== 1 || !e.hasAttribute("data-reactroot"))), !e) for (var n; n = t.lastChild;) t.removeChild(n);
  return new qk$1(t, 0, e ? {
    hydrate: !0
  } : void 0);
}
o(sk$1, "sk");
function tk$1(t, e, n, r, i) {
  var s = n._reactRootContainer;
  if (s) {
    var a = s._internalRoot;
    if (typeof i == "function") {
      var l = i;
      i = o(function () {
        var c = mk$1(a);
        l.call(c);
      }, "e");
    }
    lk$1(e, a, t, i);
  } else {
    if (s = n._reactRootContainer = sk$1(n, r), a = s._internalRoot, typeof i == "function") {
      var u = i;
      i = o(function () {
        var c = mk$1(a);
        u.call(c);
      }, "e");
    }
    Xj(function () {
      lk$1(e, a, t, i);
    });
  }
  return mk$1(a);
}
o(tk$1, "tk");
Gv = o(function (t) {
  if (t.tag === 13) {
    var e = Hg$1();
    Jg$1(t, 4, e), ok$1(t, 4);
  }
}, "ec");
bd = o(function (t) {
  if (t.tag === 13) {
    var e = Hg$1();
    Jg$1(t, 67108864, e), ok$1(t, 67108864);
  }
}, "fc");
Xv = o(function (t) {
  if (t.tag === 13) {
    var e = Hg$1(),
      n = Ig$1(t);
    Jg$1(t, n, e), ok$1(t, n);
  }
}, "gc");
Yv = o(function (t, e) {
  return e();
}, "hc");
Vc = o(function (t, e, n) {
  switch (e) {
    case "input":
      if (ab$1(t, n), e = n.name, n.type === "radio" && e != null) {
        for (n = t; n.parentNode;) n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + e) + '][type="radio"]'), e = 0; e < n.length; e++) {
          var r = n[e];
          if (r !== t && r.form === t.form) {
            var i = Db$1(r);
            if (!i) throw Error(y$1(90));
            Wa$1(r), ab$1(r, i);
          }
        }
      }
      break;
    case "textarea":
      ib$1(t, n);
      break;
    case "select":
      e = n.value, e != null && fb$1(t, !!n.multiple, e, !1);
  }
}, "yb");
Gb$1 = Wj;
Hb$1 = o(function (t, e, n, r, i) {
  var s = me;
  me |= 4;
  try {
    return gg$1(98, t.bind(null, e, n, r, i));
  } finally {
    me = s, me === 0 && (wj(), ig$1());
  }
}, "Hb");
Ib$1 = o(function () {
  !(me & 49) && (Vj(), Oj());
}, "Ib");
qv = o(function (t, e) {
  var n = me;
  me |= 2;
  try {
    return t(e);
  } finally {
    me = n, me === 0 && (wj(), ig$1());
  }
}, "Jb");
function uk$1(t, e) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!rk$1(e)) throw Error(y$1(200));
  return kk$1(t, e, null, n);
}
o(uk$1, "uk");
var $P = {
    Events: [Cb$1, ue, Db$1, Eb$1, Fb, Oj, {
      current: !1
    }]
  },
  ds = {
    findFiberByHostInstance: wc$1,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
  },
  FP = {
    bundleType: ds.bundleType,
    version: ds.version,
    rendererPackageName: ds.rendererPackageName,
    rendererConfig: ds.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: jr.ReactCurrentDispatcher,
    findHostInstanceByFiber: function (t) {
      return t = cc$1(t), t === null ? null : t.stateNode;
    },
    findFiberByHostInstance: ds.findFiberByHostInstance || pk$1,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
  };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var Yo = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Yo.isDisabled && Yo.supportsFiber) try {
    Ad = Yo.inject(FP), _r = Yo;
  } catch {}
}
fn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $P;
fn.createPortal = uk$1;
fn.findDOMNode = function (t) {
  if (t == null) return null;
  if (t.nodeType === 1) return t;
  var e = t._reactInternals;
  if (e === void 0) throw typeof t.render == "function" ? Error(y$1(188)) : Error(y$1(268, Object.keys(t)));
  return t = cc$1(e), t = t === null ? null : t.stateNode, t;
};
fn.flushSync = function (t, e) {
  var n = me;
  if (n & 48) return t(e);
  me |= 1;
  try {
    if (t) return gg$1(99, t.bind(null, e));
  } finally {
    me = n, ig$1();
  }
};
fn.hydrate = function (t, e, n) {
  if (!rk$1(e)) throw Error(y$1(200));
  return tk$1(null, t, e, !0, n);
};
fn.render = function (t, e, n) {
  if (!rk$1(e)) throw Error(y$1(200));
  return tk$1(null, t, e, !1, n);
};
fn.unmountComponentAtNode = function (t) {
  if (!rk$1(t)) throw Error(y$1(40));
  return t._reactRootContainer ? (Xj(function () {
    tk$1(null, null, t, !1, function () {
      t._reactRootContainer = null, t[Ri] = null;
    });
  }), !0) : !1;
};
fn.unstable_batchedUpdates = Wj;
fn.unstable_createPortal = function (t, e) {
  return uk$1(t, e, 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null);
};
fn.unstable_renderSubtreeIntoContainer = function (t, e, n, r) {
  if (!rk$1(n)) throw Error(y$1(200));
  if (t == null || t._reactInternals === void 0) throw Error(y$1(38));
  return tk$1(t, e, n, !1, r);
};
fn.version = "17.0.2";
function checkDCE() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (t) {
    console.error(t);
  }
}
o(checkDCE, "checkDCE");
checkDCE();
const jP = El.INFO,
  Cs = "__SALVO__::logLevel",
  getCachedLogLevel = o(() => {
    try {
      const t = localStorage.getItem(Cs);
      if (isLogLevel(t)) return t;
    } catch {}
    return null;
  }, "getCachedLogLevel"),
  getSessionLogLevel = o(() => getCachedLogLevel() || jP, "getSessionLogLevel"),
  setupGlobalApi = o(() => {
    if (window.__SALVO__) return;
    const t = El.INFO;
    window.__SALVO__ = {
      overrideLogLevel: e => {
        if (e !== null && !isLogLevel(e)) throw new Error("level must be null or a valid log level (i.e. DEBUG, INFO, WARN, ERROR, FATAL)");
        try {
          if (e) {
            if (localStorage.setItem(Cs, e), e !== localStorage.getItem(Cs)) throw new Error("Failed to add to local storage.");
          } else if (localStorage.removeItem(Cs), localStorage.getItem(Cs)) throw new Error("Failed to remove from local storage.");
          Sn.setLogLevel(e || t), console.info(e ? `Log level set to ${e}. This will persist across page loads, until you clear localStorage or run \`overrideLogLevel(null)\`` : `Log level reset to ${t}.`);
        } catch (n) {
          console.warn("Could not persist to local storage, your log level won't be remembered when you refresh.", n), Sn.setLogLevel(e || t);
        }
      }
    };
  }, "setupGlobalApi");
function main({
  enableLegacySalvoLiteComponentSupport: t
}) {
  if (window.isNodeJS) return {
    isThemeInfo: !0,
    componentService: $t
  };
  t && $t.enableLegacySupport(), $t.bootstrap(), setupGlobalApi();
}
o(main, "main");
const Sn = new DefaultLog();
Sn.setLogPrefix("Theme");
Sn.setLogLevel(getSessionLogLevel());
function isObject$1(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
o(isObject$1, "isObject$8");
var Qd = isObject$1,
  qP = typeof On == "object" && On && On.Object === Object && On,
  VP = qP,
  WP = VP,
  GP = typeof self == "object" && self && self.Object === Object && self,
  XP = WP || GP || Function("return this")(),
  sw = XP,
  YP = sw,
  now = o(function () {
    return YP.Date.now();
  }, "now$3"),
  QP = now,
  JP = /\s/;
function trimmedEndIndex(t) {
  for (var e = t.length; e-- && JP.test(t.charAt(e)););
  return e;
}
o(trimmedEndIndex, "trimmedEndIndex$1");
var eC = trimmedEndIndex,
  tC = eC,
  nC = /^\s+/;
function baseTrim(t) {
  return t && t.slice(0, tC(t) + 1).replace(nC, "");
}
o(baseTrim, "baseTrim$1");
var iC = baseTrim,
  sC = sw,
  oC = sC.Symbol,
  ow = oC,
  ig = ow,
  aw = Object.prototype,
  aC = aw.hasOwnProperty,
  lC = aw.toString,
  ps = ig ? ig.toStringTag : void 0;
function getRawTag(t) {
  var e = aC.call(t, ps),
    n = t[ps];
  try {
    t[ps] = void 0;
    var r = !0;
  } catch {}
  var i = lC.call(t);
  return r && (e ? t[ps] = n : delete t[ps]), i;
}
o(getRawTag, "getRawTag$1");
var cC = getRawTag,
  fC = Object.prototype,
  dC = fC.toString;
function objectToString(t) {
  return dC.call(t);
}
o(objectToString, "objectToString$1");
var hC = objectToString,
  sg = ow,
  mC = cC,
  gC = hC,
  yC = "[object Null]",
  vC = "[object Undefined]",
  og = sg ? sg.toStringTag : void 0;
function baseGetTag(t) {
  return t == null ? t === void 0 ? vC : yC : og && og in Object(t) ? mC(t) : gC(t);
}
o(baseGetTag, "baseGetTag$2");
var lw = baseGetTag;
function isObjectLike(t) {
  return t != null && typeof t == "object";
}
o(isObjectLike, "isObjectLike$2");
var uw = isObjectLike,
  SC = lw,
  EC = uw,
  TC = "[object Symbol]";
function isSymbol$1(t) {
  return typeof t == "symbol" || EC(t) && SC(t) == TC;
}
o(isSymbol$1, "isSymbol$1");
var CC = isSymbol$1,
  xC = iC,
  ag = Qd,
  kC = CC,
  lg = 0 / 0,
  _C = /^[-+]0x[0-9a-f]+$/i,
  OC = /^0b[01]+$/i,
  AC = /^0o[0-7]+$/i,
  LC = parseInt;
function toNumber(t) {
  if (typeof t == "number") return t;
  if (kC(t)) return lg;
  if (ag(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = ag(e) ? e + "" : e;
  }
  if (typeof t != "string") return t === 0 ? t : +t;
  t = xC(t);
  var n = OC.test(t);
  return n || AC.test(t) ? LC(t.slice(2), n ? 2 : 8) : _C.test(t) ? lg : +t;
}
o(toNumber, "toNumber$1");
var DC = toNumber,
  IC = Qd,
  dc = QP,
  ug = DC,
  RC = "Expected a function",
  NC = Math.max,
  $C = Math.min;
function debounce$1(t, e, n) {
  var r,
    i,
    s,
    a,
    l,
    u,
    c = 0,
    p = !1,
    m = !1,
    d = !0;
  if (typeof t != "function") throw new TypeError(RC);
  e = ug(e) || 0, IC(n) && (p = !!n.leading, m = "maxWait" in n, s = m ? NC(ug(n.maxWait) || 0, e) : s, d = "trailing" in n ? !!n.trailing : d);
  function invokeFunc(P) {
    var T = r,
      O = i;
    return r = i = void 0, c = P, a = t.apply(O, T), a;
  }
  o(invokeFunc, "invokeFunc");
  function leadingEdge(P) {
    return c = P, l = setTimeout(timerExpired, e), p ? invokeFunc(P) : a;
  }
  o(leadingEdge, "leadingEdge");
  function remainingWait(P) {
    var T = P - u,
      O = P - c,
      M = e - T;
    return m ? $C(M, s - O) : M;
  }
  o(remainingWait, "remainingWait");
  function shouldInvoke(P) {
    var T = P - u,
      O = P - c;
    return u === void 0 || T >= e || T < 0 || m && O >= s;
  }
  o(shouldInvoke, "shouldInvoke");
  function timerExpired() {
    var P = dc();
    if (shouldInvoke(P)) return trailingEdge(P);
    l = setTimeout(timerExpired, remainingWait(P));
  }
  o(timerExpired, "timerExpired");
  function trailingEdge(P) {
    return l = void 0, d && r ? invokeFunc(P) : (r = i = void 0, a);
  }
  o(trailingEdge, "trailingEdge");
  function cancel() {
    l !== void 0 && clearTimeout(l), c = 0, r = u = i = l = void 0;
  }
  o(cancel, "cancel");
  function flush() {
    return l === void 0 ? a : trailingEdge(dc());
  }
  o(flush, "flush");
  function debounced() {
    var P = dc(),
      T = shouldInvoke(P);
    if (r = arguments, i = this, u = P, T) {
      if (l === void 0) return leadingEdge(u);
      if (m) return clearTimeout(l), l = setTimeout(timerExpired, e), invokeFunc(u);
    }
    return l === void 0 && (l = setTimeout(timerExpired, e)), a;
  }
  return o(debounced, "debounced"), debounced.cancel = cancel, debounced.flush = flush, debounced;
}
o(debounce$1, "debounce$1");
var cw = debounce$1;
const debounce = getDefaultExportFromCjs(cw);
var jC = cw,
  BC = Qd,
  zC = "Expected a function";
function throttle$1(t, e, n) {
  var r = !0,
    i = !0;
  if (typeof t != "function") throw new TypeError(zC);
  return BC(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), jC(t, e, {
    leading: r,
    maxWait: e,
    trailing: i
  });
}
o(throttle$1, "throttle$1");
var UC = throttle$1;
const throttle = getDefaultExportFromCjs(UC);
function bind$1(t, e) {
  return o(function () {
    return t.apply(e, arguments);
  }, "wrap");
}
o(bind$1, "bind");
const {
    toString: qC
  } = Object.prototype,
  {
    getPrototypeOf: Jd
  } = Object,
  $l = (t => e => {
    const n = qC.call(e);
    return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
  })(Object.create(null)),
  kindOfTest = o(t => (t = t.toLowerCase(), e => $l(e) === t), "kindOfTest"),
  typeOfTest = o(t => e => typeof e === t, "typeOfTest"),
  {
    isArray: ji
  } = Array,
  so = typeOfTest("undefined");
function isBuffer$2(t) {
  return t !== null && !so(t) && t.constructor !== null && !so(t.constructor) && Bt(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
o(isBuffer$2, "isBuffer");
const dw = kindOfTest("ArrayBuffer");
function isArrayBufferView$1(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && dw(t.buffer), e;
}
o(isArrayBufferView$1, "isArrayBufferView");
const GC = typeOfTest("string"),
  Bt = typeOfTest("function"),
  pw = typeOfTest("number"),
  isObject$2 = o(t => t !== null && typeof t == "object", "isObject$4"),
  isBoolean$1 = o(t => t === !0 || t === !1, "isBoolean$2"),
  isPlainObject$1 = o(t => {
    if ($l(t) !== "object") return !1;
    const e = Jd(t);
    return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
  }, "isPlainObject"),
  YC = kindOfTest("Date"),
  KC = kindOfTest("File"),
  QC = kindOfTest("Blob"),
  JC = kindOfTest("FileList"),
  isStream$1 = o(t => isObject$2(t) && Bt(t.pipe), "isStream"),
  isFormData$1 = o(t => {
    let e;
    return t && (typeof FormData == "function" && t instanceof FormData || Bt(t.append) && ((e = $l(t)) === "formdata" || e === "object" && Bt(t.toString) && t.toString() === "[object FormData]"));
  }, "isFormData"),
  tx = kindOfTest("URLSearchParams"),
  [nx, rx, ix, sx] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest),
  trim$1 = o(t => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), "trim");
function forEach$1(t, e, {
  allOwnKeys: n = !1
} = {}) {
  if (t === null || typeof t > "u") return;
  let r, i;
  if (typeof t != "object" && (t = [t]), ji(t)) for (r = 0, i = t.length; r < i; r++) e.call(null, t[r], r, t);else {
    const s = n ? Object.getOwnPropertyNames(t) : Object.keys(t),
      a = s.length;
    let l;
    for (r = 0; r < a; r++) l = s[r], e.call(null, t[l], l, t);
  }
}
o(forEach$1, "forEach");
function findKey(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r = n.length,
    i;
  for (; r-- > 0;) if (i = n[r], e === i.toLowerCase()) return i;
  return null;
}
o(findKey, "findKey");
const xr = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(),
  isContextDefined = o(t => !so(t) && t !== xr, "isContextDefined");
function merge$2() {
  const {
      caseless: t
    } = isContextDefined(this) && this || {},
    e = {},
    assignValue$1 = o((r, i) => {
      const s = t && findKey(e, i) || i;
      isPlainObject$1(e[s]) && isPlainObject$1(r) ? e[s] = merge$2(e[s], r) : isPlainObject$1(r) ? e[s] = merge$2({}, r) : ji(r) ? e[s] = r.slice() : e[s] = r;
    }, "assignValue");
  for (let r = 0, i = arguments.length; r < i; r++) arguments[r] && forEach$1(arguments[r], assignValue$1);
  return e;
}
o(merge$2, "merge");
const extend$1 = o((t, e, n, {
    allOwnKeys: r
  } = {}) => (forEach$1(e, (i, s) => {
    n && Bt(i) ? t[s] = bind$1(i, n) : t[s] = i;
  }, {
    allOwnKeys: r
  }), t), "extend$3"),
  stripBOM$1 = o(t => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), "stripBOM"),
  inherits = o((t, e, n, r) => {
    t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
      value: e.prototype
    }), n && Object.assign(t.prototype, n);
  }, "inherits"),
  toFlatObject = o((t, e, n, r) => {
    let i, s, a;
    const l = {};
    if (e = e || {}, t == null) return e;
    do {
      for (i = Object.getOwnPropertyNames(t), s = i.length; s-- > 0;) a = i[s], (!r || r(a, t, e)) && !l[a] && (e[a] = t[a], l[a] = !0);
      t = n !== !1 && Jd(t);
    } while (t && (!n || n(t, e)) && t !== Object.prototype);
    return e;
  }, "toFlatObject"),
  endsWith = o((t, e, n) => {
    t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
    const r = t.indexOf(e, n);
    return r !== -1 && r === n;
  }, "endsWith"),
  toArray = o(t => {
    if (!t) return null;
    if (ji(t)) return t;
    let e = t.length;
    if (!pw(e)) return null;
    const n = new Array(e);
    for (; e-- > 0;) n[e] = t[e];
    return n;
  }, "toArray"),
  px = (t => e => t && e instanceof t)(typeof Uint8Array < "u" && Jd(Uint8Array)),
  forEachEntry = o((t, e) => {
    const r = (t && t[Symbol.iterator]).call(t);
    let i;
    for (; (i = r.next()) && !i.done;) {
      const s = i.value;
      e.call(t, s[0], s[1]);
    }
  }, "forEachEntry"),
  matchAll = o((t, e) => {
    let n;
    const r = [];
    for (; (n = t.exec(e)) !== null;) r.push(n);
    return r;
  }, "matchAll"),
  gx = kindOfTest("HTMLFormElement"),
  toCamelCase = o(t => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, o(function (n, r, i) {
    return r.toUpperCase() + i;
  }, "replacer")), "toCamelCase$1"),
  cg = (({
    hasOwnProperty: t
  }) => (e, n) => t.call(e, n))(Object.prototype),
  vx = kindOfTest("RegExp"),
  reduceDescriptors = o((t, e) => {
    const n = Object.getOwnPropertyDescriptors(t),
      r = {};
    forEach$1(n, (i, s) => {
      let a;
      (a = e(i, s, t)) !== !1 && (r[s] = a || i);
    }), Object.defineProperties(t, r);
  }, "reduceDescriptors"),
  freezeMethods = o(t => {
    reduceDescriptors(t, (e, n) => {
      if (Bt(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
      const r = t[n];
      if (Bt(r)) {
        if (e.enumerable = !1, "writable" in e) {
          e.writable = !1;
          return;
        }
        e.set || (e.set = () => {
          throw Error("Can not rewrite read-only method '" + n + "'");
        });
      }
    });
  }, "freezeMethods"),
  toObjectSet = o((t, e) => {
    const n = {},
      define = o(i => {
        i.forEach(s => {
          n[s] = !0;
        });
      }, "define");
    return ji(t) ? define(t) : define(String(t).split(e)), n;
  }, "toObjectSet"),
  noop = o(() => {}, "noop$2"),
  toFiniteNumber = o((t, e) => t != null && Number.isFinite(t = +t) ? t : e, "toFiniteNumber"),
  pc = "abcdefghijklmnopqrstuvwxyz",
  fg = "0123456789",
  yw = {
    DIGIT: fg,
    ALPHA: pc,
    ALPHA_DIGIT: pc + pc.toUpperCase() + fg
  },
  generateString = o((t = 16, e = yw.ALPHA_DIGIT) => {
    let n = "";
    const {
      length: r
    } = e;
    for (; t--;) n += e[Math.random() * r | 0];
    return n;
  }, "generateString");
function isSpecCompliantForm(t) {
  return !!(t && Bt(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
o(isSpecCompliantForm, "isSpecCompliantForm");
const toJSONObject = o(t => {
    const e = new Array(10),
      visit = o((r, i) => {
        if (isObject$2(r)) {
          if (e.indexOf(r) >= 0) return;
          if (!("toJSON" in r)) {
            e[i] = r;
            const s = ji(r) ? [] : {};
            return forEach$1(r, (a, l) => {
              const u = visit(a, i + 1);
              !so(u) && (s[l] = u);
            }), e[i] = void 0, s;
          }
        }
        return r;
      }, "visit");
    return visit(t, 0);
  }, "toJSONObject"),
  xx = kindOfTest("AsyncFunction"),
  isThenable = o(t => t && (isObject$2(t) || Bt(t)) && Bt(t.then) && Bt(t.catch), "isThenable"),
  vw = ((t, e) => t ? setImmediate : e ? ((n, r) => (xr.addEventListener("message", ({
    source: i,
    data: s
  }) => {
    i === xr && s === n && r.length && r.shift()();
  }, !1), i => {
    r.push(i), xr.postMessage(n, "*");
  }))(`axios@${Math.random()}`, []) : n => setTimeout(n))(typeof setImmediate == "function", Bt(xr.postMessage)),
  _x = typeof queueMicrotask < "u" ? queueMicrotask.bind(xr) : typeof process < "u" && process.nextTick || vw,
  z = {
    isArray: ji,
    isArrayBuffer: dw,
    isBuffer: isBuffer$2,
    isFormData: isFormData$1,
    isArrayBufferView: isArrayBufferView$1,
    isString: GC,
    isNumber: pw,
    isBoolean: isBoolean$1,
    isObject: isObject$2,
    isPlainObject: isPlainObject$1,
    isReadableStream: nx,
    isRequest: rx,
    isResponse: ix,
    isHeaders: sx,
    isUndefined: so,
    isDate: YC,
    isFile: KC,
    isBlob: QC,
    isRegExp: vx,
    isFunction: Bt,
    isStream: isStream$1,
    isURLSearchParams: tx,
    isTypedArray: px,
    isFileList: JC,
    forEach: forEach$1,
    merge: merge$2,
    extend: extend$1,
    trim: trim$1,
    stripBOM: stripBOM$1,
    inherits: inherits,
    toFlatObject: toFlatObject,
    kindOf: $l,
    kindOfTest: kindOfTest,
    endsWith: endsWith,
    toArray: toArray,
    forEachEntry: forEachEntry,
    matchAll: matchAll,
    isHTMLForm: gx,
    hasOwnProperty: cg,
    hasOwnProp: cg,
    reduceDescriptors: reduceDescriptors,
    freezeMethods: freezeMethods,
    toObjectSet: toObjectSet,
    toCamelCase: toCamelCase,
    noop: noop,
    toFiniteNumber: toFiniteNumber,
    findKey: findKey,
    global: xr,
    isContextDefined: isContextDefined,
    ALPHABET: yw,
    generateString: generateString,
    isSpecCompliantForm: isSpecCompliantForm,
    toJSONObject: toJSONObject,
    isAsyncFn: xx,
    isThenable: isThenable,
    setImmediate: vw,
    asap: _x
  };
function AxiosError(t, e, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status ? i.status : null);
}
o(AxiosError, "AxiosError");
z.inherits(AxiosError, Error, {
  toJSON: o(function () {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: z.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }, "toJSON")
});
const ww = AxiosError.prototype,
  bw = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach(t => {
  bw[t] = {
    value: t
  };
});
Object.defineProperties(AxiosError, bw);
Object.defineProperty(ww, "isAxiosError", {
  value: !0
});
AxiosError.from = (t, e, n, r, i, s) => {
  const a = Object.create(ww);
  return z.toFlatObject(t, a, o(function (u) {
    return u !== Error.prototype;
  }, "filter"), l => l !== "isAxiosError"), AxiosError.call(a, t.message, e, n, r, i), a.cause = t, a.name = t.name, s && Object.assign(a, s), a;
};
const Ox = null;
function isVisitable(t) {
  return z.isPlainObject(t) || z.isArray(t);
}
o(isVisitable, "isVisitable");
function removeBrackets(t) {
  return z.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
o(removeBrackets, "removeBrackets");
function renderKey(t, e, n) {
  return t ? t.concat(e).map(o(function (i, s) {
    return i = removeBrackets(i), !n && s ? "[" + i + "]" : i;
  }, "each")).join(n ? "." : "") : e;
}
o(renderKey, "renderKey");
function isFlatArray(t) {
  return z.isArray(t) && !t.some(isVisitable);
}
o(isFlatArray, "isFlatArray");
const Lx = z.toFlatObject(z, {}, null, o(function (e) {
  return /^is[A-Z]/.test(e);
}, "filter"));
function toFormData(t, e, n) {
  if (!z.isObject(t)) throw new TypeError("target must be an object");
  e = e || new FormData(), n = z.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, o(function (w, g) {
    return !z.isUndefined(g[w]);
  }, "defined"));
  const r = n.metaTokens,
    i = n.visitor || defaultVisitor,
    s = n.dots,
    a = n.indexes,
    u = (n.Blob || typeof Blob < "u" && Blob) && z.isSpecCompliantForm(e);
  if (!z.isFunction(i)) throw new TypeError("visitor must be a function");
  function convertValue(S) {
    if (S === null) return "";
    if (z.isDate(S)) return S.toISOString();
    if (!u && z.isBlob(S)) throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    return z.isArrayBuffer(S) || z.isTypedArray(S) ? u && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  o(convertValue, "convertValue");
  function defaultVisitor(S, w, g) {
    let h = S;
    if (S && !g && typeof S == "object") {
      if (z.endsWith(w, "{}")) w = r ? w : w.slice(0, -2), S = JSON.stringify(S);else if (z.isArray(S) && isFlatArray(S) || (z.isFileList(S) || z.endsWith(w, "[]")) && (h = z.toArray(S))) return w = removeBrackets(w), h.forEach(o(function (v, E) {
        !(z.isUndefined(v) || v === null) && e.append(a === !0 ? renderKey([w], E, s) : a === null ? w : w + "[]", convertValue(v));
      }, "each")), !1;
    }
    return isVisitable(S) ? !0 : (e.append(renderKey(g, w, s), convertValue(S)), !1);
  }
  o(defaultVisitor, "defaultVisitor");
  const m = [],
    d = Object.assign(Lx, {
      defaultVisitor: defaultVisitor,
      convertValue: convertValue,
      isVisitable: isVisitable
    });
  function build(S, w) {
    if (!z.isUndefined(S)) {
      if (m.indexOf(S) !== -1) throw Error("Circular reference detected in " + w.join("."));
      m.push(S), z.forEach(S, o(function (h, f) {
        (!(z.isUndefined(h) || h === null) && i.call(e, h, z.isString(f) ? f.trim() : f, w, d)) === !0 && build(h, w ? w.concat(f) : [f]);
      }, "each")), m.pop();
    }
  }
  if (o(build, "build"), !z.isObject(t)) throw new TypeError("data must be an object");
  return build(t), e;
}
o(toFormData, "toFormData");
function encode$4(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, o(function (r) {
    return e[r];
  }, "replacer"));
}
o(encode$4, "encode$1");
function AxiosURLSearchParams(t, e) {
  this._pairs = [], t && toFormData(t, this, e);
}
o(AxiosURLSearchParams, "AxiosURLSearchParams");
const Ew = AxiosURLSearchParams.prototype;
Ew.append = o(function (e, n) {
  this._pairs.push([e, n]);
}, "append");
Ew.toString = o(function (e) {
  const n = e ? function (r) {
    return e.call(this, r, encode$4);
  } : encode$4;
  return this._pairs.map(o(function (i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "each"), "").join("&");
}, "toString");
function encode$5(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
o(encode$5, "encode");
function buildURL$1(t, e, n) {
  if (!e) return t;
  const r = n && n.encode || encode$5,
    i = n && n.serialize;
  let s;
  if (i ? s = i(e, n) : s = z.isURLSearchParams(e) ? e.toString() : new AxiosURLSearchParams(e, n).toString(r), s) {
    const a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return t;
}
o(buildURL$1, "buildURL");
class InterceptorManager$1 {
  constructor() {
    this.handlers = [];
  }
  use(e, n, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    z.forEach(this.handlers, o(function (r) {
      r !== null && e(r);
    }, "forEachHandler"));
  }
}
o(InterceptorManager$1, "InterceptorManager");
const hg = InterceptorManager$1,
  Cw = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  Dx = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams,
  Ix = typeof FormData < "u" ? FormData : null,
  Rx = typeof Blob < "u" ? Blob : null,
  Nx = {
    isBrowser: !0,
    classes: {
      URLSearchParams: Dx,
      FormData: Ix,
      Blob: Rx
    },
    protocols: ["http", "https", "file", "blob", "url", "data"]
  },
  ep = typeof window < "u" && typeof document < "u",
  Pf = typeof navigator == "object" && navigator || void 0,
  $x = ep && (!Pf || ["ReactNative", "NativeScript", "NS"].indexOf(Pf.product) < 0),
  Fx = (() => typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(),
  jx = ep && window.location.href || "http://localhost",
  Bx = Object.freeze(Object.defineProperty({
    __proto__: null,
    hasBrowserEnv: ep,
    hasStandardBrowserEnv: $x,
    hasStandardBrowserWebWorkerEnv: Fx,
    navigator: Pf,
    origin: jx
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  It = {
    ...Bx,
    ...Nx
  };
function toURLEncodedForm(t, e) {
  return toFormData(t, new It.classes.URLSearchParams(), Object.assign({
    visitor: function (n, r, i, s) {
      return It.isNode && z.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
o(toURLEncodedForm, "toURLEncodedForm");
function parsePropPath(t) {
  return z.matchAll(/\w+|\[(\w*)]/g, t).map(e => e[0] === "[]" ? "" : e[1] || e[0]);
}
o(parsePropPath, "parsePropPath");
function arrayToObject$1(t) {
  const e = {},
    n = Object.keys(t);
  let r;
  const i = n.length;
  let s;
  for (r = 0; r < i; r++) s = n[r], e[s] = t[s];
  return e;
}
o(arrayToObject$1, "arrayToObject");
function formDataToJSON(t) {
  function buildPath(n, r, i, s) {
    let a = n[s++];
    if (a === "__proto__") return !0;
    const l = Number.isFinite(+a),
      u = s >= n.length;
    return a = !a && z.isArray(i) ? i.length : a, u ? (z.hasOwnProp(i, a) ? i[a] = [i[a], r] : i[a] = r, !l) : ((!i[a] || !z.isObject(i[a])) && (i[a] = []), buildPath(n, r, i[a], s) && z.isArray(i[a]) && (i[a] = arrayToObject$1(i[a])), !l);
  }
  if (o(buildPath, "buildPath"), z.isFormData(t) && z.isFunction(t.entries)) {
    const n = {};
    return z.forEachEntry(t, (r, i) => {
      buildPath(parsePropPath(r), i, n, 0);
    }), n;
  }
  return null;
}
o(formDataToJSON, "formDataToJSON");
function stringifySafely$1(t, e, n) {
  if (z.isString(t)) try {
    return (e || JSON.parse)(t), z.trim(t);
  } catch (r) {
    if (r.name !== "SyntaxError") throw r;
  }
  return (n || JSON.stringify)(t);
}
o(stringifySafely$1, "stringifySafely");
const tp = {
  transitional: Cw,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [o(function (e, n) {
    const r = n.getContentType() || "",
      i = r.indexOf("application/json") > -1,
      s = z.isObject(e);
    if (s && z.isHTMLForm(e) && (e = new FormData(e)), z.isFormData(e)) return i ? JSON.stringify(formDataToJSON(e)) : e;
    if (z.isArrayBuffer(e) || z.isBuffer(e) || z.isStream(e) || z.isFile(e) || z.isBlob(e) || z.isReadableStream(e)) return e;
    if (z.isArrayBufferView(e)) return e.buffer;
    if (z.isURLSearchParams(e)) return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let l;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1) return toURLEncodedForm(e, this.formSerializer).toString();
      if ((l = z.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return toFormData(l ? {
          "files[]": e
        } : e, u && new u(), this.formSerializer);
      }
    }
    return s || i ? (n.setContentType("application/json", !1), stringifySafely$1(e)) : e;
  }, "transformRequest")],
  transformResponse: [o(function (e) {
    const n = this.transitional || tp.transitional,
      r = n && n.forcedJSONParsing,
      i = this.responseType === "json";
    if (z.isResponse(e) || z.isReadableStream(e)) return e;
    if (e && z.isString(e) && (r && !this.responseType || i)) {
      const a = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(e);
      } catch (l) {
        if (a) throw l.name === "SyntaxError" ? AxiosError.from(l, AxiosError.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return e;
  }, "transformResponse")],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: It.classes.FormData,
    Blob: It.classes.Blob
  },
  validateStatus: o(function (e) {
    return e >= 200 && e < 300;
  }, "validateStatus"),
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
z.forEach(["delete", "get", "head", "post", "put", "patch"], t => {
  tp.headers[t] = {};
});
const np = tp,
  Vx = z.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]),
  parseHeaders = o(t => {
    const e = {};
    let n, r, i;
    return t && t.split(`
`).forEach(o(function (a) {
      i = a.indexOf(":"), n = a.substring(0, i).trim().toLowerCase(), r = a.substring(i + 1).trim(), !(!n || e[n] && Vx[n]) && (n === "set-cookie" ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ", " + r : r);
    }, "parser")), e;
  }, "parseHeaders"),
  mg = Symbol("internals");
function normalizeHeader(t) {
  return t && String(t).trim().toLowerCase();
}
o(normalizeHeader, "normalizeHeader");
function normalizeValue(t) {
  return t === !1 || t == null ? t : z.isArray(t) ? t.map(normalizeValue) : String(t);
}
o(normalizeValue, "normalizeValue");
function parseTokens(t) {
  const e = Object.create(null),
    n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(t);) e[r[1]] = r[2];
  return e;
}
o(parseTokens, "parseTokens");
const isValidHeaderName = o(t => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim()), "isValidHeaderName");
function matchHeaderValue(t, e, n, r, i) {
  if (z.isFunction(r)) return r.call(this, e, n);
  if (i && (e = n), !!z.isString(e)) {
    if (z.isString(r)) return e.indexOf(r) !== -1;
    if (z.isRegExp(r)) return r.test(e);
  }
}
o(matchHeaderValue, "matchHeaderValue");
function formatHeader(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, r) => n.toUpperCase() + r);
}
o(formatHeader, "formatHeader");
function buildAccessors(t, e) {
  const n = z.toCamelCase(" " + e);
  ["get", "set", "has"].forEach(r => {
    Object.defineProperty(t, r + n, {
      value: function (i, s, a) {
        return this[r].call(this, e, i, s, a);
      },
      configurable: !0
    });
  });
}
o(buildAccessors, "buildAccessors");
class AxiosHeaders {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const i = this;
    function setHeader(l, u, c) {
      const p = normalizeHeader(u);
      if (!p) throw new Error("header name must be a non-empty string");
      const m = z.findKey(i, p);
      (!m || i[m] === void 0 || c === !0 || c === void 0 && i[m] !== !1) && (i[m || u] = normalizeValue(l));
    }
    o(setHeader, "setHeader");
    const setHeaders = o((l, u) => z.forEach(l, (c, p) => setHeader(c, p, u)), "setHeaders");
    if (z.isPlainObject(e) || e instanceof this.constructor) setHeaders(e, n);else if (z.isString(e) && (e = e.trim()) && !isValidHeaderName(e)) setHeaders(parseHeaders(e), n);else if (z.isHeaders(e)) for (const [l, u] of e.entries()) setHeader(u, l, r);else e != null && setHeader(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = normalizeHeader(e), e) {
      const r = z.findKey(this, e);
      if (r) {
        const i = this[r];
        if (!n) return i;
        if (n === !0) return parseTokens(i);
        if (z.isFunction(n)) return n.call(this, i, r);
        if (z.isRegExp(n)) return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = normalizeHeader(e), e) {
      const r = z.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!n || matchHeaderValue(this, this[r], r, n)));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let i = !1;
    function deleteHeader(a) {
      if (a = normalizeHeader(a), a) {
        const l = z.findKey(r, a);
        l && (!n || matchHeaderValue(r, r[l], l, n)) && (delete r[l], i = !0);
      }
    }
    return o(deleteHeader, "deleteHeader"), z.isArray(e) ? e.forEach(deleteHeader) : deleteHeader(e), i;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length,
      i = !1;
    for (; r--;) {
      const s = n[r];
      (!e || matchHeaderValue(this, this[s], s, e, !0)) && (delete this[s], i = !0);
    }
    return i;
  }
  normalize(e) {
    const n = this,
      r = {};
    return z.forEach(this, (i, s) => {
      const a = z.findKey(r, s);
      if (a) {
        n[a] = normalizeValue(i), delete n[s];
        return;
      }
      const l = e ? formatHeader(s) : String(s).trim();
      l !== s && delete n[s], n[l] = normalizeValue(i), r[l] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = Object.create(null);
    return z.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = e && z.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach(i => r.set(i)), r;
  }
  static accessor(e) {
    const r = (this[mg] = this[mg] = {
        accessors: {}
      }).accessors,
      i = this.prototype;
    function defineAccessor(a) {
      const l = normalizeHeader(a);
      r[l] || (buildAccessors(i, a), r[l] = !0);
    }
    return o(defineAccessor, "defineAccessor"), z.isArray(e) ? e.forEach(defineAccessor) : defineAccessor(e), this;
  }
}
o(AxiosHeaders, "AxiosHeaders");
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
z.reduceDescriptors(AxiosHeaders.prototype, ({
  value: t
}, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(r) {
      this[n] = r;
    }
  };
});
z.freezeMethods(AxiosHeaders);
const ln = AxiosHeaders;
function transformData$1(t, e) {
  const n = this || np,
    r = e || n,
    i = ln.from(r.headers);
  let s = r.data;
  return z.forEach(t, o(function (l) {
    s = l.call(n, s, i.normalize(), e ? e.status : void 0);
  }, "transform")), i.normalize(), s;
}
o(transformData$1, "transformData");
function isCancel(t) {
  return !!(t && t.__CANCEL__);
}
o(isCancel, "isCancel");
function CanceledError(t, e, n) {
  AxiosError.call(this, t ?? "canceled", AxiosError.ERR_CANCELED, e, n), this.name = "CanceledError";
}
o(CanceledError, "CanceledError");
z.inherits(CanceledError, AxiosError, {
  __CANCEL__: !0
});
function settle(t, e, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? t(n) : e(new AxiosError("Request failed with status code " + n.status, [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n));
}
o(settle, "settle");
function parseProtocol(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
o(parseProtocol, "parseProtocol");
function speedometer(t, e) {
  t = t || 10;
  const n = new Array(t),
    r = new Array(t);
  let i = 0,
    s = 0,
    a;
  return e = e !== void 0 ? e : 1e3, o(function (u) {
    const c = Date.now(),
      p = r[s];
    a || (a = c), n[i] = u, r[i] = c;
    let m = s,
      d = 0;
    for (; m !== i;) d += n[m++], m = m % t;
    if (i = (i + 1) % t, i === s && (s = (s + 1) % t), c - a < e) return;
    const y = p && c - p;
    return y ? Math.round(d * 1e3 / y) : void 0;
  }, "push");
}
o(speedometer, "speedometer");
function throttle$2(t, e) {
  let n = 0,
    r = 1e3 / e,
    i,
    s;
  const invoke = o((c, p = Date.now()) => {
    n = p, i = null, s && (clearTimeout(s), s = null), t.apply(null, c);
  }, "invoke");
  return [o((...c) => {
    const p = Date.now(),
      m = p - n;
    m >= r ? invoke(c, p) : (i = c, s || (s = setTimeout(() => {
      s = null, invoke(i);
    }, r - m)));
  }, "throttled"), o(() => i && invoke(i), "flush")];
}
o(throttle$2, "throttle");
const progressEventReducer = o((t, e, n = 3) => {
    let r = 0;
    const i = speedometer(50, 250);
    return throttle$2(s => {
      const a = s.loaded,
        l = s.lengthComputable ? s.total : void 0,
        u = a - r,
        c = i(u),
        p = a <= l;
      r = a;
      const m = {
        loaded: a,
        total: l,
        progress: l ? a / l : void 0,
        bytes: u,
        rate: c || void 0,
        estimated: c && l && p ? (l - a) / c : void 0,
        event: s,
        lengthComputable: l != null,
        [e ? "download" : "upload"]: !0
      };
      t(m);
    }, n);
  }, "progressEventReducer"),
  progressEventDecorator = o((t, e) => {
    const n = t != null;
    return [r => e[0]({
      lengthComputable: n,
      total: t,
      loaded: r
    }), e[1]];
  }, "progressEventDecorator"),
  asyncDecorator = o(t => (...e) => z.asap(() => t(...e)), "asyncDecorator"),
  ek = It.hasStandardBrowserEnv ? o(function () {
    const e = It.navigator && /(msie|trident)/i.test(It.navigator.userAgent),
      n = document.createElement("a");
    let r;
    function resolveURL$1(s) {
      let a = s;
      return e && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return o(resolveURL$1, "resolveURL"), r = resolveURL$1(window.location.href), o(function (a) {
      const l = z.isString(a) ? resolveURL$1(a) : a;
      return l.protocol === r.protocol && l.host === r.host;
    }, "isURLSameOrigin");
  }, "standardBrowserEnv")() : o(function () {
    return o(function () {
      return !0;
    }, "isURLSameOrigin");
  }, "nonStandardBrowserEnv")(),
  tk = It.hasStandardBrowserEnv ? {
    write(t, e, n, r, i, s) {
      const a = [t + "=" + encodeURIComponent(e)];
      z.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), z.isString(r) && a.push("path=" + r), z.isString(i) && a.push("domain=" + i), s === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  } : {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };
function isAbsoluteURL(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
o(isAbsoluteURL, "isAbsoluteURL");
function combineURLs(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
o(combineURLs, "combineURLs");
function buildFullPath(t, e) {
  return t && !isAbsoluteURL(e) ? combineURLs(t, e) : e;
}
o(buildFullPath, "buildFullPath");
const headersToObject = o(t => t instanceof ln ? {
  ...t
} : t, "headersToObject");
function mergeConfig$1(t, e) {
  e = e || {};
  const n = {};
  function getMergedValue$1(c, p, m) {
    return z.isPlainObject(c) && z.isPlainObject(p) ? z.merge.call({
      caseless: m
    }, c, p) : z.isPlainObject(p) ? z.merge({}, p) : z.isArray(p) ? p.slice() : p;
  }
  o(getMergedValue$1, "getMergedValue");
  function mergeDeepProperties$1(c, p, m) {
    if (z.isUndefined(p)) {
      if (!z.isUndefined(c)) return getMergedValue$1(void 0, c, m);
    } else return getMergedValue$1(c, p, m);
  }
  o(mergeDeepProperties$1, "mergeDeepProperties");
  function valueFromConfig2(c, p) {
    if (!z.isUndefined(p)) return getMergedValue$1(void 0, p);
  }
  o(valueFromConfig2, "valueFromConfig2");
  function defaultToConfig2(c, p) {
    if (z.isUndefined(p)) {
      if (!z.isUndefined(c)) return getMergedValue$1(void 0, c);
    } else return getMergedValue$1(void 0, p);
  }
  o(defaultToConfig2, "defaultToConfig2");
  function mergeDirectKeys(c, p, m) {
    if (m in e) return getMergedValue$1(c, p);
    if (m in t) return getMergedValue$1(void 0, c);
  }
  o(mergeDirectKeys, "mergeDirectKeys");
  const u = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (c, p) => mergeDeepProperties$1(headersToObject(c), headersToObject(p), !0)
  };
  return z.forEach(Object.keys(Object.assign({}, t, e)), o(function (p) {
    const m = u[p] || mergeDeepProperties$1,
      d = m(t[p], e[p], p);
    z.isUndefined(d) && m !== mergeDirectKeys || (n[p] = d);
  }, "computeConfigValue")), n;
}
o(mergeConfig$1, "mergeConfig");
const resolveConfig = o(t => {
    const e = mergeConfig$1({}, t);
    let {
      data: n,
      withXSRFToken: r,
      xsrfHeaderName: i,
      xsrfCookieName: s,
      headers: a,
      auth: l
    } = e;
    e.headers = a = ln.from(a), e.url = buildURL$1(buildFullPath(e.baseURL, e.url), t.params, t.paramsSerializer), l && a.set("Authorization", "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : "")));
    let u;
    if (z.isFormData(n)) {
      if (It.hasStandardBrowserEnv || It.hasStandardBrowserWebWorkerEnv) a.setContentType(void 0);else if ((u = a.getContentType()) !== !1) {
        const [c, ...p] = u ? u.split(";").map(m => m.trim()).filter(Boolean) : [];
        a.setContentType([c || "multipart/form-data", ...p].join("; "));
      }
    }
    if (It.hasStandardBrowserEnv && (r && z.isFunction(r) && (r = r(e)), r || r !== !1 && ek(e.url))) {
      const c = i && s && tk.read(s);
      c && a.set(i, c);
    }
    return e;
  }, "resolveConfig"),
  ik = typeof XMLHttpRequest < "u",
  sk = ik && function (t) {
    return new Promise(o(function (n, r) {
      const i = resolveConfig(t);
      let s = i.data;
      const a = ln.from(i.headers).normalize();
      let {
          responseType: l,
          onUploadProgress: u,
          onDownloadProgress: c
        } = i,
        p,
        m,
        d,
        y,
        S;
      function done() {
        y && y(), S && S(), i.cancelToken && i.cancelToken.unsubscribe(p), i.signal && i.signal.removeEventListener("abort", p);
      }
      o(done, "done");
      let g = new XMLHttpRequest();
      g.open(i.method.toUpperCase(), i.url, !0), g.timeout = i.timeout;
      function onloadend$1() {
        if (!g) return;
        const v = ln.from("getAllResponseHeaders" in g && g.getAllResponseHeaders()),
          b = {
            data: !l || l === "text" || l === "json" ? g.responseText : g.response,
            status: g.status,
            statusText: g.statusText,
            headers: v,
            config: t,
            request: g
          };
        settle(o(function (T) {
          n(T), done();
        }, "_resolve"), o(function (T) {
          r(T), done();
        }, "_reject"), b), g = null;
      }
      o(onloadend$1, "onloadend"), "onloadend" in g ? g.onloadend = onloadend$1 : g.onreadystatechange = o(function () {
        !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(onloadend$1);
      }, "handleLoad"), g.onabort = o(function () {
        g && (r(new AxiosError("Request aborted", AxiosError.ECONNABORTED, t, g)), g = null);
      }, "handleAbort"), g.onerror = o(function () {
        r(new AxiosError("Network Error", AxiosError.ERR_NETWORK, t, g)), g = null;
      }, "handleError"), g.ontimeout = o(function () {
        let E = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
        const b = i.transitional || Cw;
        i.timeoutErrorMessage && (E = i.timeoutErrorMessage), r(new AxiosError(E, b.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED, t, g)), g = null;
      }, "handleTimeout"), s === void 0 && a.setContentType(null), "setRequestHeader" in g && z.forEach(a.toJSON(), o(function (E, b) {
        g.setRequestHeader(b, E);
      }, "setRequestHeader")), z.isUndefined(i.withCredentials) || (g.withCredentials = !!i.withCredentials), l && l !== "json" && (g.responseType = i.responseType), c && ([d, S] = progressEventReducer(c, !0), g.addEventListener("progress", d)), u && g.upload && ([m, y] = progressEventReducer(u), g.upload.addEventListener("progress", m), g.upload.addEventListener("loadend", y)), (i.cancelToken || i.signal) && (p = o(v => {
        g && (r(!v || v.type ? new CanceledError(null, t, g) : v), g.abort(), g = null);
      }, "onCanceled"), i.cancelToken && i.cancelToken.subscribe(p), i.signal && (i.signal.aborted ? p() : i.signal.addEventListener("abort", p)));
      const f = parseProtocol(i.url);
      if (f && It.protocols.indexOf(f) === -1) {
        r(new AxiosError("Unsupported protocol " + f + ":", AxiosError.ERR_BAD_REQUEST, t));
        return;
      }
      g.send(s || null);
    }, "dispatchXhrRequest"));
  },
  composeSignals = o((t, e) => {
    const {
      length: n
    } = t = t ? t.filter(Boolean) : [];
    if (e || n) {
      let r = new AbortController(),
        i;
      const onabort = o(function (c) {
        if (!i) {
          i = !0, unsubscribe();
          const p = c instanceof Error ? c : this.reason;
          r.abort(p instanceof AxiosError ? p : new CanceledError(p instanceof Error ? p.message : p));
        }
      }, "onabort");
      let a = e && setTimeout(() => {
        a = null, onabort(new AxiosError(`timeout ${e} of ms exceeded`, AxiosError.ETIMEDOUT));
      }, e);
      const unsubscribe = o(() => {
        t && (a && clearTimeout(a), a = null, t.forEach(c => {
          c.unsubscribe ? c.unsubscribe(onabort) : c.removeEventListener("abort", onabort);
        }), t = null);
      }, "unsubscribe");
      t.forEach(c => c.addEventListener("abort", onabort));
      const {
        signal: u
      } = r;
      return u.unsubscribe = () => z.asap(unsubscribe), u;
    }
  }, "composeSignals"),
  ak = composeSignals,
  streamChunk = o(function* (t, e) {
    let n = t.byteLength;
    if (!e || n < e) {
      yield t;
      return;
    }
    let r = 0,
      i;
    for (; r < n;) i = r + e, yield t.slice(r, i), r = i;
  }, "streamChunk"),
  readBytes = o(async function* (t, e) {
    for await (const n of readStream(t)) yield* streamChunk(n, e);
  }, "readBytes"),
  readStream = o(async function* (t) {
    if (t[Symbol.asyncIterator]) {
      yield* t;
      return;
    }
    const e = t.getReader();
    try {
      for (;;) {
        const {
          done: n,
          value: r
        } = await e.read();
        if (n) break;
        yield r;
      }
    } finally {
      await e.cancel();
    }
  }, "readStream"),
  trackStream = o((t, e, n, r) => {
    const i = readBytes(t, e);
    let s = 0,
      a,
      _onFinish = o(u => {
        a || (a = !0, r && r(u));
      }, "_onFinish");
    return new ReadableStream({
      async pull(u) {
        try {
          const {
            done: c,
            value: p
          } = await i.next();
          if (c) {
            _onFinish(), u.close();
            return;
          }
          let m = p.byteLength;
          if (n) {
            let d = s += m;
            n(d);
          }
          u.enqueue(new Uint8Array(p));
        } catch (c) {
          throw _onFinish(c), c;
        }
      },
      cancel(u) {
        return _onFinish(u), i.return();
      }
    }, {
      highWaterMark: 2
    });
  }, "trackStream"),
  zl = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function",
  Lw = zl && typeof ReadableStream == "function",
  fk = zl && (typeof TextEncoder == "function" ? (t => e => t.encode(e))(new TextEncoder()) : async t => new Uint8Array(await new Response(t).arrayBuffer())),
  test = o((t, ...e) => {
    try {
      return !!t(...e);
    } catch {
      return !1;
    }
  }, "test"),
  dk = Lw && test(() => {
    let t = !1;
    const e = new Request(It.origin, {
      body: new ReadableStream(),
      method: "POST",
      get duplex() {
        return t = !0, "half";
      }
    }).headers.has("Content-Type");
    return t && !e;
  }),
  bg = 64 * 1024,
  Cf = Lw && test(() => z.isReadableStream(new Response("").body)),
  Wa = {
    stream: Cf && (t => t.body)
  };
zl && (t => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach(e => {
    !Wa[e] && (Wa[e] = z.isFunction(t[e]) ? n => n[e]() : (n, r) => {
      throw new AxiosError(`Response type '${e}' is not supported`, AxiosError.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const getBodyLength = o(async t => {
    if (t == null) return 0;
    if (z.isBlob(t)) return t.size;
    if (z.isSpecCompliantForm(t)) return (await new Request(It.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
    if (z.isArrayBufferView(t) || z.isArrayBuffer(t)) return t.byteLength;
    if (z.isURLSearchParams(t) && (t = t + ""), z.isString(t)) return (await fk(t)).byteLength;
  }, "getBodyLength"),
  resolveBodyLength = o(async (t, e) => {
    const n = z.toFiniteNumber(t.getContentLength());
    return n ?? getBodyLength(e);
  }, "resolveBodyLength"),
  mk = zl && (async t => {
    let {
      url: e,
      method: n,
      data: r,
      signal: i,
      cancelToken: s,
      timeout: a,
      onDownloadProgress: l,
      onUploadProgress: u,
      responseType: c,
      headers: p,
      withCredentials: m = "same-origin",
      fetchOptions: d
    } = resolveConfig(t);
    c = c ? (c + "").toLowerCase() : "text";
    let y = ak([i, s && s.toAbortSignal()], a),
      S;
    const w = y && y.unsubscribe && (() => {
      y.unsubscribe();
    });
    let g;
    try {
      if (u && dk && n !== "get" && n !== "head" && (g = await resolveBodyLength(p, r)) !== 0) {
        let b = new Request(e, {
            method: "POST",
            body: r,
            duplex: "half"
          }),
          P;
        if (z.isFormData(r) && (P = b.headers.get("content-type")) && p.setContentType(P), b.body) {
          const [T, O] = progressEventDecorator(g, progressEventReducer(asyncDecorator(u)));
          r = trackStream(b.body, bg, T, O);
        }
      }
      z.isString(m) || (m = m ? "include" : "omit");
      const h = "credentials" in Request.prototype;
      S = new Request(e, {
        ...d,
        signal: y,
        method: n.toUpperCase(),
        headers: p.normalize().toJSON(),
        body: r,
        duplex: "half",
        credentials: h ? m : void 0
      });
      let f = await fetch(S);
      const v = Cf && (c === "stream" || c === "response");
      if (Cf && (l || v && w)) {
        const b = {};
        ["status", "statusText", "headers"].forEach(M => {
          b[M] = f[M];
        });
        const P = z.toFiniteNumber(f.headers.get("content-length")),
          [T, O] = l && progressEventDecorator(P, progressEventReducer(asyncDecorator(l), !0)) || [];
        f = new Response(trackStream(f.body, bg, T, () => {
          O && O(), w && w();
        }), b);
      }
      c = c || "text";
      let E = await Wa[z.findKey(Wa, c) || "text"](f, t);
      return !v && w && w(), await new Promise((b, P) => {
        settle(b, P, {
          data: E,
          headers: ln.from(f.headers),
          status: f.status,
          statusText: f.statusText,
          config: t,
          request: S
        });
      });
    } catch (h) {
      throw w && w(), h && h.name === "TypeError" && /fetch/i.test(h.message) ? Object.assign(new AxiosError("Network Error", AxiosError.ERR_NETWORK, t, S), {
        cause: h.cause || h
      }) : AxiosError.from(h, h && h.code, t, S);
    }
  }),
  xf = {
    http: Ox,
    xhr: sk,
    fetch: mk
  };
z.forEach(xf, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", {
        value: e
      });
    } catch {}
    Object.defineProperty(t, "adapterName", {
      value: e
    });
  }
});
const renderReason = o(t => `- ${t}`, "renderReason"),
  isResolvedHandle = o(t => z.isFunction(t) || t === null || t === !1, "isResolvedHandle"),
  Dw = {
    getAdapter: t => {
      t = z.isArray(t) ? t : [t];
      const {
        length: e
      } = t;
      let n, r;
      const i = {};
      for (let s = 0; s < e; s++) {
        n = t[s];
        let a;
        if (r = n, !isResolvedHandle(n) && (r = xf[(a = String(n)).toLowerCase()], r === void 0)) throw new AxiosError(`Unknown adapter '${a}'`);
        if (r) break;
        i[a || "#" + s] = r;
      }
      if (!r) {
        const s = Object.entries(i).map(([l, u]) => `adapter ${l} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build"));
        let a = e ? s.length > 1 ? `since :
` + s.map(renderReason).join(`
`) : " " + renderReason(s[0]) : "as no adapter specified";
        throw new AxiosError("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
      }
      return r;
    },
    adapters: xf
  };
function throwIfCancellationRequested$1(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new CanceledError(null, t);
}
o(throwIfCancellationRequested$1, "throwIfCancellationRequested");
function dispatchRequest$1(t) {
  return throwIfCancellationRequested$1(t), t.headers = ln.from(t.headers), t.data = transformData$1.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Dw.getAdapter(t.adapter || np.adapter)(t).then(o(function (r) {
    return throwIfCancellationRequested$1(t), r.data = transformData$1.call(t, t.transformResponse, r), r.headers = ln.from(r.headers), r;
  }, "onAdapterResolution"), o(function (r) {
    return isCancel(r) || (throwIfCancellationRequested$1(t), r && r.response && (r.response.data = transformData$1.call(t, t.transformResponse, r.response), r.response.headers = ln.from(r.response.headers))), Promise.reject(r);
  }, "onAdapterRejection"));
}
o(dispatchRequest$1, "dispatchRequest");
const Iw = "1.7.7",
  rp = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  rp[t] = o(function (r) {
    return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
  }, "validator");
});
const Tg = {};
rp.transitional = o(function (e, n, r) {
  function formatMessage$1(s, a) {
    return "[Axios v" + Iw + "] Transitional option '" + s + "'" + a + (r ? ". " + r : "");
  }
  return o(formatMessage$1, "formatMessage"), (s, a, l) => {
    if (e === !1) throw new AxiosError(formatMessage$1(a, " has been removed" + (n ? " in " + n : "")), AxiosError.ERR_DEPRECATED);
    return n && !Tg[a] && (Tg[a] = !0, console.warn(formatMessage$1(a, " has been deprecated since v" + n + " and will be removed in the near future"))), e ? e(s, a, l) : !0;
  };
}, "transitional");
function assertOptions$1(t, e, n) {
  if (typeof t != "object") throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let i = r.length;
  for (; i-- > 0;) {
    const s = r[i],
      a = e[s];
    if (a) {
      const l = t[s],
        u = l === void 0 || a(l, s, t);
      if (u !== !0) throw new AxiosError("option " + s + " must be " + u, AxiosError.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0) throw new AxiosError("Unknown option " + s, AxiosError.ERR_BAD_OPTION);
  }
}
o(assertOptions$1, "assertOptions");
const kf = {
    assertOptions: assertOptions$1,
    validators: rp
  },
  Fn = kf.validators;
class Axios$1 {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new hg(),
      response: new hg()
    };
  }
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let i;
        Error.captureStackTrace ? Error.captureStackTrace(i = {}) : i = new Error();
        const s = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
        } catch {}
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = mergeConfig$1(this.defaults, n);
    const {
      transitional: r,
      paramsSerializer: i,
      headers: s
    } = n;
    r !== void 0 && kf.assertOptions(r, {
      silentJSONParsing: Fn.transitional(Fn.boolean),
      forcedJSONParsing: Fn.transitional(Fn.boolean),
      clarifyTimeoutError: Fn.transitional(Fn.boolean)
    }, !1), i != null && (z.isFunction(i) ? n.paramsSerializer = {
      serialize: i
    } : kf.assertOptions(i, {
      encode: Fn.function,
      serialize: Fn.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = s && z.merge(s.common, s[n.method]);
    s && z.forEach(["delete", "get", "head", "post", "put", "patch", "common"], S => {
      delete s[S];
    }), n.headers = ln.concat(a, s);
    const l = [];
    let u = !0;
    this.interceptors.request.forEach(o(function (w) {
      typeof w.runWhen == "function" && w.runWhen(n) === !1 || (u = u && w.synchronous, l.unshift(w.fulfilled, w.rejected));
    }, "unshiftRequestInterceptors"));
    const c = [];
    this.interceptors.response.forEach(o(function (w) {
      c.push(w.fulfilled, w.rejected);
    }, "pushResponseInterceptors"));
    let p,
      m = 0,
      d;
    if (!u) {
      const S = [dispatchRequest$1.bind(this), void 0];
      for (S.unshift.apply(S, l), S.push.apply(S, c), d = S.length, p = Promise.resolve(n); m < d;) p = p.then(S[m++], S[m++]);
      return p;
    }
    d = l.length;
    let y = n;
    for (m = 0; m < d;) {
      const S = l[m++],
        w = l[m++];
      try {
        y = S(y);
      } catch (g) {
        w.call(this, g);
        break;
      }
    }
    try {
      p = dispatchRequest$1.call(this, y);
    } catch (S) {
      return Promise.reject(S);
    }
    for (m = 0, d = c.length; m < d;) p = p.then(c[m++], c[m++]);
    return p;
  }
  getUri(e) {
    e = mergeConfig$1(this.defaults, e);
    const n = buildFullPath(e.baseURL, e.url);
    return buildURL$1(n, e.params, e.paramsSerializer);
  }
}
o(Axios$1, "Axios");
z.forEach(["delete", "get", "head", "options"], o(function (e) {
  Axios$1.prototype[e] = function (n, r) {
    return this.request(mergeConfig$1(r || {}, {
      method: e,
      url: n,
      data: (r || {}).data
    }));
  };
}, "forEachMethodNoData"));
z.forEach(["post", "put", "patch"], o(function (e) {
  function generateHTTPMethod(r) {
    return o(function (s, a, l) {
      return this.request(mergeConfig$1(l || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: a
      }));
    }, "httpMethod");
  }
  o(generateHTTPMethod, "generateHTTPMethod"), Axios$1.prototype[e] = generateHTTPMethod(), Axios$1.prototype[e + "Form"] = generateHTTPMethod(!0);
}, "forEachMethodWithData"));
const ha = Axios$1;
class CancelToken$1 {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(o(function (s) {
      n = s;
    }, "promiseExecutor"));
    const r = this;
    this.promise.then(i => {
      if (!r._listeners) return;
      let s = r._listeners.length;
      for (; s-- > 0;) r._listeners[s](i);
      r._listeners = null;
    }), this.promise.then = i => {
      let s;
      const a = new Promise(l => {
        r.subscribe(l), s = l;
      }).then(i);
      return a.cancel = o(function () {
        r.unsubscribe(s);
      }, "reject"), a;
    }, e(o(function (s, a, l) {
      r.reason || (r.reason = new CanceledError(s, a, l), n(r.reason));
    }, "cancel"));
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(),
      abort = o(r => {
        e.abort(r);
      }, "abort");
    return this.subscribe(abort), e.signal.unsubscribe = () => this.unsubscribe(abort), e.signal;
  }
  static source() {
    let e;
    return {
      token: new CancelToken$1(o(function (i) {
        e = i;
      }, "executor")),
      cancel: e
    };
  }
}
o(CancelToken$1, "CancelToken");
const vk = CancelToken$1;
function spread(t) {
  return o(function (n) {
    return t.apply(null, n);
  }, "wrap");
}
o(spread, "spread");
function isAxiosError(t) {
  return z.isObject(t) && t.isAxiosError === !0;
}
o(isAxiosError, "isAxiosError");
const _f = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(_f).forEach(([t, e]) => {
  _f[e] = t;
});
const Sk = _f;
function createInstance$1(t) {
  const e = new ha(t),
    n = bind$1(ha.prototype.request, e);
  return z.extend(n, ha.prototype, e, {
    allOwnKeys: !0
  }), z.extend(n, e, null, {
    allOwnKeys: !0
  }), n.create = o(function (i) {
    return createInstance$1(mergeConfig$1(t, i));
  }, "create"), n;
}
o(createInstance$1, "createInstance");
const Ze = createInstance$1(np);
Ze.Axios = ha;
Ze.CanceledError = CanceledError;
Ze.CancelToken = vk;
Ze.isCancel = isCancel;
Ze.VERSION = Iw;
Ze.toFormData = toFormData;
Ze.AxiosError = AxiosError;
Ze.Cancel = Ze.CanceledError;
Ze.all = o(function (e) {
  return Promise.all(e);
}, "all");
Ze.spread = spread;
Ze.isAxiosError = isAxiosError;
Ze.mergeConfig = mergeConfig$1;
Ze.AxiosHeaders = ln;
Ze.formToJSON = t => formDataToJSON(z.isHTMLForm(t) ? new FormData(t) : t);
Ze.getAdapter = Dw.getAdapter;
Ze.HttpStatusCode = Sk;
Ze.default = Ze;
const axios = Ze;
function isObject$3(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
o(isObject$3, "isObject$3");
function extend$2(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {}), Object.keys(e).forEach(n => {
    typeof t[n] > "u" ? t[n] = e[n] : isObject$3(e[n]) && isObject$3(t[n]) && Object.keys(e[n]).length > 0 && extend$2(t[n], e[n]);
  });
}
o(extend$2, "extend$2");
const Nw = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {}
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const t = typeof document < "u" ? document : {};
  return extend$2(t, Nw), t;
}
o(getDocument, "getDocument");
const Ek = {
  document: Nw,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: o(function () {
    return this;
  }, "CustomEvent"),
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function getWindow() {
  const t = typeof window < "u" ? window : {};
  return extend$2(t, Ek), t;
}
o(getWindow, "getWindow");
function classesToTokens(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter(e => !!e.trim());
}
o(classesToTokens, "classesToTokens");
function deleteProps(t) {
  const e = t;
  Object.keys(e).forEach(n => {
    try {
      e[n] = null;
    } catch {}
    try {
      delete e[n];
    } catch {}
  });
}
o(deleteProps, "deleteProps");
function nextTick(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
o(nextTick, "nextTick");
function now$1() {
  return Date.now();
}
o(now$1, "now$1");
function getComputedStyle$1(t) {
  const e = getWindow();
  let n;
  return e.getComputedStyle && (n = e.getComputedStyle(t, null)), !n && t.currentStyle && (n = t.currentStyle), n || (n = t.style), n;
}
o(getComputedStyle$1, "getComputedStyle$1");
function getTranslate(t, e) {
  e === void 0 && (e = "x");
  const n = getWindow();
  let r, i, s;
  const a = getComputedStyle$1(t);
  return n.WebKitCSSMatrix ? (i = a.transform || a.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map(l => l.replace(",", ".")).join(", ")), s = new n.WebKitCSSMatrix(i === "none" ? "" : i)) : (s = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = s.toString().split(",")), e === "x" && (n.WebKitCSSMatrix ? i = s.m41 : r.length === 16 ? i = parseFloat(r[12]) : i = parseFloat(r[4])), e === "y" && (n.WebKitCSSMatrix ? i = s.m42 : r.length === 16 ? i = parseFloat(r[13]) : i = parseFloat(r[5])), i || 0;
}
o(getTranslate, "getTranslate");
function isObject$4(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
o(isObject$4, "isObject$2");
function isNode(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
o(isNode, "isNode");
function extend$3() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]),
    e = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (r != null && !isNode(r)) {
      const i = Object.keys(Object(r)).filter(s => e.indexOf(s) < 0);
      for (let s = 0, a = i.length; s < a; s += 1) {
        const l = i[s],
          u = Object.getOwnPropertyDescriptor(r, l);
        u !== void 0 && u.enumerable && (isObject$4(t[l]) && isObject$4(r[l]) ? r[l].__swiper__ ? t[l] = r[l] : extend$3(t[l], r[l]) : !isObject$4(t[l]) && isObject$4(r[l]) ? (t[l] = {}, r[l].__swiper__ ? t[l] = r[l] : extend$3(t[l], r[l])) : t[l] = r[l]);
      }
    }
  }
  return t;
}
o(extend$3, "extend$1");
function setCSSProperty(t, e, n) {
  t.style.setProperty(e, n);
}
o(setCSSProperty, "setCSSProperty");
function animateCSSModeScroll(t) {
  let {
    swiper: e,
    targetPosition: n,
    side: r
  } = t;
  const i = getWindow(),
    s = -e.translate;
  let a = null,
    l;
  const u = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(e.cssModeFrameID);
  const c = n > s ? "next" : "prev",
    isOutOfBound = o((d, y) => c === "next" && d >= y || c === "prev" && d <= y, "isOutOfBound"),
    animate = o(() => {
      l = new Date().getTime(), a === null && (a = l);
      const d = Math.max(Math.min((l - a) / u, 1), 0),
        y = .5 - Math.cos(d * Math.PI) / 2;
      let S = s + y * (n - s);
      if (isOutOfBound(S, n) && (S = n), e.wrapperEl.scrollTo({
        [r]: S
      }), isOutOfBound(S, n)) {
        e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
          e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
            [r]: S
          });
        }), i.cancelAnimationFrame(e.cssModeFrameID);
        return;
      }
      e.cssModeFrameID = i.requestAnimationFrame(animate);
    }, "animate");
  animate();
}
o(animateCSSModeScroll, "animateCSSModeScroll");
function getSlideTransformEl(t) {
  return t.querySelector(".swiper-slide-transform") || t.shadowRoot && t.shadowRoot.querySelector(".swiper-slide-transform") || t;
}
o(getSlideTransformEl, "getSlideTransformEl");
function elementChildren(t, e) {
  e === void 0 && (e = "");
  const n = [...t.children];
  return t instanceof HTMLSlotElement && n.push(...t.assignedElements()), e ? n.filter(r => r.matches(e)) : n;
}
o(elementChildren, "elementChildren");
function elementIsChildOf(t, e) {
  const n = e.contains(t);
  return !n && e instanceof HTMLSlotElement ? [...e.assignedElements()].includes(t) : n;
}
o(elementIsChildOf, "elementIsChildOf");
function showWarning(t) {
  try {
    console.warn(t);
    return;
  } catch {}
}
o(showWarning, "showWarning");
function createElement(t, e) {
  e === void 0 && (e = []);
  const n = document.createElement(t);
  return n.classList.add(...(Array.isArray(e) ? e : classesToTokens(e))), n;
}
o(createElement, "createElement$1");
function elementOffset(t) {
  const e = getWindow(),
    n = getDocument(),
    r = t.getBoundingClientRect(),
    i = n.body,
    s = t.clientTop || i.clientTop || 0,
    a = t.clientLeft || i.clientLeft || 0,
    l = t === e ? e.scrollY : t.scrollTop,
    u = t === e ? e.scrollX : t.scrollLeft;
  return {
    top: r.top + l - s,
    left: r.left + u - a
  };
}
o(elementOffset, "elementOffset");
function elementPrevAll(t, e) {
  const n = [];
  for (; t.previousElementSibling;) {
    const r = t.previousElementSibling;
    e ? r.matches(e) && n.push(r) : n.push(r), t = r;
  }
  return n;
}
o(elementPrevAll, "elementPrevAll");
function elementNextAll(t, e) {
  const n = [];
  for (; t.nextElementSibling;) {
    const r = t.nextElementSibling;
    e ? r.matches(e) && n.push(r) : n.push(r), t = r;
  }
  return n;
}
o(elementNextAll, "elementNextAll");
function elementStyle(t, e) {
  return getWindow().getComputedStyle(t, null).getPropertyValue(e);
}
o(elementStyle, "elementStyle");
function elementIndex(t) {
  let e = t,
    n;
  if (e) {
    for (n = 0; (e = e.previousSibling) !== null;) e.nodeType === 1 && (n += 1);
    return n;
  }
}
o(elementIndex, "elementIndex");
function elementParents(t, e) {
  const n = [];
  let r = t.parentElement;
  for (; r;) e ? r.matches(e) && n.push(r) : n.push(r), r = r.parentElement;
  return n;
}
o(elementParents, "elementParents");
function elementTransitionEnd(t, e) {
  function fireCallBack(r) {
    r.target === t && (e.call(t, r), t.removeEventListener("transitionend", fireCallBack));
  }
  o(fireCallBack, "fireCallBack"), e && t.addEventListener("transitionend", fireCallBack);
}
o(elementTransitionEnd, "elementTransitionEnd");
function elementOuterSize(t, e, n) {
  const r = getWindow();
  return n ? t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(r.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(r.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom")) : t.offsetWidth;
}
o(elementOuterSize, "elementOuterSize");
function makeElementsArray(t) {
  return (Array.isArray(t) ? t : [t]).filter(e => !!e);
}
o(makeElementsArray, "makeElementsArray");
let yc;
function calcSupport() {
  const t = getWindow(),
    e = getDocument();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
o(calcSupport, "calcSupport");
function getSupport() {
  return yc || (yc = calcSupport()), yc;
}
o(getSupport, "getSupport");
let vc;
function calcDevice(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const n = getSupport(),
    r = getWindow(),
    i = r.navigator.platform,
    s = e || r.navigator.userAgent,
    a = {
      ios: !1,
      android: !1
    },
    l = r.screen.width,
    u = r.screen.height,
    c = s.match(/(Android);?[\s\/]+([\d.]+)?/);
  let p = s.match(/(iPad).*OS\s([\d_]+)/);
  const m = s.match(/(iPod)(.*OS\s([\d_]+))?/),
    d = !p && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    y = i === "Win32";
  let S = i === "MacIntel";
  const w = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !p && S && n.touch && w.indexOf(`${l}x${u}`) >= 0 && (p = s.match(/(Version)\/([\d.]+)/), p || (p = [0, 1, "13_0_0"]), S = !1), c && !y && (a.os = "android", a.android = !0), (p || d || m) && (a.os = "ios", a.ios = !0), a;
}
o(calcDevice, "calcDevice");
function getDevice(t) {
  return t === void 0 && (t = {}), vc || (vc = calcDevice(t)), vc;
}
o(getDevice, "getDevice");
let wc;
function calcBrowser() {
  const t = getWindow(),
    e = getDevice();
  let n = !1;
  function isSafari() {
    const l = t.navigator.userAgent.toLowerCase();
    return l.indexOf("safari") >= 0 && l.indexOf("chrome") < 0 && l.indexOf("android") < 0;
  }
  if (o(isSafari, "isSafari"), isSafari()) {
    const l = String(t.navigator.userAgent);
    if (l.includes("Version/")) {
      const [u, c] = l.split("Version/")[1].split(" ")[0].split(".").map(p => Number(p));
      n = u < 16 || u === 16 && c < 2;
    }
  }
  const i = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent),
    s = isSafari(),
    a = s || i && e.ios;
  return {
    isSafari: n || s,
    needPerspectiveFix: n,
    need3dFix: a,
    isWebView: i
  };
}
o(calcBrowser, "calcBrowser");
function getBrowser() {
  return wc || (wc = calcBrowser()), wc;
}
o(getBrowser, "getBrowser");
function Resize(t) {
  let {
    swiper: e,
    on: n,
    emit: r
  } = t;
  const i = getWindow();
  let s = null,
    a = null;
  const resizeHandler = o(() => {
      !e || e.destroyed || !e.initialized || (r("beforeResize"), r("resize"));
    }, "resizeHandler"),
    createObserver = o(() => {
      !e || e.destroyed || !e.initialized || (s = new ResizeObserver(m => {
        a = i.requestAnimationFrame(() => {
          const {
            width: d,
            height: y
          } = e;
          let S = d,
            w = y;
          m.forEach(g => {
            let {
              contentBoxSize: h,
              contentRect: f,
              target: v
            } = g;
            v && v !== e.el || (S = f ? f.width : (h[0] || h).inlineSize, w = f ? f.height : (h[0] || h).blockSize);
          }), (S !== d || w !== y) && resizeHandler();
        });
      }), s.observe(e.el));
    }, "createObserver"),
    removeObserver = o(() => {
      a && i.cancelAnimationFrame(a), s && s.unobserve && e.el && (s.unobserve(e.el), s = null);
    }, "removeObserver"),
    orientationChangeHandler = o(() => {
      !e || e.destroyed || !e.initialized || r("orientationchange");
    }, "orientationChangeHandler");
  n("init", () => {
    if (e.params.resizeObserver && typeof i.ResizeObserver < "u") {
      createObserver();
      return;
    }
    i.addEventListener("resize", resizeHandler), i.addEventListener("orientationchange", orientationChangeHandler);
  }), n("destroy", () => {
    removeObserver(), i.removeEventListener("resize", resizeHandler), i.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
o(Resize, "Resize");
function Observer(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r,
    emit: i
  } = t;
  const s = [],
    a = getWindow(),
    attach = o(function (p, m) {
      m === void 0 && (m = {});
      const d = a.MutationObserver || a.WebkitMutationObserver,
        y = new d(S => {
          if (e.__preventObserver__) return;
          if (S.length === 1) {
            i("observerUpdate", S[0]);
            return;
          }
          const observerUpdate = o(function () {
            i("observerUpdate", S[0]);
          }, "observerUpdate");
          a.requestAnimationFrame ? a.requestAnimationFrame(observerUpdate) : a.setTimeout(observerUpdate, 0);
        });
      y.observe(p, {
        attributes: typeof m.attributes > "u" ? !0 : m.attributes,
        childList: e.isElement || (typeof m.childList > "u" ? !0 : m).childList,
        characterData: typeof m.characterData > "u" ? !0 : m.characterData
      }), s.push(y);
    }, "attach"),
    init = o(() => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const p = elementParents(e.hostEl);
          for (let m = 0; m < p.length; m += 1) attach(p[m]);
        }
        attach(e.hostEl, {
          childList: e.params.observeSlideChildren
        }), attach(e.wrapperEl, {
          attributes: !1
        });
      }
    }, "init"),
    destroy = o(() => {
      s.forEach(p => {
        p.disconnect();
      }), s.splice(0, s.length);
    }, "destroy");
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), r("init", init), r("destroy", destroy);
}
o(Observer, "Observer");
var Rk = {
  on(t, e, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof e != "function") return r;
    const i = n ? "unshift" : "push";
    return t.split(" ").forEach(s => {
      r.eventsListeners[s] || (r.eventsListeners[s] = []), r.eventsListeners[s][i](e);
    }), r;
  },
  once(t, e, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof e != "function") return r;
    function onceHandler() {
      r.off(t, onceHandler), onceHandler.__emitterProxy && delete onceHandler.__emitterProxy;
      for (var s = arguments.length, a = new Array(s), l = 0; l < s; l++) a[l] = arguments[l];
      e.apply(r, a);
    }
    return o(onceHandler, "onceHandler"), onceHandler.__emitterProxy = e, r.on(t, onceHandler, n);
  },
  onAny(t, e) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    const r = e ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(t) < 0 && n.eventsAnyListeners[r](t), n;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const n = e.eventsAnyListeners.indexOf(t);
    return n >= 0 && e.eventsAnyListeners.splice(n, 1), e;
  },
  off(t, e) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || t.split(" ").forEach(r => {
      typeof e > "u" ? n.eventsListeners[r] = [] : n.eventsListeners[r] && n.eventsListeners[r].forEach((i, s) => {
        (i === e || i.__emitterProxy && i.__emitterProxy === e) && n.eventsListeners[r].splice(s, 1);
      });
    }), n;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let e, n, r;
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++) s[a] = arguments[a];
    return typeof s[0] == "string" || Array.isArray(s[0]) ? (e = s[0], n = s.slice(1, s.length), r = t) : (e = s[0].events, n = s[0].data, r = s[0].context || t), n.unshift(r), (Array.isArray(e) ? e : e.split(" ")).forEach(u => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach(c => {
        c.apply(r, [u, ...n]);
      }), t.eventsListeners && t.eventsListeners[u] && t.eventsListeners[u].forEach(c => {
        c.apply(r, n);
      });
    }), t;
  }
};
function updateSize() {
  const t = this;
  let e, n;
  const r = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = r.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? n = t.params.height : n = r.clientHeight, !(e === 0 && t.isHorizontal() || n === 0 && t.isVertical()) && (e = e - parseInt(elementStyle(r, "padding-left") || 0, 10) - parseInt(elementStyle(r, "padding-right") || 0, 10), n = n - parseInt(elementStyle(r, "padding-top") || 0, 10) - parseInt(elementStyle(r, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(n) && (n = 0), Object.assign(t, {
    width: e,
    height: n,
    size: t.isHorizontal() ? e : n
  }));
}
o(updateSize, "updateSize");
function updateSlides() {
  const t = this;
  function getDirectionPropertyValue(I, U) {
    return parseFloat(I.getPropertyValue(t.getDirectionLabel(U)) || 0);
  }
  o(getDirectionPropertyValue, "getDirectionPropertyValue");
  const n = t.params,
    {
      wrapperEl: r,
      slidesEl: i,
      size: s,
      rtlTranslate: a,
      wrongRTL: l
    } = t,
    u = t.virtual && n.virtual.enabled,
    c = u ? t.virtual.slides.length : t.slides.length,
    p = elementChildren(i, `.${t.params.slideClass}, swiper-slide`),
    m = u ? t.virtual.slides.length : p.length;
  let d = [];
  const y = [],
    S = [];
  let w = n.slidesOffsetBefore;
  typeof w == "function" && (w = n.slidesOffsetBefore.call(t));
  let g = n.slidesOffsetAfter;
  typeof g == "function" && (g = n.slidesOffsetAfter.call(t));
  const h = t.snapGrid.length,
    f = t.slidesGrid.length;
  let v = n.spaceBetween,
    E = -w,
    b = 0,
    P = 0;
  if (typeof s > "u") return;
  typeof v == "string" && v.indexOf("%") >= 0 ? v = parseFloat(v.replace("%", "")) / 100 * s : typeof v == "string" && (v = parseFloat(v)), t.virtualSize = -v, p.forEach(I => {
    a ? I.style.marginLeft = "" : I.style.marginRight = "", I.style.marginBottom = "", I.style.marginTop = "";
  }), n.centeredSlides && n.cssMode && (setCSSProperty(r, "--swiper-centered-offset-before", ""), setCSSProperty(r, "--swiper-centered-offset-after", ""));
  const T = n.grid && n.grid.rows > 1 && t.grid;
  T ? t.grid.initSlides(p) : t.grid && t.grid.unsetSlides();
  let O;
  const M = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter(I => typeof n.breakpoints[I].slidesPerView < "u").length > 0;
  for (let I = 0; I < m; I += 1) {
    O = 0;
    let display;
    if (p[I] && (display = p[I]), T && t.grid.updateSlide(I, display, p), !(p[I] && elementStyle(display, "display") === "none")) {
      if (n.slidesPerView === "auto") {
        M && (p[I].style[t.getDirectionLabel("width")] = "");
        const width = getComputedStyle(display),
          R = display.style.transform,
          B = display.style.webkitTransform;
        if (R && (display.style.transform = "none"), B && (display.style.webkitTransform = "none"), n.roundLengths) O = t.isHorizontal() ? elementOuterSize(display, "width", !0) : elementOuterSize(display, "height", !0);else {
          const width$1 = getDirectionPropertyValue(width, "width"),
            Q = getDirectionPropertyValue(width, "padding-left"),
            te = getDirectionPropertyValue(width, "padding-right"),
            j = getDirectionPropertyValue(width, "margin-left"),
            X = getDirectionPropertyValue(width, "margin-right"),
            q = width.getPropertyValue("box-sizing");
          if (q && q === "border-box") O = width$1 + j + X;else {
            const {
              clientWidth: C,
              offsetWidth: A
            } = display;
            O = width$1 + Q + te + j + X + (A - C);
          }
        }
        R && (display.style.transform = R), B && (display.style.webkitTransform = B), n.roundLengths && (O = Math.floor(O));
      } else O = (s - (n.slidesPerView - 1) * v) / n.slidesPerView, n.roundLengths && (O = Math.floor(O)), p[I] && (p[I].style[t.getDirectionLabel("width")] = `${O}px`);
      p[I] && (p[I].swiperSlideSize = O), S.push(O), n.centeredSlides ? (E = E + O / 2 + b / 2 + v, b === 0 && I !== 0 && (E = E - s / 2 - v), I === 0 && (E = E - s / 2 - v), Math.abs(E) < 1 / 1e3 && (E = 0), n.roundLengths && (E = Math.floor(E)), P % n.slidesPerGroup === 0 && d.push(E), y.push(E)) : (n.roundLengths && (E = Math.floor(E)), (P - Math.min(t.params.slidesPerGroupSkip, P)) % t.params.slidesPerGroup === 0 && d.push(E), y.push(E), E = E + O + v), t.virtualSize += O + v, b = O, P += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, s) + g, a && l && (n.effect === "slide" || n.effect === "coverflow") && (r.style.width = `${t.virtualSize + v}px`), n.setWrapperSize && (r.style[t.getDirectionLabel("width")] = `${t.virtualSize + v}px`), T && t.grid.updateWrapperSize(O, d), !n.centeredSlides) {
    const I = [];
    for (let U = 0; U < d.length; U += 1) {
      let _ = d[U];
      n.roundLengths && (_ = Math.floor(_)), d[U] <= t.virtualSize - s && I.push(_);
    }
    d = I, Math.floor(t.virtualSize - s) - Math.floor(d[d.length - 1]) > 1 && d.push(t.virtualSize - s);
  }
  if (u && n.loop) {
    const I = S[0] + v;
    if (n.slidesPerGroup > 1) {
      const U = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / n.slidesPerGroup),
        _ = I * n.slidesPerGroup;
      for (let R = 0; R < U; R += 1) d.push(d[d.length - 1] + _);
    }
    for (let U = 0; U < t.virtual.slidesBefore + t.virtual.slidesAfter; U += 1) n.slidesPerGroup === 1 && d.push(d[d.length - 1] + I), y.push(y[y.length - 1] + I), t.virtualSize += I;
  }
  if (d.length === 0 && (d = [0]), v !== 0) {
    const I = t.isHorizontal() && a ? "marginLeft" : t.getDirectionLabel("marginRight");
    p.filter((U, _) => !n.cssMode || n.loop ? !0 : _ !== p.length - 1).forEach(U => {
      U.style[I] = `${v}px`;
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let I = 0;
    S.forEach(_ => {
      I += _ + (v || 0);
    }), I -= v;
    const U = I > s ? I - s : 0;
    d = d.map(_ => _ <= 0 ? -w : _ > U ? U + g : _);
  }
  if (n.centerInsufficientSlides) {
    let I = 0;
    S.forEach(_ => {
      I += _ + (v || 0);
    }), I -= v;
    const U = (n.slidesOffsetBefore || 0) + (n.slidesOffsetAfter || 0);
    if (I + U < s) {
      const _ = (s - I - U) / 2;
      d.forEach((R, B) => {
        d[B] = R - _;
      }), y.forEach((R, B) => {
        y[B] = R + _;
      });
    }
  }
  if (Object.assign(t, {
    slides: p,
    snapGrid: d,
    slidesGrid: y,
    slidesSizesGrid: S
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    setCSSProperty(r, "--swiper-centered-offset-before", `${-d[0]}px`), setCSSProperty(r, "--swiper-centered-offset-after", `${t.size / 2 - S[S.length - 1] / 2}px`);
    const I = -t.snapGrid[0],
      U = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map(_ => _ + I), t.slidesGrid = t.slidesGrid.map(_ => _ + U);
  }
  if (m !== c && t.emit("slidesLengthChange"), d.length !== h && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), y.length !== f && t.emit("slidesGridLengthChange"), n.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !u && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const I = `${n.containerModifierClass}backface-hidden`,
      U = t.el.classList.contains(I);
    m <= n.maxBackfaceHiddenSlides ? U || t.el.classList.add(I) : U && t.el.classList.remove(I);
  }
}
o(updateSlides, "updateSlides");
function updateAutoHeight(t) {
  const e = this,
    n = [],
    r = e.virtual && e.params.virtual.enabled;
  let i = 0,
    s;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const getSlideByIndex = o(l => r ? e.slides[e.getSlideIndexByData(l)] : e.slides[l], "getSlideByIndex");
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1) {
    if (e.params.centeredSlides) (e.visibleSlides || []).forEach(l => {
      n.push(l);
    });else for (s = 0; s < Math.ceil(e.params.slidesPerView); s += 1) {
      const l = e.activeIndex + s;
      if (l > e.slides.length && !r) break;
      n.push(getSlideByIndex(l));
    }
  } else n.push(getSlideByIndex(e.activeIndex));
  for (s = 0; s < n.length; s += 1) if (typeof n[s] < "u") {
    const l = n[s].offsetHeight;
    i = l > i ? l : i;
  }
  (i || i === 0) && (e.wrapperEl.style.height = `${i}px`);
}
o(updateAutoHeight, "updateAutoHeight");
function updateSlidesOffset() {
  const t = this,
    e = t.slides,
    n = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let r = 0; r < e.length; r += 1) e[r].swiperSlideOffset = (t.isHorizontal() ? e[r].offsetLeft : e[r].offsetTop) - n - t.cssOverflowAdjustment();
}
o(updateSlidesOffset, "updateSlidesOffset");
const toggleSlideClasses = o((t, e, n) => {
  e && !t.classList.contains(n) ? t.classList.add(n) : !e && t.classList.contains(n) && t.classList.remove(n);
}, "toggleSlideClasses$1");
function updateSlidesProgress(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this,
    n = e.params,
    {
      slides: r,
      rtlTranslate: i,
      snapGrid: s
    } = e;
  if (r.length === 0) return;
  typeof r[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let a = -t;
  i && (a = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let l = n.spaceBetween;
  typeof l == "string" && l.indexOf("%") >= 0 ? l = parseFloat(l.replace("%", "")) / 100 * e.size : typeof l == "string" && (l = parseFloat(l));
  for (let u = 0; u < r.length; u += 1) {
    const c = r[u];
    let p = c.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (p -= r[0].swiperSlideOffset);
    const m = (a + (n.centeredSlides ? e.minTranslate() : 0) - p) / (c.swiperSlideSize + l),
      d = (a - s[0] + (n.centeredSlides ? e.minTranslate() : 0) - p) / (c.swiperSlideSize + l),
      y = -(a - p),
      S = y + e.slidesSizesGrid[u],
      w = y >= 0 && y <= e.size - e.slidesSizesGrid[u],
      g = y >= 0 && y < e.size - 1 || S > 1 && S <= e.size || y <= 0 && S >= e.size;
    g && (e.visibleSlides.push(c), e.visibleSlidesIndexes.push(u)), toggleSlideClasses(c, g, n.slideVisibleClass), toggleSlideClasses(c, w, n.slideFullyVisibleClass), c.progress = i ? -m : m, c.originalProgress = i ? -d : d;
  }
}
o(updateSlidesProgress, "updateSlidesProgress");
function updateProgress(t) {
  const e = this;
  if (typeof t > "u") {
    const p = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * p || 0;
  }
  const n = e.params,
    r = e.maxTranslate() - e.minTranslate();
  let {
    progress: i,
    isBeginning: s,
    isEnd: a,
    progressLoop: l
  } = e;
  const u = s,
    c = a;
  if (r === 0) i = 0, s = !0, a = !0;else {
    i = (t - e.minTranslate()) / r;
    const p = Math.abs(t - e.minTranslate()) < 1,
      m = Math.abs(t - e.maxTranslate()) < 1;
    s = p || i <= 0, a = m || i >= 1, p && (i = 0), m && (i = 1);
  }
  if (n.loop) {
    const p = e.getSlideIndexByData(0),
      m = e.getSlideIndexByData(e.slides.length - 1),
      d = e.slidesGrid[p],
      y = e.slidesGrid[m],
      S = e.slidesGrid[e.slidesGrid.length - 1],
      w = Math.abs(t);
    w >= d ? l = (w - d) / S : l = (w + S - y) / S, l > 1 && (l -= 1);
  }
  Object.assign(e, {
    progress: i,
    progressLoop: l,
    isBeginning: s,
    isEnd: a
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && e.updateSlidesProgress(t), s && !u && e.emit("reachBeginning toEdge"), a && !c && e.emit("reachEnd toEdge"), (u && !s || c && !a) && e.emit("fromEdge"), e.emit("progress", i);
}
o(updateProgress, "updateProgress");
const toggleSlideClasses$1 = o((t, e, n) => {
  e && !t.classList.contains(n) ? t.classList.add(n) : !e && t.classList.contains(n) && t.classList.remove(n);
}, "toggleSlideClasses");
function updateSlidesClasses() {
  const t = this,
    {
      slides: e,
      params: n,
      slidesEl: r,
      activeIndex: i
    } = t,
    s = t.virtual && n.virtual.enabled,
    a = t.grid && n.grid && n.grid.rows > 1,
    getFilteredSlide = o(m => elementChildren(r, `.${n.slideClass}${m}, swiper-slide${m}`)[0], "getFilteredSlide");
  let u, c, p;
  if (s) {
    if (n.loop) {
      let m = i - t.virtual.slidesBefore;
      m < 0 && (m = t.virtual.slides.length + m), m >= t.virtual.slides.length && (m -= t.virtual.slides.length), u = getFilteredSlide(`[data-swiper-slide-index="${m}"]`);
    } else u = getFilteredSlide(`[data-swiper-slide-index="${i}"]`);
  } else a ? (u = e.filter(m => m.column === i)[0], p = e.filter(m => m.column === i + 1)[0], c = e.filter(m => m.column === i - 1)[0]) : u = e[i];
  u && (a || (p = elementNextAll(u, `.${n.slideClass}, swiper-slide`)[0], n.loop && !p && (p = e[0]), c = elementPrevAll(u, `.${n.slideClass}, swiper-slide`)[0], n.loop && !c === 0 && (c = e[e.length - 1]))), e.forEach(m => {
    toggleSlideClasses$1(m, m === u, n.slideActiveClass), toggleSlideClasses$1(m, m === p, n.slideNextClass), toggleSlideClasses$1(m, m === c, n.slidePrevClass);
  }), t.emitSlidesClasses();
}
o(updateSlidesClasses, "updateSlidesClasses");
const processLazyPreloader = o((t, e) => {
    if (!t || t.destroyed || !t.params) return;
    const slideSelector = o(() => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, "slideSelector"),
      r = e.closest(slideSelector());
    if (r) {
      let i = r.querySelector(`.${t.params.lazyPreloaderClass}`);
      !i && t.isElement && (r.shadowRoot ? i = r.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
        r.shadowRoot && (i = r.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), i && i.remove());
      })), i && i.remove();
    }
  }, "processLazyPreloader"),
  unlazy = o((t, e) => {
    if (!t.slides[e]) return;
    const n = t.slides[e].querySelector('[loading="lazy"]');
    n && n.removeAttribute("loading");
  }, "unlazy"),
  preload = o(t => {
    if (!t || t.destroyed || !t.params) return;
    let e = t.params.lazyPreloadPrevNext;
    const n = t.slides.length;
    if (!n || !e || e < 0) return;
    e = Math.min(e, n);
    const r = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView),
      i = t.activeIndex;
    if (t.params.grid && t.params.grid.rows > 1) {
      const a = i,
        l = [a - e];
      l.push(...Array.from({
        length: e
      }).map((u, c) => a + r + c)), t.slides.forEach((u, c) => {
        l.includes(u.column) && unlazy(t, c);
      });
      return;
    }
    const s = i + r - 1;
    if (t.params.rewind || t.params.loop) for (let a = i - e; a <= s + e; a += 1) {
      const l = (a % n + n) % n;
      (l < i || l > s) && unlazy(t, l);
    } else for (let a = Math.max(i - e, 0); a <= Math.min(s + e, n - 1); a += 1) a !== i && (a > s || a < i) && unlazy(t, a);
  }, "preload");
function getActiveIndexByTranslate(t) {
  const {
      slidesGrid: e,
      params: n
    } = t,
    r = t.rtlTranslate ? t.translate : -t.translate;
  let i;
  for (let s = 0; s < e.length; s += 1) typeof e[s + 1] < "u" ? r >= e[s] && r < e[s + 1] - (e[s + 1] - e[s]) / 2 ? i = s : r >= e[s] && r < e[s + 1] && (i = s + 1) : r >= e[s] && (i = s);
  return n.normalizeSlideIndex && (i < 0 || typeof i > "u") && (i = 0), i;
}
o(getActiveIndexByTranslate, "getActiveIndexByTranslate");
function updateActiveIndex(t) {
  const e = this,
    n = e.rtlTranslate ? e.translate : -e.translate,
    {
      snapGrid: r,
      params: i,
      activeIndex: s,
      realIndex: a,
      snapIndex: l
    } = e;
  let u = t,
    c;
  const getVirtualRealIndex = o(y => {
    let S = y - e.virtual.slidesBefore;
    return S < 0 && (S = e.virtual.slides.length + S), S >= e.virtual.slides.length && (S -= e.virtual.slides.length), S;
  }, "getVirtualRealIndex");
  if (typeof u > "u" && (u = getActiveIndexByTranslate(e)), r.indexOf(n) >= 0) c = r.indexOf(n);else {
    const y = Math.min(i.slidesPerGroupSkip, u);
    c = y + Math.floor((u - y) / i.slidesPerGroup);
  }
  if (c >= r.length && (c = r.length - 1), u === s && !e.params.loop) {
    c !== l && (e.snapIndex = c, e.emit("snapIndexChange"));
    return;
  }
  if (u === s && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = getVirtualRealIndex(u);
    return;
  }
  const m = e.grid && i.grid && i.grid.rows > 1;
  let d;
  if (e.virtual && i.virtual.enabled && i.loop) d = getVirtualRealIndex(u);else if (m) {
    const y = e.slides.filter(w => w.column === u)[0];
    let S = parseInt(y.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(S) && (S = Math.max(e.slides.indexOf(y), 0)), d = Math.floor(S / i.grid.rows);
  } else if (e.slides[u]) {
    const y = e.slides[u].getAttribute("data-swiper-slide-index");
    y ? d = parseInt(y, 10) : d = u;
  } else d = u;
  Object.assign(e, {
    previousSnapIndex: l,
    snapIndex: c,
    previousRealIndex: a,
    realIndex: d,
    previousIndex: s,
    activeIndex: u
  }), e.initialized && preload(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (a !== d && e.emit("realIndexChange"), e.emit("slideChange"));
}
o(updateActiveIndex, "updateActiveIndex");
function updateClickedSlide(t, e) {
  const n = this,
    r = n.params;
  let i = t.closest(`.${r.slideClass}, swiper-slide`);
  !i && n.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach(l => {
    !i && l.matches && l.matches(`.${r.slideClass}, swiper-slide`) && (i = l);
  });
  let s = !1,
    a;
  if (i) {
    for (let l = 0; l < n.slides.length; l += 1) if (n.slides[l] === i) {
      s = !0, a = l;
      break;
    }
  }
  if (i && s) n.clickedSlide = i, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(i.getAttribute("data-swiper-slide-index"), 10) : n.clickedIndex = a;else {
    n.clickedSlide = void 0, n.clickedIndex = void 0;
    return;
  }
  r.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
o(updateClickedSlide, "updateClickedSlide");
var Wk = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};
function getSwiperTranslate(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this,
    {
      params: n,
      rtlTranslate: r,
      translate: i,
      wrapperEl: s
    } = e;
  if (n.virtualTranslate) return r ? -i : i;
  if (n.cssMode) return i;
  let a = getTranslate(s, t);
  return a += e.cssOverflowAdjustment(), r && (a = -a), a || 0;
}
o(getSwiperTranslate, "getSwiperTranslate");
function setTranslate(t, e) {
  const n = this,
    {
      rtlTranslate: r,
      params: i,
      wrapperEl: s,
      progress: a
    } = n;
  let l = 0,
    u = 0;
  const c = 0;
  n.isHorizontal() ? l = r ? -t : t : u = t, i.roundLengths && (l = Math.floor(l), u = Math.floor(u)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? l : u, i.cssMode ? s[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -u : i.virtualTranslate || (n.isHorizontal() ? l -= n.cssOverflowAdjustment() : u -= n.cssOverflowAdjustment(), s.style.transform = `translate3d(${l}px, ${u}px, ${c}px)`);
  let p;
  const m = n.maxTranslate() - n.minTranslate();
  m === 0 ? p = 0 : p = (t - n.minTranslate()) / m, p !== a && n.updateProgress(t), n.emit("setTranslate", n.translate, e);
}
o(setTranslate, "setTranslate");
function minTranslate() {
  return -this.snapGrid[0];
}
o(minTranslate, "minTranslate");
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
o(maxTranslate, "maxTranslate");
function translateTo(t, e, n, r, i) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), n === void 0 && (n = !0), r === void 0 && (r = !0);
  const s = this,
    {
      params: a,
      wrapperEl: l
    } = s;
  if (s.animating && a.preventInteractionOnTransition) return !1;
  const u = s.minTranslate(),
    c = s.maxTranslate();
  let p;
  if (r && t > u ? p = u : r && t < c ? p = c : p = t, s.updateProgress(p), a.cssMode) {
    const m = s.isHorizontal();
    if (e === 0) l[m ? "scrollLeft" : "scrollTop"] = -p;else {
      if (!s.support.smoothScroll) return animateCSSModeScroll({
        swiper: s,
        targetPosition: -p,
        side: m ? "left" : "top"
      }), !0;
      l.scrollTo({
        [m ? "left" : "top"]: -p,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (s.setTransition(0), s.setTranslate(p), n && (s.emit("beforeTransitionStart", e, i), s.emit("transitionEnd"))) : (s.setTransition(e), s.setTranslate(p), n && (s.emit("beforeTransitionStart", e, i), s.emit("transitionStart")), s.animating || (s.animating = !0, s.onTranslateToWrapperTransitionEnd || (s.onTranslateToWrapperTransitionEnd = o(function (d) {
    !s || s.destroyed || d.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.onTranslateToWrapperTransitionEnd = null, delete s.onTranslateToWrapperTransitionEnd, s.animating = !1, n && s.emit("transitionEnd"));
  }, "transitionEnd")), s.wrapperEl.addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd))), !0;
}
o(translateTo, "translateTo");
var Jk = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};
function setTransition(t, e) {
  const n = this;
  n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${t}ms`, n.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), n.emit("setTransition", t, e);
}
o(setTransition, "setTransition");
function transitionEmit(t) {
  let {
    swiper: e,
    runCallbacks: n,
    direction: r,
    step: i
  } = t;
  const {
    activeIndex: s,
    previousIndex: a
  } = e;
  let l = r;
  if (l || (s > a ? l = "next" : s < a ? l = "prev" : l = "reset"), e.emit(`transition${i}`), n && s !== a) {
    if (l === "reset") {
      e.emit(`slideResetTransition${i}`);
      return;
    }
    e.emit(`slideChangeTransition${i}`), l === "next" ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`);
  }
}
o(transitionEmit, "transitionEmit");
function transitionStart(t, e) {
  t === void 0 && (t = !0);
  const n = this,
    {
      params: r
    } = n;
  r.cssMode || (r.autoHeight && n.updateAutoHeight(), transitionEmit({
    swiper: n,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
o(transitionStart, "transitionStart");
function transitionEnd(t, e) {
  t === void 0 && (t = !0);
  const n = this,
    {
      params: r
    } = n;
  n.animating = !1, !r.cssMode && (n.setTransition(0), transitionEmit({
    swiper: n,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
o(transitionEnd, "transitionEnd");
var n_ = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};
function slideTo(t, e, n, r, i) {
  t === void 0 && (t = 0), n === void 0 && (n = !0), typeof t == "string" && (t = parseInt(t, 10));
  const s = this;
  let a = t;
  a < 0 && (a = 0);
  const {
    params: l,
    snapGrid: u,
    slidesGrid: c,
    previousIndex: p,
    activeIndex: m,
    rtlTranslate: d,
    wrapperEl: y,
    enabled: S
  } = s;
  if (!S && !r && !i || s.destroyed || s.animating && l.preventInteractionOnTransition) return !1;
  typeof e > "u" && (e = s.params.speed);
  const w = Math.min(s.params.slidesPerGroupSkip, a);
  let g = w + Math.floor((a - w) / s.params.slidesPerGroup);
  g >= u.length && (g = u.length - 1);
  const h = -u[g];
  if (l.normalizeSlideIndex) for (let b = 0; b < c.length; b += 1) {
    const P = -Math.floor(h * 100),
      T = Math.floor(c[b] * 100),
      O = Math.floor(c[b + 1] * 100);
    typeof c[b + 1] < "u" ? P >= T && P < O - (O - T) / 2 ? a = b : P >= T && P < O && (a = b + 1) : P >= T && (a = b);
  }
  if (s.initialized && a !== m && (!s.allowSlideNext && (d ? h > s.translate && h > s.minTranslate() : h < s.translate && h < s.minTranslate()) || !s.allowSlidePrev && h > s.translate && h > s.maxTranslate() && (m || 0) !== a)) return !1;
  a !== (p || 0) && n && s.emit("beforeSlideChangeStart"), s.updateProgress(h);
  let f;
  a > m ? f = "next" : a < m ? f = "prev" : f = "reset";
  const v = s.virtual && s.params.virtual.enabled;
  if (!(v && i) && (d && -h === s.translate || !d && h === s.translate)) return s.updateActiveIndex(a), l.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), l.effect !== "slide" && s.setTranslate(h), f !== "reset" && (s.transitionStart(n, f), s.transitionEnd(n, f)), !1;
  if (l.cssMode) {
    const b = s.isHorizontal(),
      P = d ? h : -h;
    if (e === 0) v && (s.wrapperEl.style.scrollSnapType = "none", s._immediateVirtual = !0), v && !s._cssModeVirtualInitialSet && s.params.initialSlide > 0 ? (s._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
      y[b ? "scrollLeft" : "scrollTop"] = P;
    })) : y[b ? "scrollLeft" : "scrollTop"] = P, v && requestAnimationFrame(() => {
      s.wrapperEl.style.scrollSnapType = "", s._immediateVirtual = !1;
    });else {
      if (!s.support.smoothScroll) return animateCSSModeScroll({
        swiper: s,
        targetPosition: P,
        side: b ? "left" : "top"
      }), !0;
      y.scrollTo({
        [b ? "left" : "top"]: P,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return s.setTransition(e), s.setTranslate(h), s.updateActiveIndex(a), s.updateSlidesClasses(), s.emit("beforeTransitionStart", e, r), s.transitionStart(n, f), e === 0 ? s.transitionEnd(n, f) : s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = o(function (P) {
    !s || s.destroyed || P.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(n, f));
  }, "transitionEnd")), s.wrapperEl.addEventListener("transitionend", s.onSlideToWrapperTransitionEnd)), !0;
}
o(slideTo, "slideTo");
function slideToLoop(t, e, n, r) {
  t === void 0 && (t = 0), n === void 0 && (n = !0), typeof t == "string" && (t = parseInt(t, 10));
  const i = this;
  if (i.destroyed) return;
  typeof e > "u" && (e = i.params.speed);
  const s = i.grid && i.params.grid && i.params.grid.rows > 1;
  let a = t;
  if (i.params.loop) if (i.virtual && i.params.virtual.enabled) a = a + i.virtual.slidesBefore;else {
    let l;
    if (s) {
      const d = a * i.params.grid.rows;
      l = i.slides.filter(y => y.getAttribute("data-swiper-slide-index") * 1 === d)[0].column;
    } else l = i.getSlideIndexByData(a);
    const u = s ? Math.ceil(i.slides.length / i.params.grid.rows) : i.slides.length,
      {
        centeredSlides: c
      } = i.params;
    let p = i.params.slidesPerView;
    p === "auto" ? p = i.slidesPerViewDynamic() : (p = Math.ceil(parseFloat(i.params.slidesPerView, 10)), c && p % 2 === 0 && (p = p + 1));
    let m = u - l < p;
    if (c && (m = m || l < Math.ceil(p / 2)), r && c && i.params.slidesPerView !== "auto" && !s && (m = !1), m) {
      const d = c ? l < i.activeIndex ? "prev" : "next" : l - i.activeIndex - 1 < i.params.slidesPerView ? "next" : "prev";
      i.loopFix({
        direction: d,
        slideTo: !0,
        activeSlideIndex: d === "next" ? l + 1 : l - u + 1,
        slideRealIndex: d === "next" ? i.realIndex : void 0
      });
    }
    if (s) {
      const d = a * i.params.grid.rows;
      a = i.slides.filter(y => y.getAttribute("data-swiper-slide-index") * 1 === d)[0].column;
    } else a = i.getSlideIndexByData(a);
  }
  return requestAnimationFrame(() => {
    i.slideTo(a, e, n, r);
  }), i;
}
o(slideToLoop, "slideToLoop");
function slideNext(t, e, n) {
  e === void 0 && (e = !0);
  const r = this,
    {
      enabled: i,
      params: s,
      animating: a
    } = r;
  if (!i || r.destroyed) return r;
  typeof t > "u" && (t = r.params.speed);
  let l = s.slidesPerGroup;
  s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (l = Math.max(r.slidesPerViewDynamic("current", !0), 1));
  const u = r.activeIndex < s.slidesPerGroupSkip ? 1 : l,
    c = r.virtual && s.virtual.enabled;
  if (s.loop) {
    if (a && !c && s.loopPreventsSliding) return !1;
    if (r.loopFix({
      direction: "next"
    }), r._clientLeft = r.wrapperEl.clientLeft, r.activeIndex === r.slides.length - 1 && s.cssMode) return requestAnimationFrame(() => {
      r.slideTo(r.activeIndex + u, t, e, n);
    }), !0;
  }
  return s.rewind && r.isEnd ? r.slideTo(0, t, e, n) : r.slideTo(r.activeIndex + u, t, e, n);
}
o(slideNext, "slideNext");
function slidePrev(t, e, n) {
  e === void 0 && (e = !0);
  const r = this,
    {
      params: i,
      snapGrid: s,
      slidesGrid: a,
      rtlTranslate: l,
      enabled: u,
      animating: c
    } = r;
  if (!u || r.destroyed) return r;
  typeof t > "u" && (t = r.params.speed);
  const p = r.virtual && i.virtual.enabled;
  if (i.loop) {
    if (c && !p && i.loopPreventsSliding) return !1;
    r.loopFix({
      direction: "prev"
    }), r._clientLeft = r.wrapperEl.clientLeft;
  }
  const m = l ? r.translate : -r.translate;
  function normalize(h) {
    return h < 0 ? -Math.floor(Math.abs(h)) : Math.floor(h);
  }
  o(normalize, "normalize");
  const y = normalize(m),
    S = s.map(h => normalize(h));
  let w = s[S.indexOf(y) - 1];
  if (typeof w > "u" && i.cssMode) {
    let h;
    s.forEach((f, v) => {
      y >= f && (h = v);
    }), typeof h < "u" && (w = s[h > 0 ? h - 1 : h]);
  }
  let g = 0;
  if (typeof w < "u" && (g = a.indexOf(w), g < 0 && (g = r.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (g = g - r.slidesPerViewDynamic("previous", !0) + 1, g = Math.max(g, 0))), i.rewind && r.isBeginning) {
    const h = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
    return r.slideTo(h, t, e, n);
  } else if (i.loop && r.activeIndex === 0 && i.cssMode) return requestAnimationFrame(() => {
    r.slideTo(g, t, e, n);
  }), !0;
  return r.slideTo(g, t, e, n);
}
o(slidePrev, "slidePrev");
function slideReset(t, e, n) {
  e === void 0 && (e = !0);
  const r = this;
  if (!r.destroyed) return typeof t > "u" && (t = r.params.speed), r.slideTo(r.activeIndex, t, e, n);
}
o(slideReset, "slideReset");
function slideToClosest(t, e, n, r) {
  e === void 0 && (e = !0), r === void 0 && (r = .5);
  const i = this;
  if (i.destroyed) return;
  typeof t > "u" && (t = i.params.speed);
  let s = i.activeIndex;
  const a = Math.min(i.params.slidesPerGroupSkip, s),
    l = a + Math.floor((s - a) / i.params.slidesPerGroup),
    u = i.rtlTranslate ? i.translate : -i.translate;
  if (u >= i.snapGrid[l]) {
    const c = i.snapGrid[l],
      p = i.snapGrid[l + 1];
    u - c > (p - c) * r && (s += i.params.slidesPerGroup);
  } else {
    const c = i.snapGrid[l - 1],
      p = i.snapGrid[l];
    u - c <= (p - c) * r && (s -= i.params.slidesPerGroup);
  }
  return s = Math.max(s, 0), s = Math.min(s, i.slidesGrid.length - 1), i.slideTo(s, t, e, n);
}
o(slideToClosest, "slideToClosest");
function slideToClickedSlide() {
  const t = this;
  if (t.destroyed) return;
  const {
      params: e,
      slidesEl: n
    } = t,
    r = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let i = t.clickedIndex,
    s;
  const a = t.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (t.animating) return;
    s = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? i < t.loopedSlides - r / 2 || i > t.slides.length - t.loopedSlides + r / 2 ? (t.loopFix(), i = t.getSlideIndex(elementChildren(n, `${a}[data-swiper-slide-index="${s}"]`)[0]), nextTick(() => {
      t.slideTo(i);
    })) : t.slideTo(i) : i > t.slides.length - r ? (t.loopFix(), i = t.getSlideIndex(elementChildren(n, `${a}[data-swiper-slide-index="${s}"]`)[0]), nextTick(() => {
      t.slideTo(i);
    })) : t.slideTo(i);
  } else t.slideTo(i);
}
o(slideToClickedSlide, "slideToClickedSlide");
var c_ = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};
function loopCreate(t) {
  const e = this,
    {
      params: n,
      slidesEl: r
    } = e;
  if (!n.loop || e.virtual && e.params.virtual.enabled) return;
  const initSlides = o(() => {
      elementChildren(r, `.${n.slideClass}, swiper-slide`).forEach((m, d) => {
        m.setAttribute("data-swiper-slide-index", d);
      });
    }, "initSlides"),
    s = e.grid && n.grid && n.grid.rows > 1,
    a = n.slidesPerGroup * (s ? n.grid.rows : 1),
    l = e.slides.length % a !== 0,
    u = s && e.slides.length % n.grid.rows !== 0,
    addBlankSlides = o(p => {
      for (let m = 0; m < p; m += 1) {
        const d = e.isElement ? createElement("swiper-slide", [n.slideBlankClass]) : createElement("div", [n.slideClass, n.slideBlankClass]);
        e.slidesEl.append(d);
      }
    }, "addBlankSlides");
  if (l) {
    if (n.loopAddBlankSlides) {
      const p = a - e.slides.length % a;
      addBlankSlides(p), e.recalcSlides(), e.updateSlides();
    } else showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    initSlides();
  } else if (u) {
    if (n.loopAddBlankSlides) {
      const p = n.grid.rows - e.slides.length % n.grid.rows;
      addBlankSlides(p), e.recalcSlides(), e.updateSlides();
    } else showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    initSlides();
  } else initSlides();
  e.loopFix({
    slideRealIndex: t,
    direction: n.centeredSlides ? void 0 : "next"
  });
}
o(loopCreate, "loopCreate");
function loopFix(t) {
  let {
    slideRealIndex: e,
    slideTo: n = !0,
    direction: r,
    setTranslate: i,
    activeSlideIndex: s,
    byController: a,
    byMousewheel: l
  } = t === void 0 ? {} : t;
  const u = this;
  if (!u.params.loop) return;
  u.emit("beforeLoopFix");
  const {
      slides: c,
      allowSlidePrev: p,
      allowSlideNext: m,
      slidesEl: d,
      params: y
    } = u,
    {
      centeredSlides: S
    } = y;
  if (u.allowSlidePrev = !0, u.allowSlideNext = !0, u.virtual && y.virtual.enabled) {
    n && (!y.centeredSlides && u.snapIndex === 0 ? u.slideTo(u.virtual.slides.length, 0, !1, !0) : y.centeredSlides && u.snapIndex < y.slidesPerView ? u.slideTo(u.virtual.slides.length + u.snapIndex, 0, !1, !0) : u.snapIndex === u.snapGrid.length - 1 && u.slideTo(u.virtual.slidesBefore, 0, !1, !0)), u.allowSlidePrev = p, u.allowSlideNext = m, u.emit("loopFix");
    return;
  }
  let w = y.slidesPerView;
  w === "auto" ? w = u.slidesPerViewDynamic() : (w = Math.ceil(parseFloat(y.slidesPerView, 10)), S && w % 2 === 0 && (w = w + 1));
  const g = y.slidesPerGroupAuto ? w : y.slidesPerGroup;
  let h = g;
  h % g !== 0 && (h += g - h % g), h += y.loopAdditionalSlides, u.loopedSlides = h;
  const f = u.grid && y.grid && y.grid.rows > 1;
  c.length < w + h ? showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : f && y.grid.fill === "row" && showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const v = [],
    E = [];
  let b = u.activeIndex;
  typeof s > "u" ? s = u.getSlideIndex(c.filter(R => R.classList.contains(y.slideActiveClass))[0]) : b = s;
  const P = r === "next" || !r,
    T = r === "prev" || !r;
  let O = 0,
    M = 0;
  const I = f ? Math.ceil(c.length / y.grid.rows) : c.length,
    _ = (f ? c[s].column : s) + (S && typeof i > "u" ? -w / 2 + .5 : 0);
  if (_ < h) {
    O = Math.max(h - _, g);
    for (let R = 0; R < h - _; R += 1) {
      const B = R - Math.floor(R / I) * I;
      if (f) {
        const H = I - B - 1;
        for (let Q = c.length - 1; Q >= 0; Q -= 1) c[Q].column === H && v.push(Q);
      } else v.push(I - B - 1);
    }
  } else if (_ + w > I - h) {
    M = Math.max(_ - (I - h * 2), g);
    for (let R = 0; R < M; R += 1) {
      const B = R - Math.floor(R / I) * I;
      f ? c.forEach((H, Q) => {
        H.column === B && E.push(Q);
      }) : E.push(B);
    }
  }
  if (u.__preventObserver__ = !0, requestAnimationFrame(() => {
    u.__preventObserver__ = !1;
  }), T && v.forEach(R => {
    c[R].swiperLoopMoveDOM = !0, d.prepend(c[R]), c[R].swiperLoopMoveDOM = !1;
  }), P && E.forEach(R => {
    c[R].swiperLoopMoveDOM = !0, d.append(c[R]), c[R].swiperLoopMoveDOM = !1;
  }), u.recalcSlides(), y.slidesPerView === "auto" ? u.updateSlides() : f && (v.length > 0 && T || E.length > 0 && P) && u.slides.forEach((R, B) => {
    u.grid.updateSlide(B, R, u.slides);
  }), y.watchSlidesProgress && u.updateSlidesOffset(), n) {
    if (v.length > 0 && T) {
      if (typeof e > "u") {
        const R = u.slidesGrid[b],
          H = u.slidesGrid[b + O] - R;
        l ? u.setTranslate(u.translate - H) : (u.slideTo(b + Math.ceil(O), 0, !1, !0), i && (u.touchEventsData.startTranslate = u.touchEventsData.startTranslate - H, u.touchEventsData.currentTranslate = u.touchEventsData.currentTranslate - H));
      } else if (i) {
        const R = f ? v.length / y.grid.rows : v.length;
        u.slideTo(u.activeIndex + R, 0, !1, !0), u.touchEventsData.currentTranslate = u.translate;
      }
    } else if (E.length > 0 && P) if (typeof e > "u") {
      const R = u.slidesGrid[b],
        H = u.slidesGrid[b - M] - R;
      l ? u.setTranslate(u.translate - H) : (u.slideTo(b - M, 0, !1, !0), i && (u.touchEventsData.startTranslate = u.touchEventsData.startTranslate - H, u.touchEventsData.currentTranslate = u.touchEventsData.currentTranslate - H));
    } else {
      const R = f ? E.length / y.grid.rows : E.length;
      u.slideTo(u.activeIndex - R, 0, !1, !0);
    }
  }
  if (u.allowSlidePrev = p, u.allowSlideNext = m, u.controller && u.controller.control && !a) {
    const R = {
      slideRealIndex: e,
      direction: r,
      setTranslate: i,
      activeSlideIndex: s,
      byController: !0
    };
    Array.isArray(u.controller.control) ? u.controller.control.forEach(B => {
      !B.destroyed && B.params.loop && B.loopFix({
        ...R,
        slideTo: B.params.slidesPerView === y.slidesPerView ? n : !1
      });
    }) : u.controller.control instanceof u.constructor && u.controller.control.params.loop && u.controller.control.loopFix({
      ...R,
      slideTo: u.controller.control.params.slidesPerView === y.slidesPerView ? n : !1
    });
  }
  u.emit("loopFix");
}
o(loopFix, "loopFix");
function loopDestroy() {
  const t = this,
    {
      params: e,
      slidesEl: n
    } = t;
  if (!e.loop || t.virtual && t.params.virtual.enabled) return;
  t.recalcSlides();
  const r = [];
  t.slides.forEach(i => {
    const s = typeof i.swiperSlideIndex > "u" ? i.getAttribute("data-swiper-slide-index") * 1 : i.swiperSlideIndex;
    r[s] = i;
  }), t.slides.forEach(i => {
    i.removeAttribute("data-swiper-slide-index");
  }), r.forEach(i => {
    n.append(i);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
o(loopDestroy, "loopDestroy");
var h_ = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};
function setGrabCursor(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const n = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
o(setGrabCursor, "setGrabCursor");
function unsetGrabCursor() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
o(unsetGrabCursor, "unsetGrabCursor");
var y_ = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};
function closestElement(t, e) {
  e === void 0 && (e = this);
  function __closestFrom(r) {
    if (!r || r === getDocument() || r === getWindow()) return null;
    r.assignedSlot && (r = r.assignedSlot);
    const i = r.closest(t);
    return !i && !r.getRootNode ? null : i || __closestFrom(r.getRootNode().host);
  }
  return o(__closestFrom, "__closestFrom"), __closestFrom(e);
}
o(closestElement, "closestElement");
function preventEdgeSwipe(t, e, n) {
  const r = getWindow(),
    {
      params: i
    } = t,
    s = i.edgeSwipeDetection,
    a = i.edgeSwipeThreshold;
  return s && (n <= a || n >= r.innerWidth - a) ? s === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
o(preventEdgeSwipe, "preventEdgeSwipe");
function onTouchStart(t) {
  const e = this,
    n = getDocument();
  let r = t;
  r.originalEvent && (r = r.originalEvent);
  const i = e.touchEventsData;
  if (r.type === "pointerdown") {
    if (i.pointerId !== null && i.pointerId !== r.pointerId) return;
    i.pointerId = r.pointerId;
  } else r.type === "touchstart" && r.targetTouches.length === 1 && (i.touchId = r.targetTouches[0].identifier);
  if (r.type === "touchstart") {
    preventEdgeSwipe(e, r, r.targetTouches[0].pageX);
    return;
  }
  const {
    params: s,
    touches: a,
    enabled: l
  } = e;
  if (!l || !s.simulateTouch && r.pointerType === "mouse" || e.animating && s.preventInteractionOnTransition) return;
  !e.animating && s.cssMode && s.loop && e.loopFix();
  let u = r.target;
  if (s.touchEventsTarget === "wrapper" && !elementIsChildOf(u, e.wrapperEl) || "which" in r && r.which === 3 || "button" in r && r.button > 0 || i.isTouched && i.isMoved) return;
  const c = !!s.noSwipingClass && s.noSwipingClass !== "",
    p = r.composedPath ? r.composedPath() : r.path;
  c && r.target && r.target.shadowRoot && p && (u = p[0]);
  const m = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`,
    d = !!(r.target && r.target.shadowRoot);
  if (s.noSwiping && (d ? closestElement(m, u) : u.closest(m))) {
    e.allowClick = !0;
    return;
  }
  if (s.swipeHandler && !u.closest(s.swipeHandler)) return;
  a.currentX = r.pageX, a.currentY = r.pageY;
  const y = a.currentX,
    S = a.currentY;
  if (!preventEdgeSwipe(e, r, y)) return;
  Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = y, a.startY = S, i.touchStartTime = now$1(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, s.threshold > 0 && (i.allowThresholdMove = !1);
  let w = !0;
  u.matches(i.focusableElements) && (w = !1, u.nodeName === "SELECT" && (i.isTouched = !1)), n.activeElement && n.activeElement.matches(i.focusableElements) && n.activeElement !== u && (r.pointerType === "mouse" || r.pointerType !== "mouse" && !u.matches(i.focusableElements)) && n.activeElement.blur();
  const g = w && e.allowTouchMove && s.touchStartPreventDefault;
  (s.touchStartForcePreventDefault || g) && !u.isContentEditable && r.preventDefault(), s.freeMode && s.freeMode.enabled && e.freeMode && e.animating && !s.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", r);
}
o(onTouchStart, "onTouchStart");
function onTouchMove(t) {
  const e = getDocument(),
    n = this,
    r = n.touchEventsData,
    {
      params: i,
      touches: s,
      rtlTranslate: a,
      enabled: l
    } = n;
  if (!l || !i.simulateTouch && t.pointerType === "mouse") return;
  let u = t;
  if (u.originalEvent && (u = u.originalEvent), u.type === "pointermove" && (r.touchId !== null || u.pointerId !== r.pointerId)) return;
  let c;
  if (u.type === "touchmove") {
    if (c = [...u.changedTouches].filter(P => P.identifier === r.touchId)[0], !c || c.identifier !== r.touchId) return;
  } else c = u;
  if (!r.isTouched) {
    r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", u);
    return;
  }
  const p = c.pageX,
    m = c.pageY;
  if (u.preventedByNestedSwiper) {
    s.startX = p, s.startY = m;
    return;
  }
  if (!n.allowTouchMove) {
    u.target.matches(r.focusableElements) || (n.allowClick = !1), r.isTouched && (Object.assign(s, {
      startX: p,
      startY: m,
      currentX: p,
      currentY: m
    }), r.touchStartTime = now$1());
    return;
  }
  if (i.touchReleaseOnEdges && !i.loop) {
    if (n.isVertical()) {
      if (m < s.startY && n.translate <= n.maxTranslate() || m > s.startY && n.translate >= n.minTranslate()) {
        r.isTouched = !1, r.isMoved = !1;
        return;
      }
    } else if (p < s.startX && n.translate <= n.maxTranslate() || p > s.startX && n.translate >= n.minTranslate()) return;
  }
  if (e.activeElement && e.activeElement.matches(r.focusableElements) && e.activeElement !== u.target && u.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && u.target === e.activeElement && u.target.matches(r.focusableElements)) {
    r.isMoved = !0, n.allowClick = !1;
    return;
  }
  r.allowTouchCallbacks && n.emit("touchMove", u), s.previousX = s.currentX, s.previousY = s.currentY, s.currentX = p, s.currentY = m;
  const d = s.currentX - s.startX,
    y = s.currentY - s.startY;
  if (n.params.threshold && Math.sqrt(d ** 2 + y ** 2) < n.params.threshold) return;
  if (typeof r.isScrolling > "u") {
    let P;
    n.isHorizontal() && s.currentY === s.startY || n.isVertical() && s.currentX === s.startX ? r.isScrolling = !1 : d * d + y * y >= 25 && (P = Math.atan2(Math.abs(y), Math.abs(d)) * 180 / Math.PI, r.isScrolling = n.isHorizontal() ? P > i.touchAngle : 90 - P > i.touchAngle);
  }
  if (r.isScrolling && n.emit("touchMoveOpposite", u), typeof r.startMoving > "u" && (s.currentX !== s.startX || s.currentY !== s.startY) && (r.startMoving = !0), r.isScrolling || u.type === "touchmove" && r.preventTouchMoveFromPointerMove) {
    r.isTouched = !1;
    return;
  }
  if (!r.startMoving) return;
  n.allowClick = !1, !i.cssMode && u.cancelable && u.preventDefault(), i.touchMoveStopPropagation && !i.nested && u.stopPropagation();
  let S = n.isHorizontal() ? d : y,
    w = n.isHorizontal() ? s.currentX - s.previousX : s.currentY - s.previousY;
  i.oneWayMovement && (S = Math.abs(S) * (a ? 1 : -1), w = Math.abs(w) * (a ? 1 : -1)), s.diff = S, S *= i.touchRatio, a && (S = -S, w = -w);
  const g = n.touchesDirection;
  n.swipeDirection = S > 0 ? "prev" : "next", n.touchesDirection = w > 0 ? "prev" : "next";
  const h = n.params.loop && !i.cssMode,
    f = n.touchesDirection === "next" && n.allowSlideNext || n.touchesDirection === "prev" && n.allowSlidePrev;
  if (!r.isMoved) {
    if (h && f && n.loopFix({
      direction: n.swipeDirection
    }), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
      const P = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      n.wrapperEl.dispatchEvent(P);
    }
    r.allowMomentumBounce = !1, i.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", u);
  }
  let v;
  if (new Date().getTime(), r.isMoved && r.allowThresholdMove && g !== n.touchesDirection && h && f && Math.abs(S) >= 1) {
    Object.assign(s, {
      startX: p,
      startY: m,
      currentX: p,
      currentY: m,
      startTranslate: r.currentTranslate
    }), r.loopSwapReset = !0, r.startTranslate = r.currentTranslate;
    return;
  }
  n.emit("sliderMove", u), r.isMoved = !0, r.currentTranslate = S + r.startTranslate;
  let E = !0,
    b = i.resistanceRatio;
  if (i.touchReleaseOnEdges && (b = 0), S > 0 ? (h && f && !v && r.allowThresholdMove && r.currentTranslate > (i.centeredSlides ? n.minTranslate() - n.slidesSizesGrid[n.activeIndex + 1] - (i.slidesPerView !== "auto" && n.slides.length - i.slidesPerView >= 2 ? n.slidesSizesGrid[n.activeIndex + 1] + n.params.spaceBetween : 0) - n.params.spaceBetween : n.minTranslate()) && n.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), r.currentTranslate > n.minTranslate() && (E = !1, i.resistance && (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + S) ** b))) : S < 0 && (h && f && !v && r.allowThresholdMove && r.currentTranslate < (i.centeredSlides ? n.maxTranslate() + n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween + (i.slidesPerView !== "auto" && n.slides.length - i.slidesPerView >= 2 ? n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween : 0) : n.maxTranslate()) && n.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: n.slides.length - (i.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
  }), r.currentTranslate < n.maxTranslate() && (E = !1, i.resistance && (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - S) ** b))), E && (u.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (r.currentTranslate = r.startTranslate), i.threshold > 0) if (Math.abs(S) > i.threshold || r.allowThresholdMove) {
    if (!r.allowThresholdMove) {
      r.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, r.currentTranslate = r.startTranslate, s.diff = n.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY;
      return;
    }
  } else {
    r.currentTranslate = r.startTranslate;
    return;
  }
  !i.followFinger || i.cssMode || ((i.freeMode && i.freeMode.enabled && n.freeMode || i.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), i.freeMode && i.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate));
}
o(onTouchMove, "onTouchMove");
function onTouchEnd(t) {
  const e = this,
    n = e.touchEventsData;
  let r = t;
  r.originalEvent && (r = r.originalEvent);
  let i;
  if (r.type === "touchend" || r.type === "touchcancel") {
    if (i = [...r.changedTouches].filter(b => b.identifier === n.touchId)[0], !i || i.identifier !== n.touchId) return;
  } else {
    if (n.touchId !== null || r.pointerId !== n.pointerId) return;
    i = r;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(r.type) && !(["pointercancel", "contextmenu"].includes(r.type) && (e.browser.isSafari || e.browser.isWebView))) return;
  n.pointerId = null, n.touchId = null;
  const {
    params: a,
    touches: l,
    rtlTranslate: u,
    slidesGrid: c,
    enabled: p
  } = e;
  if (!p || !a.simulateTouch && r.pointerType === "mouse") return;
  if (n.allowTouchCallbacks && e.emit("touchEnd", r), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && a.grabCursor && e.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  a.grabCursor && n.isMoved && n.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const m = now$1(),
    d = m - n.touchStartTime;
  if (e.allowClick) {
    const b = r.path || r.composedPath && r.composedPath();
    e.updateClickedSlide(b && b[0] || r.target, b), e.emit("tap click", r), d < 300 && m - n.lastClickTime < 300 && e.emit("doubleTap doubleClick", r);
  }
  if (n.lastClickTime = now$1(), nextTick(() => {
    e.destroyed || (e.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !e.swipeDirection || l.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let y;
  if (a.followFinger ? y = u ? e.translate : -e.translate : y = -n.currentTranslate, a.cssMode) return;
  if (a.freeMode && a.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: y
    });
    return;
  }
  const S = y >= -e.maxTranslate() && !e.params.loop;
  let w = 0,
    g = e.slidesSizesGrid[0];
  for (let b = 0; b < c.length; b += b < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
    const P = b < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    typeof c[b + P] < "u" ? (S || y >= c[b] && y < c[b + P]) && (w = b, g = c[b + P] - c[b]) : (S || y >= c[b]) && (w = b, g = c[c.length - 1] - c[c.length - 2]);
  }
  let h = null,
    f = null;
  a.rewind && (e.isBeginning ? f = a.virtual && a.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (h = 0));
  const v = (y - c[w]) / g,
    E = w < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
  if (d > a.longSwipesMs) {
    if (!a.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (v >= a.longSwipesRatio ? e.slideTo(a.rewind && e.isEnd ? h : w + E) : e.slideTo(w)), e.swipeDirection === "prev" && (v > 1 - a.longSwipesRatio ? e.slideTo(w + E) : f !== null && v < 0 && Math.abs(v) > a.longSwipesRatio ? e.slideTo(f) : e.slideTo(w));
  } else {
    if (!a.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (r.target === e.navigation.nextEl || r.target === e.navigation.prevEl) ? r.target === e.navigation.nextEl ? e.slideTo(w + E) : e.slideTo(w) : (e.swipeDirection === "next" && e.slideTo(h !== null ? h : w + E), e.swipeDirection === "prev" && e.slideTo(f !== null ? f : w));
  }
}
o(onTouchEnd, "onTouchEnd");
function onResize() {
  const t = this,
    {
      params: e,
      el: n
    } = t;
  if (n && n.offsetWidth === 0) return;
  e.breakpoints && t.setBreakpoint();
  const {
      allowSlideNext: r,
      allowSlidePrev: i,
      snapGrid: s
    } = t,
    a = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const l = a && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !l ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !a ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = i, t.allowSlideNext = r, t.params.watchOverflow && s !== t.snapGrid && t.checkOverflow();
}
o(onResize, "onResize");
function onClick(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
o(onClick, "onClick");
function onScroll() {
  const t = this,
    {
      wrapperEl: e,
      rtlTranslate: n,
      enabled: r
    } = t;
  if (!r) return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let i;
  const s = t.maxTranslate() - t.minTranslate();
  s === 0 ? i = 0 : i = (t.translate - t.minTranslate()) / s, i !== t.progress && t.updateProgress(n ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
o(onScroll, "onScroll");
function onLoad(t) {
  const e = this;
  processLazyPreloader(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
o(onLoad, "onLoad");
function onDocumentTouchStart() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
o(onDocumentTouchStart, "onDocumentTouchStart");
const events = o((t, e) => {
  const n = getDocument(),
    {
      params: r,
      el: i,
      wrapperEl: s,
      device: a
    } = t,
    l = !!r.nested,
    u = e === "on" ? "addEventListener" : "removeEventListener",
    c = e;
  !i || typeof i == "string" || (n[u]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: l
  }), i[u]("touchstart", t.onTouchStart, {
    passive: !1
  }), i[u]("pointerdown", t.onTouchStart, {
    passive: !1
  }), n[u]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: l
  }), n[u]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: l
  }), n[u]("touchend", t.onTouchEnd, {
    passive: !0
  }), n[u]("pointerup", t.onTouchEnd, {
    passive: !0
  }), n[u]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), n[u]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), n[u]("pointerout", t.onTouchEnd, {
    passive: !0
  }), n[u]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), n[u]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (r.preventClicks || r.preventClicksPropagation) && i[u]("click", t.onClick, !0), r.cssMode && s[u]("scroll", t.onScroll), r.updateOnWindowResize ? t[c](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, !0) : t[c]("observerUpdate", onResize, !0), i[u]("load", t.onLoad, {
    capture: !0
  }));
}, "events");
function attachEvents() {
  const on = this,
    {
      params: e
    } = on;
  on.onTouchStart = onTouchStart.bind(on), on.onTouchMove = onTouchMove.bind(on), on.onTouchEnd = onTouchEnd.bind(on), on.onDocumentTouchStart = onDocumentTouchStart.bind(on), e.cssMode && (on.onScroll = onScroll.bind(on)), on.onClick = onClick.bind(on), on.onLoad = onLoad.bind(on), events(on, "on");
}
o(attachEvents, "attachEvents");
function detachEvents() {
  events(this, "off");
}
o(detachEvents, "detachEvents");
var __ = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};
const isGridEnabled = o((t, e) => t.grid && e.grid && e.grid.rows > 1, "isGridEnabled");
function setBreakpoint() {
  const t = this,
    {
      realIndex: e,
      initialized: n,
      params: r,
      el: i
    } = t,
    s = r.breakpoints;
  if (!s || s && Object.keys(s).length === 0) return;
  const a = t.getBreakpoint(s, t.params.breakpointsBase, t.el);
  if (!a || t.currentBreakpoint === a) return;
  const u = (a in s ? s[a] : void 0) || t.originalParams,
    c = isGridEnabled(t, r),
    p = isGridEnabled(t, u),
    m = t.params.grabCursor,
    d = u.grabCursor,
    y = r.enabled;
  c && !p ? (i.classList.remove(`${r.containerModifierClass}grid`, `${r.containerModifierClass}grid-column`), t.emitContainerClasses()) : !c && p && (i.classList.add(`${r.containerModifierClass}grid`), (u.grid.fill && u.grid.fill === "column" || !u.grid.fill && r.grid.fill === "column") && i.classList.add(`${r.containerModifierClass}grid-column`), t.emitContainerClasses()), m && !d ? t.unsetGrabCursor() : !m && d && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach(v => {
    if (typeof u[v] > "u") return;
    const E = r[v] && r[v].enabled,
      b = u[v] && u[v].enabled;
    E && !b && t[v].disable(), !E && b && t[v].enable();
  });
  const S = u.direction && u.direction !== r.direction,
    w = r.loop && (u.slidesPerView !== r.slidesPerView || S),
    g = r.loop;
  S && n && t.changeDirection(), extend$3(t.params, u);
  const h = t.params.enabled,
    f = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), y && !h ? t.disable() : !y && h && t.enable(), t.currentBreakpoint = a, t.emit("_beforeBreakpoint", u), n && (w ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !g && f ? (t.loopCreate(e), t.updateSlides()) : g && !f && t.loopDestroy()), t.emit("breakpoint", u);
}
o(setBreakpoint, "setBreakpoint");
function getBreakpoint(t, e, n) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !n) return;
  let r = !1;
  const i = getWindow(),
    s = e === "window" ? i.innerHeight : n.clientHeight,
    a = Object.keys(t).map(l => {
      if (typeof l == "string" && l.indexOf("@") === 0) {
        const u = parseFloat(l.substr(1));
        return {
          value: s * u,
          point: l
        };
      }
      return {
        value: l,
        point: l
      };
    });
  a.sort((l, u) => parseInt(l.value, 10) - parseInt(u.value, 10));
  for (let l = 0; l < a.length; l += 1) {
    const {
      point: u,
      value: c
    } = a[l];
    e === "window" ? i.matchMedia(`(min-width: ${c}px)`).matches && (r = u) : c <= n.clientWidth && (r = u);
  }
  return r || "max";
}
o(getBreakpoint, "getBreakpoint");
var L_ = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};
function prepareClasses(t, e) {
  const n = [];
  return t.forEach(r => {
    typeof r == "object" ? Object.keys(r).forEach(i => {
      r[i] && n.push(e + i);
    }) : typeof r == "string" && n.push(e + r);
  }), n;
}
o(prepareClasses, "prepareClasses");
function addClasses() {
  const t = this,
    {
      classNames: e,
      params: n,
      rtl: r,
      el: i,
      device: s
    } = t,
    a = prepareClasses(["initialized", n.direction, {
      "free-mode": t.params.freeMode && n.freeMode.enabled
    }, {
      autoheight: n.autoHeight
    }, {
      rtl: r
    }, {
      grid: n.grid && n.grid.rows > 1
    }, {
      "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
    }, {
      android: s.android
    }, {
      ios: s.ios
    }, {
      "css-mode": n.cssMode
    }, {
      centered: n.cssMode && n.centeredSlides
    }, {
      "watch-progress": n.watchSlidesProgress
    }], n.containerModifierClass);
  e.push(...a), i.classList.add(...e), t.emitContainerClasses();
}
o(addClasses, "addClasses");
function removeClasses() {
  const t = this,
    {
      el: e,
      classNames: n
    } = t;
  !e || typeof e == "string" || (e.classList.remove(...n), t.emitContainerClasses());
}
o(removeClasses, "removeClasses");
var R_ = {
  addClasses: addClasses,
  removeClasses: removeClasses
};
function checkOverflow() {
  const t = this,
    {
      isLocked: e,
      params: n
    } = t,
    {
      slidesOffsetBefore: r
    } = n;
  if (r) {
    const i = t.slides.length - 1,
      s = t.slidesGrid[i] + t.slidesSizesGrid[i] + r * 2;
    t.isLocked = t.size > s;
  } else t.isLocked = t.snapGrid.length === 1;
  n.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), n.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
o(checkOverflow, "checkOverflow");
var $_ = {
    checkOverflow: checkOverflow
  },
  Og = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: .5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: .85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1
  };
function moduleExtendParams(t, e) {
  return o(function (r) {
    r === void 0 && (r = {});
    const i = Object.keys(r)[0],
      s = r[i];
    if (typeof s != "object" || s === null) {
      extend$3(e, r);
      return;
    }
    if (t[i] === !0 && (t[i] = {
      enabled: !0
    }), i === "navigation" && t[i] && t[i].enabled && !t[i].prevEl && !t[i].nextEl && (t[i].auto = !0), ["pagination", "scrollbar"].indexOf(i) >= 0 && t[i] && t[i].enabled && !t[i].el && (t[i].auto = !0), !(i in t && "enabled" in s)) {
      extend$3(e, r);
      return;
    }
    typeof t[i] == "object" && !("enabled" in t[i]) && (t[i].enabled = !0), t[i] || (t[i] = {
      enabled: !1
    }), extend$3(e, r);
  }, "extendParams");
}
o(moduleExtendParams, "moduleExtendParams");
const Ec = {
    eventsEmitter: Rk,
    update: Wk,
    translate: Jk,
    transition: n_,
    slide: c_,
    loop: h_,
    grabCursor: y_,
    events: __,
    breakpoints: L_,
    checkOverflow: $_,
    classes: R_
  },
  Tc = {};
class Swiper {
  constructor() {
    let e, n;
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++) i[s] = arguments[s];
    i.length === 1 && i[0].constructor && Object.prototype.toString.call(i[0]).slice(8, -1) === "Object" ? n = i[0] : [e, n] = i, n || (n = {}), n = extend$3({}, n), e && !n.el && (n.el = e);
    const a = getDocument();
    if (n.el && typeof n.el == "string" && a.querySelectorAll(n.el).length > 1) {
      const p = [];
      return a.querySelectorAll(n.el).forEach(m => {
        const d = extend$3({}, n, {
          el: m
        });
        p.push(new Swiper(d));
      }), p;
    }
    const l = this;
    l.__swiper__ = !0, l.support = getSupport(), l.device = getDevice({
      userAgent: n.userAgent
    }), l.browser = getBrowser(), l.eventsListeners = {}, l.eventsAnyListeners = [], l.modules = [...l.__modules__], n.modules && Array.isArray(n.modules) && l.modules.push(...n.modules);
    const u = {};
    l.modules.forEach(p => {
      p({
        params: n,
        swiper: l,
        extendParams: moduleExtendParams(n, u),
        on: l.on.bind(l),
        once: l.once.bind(l),
        off: l.off.bind(l),
        emit: l.emit.bind(l)
      });
    });
    const c = extend$3({}, Og, u);
    return l.params = extend$3({}, c, Tc, n), l.originalParams = extend$3({}, l.params), l.passedParams = extend$3({}, n), l.params && l.params.on && Object.keys(l.params.on).forEach(p => {
      l.on(p, l.params.on[p]);
    }), l.params && l.params.onAny && l.onAny(l.params.onAny), Object.assign(l, {
      enabled: l.params.enabled,
      el: e,
      classNames: [],
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      isHorizontal() {
        return l.params.direction === "horizontal";
      },
      isVertical() {
        return l.params.direction === "vertical";
      },
      activeIndex: 0,
      realIndex: 0,
      isBeginning: !0,
      isEnd: !1,
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      allowSlideNext: l.params.allowSlideNext,
      allowSlidePrev: l.params.allowSlidePrev,
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        focusableElements: l.params.focusableElements,
        lastClickTime: 0,
        clickTimeout: void 0,
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      allowClick: !0,
      allowTouchMove: l.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      imagesToLoad: [],
      imagesLoaded: 0
    }), l.emit("_swiper"), l.params.init && l.init(), l;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
        slidesEl: n,
        params: r
      } = this,
      i = elementChildren(n, `.${r.slideClass}, swiper-slide`),
      s = elementIndex(i[0]);
    return elementIndex(e) - s;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.filter(n => n.getAttribute("data-swiper-slide-index") * 1 === e)[0]);
  }
  recalcSlides() {
    const e = this,
      {
        slidesEl: n,
        params: r
      } = e;
    e.slides = elementChildren(n, `.${r.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, n) {
    const r = this;
    e = Math.min(Math.max(e, 0), 1);
    const i = r.minTranslate(),
      a = (r.maxTranslate() - i) * e + i;
    r.translateTo(a, typeof n > "u" ? 0 : n), r.updateActiveIndex(), r.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const n = e.el.className.split(" ").filter(r => r.indexOf("swiper") === 0 || r.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(e) {
    const n = this;
    return n.destroyed ? "" : e.className.split(" ").filter(r => r.indexOf("swiper-slide") === 0 || r.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const n = [];
    e.slides.forEach(r => {
      const i = e.getSlideClasses(r);
      n.push({
        slideEl: r,
        classNames: i
      }), e.emit("_slideClass", r, i);
    }), e.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(e, n) {
    e === void 0 && (e = "current"), n === void 0 && (n = !1);
    const r = this,
      {
        params: i,
        slides: s,
        slidesGrid: a,
        slidesSizesGrid: l,
        size: u,
        activeIndex: c
      } = r;
    let p = 1;
    if (typeof i.slidesPerView == "number") return i.slidesPerView;
    if (i.centeredSlides) {
      let m = s[c] ? Math.ceil(s[c].swiperSlideSize) : 0,
        d;
      for (let y = c + 1; y < s.length; y += 1) s[y] && !d && (m += Math.ceil(s[y].swiperSlideSize), p += 1, m > u && (d = !0));
      for (let y = c - 1; y >= 0; y -= 1) s[y] && !d && (m += s[y].swiperSlideSize, p += 1, m > u && (d = !0));
    } else if (e === "current") for (let m = c + 1; m < s.length; m += 1) (n ? a[m] + l[m] - a[c] < u : a[m] - a[c] < u) && (p += 1);else for (let m = c - 1; m >= 0; m -= 1) a[c] - a[m] < u && (p += 1);
    return p;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: n,
      params: r
    } = e;
    r.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach(a => {
      a.complete && processLazyPreloader(e, a);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function setTranslate$1() {
      const a = e.rtlTranslate ? e.translate * -1 : e.translate,
        l = Math.min(Math.max(a, e.maxTranslate()), e.minTranslate());
      e.setTranslate(l), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    o(setTranslate$1, "setTranslate");
    let s;
    if (r.freeMode && r.freeMode.enabled && !r.cssMode) setTranslate$1(), r.autoHeight && e.updateAutoHeight();else {
      if ((r.slidesPerView === "auto" || r.slidesPerView > 1) && e.isEnd && !r.centeredSlides) {
        const a = e.virtual && r.virtual.enabled ? e.virtual.slides : e.slides;
        s = e.slideTo(a.length - 1, 0, !1, !0);
      } else s = e.slideTo(e.activeIndex, 0, !1, !0);
      s || setTranslate$1();
    }
    r.watchOverflow && n !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, n) {
    n === void 0 && (n = !0);
    const r = this,
      i = r.params.direction;
    return e || (e = i === "horizontal" ? "vertical" : "horizontal"), e === i || e !== "horizontal" && e !== "vertical" || (r.el.classList.remove(`${r.params.containerModifierClass}${i}`), r.el.classList.add(`${r.params.containerModifierClass}${e}`), r.emitContainerClasses(), r.params.direction = e, r.slides.forEach(s => {
      e === "vertical" ? s.style.width = "" : s.style.height = "";
    }), r.emit("changeDirection"), n && r.update()), r;
  }
  changeLanguageDirection(e) {
    const n = this;
    n.rtl && e === "rtl" || !n.rtl && e === "ltr" || (n.rtl = e === "rtl", n.rtlTranslate = n.params.direction === "horizontal" && n.rtl, n.rtl ? (n.el.classList.add(`${n.params.containerModifierClass}rtl`), n.el.dir = "rtl") : (n.el.classList.remove(`${n.params.containerModifierClass}rtl`), n.el.dir = "ltr"), n.update());
  }
  mount(e) {
    const n = this;
    if (n.mounted) return !0;
    let direction = e || n.params.el;
    if (typeof direction == "string" && (direction = document.querySelector(direction)), !direction) return !1;
    direction.swiper = n, direction.parentNode && direction.parentNode.host && direction.parentNode.host.nodeName === n.params.swiperElementNodeName.toUpperCase() && (n.isElement = !0);
    const getWrapperSelector = o(() => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`, "getWrapperSelector");
    let display$1 = o(() => direction && direction.shadowRoot && direction.shadowRoot.querySelector ? direction.shadowRoot.querySelector(getWrapperSelector()) : elementChildren(direction, getWrapperSelector())[0], "getWrapper")();
    return !display$1 && n.params.createElements && (display$1 = createElement("div", n.params.wrapperClass), direction.append(display$1), elementChildren(direction, `.${n.params.slideClass}`).forEach(l => {
      display$1.append(l);
    })), Object.assign(n, {
      el: direction,
      wrapperEl: display$1,
      slidesEl: n.isElement && !direction.parentNode.host.slideSlots ? direction.parentNode.host : display$1,
      hostEl: n.isElement ? direction.parentNode.host : direction,
      mounted: !0,
      rtl: direction.dir.toLowerCase() === "rtl" || elementStyle(direction, "direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (direction.dir.toLowerCase() === "rtl" || elementStyle(direction, "direction") === "rtl"),
      wrongRTL: elementStyle(display$1, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const n = this;
    if (n.initialized || n.mount(e) === !1) return n;
    n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.loop && n.virtual && n.params.virtual.enabled ? n.slideTo(n.params.initialSlide + n.virtual.slidesBefore, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.params.loop && n.loopCreate(), n.attachEvents();
    const i = [...n.el.querySelectorAll('[loading="lazy"]')];
    return n.isElement && i.push(...n.hostEl.querySelectorAll('[loading="lazy"]')), i.forEach(s => {
      s.complete ? processLazyPreloader(n, s) : s.addEventListener("load", a => {
        processLazyPreloader(n, a.target);
      });
    }), preload(n), n.initialized = !0, preload(n), n.emit("init"), n.emit("afterInit"), n;
  }
  destroy(e, n) {
    e === void 0 && (e = !0), n === void 0 && (n = !0);
    const r = this,
      {
        params: i,
        el: s,
        wrapperEl: a,
        slides: l
      } = r;
    return typeof r.params > "u" || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), i.loop && r.loopDestroy(), n && (r.removeClasses(), s && typeof s != "string" && s.removeAttribute("style"), a && a.removeAttribute("style"), l && l.length && l.forEach(u => {
      u.classList.remove(i.slideVisibleClass, i.slideFullyVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass), u.removeAttribute("style"), u.removeAttribute("data-swiper-slide-index");
    })), r.emit("destroy"), Object.keys(r.eventsListeners).forEach(u => {
      r.off(u);
    }), e !== !1 && (r.el && typeof r.el != "string" && (r.el.swiper = null), deleteProps(r)), r.destroyed = !0), null;
  }
  static extendDefaults(e) {
    extend$3(Tc, e);
  }
  static get extendedDefaults() {
    return Tc;
  }
  static get defaults() {
    return Og;
  }
  static installModule(e) {
    Swiper.prototype.__modules__ || (Swiper.prototype.__modules__ = []);
    const n = Swiper.prototype.__modules__;
    typeof e == "function" && n.indexOf(e) < 0 && n.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach(n => Swiper.installModule(n)), Swiper) : (Swiper.installModule(e), Swiper);
  }
}
o(Swiper, "Swiper");
Object.keys(Ec).forEach(t => {
  Object.keys(Ec[t]).forEach(e => {
    Swiper.prototype[e] = Ec[t][e];
  });
});
Swiper.use([Resize, Observer]);
function Mousewheel(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r,
    emit: i
  } = t;
  const s = getWindow();
  n({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let a,
    l = now$1(),
    u;
  const c = [];
  function normalize$1(v) {
    let T = 0,
      O = 0,
      M = 0,
      I = 0;
    return "detail" in v && (O = v.detail), "wheelDelta" in v && (O = -v.wheelDelta / 120), "wheelDeltaY" in v && (O = -v.wheelDeltaY / 120), "wheelDeltaX" in v && (T = -v.wheelDeltaX / 120), "axis" in v && v.axis === v.HORIZONTAL_AXIS && (T = O, O = 0), M = T * 10, I = O * 10, "deltaY" in v && (I = v.deltaY), "deltaX" in v && (M = v.deltaX), v.shiftKey && !M && (M = I, I = 0), (M || I) && v.deltaMode && (v.deltaMode === 1 ? (M *= 40, I *= 40) : (M *= 800, I *= 800)), M && !T && (T = M < 1 ? -1 : 1), I && !O && (O = I < 1 ? -1 : 1), {
      spinX: T,
      spinY: O,
      pixelX: M,
      pixelY: I
    };
  }
  o(normalize$1, "normalize");
  function handleMouseEnter() {
    e.enabled && (e.mouseEntered = !0);
  }
  o(handleMouseEnter, "handleMouseEnter");
  function handleMouseLeave() {
    e.enabled && (e.mouseEntered = !1);
  }
  o(handleMouseLeave, "handleMouseLeave");
  function animateSlider(v) {
    return e.params.mousewheel.thresholdDelta && v.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && now$1() - l < e.params.mousewheel.thresholdTime ? !1 : v.delta >= 6 && now$1() - l < 60 ? !0 : (v.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), i("scroll", v.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), i("scroll", v.raw)), l = new s.Date().getTime(), !1);
  }
  o(animateSlider, "animateSlider");
  function releaseScroll(v) {
    const E = e.params.mousewheel;
    if (v.direction < 0) {
      if (e.isEnd && !e.params.loop && E.releaseOnEdges) return !0;
    } else if (e.isBeginning && !e.params.loop && E.releaseOnEdges) return !0;
    return !1;
  }
  o(releaseScroll, "releaseScroll");
  function handle(v) {
    let E = v,
      b = !0;
    if (!e.enabled || v.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
    const P = e.params.mousewheel;
    e.params.cssMode && E.preventDefault();
    let T = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (T = document.querySelector(e.params.mousewheel.eventsTarget));
    const O = T && T.contains(E.target);
    if (!e.mouseEntered && !O && !P.releaseOnEdges) return !0;
    E.originalEvent && (E = E.originalEvent);
    let M = 0;
    const I = e.rtlTranslate ? -1 : 1,
      U = normalize$1(E);
    if (P.forceToAxis) {
      if (e.isHorizontal()) {
        if (Math.abs(U.pixelX) > Math.abs(U.pixelY)) M = -U.pixelX * I;else return !0;
      } else if (Math.abs(U.pixelY) > Math.abs(U.pixelX)) M = -U.pixelY;else return !0;
    } else M = Math.abs(U.pixelX) > Math.abs(U.pixelY) ? -U.pixelX * I : -U.pixelY;
    if (M === 0) return !0;
    P.invert && (M = -M);
    let _ = e.getTranslate() + M * P.sensitivity;
    if (_ >= e.minTranslate() && (_ = e.minTranslate()), _ <= e.maxTranslate() && (_ = e.maxTranslate()), b = e.params.loop ? !0 : !(_ === e.minTranslate() || _ === e.maxTranslate()), b && e.params.nested && E.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const R = {
        time: now$1(),
        delta: Math.abs(M),
        direction: Math.sign(M),
        raw: v
      };
      c.length >= 2 && c.shift();
      const B = c.length ? c[c.length - 1] : void 0;
      if (c.push(R), B ? (R.direction !== B.direction || R.delta > B.delta || R.time > B.time + 150) && animateSlider(R) : animateSlider(R), releaseScroll(R)) return !0;
    } else {
      const R = {
          time: now$1(),
          delta: Math.abs(M),
          direction: Math.sign(M)
        },
        B = u && R.time < u.time + 500 && R.delta <= u.delta && R.direction === u.direction;
      if (!B) {
        u = void 0;
        let H = e.getTranslate() + M * P.sensitivity;
        const Q = e.isBeginning,
          te = e.isEnd;
        if (H >= e.minTranslate() && (H = e.minTranslate()), H <= e.maxTranslate() && (H = e.maxTranslate()), e.setTransition(0), e.setTranslate(H), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!Q && e.isBeginning || !te && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: R.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(a), a = void 0, c.length >= 15 && c.shift();
          const j = c.length ? c[c.length - 1] : void 0,
            X = c[0];
          if (c.push(R), j && (R.delta > j.delta || R.direction !== j.direction)) c.splice(0);else if (c.length >= 15 && R.time - X.time < 500 && X.delta - R.delta >= 1 && R.delta <= 6) {
            const q = M > 0 ? .8 : .2;
            u = R, c.splice(0), a = nextTick(() => {
              e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, q);
            }, 0);
          }
          a || (a = nextTick(() => {
            if (e.destroyed || !e.params) return;
            const q = .5;
            u = R, c.splice(0), e.slideToClosest(e.params.speed, !0, void 0, q);
          }, 500));
        }
        if (B || i("scroll", E), e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(), P.releaseOnEdges && (H === e.minTranslate() || H === e.maxTranslate())) return !0;
      }
    }
    return E.preventDefault ? E.preventDefault() : E.returnValue = !1, !1;
  }
  o(handle, "handle");
  function events$1(v) {
    let E = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (E = document.querySelector(e.params.mousewheel.eventsTarget)), E[v]("mouseenter", handleMouseEnter), E[v]("mouseleave", handleMouseLeave), E[v]("wheel", handle);
  }
  o(events$1, "events");
  function enable() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", handle), !0) : e.mousewheel.enabled ? !1 : (events$1("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  o(enable, "enable");
  function disable() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, handle), !0) : e.mousewheel.enabled ? (events$1("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  o(disable, "disable"), r("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && disable(), e.params.mousewheel.enabled && enable();
  }), r("destroy", () => {
    e.params.cssMode && enable(), e.mousewheel.enabled && disable();
  }), Object.assign(e.mousewheel, {
    enable: enable,
    disable: disable
  });
}
o(Mousewheel, "Mousewheel");
function createElementIfNotDefined(t, e, n, r) {
  return t.params.createElements && Object.keys(r).forEach(i => {
    if (!n[i] && n.auto === !0) {
      let s = elementChildren(t.el, `.${r[i]}`)[0];
      s || (s = createElement("div", r[i]), s.className = r[i], t.el.append(s)), n[i] = s, e[i] = s;
    }
  }), n;
}
o(createElementIfNotDefined, "createElementIfNotDefined");
function Navigation(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r,
    emit: i
  } = t;
  n({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function getEl(S) {
    let w;
    return S && typeof S == "string" && e.isElement && (w = e.el.querySelector(S) || e.hostEl.querySelector(S), w) ? w : (S && (typeof S == "string" && (w = [...document.querySelectorAll(S)]), e.params.uniqueNavElements && typeof S == "string" && w && w.length > 1 && e.el.querySelectorAll(S).length === 1 ? w = e.el.querySelector(S) : w && w.length === 1 && (w = w[0])), S && !w ? S : w);
  }
  o(getEl, "getEl");
  function toggleEl(S, w) {
    const g = e.params.navigation;
    S = makeElementsArray(S), S.forEach(h => {
      h && (h.classList[w ? "add" : "remove"](...g.disabledClass.split(" ")), h.tagName === "BUTTON" && (h.disabled = w), e.params.watchOverflow && e.enabled && h.classList[e.isLocked ? "add" : "remove"](g.lockClass));
    });
  }
  o(toggleEl, "toggleEl");
  function update() {
    const {
      nextEl: S,
      prevEl: w
    } = e.navigation;
    if (e.params.loop) {
      toggleEl(w, !1), toggleEl(S, !1);
      return;
    }
    toggleEl(w, e.isBeginning && !e.params.rewind), toggleEl(S, e.isEnd && !e.params.rewind);
  }
  o(update, "update");
  function onPrevClick(S) {
    S.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), i("navigationPrev"));
  }
  o(onPrevClick, "onPrevClick");
  function onNextClick(S) {
    S.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), i("navigationNext"));
  }
  o(onNextClick, "onNextClick");
  function init$1() {
    const S = e.params.navigation;
    if (e.params.navigation = createElementIfNotDefined(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(S.nextEl || S.prevEl)) return;
    let w = getEl(S.nextEl),
      g = getEl(S.prevEl);
    Object.assign(e.navigation, {
      nextEl: w,
      prevEl: g
    }), w = makeElementsArray(w), g = makeElementsArray(g);
    const initButton = o((f, v) => {
      f && f.addEventListener("click", v === "next" ? onNextClick : onPrevClick), !e.enabled && f && f.classList.add(...S.lockClass.split(" "));
    }, "initButton");
    w.forEach(next => initButton(next, "next")), g.forEach(prev => initButton(prev, "prev"));
  }
  o(init$1, "init");
  function destroy$1() {
    let {
      nextEl: S,
      prevEl: w
    } = e.navigation;
    S = makeElementsArray(S), w = makeElementsArray(w);
    const destroyButton = o((h, f) => {
      h.removeEventListener("click", f === "next" ? onNextClick : onPrevClick), h.classList.remove(...e.params.navigation.disabledClass.split(" "));
    }, "destroyButton");
    S.forEach(next$1 => destroyButton(next$1, "next")), w.forEach(prev$1 => destroyButton(prev$1, "prev"));
  }
  o(destroy$1, "destroy"), r("init", () => {
    e.params.navigation.enabled === !1 ? disable$1() : (init$1(), update());
  }), r("toEdge fromEdge lock unlock", () => {
    update();
  }), r("destroy", () => {
    destroy$1();
  }), r("enable disable", () => {
    let {
      nextEl: S,
      prevEl: w
    } = e.navigation;
    if (S = makeElementsArray(S), w = makeElementsArray(w), e.enabled) {
      update();
      return;
    }
    [...S, ...w].filter(g => !!g).forEach(g => g.classList.add(e.params.navigation.lockClass));
  }), r("click", (S, w) => {
    let {
      nextEl: g,
      prevEl: h
    } = e.navigation;
    g = makeElementsArray(g), h = makeElementsArray(h);
    const f = w.target;
    let v = h.includes(f) || g.includes(f);
    if (e.isElement && !v) {
      const E = w.path || w.composedPath && w.composedPath();
      E && (v = E.find(b => g.includes(b) || h.includes(b)));
    }
    if (e.params.navigation.hideOnClick && !v) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === f || e.pagination.el.contains(f))) return;
      let E;
      g.length ? E = g[0].classList.contains(e.params.navigation.hiddenClass) : h.length && (E = h[0].classList.contains(e.params.navigation.hiddenClass)), i(E === !0 ? "navigationShow" : "navigationHide"), [...g, ...h].filter(b => !!b).forEach(b => b.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const enable$1 = o(() => {
      e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), init$1(), update();
    }, "enable"),
    disable$1 = o(() => {
      e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), destroy$1();
    }, "disable");
  Object.assign(e.navigation, {
    enable: enable$1,
    disable: disable$1,
    update: update,
    init: init$1,
    destroy: destroy$1
  });
}
o(Navigation, "Navigation");
function classesToSelector(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
o(classesToSelector, "classesToSelector");
function Pagination(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r,
    emit: i
  } = t;
  const s = "swiper-pagination";
  n({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: f => f,
      formatFractionTotal: f => f,
      bulletClass: `${s}-bullet`,
      bulletActiveClass: `${s}-bullet-active`,
      modifierClass: `${s}-`,
      currentClass: `${s}-current`,
      totalClass: `${s}-total`,
      hiddenClass: `${s}-hidden`,
      progressbarFillClass: `${s}-progressbar-fill`,
      progressbarOppositeClass: `${s}-progressbar-opposite`,
      clickableClass: `${s}-clickable`,
      lockClass: `${s}-lock`,
      horizontalClass: `${s}-horizontal`,
      verticalClass: `${s}-vertical`,
      paginationDisabledClass: `${s}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let a,
    l = 0;
  function isPaginationDisabled() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  o(isPaginationDisabled, "isPaginationDisabled");
  function setSideBullets(f, v) {
    const {
      bulletActiveClass: E
    } = e.params.pagination;
    f && (f = f[`${v === "prev" ? "previous" : "next"}ElementSibling`], f && (f.classList.add(`${E}-${v}`), f = f[`${v === "prev" ? "previous" : "next"}ElementSibling`], f && f.classList.add(`${E}-${v}-${v}`)));
  }
  o(setSideBullets, "setSideBullets");
  function getMoveDirection(f, v, E) {
    if (f = f % E, v = v % E, v === f + 1) return "next";
    if (v === f - 1) return "previous";
  }
  o(getMoveDirection, "getMoveDirection");
  function onBulletClick(f) {
    const v = f.target.closest(classesToSelector(e.params.pagination.bulletClass));
    if (!v) return;
    f.preventDefault();
    const E = elementIndex(v) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === E) return;
      const b = getMoveDirection(e.realIndex, E, e.slides.length);
      b === "next" ? e.slideNext() : b === "previous" ? e.slidePrev() : e.slideToLoop(E);
    } else e.slideTo(E);
  }
  o(onBulletClick, "onBulletClick");
  function update$1() {
    const f = e.rtl,
      v = e.params.pagination;
    if (isPaginationDisabled()) return;
    let E = e.pagination.el;
    E = makeElementsArray(E);
    let b, P;
    const T = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
      O = e.params.loop ? Math.ceil(T / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (P = e.previousRealIndex || 0, b = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (b = e.snapIndex, P = e.previousSnapIndex) : (P = e.previousIndex || 0, b = e.activeIndex || 0), v.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const M = e.pagination.bullets;
      let I, U, _;
      if (v.dynamicBullets && (a = elementOuterSize(M[0], e.isHorizontal() ? "width" : "height", !0), E.forEach(R => {
        R.style[e.isHorizontal() ? "width" : "height"] = `${a * (v.dynamicMainBullets + 4)}px`;
      }), v.dynamicMainBullets > 1 && P !== void 0 && (l += b - (P || 0), l > v.dynamicMainBullets - 1 ? l = v.dynamicMainBullets - 1 : l < 0 && (l = 0)), I = Math.max(b - l, 0), U = I + (Math.min(M.length, v.dynamicMainBullets) - 1), _ = (U + I) / 2), M.forEach(R => {
        const B = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(H => `${v.bulletActiveClass}${H}`)].map(H => typeof H == "string" && H.includes(" ") ? H.split(" ") : H).flat();
        R.classList.remove(...B);
      }), E.length > 1) M.forEach(prev$2 => {
        const B = elementIndex(prev$2);
        B === b ? prev$2.classList.add(...v.bulletActiveClass.split(" ")) : e.isElement && prev$2.setAttribute("part", "bullet"), v.dynamicBullets && (B >= I && B <= U && prev$2.classList.add(...`${v.bulletActiveClass}-main`.split(" ")), B === I && setSideBullets(prev$2, "prev"), B === U && setSideBullets(prev$2, "next"));
      });else {
        const R = M[b];
        if (R && R.classList.add(...v.bulletActiveClass.split(" ")), e.isElement && M.forEach((B, H) => {
          B.setAttribute("part", H === b ? "bullet-active" : "bullet");
        }), v.dynamicBullets) {
          const prev$3 = M[I],
            next$2 = M[U];
          for (let Q = I; Q <= U; Q += 1) M[Q] && M[Q].classList.add(...`${v.bulletActiveClass}-main`.split(" "));
          setSideBullets(prev$3, "prev"), setSideBullets(next$2, "next");
        }
      }
      if (v.dynamicBullets) {
        const R = Math.min(M.length, v.dynamicMainBullets + 4),
          B = (a * R - a) / 2 - _ * a,
          H = f ? "right" : "left";
        M.forEach(Q => {
          Q.style[e.isHorizontal() ? H : "top"] = `${B}px`;
        });
      }
    }
    E.forEach((M, I) => {
      if (v.type === "fraction" && (M.querySelectorAll(classesToSelector(v.currentClass)).forEach(U => {
        U.textContent = v.formatFractionCurrent(b + 1);
      }), M.querySelectorAll(classesToSelector(v.totalClass)).forEach(U => {
        U.textContent = v.formatFractionTotal(O);
      })), v.type === "progressbar") {
        let U;
        v.progressbarOpposite ? U = e.isHorizontal() ? "vertical" : "horizontal" : U = e.isHorizontal() ? "horizontal" : "vertical";
        const _ = (b + 1) / O;
        let R = 1,
          B = 1;
        U === "horizontal" ? R = _ : B = _, M.querySelectorAll(classesToSelector(v.progressbarFillClass)).forEach(H => {
          H.style.transform = `translate3d(0,0,0) scaleX(${R}) scaleY(${B})`, H.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      v.type === "custom" && v.renderCustom ? (M.innerHTML = v.renderCustom(e, b + 1, O), I === 0 && i("paginationRender", M)) : (I === 0 && i("paginationRender", M), i("paginationUpdate", M)), e.params.watchOverflow && e.enabled && M.classList[e.isLocked ? "add" : "remove"](v.lockClass);
    });
  }
  o(update$1, "update");
  function render() {
    const f = e.params.pagination;
    if (isPaginationDisabled()) return;
    const v = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let E = e.pagination.el;
    E = makeElementsArray(E);
    let b = "";
    if (f.type === "bullets") {
      let P = e.params.loop ? Math.ceil(v / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && P > v && (P = v);
      for (let T = 0; T < P; T += 1) f.renderBullet ? b += f.renderBullet.call(e, T, f.bulletClass) : b += `<${f.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${f.bulletClass}"></${f.bulletElement}>`;
    }
    f.type === "fraction" && (f.renderFraction ? b = f.renderFraction.call(e, f.currentClass, f.totalClass) : b = `<span class="${f.currentClass}"></span> / <span class="${f.totalClass}"></span>`), f.type === "progressbar" && (f.renderProgressbar ? b = f.renderProgressbar.call(e, f.progressbarFillClass) : b = `<span class="${f.progressbarFillClass}"></span>`), e.pagination.bullets = [], E.forEach(P => {
      f.type !== "custom" && (P.innerHTML = b || ""), f.type === "bullets" && e.pagination.bullets.push(...P.querySelectorAll(classesToSelector(f.bulletClass)));
    }), f.type !== "custom" && i("paginationRender", E[0]);
  }
  o(render, "render");
  function init$2() {
    e.params.pagination = createElementIfNotDefined(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const f = e.params.pagination;
    if (!f.el) return;
    let v;
    typeof f.el == "string" && e.isElement && (v = e.el.querySelector(f.el)), !v && typeof f.el == "string" && (v = [...document.querySelectorAll(f.el)]), v || (v = f.el), !(!v || v.length === 0) && (e.params.uniqueNavElements && typeof f.el == "string" && Array.isArray(v) && v.length > 1 && (v = [...e.el.querySelectorAll(f.el)], v.length > 1 && (v = v.filter(E => elementParents(E, ".swiper")[0] === e.el)[0])), Array.isArray(v) && v.length === 1 && (v = v[0]), Object.assign(e.pagination, {
      el: v
    }), v = makeElementsArray(v), v.forEach(E => {
      f.type === "bullets" && f.clickable && E.classList.add(...(f.clickableClass || "").split(" ")), E.classList.add(f.modifierClass + f.type), E.classList.add(e.isHorizontal() ? f.horizontalClass : f.verticalClass), f.type === "bullets" && f.dynamicBullets && (E.classList.add(`${f.modifierClass}${f.type}-dynamic`), l = 0, f.dynamicMainBullets < 1 && (f.dynamicMainBullets = 1)), f.type === "progressbar" && f.progressbarOpposite && E.classList.add(f.progressbarOppositeClass), f.clickable && E.addEventListener("click", onBulletClick), e.enabled || E.classList.add(f.lockClass);
    }));
  }
  o(init$2, "init");
  function destroy$2() {
    const f = e.params.pagination;
    if (isPaginationDisabled()) return;
    let v = e.pagination.el;
    v && (v = makeElementsArray(v), v.forEach(E => {
      E.classList.remove(f.hiddenClass), E.classList.remove(f.modifierClass + f.type), E.classList.remove(e.isHorizontal() ? f.horizontalClass : f.verticalClass), f.clickable && (E.classList.remove(...(f.clickableClass || "").split(" ")), E.removeEventListener("click", onBulletClick));
    })), e.pagination.bullets && e.pagination.bullets.forEach(E => E.classList.remove(...f.bulletActiveClass.split(" ")));
  }
  o(destroy$2, "destroy"), r("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const f = e.params.pagination;
    let {
      el: v
    } = e.pagination;
    v = makeElementsArray(v), v.forEach(E => {
      E.classList.remove(f.horizontalClass, f.verticalClass), E.classList.add(e.isHorizontal() ? f.horizontalClass : f.verticalClass);
    });
  }), r("init", () => {
    e.params.pagination.enabled === !1 ? disable$2() : (init$2(), render(), update$1());
  }), r("activeIndexChange", () => {
    typeof e.snapIndex > "u" && update$1();
  }), r("snapIndexChange", () => {
    update$1();
  }), r("snapGridLengthChange", () => {
    render(), update$1();
  }), r("destroy", () => {
    destroy$2();
  }), r("enable disable", () => {
    let {
      el: f
    } = e.pagination;
    f && (f = makeElementsArray(f), f.forEach(v => v.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), r("lock unlock", () => {
    update$1();
  }), r("click", (f, v) => {
    const E = v.target,
      b = makeElementsArray(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && b && b.length > 0 && !E.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && E === e.navigation.nextEl || e.navigation.prevEl && E === e.navigation.prevEl)) return;
      const P = b[0].classList.contains(e.params.pagination.hiddenClass);
      i(P === !0 ? "paginationShow" : "paginationHide"), b.forEach(T => T.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const enable$2 = o(() => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass);
      let {
        el: f
      } = e.pagination;
      f && (f = makeElementsArray(f), f.forEach(v => v.classList.remove(e.params.pagination.paginationDisabledClass))), init$2(), render(), update$1();
    }, "enable"),
    disable$2 = o(() => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass);
      let {
        el: f
      } = e.pagination;
      f && (f = makeElementsArray(f), f.forEach(v => v.classList.add(e.params.pagination.paginationDisabledClass))), destroy$2();
    }, "disable");
  Object.assign(e.pagination, {
    enable: enable$2,
    disable: disable$2,
    render: render,
    update: update$1,
    init: init$2,
    destroy: destroy$2
  });
}
o(Pagination, "Pagination");
function Scrollbar(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r,
    emit: i
  } = t;
  const s = getDocument();
  let a = !1,
    l = null,
    u = null,
    c,
    p,
    m,
    d;
  n({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function setTranslate$2() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
        scrollbar: _,
        rtlTranslate: R
      } = e,
      {
        dragEl: B,
        el: H
      } = _,
      Q = e.params.scrollbar,
      te = e.params.loop ? e.progressLoop : e.progress;
    let j = p,
      X = (m - p) * te;
    R ? (X = -X, X > 0 ? (j = p - X, X = 0) : -X + p > m && (j = m + X)) : X < 0 ? (j = p + X, X = 0) : X + p > m && (j = m - X), e.isHorizontal() ? (B.style.transform = `translate3d(${X}px, 0, 0)`, B.style.width = `${j}px`) : (B.style.transform = `translate3d(0px, ${X}px, 0)`, B.style.height = `${j}px`), Q.hide && (clearTimeout(l), H.style.opacity = 1, l = setTimeout(() => {
      H.style.opacity = 0, H.style.transitionDuration = "400ms";
    }, 1e3));
  }
  o(setTranslate$2, "setTranslate");
  function setTransition$1(_) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${_}ms`);
  }
  o(setTransition$1, "setTransition");
  function updateSize$1() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
        scrollbar: _
      } = e,
      {
        dragEl: R,
        el: B
      } = _;
    R.style.width = "", R.style.height = "", m = e.isHorizontal() ? B.offsetWidth : B.offsetHeight, d = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? p = m * d : p = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? R.style.width = `${p}px` : R.style.height = `${p}px`, d >= 1 ? B.style.display = "none" : B.style.display = "", e.params.scrollbar.hide && (B.style.opacity = 0), e.params.watchOverflow && e.enabled && _.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  o(updateSize$1, "updateSize");
  function getPointerPosition(_) {
    return e.isHorizontal() ? _.clientX : _.clientY;
  }
  o(getPointerPosition, "getPointerPosition");
  function setDragPosition(_) {
    const {
        scrollbar: R,
        rtlTranslate: B
      } = e,
      {
        el: H
      } = R;
    let Q;
    Q = (getPointerPosition(_) - elementOffset(H)[e.isHorizontal() ? "left" : "top"] - (c !== null ? c : p / 2)) / (m - p), Q = Math.max(Math.min(Q, 1), 0), B && (Q = 1 - Q);
    const te = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * Q;
    e.updateProgress(te), e.setTranslate(te), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  o(setDragPosition, "setDragPosition");
  function onDragStart(_) {
    const R = e.params.scrollbar,
      {
        scrollbar: B,
        wrapperEl: H
      } = e,
      {
        el: Q,
        dragEl: te
      } = B;
    a = !0, c = _.target === te ? getPointerPosition(_) - _.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, _.preventDefault(), _.stopPropagation(), H.style.transitionDuration = "100ms", te.style.transitionDuration = "100ms", setDragPosition(_), clearTimeout(u), Q.style.transitionDuration = "0ms", R.hide && (Q.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), i("scrollbarDragStart", _);
  }
  o(onDragStart, "onDragStart");
  function onDragMove(_) {
    const {
        scrollbar: R,
        wrapperEl: B
      } = e,
      {
        el: H,
        dragEl: Q
      } = R;
    a && (_.preventDefault && _.cancelable ? _.preventDefault() : _.returnValue = !1, setDragPosition(_), B.style.transitionDuration = "0ms", H.style.transitionDuration = "0ms", Q.style.transitionDuration = "0ms", i("scrollbarDragMove", _));
  }
  o(onDragMove, "onDragMove");
  function onDragEnd(_) {
    const R = e.params.scrollbar,
      {
        scrollbar: B,
        wrapperEl: H
      } = e,
      {
        el: Q
      } = B;
    a && (a = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", H.style.transitionDuration = ""), R.hide && (clearTimeout(u), u = nextTick(() => {
      Q.style.opacity = 0, Q.style.transitionDuration = "400ms";
    }, 1e3)), i("scrollbarDragEnd", _), R.snapOnRelease && e.slideToClosest());
  }
  o(onDragEnd, "onDragEnd");
  function events$2(_) {
    const {
        scrollbar: R,
        params: B
      } = e,
      H = R.el;
    if (!H) return;
    const Q = H,
      te = B.passiveListeners ? {
        passive: !1,
        capture: !1
      } : !1,
      j = B.passiveListeners ? {
        passive: !0,
        capture: !1
      } : !1;
    if (!Q) return;
    const X = _ === "on" ? "addEventListener" : "removeEventListener";
    Q[X]("pointerdown", onDragStart, te), s[X]("pointermove", onDragMove, te), s[X]("pointerup", onDragEnd, j);
  }
  o(events$2, "events");
  function enableDraggable() {
    !e.params.scrollbar.el || !e.scrollbar.el || events$2("on");
  }
  o(enableDraggable, "enableDraggable");
  function disableDraggable() {
    !e.params.scrollbar.el || !e.scrollbar.el || events$2("off");
  }
  o(disableDraggable, "disableDraggable");
  function init$3() {
    const {
      scrollbar: _,
      el: R
    } = e;
    e.params.scrollbar = createElementIfNotDefined(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const B = e.params.scrollbar;
    if (!B.el) return;
    let H;
    if (typeof B.el == "string" && e.isElement && (H = e.el.querySelector(B.el)), !H && typeof B.el == "string") {
      if (H = s.querySelectorAll(B.el), !H.length) return;
    } else H || (H = B.el);
    e.params.uniqueNavElements && typeof B.el == "string" && H.length > 1 && R.querySelectorAll(B.el).length === 1 && (H = R.querySelector(B.el)), H.length > 0 && (H = H[0]), H.classList.add(e.isHorizontal() ? B.horizontalClass : B.verticalClass);
    let Q;
    H && (Q = H.querySelector(classesToSelector(e.params.scrollbar.dragClass)), Q || (Q = createElement("div", e.params.scrollbar.dragClass), H.append(Q))), Object.assign(_, {
      el: H,
      dragEl: Q
    }), B.draggable && enableDraggable(), H && H.classList[e.enabled ? "remove" : "add"](...classesToTokens(e.params.scrollbar.lockClass));
  }
  o(init$3, "init");
  function destroy$3() {
    const _ = e.params.scrollbar,
      R = e.scrollbar.el;
    R && R.classList.remove(...classesToTokens(e.isHorizontal() ? _.horizontalClass : _.verticalClass)), disableDraggable();
  }
  o(destroy$3, "destroy"), r("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el) return;
    const _ = e.params.scrollbar;
    let {
      el: R
    } = e.scrollbar;
    R = makeElementsArray(R), R.forEach(B => {
      B.classList.remove(_.horizontalClass, _.verticalClass), B.classList.add(e.isHorizontal() ? _.horizontalClass : _.verticalClass);
    });
  }), r("init", () => {
    e.params.scrollbar.enabled === !1 ? disable$3() : (init$3(), updateSize$1(), setTranslate$2());
  }), r("update resize observerUpdate lock unlock changeDirection", () => {
    updateSize$1();
  }), r("setTranslate", () => {
    setTranslate$2();
  }), r("setTransition", (_, R) => {
    setTransition$1(R);
  }), r("enable disable", () => {
    const {
      el: _
    } = e.scrollbar;
    _ && _.classList[e.enabled ? "remove" : "add"](...classesToTokens(e.params.scrollbar.lockClass));
  }), r("destroy", () => {
    destroy$3();
  });
  const enable$3 = o(() => {
      e.el.classList.remove(...classesToTokens(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...classesToTokens(e.params.scrollbar.scrollbarDisabledClass)), init$3(), updateSize$1(), setTranslate$2();
    }, "enable"),
    disable$3 = o(() => {
      e.el.classList.add(...classesToTokens(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...classesToTokens(e.params.scrollbar.scrollbarDisabledClass)), destroy$3();
    }, "disable");
  Object.assign(e.scrollbar, {
    enable: enable$3,
    disable: disable$3,
    updateSize: updateSize$1,
    setTranslate: setTranslate$2,
    init: init$3,
    destroy: destroy$3
  });
}
o(Scrollbar, "Scrollbar");
function Zoom(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r,
    emit: i
  } = t;
  const s = getWindow();
  n({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let a = 1,
    l = !1,
    u,
    c;
  const p = [],
    m = {
      originX: 0,
      originY: 0,
      slideEl: void 0,
      slideWidth: void 0,
      slideHeight: void 0,
      imageEl: void 0,
      imageWrapEl: void 0,
      maxRatio: 3
    },
    d = {
      isTouched: void 0,
      isMoved: void 0,
      currentX: void 0,
      currentY: void 0,
      minX: void 0,
      minY: void 0,
      maxX: void 0,
      maxY: void 0,
      width: void 0,
      height: void 0,
      startX: void 0,
      startY: void 0,
      touchesStart: {},
      touchesCurrent: {}
    },
    y = {
      x: void 0,
      y: void 0,
      prevPositionX: void 0,
      prevPositionY: void 0,
      prevTime: void 0
    };
  let S = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return S;
    },
    set(C) {
      if (S !== C) {
        const A = m.imageEl,
          L = m.slideEl;
        i("zoomChange", C, A, L);
      }
      S = C;
    }
  });
  function getDistanceBetweenTouches() {
    if (p.length < 2) return 1;
    const C = p[0].pageX,
      A = p[0].pageY,
      L = p[1].pageX,
      V = p[1].pageY;
    return Math.sqrt((L - C) ** 2 + (V - A) ** 2);
  }
  o(getDistanceBetweenTouches, "getDistanceBetweenTouches");
  function getMaxRatio() {
    const C = e.params.zoom,
      A = m.imageWrapEl.getAttribute("data-swiper-zoom") || C.maxRatio;
    if (C.limitToOriginalSize && m.imageEl && m.imageEl.naturalWidth) {
      const L = m.imageEl.naturalWidth / m.imageEl.offsetWidth;
      return Math.min(L, A);
    }
    return A;
  }
  o(getMaxRatio, "getMaxRatio");
  function getScaleOrigin() {
    if (p.length < 2) return {
      x: null,
      y: null
    };
    const C = m.imageEl.getBoundingClientRect();
    return [(p[0].pageX + (p[1].pageX - p[0].pageX) / 2 - C.x - s.scrollX) / a, (p[0].pageY + (p[1].pageY - p[0].pageY) / 2 - C.y - s.scrollY) / a];
  }
  o(getScaleOrigin, "getScaleOrigin");
  function getSlideSelector() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  o(getSlideSelector, "getSlideSelector");
  function eventWithinSlide(C) {
    const A = getSlideSelector();
    return !!(C.target.matches(A) || e.slides.filter(L => L.contains(C.target)).length > 0);
  }
  o(eventWithinSlide, "eventWithinSlide");
  function eventWithinZoomContainer(C) {
    const A = `.${e.params.zoom.containerClass}`;
    return !!(C.target.matches(A) || [...e.hostEl.querySelectorAll(A)].filter(L => L.contains(C.target)).length > 0);
  }
  o(eventWithinZoomContainer, "eventWithinZoomContainer");
  function onGestureStart(C) {
    if (C.pointerType === "mouse" && p.splice(0, p.length), !eventWithinSlide(C)) return;
    const A = e.params.zoom;
    if (u = !1, c = !1, p.push(C), !(p.length < 2)) {
      if (u = !0, m.scaleStart = getDistanceBetweenTouches(), !m.slideEl) {
        m.slideEl = C.target.closest(`.${e.params.slideClass}, swiper-slide`), m.slideEl || (m.slideEl = e.slides[e.activeIndex]);
        let L = m.slideEl.querySelector(`.${A.containerClass}`);
        if (L && (L = L.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), m.imageEl = L, L ? m.imageWrapEl = elementParents(m.imageEl, `.${A.containerClass}`)[0] : m.imageWrapEl = void 0, !m.imageWrapEl) {
          m.imageEl = void 0;
          return;
        }
        m.maxRatio = getMaxRatio();
      }
      if (m.imageEl) {
        const [L, V] = getScaleOrigin();
        m.originX = L, m.originY = V, m.imageEl.style.transitionDuration = "0ms";
      }
      l = !0;
    }
  }
  o(onGestureStart, "onGestureStart");
  function onGestureChange(C) {
    if (!eventWithinSlide(C)) return;
    const A = e.params.zoom,
      L = e.zoom,
      V = p.findIndex(Y => Y.pointerId === C.pointerId);
    V >= 0 && (p[V] = C), !(p.length < 2) && (c = !0, m.scaleMove = getDistanceBetweenTouches(), m.imageEl && (L.scale = m.scaleMove / m.scaleStart * a, L.scale > m.maxRatio && (L.scale = m.maxRatio - 1 + (L.scale - m.maxRatio + 1) ** .5), L.scale < A.minRatio && (L.scale = A.minRatio + 1 - (A.minRatio - L.scale + 1) ** .5), m.imageEl.style.transform = `translate3d(0,0,0) scale(${L.scale})`));
  }
  o(onGestureChange, "onGestureChange");
  function onGestureEnd(C) {
    if (!eventWithinSlide(C) || C.pointerType === "mouse" && C.type === "pointerout") return;
    const A = e.params.zoom,
      L = e.zoom,
      V = p.findIndex(Y => Y.pointerId === C.pointerId);
    V >= 0 && p.splice(V, 1), !(!u || !c) && (u = !1, c = !1, m.imageEl && (L.scale = Math.max(Math.min(L.scale, m.maxRatio), A.minRatio), m.imageEl.style.transitionDuration = `${e.params.speed}ms`, m.imageEl.style.transform = `translate3d(0,0,0) scale(${L.scale})`, a = L.scale, l = !1, L.scale > 1 && m.slideEl ? m.slideEl.classList.add(`${A.zoomedSlideClass}`) : L.scale <= 1 && m.slideEl && m.slideEl.classList.remove(`${A.zoomedSlideClass}`), L.scale === 1 && (m.originX = 0, m.originY = 0, m.slideEl = void 0)));
  }
  o(onGestureEnd, "onGestureEnd");
  let O;
  function allowTouchMove() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  o(allowTouchMove, "allowTouchMove");
  function preventTouchMove() {
    clearTimeout(O), e.touchEventsData.preventTouchMoveFromPointerMove = !0, O = setTimeout(() => {
      e.destroyed || allowTouchMove();
    });
  }
  o(preventTouchMove, "preventTouchMove");
  function onTouchStart$1(C) {
    const A = e.device;
    if (!m.imageEl || d.isTouched) return;
    A.android && C.cancelable && C.preventDefault(), d.isTouched = !0;
    const L = p.length > 0 ? p[0] : C;
    d.touchesStart.x = L.pageX, d.touchesStart.y = L.pageY;
  }
  o(onTouchStart$1, "onTouchStart");
  function onTouchMove$1(C) {
    if (!eventWithinSlide(C) || !eventWithinZoomContainer(C)) return;
    const A = e.zoom;
    if (!m.imageEl || !d.isTouched || !m.slideEl) return;
    d.isMoved || (d.width = m.imageEl.offsetWidth || m.imageEl.clientWidth, d.height = m.imageEl.offsetHeight || m.imageEl.clientHeight, d.startX = getTranslate(m.imageWrapEl, "x") || 0, d.startY = getTranslate(m.imageWrapEl, "y") || 0, m.slideWidth = m.slideEl.offsetWidth, m.slideHeight = m.slideEl.offsetHeight, m.imageWrapEl.style.transitionDuration = "0ms");
    const L = d.width * A.scale,
      V = d.height * A.scale;
    if (d.minX = Math.min(m.slideWidth / 2 - L / 2, 0), d.maxX = -d.minX, d.minY = Math.min(m.slideHeight / 2 - V / 2, 0), d.maxY = -d.minY, d.touchesCurrent.x = p.length > 0 ? p[0].pageX : C.pageX, d.touchesCurrent.y = p.length > 0 ? p[0].pageY : C.pageY, Math.max(Math.abs(d.touchesCurrent.x - d.touchesStart.x), Math.abs(d.touchesCurrent.y - d.touchesStart.y)) > 5 && (e.allowClick = !1), !d.isMoved && !l) {
      if (e.isHorizontal() && (Math.floor(d.minX) === Math.floor(d.startX) && d.touchesCurrent.x < d.touchesStart.x || Math.floor(d.maxX) === Math.floor(d.startX) && d.touchesCurrent.x > d.touchesStart.x)) {
        d.isTouched = !1, allowTouchMove();
        return;
      }
      if (!e.isHorizontal() && (Math.floor(d.minY) === Math.floor(d.startY) && d.touchesCurrent.y < d.touchesStart.y || Math.floor(d.maxY) === Math.floor(d.startY) && d.touchesCurrent.y > d.touchesStart.y)) {
        d.isTouched = !1, allowTouchMove();
        return;
      }
    }
    C.cancelable && C.preventDefault(), C.stopPropagation(), preventTouchMove(), d.isMoved = !0;
    const re = (A.scale - a) / (m.maxRatio - e.params.zoom.minRatio),
      {
        originX: ae,
        originY: le
      } = m;
    d.currentX = d.touchesCurrent.x - d.touchesStart.x + d.startX + re * (d.width - ae * 2), d.currentY = d.touchesCurrent.y - d.touchesStart.y + d.startY + re * (d.height - le * 2), d.currentX < d.minX && (d.currentX = d.minX + 1 - (d.minX - d.currentX + 1) ** .8), d.currentX > d.maxX && (d.currentX = d.maxX - 1 + (d.currentX - d.maxX + 1) ** .8), d.currentY < d.minY && (d.currentY = d.minY + 1 - (d.minY - d.currentY + 1) ** .8), d.currentY > d.maxY && (d.currentY = d.maxY - 1 + (d.currentY - d.maxY + 1) ** .8), y.prevPositionX || (y.prevPositionX = d.touchesCurrent.x), y.prevPositionY || (y.prevPositionY = d.touchesCurrent.y), y.prevTime || (y.prevTime = Date.now()), y.x = (d.touchesCurrent.x - y.prevPositionX) / (Date.now() - y.prevTime) / 2, y.y = (d.touchesCurrent.y - y.prevPositionY) / (Date.now() - y.prevTime) / 2, Math.abs(d.touchesCurrent.x - y.prevPositionX) < 2 && (y.x = 0), Math.abs(d.touchesCurrent.y - y.prevPositionY) < 2 && (y.y = 0), y.prevPositionX = d.touchesCurrent.x, y.prevPositionY = d.touchesCurrent.y, y.prevTime = Date.now(), m.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`;
  }
  o(onTouchMove$1, "onTouchMove");
  function onTouchEnd$1() {
    const C = e.zoom;
    if (!m.imageEl) return;
    if (!d.isTouched || !d.isMoved) {
      d.isTouched = !1, d.isMoved = !1;
      return;
    }
    d.isTouched = !1, d.isMoved = !1;
    let A = 300,
      L = 300;
    const V = y.x * A,
      Y = d.currentX + V,
      re = y.y * L,
      ae = d.currentY + re;
    y.x !== 0 && (A = Math.abs((Y - d.currentX) / y.x)), y.y !== 0 && (L = Math.abs((ae - d.currentY) / y.y));
    const le = Math.max(A, L);
    d.currentX = Y, d.currentY = ae;
    const ce = d.width * C.scale,
      W = d.height * C.scale;
    d.minX = Math.min(m.slideWidth / 2 - ce / 2, 0), d.maxX = -d.minX, d.minY = Math.min(m.slideHeight / 2 - W / 2, 0), d.maxY = -d.minY, d.currentX = Math.max(Math.min(d.currentX, d.maxX), d.minX), d.currentY = Math.max(Math.min(d.currentY, d.maxY), d.minY), m.imageWrapEl.style.transitionDuration = `${le}ms`, m.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`;
  }
  o(onTouchEnd$1, "onTouchEnd");
  function onTransitionEnd() {
    const C = e.zoom;
    m.slideEl && e.activeIndex !== e.slides.indexOf(m.slideEl) && (m.imageEl && (m.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), m.imageWrapEl && (m.imageWrapEl.style.transform = "translate3d(0,0,0)"), m.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), C.scale = 1, a = 1, m.slideEl = void 0, m.imageEl = void 0, m.imageWrapEl = void 0, m.originX = 0, m.originY = 0);
  }
  o(onTransitionEnd, "onTransitionEnd");
  function zoomIn(C) {
    const A = e.zoom,
      L = e.params.zoom;
    if (!m.slideEl) {
      C && C.target && (m.slideEl = C.target.closest(`.${e.params.slideClass}, swiper-slide`)), m.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? m.slideEl = elementChildren(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : m.slideEl = e.slides[e.activeIndex]);
      let Gt = m.slideEl.querySelector(`.${L.containerClass}`);
      Gt && (Gt = Gt.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), m.imageEl = Gt, Gt ? m.imageWrapEl = elementParents(m.imageEl, `.${L.containerClass}`)[0] : m.imageWrapEl = void 0;
    }
    if (!m.imageEl || !m.imageWrapEl) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), m.slideEl.classList.add(`${L.zoomedSlideClass}`);
    let V, Y, re, ae, le, ce, W, ie, de, fe, ge, we, ke, He, qt, Vt, Wt, pn;
    typeof d.touchesStart.x > "u" && C ? (V = C.pageX, Y = C.pageY) : (V = d.touchesStart.x, Y = d.touchesStart.y);
    const Rt = typeof C == "number" ? C : null;
    a === 1 && Rt && (V = void 0, Y = void 0, d.touchesStart.x = void 0, d.touchesStart.y = void 0);
    const Ie = getMaxRatio();
    A.scale = Rt || Ie, a = Rt || Ie, C && !(a === 1 && Rt) ? (Wt = m.slideEl.offsetWidth, pn = m.slideEl.offsetHeight, re = elementOffset(m.slideEl).left + s.scrollX, ae = elementOffset(m.slideEl).top + s.scrollY, le = re + Wt / 2 - V, ce = ae + pn / 2 - Y, de = m.imageEl.offsetWidth || m.imageEl.clientWidth, fe = m.imageEl.offsetHeight || m.imageEl.clientHeight, ge = de * A.scale, we = fe * A.scale, ke = Math.min(Wt / 2 - ge / 2, 0), He = Math.min(pn / 2 - we / 2, 0), qt = -ke, Vt = -He, W = le * A.scale, ie = ce * A.scale, W < ke && (W = ke), W > qt && (W = qt), ie < He && (ie = He), ie > Vt && (ie = Vt)) : (W = 0, ie = 0), Rt && A.scale === 1 && (m.originX = 0, m.originY = 0), m.imageWrapEl.style.transitionDuration = "300ms", m.imageWrapEl.style.transform = `translate3d(${W}px, ${ie}px,0)`, m.imageEl.style.transitionDuration = "300ms", m.imageEl.style.transform = `translate3d(0,0,0) scale(${A.scale})`;
  }
  o(zoomIn, "zoomIn");
  function zoomOut() {
    const C = e.zoom,
      A = e.params.zoom;
    if (!m.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? m.slideEl = elementChildren(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : m.slideEl = e.slides[e.activeIndex];
      let L = m.slideEl.querySelector(`.${A.containerClass}`);
      L && (L = L.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), m.imageEl = L, L ? m.imageWrapEl = elementParents(m.imageEl, `.${A.containerClass}`)[0] : m.imageWrapEl = void 0;
    }
    !m.imageEl || !m.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), C.scale = 1, a = 1, d.touchesStart.x = void 0, d.touchesStart.y = void 0, m.imageWrapEl.style.transitionDuration = "300ms", m.imageWrapEl.style.transform = "translate3d(0,0,0)", m.imageEl.style.transitionDuration = "300ms", m.imageEl.style.transform = "translate3d(0,0,0) scale(1)", m.slideEl.classList.remove(`${A.zoomedSlideClass}`), m.slideEl = void 0, m.originX = 0, m.originY = 0);
  }
  o(zoomOut, "zoomOut");
  function zoomToggle(C) {
    const A = e.zoom;
    A.scale && A.scale !== 1 ? zoomOut() : zoomIn(C);
  }
  o(zoomToggle, "zoomToggle");
  function getListeners() {
    const C = e.params.passiveListeners ? {
        passive: !0,
        capture: !1
      } : !1,
      A = e.params.passiveListeners ? {
        passive: !1,
        capture: !0
      } : !0;
    return {
      passiveListener: C,
      activeListenerWithCapture: A
    };
  }
  o(getListeners, "getListeners");
  function enable$4() {
    const C = e.zoom;
    if (C.enabled) return;
    C.enabled = !0;
    const {
      passiveListener: A,
      activeListenerWithCapture: L
    } = getListeners();
    e.wrapperEl.addEventListener("pointerdown", onGestureStart, A), e.wrapperEl.addEventListener("pointermove", onGestureChange, L), ["pointerup", "pointercancel", "pointerout"].forEach(V => {
      e.wrapperEl.addEventListener(V, onGestureEnd, A);
    }), e.wrapperEl.addEventListener("pointermove", onTouchMove$1, L);
  }
  o(enable$4, "enable");
  function disable$4() {
    const C = e.zoom;
    if (!C.enabled) return;
    C.enabled = !1;
    const {
      passiveListener: A,
      activeListenerWithCapture: L
    } = getListeners();
    e.wrapperEl.removeEventListener("pointerdown", onGestureStart, A), e.wrapperEl.removeEventListener("pointermove", onGestureChange, L), ["pointerup", "pointercancel", "pointerout"].forEach(V => {
      e.wrapperEl.removeEventListener(V, onGestureEnd, A);
    }), e.wrapperEl.removeEventListener("pointermove", onTouchMove$1, L);
  }
  o(disable$4, "disable"), r("init", () => {
    e.params.zoom.enabled && enable$4();
  }), r("destroy", () => {
    disable$4();
  }), r("touchStart", (C, A) => {
    e.zoom.enabled && onTouchStart$1(A);
  }), r("touchEnd", (C, A) => {
    e.zoom.enabled && onTouchEnd$1();
  }), r("doubleTap", (C, A) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && zoomToggle(A);
  }), r("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && onTransitionEnd();
  }), r("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && onTransitionEnd();
  }), Object.assign(e.zoom, {
    enable: enable$4,
    disable: disable$4,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}
o(Zoom, "Zoom");
function Controller(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r
  } = t;
  n({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
    }
  }), e.controller = {
    control: void 0
  };
  function LinearSpline(c, p) {
    const m = o(function () {
      let w, g, h;
      return (f, v) => {
        for (g = -1, w = f.length; w - g > 1;) h = w + g >> 1, f[h] <= v ? g = h : w = h;
        return w;
      };
    }, "search")();
    this.x = c, this.y = p, this.lastIndex = c.length - 1;
    let d, y;
    return this.interpolate = o(function (w) {
      return w ? (y = m(this.x, w), d = y - 1, (w - this.x[d]) * (this.y[y] - this.y[d]) / (this.x[y] - this.x[d]) + this.y[d]) : 0;
    }, "interpolate"), this;
  }
  o(LinearSpline, "LinearSpline");
  function getInterpolateFunction(c) {
    e.controller.spline = e.params.loop ? new LinearSpline(e.slidesGrid, c.slidesGrid) : new LinearSpline(e.snapGrid, c.snapGrid);
  }
  o(getInterpolateFunction, "getInterpolateFunction");
  function setTranslate$3(c, p) {
    const m = e.controller.control;
    let d, y;
    const S = e.constructor;
    function setControlledTranslate(g) {
      if (g.destroyed) return;
      const h = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (getInterpolateFunction(g), y = -e.controller.spline.interpolate(-h)), (!y || e.params.controller.by === "container") && (d = (g.maxTranslate() - g.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(d) || !Number.isFinite(d)) && (d = 1), y = (h - e.minTranslate()) * d + g.minTranslate()), e.params.controller.inverse && (y = g.maxTranslate() - y), g.updateProgress(y), g.setTranslate(y, e), g.updateActiveIndex(), g.updateSlidesClasses();
    }
    if (o(setControlledTranslate, "setControlledTranslate"), Array.isArray(m)) for (let g = 0; g < m.length; g += 1) m[g] !== p && m[g] instanceof S && setControlledTranslate(m[g]);else m instanceof S && p !== m && setControlledTranslate(m);
  }
  o(setTranslate$3, "setTranslate");
  function setTransition$2(c, p) {
    const m = e.constructor,
      d = e.controller.control;
    let y;
    function setControlledTransition(w) {
      w.destroyed || (w.setTransition(c, e), c !== 0 && (w.transitionStart(), w.params.autoHeight && nextTick(() => {
        w.updateAutoHeight();
      }), elementTransitionEnd(w.wrapperEl, () => {
        d && w.transitionEnd();
      })));
    }
    if (o(setControlledTransition, "setControlledTransition"), Array.isArray(d)) for (y = 0; y < d.length; y += 1) d[y] !== p && d[y] instanceof m && setControlledTransition(d[y]);else d instanceof m && p !== d && setControlledTransition(d);
  }
  o(setTransition$2, "setTransition");
  function removeSpline() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  o(removeSpline, "removeSpline"), r("beforeInit", () => {
    if (typeof window < "u" && (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach(p => {
        if (e.controller.control || (e.controller.control = []), p && p.swiper) e.controller.control.push(p.swiper);else if (p) {
          const m = `${e.params.eventsPrefix}init`,
            onControllerSwiper = o(y => {
              e.controller.control.push(y.detail[0]), e.update(), p.removeEventListener(m, onControllerSwiper);
            }, "onControllerSwiper");
          p.addEventListener(m, onControllerSwiper);
        }
      });
      return;
    }
    e.controller.control = e.params.controller.control;
  }), r("update", () => {
    removeSpline();
  }), r("resize", () => {
    removeSpline();
  }), r("observerUpdate", () => {
    removeSpline();
  }), r("setTranslate", (c, p, m) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(p, m);
  }), r("setTransition", (c, p, m) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(p, m);
  }), Object.assign(e.controller, {
    setTranslate: setTranslate$3,
    setTransition: setTransition$2
  });
}
o(Controller, "Controller");
function HashNavigation(t) {
  let {
      swiper: e,
      extendParams: n,
      emit: r,
      on: i
    } = t,
    s = !1;
  const a = getDocument(),
    l = getWindow();
  n({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(d, y) {
        if (e.virtual && e.params.virtual.enabled) {
          const S = e.slides.filter(g => g.getAttribute("data-hash") === y)[0];
          return S ? parseInt(S.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return e.getSlideIndex(elementChildren(e.slidesEl, `.${e.params.slideClass}[data-hash="${y}"], swiper-slide[data-hash="${y}"]`)[0]);
      }
    }
  });
  const onHashChange = o(() => {
      r("hashChange");
      const d = a.location.hash.replace("#", ""),
        y = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex],
        S = y ? y.getAttribute("data-hash") : "";
      if (d !== S) {
        const w = e.params.hashNavigation.getSlideIndex(e, d);
        if (typeof w > "u" || Number.isNaN(w)) return;
        e.slideTo(w);
      }
    }, "onHashChange"),
    setHash = o(() => {
      if (!s || !e.params.hashNavigation.enabled) return;
      const d = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex],
        y = d ? d.getAttribute("data-hash") || d.getAttribute("data-history") : "";
      e.params.hashNavigation.replaceState && l.history && l.history.replaceState ? (l.history.replaceState(null, null, `#${y}` || ""), r("hashSet")) : (a.location.hash = y || "", r("hashSet"));
    }, "setHash"),
    init$4 = o(() => {
      if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
      s = !0;
      const d = a.location.hash.replace("#", "");
      if (d) {
        const S = e.params.hashNavigation.getSlideIndex(e, d);
        e.slideTo(S || 0, 0, e.params.runCallbacksOnInit, !0);
      }
      e.params.hashNavigation.watchState && l.addEventListener("hashchange", onHashChange);
    }, "init"),
    destroy$4 = o(() => {
      e.params.hashNavigation.watchState && l.removeEventListener("hashchange", onHashChange);
    }, "destroy");
  i("init", () => {
    e.params.hashNavigation.enabled && init$4();
  }), i("destroy", () => {
    e.params.hashNavigation.enabled && destroy$4();
  }), i("transitionEnd _freeModeNoMomentumRelease", () => {
    s && setHash();
  }), i("slideChange", () => {
    s && e.params.cssMode && setHash();
  });
}
o(HashNavigation, "HashNavigation");
function Autoplay(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r,
    emit: i,
    params: s
  } = t;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, n({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let a,
    l,
    u = s && s.autoplay ? s.autoplay.delay : 3e3,
    c = s && s.autoplay ? s.autoplay.delay : 3e3,
    p,
    m = new Date().getTime(),
    d,
    y,
    S,
    w,
    g,
    h,
    f;
  function onTransitionEnd$1(j) {
    !e || e.destroyed || !e.wrapperEl || j.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", onTransitionEnd$1), !(f || j.detail && j.detail.bySwiperTouchMove) && resume());
  }
  o(onTransitionEnd$1, "onTransitionEnd");
  const calcTimeLeft = o(() => {
      if (e.destroyed || !e.autoplay.running) return;
      e.autoplay.paused ? d = !0 : d && (c = p, d = !1);
      const j = e.autoplay.paused ? p : m + c - new Date().getTime();
      e.autoplay.timeLeft = j, i("autoplayTimeLeft", j, j / u), l = requestAnimationFrame(() => {
        calcTimeLeft();
      });
    }, "calcTimeLeft"),
    getSlideDelay = o(() => {
      let j;
      return e.virtual && e.params.virtual.enabled ? j = e.slides.filter(q => q.classList.contains("swiper-slide-active"))[0] : j = e.slides[e.activeIndex], j ? parseInt(j.getAttribute("data-swiper-autoplay"), 10) : void 0;
    }, "getSlideDelay"),
    run = o(j => {
      if (e.destroyed || !e.autoplay.running) return;
      cancelAnimationFrame(l), calcTimeLeft();
      let X = typeof j > "u" ? e.params.autoplay.delay : j;
      u = e.params.autoplay.delay, c = e.params.autoplay.delay;
      const q = getSlideDelay();
      !Number.isNaN(q) && q > 0 && typeof j > "u" && (X = q, u = q, c = q), p = X;
      const C = e.params.speed,
        proceed = o(() => {
          !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(C, !0, !0), i("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, C, !0, !0), i("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(C, !0, !0), i("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, C, !0, !0), i("autoplay")), e.params.cssMode && (m = new Date().getTime(), requestAnimationFrame(() => {
            run();
          })));
        }, "proceed");
      return X > 0 ? (clearTimeout(a), a = setTimeout(() => {
        proceed();
      }, X)) : requestAnimationFrame(() => {
        proceed();
      }), X;
    }, "run"),
    start = o(() => {
      m = new Date().getTime(), e.autoplay.running = !0, run(), i("autoplayStart");
    }, "start"),
    stop = o(() => {
      e.autoplay.running = !1, clearTimeout(a), cancelAnimationFrame(l), i("autoplayStop");
    }, "stop"),
    pause = o((j, X) => {
      if (e.destroyed || !e.autoplay.running) return;
      clearTimeout(a), j || (h = !0);
      const proceed$1 = o(() => {
        i("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", onTransitionEnd$1) : resume();
      }, "proceed");
      if (e.autoplay.paused = !0, X) {
        g && (p = e.params.autoplay.delay), g = !1, proceed$1();
        return;
      }
      p = (p || e.params.autoplay.delay) - (new Date().getTime() - m), !(e.isEnd && p < 0 && !e.params.loop) && (p < 0 && (p = 0), proceed$1());
    }, "pause"),
    resume = o(() => {
      e.isEnd && p < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (m = new Date().getTime(), h ? (h = !1, run(p)) : run(), e.autoplay.paused = !1, i("autoplayResume"));
    }, "resume"),
    onVisibilityChange = o(() => {
      if (e.destroyed || !e.autoplay.running) return;
      const j = getDocument();
      j.visibilityState === "hidden" && (h = !0, pause(!0)), j.visibilityState === "visible" && resume();
    }, "onVisibilityChange"),
    onPointerEnter = o(j => {
      j.pointerType === "mouse" && (h = !0, f = !0, !(e.animating || e.autoplay.paused) && pause(!0));
    }, "onPointerEnter"),
    onPointerLeave = o(j => {
      j.pointerType === "mouse" && (f = !1, e.autoplay.paused && resume());
    }, "onPointerLeave"),
    attachMouseEvents = o(() => {
      e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", onPointerEnter), e.el.addEventListener("pointerleave", onPointerLeave));
    }, "attachMouseEvents"),
    detachMouseEvents = o(() => {
      e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", onPointerEnter), e.el.removeEventListener("pointerleave", onPointerLeave));
    }, "detachMouseEvents"),
    attachDocumentEvents = o(() => {
      getDocument().addEventListener("visibilitychange", onVisibilityChange);
    }, "attachDocumentEvents"),
    detachDocumentEvents = o(() => {
      getDocument().removeEventListener("visibilitychange", onVisibilityChange);
    }, "detachDocumentEvents");
  r("init", () => {
    e.params.autoplay.enabled && (attachMouseEvents(), attachDocumentEvents(), start());
  }), r("destroy", () => {
    detachMouseEvents(), detachDocumentEvents(), e.autoplay.running && stop();
  }), r("_freeModeStaticRelease", () => {
    (S || h) && resume();
  }), r("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? stop() : pause(!0, !0);
  }), r("beforeTransitionStart", (j, X, q) => {
    e.destroyed || !e.autoplay.running || (q || !e.params.autoplay.disableOnInteraction ? pause(!0, !0) : stop());
  }), r("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        stop();
        return;
      }
      y = !0, S = !1, h = !1, w = setTimeout(() => {
        h = !0, S = !0, pause(!0);
      }, 200);
    }
  }), r("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !y)) {
      if (clearTimeout(w), clearTimeout(a), e.params.autoplay.disableOnInteraction) {
        S = !1, y = !1;
        return;
      }
      S && e.params.cssMode && resume(), S = !1, y = !1;
    }
  }), r("slideChange", () => {
    e.destroyed || !e.autoplay.running || (g = !0);
  }), Object.assign(e.autoplay, {
    start: start,
    stop: stop,
    pause: pause,
    resume: resume
  });
}
o(Autoplay, "Autoplay");
function Thumb(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r
  } = t;
  n({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let i = !1,
    s = !1;
  e.thumbs = {
    swiper: null
  };
  function onThumbClick() {
    const c = e.thumbs.swiper;
    if (!c || c.destroyed) return;
    const p = c.clickedIndex,
      m = c.clickedSlide;
    if (m && m.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof p > "u" || p === null) return;
    let d;
    c.params.loop ? d = parseInt(c.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : d = p, e.params.loop ? e.slideToLoop(d) : e.slideTo(d);
  }
  o(onThumbClick, "onThumbClick");
  function init$5() {
    const {
      thumbs: c
    } = e.params;
    if (i) return !1;
    i = !0;
    const p = e.constructor;
    if (c.swiper instanceof p) e.thumbs.swiper = c.swiper, Object.assign(e.thumbs.swiper.originalParams, {
      watchSlidesProgress: !0,
      slideToClickedSlide: !1
    }), Object.assign(e.thumbs.swiper.params, {
      watchSlidesProgress: !0,
      slideToClickedSlide: !1
    }), e.thumbs.swiper.update();else if (isObject$4(c.swiper)) {
      const m = Object.assign({}, c.swiper);
      Object.assign(m, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new p(m), s = !0;
    }
    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", onThumbClick), !0;
  }
  o(init$5, "init");
  function update$2(c) {
    const p = e.thumbs.swiper;
    if (!p || p.destroyed) return;
    const m = p.params.slidesPerView === "auto" ? p.slidesPerViewDynamic() : p.params.slidesPerView;
    let d = 1;
    const y = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (d = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (d = 1), d = Math.floor(d), p.slides.forEach(g => g.classList.remove(y)), p.params.loop || p.params.virtual && p.params.virtual.enabled) for (let g = 0; g < d; g += 1) elementChildren(p.slidesEl, `[data-swiper-slide-index="${e.realIndex + g}"]`).forEach(h => {
      h.classList.add(y);
    });else for (let g = 0; g < d; g += 1) p.slides[e.realIndex + g] && p.slides[e.realIndex + g].classList.add(y);
    const S = e.params.thumbs.autoScrollOffset,
      w = S && !p.params.loop;
    if (e.realIndex !== p.realIndex || w) {
      const g = p.activeIndex;
      let h, f;
      if (p.params.loop) {
        const v = p.slides.filter(E => E.getAttribute("data-swiper-slide-index") === `${e.realIndex}`)[0];
        h = p.slides.indexOf(v), f = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else h = e.realIndex, f = h > e.previousIndex ? "next" : "prev";
      w && (h += f === "next" ? S : -1 * S), p.visibleSlidesIndexes && p.visibleSlidesIndexes.indexOf(h) < 0 && (p.params.centeredSlides ? h > g ? h = h - Math.floor(m / 2) + 1 : h = h + Math.floor(m / 2) - 1 : h > g && p.params.slidesPerGroup, p.slideTo(h, c ? 0 : void 0));
    }
  }
  o(update$2, "update"), r("beforeInit", () => {
    const {
      thumbs: c
    } = e.params;
    if (!(!c || !c.swiper)) if (typeof c.swiper == "string" || c.swiper instanceof HTMLElement) {
      const p = getDocument(),
        getThumbsElementAndInit = o(() => {
          const y = typeof c.swiper == "string" ? p.querySelector(c.swiper) : c.swiper;
          if (y && y.swiper) c.swiper = y.swiper, init$5(), update$2(!0);else if (y) {
            const S = `${e.params.eventsPrefix}init`,
              onThumbsSwiper = o(g => {
                c.swiper = g.detail[0], y.removeEventListener(S, onThumbsSwiper), init$5(), update$2(!0), c.swiper.update(), e.update();
              }, "onThumbsSwiper");
            y.addEventListener(S, onThumbsSwiper);
          }
          return y;
        }, "getThumbsElementAndInit"),
        watchForThumbsToAppear = o(() => {
          if (e.destroyed) return;
          getThumbsElementAndInit() || requestAnimationFrame(watchForThumbsToAppear);
        }, "watchForThumbsToAppear");
      requestAnimationFrame(watchForThumbsToAppear);
    } else init$5(), update$2(!0);
  }), r("slideChange update resize observerUpdate", () => {
    update$2();
  }), r("setTransition", (c, p) => {
    const m = e.thumbs.swiper;
    !m || m.destroyed || m.setTransition(p);
  }), r("beforeDestroy", () => {
    const c = e.thumbs.swiper;
    !c || c.destroyed || s && c.destroy();
  }), Object.assign(e.thumbs, {
    init: init$5,
    update: update$2
  });
}
o(Thumb, "Thumb");
function effectInit(t) {
  const {
    effect: e,
    swiper: n,
    on: r,
    setTranslate: i,
    setTransition: s,
    overwriteParams: a,
    perspective: l,
    recreateShadows: u,
    getEffectParams: c
  } = t;
  r("beforeInit", () => {
    if (n.params.effect !== e) return;
    n.classNames.push(`${n.params.containerModifierClass}${e}`), l && l() && n.classNames.push(`${n.params.containerModifierClass}3d`);
    const m = a ? a() : {};
    Object.assign(n.params, m), Object.assign(n.originalParams, m);
  }), r("setTranslate", () => {
    n.params.effect === e && i();
  }), r("setTransition", (m, d) => {
    n.params.effect === e && s(d);
  }), r("transitionEnd", () => {
    if (n.params.effect === e && u) {
      if (!c || !c().slideShadows) return;
      n.slides.forEach(m => {
        m.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(d => d.remove());
      }), u();
    }
  });
  let p;
  r("virtualUpdate", () => {
    n.params.effect === e && (n.slides.length || (p = !0), requestAnimationFrame(() => {
      p && n.slides && n.slides.length && (i(), p = !1);
    }));
  });
}
o(effectInit, "effectInit");
function effectTarget(t, e) {
  const n = getSlideTransformEl(e);
  return n !== e && (n.style.backfaceVisibility = "hidden", n.style["-webkit-backface-visibility"] = "hidden"), n;
}
o(effectTarget, "effectTarget");
function effectVirtualTransitionEnd(t) {
  let {
    swiper: e,
    duration: n,
    transformElements: r,
    allSlides: i
  } = t;
  const {
      activeIndex: s
    } = e,
    getSlide = o(l => l.parentElement ? l.parentElement : e.slides.filter(c => c.shadowRoot && c.shadowRoot === l.parentNode)[0], "getSlide");
  if (e.params.virtualTranslate && n !== 0) {
    let l = !1,
      u;
    i ? u = r : u = r.filter(c => {
      const p = c.classList.contains("swiper-slide-transform") ? getSlide(c) : c;
      return e.getSlideIndex(p) === s;
    }), u.forEach(c => {
      elementTransitionEnd(c, () => {
        if (l || !e || e.destroyed) return;
        l = !0, e.animating = !1;
        const p = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(p);
      });
    });
  }
}
o(effectVirtualTransitionEnd, "effectVirtualTransitionEnd");
function EffectFade(t) {
  let {
    swiper: e,
    extendParams: n,
    on: r
  } = t;
  n({
    fadeEffect: {
      crossFade: !1
    }
  }), effectInit({
    effect: "fade",
    swiper: e,
    on: r,
    setTranslate: o(() => {
      const {
          slides: a
        } = e,
        l = e.params.fadeEffect;
      for (let u = 0; u < a.length; u += 1) {
        const c = e.slides[u];
        let m = -c.swiperSlideOffset;
        e.params.virtualTranslate || (m -= e.translate);
        let d = 0;
        e.isHorizontal() || (d = m, m = 0);
        const y = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(c.progress), 0) : 1 + Math.min(Math.max(c.progress, -1), 0),
          S = effectTarget(l, c);
        S.style.opacity = y, S.style.transform = `translate3d(${m}px, ${d}px, 0px)`;
      }
    }, "setTranslate"),
    setTransition: o(a => {
      const l = e.slides.map(u => getSlideTransformEl(u));
      l.forEach(u => {
        u.style.transitionDuration = `${a}ms`;
      }), effectVirtualTransitionEnd({
        swiper: e,
        duration: a,
        transformElements: l,
        allSlides: !0
      });
    }, "setTransition"),
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
o(EffectFade, "EffectFade");
function noop$1() {}
o(noop$1, "noop$1");
const identity = o(t => t, "identity");
function assign(t, e) {
  for (const n in e) t[n] = e[n];
  return t;
}
o(assign, "assign");
function run$1(t) {
  return t();
}
o(run$1, "run");
function run_all(t) {
  t.forEach(run$1);
}
o(run_all, "run_all");
function is_function(t) {
  return typeof t == "function";
}
o(is_function, "is_function");
function not_equal(t, e) {
  return t != t ? e == e : t !== e;
}
o(not_equal, "not_equal");
function is_empty(t) {
  return Object.keys(t).length === 0;
}
o(is_empty, "is_empty");
function subscribe(t, ...e) {
  if (t == null) return noop$1;
  const n = t.subscribe(...e);
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
o(subscribe, "subscribe");
function component_subscribe(t, e, n) {
  t.$$.on_destroy.push(subscribe(e, n));
}
o(component_subscribe, "component_subscribe");
function action_destroyer(t) {
  return t && is_function(t.destroy) ? t.destroy : noop$1;
}
o(action_destroyer, "action_destroyer");
let now$2 = o(() => globalThis.performance.now(), "now"),
  raf = o(t => requestAnimationFrame(t), "raf");
const yi = new Set();
function run_tasks(t) {
  yi.forEach(e => {
    e.c(t) || (yi.delete(e), e.f());
  }), yi.size !== 0 && raf(run_tasks);
}
o(run_tasks, "run_tasks");
function loop(t) {
  let e;
  return yi.size === 0 && raf(run_tasks), {
    promise: new Promise(n => {
      yi.add(e = {
        c: t,
        f: n
      });
    }),
    abort() {
      yi.delete(e);
    }
  };
}
o(loop, "loop");
function append(t, e) {
  t.appendChild(e);
}
o(append, "append");
function insert(t, e, n) {
  t.insertBefore(e, n || null);
}
o(insert, "insert");
function detach(t) {
  t.parentNode.removeChild(t);
}
o(detach, "detach");
function element(t) {
  return document.createElement(t);
}
o(element, "element");
function text(t) {
  return document.createTextNode(t);
}
o(text, "text");
function empty() {
  return text("");
}
o(empty, "empty");
function listen(t, e, n, r) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n, r);
}
o(listen, "listen");
function attr(t, e, n) {
  n == null ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
}
o(attr, "attr");
function set_style(t, e, n, r) {
  n === null ? t.style.removeProperty(e) : t.style.setProperty(e, n);
}
o(set_style, "set_style");
function toggle_class(t, e, n) {
  t.classList[n ? "add" : "remove"](e);
}
o(toggle_class, "toggle_class");
function custom_event(t, e, n = !1) {
  const r = document.createEvent("CustomEvent");
  return r.initCustomEvent(t, n, !1, e), r;
}
o(custom_event, "custom_event");
let oi,
  cp = 0,
  Df = {};
function create_rule(t, e, n, r, i, s, a, l = 0) {
  const u = 16.666 / r;
  let c = `{
`;
  for (let y = 0; y <= 1; y += u) {
    const S = e + (n - e) * s(y);
    c += y * 100 + `%{${a(S, 1 - S)}}
`;
  }
  const p = c + `100% {${a(n, 1 - n)}}
}`,
    m = `_bp_${Math.round(Math.random() * 1e9)}_${l}`;
  if (!Df[m]) {
    if (!oi) {
      const y = element("style");
      document.head.appendChild(y), oi = y.sheet;
    }
    Df[m] = !0, oi.insertRule(`@keyframes ${m} ${p}`, oi.cssRules.length);
  }
  const d = t.style.animation || "";
  return t.style.animation = `${d ? `${d}, ` : ""}${m} ${r}ms linear ${i}ms 1 both`, cp += 1, m;
}
o(create_rule, "create_rule");
function delete_rule(t, e) {
  t.style.animation = (t.style.animation || "").split(", ").filter(e ? n => n.indexOf(e) < 0 : n => n.indexOf("_bp") === -1).join(", "), e && ! --cp && clear_rules();
}
o(delete_rule, "delete_rule");
function clear_rules() {
  raf(() => {
    if (cp) return;
    let t = oi.cssRules.length;
    for (; t--;) oi.deleteRule(t);
    Df = {};
  });
}
o(clear_rules, "clear_rules");
let fp;
function set_current_component(t) {
  fp = t;
}
o(set_current_component, "set_current_component");
const ks = [],
  Lg = [],
  ga = [],
  Mg = [],
  G_ = Promise.resolve();
let Rf = !1;
function schedule_update() {
  Rf || (Rf = !0, G_.then(flush$1));
}
o(schedule_update, "schedule_update");
function add_render_callback(t) {
  ga.push(t);
}
o(add_render_callback, "add_render_callback");
const Pc = new Set();
let Qo = 0;
function flush$1() {
  const t = fp;
  do {
    for (; Qo < ks.length;) {
      const e = ks[Qo];
      Qo++, set_current_component(e), update$3(e.$$);
    }
    for (set_current_component(null), ks.length = 0, Qo = 0; Lg.length;) Lg.pop()();
    for (let e = 0; e < ga.length; e += 1) {
      const n = ga[e];
      Pc.has(n) || (Pc.add(n), n());
    }
    ga.length = 0;
  } while (ks.length);
  for (; Mg.length;) Mg.pop()();
  Rf = !1, Pc.clear(), set_current_component(t);
}
o(flush$1, "flush");
function update$3(t) {
  if (t.fragment !== null) {
    t.update(), run_all(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(add_render_callback);
  }
}
o(update$3, "update");
let ms;
function wait() {
  return ms || (ms = Promise.resolve(), ms.then(() => {
    ms = null;
  })), ms;
}
o(wait, "wait");
function dispatch(t, e, n) {
  t.dispatchEvent(custom_event(`${e ? "intro" : "outro"}${n}`));
}
o(dispatch, "dispatch");
const ya = new Set();
let Yn;
function group_outros() {
  Yn = {
    r: 0,
    c: [],
    p: Yn
  };
}
o(group_outros, "group_outros");
function check_outros() {
  Yn.r || run_all(Yn.c), Yn = Yn.p;
}
o(check_outros, "check_outros");
function transition_in(t, e) {
  t && t.i && (ya.delete(t), t.i(e));
}
o(transition_in, "transition_in");
function transition_out(t, e, n, r) {
  if (t && t.o) {
    if (ya.has(t)) return;
    ya.add(t), Yn.c.push(() => {
      ya.delete(t), r && (n && t.d(1), r());
    }), t.o(e);
  }
}
o(transition_out, "transition_out");
const Yw = {
  duration: 0
};
function create_in_transition(t, e, n) {
  let r = e(t, n),
    i = !1,
    s,
    a,
    l = 0;
  function cleanup() {
    s && delete_rule(t, s);
  }
  o(cleanup, "cleanup");
  function go$1() {
    const {
      delay: m = 0,
      duration: d = 300,
      easing: y = identity,
      tick: S = noop$1,
      css: w
    } = r || Yw;
    w && (s = create_rule(t, 0, 1, d, m, y, w, l++)), S(0, 1);
    const g = now$2() + m,
      h = g + d;
    a && a.abort(), i = !0, add_render_callback(() => dispatch(t, !0, "start")), a = loop(f => {
      if (i) {
        if (f >= h) return S(1, 0), dispatch(t, !0, "end"), cleanup(), i = !1;
        if (f >= g) {
          const v = y((f - g) / d);
          S(v, 1 - v);
        }
      }
      return i;
    });
  }
  o(go$1, "go");
  let p = !1;
  return {
    start() {
      p || (p = !0, delete_rule(t), is_function(r) ? (r = r(), wait().then(go$1)) : go$1());
    },
    invalidate() {
      p = !1;
    },
    end() {
      i && (cleanup(), i = !1);
    }
  };
}
o(create_in_transition, "create_in_transition");
function create_out_transition(t, e, n) {
  let r = e(t, n),
    i = !0,
    s;
  const a = Yn;
  a.r += 1;
  function go$1() {
    const {
      delay: u = 0,
      duration: c = 300,
      easing: p = identity,
      tick: m = noop$1,
      css: d
    } = r || Yw;
    d && (s = create_rule(t, 1, 0, c, u, p, d));
    const y = now$2() + u,
      S = y + c;
    add_render_callback(() => dispatch(t, !1, "start")), loop(w => {
      if (i) {
        if (w >= S) return m(0, 1), dispatch(t, !1, "end"), --a.r || run_all(a.c), !1;
        if (w >= y) {
          const g = p((w - y) / c);
          m(1 - g, g);
        }
      }
      return i;
    });
  }
  return o(go$1, "go"), is_function(r) ? wait().then(() => {
    r = r(), go$1();
  }) : go$1(), {
    end(u) {
      u && r.tick && r.tick(1, 0), i && (s && delete_rule(t, s), i = !1);
    }
  };
}
o(create_out_transition, "create_out_transition");
function create_component(t) {
  t && t.c();
}
o(create_component, "create_component");
function mount_component(t, e, n, r) {
  const {
    fragment: i,
    on_mount: s,
    on_destroy: a,
    after_update: l
  } = t.$$;
  i && i.m(e, n), r || add_render_callback(() => {
    const u = s.map(run$1).filter(is_function);
    a ? a.push(...u) : run_all(u), t.$$.on_mount = [];
  }), l.forEach(add_render_callback);
}
o(mount_component, "mount_component");
function destroy_component(t, e) {
  const n = t.$$;
  n.fragment !== null && (run_all(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
}
o(destroy_component, "destroy_component");
function make_dirty(t, e) {
  t.$$.dirty[0] === -1 && (ks.push(t), schedule_update(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
o(make_dirty, "make_dirty");
function init$6(t, e, n, r, i, s, a, l = [-1]) {
  const u = fp;
  set_current_component(t);
  const c = t.$$ = {
    fragment: null,
    ctx: null,
    props: s,
    update: noop$1,
    not_equal: i,
    bound: {},
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (u ? u.$$.context : [])),
    callbacks: {},
    dirty: l,
    skip_bound: !1,
    root: e.target || u.$$.root
  };
  a && a(c.root);
  let p = !1;
  c.ctx = n ? n(t, e.props || {}, (m, d, ...y) => {
    const S = y.length ? y[0] : d;
    return c.ctx && i(c.ctx[m], c.ctx[m] = S) && (!c.skip_bound && c.bound[m] && c.bound[m](S), p && make_dirty(t, m)), d;
  }) : [], c.update(), p = !0, run_all(c.before_update), c.fragment = r ? r(c.ctx) : !1, e.target && (c.fragment && c.fragment.c(), mount_component(t, e.target, e.anchor, e.customElement), flush$1()), set_current_component(u);
}
o(init$6, "init");
class SvelteComponent {
  $destroy() {
    destroy_component(this, 1), this.$destroy = noop$1;
  }
  $on(e, n) {
    const r = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return r.push(n), () => {
      const i = r.indexOf(n);
      i !== -1 && r.splice(i, 1);
    };
  }
  $set(e) {
    this.$$set && !is_empty(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
o(SvelteComponent, "SvelteComponent");
function cubicOut(t) {
  const e = t - 1;
  return e * e * e + 1;
}
o(cubicOut, "cubicOut");
function fly(t, {
  delay: e = 0,
  duration: n = 400,
  easing: r = cubicOut,
  x: i = 0,
  y: s = 0,
  opacity: a = 0
} = {}) {
  const l = getComputedStyle(t),
    u = +l.opacity,
    c = l.transform === "none" ? "" : l.transform,
    p = u * (1 - a);
  return {
    delay: e,
    duration: n,
    easing: r,
    css: (m, d) => `
			transform: ${c} translate(${(1 - m) * i}px, ${(1 - m) * s}px);
			opacity: ${u - p * d}`
  };
}
o(fly, "fly");
const Yr = [];
function writable(t, e = noop$1) {
  let n;
  const r = new Set();
  function set(l) {
    if (not_equal(t, l) && (t = l, n)) {
      const u = !Yr.length;
      for (const c of r) c[1](), Yr.push(c, t);
      if (u) {
        for (let c = 0; c < Yr.length; c += 2) Yr[c][0](Yr[c + 1]);
        Yr.length = 0;
      }
    }
  }
  o(set, "set");
  function update$4(l) {
    set(l(t));
  }
  o(update$4, "update");
  function subscribe$1(l, u = noop$1) {
    const c = [l, u];
    return r.add(c), r.size === 1 && (n = e(set) || noop$1), l(t), () => {
      r.delete(c), r.size === 0 && (n(), n = null);
    };
  }
  return o(subscribe$1, "subscribe"), {
    set: set,
    update: update$4,
    subscribe: subscribe$1
  };
}
o(writable, "writable");
function get_interpolator(t, e) {
  if (t === e || t !== t) return () => t;
  const n = typeof t;
  if (Array.isArray(t)) {
    const r = e.map((i, s) => get_interpolator(t[s], i));
    return i => r.map(s => s(i));
  }
  if (n === "number") {
    const r = e - t;
    return i => t + i * r;
  }
}
o(get_interpolator, "get_interpolator");
function tweened(t, e = {}) {
  const n = writable(t);
  let r,
    i = t;
  function set$1(a, l) {
    if (t == null) return n.set(t = a), Promise.resolve();
    i = a;
    let u = r,
      c = !1,
      {
        delay: p = 0,
        duration: m = 400,
        easing: d = identity,
        interpolate: y = get_interpolator
      } = assign(assign({}, e), l);
    if (m === 0) return u && (u.abort(), u = null), n.set(t = i), Promise.resolve();
    const S = now$2() + p;
    let w;
    return r = loop(g => {
      if (g < S) return !0;
      c || (w = y(t, a), typeof m == "function" && (m = m(t, a)), c = !0), u && (u.abort(), u = null);
      const h = g - S;
      return h > m ? (n.set(t = a), !1) : (n.set(t = w(d(h / m))), !0);
    }), r.promise;
  }
  return o(set$1, "set"), {
    set: set$1,
    update: (a, l) => set$1(a(i, t), l),
    subscribe: n.subscribe
  };
}
o(tweened, "tweened");
const Ka = writable(0);
var ny;
const Q_ = (ny = globalThis.matchMedia) == null ? void 0 : ny.call(globalThis, "(prefers-reduced-motion: reduce)").matches,
  defaultTweenOptions = o(t => ({
    easing: cubicOut,
    duration: Q_ ? 0 : t
  }), "defaultTweenOptions"),
  getThumbBackground = o(t => !t.thumb || `url(${t.thumb})`, "getThumbBackground"),
  addAttributes = o((t, e) => {
    if (e) {
      typeof e == "string" && (e = JSON.parse(e));
      for (const n in e) t.setAttribute(n, e[n]);
    }
  }, "addAttributes");
function create_if_block_1(t) {
  let e, n, r;
  return {
    c() {
      e = element("div"), e.innerHTML = '<span class="bp-bar"></span><span class="bp-o"></span>', attr(e, "class", "bp-load"), set_style(e, "background-image", getThumbBackground(t[0]));
    },
    m(i, s) {
      insert(i, e, s), r = !0;
    },
    p(i, s) {
      s & 1 && set_style(e, "background-image", getThumbBackground(i[0]));
    },
    i(i) {
      r || (n && n.end(1), r = !0);
    },
    o(i) {
      i && (n = create_out_transition(e, fly, {
        duration: 480
      })), r = !1;
    },
    d(i) {
      i && detach(e), i && n && n.end();
    }
  };
}
o(create_if_block_1, "create_if_block_1$2");
function create_if_block(t) {
  let e, n;
  return {
    c() {
      e = element("div"), attr(e, "class", "bp-load"), set_style(e, "background-image", getThumbBackground(t[0]));
    },
    m(r, i) {
      insert(r, e, i);
    },
    p(r, i) {
      i & 1 && set_style(e, "background-image", getThumbBackground(r[0]));
    },
    i(r) {
      n || add_render_callback(() => {
        n = create_in_transition(e, fly, {
          duration: 480
        }), n.start();
      });
    },
    o: noop$1,
    d(r) {
      r && detach(e);
    }
  };
}
o(create_if_block, "create_if_block$2");
function create_fragment(t) {
  let e,
    n,
    r = !t[1] && create_if_block_1(t),
    i = t[2] && create_if_block(t);
  return {
    c() {
      r && r.c(), e = empty(), i && i.c(), n = empty();
    },
    m(s, a) {
      r && r.m(s, a), insert(s, e, a), i && i.m(s, a), insert(s, n, a);
    },
    p(s, [a]) {
      s[1] ? r && (group_outros(), transition_out(r, 1, 1, () => {
        r = null;
      }), check_outros()) : r ? (r.p(s, a), a & 2 && transition_in(r, 1)) : (r = create_if_block_1(s), r.c(), transition_in(r, 1), r.m(e.parentNode, e)), s[2] ? i ? (i.p(s, a), a & 4 && transition_in(i, 1)) : (i = create_if_block(s), i.c(), transition_in(i, 1), i.m(n.parentNode, n)) : i && (i.d(1), i = null);
    },
    i(s) {
      transition_in(r), transition_in(i);
    },
    o(s) {
      transition_out(r);
    },
    d(s) {
      r && r.d(s), s && detach(e), i && i.d(s), s && detach(n);
    }
  };
}
o(create_fragment, "create_fragment$4");
function instance(t, e, n) {
  let r;
  component_subscribe(t, Ka, a => n(2, r = a));
  let {
      activeItem: i
    } = e,
    {
      loaded: s
    } = e;
  return t.$$set = a => {
    "activeItem" in a && n(0, i = a.activeItem), "loaded" in a && n(1, s = a.loaded);
  }, [i, s, r];
}
o(instance, "instance$4");
class Loading extends SvelteComponent {
  constructor(e) {
    super(), init$6(this, e, instance, create_fragment, not_equal, {
      activeItem: 0,
      loaded: 1
    });
  }
}
o(Loading, "Loading");
function create_if_block_1$1(t) {
  let e, n, r, i, s, a;
  return {
    c() {
      e = element("img"), attr(e, "sizes", n = t[8].sizes || `${t[1]}px`), attr(e, "alt", t[7].alt);
    },
    m(l, u) {
      insert(l, e, u), i = !0, s || (a = [action_destroyer(t[21].call(null, e)), listen(e, "error", t[27])], s = !0);
    },
    p(l, u) {
      (!i || u[0] & 2 && n !== (n = l[8].sizes || `${l[1]}px`)) && attr(e, "sizes", n);
    },
    i(l) {
      i || (r && r.end(1), i = !0);
    },
    o(l) {
      r = create_out_transition(e, fly, {}), i = !1;
    },
    d(l) {
      l && detach(e), l && r && r.end(), s = !1, run_all(a);
    }
  };
}
o(create_if_block_1$1, "create_if_block_1$1");
function create_if_block$1(t) {
  let e, n;
  return e = new Loading({
    props: {
      activeItem: t[7],
      loaded: t[2]
    }
  }), {
    c() {
      create_component(e.$$.fragment);
    },
    m(r, i) {
      mount_component(e, r, i), n = !0;
    },
    p(r, i) {
      const s = {};
      i[0] & 4 && (s.loaded = r[2]), e.$set(s);
    },
    i(r) {
      n || (transition_in(e.$$.fragment, r), n = !0);
    },
    o(r) {
      transition_out(e.$$.fragment, r), n = !1;
    },
    d(r) {
      destroy_component(e, r);
    }
  };
}
o(create_if_block$1, "create_if_block$1");
function create_fragment$1(t) {
  let e,
    n,
    r,
    i = `translate3d(${t[0][0] / -2 + t[6][0]}px, ${t[0][1] / -2 + t[6][1]}px, 0)`,
    s,
    a,
    l,
    u = t[2] && create_if_block_1$1(t),
    c = t[3] && create_if_block$1(t);
  return {
    c() {
      e = element("div"), n = element("div"), u && u.c(), r = empty(), c && c.c(), attr(n, "class", "bp-img"), set_style(n, "width", t[0][0] + "px"), set_style(n, "height", t[0][1] + "px"), toggle_class(n, "bp-drag", t[4]), toggle_class(n, "bp-canzoom", t[11] > 1 && t[0][0] < t[12]), set_style(n, "background-image", getThumbBackground(t[7])), set_style(n, "transform", i), attr(e, "class", "bp-img-wrap"), toggle_class(e, "bp-close", t[5]);
    },
    m(p, m) {
      insert(p, e, m), append(e, n), u && u.m(n, null), append(n, r), c && c.m(n, null), s = !0, a || (l = [action_destroyer(t[20].call(null, n)), listen(e, "wheel", t[15]), listen(e, "pointerdown", t[16]), listen(e, "pointermove", t[17]), listen(e, "pointerup", t[19]), listen(e, "pointercancel", t[18])], a = !0);
    },
    p(p, m) {
      p[2] ? u ? (u.p(p, m), m[0] & 4 && transition_in(u, 1)) : (u = create_if_block_1$1(p), u.c(), transition_in(u, 1), u.m(n, r)) : u && (group_outros(), transition_out(u, 1, 1, () => {
        u = null;
      }), check_outros()), p[3] ? c ? (c.p(p, m), m[0] & 8 && transition_in(c, 1)) : (c = create_if_block$1(p), c.c(), transition_in(c, 1), c.m(n, null)) : c && (group_outros(), transition_out(c, 1, 1, () => {
        c = null;
      }), check_outros()), (!s || m[0] & 1) && set_style(n, "width", p[0][0] + "px"), (!s || m[0] & 1) && set_style(n, "height", p[0][1] + "px"), (!s || m[0] & 16) && toggle_class(n, "bp-drag", p[4]), (!s || m[0] & 6145) && toggle_class(n, "bp-canzoom", p[11] > 1 && p[0][0] < p[12]), m[0] & 65 && i !== (i = `translate3d(${p[0][0] / -2 + p[6][0]}px, ${p[0][1] / -2 + p[6][1]}px, 0)`) && set_style(n, "transform", i), (!s || m[0] & 32) && toggle_class(e, "bp-close", p[5]);
    },
    i(p) {
      s || (transition_in(u), transition_in(c), s = !0);
    },
    o(p) {
      transition_out(u), transition_out(c), s = !1;
    },
    d(p) {
      p && detach(e), u && u.d(), c && c.d(), a = !1, run_all(l);
    }
  };
}
o(create_fragment$1, "create_fragment$3");
function instance$1(t, e, n) {
  let r, i, s, a;
  component_subscribe(t, Ka, W => n(26, s = W));
  let {
      props: l
    } = e,
    {
      smallScreen: u
    } = e,
    {
      activeItem: c,
      opts: p,
      prev: m,
      next: d,
      zoomed: y,
      container: S
    } = l;
  component_subscribe(t, y, W => n(25, r = W));
  let w = c.maxZoom || p.maxZoom || 10,
    g = l.calculateDimensions(c),
    h = g[0],
    f,
    v,
    E,
    b,
    P = 0,
    T,
    O,
    M,
    I,
    U,
    _,
    R;
  const B = +c.width,
    H = [],
    Q = new Map(),
    te = tweened(g, defaultTweenOptions(400));
  component_subscribe(t, te, W => n(0, a = W));
  const j = tweened([0, 0], defaultTweenOptions(400));
  component_subscribe(t, j, W => n(6, i = W));
  const boundTranslateValues = o(([W, ie], de = a) => {
    const fe = (de[0] - S.w) / 2,
      ge = (de[1] - S.h) / 2;
    return fe < 0 ? W = 0 : W > fe ? u ? (W = T ? fe + (W - fe) / 10 : fe, W > fe + 20 && n(4, T = m())) : W = fe : W < -fe && (u ? (W = T ? -fe - (-fe - W) / 10 : -fe, W < -fe - 20 && n(4, T = d())) : W = -fe), ge < 0 ? ie = 0 : ie > ge ? ie = ge : ie < -ge && (ie = -ge), [W, ie];
  }, "boundTranslateValues");
  function changeZoom(W = w, ie) {
    if (s) return;
    const de = g[0] * w;
    let fe = a[0] + a[0] * W,
      ge = a[1] + a[1] * W;
    if (W > 0) fe > de && (fe = de, ge = g[1] * w), fe > B && (fe = B, ge = +c.height);else if (fe < g[0]) return te.set(g), j.set([0, 0]);
    let {
      x: we,
      y: ke,
      width: He,
      height: qt
    } = b.getBoundingClientRect();
    const Vt = ie ? ie.clientX - we - He / 2 : 0,
      Wt = ie ? ie.clientY - ke - qt / 2 : 0;
    we = -Vt * (fe / He) + Vt, ke = -Wt * (ge / qt) + Wt;
    const pn = [fe, ge];
    te.set(pn).then(() => {
      n(1, h = Math.round(Math.max(h, fe)));
    }), j.set(boundTranslateValues([i[0] + we, i[1] + ke], pn));
  }
  o(changeZoom, "changeZoom"), Object.defineProperty(c, "zoom", {
    configurable: !0,
    get: () => r,
    set: W => changeZoom(W ? w : -w)
  });
  const onWheel = o(W => {
      p.inline && !r || (W.preventDefault(), changeZoom(W.deltaY / -300, W));
    }, "onWheel"),
    onPointerDown = o(W => {
      W.button !== 2 && (W.preventDefault(), n(4, T = !0), Q.set(W.pointerId, W), M = W.clientX, I = W.clientY, U = i[0], _ = i[1]);
    }, "onPointerDown"),
    onPointerMove = o(W => {
      var fe;
      if (Q.size > 1) return n(4, T = !1), ((fe = p.noPinch) == null ? void 0 : fe.call(p, S.el)) || handlePinch(W);
      if (!T) return;
      let ie = W.clientX,
        de = W.clientY;
      O = H.push({
        x: ie,
        y: de
      }) > 2, ie = ie - M, de = de - I, r || (de < -90 && n(4, T = !p.noClose && l.close()), Math.abs(de) < 30 && (ie > 40 && n(4, T = m()), ie < -40 && n(4, T = d()))), r && O && !s && j.set(boundTranslateValues([U + ie, _ + de]), {
        duration: 0
      });
    }, "onPointerMove"),
    handlePinch = o(W => {
      const [ie, de] = Q.set(W.pointerId, W).values(),
        fe = ie.clientX - de.clientX,
        ge = ie.clientY - de.clientY,
        we = Math.hypot(fe, ge);
      E = E || {
        clientX: (ie.clientX + de.clientX) / 2,
        clientY: (ie.clientY + de.clientY) / 2
      }, changeZoom(((P || we) - we) / -35, E), P = we;
    }, "handlePinch"),
    removeEventFromCache = o(W => Q.delete(W.pointerId), "removeEventFromCache");
  function onPointerUp(W) {
    var ie;
    if (removeEventFromCache(W), E && (n(4, T = P = 0), E = Q.size ? E : null), !!T) {
      if (n(4, T = !1), W.target === this && !p.noClose) return l.close();
      if (O) {
        const [de, fe, ge] = H.slice(-3),
          we = fe.x - ge.x,
          ke = fe.y - ge.y;
        Math.hypot(we, ke) > 5 && j.set(boundTranslateValues([i[0] - (de.x - ge.x) * 5, i[1] - (de.y - ge.y) * 5]));
      } else (ie = p.onImageClick) != null && ie.call(p, S.el, c) || changeZoom(r ? -w : w, W);
      O = !1, H.length = 0;
    }
  }
  o(onPointerUp, "onPointerUp");
  const onMount = o(W => {
      b = W, l.setResizeFunc(() => {
        n(24, g = l.calculateDimensions(c)), (p.inline || !u) && (te.set(g), j.set([0, 0]));
      }), l.loadImage(c).then(() => {
        n(2, f = !0), l.preloadNext();
      }), setTimeout(() => {
        n(3, v = !f);
      }, 250);
    }, "onMount"),
    addSrc = o(W => {
      addAttributes(W, c.attr), W.srcset = c.img;
    }, "addSrc"),
    error_handler = o(W => {
      var ie;
      return (ie = p.onError) == null ? void 0 : ie.call(p, S, c, W);
    }, "error_handler");
  return t.$$set = W => {
    "smallScreen" in W && n(23, u = W.smallScreen);
  }, t.$$.update = () => {
    if (t.$$.dirty[0] & 16777217 && y.set(a[0] - 10 > g[0]), t.$$.dirty[0] & 117440512 && s && r && !p.intro) {
      const W = defaultTweenOptions(480);
      j.set([0, 0], W), te.set(g, W), n(5, R = !0);
    }
  }, [a, h, f, v, T, R, i, c, p, y, S, w, B, te, j, onWheel, onPointerDown, onPointerMove, removeEventFromCache, onPointerUp, onMount, addSrc, l, u, g, r, s, error_handler];
}
o(instance$1, "instance$3");
let Image$1 = o(class extends SvelteComponent {
  constructor(e) {
    super(), init$6(this, e, instance$1, create_fragment$1, not_equal, {
      props: 22,
      smallScreen: 23
    }, null, [-1, -1]);
  }
}, "Image");
function create_fragment$2(t) {
  let e, n, r, i, s, a;
  return r = new Loading({
    props: {
      activeItem: t[2],
      loaded: t[0]
    }
  }), {
    c() {
      e = element("div"), n = element("iframe"), create_component(r.$$.fragment), attr(n, "allow", "autoplay; fullscreen"), attr(n, "title", t[2].title), attr(e, "class", "bp-if"), set_style(e, "width", t[1][0] + "px"), set_style(e, "height", t[1][1] + "px");
    },
    m(l, u) {
      insert(l, e, u), append(e, n), mount_component(r, e, null), i = !0, s || (a = [action_destroyer(t[3].call(null, n)), listen(n, "load", t[5])], s = !0);
    },
    p(l, [u]) {
      const c = {};
      u & 1 && (c.loaded = l[0]), r.$set(c), (!i || u & 2) && set_style(e, "width", l[1][0] + "px"), (!i || u & 2) && set_style(e, "height", l[1][1] + "px");
    },
    i(l) {
      i || (transition_in(r.$$.fragment, l), i = !0);
    },
    o(l) {
      transition_out(r.$$.fragment, l), i = !1;
    },
    d(l) {
      l && detach(e), destroy_component(r), s = !1, run_all(a);
    }
  };
}
o(create_fragment$2, "create_fragment$2");
function instance$2(t, e, n) {
  let {
      props: r
    } = e,
    i,
    s;
  const {
      activeItem: a
    } = r,
    setDimensions = o(() => n(1, s = r.calculateDimensions(a)), "setDimensions");
  return setDimensions(), r.setResizeFunc(setDimensions), [i, s, a, o(p => {
    addAttributes(p, a.attr), p.src = a.iframe;
  }, "addSrc"), r, o(() => n(0, i = !0), "load_handler")];
}
o(instance$2, "instance$2");
class Iframe extends SvelteComponent {
  constructor(e) {
    super(), init$6(this, e, instance$2, create_fragment$2, not_equal, {
      props: 4
    });
  }
}
o(Iframe, "Iframe");
function create_fragment$3(t) {
  let e, n, r, i, s;
  return n = new Loading({
    props: {
      activeItem: t[2],
      loaded: t[0]
    }
  }), {
    c() {
      e = element("div"), create_component(n.$$.fragment), attr(e, "class", "bp-vid"), set_style(e, "width", t[1][0] + "px"), set_style(e, "height", t[1][1] + "px"), set_style(e, "background-image", getThumbBackground(t[2]));
    },
    m(a, l) {
      insert(a, e, l), mount_component(n, e, null), r = !0, i || (s = action_destroyer(t[3].call(null, e)), i = !0);
    },
    p(a, [l]) {
      const u = {};
      l & 1 && (u.loaded = a[0]), n.$set(u), (!r || l & 2) && set_style(e, "width", a[1][0] + "px"), (!r || l & 2) && set_style(e, "height", a[1][1] + "px");
    },
    i(a) {
      r || (transition_in(n.$$.fragment, a), r = !0);
    },
    o(a) {
      transition_out(n.$$.fragment, a), r = !1;
    },
    d(a) {
      a && detach(e), destroy_component(n), i = !1, s();
    }
  };
}
o(create_fragment$3, "create_fragment$1");
function instance$3(t, e, n) {
  let {
      props: r
    } = e,
    i,
    s;
  const {
      activeItem: a,
      opts: l,
      container: u
    } = r,
    setDimensions$1 = o(() => n(1, s = r.calculateDimensions(a)), "setDimensions");
  return setDimensions$1(), r.setResizeFunc(setDimensions$1), [i, s, a, o(m => {
    let d;
    const appendToVideo = o((S, w) => {
      var g;
      Array.isArray(w) || (w = JSON.parse(w));
      for (const h of w) {
        d || (d = document.createElement((g = h.type) != null && g.includes("audio") ? "audio" : "video"), addAttributes(d, {
          controls: !0,
          autoplay: !0,
          playsinline: !0,
          tabindex: "0"
        }), addAttributes(d, a.attr));
        const f = document.createElement(S);
        addAttributes(f, h), S == "source" && (f.onError = v => {
          var E;
          return (E = l.onError) == null ? void 0 : E.call(l, u, a, v);
        }), d.append(f);
      }
    }, "appendToVideo");
    appendToVideo("source", a.sources), appendToVideo("track", a.tracks || []), d.oncanplay = () => n(0, i = !0), m.append(d);
  }, "onMount"), r];
}
o(instance$3, "instance$1");
class Video extends SvelteComponent {
  constructor(e) {
    super(), init$6(this, e, instance$3, create_fragment$3, not_equal, {
      props: 4
    });
  }
}
o(Video, "Video");
function create_if_block$2(t) {
  let e,
    n,
    r,
    i = t[6].i,
    s,
    a,
    l,
    u,
    c,
    p,
    m = create_key_block(t),
    d = t[0].length > 1 && create_if_block_1$2(t);
  return {
    c() {
      e = element("div"), n = element("div"), m.c(), s = element("div"), a = element("button"), d && d.c(), attr(a, "class", "bp-x"), attr(a, "title", "Close"), attr(a, "aria-label", "Close"), attr(s, "class", "bp-controls"), attr(e, "class", "bp-wrap"), toggle_class(e, "bp-zoomed", t[10]), toggle_class(e, "bp-inline", t[8]), toggle_class(e, "bp-small", t[7]), toggle_class(e, "bp-noclose", t[5].noClose);
    },
    m(y, S) {
      insert(y, e, S), append(e, n), m.m(e, null), append(e, s), append(s, a), d && d.m(s, null), u = !0, c || (p = [listen(a, "click", t[1]), action_destroyer(t[14].call(null, e))], c = !0);
    },
    p(y, S) {
      S[0] & 64 && not_equal(i, i = y[6].i) ? (group_outros(), transition_out(m, 1, 1, noop$1), check_outros(), m = create_key_block(y), m.c(), transition_in(m, 1), m.m(e, s)) : m.p(y, S), y[0].length > 1 ? d ? d.p(y, S) : (d = create_if_block_1$2(y), d.c(), d.m(s, null)) : d && (d.d(1), d = null), (!u || S[0] & 1024) && toggle_class(e, "bp-zoomed", y[10]), (!u || S[0] & 256) && toggle_class(e, "bp-inline", y[8]), (!u || S[0] & 128) && toggle_class(e, "bp-small", y[7]), (!u || S[0] & 32) && toggle_class(e, "bp-noclose", y[5].noClose);
    },
    i(y) {
      u || (r && r.end(1), transition_in(m), l && l.end(1), u = !0);
    },
    o(y) {
      y && (r = create_out_transition(n, fly, {
        duration: 480
      })), transition_out(m), y && (l = create_out_transition(s, fly, {})), u = !1;
    },
    d(y) {
      y && detach(e), y && r && r.end(), m.d(y), d && d.d(), y && l && l.end(), c = !1, run_all(p);
    }
  };
}
o(create_if_block$2, "create_if_block");
function create_else_block(t) {
  let e,
    n = (t[6].html ?? t[6].element.outerHTML) + "";
  return {
    c() {
      e = element("div"), attr(e, "class", "bp-html");
    },
    m(r, i) {
      insert(r, e, i), e.innerHTML = n;
    },
    p(r, i) {
      i[0] & 64 && n !== (n = (r[6].html ?? r[6].element.outerHTML) + "") && (e.innerHTML = n);
    },
    i: noop$1,
    o: noop$1,
    d(r) {
      r && detach(e);
    }
  };
}
o(create_else_block, "create_else_block");
function create_if_block_5(t) {
  let e, n;
  return e = new Iframe({
    props: {
      props: t[13]()
    }
  }), {
    c() {
      create_component(e.$$.fragment);
    },
    m(r, i) {
      mount_component(e, r, i), n = !0;
    },
    p: noop$1,
    i(r) {
      n || (transition_in(e.$$.fragment, r), n = !0);
    },
    o(r) {
      transition_out(e.$$.fragment, r), n = !1;
    },
    d(r) {
      destroy_component(e, r);
    }
  };
}
o(create_if_block_5, "create_if_block_5");
function create_if_block_4(t) {
  let e, n;
  return e = new Video({
    props: {
      props: t[13]()
    }
  }), {
    c() {
      create_component(e.$$.fragment);
    },
    m(r, i) {
      mount_component(e, r, i), n = !0;
    },
    p: noop$1,
    i(r) {
      n || (transition_in(e.$$.fragment, r), n = !0);
    },
    o(r) {
      transition_out(e.$$.fragment, r), n = !1;
    },
    d(r) {
      destroy_component(e, r);
    }
  };
}
o(create_if_block_4, "create_if_block_4");
function create_if_block_3(t) {
  let e, n;
  return e = new Image$1({
    props: {
      props: t[13](),
      smallScreen: t[7]
    }
  }), {
    c() {
      create_component(e.$$.fragment);
    },
    m(r, i) {
      mount_component(e, r, i), n = !0;
    },
    p(r, i) {
      const s = {};
      i[0] & 128 && (s.smallScreen = r[7]), e.$set(s);
    },
    i(r) {
      n || (transition_in(e.$$.fragment, r), n = !0);
    },
    o(r) {
      transition_out(e.$$.fragment, r), n = !1;
    },
    d(r) {
      destroy_component(e, r);
    }
  };
}
o(create_if_block_3, "create_if_block_3");
function create_if_block_2(t) {
  let e,
    n = t[6].caption + "",
    r,
    i;
  return {
    c() {
      e = element("div"), attr(e, "class", "bp-cap");
    },
    m(s, a) {
      insert(s, e, a), e.innerHTML = n, i = !0;
    },
    p(s, a) {
      (!i || a[0] & 64) && n !== (n = s[6].caption + "") && (e.innerHTML = n);
    },
    i(s) {
      i || (r && r.end(1), i = !0);
    },
    o(s) {
      r = create_out_transition(e, fly, {
        duration: 200
      }), i = !1;
    },
    d(s) {
      s && detach(e), s && r && r.end();
    }
  };
}
o(create_if_block_2, "create_if_block_2");
function create_key_block(t) {
  let e, n, r, i, s, a, l, u, c;
  const p = [create_if_block_3, create_if_block_4, create_if_block_5, create_else_block],
    m = [];
  function select_block_type(S, w) {
    return S[6].img ? 0 : S[6].sources ? 1 : S[6].iframe ? 2 : 3;
  }
  o(select_block_type, "select_block_type"), n = select_block_type(t), r = m[n] = p[n](t);
  let y = t[6].caption && create_if_block_2(t);
  return {
    c() {
      e = element("div"), r.c(), y && y.c(), a = empty(), attr(e, "class", "bp-inner");
    },
    m(S, w) {
      insert(S, e, w), m[n].m(e, null), y && y.m(S, w), insert(S, a, w), l = !0, u || (c = [listen(e, "pointerdown", t[20]), listen(e, "pointerup", t[21])], u = !0);
    },
    p(S, w) {
      let g = n;
      n = select_block_type(S), n === g ? m[n].p(S, w) : (group_outros(), transition_out(m[g], 1, 1, () => {
        m[g] = null;
      }), check_outros(), r = m[n], r ? r.p(S, w) : (r = m[n] = p[n](S), r.c()), transition_in(r, 1), r.m(e, null)), S[6].caption ? y ? (y.p(S, w), w[0] & 64 && transition_in(y, 1)) : (y = create_if_block_2(S), y.c(), transition_in(y, 1), y.m(a.parentNode, a)) : y && (group_outros(), transition_out(y, 1, 1, () => {
        y = null;
      }), check_outros());
    },
    i(S) {
      l || (transition_in(r), add_render_callback(() => {
        s && s.end(1), i = create_in_transition(e, t[12], !0), i.start();
      }), transition_in(y), l = !0);
    },
    o(S) {
      transition_out(r), i && i.invalidate(), s = create_out_transition(e, t[12], !1), transition_out(y), l = !1;
    },
    d(S) {
      S && detach(e), m[n].d(), S && s && s.end(), y && y.d(S), S && detach(a), u = !1, run_all(c);
    }
  };
}
o(create_key_block, "create_key_block");
function create_if_block_1$2(t) {
  let e,
    n = `${t[4] + 1} / ${t[0].length}`,
    r,
    i,
    s,
    a;
  return {
    c() {
      e = element("div"), r = element("button"), i = element("button"), attr(e, "class", "bp-count"), attr(r, "class", "bp-prev"), attr(r, "title", "Previous"), attr(r, "aria-label", "Previous"), attr(i, "class", "bp-next"), attr(i, "title", "Next"), attr(i, "aria-label", "Next");
    },
    m(l, u) {
      insert(l, e, u), e.innerHTML = n, insert(l, r, u), insert(l, i, u), s || (a = [listen(r, "click", t[2]), listen(i, "click", t[3])], s = !0);
    },
    p(l, u) {
      u[0] & 17 && n !== (n = `${l[4] + 1} / ${l[0].length}`) && (e.innerHTML = n);
    },
    d(l) {
      l && detach(e), l && detach(r), l && detach(i), s = !1, run_all(a);
    }
  };
}
o(create_if_block_1$2, "create_if_block_1");
function create_fragment$4(t) {
  let e,
    n,
    r = t[0] && create_if_block$2(t);
  return {
    c() {
      r && r.c(), e = empty();
    },
    m(i, s) {
      r && r.m(i, s), insert(i, e, s), n = !0;
    },
    p(i, s) {
      i[0] ? r ? (r.p(i, s), s[0] & 1 && transition_in(r, 1)) : (r = create_if_block$2(i), r.c(), transition_in(r, 1), r.m(e.parentNode, e)) : r && (group_outros(), transition_out(r, 1, 1, () => {
        r = null;
      }), check_outros());
    },
    i(i) {
      n || (transition_in(r), n = !0);
    },
    o(i) {
      transition_out(r), n = !1;
    },
    d(i) {
      r && r.d(i), i && detach(e);
    }
  };
}
o(create_fragment$4, "create_fragment");
function instance$4(t, e, n) {
  let r,
    {
      items: i = void 0
    } = e,
    {
      target: s = void 0
    } = e;
  const a = document.documentElement;
  let l, u, c, p, m, d, y, S, w;
  const activeItemIsHtml = o(() => !w.img && !w.sources && !w.iframe, "activeItemIsHtml");
  let h;
  const setResizeFunc = o(C => h = C, "setResizeFunc"),
    v = {},
    E = writable(0);
  component_subscribe(t, E, C => n(10, r = C));
  const open = o(C => {
      n(5, u = C), n(8, d = u.inline), !d && a.scrollHeight > a.clientHeight && a.classList.add("bp-lock"), p = document.activeElement, n(19, v.w = s.offsetWidth, v), n(19, v.h = s === document.body ? globalThis.innerHeight : s.clientHeight, v), n(7, m = v.w < 769), n(4, l = u.position || 0), n(0, i = []);
      for (let A = 0; A < (u.items.length || 1); A++) {
        let L = u.items[A] || u.items;
        "dataset" in L ? i.push({
          element: L,
          i: A,
          ...L.dataset
        }) : (L.i = A, i.push(L), L = L.element), u.el && u.el === L && n(4, l = A);
      }
    }, "open"),
    close = o(() => {
      var C;
      (C = u.onClose) == null || C.call(u, v.el, w), Ka.set(!0), n(0, i = null), p == null || p.focus({
        preventScroll: !0
      });
    }, "close"),
    prev$4 = o(() => setPosition(l - 1), "prev"),
    next$3 = o(() => setPosition(l + 1), "next"),
    setPosition = o(C => {
      y = C - l, n(4, l = getNextPosition(C));
    }, "setPosition"),
    getNextPosition = o(C => (C + i.length) % i.length, "getNextPosition"),
    onKeydown = o(C => {
      const {
        key: A,
        shiftKey: L
      } = C;
      if (A === "Escape") !u.noClose && close();else if (A === "ArrowRight") next$3();else if (A === "ArrowLeft") prev$4();else if (A === "Tab") {
        const {
          activeElement: V
        } = document;
        if (L || !V.controls) {
          C.preventDefault();
          const {
              focusWrap: Y = v.el
            } = u,
            re = [...Y.querySelectorAll("*")].filter(le => le.tabIndex >= 0);
          let ae = re.indexOf(V);
          ae += re.length + (L ? -1 : 1), re[ae % re.length].focus();
        }
      }
    }, "onKeydown"),
    calculateDimensions = o(({
      width: C = 1920,
      height: A = 1080
    }) => {
      const {
          scale: L = .99
        } = u,
        V = Math.min(1, v.w / C * L, v.h / A * L);
      return [Math.round(C * V), Math.round(A * V)];
    }, "calculateDimensions"),
    preloadNext = o(() => {
      if (i) {
        const C = i[getNextPosition(l + 1)],
          A = i[getNextPosition(l - 1)];
        !C.preload && loadImage(C), !A.preload && loadImage(A);
      }
    }, "preloadNext"),
    loadImage = o(C => {
      if (C.img) {
        const A = document.createElement("img");
        return A.sizes = u.sizes || `${calculateDimensions(C)[0]}px`, A.srcset = C.img, C.preload = !0, A.decode().catch(L => {});
      }
    }, "loadImage"),
    mediaTransition = o((C, A) => !c || !i ? (n(18, c = A), u.intro ? fly(C, {
      y: A ? 10 : -10
    }) : scaleIn(C)) : fly(C, {
      x: (y > 0 ? 20 : -20) * (A ? 1 : -1),
      duration: 250
    }), "mediaTransition"),
    scaleIn = o(C => {
      let A;
      if (activeItemIsHtml()) {
        const le = C.firstChild.firstChild;
        A = [le.clientWidth, le.clientHeight];
      } else A = calculateDimensions(w);
      const L = (w.element || p).getBoundingClientRect(),
        V = L.left - (v.w - L.width) / 2,
        Y = L.top - (v.h - L.height) / 2,
        re = L.width / A[0],
        ae = L.height / A[1];
      return {
        duration: 480,
        easing: cubicOut,
        css: (le, ce) => `transform:translate3d(${V * ce}px, ${Y * ce}px, 0) scale3d(${re + le * (1 - re)}, ${ae + le * (1 - ae)}, 1)`
      };
    }, "scaleIn"),
    getChildProps = o(() => ({
      activeItem: w,
      calculateDimensions: calculateDimensions,
      loadImage: loadImage,
      preloadNext: preloadNext,
      opts: u,
      prev: prev$4,
      next: next$3,
      close: close,
      setResizeFunc: setResizeFunc,
      zoomed: E,
      container: v
    }), "getChildProps"),
    containerActions = o(C => {
      var V;
      n(19, v.el = C, v);
      let A;
      (V = u.onOpen) == null || V.call(u, v.el, w), d || globalThis.addEventListener("keydown", onKeydown);
      const L = new ResizeObserver(Y => {
        var re;
        A && (n(19, v.w = Y[0].contentRect.width, v), n(19, v.h = Y[0].contentRect.height, v), n(7, m = v.w < 769), activeItemIsHtml() || h == null || h(), (re = u.onResize) == null || re.call(u, v.el, w)), A = !0;
      });
      return L.observe(C), {
        destroy() {
          var Y;
          L.disconnect(), globalThis.removeEventListener("keydown", onKeydown), Ka.set(!1), a.classList.remove("bp-lock"), (Y = u.onClosed) == null || Y.call(u);
        }
      };
    }, "containerActions"),
    pointerdown_handler = o(C => n(9, S = C.target), "pointerdown_handler"),
    pointerup_handler = o(function (C) {
      C.button !== 2 && C.target === this && S === this && !u.noClose && close();
    }, "pointerup_handler");
  return t.$$set = C => {
    "items" in C && n(0, i = C.items), "target" in C && n(15, s = C.target);
  }, t.$$.update = () => {
    var C;
    t.$$.dirty[0] & 786545 && i && (n(6, w = i[l]), c && ((C = u.onUpdate) == null || C.call(u, v.el, w)));
  }, [i, close, prev$4, next$3, l, u, w, m, d, S, r, E, mediaTransition, getChildProps, containerActions, s, open, setPosition, c, v, pointerdown_handler, pointerup_handler];
}
o(instance$4, "instance");
class Bigger_picture extends SvelteComponent {
  constructor(e) {
    super(), init$6(this, e, instance$4, create_fragment$4, not_equal, {
      items: 0,
      target: 15,
      open: 16,
      close: 1,
      prev: 2,
      next: 3,
      setPosition: 17
    }, null, [-1, -1]);
  }
  get items() {
    return this.$$.ctx[0];
  }
  get target() {
    return this.$$.ctx[15];
  }
  get open() {
    return this.$$.ctx[16];
  }
  get close() {
    return this.$$.ctx[1];
  }
  get prev() {
    return this.$$.ctx[2];
  }
  get next() {
    return this.$$.ctx[3];
  }
  get setPosition() {
    return this.$$.ctx[17];
  }
}
o(Bigger_picture, "Bigger_picture");
function biggerPicture(t) {
  return new Bigger_picture({
    ...t,
    props: t
  });
}
o(biggerPicture, "biggerPicture");
class Loader {
  constructor(e = null, n = {}) {
    if (this.apiKey = e, this.options = n, typeof window > "u") throw new Error("google-maps is supported only in browser environment");
  }
  load() {
    return typeof this.api < "u" ? Promise.resolve(this.api) : typeof this.loader < "u" ? this.loader : (window[Loader.CALLBACK_NAME] = () => {
      if (this.api = window.google, typeof this.resolve > "u") throw new Error("Should not happen");
      this.resolve(this.api);
    }, window.gm_authFailure = () => {
      if (typeof this.reject > "u") throw new Error("Should not happen");
      this.reject(new Error("google-maps: authentication error"));
    }, this.loader = new Promise((e, n) => {
      this.resolve = e, this.reject = n;
      const r = document.createElement("script");
      r.src = this.createUrl(), r.async = !0, r.onerror = i => n(i), document.head.appendChild(r);
    }));
  }
  createUrl() {
    const e = [`callback=${Loader.CALLBACK_NAME}`];
    this.apiKey && e.push(`key=${this.apiKey}`);
    for (let n in this.options) if (this.options.hasOwnProperty(n)) {
      let r = this.options[n];
      n === "version" && (n = "v"), n === "libraries" && (r = r.join(",")), e.push(`${n}=${r}`);
    }
    return `https://maps.googleapis.com/maps/api/js?${e.join("&")}`;
  }
}
o(Loader, "Loader");
Loader.CALLBACK_NAME = "_dk_google_maps_loader_cb";
var Hn;
(function (t) {
  t.Range = "range", t.Steps = "steps", t.Positions = "positions", t.Count = "count", t.Values = "values";
})(Hn || (Hn = {}));
var Pt;
(function (t) {
  t[t.None = -1] = "None", t[t.NoValue = 0] = "NoValue", t[t.LargeValue = 1] = "LargeValue", t[t.SmallValue = 2] = "SmallValue";
})(Pt || (Pt = {}));
function isValidFormatter(t) {
  return isValidPartialFormatter(t) && typeof t.from == "function";
}
o(isValidFormatter, "isValidFormatter");
function isValidPartialFormatter(t) {
  return typeof t == "object" && typeof t.to == "function";
}
o(isValidPartialFormatter, "isValidPartialFormatter");
function removeElement(t) {
  t.parentElement.removeChild(t);
}
o(removeElement, "removeElement$1");
function isSet$1(t) {
  return t != null;
}
o(isSet$1, "isSet");
function preventDefault(t) {
  t.preventDefault();
}
o(preventDefault, "preventDefault");
function unique(t) {
  return t.filter(function (e) {
    return this[e] ? !1 : this[e] = !0;
  }, {});
}
o(unique, "unique");
function closest(t, e) {
  return Math.round(t / e) * e;
}
o(closest, "closest$2");
function offset(t, e) {
  var n = t.getBoundingClientRect(),
    r = t.ownerDocument,
    i = r.documentElement,
    s = getPageOffset(r);
  return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (s.x = 0), e ? n.top + s.y - i.clientTop : n.left + s.x - i.clientLeft;
}
o(offset, "offset");
function isNumeric(t) {
  return typeof t == "number" && !isNaN(t) && isFinite(t);
}
o(isNumeric, "isNumeric");
function addClassFor(t, e, n) {
  n > 0 && (addClass(t, e), setTimeout(function () {
    removeClass(t, e);
  }, n));
}
o(addClassFor, "addClassFor");
function limit(t) {
  return Math.max(Math.min(t, 100), 0);
}
o(limit, "limit");
function asArray(t) {
  return Array.isArray(t) ? t : [t];
}
o(asArray, "asArray");
function countDecimals(t) {
  t = String(t);
  var e = t.split(".");
  return e.length > 1 ? e[1].length : 0;
}
o(countDecimals, "countDecimals");
function addClass(t, e) {
  t.classList && !/\s/.test(e) ? t.classList.add(e) : t.className += " " + e;
}
o(addClass, "addClass");
function removeClass(t, e) {
  t.classList && !/\s/.test(e) ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\b)" + e.split(" ").join("|") + "(\\b|$)", "gi"), " ");
}
o(removeClass, "removeClass");
function hasClass(t, e) {
  return t.classList ? t.classList.contains(e) : new RegExp("\\b" + e + "\\b").test(t.className);
}
o(hasClass, "hasClass$1");
function getPageOffset(t) {
  var e = window.pageXOffset !== void 0,
    n = (t.compatMode || "") === "CSS1Compat",
    r = e ? window.pageXOffset : n ? t.documentElement.scrollLeft : t.body.scrollLeft,
    i = e ? window.pageYOffset : n ? t.documentElement.scrollTop : t.body.scrollTop;
  return {
    x: r,
    y: i
  };
}
o(getPageOffset, "getPageOffset");
function getActions() {
  return window.navigator.pointerEnabled ? {
    start: "pointerdown",
    move: "pointermove",
    end: "pointerup"
  } : window.navigator.msPointerEnabled ? {
    start: "MSPointerDown",
    move: "MSPointerMove",
    end: "MSPointerUp"
  } : {
    start: "mousedown touchstart",
    move: "mousemove touchmove",
    end: "mouseup touchend"
  };
}
o(getActions, "getActions");
function getSupportsPassive() {
  var t = !1;
  try {
    var e = Object.defineProperty({}, "passive", {
      get: function () {
        t = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {}
  return t;
}
o(getSupportsPassive, "getSupportsPassive");
function getSupportsTouchActionNone() {
  return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
o(getSupportsTouchActionNone, "getSupportsTouchActionNone");
function subRangeRatio(t, e) {
  return 100 / (e - t);
}
o(subRangeRatio, "subRangeRatio");
function fromPercentage(t, e, n) {
  return e * 100 / (t[n + 1] - t[n]);
}
o(fromPercentage, "fromPercentage");
function toPercentage(t, e) {
  return fromPercentage(t, t[0] < 0 ? e + Math.abs(t[0]) : e - t[0], 0);
}
o(toPercentage, "toPercentage");
function isPercentage(t, e) {
  return e * (t[1] - t[0]) / 100 + t[0];
}
o(isPercentage, "isPercentage");
function getJ(t, e) {
  for (var n = 1; t >= e[n];) n += 1;
  return n;
}
o(getJ, "getJ");
function toStepping(t, e, n) {
  if (n >= t.slice(-1)[0]) return 100;
  var r = getJ(n, t),
    i = t[r - 1],
    s = t[r],
    a = e[r - 1],
    l = e[r];
  return a + toPercentage([i, s], n) / subRangeRatio(a, l);
}
o(toStepping, "toStepping");
function fromStepping(t, e, n) {
  if (n >= 100) return t.slice(-1)[0];
  var r = getJ(n, e),
    i = t[r - 1],
    s = t[r],
    a = e[r - 1],
    l = e[r];
  return isPercentage([i, s], (n - a) * subRangeRatio(a, l));
}
o(fromStepping, "fromStepping");
function getStep(t, e, n, r) {
  if (r === 100) return r;
  var i = getJ(r, t),
    s = t[i - 1],
    a = t[i];
  return n ? r - s > (a - s) / 2 ? a : s : e[i - 1] ? t[i - 1] + closest(r - t[i - 1], e[i - 1]) : r;
}
o(getStep, "getStep");
var nb = function () {
    function Spectrum(e, n, r) {
      this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [r || !1], this.xNumSteps = [!1], this.snap = n;
      var i,
        s = [];
      for (Object.keys(e).forEach(function (a) {
        s.push([asArray(e[a]), a]);
      }), s.sort(function (a, l) {
        return a[0][0] - l[0][0];
      }), i = 0; i < s.length; i++) this.handleEntryPoint(s[i][1], s[i][0]);
      for (this.xNumSteps = this.xSteps.slice(0), i = 0; i < this.xNumSteps.length; i++) this.handleStepPoint(i, this.xNumSteps[i]);
    }
    return o(Spectrum, "Spectrum"), Spectrum.prototype.getDistance = function (e) {
      for (var n = [], r = 0; r < this.xNumSteps.length - 1; r++) n[r] = fromPercentage(this.xVal, e, r);
      return n;
    }, Spectrum.prototype.getAbsoluteDistance = function (e, n, r) {
      var i = 0;
      if (e < this.xPct[this.xPct.length - 1]) for (; e > this.xPct[i + 1];) i++;else e === this.xPct[this.xPct.length - 1] && (i = this.xPct.length - 2);
      !r && e === this.xPct[i + 1] && i++, n === null && (n = []);
      var s,
        a = 1,
        l = n[i],
        u = 0,
        c = 0,
        p = 0,
        m = 0;
      for (r ? s = (e - this.xPct[i]) / (this.xPct[i + 1] - this.xPct[i]) : s = (this.xPct[i + 1] - e) / (this.xPct[i + 1] - this.xPct[i]); l > 0;) u = this.xPct[i + 1 + m] - this.xPct[i + m], n[i + m] * a + 100 - s * 100 > 100 ? (c = u * s, a = (l - 100 * s) / n[i + m], s = 1) : (c = n[i + m] * u / 100 * a, a = 0), r ? (p = p - c, this.xPct.length + m >= 1 && m--) : (p = p + c, this.xPct.length - m >= 1 && m++), l = n[i + m] * a;
      return e + p;
    }, Spectrum.prototype.toStepping = function (e) {
      return e = toStepping(this.xVal, this.xPct, e), e;
    }, Spectrum.prototype.fromStepping = function (e) {
      return fromStepping(this.xVal, this.xPct, e);
    }, Spectrum.prototype.getStep = function (e) {
      return e = getStep(this.xPct, this.xSteps, this.snap, e), e;
    }, Spectrum.prototype.getDefaultStep = function (e, n, r) {
      var i = getJ(e, this.xPct);
      return (e === 100 || n && e === this.xPct[i - 1]) && (i = Math.max(i - 1, 1)), (this.xVal[i] - this.xVal[i - 1]) / r;
    }, Spectrum.prototype.getNearbySteps = function (e) {
      var n = getJ(e, this.xPct);
      return {
        stepBefore: {
          startValue: this.xVal[n - 2],
          step: this.xNumSteps[n - 2],
          highestStep: this.xHighestCompleteStep[n - 2]
        },
        thisStep: {
          startValue: this.xVal[n - 1],
          step: this.xNumSteps[n - 1],
          highestStep: this.xHighestCompleteStep[n - 1]
        },
        stepAfter: {
          startValue: this.xVal[n],
          step: this.xNumSteps[n],
          highestStep: this.xHighestCompleteStep[n]
        }
      };
    }, Spectrum.prototype.countStepDecimals = function () {
      var e = this.xNumSteps.map(countDecimals);
      return Math.max.apply(null, e);
    }, Spectrum.prototype.hasNoSize = function () {
      return this.xVal[0] === this.xVal[this.xVal.length - 1];
    }, Spectrum.prototype.convert = function (e) {
      return this.getStep(this.toStepping(e));
    }, Spectrum.prototype.handleEntryPoint = function (e, n) {
      var r;
      if (e === "min" ? r = 0 : e === "max" ? r = 100 : r = parseFloat(e), !isNumeric(r) || !isNumeric(n[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
      this.xPct.push(r), this.xVal.push(n[0]);
      var i = Number(n[1]);
      r ? this.xSteps.push(isNaN(i) ? !1 : i) : isNaN(i) || (this.xSteps[0] = i), this.xHighestCompleteStep.push(0);
    }, Spectrum.prototype.handleStepPoint = function (e, n) {
      if (n) {
        if (this.xVal[e] === this.xVal[e + 1]) {
          this.xSteps[e] = this.xHighestCompleteStep[e] = this.xVal[e];
          return;
        }
        this.xSteps[e] = fromPercentage([this.xVal[e], this.xVal[e + 1]], n, 0) / subRangeRatio(this.xPct[e], this.xPct[e + 1]);
        var r = (this.xVal[e + 1] - this.xVal[e]) / this.xNumSteps[e],
          i = Math.ceil(Number(r.toFixed(3)) - 1),
          s = this.xVal[e] + this.xNumSteps[e] * i;
        this.xHighestCompleteStep[e] = s;
      }
    }, Spectrum;
  }(),
  Wg = {
    to: function (t) {
      return t === void 0 ? "" : t.toFixed(2);
    },
    from: Number
  },
  rb = {
    target: "target",
    base: "base",
    origin: "origin",
    handle: "handle",
    handleLower: "handle-lower",
    handleUpper: "handle-upper",
    touchArea: "touch-area",
    horizontal: "horizontal",
    vertical: "vertical",
    background: "background",
    connect: "connect",
    connects: "connects",
    ltr: "ltr",
    rtl: "rtl",
    textDirectionLtr: "txt-dir-ltr",
    textDirectionRtl: "txt-dir-rtl",
    draggable: "draggable",
    drag: "state-drag",
    tap: "state-tap",
    active: "active",
    tooltip: "tooltip",
    pips: "pips",
    pipsHorizontal: "pips-horizontal",
    pipsVertical: "pips-vertical",
    marker: "marker",
    markerHorizontal: "marker-horizontal",
    markerVertical: "marker-vertical",
    markerNormal: "marker-normal",
    markerLarge: "marker-large",
    markerSub: "marker-sub",
    value: "value",
    valueHorizontal: "value-horizontal",
    valueVertical: "value-vertical",
    valueNormal: "value-normal",
    valueLarge: "value-large",
    valueSub: "value-sub"
  },
  jn = {
    tooltips: ".__tooltips",
    aria: ".__aria"
  };
function testStep(t, e) {
  if (!isNumeric(e)) throw new Error("noUiSlider: 'step' is not numeric.");
  t.singleStep = e;
}
o(testStep, "testStep");
function testKeyboardPageMultiplier(t, e) {
  if (!isNumeric(e)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
  t.keyboardPageMultiplier = e;
}
o(testKeyboardPageMultiplier, "testKeyboardPageMultiplier");
function testKeyboardMultiplier(t, e) {
  if (!isNumeric(e)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
  t.keyboardMultiplier = e;
}
o(testKeyboardMultiplier, "testKeyboardMultiplier");
function testKeyboardDefaultStep(t, e) {
  if (!isNumeric(e)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
  t.keyboardDefaultStep = e;
}
o(testKeyboardDefaultStep, "testKeyboardDefaultStep");
function testRange(t, e) {
  if (typeof e != "object" || Array.isArray(e)) throw new Error("noUiSlider: 'range' is not an object.");
  if (e.min === void 0 || e.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
  t.spectrum = new nb(e, t.snap || !1, t.singleStep);
}
o(testRange, "testRange");
function testStart(t, e) {
  if (e = asArray(e), !Array.isArray(e) || !e.length) throw new Error("noUiSlider: 'start' option is incorrect.");
  t.handles = e.length, t.start = e;
}
o(testStart, "testStart");
function testSnap(t, e) {
  if (typeof e != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
  t.snap = e;
}
o(testSnap, "testSnap");
function testAnimate(t, e) {
  if (typeof e != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
  t.animate = e;
}
o(testAnimate, "testAnimate");
function testAnimationDuration(t, e) {
  if (typeof e != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
  t.animationDuration = e;
}
o(testAnimationDuration, "testAnimationDuration");
function testConnect(t, e) {
  var n = [!1],
    r;
  if (e === "lower" ? e = [!0, !1] : e === "upper" && (e = [!1, !0]), e === !0 || e === !1) {
    for (r = 1; r < t.handles; r++) n.push(e);
    n.push(!1);
  } else {
    if (!Array.isArray(e) || !e.length || e.length !== t.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
    n = e;
  }
  t.connect = n;
}
o(testConnect, "testConnect");
function testOrientation(t, e) {
  switch (e) {
    case "horizontal":
      t.ort = 0;
      break;
    case "vertical":
      t.ort = 1;
      break;
    default:
      throw new Error("noUiSlider: 'orientation' option is invalid.");
  }
}
o(testOrientation, "testOrientation");
function testMargin(t, e) {
  if (!isNumeric(e)) throw new Error("noUiSlider: 'margin' option must be numeric.");
  e !== 0 && (t.margin = t.spectrum.getDistance(e));
}
o(testMargin, "testMargin");
function testLimit(t, e) {
  if (!isNumeric(e)) throw new Error("noUiSlider: 'limit' option must be numeric.");
  if (t.limit = t.spectrum.getDistance(e), !t.limit || t.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
}
o(testLimit, "testLimit");
function testPadding(t, e) {
  var n;
  if (!isNumeric(e) && !Array.isArray(e)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
  if (Array.isArray(e) && !(e.length === 2 || isNumeric(e[0]) || isNumeric(e[1]))) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
  if (e !== 0) {
    for (Array.isArray(e) || (e = [e, e]), t.padding = [t.spectrum.getDistance(e[0]), t.spectrum.getDistance(e[1])], n = 0; n < t.spectrum.xNumSteps.length - 1; n++) if (t.padding[0][n] < 0 || t.padding[1][n] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
    var r = e[0] + e[1],
      i = t.spectrum.xVal[0],
      s = t.spectrum.xVal[t.spectrum.xVal.length - 1];
    if (r / (s - i) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
  }
}
o(testPadding, "testPadding");
function testDirection(t, e) {
  switch (e) {
    case "ltr":
      t.dir = 0;
      break;
    case "rtl":
      t.dir = 1;
      break;
    default:
      throw new Error("noUiSlider: 'direction' option was not recognized.");
  }
}
o(testDirection, "testDirection");
function testBehaviour(t, e) {
  if (typeof e != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
  var n = e.indexOf("tap") >= 0,
    r = e.indexOf("drag") >= 0,
    i = e.indexOf("fixed") >= 0,
    s = e.indexOf("snap") >= 0,
    a = e.indexOf("hover") >= 0,
    l = e.indexOf("unconstrained") >= 0,
    u = e.indexOf("invert-connects") >= 0,
    c = e.indexOf("drag-all") >= 0,
    p = e.indexOf("smooth-steps") >= 0;
  if (i) {
    if (t.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
    testMargin(t, t.start[1] - t.start[0]);
  }
  if (u && t.handles !== 2) throw new Error("noUiSlider: 'invert-connects' behaviour must be used with 2 handles");
  if (l && (t.margin || t.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
  t.events = {
    tap: n || s,
    drag: r,
    dragAll: c,
    smoothSteps: p,
    fixed: i,
    snap: s,
    hover: a,
    unconstrained: l,
    invertConnects: u
  };
}
o(testBehaviour, "testBehaviour");
function testTooltips(t, e) {
  if (e !== !1) if (e === !0 || isValidPartialFormatter(e)) {
    t.tooltips = [];
    for (var n = 0; n < t.handles; n++) t.tooltips.push(e);
  } else {
    if (e = asArray(e), e.length !== t.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
    e.forEach(function (r) {
      if (typeof r != "boolean" && !isValidPartialFormatter(r)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
    }), t.tooltips = e;
  }
}
o(testTooltips, "testTooltips");
function testHandleAttributes(t, e) {
  if (e.length !== t.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
  t.handleAttributes = e;
}
o(testHandleAttributes, "testHandleAttributes");
function testAriaFormat(t, e) {
  if (!isValidPartialFormatter(e)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
  t.ariaFormat = e;
}
o(testAriaFormat, "testAriaFormat");
function testFormat(t, e) {
  if (!isValidFormatter(e)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
  t.format = e;
}
o(testFormat, "testFormat");
function testKeyboardSupport(t, e) {
  if (typeof e != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
  t.keyboardSupport = e;
}
o(testKeyboardSupport, "testKeyboardSupport");
function testDocumentElement(t, e) {
  t.documentElement = e;
}
o(testDocumentElement, "testDocumentElement");
function testCssPrefix(t, e) {
  if (typeof e != "string" && e !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
  t.cssPrefix = e;
}
o(testCssPrefix, "testCssPrefix");
function testCssClasses(t, e) {
  if (typeof e != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
  typeof t.cssPrefix == "string" ? (t.cssClasses = {}, Object.keys(e).forEach(function (n) {
    t.cssClasses[n] = t.cssPrefix + e[n];
  })) : t.cssClasses = e;
}
o(testCssClasses, "testCssClasses");
function testOptions(t) {
  var e = {
      margin: null,
      limit: null,
      padding: null,
      animate: !0,
      animationDuration: 300,
      ariaFormat: Wg,
      format: Wg
    },
    n = {
      step: {
        r: !1,
        t: testStep
      },
      keyboardPageMultiplier: {
        r: !1,
        t: testKeyboardPageMultiplier
      },
      keyboardMultiplier: {
        r: !1,
        t: testKeyboardMultiplier
      },
      keyboardDefaultStep: {
        r: !1,
        t: testKeyboardDefaultStep
      },
      start: {
        r: !0,
        t: testStart
      },
      connect: {
        r: !0,
        t: testConnect
      },
      direction: {
        r: !0,
        t: testDirection
      },
      snap: {
        r: !1,
        t: testSnap
      },
      animate: {
        r: !1,
        t: testAnimate
      },
      animationDuration: {
        r: !1,
        t: testAnimationDuration
      },
      range: {
        r: !0,
        t: testRange
      },
      orientation: {
        r: !1,
        t: testOrientation
      },
      margin: {
        r: !1,
        t: testMargin
      },
      limit: {
        r: !1,
        t: testLimit
      },
      padding: {
        r: !1,
        t: testPadding
      },
      behaviour: {
        r: !0,
        t: testBehaviour
      },
      ariaFormat: {
        r: !1,
        t: testAriaFormat
      },
      format: {
        r: !1,
        t: testFormat
      },
      tooltips: {
        r: !1,
        t: testTooltips
      },
      keyboardSupport: {
        r: !0,
        t: testKeyboardSupport
      },
      documentElement: {
        r: !1,
        t: testDocumentElement
      },
      cssPrefix: {
        r: !0,
        t: testCssPrefix
      },
      cssClasses: {
        r: !0,
        t: testCssClasses
      },
      handleAttributes: {
        r: !1,
        t: testHandleAttributes
      }
    },
    r = {
      connect: !1,
      direction: "ltr",
      behaviour: "tap",
      orientation: "horizontal",
      keyboardSupport: !0,
      cssPrefix: "noUi-",
      cssClasses: rb,
      keyboardPageMultiplier: 5,
      keyboardMultiplier: 1,
      keyboardDefaultStep: 10
    };
  t.format && !t.ariaFormat && (t.ariaFormat = t.format), Object.keys(n).forEach(function (u) {
    if (!isSet$1(t[u]) && r[u] === void 0) {
      if (n[u].r) throw new Error("noUiSlider: '" + u + "' is required.");
      return;
    }
    n[u].t(e, isSet$1(t[u]) ? t[u] : r[u]);
  }), e.pips = t.pips;
  var i = document.createElement("div"),
    s = i.style.msTransform !== void 0,
    a = i.style.transform !== void 0;
  e.transformRule = a ? "transform" : s ? "msTransform" : "webkitTransform";
  var l = [["left", "top"], ["right", "bottom"]];
  return e.style = l[e.dir][e.ort], e;
}
o(testOptions, "testOptions");
function scope(t, e, n) {
  var r = getActions(),
    i = getSupportsTouchActionNone(),
    s = i && getSupportsPassive(),
    a = t,
    l,
    u,
    c,
    p,
    m,
    d,
    y = e.spectrum,
    S = [],
    w = [],
    g = [],
    h = 0,
    f = {},
    v = !1,
    E = t.ownerDocument,
    b = e.documentElement || E.documentElement,
    P = E.body,
    T = E.dir === "rtl" || e.ort === 1 ? 0 : 100;
  function addNodeTo(k, D) {
    var N = E.createElement("div");
    return D && addClass(N, D), k.appendChild(N), N;
  }
  o(addNodeTo, "addNodeTo");
  function addOrigin(k, D) {
    var N = addNodeTo(k, e.cssClasses.origin),
      G = addNodeTo(N, e.cssClasses.handle);
    if (addNodeTo(G, e.cssClasses.touchArea), G.setAttribute("data-handle", String(D)), e.keyboardSupport && (G.setAttribute("tabindex", "0"), G.addEventListener("keydown", function (Z) {
      return eventKeydown(Z, D);
    })), e.handleAttributes !== void 0) {
      var J = e.handleAttributes[D];
      Object.keys(J).forEach(function (Z) {
        G.setAttribute(Z, J[Z]);
      });
    }
    return G.setAttribute("role", "slider"), G.setAttribute("aria-orientation", e.ort ? "vertical" : "horizontal"), D === 0 ? addClass(G, e.cssClasses.handleLower) : D === e.handles - 1 && addClass(G, e.cssClasses.handleUpper), N.handle = G, N;
  }
  o(addOrigin, "addOrigin");
  function addConnect(k, D) {
    return D ? addNodeTo(k, e.cssClasses.connect) : !1;
  }
  o(addConnect, "addConnect");
  function addElements(k, D) {
    u = addNodeTo(D, e.cssClasses.connects), c = [], p = [], p.push(addConnect(u, k[0]));
    for (var N = 0; N < e.handles; N++) c.push(addOrigin(D, N)), g[N] = N, p.push(addConnect(u, k[N + 1]));
  }
  o(addElements, "addElements");
  function addSlider(k) {
    addClass(k, e.cssClasses.target), e.dir === 0 ? addClass(k, e.cssClasses.ltr) : addClass(k, e.cssClasses.rtl), e.ort === 0 ? addClass(k, e.cssClasses.horizontal) : addClass(k, e.cssClasses.vertical);
    var D = getComputedStyle(k).direction;
    return D === "rtl" ? addClass(k, e.cssClasses.textDirectionRtl) : addClass(k, e.cssClasses.textDirectionLtr), addNodeTo(k, e.cssClasses.base);
  }
  o(addSlider, "addSlider");
  function addTooltip(k, D) {
    return !e.tooltips || !e.tooltips[D] ? !1 : addNodeTo(k.firstChild, e.cssClasses.tooltip);
  }
  o(addTooltip, "addTooltip");
  function isSliderDisabled() {
    return a.hasAttribute("disabled");
  }
  o(isSliderDisabled, "isSliderDisabled");
  function isHandleDisabled(k) {
    var D = c[k];
    return D.hasAttribute("disabled");
  }
  o(isHandleDisabled, "isHandleDisabled");
  function disable$5(k) {
    k != null ? (c[k].setAttribute("disabled", ""), c[k].handle.removeAttribute("tabindex")) : (a.setAttribute("disabled", ""), c.forEach(function (D) {
      D.handle.removeAttribute("tabindex");
    }));
  }
  o(disable$5, "disable");
  function enable$5(k) {
    k != null ? (c[k].removeAttribute("disabled"), c[k].handle.setAttribute("tabindex", "0")) : (a.removeAttribute("disabled"), c.forEach(function (D) {
      D.removeAttribute("disabled"), D.handle.setAttribute("tabindex", "0");
    }));
  }
  o(enable$5, "enable");
  function removeTooltips() {
    d && (removeEvent("update" + jn.tooltips), d.forEach(function (k) {
      k && removeElement(k);
    }), d = null);
  }
  o(removeTooltips, "removeTooltips");
  function tooltips() {
    removeTooltips(), d = c.map(addTooltip), bindEvent("update" + jn.tooltips, function (k, D, N) {
      if (!(!d || !e.tooltips) && d[D] !== !1) {
        var G = k[D];
        e.tooltips[D] !== !0 && (G = e.tooltips[D].to(N[D])), d[D].innerHTML = G;
      }
    });
  }
  o(tooltips, "tooltips");
  function aria() {
    removeEvent("update" + jn.aria), bindEvent("update" + jn.aria, function (k, D, N, G, J) {
      g.forEach(function (Z) {
        var ue = c[Z],
          se = checkHandlePosition(w, Z, 0, !0, !0, !0),
          Pe = checkHandlePosition(w, Z, 100, !0, !0, !0),
          xe = J[Z],
          De = String(e.ariaFormat.to(N[Z]));
        se = y.fromStepping(se).toFixed(1), Pe = y.fromStepping(Pe).toFixed(1), xe = y.fromStepping(xe).toFixed(1), ue.children[0].setAttribute("aria-valuemin", se), ue.children[0].setAttribute("aria-valuemax", Pe), ue.children[0].setAttribute("aria-valuenow", xe), ue.children[0].setAttribute("aria-valuetext", De);
      });
    });
  }
  o(aria, "aria");
  function getGroup(k) {
    if (k.mode === Hn.Range || k.mode === Hn.Steps) return y.xVal;
    if (k.mode === Hn.Count) {
      if (k.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
      for (var D = k.values - 1, N = 100 / D, G = []; D--;) G[D] = D * N;
      return G.push(100), mapToRange(G, k.stepped);
    }
    return k.mode === Hn.Positions ? mapToRange(k.values, k.stepped) : k.mode === Hn.Values ? k.stepped ? k.values.map(function (J) {
      return y.fromStepping(y.getStep(y.toStepping(J)));
    }) : k.values : [];
  }
  o(getGroup, "getGroup");
  function mapToRange(k, D) {
    return k.map(function (N) {
      return y.fromStepping(D ? y.getStep(N) : N);
    });
  }
  o(mapToRange, "mapToRange");
  function generateSpread(k) {
    function safeIncrement(xe, De) {
      return Number((xe + De).toFixed(7));
    }
    o(safeIncrement, "safeIncrement");
    var N = getGroup(k),
      G = {},
      J = y.xVal[0],
      Z = y.xVal[y.xVal.length - 1],
      ue = !1,
      se = !1,
      Pe = 0;
    return N = unique(N.slice().sort(function (xe, De) {
      return xe - De;
    })), N[0] !== J && (N.unshift(J), ue = !0), N[N.length - 1] !== Z && (N.push(Z), se = !0), N.forEach(function (xe, De) {
      var Re,
        Se,
        Be,
        et = xe,
        Ue = N[De + 1],
        Ke,
        Vi,
        gr,
        mn,
        yr,
        Wi,
        Gi,
        bp = k.mode === Hn.Steps;
      for (bp && (Re = y.xNumSteps[De]), Re || (Re = Ue - et), Ue === void 0 && (Ue = et), Re = Math.max(Re, 1e-7), Se = et; Se <= Ue; Se = safeIncrement(Se, Re)) {
        for (Ke = y.toStepping(Se), Vi = Ke - Pe, yr = Vi / (k.density || 1), Wi = Math.round(yr), Gi = Vi / Wi, Be = 1; Be <= Wi; Be += 1) gr = Pe + Be * Gi, G[gr.toFixed(5)] = [y.fromStepping(gr), 0];
        mn = N.indexOf(Se) > -1 ? Pt.LargeValue : bp ? Pt.SmallValue : Pt.NoValue, !De && ue && Se !== Ue && (mn = 0), Se === Ue && se || (G[Ke.toFixed(5)] = [Se, mn]), Pe = Ke;
      }
    }), G;
  }
  o(generateSpread, "generateSpread");
  function addMarking(k, D, N) {
    var G,
      J,
      Z = E.createElement("div"),
      ue = (G = {}, G[Pt.None] = "", G[Pt.NoValue] = e.cssClasses.valueNormal, G[Pt.LargeValue] = e.cssClasses.valueLarge, G[Pt.SmallValue] = e.cssClasses.valueSub, G),
      se = (J = {}, J[Pt.None] = "", J[Pt.NoValue] = e.cssClasses.markerNormal, J[Pt.LargeValue] = e.cssClasses.markerLarge, J[Pt.SmallValue] = e.cssClasses.markerSub, J),
      Pe = [e.cssClasses.valueHorizontal, e.cssClasses.valueVertical],
      xe = [e.cssClasses.markerHorizontal, e.cssClasses.markerVertical];
    addClass(Z, e.cssClasses.pips), addClass(Z, e.ort === 0 ? e.cssClasses.pipsHorizontal : e.cssClasses.pipsVertical);
    function getClasses(Se, Be) {
      var et = Be === e.cssClasses.value,
        Ue = et ? Pe : xe,
        Ke = et ? ue : se;
      return Be + " " + Ue[e.ort] + " " + Ke[Se];
    }
    o(getClasses, "getClasses");
    function addSpread(Se, Be, et) {
      if (et = D ? D(Be, et) : et, et !== Pt.None) {
        var Ue = addNodeTo(Z, !1);
        Ue.className = getClasses(et, e.cssClasses.marker), Ue.style[e.style] = Se + "%", et > Pt.NoValue && (Ue = addNodeTo(Z, !1), Ue.className = getClasses(et, e.cssClasses.value), Ue.setAttribute("data-value", String(Be)), Ue.style[e.style] = Se + "%", Ue.innerHTML = String(N.to(Be)));
      }
    }
    return o(addSpread, "addSpread"), Object.keys(k).forEach(function (Se) {
      addSpread(Se, k[Se][0], k[Se][1]);
    }), Z;
  }
  o(addMarking, "addMarking");
  function removePips() {
    m && (removeElement(m), m = null);
  }
  o(removePips, "removePips");
  function pips(k) {
    removePips();
    var D = generateSpread(k),
      N = k.filter,
      G = k.format || {
        to: function (J) {
          return String(Math.round(J));
        }
      };
    return m = a.appendChild(addMarking(D, N, G)), m;
  }
  o(pips, "pips");
  function baseSize() {
    var k = l.getBoundingClientRect(),
      D = "offset" + ["Width", "Height"][e.ort];
    return e.ort === 0 ? k.width || l[D] : k.height || l[D];
  }
  o(baseSize, "baseSize");
  function attachEvent(k, D, N, G) {
    var method = o(function (ue) {
        var se = fixEvent(ue, G.pageOffset, G.target || D);
        if (!se || isSliderDisabled() && !G.doNotReject || hasClass(a, e.cssClasses.tap) && !G.doNotReject || k === r.start && se.buttons !== void 0 && se.buttons > 1 || G.hover && se.buttons) return !1;
        s || se.preventDefault(), se.calcPoint = se.points[e.ort], N(se, G);
      }, "method"),
      Z = [];
    return k.split(" ").forEach(function (ue) {
      D.addEventListener(ue, method, s ? {
        passive: !0
      } : !1), Z.push([ue, method]);
    }), Z;
  }
  o(attachEvent, "attachEvent");
  function fixEvent(k, D, N) {
    var G = k.type.indexOf("touch") === 0,
      J = k.type.indexOf("mouse") === 0,
      Z = k.type.indexOf("pointer") === 0,
      ue = 0,
      se = 0;
    if (k.type.indexOf("MSPointer") === 0 && (Z = !0), k.type === "mousedown" && !k.buttons && !k.touches) return !1;
    if (G) {
      var isTouchOnTarget = o(function (Re) {
        var Se = Re.target;
        return Se === N || N.contains(Se) || k.composed && k.composedPath().shift() === N;
      }, "isTouchOnTarget");
      if (k.type === "touchstart") {
        var xe = Array.prototype.filter.call(k.touches, isTouchOnTarget);
        if (xe.length > 1) return !1;
        ue = xe[0].pageX, se = xe[0].pageY;
      } else {
        var De = Array.prototype.find.call(k.changedTouches, isTouchOnTarget);
        if (!De) return !1;
        ue = De.pageX, se = De.pageY;
      }
    }
    return D = D || getPageOffset(E), (J || Z) && (ue = k.clientX + D.x, se = k.clientY + D.y), k.pageOffset = D, k.points = [ue, se], k.cursor = J || Z, k;
  }
  o(fixEvent, "fixEvent");
  function calcPointToPercentage(k) {
    var D = k - offset(l, e.ort),
      N = D * 100 / baseSize();
    return N = limit(N), e.dir ? 100 - N : N;
  }
  o(calcPointToPercentage, "calcPointToPercentage");
  function getClosestHandle(k) {
    var D = 100,
      N = !1;
    return c.forEach(function (G, J) {
      if (!isHandleDisabled(J)) {
        var Z = w[J],
          ue = Math.abs(Z - k),
          se = ue === 100 && D === 100,
          Pe = ue < D,
          xe = ue <= D && k > Z;
        (Pe || xe || se) && (N = J, D = ue);
      }
    }), N;
  }
  o(getClosestHandle, "getClosestHandle");
  function documentLeave(k, D) {
    k.type === "mouseout" && k.target.nodeName === "HTML" && k.relatedTarget === null && eventEnd(k, D);
  }
  o(documentLeave, "documentLeave");
  function eventMove(k, D) {
    if (navigator.appVersion.indexOf("MSIE 9") === -1 && k.buttons === 0 && D.buttonsProperty !== 0) return eventEnd(k, D);
    var N = (e.dir ? -1 : 1) * (k.calcPoint - D.startCalcPoint),
      G = N * 100 / D.baseSize;
    moveHandles(N > 0, G, D.locations, D.handleNumbers, D.connect);
  }
  o(eventMove, "eventMove");
  function eventEnd(k, D) {
    D.handle && (removeClass(D.handle, e.cssClasses.active), h -= 1), D.listeners.forEach(function (N) {
      b.removeEventListener(N[0], N[1]);
    }), h === 0 && (removeClass(a, e.cssClasses.drag), setZindex(), k.cursor && (P.style.cursor = "", P.removeEventListener("selectstart", preventDefault))), e.events.smoothSteps && (D.handleNumbers.forEach(function (N) {
      setHandle(N, w[N], !0, !0, !1, !1);
    }), D.handleNumbers.forEach(function (N) {
      fireEvent("update", N);
    })), D.handleNumbers.forEach(function (N) {
      fireEvent("change", N), fireEvent("set", N), fireEvent("end", N);
    });
  }
  o(eventEnd, "eventEnd");
  function eventStart(k, D) {
    if (!D.handleNumbers.some(isHandleDisabled)) {
      var N;
      if (D.handleNumbers.length === 1) {
        var G = c[D.handleNumbers[0]];
        N = G.children[0], h += 1, addClass(N, e.cssClasses.active);
      }
      k.stopPropagation();
      var J = [],
        Z = attachEvent(r.move, b, eventMove, {
          target: k.target,
          handle: N,
          connect: D.connect,
          listeners: J,
          startCalcPoint: k.calcPoint,
          baseSize: baseSize(),
          pageOffset: k.pageOffset,
          handleNumbers: D.handleNumbers,
          buttonsProperty: k.buttons,
          locations: w.slice()
        }),
        ue = attachEvent(r.end, b, eventEnd, {
          target: k.target,
          handle: N,
          listeners: J,
          doNotReject: !0,
          handleNumbers: D.handleNumbers
        }),
        se = attachEvent("mouseout", b, documentLeave, {
          target: k.target,
          handle: N,
          listeners: J,
          doNotReject: !0,
          handleNumbers: D.handleNumbers
        });
      J.push.apply(J, Z.concat(ue, se)), k.cursor && (P.style.cursor = getComputedStyle(k.target).cursor, c.length > 1 && addClass(a, e.cssClasses.drag), P.addEventListener("selectstart", preventDefault, !1)), D.handleNumbers.forEach(function (Pe) {
        fireEvent("start", Pe);
      });
    }
  }
  o(eventStart, "eventStart");
  function eventTap(k) {
    k.stopPropagation();
    var D = calcPointToPercentage(k.calcPoint),
      N = getClosestHandle(D);
    N !== !1 && (e.events.snap || addClassFor(a, e.cssClasses.tap, e.animationDuration), setHandle(N, D, !0, !0), setZindex(), fireEvent("slide", N, !0), fireEvent("update", N, !0), e.events.snap ? eventStart(k, {
      handleNumbers: [N]
    }) : (fireEvent("change", N, !0), fireEvent("set", N, !0)));
  }
  o(eventTap, "eventTap");
  function eventHover(k) {
    var D = calcPointToPercentage(k.calcPoint),
      N = y.getStep(D),
      G = y.fromStepping(N);
    Object.keys(f).forEach(function (J) {
      J.split(".")[0] === "hover" && f[J].forEach(function (Z) {
        Z.call(Nt, G);
      });
    });
  }
  o(eventHover, "eventHover");
  function eventKeydown(k, D) {
    if (isSliderDisabled() || isHandleDisabled(D)) return !1;
    var N = ["Left", "Right"],
      G = ["Down", "Up"],
      J = ["PageDown", "PageUp"],
      Z = ["Home", "End"];
    e.dir && !e.ort ? N.reverse() : e.ort && !e.dir && (G.reverse(), J.reverse());
    var ue = k.key.replace("Arrow", ""),
      se = ue === J[0],
      Pe = ue === J[1],
      xe = ue === G[0] || ue === N[0] || se,
      De = ue === G[1] || ue === N[1] || Pe,
      Re = ue === Z[0],
      Se = ue === Z[1];
    if (!xe && !De && !Re && !Se) return !0;
    k.preventDefault();
    var Be;
    if (De || xe) {
      var et = xe ? 0 : 1,
        Ue = getNextStepsForHandle(D),
        Ke = Ue[et];
      if (Ke === null) return !1;
      Ke === !1 && (Ke = y.getDefaultStep(w[D], xe, e.keyboardDefaultStep)), Pe || se ? Ke *= e.keyboardPageMultiplier : Ke *= e.keyboardMultiplier, Ke = Math.max(Ke, 1e-7), Ke = (xe ? -1 : 1) * Ke, Be = S[D] + Ke;
    } else Se ? Be = e.spectrum.xVal[e.spectrum.xVal.length - 1] : Be = e.spectrum.xVal[0];
    return setHandle(D, y.toStepping(Be), !0, !0), fireEvent("slide", D), fireEvent("update", D), fireEvent("change", D), fireEvent("set", D), !1;
  }
  o(eventKeydown, "eventKeydown");
  function bindSliderEvents(k) {
    k.fixed || c.forEach(function (D, N) {
      attachEvent(r.start, D.children[0], eventStart, {
        handleNumbers: [N]
      });
    }), k.tap && attachEvent(r.start, l, eventTap, {}), k.hover && attachEvent(r.move, l, eventHover, {
      hover: !0
    }), k.drag && p.forEach(function (D, N) {
      if (!(D === !1 || N === 0 || N === p.length - 1)) {
        var G = c[N - 1],
          J = c[N],
          Z = [D],
          ue = [G, J],
          se = [N - 1, N];
        addClass(D, e.cssClasses.draggable), k.fixed && (Z.push(G.children[0]), Z.push(J.children[0])), k.dragAll && (ue = c, se = g), Z.forEach(function (Pe) {
          attachEvent(r.start, Pe, eventStart, {
            handles: ue,
            handleNumbers: se,
            connect: D
          });
        });
      }
    });
  }
  o(bindSliderEvents, "bindSliderEvents");
  function bindEvent(k, D) {
    f[k] = f[k] || [], f[k].push(D), k.split(".")[0] === "update" && c.forEach(function (N, G) {
      fireEvent("update", G);
    });
  }
  o(bindEvent, "bindEvent");
  function isInternalNamespace(k) {
    return k === jn.aria || k === jn.tooltips;
  }
  o(isInternalNamespace, "isInternalNamespace");
  function removeEvent(k) {
    var D = k && k.split(".")[0],
      N = D ? k.substring(D.length) : k;
    Object.keys(f).forEach(function (G) {
      var J = G.split(".")[0],
        Z = G.substring(J.length);
      (!D || D === J) && (!N || N === Z) && (!isInternalNamespace(Z) || N === Z) && delete f[G];
    });
  }
  o(removeEvent, "removeEvent");
  function fireEvent(k, D, N) {
    Object.keys(f).forEach(function (G) {
      var J = G.split(".")[0];
      k === J && f[G].forEach(function (Z) {
        Z.call(Nt, S.map(e.format.to), D, S.slice(), N || !1, w.slice(), Nt);
      });
    });
  }
  o(fireEvent, "fireEvent");
  function checkHandlePosition(k, D, N, G, J, Z, ue) {
    var se;
    return c.length > 1 && !e.events.unconstrained && (G && D > 0 && (se = y.getAbsoluteDistance(k[D - 1], e.margin, !1), N = Math.max(N, se)), J && D < c.length - 1 && (se = y.getAbsoluteDistance(k[D + 1], e.margin, !0), N = Math.min(N, se))), c.length > 1 && e.limit && (G && D > 0 && (se = y.getAbsoluteDistance(k[D - 1], e.limit, !1), N = Math.min(N, se)), J && D < c.length - 1 && (se = y.getAbsoluteDistance(k[D + 1], e.limit, !0), N = Math.max(N, se))), e.padding && (D === 0 && (se = y.getAbsoluteDistance(0, e.padding[0], !1), N = Math.max(N, se)), D === c.length - 1 && (se = y.getAbsoluteDistance(100, e.padding[1], !0), N = Math.min(N, se))), ue || (N = y.getStep(N)), N = limit(N), N === k[D] && !Z ? !1 : N;
  }
  o(checkHandlePosition, "checkHandlePosition");
  function inRuleOrder(k, D) {
    var N = e.ort;
    return (N ? D : k) + ", " + (N ? k : D);
  }
  o(inRuleOrder, "inRuleOrder");
  function moveHandles(k, D, N, G, J) {
    var Z = N.slice(),
      ue = G[0],
      se = e.events.smoothSteps,
      Pe = [!k, k],
      xe = [k, !k];
    G = G.slice(), k && G.reverse(), G.length > 1 ? G.forEach(function (Re, Se) {
      var Be = checkHandlePosition(Z, Re, Z[Re] + D, Pe[Se], xe[Se], !1, se);
      Be === !1 ? D = 0 : (D = Be - Z[Re], Z[Re] = Be);
    }) : Pe = xe = [!0];
    var De = !1;
    G.forEach(function (Re, Se) {
      De = setHandle(Re, N[Re] + D, Pe[Se], xe[Se], !1, se) || De;
    }), De && (G.forEach(function (Re) {
      fireEvent("update", Re), fireEvent("slide", Re);
    }), J != null && fireEvent("drag", ue));
  }
  o(moveHandles, "moveHandles");
  function transformDirection(k, D) {
    return e.dir ? 100 - k - D : k;
  }
  o(transformDirection, "transformDirection");
  function updateHandlePosition(k, D) {
    w[k] = D, S[k] = y.fromStepping(D);
    var N = transformDirection(D, 0) - T,
      G = "translate(" + inRuleOrder(N + "%", "0") + ")";
    if (c[k].style[e.transformRule] = G, e.events.invertConnects && w.length > 1) {
      var J = w.every(function (Z, ue, se) {
        return ue === 0 || Z >= se[ue - 1];
      });
      if (v !== !J) {
        invertConnects();
        return;
      }
    }
    updateConnect(k), updateConnect(k + 1), v && (updateConnect(k - 1), updateConnect(k + 2));
  }
  o(updateHandlePosition, "updateHandlePosition");
  function setZindex() {
    g.forEach(function (k) {
      var D = w[k] > 50 ? -1 : 1,
        N = 3 + (c.length + D * k);
      c[k].style.zIndex = String(N);
    });
  }
  o(setZindex, "setZindex");
  function setHandle(k, D, N, G, J, Z) {
    return J || (D = checkHandlePosition(w, k, D, N, G, !1, Z)), D === !1 ? !1 : (updateHandlePosition(k, D), !0);
  }
  o(setHandle, "setHandle");
  function updateConnect(k) {
    if (p[k]) {
      var D = w.slice();
      v && D.sort(function (se, Pe) {
        return se - Pe;
      });
      var N = 0,
        G = 100;
      k !== 0 && (N = D[k - 1]), k !== p.length - 1 && (G = D[k]);
      var J = G - N,
        Z = "translate(" + inRuleOrder(transformDirection(N, J) + "%", "0") + ")",
        ue = "scale(" + inRuleOrder(J / 100, "1") + ")";
      p[k].style[e.transformRule] = Z + " " + ue;
    }
  }
  o(updateConnect, "updateConnect");
  function resolveToValue(k, D) {
    return k === null || k === !1 || k === void 0 || (typeof k == "number" && (k = String(k)), k = e.format.from(k), k !== !1 && (k = y.toStepping(k)), k === !1 || isNaN(k)) ? w[D] : k;
  }
  o(resolveToValue, "resolveToValue");
  function valueSet(k, D, N) {
    var G = asArray(k),
      J = w[0] === void 0;
    D = D === void 0 ? !0 : D, e.animate && !J && addClassFor(a, e.cssClasses.tap, e.animationDuration), g.forEach(function (se) {
      setHandle(se, resolveToValue(G[se], se), !0, !1, N);
    });
    var Z = g.length === 1 ? 0 : 1;
    if (J && y.hasNoSize() && (N = !0, w[0] = 0, g.length > 1)) {
      var ue = 100 / (g.length - 1);
      g.forEach(function (se) {
        w[se] = se * ue;
      });
    }
    for (; Z < g.length; ++Z) g.forEach(function (se) {
      setHandle(se, w[se], !0, !0, N);
    });
    setZindex(), g.forEach(function (se) {
      fireEvent("update", se), G[se] !== null && D && fireEvent("set", se);
    });
  }
  o(valueSet, "valueSet");
  function valueReset(k) {
    valueSet(e.start, k);
  }
  o(valueReset, "valueReset");
  function valueSetHandle(k, D, N, G) {
    if (k = Number(k), !(k >= 0 && k < g.length)) throw new Error("noUiSlider: invalid handle number, got: " + k);
    setHandle(k, resolveToValue(D, k), !0, !0, G), fireEvent("update", k), N && fireEvent("set", k);
  }
  o(valueSetHandle, "valueSetHandle");
  function valueGet(k) {
    if (k === void 0 && (k = !1), k) return S.length === 1 ? S[0] : S.slice(0);
    var D = S.map(e.format.to);
    return D.length === 1 ? D[0] : D;
  }
  o(valueGet, "valueGet");
  function destroy$5() {
    for (removeEvent(jn.aria), removeEvent(jn.tooltips), Object.keys(e.cssClasses).forEach(function (k) {
      removeClass(a, e.cssClasses[k]);
    }); a.firstChild;) a.removeChild(a.firstChild);
    delete a.noUiSlider;
  }
  o(destroy$5, "destroy");
  function getNextStepsForHandle(k) {
    var D = w[k],
      N = y.getNearbySteps(D),
      G = S[k],
      J = N.thisStep.step,
      Z = null;
    if (e.snap) return [G - N.stepBefore.startValue || null, N.stepAfter.startValue - G || null];
    J !== !1 && G + J > N.stepAfter.startValue && (J = N.stepAfter.startValue - G), G > N.thisStep.startValue ? Z = N.thisStep.step : N.stepBefore.step === !1 ? Z = !1 : Z = G - N.stepBefore.highestStep, D === 100 ? J = null : D === 0 && (Z = null);
    var ue = y.countStepDecimals();
    return J !== null && J !== !1 && (J = Number(J.toFixed(ue))), Z !== null && Z !== !1 && (Z = Number(Z.toFixed(ue))), [Z, J];
  }
  o(getNextStepsForHandle, "getNextStepsForHandle");
  function getNextSteps() {
    return g.map(getNextStepsForHandle);
  }
  o(getNextSteps, "getNextSteps");
  function updateOptions(k, D) {
    var N = valueGet(),
      G = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips", "connect"];
    G.forEach(function (Z) {
      k[Z] !== void 0 && (n[Z] = k[Z]);
    });
    var J = testOptions(n);
    G.forEach(function (Z) {
      k[Z] !== void 0 && (e[Z] = J[Z]);
    }), y = J.spectrum, e.margin = J.margin, e.limit = J.limit, e.padding = J.padding, e.pips ? pips(e.pips) : removePips(), e.tooltips ? tooltips() : removeTooltips(), w = [], valueSet(isSet$1(k.start) ? k.start : N, D), k.connect && updateConnectOption();
  }
  o(updateOptions, "updateOptions");
  function updateConnectOption() {
    for (; u.firstChild;) u.removeChild(u.firstChild);
    for (var k = 0; k <= e.handles; k++) p[k] = addConnect(u, e.connect[k]), updateConnect(k);
    bindSliderEvents({
      drag: e.events.drag,
      fixed: !0
    });
  }
  o(updateConnectOption, "updateConnectOption");
  function invertConnects() {
    v = !v, testConnect(e, e.connect.map(function (k) {
      return !k;
    })), updateConnectOption();
  }
  o(invertConnects, "invertConnects");
  function setupSlider() {
    l = addSlider(a), addElements(e.connect, l), bindSliderEvents(e.events), valueSet(e.start), e.pips && pips(e.pips), e.tooltips && tooltips(), aria();
  }
  o(setupSlider, "setupSlider"), setupSlider();
  var Nt = {
    destroy: destroy$5,
    steps: getNextSteps,
    on: bindEvent,
    off: removeEvent,
    get: valueGet,
    set: valueSet,
    setHandle: valueSetHandle,
    reset: valueReset,
    disable: disable$5,
    enable: enable$5,
    __moveHandles: function (k, D, N) {
      moveHandles(k, D, w, N);
    },
    options: n,
    updateOptions: updateOptions,
    target: a,
    removePips: removePips,
    removeTooltips: removeTooltips,
    getPositions: function () {
      return w.slice();
    },
    getTooltips: function () {
      return d;
    },
    getOrigins: function () {
      return c;
    },
    pips: pips
  };
  return Nt;
}
o(scope, "scope");
function initialize(t, e) {
  if (!t || !t.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + t);
  if (t.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
  var n = testOptions(e),
    r = scope(t, n, e);
  return t.noUiSlider = r, r;
}
o(initialize, "initialize");
const noUiSlider = {
  __spectrum: nb,
  cssClasses: rb,
  create: initialize
};
var QO = lw,
  JO = uw,
  ZO = "[object Number]";
function isNumber$3(t) {
  return typeof t == "number" || JO(t) && QO(t) == ZO;
}
o(isNumber$3, "isNumber$2");
var tA = isNumber$3;
const isNumber = getDefaultExportFromCjs(tA);
function _defineProperty(t, e, n) {
  return (e = _toPropertyKey(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
o(_defineProperty, "_defineProperty$1");
function _toPrimitive(t, e) {
  if (typeof t != "object" || t === null) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
o(_toPrimitive, "_toPrimitive");
function _toPropertyKey(string) {
  var string$1 = _toPrimitive(string, "string");
  return typeof string$1 == "symbol" ? string$1 : String(string$1);
}
o(_toPropertyKey, "_toPropertyKey");
function _classCallCheck(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
o(_classCallCheck, "_classCallCheck");
function _defineProperties(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
o(_defineProperties, "_defineProperties");
function _createClass(t, e, n) {
  return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), t;
}
o(_createClass, "_createClass");
function _defineProperty$1(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
o(_defineProperty$1, "_defineProperty");
function ownKeys(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
o(ownKeys, "ownKeys");
function _objectSpread2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys(Object(n), !0).forEach(function (r) {
      _defineProperty$1(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
o(_objectSpread2, "_objectSpread2");
var Kg = {
  addCSS: !0,
  thumbWidth: 15,
  watch: !0
};
function matches(t, e) {
  return function () {
    return Array.from(document.querySelectorAll(e)).includes(this);
  }.call(t, e);
}
o(matches, "matches$1");
function trigger(t, e) {
  if (t && e) {
    var n = new Event(e, {
      bubbles: !0
    });
    t.dispatchEvent(n);
  }
}
o(trigger, "trigger");
var getConstructor = o(function (t) {
    return t != null ? t.constructor : null;
  }, "getConstructor$1"),
  instanceOf = o(function (t, e) {
    return !!(t && e && t instanceof e);
  }, "instanceOf$1"),
  isNullOrUndefined$1 = o(function (t) {
    return t == null;
  }, "isNullOrUndefined$1"),
  isObject$5 = o(function (t) {
    return getConstructor(t) === Object;
  }, "isObject$1"),
  isNumber$4 = o(function (t) {
    return getConstructor(t) === Number && !Number.isNaN(t);
  }, "isNumber$1"),
  isString$2 = o(function (t) {
    return getConstructor(t) === String;
  }, "isString$1"),
  isBoolean$2 = o(function (t) {
    return getConstructor(t) === Boolean;
  }, "isBoolean$1"),
  isFunction$1 = o(function (t) {
    return getConstructor(t) === Function;
  }, "isFunction$1"),
  isArray$2 = o(function (t) {
    return Array.isArray(t);
  }, "isArray$1"),
  isNodeList = o(function (t) {
    return instanceOf(t, NodeList);
  }, "isNodeList$1"),
  isElement$1 = o(function (t) {
    return instanceOf(t, Element);
  }, "isElement$1"),
  isEvent = o(function (t) {
    return instanceOf(t, Event);
  }, "isEvent$1"),
  isEmpty = o(function (t) {
    return isNullOrUndefined$1(t) || (isString$2(t) || isArray$2(t) || isNodeList(t)) && !t.length || isObject$5(t) && !Object.keys(t).length;
  }, "isEmpty$1"),
  yt = {
    nullOrUndefined: isNullOrUndefined$1,
    object: isObject$5,
    number: isNumber$4,
    string: isString$2,
    boolean: isBoolean$2,
    function: isFunction$1,
    array: isArray$2,
    nodeList: isNodeList,
    element: isElement$1,
    event: isEvent,
    empty: isEmpty
  };
function getDecimalPlaces(t) {
  var e = "".concat(t).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  return e ? Math.max(0, (e[1] ? e[1].length : 0) - (e[2] ? +e[2] : 0)) : 0;
}
o(getDecimalPlaces, "getDecimalPlaces");
function round(t, e) {
  if (1 > e) {
    var n = getDecimalPlaces(e);
    return parseFloat(t.toFixed(n));
  }
  return Math.round(t / e) * e;
}
o(round, "round");
var yA = function () {
  function e$1(e, n) {
    _classCallCheck(this, e$1), yt.element(e) ? this.element = e : yt.string(e) && (this.element = document.querySelector(e)), yt.element(this.element) && yt.empty(this.element.rangeTouch) && (this.config = _objectSpread2({}, Kg, {}, n), this.init());
  }
  return o(e$1, "e"), _createClass(e$1, [{
    key: "init",
    value: function () {
      e$1.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
    }
  }, {
    key: "destroy",
    value: function () {
      e$1.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
    }
  }, {
    key: "listeners",
    value: function (e) {
      var n = this,
        r = e ? "addEventListener" : "removeEventListener";
      ["touchstart", "touchmove", "touchend"].forEach(function (i) {
        n.element[r](i, function (s) {
          return n.set(s);
        }, !1);
      });
    }
  }, {
    key: "get",
    value: function (e) {
      if (!e$1.enabled || !yt.event(e)) return null;
      var n,
        r = e.target,
        i = e.changedTouches[0],
        s = parseFloat(r.getAttribute("min")) || 0,
        a = parseFloat(r.getAttribute("max")) || 100,
        l = parseFloat(r.getAttribute("step")) || 1,
        u = r.getBoundingClientRect(),
        c = 100 / u.width * (this.config.thumbWidth / 2) / 100;
      return 0 > (n = 100 / u.width * (i.clientX - u.left)) ? n = 0 : 100 < n && (n = 100), 50 > n ? n -= (100 - 2 * n) * c : 50 < n && (n += 2 * (n - 50) * c), s + round(n / 100 * (a - s), l);
    }
  }, {
    key: "set",
    value: function (e) {
      e$1.enabled && yt.event(e) && !e.target.disabled && (e.preventDefault(), e.target.value = this.get(e), trigger(e.target, e.type === "touchend" ? "change" : "input"));
    }
  }], [{
    key: "setup",
    value: function (e) {
      var n = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
        r = null;
      if (yt.empty(e) || yt.string(e) ? r = Array.from(document.querySelectorAll(yt.string(e) ? e : 'input[type="range"]')) : yt.element(e) ? r = [e] : yt.nodeList(e) ? r = Array.from(e) : yt.array(e) && (r = e.filter(yt.element)), yt.empty(r)) return null;
      var i = _objectSpread2({}, Kg, {}, n);
      if (yt.string(e) && i.watch) {
        var s = new MutationObserver(function (a) {
          Array.from(a).forEach(function (l) {
            Array.from(l.addedNodes).forEach(function (u) {
              yt.element(u) && matches(u, e) && new e$1(u, i);
            });
          });
        });
        s.observe(document.body, {
          childList: !0,
          subtree: !0
        });
      }
      return r.map(function (a) {
        return new e$1(a, n);
      });
    }
  }, {
    key: "enabled",
    get: function () {
      return "ontouchstart" in document.documentElement;
    }
  }]), e$1;
}();
const getConstructor$1 = o(t => t != null ? t.constructor : null, "getConstructor"),
  instanceOf$1 = o((t, e) => !!(t && e && t instanceof e), "instanceOf"),
  isNullOrUndefined$2 = o(t => t == null, "isNullOrUndefined"),
  isObject$6 = o(t => getConstructor$1(t) === Object, "isObject"),
  isNumber$5 = o(t => getConstructor$1(t) === Number && !Number.isNaN(t), "isNumber"),
  isString$3 = o(t => getConstructor$1(t) === String, "isString"),
  isBoolean$3 = o(t => getConstructor$1(t) === Boolean, "isBoolean"),
  isFunction$2 = o(t => typeof t == "function", "isFunction"),
  isArray$3 = o(t => Array.isArray(t), "isArray"),
  isWeakMap$1 = o(t => instanceOf$1(t, WeakMap), "isWeakMap"),
  isNodeList$1 = o(t => instanceOf$1(t, NodeList), "isNodeList"),
  isTextNode = o(t => getConstructor$1(t) === Text, "isTextNode"),
  isEvent$1 = o(t => instanceOf$1(t, Event), "isEvent"),
  isKeyboardEvent = o(t => instanceOf$1(t, KeyboardEvent), "isKeyboardEvent"),
  isCue = o(t => instanceOf$1(t, window.TextTrackCue) || instanceOf$1(t, window.VTTCue), "isCue"),
  isTrack = o(t => instanceOf$1(t, TextTrack) || !isNullOrUndefined$2(t) && isString$3(t.kind), "isTrack"),
  isPromise = o(t => instanceOf$1(t, Promise) && isFunction$2(t.then), "isPromise"),
  isElement$2 = o(t => t !== null && typeof t == "object" && t.nodeType === 1 && typeof t.style == "object" && typeof t.ownerDocument == "object", "isElement"),
  isEmpty$1 = o(t => isNullOrUndefined$2(t) || (isString$3(t) || isArray$3(t) || isNodeList$1(t)) && !t.length || isObject$6(t) && !Object.keys(t).length, "isEmpty"),
  isUrl = o(t => {
    if (instanceOf$1(t, window.URL)) return !0;
    if (!isString$3(t)) return !1;
    let e = t;
    t.startsWith("http://") && t.startsWith("https://") || (e = `http://${t}`);
    try {
      return !isEmpty$1(new URL(e).hostname);
    } catch {
      return !1;
    }
  }, "isUrl");
var x = {
  nullOrUndefined: isNullOrUndefined$2,
  object: isObject$6,
  number: isNumber$5,
  string: isString$3,
  boolean: isBoolean$3,
  function: isFunction$2,
  array: isArray$3,
  weakMap: isWeakMap$1,
  nodeList: isNodeList$1,
  element: isElement$2,
  textNode: isTextNode,
  event: isEvent$1,
  keyboardEvent: isKeyboardEvent,
  cue: isCue,
  track: isTrack,
  promise: isPromise,
  url: isUrl,
  empty: isEmpty$1
};
const Ff = (() => {
  const t = document.createElement("span"),
    e = {
      WebkitTransition: "webkitTransitionEnd",
      MozTransition: "transitionend",
      OTransition: "oTransitionEnd otransitionend",
      transition: "transitionend"
    },
    n = Object.keys(e).find(r => t.style[r] !== void 0);
  return !!x.string(n) && e[n];
})();
function repaint(t, e) {
  setTimeout(() => {
    try {
      t.hidden = !0, t.offsetHeight, t.hidden = !1;
    } catch {}
  }, e);
}
o(repaint, "repaint");
const OA = !!window.document.documentMode,
  AA = /Edge/g.test(navigator.userAgent),
  LA = "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
  MA = /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
  DA = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1,
  IA = /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
var at = {
  isIE: OA,
  isEdge: AA,
  isWebKit: LA,
  isIPhone: MA,
  isIPadOS: DA,
  isIos: IA
};
function cloneDeep(t) {
  return JSON.parse(JSON.stringify(t));
}
o(cloneDeep, "cloneDeep");
function getDeep(t, e) {
  return e.split(".").reduce((n, r) => n && n[r], t);
}
o(getDeep, "getDeep");
function extend$4(t = {}, ...e) {
  if (!e.length) return t;
  const n = e.shift();
  return x.object(n) ? (Object.keys(n).forEach(r => {
    x.object(n[r]) ? (Object.keys(t).includes(r) || Object.assign(t, {
      [r]: {}
    }), extend$4(t[r], n[r])) : Object.assign(t, {
      [r]: n[r]
    });
  }), extend$4(t, ...e)) : t;
}
o(extend$4, "extend");
function wrap(t, e) {
  const n = t.length ? t : [t];
  Array.from(n).reverse().forEach((r, i) => {
    const s = i > 0 ? e.cloneNode(!0) : e,
      a = r.parentNode,
      l = r.nextSibling;
    s.appendChild(r), l ? a.insertBefore(s, l) : a.appendChild(s);
  });
}
o(wrap, "wrap");
function setAttributes(t, e) {
  x.element(t) && !x.empty(e) && Object.entries(e).filter(([, n]) => !x.nullOrUndefined(n)).forEach(([n, r]) => t.setAttribute(n, r));
}
o(setAttributes, "setAttributes");
function createElement$1(t, e, n) {
  const r = document.createElement(t);
  return x.object(e) && setAttributes(r, e), x.string(n) && (r.innerText = n), r;
}
o(createElement$1, "createElement");
function insertAfter(t, e) {
  x.element(t) && x.element(e) && e.parentNode.insertBefore(t, e.nextSibling);
}
o(insertAfter, "insertAfter");
function insertElement(t, e, n, r) {
  x.element(e) && e.appendChild(createElement$1(t, n, r));
}
o(insertElement, "insertElement");
function removeElement$1(t) {
  x.nodeList(t) || x.array(t) ? Array.from(t).forEach(removeElement$1) : x.element(t) && x.element(t.parentNode) && t.parentNode.removeChild(t);
}
o(removeElement$1, "removeElement");
function emptyElement(t) {
  if (!x.element(t)) return;
  let {
    length: e
  } = t.childNodes;
  for (; e > 0;) t.removeChild(t.lastChild), e -= 1;
}
o(emptyElement, "emptyElement");
function replaceElement(t, e) {
  return x.element(e) && x.element(e.parentNode) && x.element(t) ? (e.parentNode.replaceChild(t, e), t) : null;
}
o(replaceElement, "replaceElement");
function getAttributesFromSelector(t, e) {
  if (!x.string(t) || x.empty(t)) return {};
  const n = {},
    r = extend$4({}, e);
  return t.split(",").forEach(i => {
    const s = i.trim(),
      a = s.replace(".", ""),
      l = s.replace(/[[\]]/g, "").split("="),
      [u] = l,
      c = l.length > 1 ? l[1].replace(/["']/g, "") : "";
    switch (s.charAt(0)) {
      case ".":
        x.string(r.class) ? n.class = `${r.class} ${a}` : n.class = a;
        break;
      case "#":
        n.id = s.replace("#", "");
        break;
      case "[":
        n[u] = c;
    }
  }), extend$4(r, n);
}
o(getAttributesFromSelector, "getAttributesFromSelector");
function toggleHidden(t, e) {
  if (!x.element(t)) return;
  let n = e;
  x.boolean(n) || (n = !t.hidden), t.hidden = n;
}
o(toggleHidden, "toggleHidden");
function toggleClass(t, e, n) {
  if (x.nodeList(t)) return Array.from(t).map(r => toggleClass(r, e, n));
  if (x.element(t)) {
    let r = "toggle";
    return n !== void 0 && (r = n ? "add" : "remove"), t.classList[r](e), t.classList.contains(e);
  }
  return !1;
}
o(toggleClass, "toggleClass");
function hasClass$1(t, e) {
  return x.element(t) && t.classList.contains(e);
}
o(hasClass$1, "hasClass");
function matches$1(t, e) {
  const {
    prototype: n
  } = Element;
  return (n.matches || n.webkitMatchesSelector || n.mozMatchesSelector || n.msMatchesSelector || function () {
    return Array.from(document.querySelectorAll(e)).includes(this);
  }).call(t, e);
}
o(matches$1, "matches");
function closest$1(t, e) {
  const {
    prototype: n
  } = Element;
  return (n.closest || function () {
    let r = this;
    do {
      if (matches$1.matches(r, e)) return r;
      r = r.parentElement || r.parentNode;
    } while (r !== null && r.nodeType === 1);
    return null;
  }).call(t, e);
}
o(closest$1, "closest$1");
function getElements(t) {
  return this.elements.container.querySelectorAll(t);
}
o(getElements, "getElements");
function getElement(t) {
  return this.elements.container.querySelector(t);
}
o(getElement, "getElement");
function setFocus(t = null, e = !1) {
  x.element(t) && t.focus({
    preventScroll: !0,
    focusVisible: e
  });
}
o(setFocus, "setFocus");
const Jg = {
    "audio/ogg": "vorbis",
    "audio/wav": "1",
    "video/webm": "vp8, vorbis",
    "video/mp4": "avc1.42E01E, mp4a.40.2",
    "video/ogg": "theora"
  },
  Xe = {
    audio: "canPlayType" in document.createElement("audio"),
    video: "canPlayType" in document.createElement("video"),
    check(t, e) {
      const n = Xe[t] || e !== "html5";
      return {
        api: n,
        ui: n && Xe.rangeInput
      };
    },
    pip: !(at.isIPhone || !x.function(createElement$1("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || createElement$1("video").disablePictureInPicture)),
    airplay: x.function(window.WebKitPlaybackTargetAvailabilityEvent),
    playsinline: "playsInline" in document.createElement("video"),
    mime(t) {
      if (x.empty(t)) return !1;
      const [e] = t.split("/");
      let n = t;
      if (!this.isHTML5 || e !== this.type) return !1;
      Object.keys(Jg).includes(n) && (n += `; codecs="${Jg[t]}"`);
      try {
        return !!(n && this.media.canPlayType(n).replace(/no/, ""));
      } catch {
        return !1;
      }
    },
    textTracks: "textTracks" in document.createElement("video"),
    rangeInput: (() => {
      const t = document.createElement("input");
      return t.type = "range", t.type === "range";
    })(),
    touch: "ontouchstart" in document.documentElement,
    transitions: Ff !== !1,
    reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
  },
  FA = (() => {
    let t = !1;
    try {
      const e = Object.defineProperty({}, "passive", {
        get: () => (t = !0, null)
      });
      window.addEventListener("test", null, e), window.removeEventListener("test", null, e);
    } catch {}
    return t;
  })();
function toggleListener(t, e, n, r = !1, i = !0, s = !1) {
  if (!t || !("addEventListener" in t) || x.empty(e) || !x.function(n)) return;
  const a = e.split(" ");
  let l = s;
  FA && (l = {
    passive: i,
    capture: s
  }), a.forEach(u => {
    this && this.eventListeners && r && this.eventListeners.push({
      element: t,
      type: u,
      callback: n,
      options: l
    }), t[r ? "addEventListener" : "removeEventListener"](u, n, l);
  });
}
o(toggleListener, "toggleListener");
function on$1(t, e = "", n, r = !0, i = !1) {
  toggleListener.call(this, t, e, n, !0, r, i);
}
o(on$1, "on");
function off(t, e = "", n, r = !0, i = !1) {
  toggleListener.call(this, t, e, n, !1, r, i);
}
o(off, "off");
function once(t, e = "", n, r = !0, i = !1) {
  const r$1 = o((...a) => {
    off(t, e, r$1, r, i), n.apply(this, a);
  }, "r");
  toggleListener.call(this, t, e, r$1, !0, r, i);
}
o(once, "once");
function triggerEvent(t, e = "", n = !1, r = {}) {
  if (!x.element(t) || x.empty(e)) return;
  const i = new CustomEvent(e, {
    bubbles: n,
    detail: {
      ...r,
      plyr: this
    }
  });
  t.dispatchEvent(i);
}
o(triggerEvent, "triggerEvent");
function unbindListeners() {
  this && this.eventListeners && (this.eventListeners.forEach(t => {
    const {
      element: e,
      type: n,
      callback: r,
      options: i
    } = t;
    e.removeEventListener(n, r, i);
  }), this.eventListeners = []);
}
o(unbindListeners, "unbindListeners");
function ready() {
  return new Promise(t => this.ready ? setTimeout(t, 0) : on$1.call(this, this.elements.container, "ready", t)).then(() => {});
}
o(ready, "ready");
function silencePromise(t) {
  x.promise(t) && t.then(null, () => {});
}
o(silencePromise, "silencePromise");
function dedupe(t) {
  return x.array(t) ? t.filter((e, n) => t.indexOf(e) === n) : t;
}
o(dedupe, "dedupe");
function closest$2(t, e) {
  return x.array(t) && t.length ? t.reduce((n, r) => Math.abs(r - e) < Math.abs(n - e) ? r : n) : null;
}
o(closest$2, "closest");
function supportsCSS(t) {
  return !(!window || !window.CSS) && window.CSS.supports(t);
}
o(supportsCSS, "supportsCSS");
const Zg = [[1, 1], [4, 3], [3, 4], [5, 4], [4, 5], [3, 2], [2, 3], [16, 10], [10, 16], [16, 9], [9, 16], [21, 9], [9, 21], [32, 9], [9, 32]].reduce((t, [e, n]) => ({
  ...t,
  [e / n]: [e, n]
}), {});
function validateAspectRatio(t) {
  return x.array(t) || x.string(t) && t.includes(":") ? (x.array(t) ? t : t.split(":")).map(Number).every(x.number) : !1;
}
o(validateAspectRatio, "validateAspectRatio");
function reduceAspectRatio(t) {
  if (!x.array(t) || !t.every(x.number)) return null;
  const [e, n] = t,
    s$1 = o((s, a) => a === 0 ? s : s$1(a, s % a), "s"),
    i = s$1(e, n);
  return [e / i, n / i];
}
o(reduceAspectRatio, "reduceAspectRatio");
function getAspectRatio(t) {
  const t$1 = o(r => validateAspectRatio(r) ? r.split(":").map(Number) : null, "t");
  let n = t$1(t);
  if (n === null && (n = t$1(this.config.ratio)), n === null && !x.empty(this.embed) && x.array(this.embed.ratio) && ({
    ratio: n
  } = this.embed), n === null && this.isHTML5) {
    const {
      videoWidth: r,
      videoHeight: i
    } = this.media;
    n = [r, i];
  }
  return reduceAspectRatio(n);
}
o(getAspectRatio, "getAspectRatio");
function setAspectRatio(t) {
  if (!this.isVideo) return {};
  const {
      wrapper: e
    } = this.elements,
    n = getAspectRatio.call(this, t);
  if (!x.array(n)) return {};
  const [r, i] = reduceAspectRatio(n),
    s = 100 / r * i;
  if (supportsCSS(`aspect-ratio: ${r}/${i}`) ? e.style.aspectRatio = `${r}/${i}` : e.style.paddingBottom = `${s}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
    const a = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10),
      l = (a - s) / (a / 50);
    this.fullscreen.active ? e.style.paddingBottom = null : this.media.style.transform = `translateY(-${l}%)`;
  } else this.isHTML5 && e.classList.add(this.config.classNames.videoFixedRatio);
  return {
    padding: s,
    ratio: n
  };
}
o(setAspectRatio, "setAspectRatio");
function roundAspectRatio(t, e, n = .05) {
  const r = t / e,
    i = closest$2(Object.keys(Zg), r);
  return Math.abs(i - r) <= n ? Zg[i] : [t, e];
}
o(roundAspectRatio, "roundAspectRatio");
function getViewportSize() {
  return [Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0), Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)];
}
o(getViewportSize, "getViewportSize");
const Kn = {
  getSources() {
    return this.isHTML5 ? Array.from(this.media.querySelectorAll("source")).filter(t => {
      const e = t.getAttribute("type");
      return !!x.empty(e) || Xe.mime.call(this, e);
    }) : [];
  },
  getQualityOptions() {
    return this.config.quality.forced ? this.config.quality.options : Kn.getSources.call(this).map(t => Number(t.getAttribute("size"))).filter(Boolean);
  },
  setup() {
    if (!this.isHTML5) return;
    const t = this;
    t.options.speed = t.config.speed.options, x.empty(this.config.ratio) || setAspectRatio.call(t), Object.defineProperty(t.media, "quality", {
      get() {
        const e = Kn.getSources.call(t).find(n => n.getAttribute("src") === t.source);
        return e && Number(e.getAttribute("size"));
      },
      set(e) {
        if (t.quality !== e) {
          if (t.config.quality.forced && x.function(t.config.quality.onChange)) t.config.quality.onChange(e);else {
            const n = Kn.getSources.call(t).find(u => Number(u.getAttribute("size")) === e);
            if (!n) return;
            const {
              currentTime: r,
              paused: i,
              preload: s,
              readyState: a,
              playbackRate: l
            } = t.media;
            t.media.src = n.getAttribute("src"), (s !== "none" || a) && (t.once("loadedmetadata", () => {
              t.speed = l, t.currentTime = r, i || silencePromise(t.play());
            }), t.media.load());
          }
          triggerEvent.call(t, t.media, "qualitychange", !1, {
            quality: e
          });
        }
      }
    });
  },
  cancelRequests() {
    this.isHTML5 && (removeElement$1(Kn.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
  }
};
function generateId(t) {
  return `${t}-${Math.floor(1e4 * Math.random())}`;
}
o(generateId, "generateId");
function format(t, ...e) {
  return x.empty(t) ? t : t.toString().replace(/{(\d+)}/g, (n, r) => e[r].toString());
}
o(format, "format");
function getPercentage(t, e) {
  return t === 0 || e === 0 || Number.isNaN(t) || Number.isNaN(e) ? 0 : (t / e * 100).toFixed(2);
}
o(getPercentage, "getPercentage");
const replaceAll = o((t = "", e = "", n = "") => t.replace(new RegExp(e.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), n.toString()), "replaceAll"),
  toTitleCase = o((t = "") => t.toString().replace(/\w\S*/g, e => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()), "toTitleCase");
function toPascalCase(t = "") {
  let e = t.toString();
  return e = replaceAll(e, "-", " "), e = replaceAll(e, "_", " "), e = toTitleCase(e), replaceAll(e, " ", "");
}
o(toPascalCase, "toPascalCase");
function toCamelCase$1(t = "") {
  let e = t.toString();
  return e = toPascalCase(e), e.charAt(0).toLowerCase() + e.slice(1);
}
o(toCamelCase$1, "toCamelCase");
function stripHTML(t) {
  const e = document.createDocumentFragment(),
    n = document.createElement("div");
  return e.appendChild(n), n.innerHTML = t, e.firstChild.innerText;
}
o(stripHTML, "stripHTML");
function getHTML(t) {
  const e = document.createElement("div");
  return e.appendChild(t), e.innerHTML;
}
o(getHTML, "getHTML");
const ey = {
    pip: "PIP",
    airplay: "AirPlay",
    html5: "HTML5",
    vimeo: "Vimeo",
    youtube: "YouTube"
  },
  ot = {
    get(t = "", e = {}) {
      if (x.empty(t) || x.empty(e)) return "";
      let n = getDeep(e.i18n, t);
      if (x.empty(n)) return Object.keys(ey).includes(t) ? ey[t] : "";
      const r = {
        "{seektime}": e.seekTime,
        "{title}": e.title
      };
      return Object.entries(r).forEach(([i, s]) => {
        n = replaceAll(n, i, s);
      }), n;
    }
  };
class Storage {
  constructor(e) {
    _defineProperty(this, "get", n => {
      if (!Storage.supported || !this.enabled) return null;
      const r = window.localStorage.getItem(this.key);
      if (x.empty(r)) return null;
      const i = JSON.parse(r);
      return x.string(n) && n.length ? i[n] : i;
    }), _defineProperty(this, "set", n => {
      if (!Storage.supported || !this.enabled || !x.object(n)) return;
      let r = this.get();
      x.empty(r) && (r = {}), extend$4(r, n);
      try {
        window.localStorage.setItem(this.key, JSON.stringify(r));
      } catch {}
    }), this.enabled = e.config.storage.enabled, this.key = e.config.storage.key;
  }
  static get supported() {
    try {
      if (!("localStorage" in window)) return !1;
      const e = "___test";
      return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
    } catch {
      return !1;
    }
  }
}
o(Storage, "Storage");
function fetch$1(t, e = "text") {
  return new Promise((n, r) => {
    try {
      const i = new XMLHttpRequest();
      if (!("withCredentials" in i)) return;
      i.addEventListener("load", () => {
        if (e === "text") try {
          n(JSON.parse(i.responseText));
        } catch {
          n(i.responseText);
        } else n(i.response);
      }), i.addEventListener("error", () => {
        throw new Error(i.status);
      }), i.open("GET", t, !0), i.responseType = e, i.send();
    } catch (i) {
      r(i);
    }
  });
}
o(fetch$1, "fetch$1");
function loadSprite(t, e) {
  if (!x.string(t)) return;
  const n = "cache",
    r = x.string(e);
  let i = !1;
  const r$1 = o(() => document.getElementById(e) !== null, "r"),
    a = o((l, u) => {
      l.innerHTML = u, r && r$1() || document.body.insertAdjacentElement("afterbegin", l);
    }, "a");
  if (!r || !r$1()) {
    const l = Storage.supported,
      u = document.createElement("div");
    if (u.setAttribute("hidden", ""), r && u.setAttribute("id", e), l) {
      const c = window.localStorage.getItem(`${n}-${e}`);
      if (i = c !== null, i) {
        const p = JSON.parse(c);
        a(u, p.content);
      }
    }
    fetch$1(t).then(c => {
      if (!x.empty(c)) {
        if (l) try {
          window.localStorage.setItem(`${n}-${e}`, JSON.stringify({
            content: c
          }));
        } catch {}
        a(u, c);
      }
    }).catch(() => {});
  }
}
o(loadSprite, "loadSprite");
const getHours = o(t => Math.trunc(t / 60 / 60 % 60, 10), "getHours"),
  getMinutes = o(t => Math.trunc(t / 60 % 60, 10), "getMinutes"),
  getSeconds = o(t => Math.trunc(t % 60, 10), "getSeconds");
function formatTime(t = 0, e = !1, n = !1) {
  if (!x.number(t)) return formatTime(void 0, e, n);
  const s$1 = o(l => `0${l}`.slice(-2), "s");
  let i = getHours(t);
  const s = getMinutes(t),
    a = getSeconds(t);
  return i = e || i > 0 ? `${i}:` : "", `${n && t > 0 ? "-" : ""}${i}${s$1(s)}:${s$1(a)}`;
}
o(formatTime, "formatTime");
const ee = {
  getIconUrl() {
    const t = new URL(this.config.iconUrl, window.location),
      e = window.location.host ? window.location.host : window.top.location.host,
      n = t.host !== e || at.isIE && !window.svg4everybody;
    return {
      url: this.config.iconUrl,
      cors: n
    };
  },
  findElements() {
    try {
      return this.elements.controls = getElement.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
        play: getElements.call(this, this.config.selectors.buttons.play),
        pause: getElement.call(this, this.config.selectors.buttons.pause),
        restart: getElement.call(this, this.config.selectors.buttons.restart),
        rewind: getElement.call(this, this.config.selectors.buttons.rewind),
        fastForward: getElement.call(this, this.config.selectors.buttons.fastForward),
        mute: getElement.call(this, this.config.selectors.buttons.mute),
        pip: getElement.call(this, this.config.selectors.buttons.pip),
        airplay: getElement.call(this, this.config.selectors.buttons.airplay),
        settings: getElement.call(this, this.config.selectors.buttons.settings),
        captions: getElement.call(this, this.config.selectors.buttons.captions),
        fullscreen: getElement.call(this, this.config.selectors.buttons.fullscreen)
      }, this.elements.progress = getElement.call(this, this.config.selectors.progress), this.elements.inputs = {
        seek: getElement.call(this, this.config.selectors.inputs.seek),
        volume: getElement.call(this, this.config.selectors.inputs.volume)
      }, this.elements.display = {
        buffer: getElement.call(this, this.config.selectors.display.buffer),
        currentTime: getElement.call(this, this.config.selectors.display.currentTime),
        duration: getElement.call(this, this.config.selectors.display.duration)
      }, x.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), !0;
    } catch (t) {
      return this.debug.warn("It looks like there is a problem with your custom controls HTML", t), this.toggleNativeControls(!0), !1;
    }
  },
  createIcon(t, e) {
    const n = "http://www.w3.org/2000/svg",
      r = ee.getIconUrl.call(this),
      i = `${r.cors ? "" : r.url}#${this.config.iconPrefix}`,
      s = document.createElementNS(n, "svg");
    setAttributes(s, extend$4(e, {
      "aria-hidden": "true",
      focusable: "false"
    }));
    const a = document.createElementNS(n, "use"),
      l = `${i}-${t}`;
    return "href" in a && a.setAttributeNS("http://www.w3.org/1999/xlink", "href", l), a.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", l), s.appendChild(a), s;
  },
  createLabel(t, e = {}) {
    const n = ot.get(t, this.config);
    return createElement$1("span", {
      ...e,
      class: [e.class, this.config.classNames.hidden].filter(Boolean).join(" ")
    }, n);
  },
  createBadge(t) {
    if (x.empty(t)) return null;
    const e = createElement$1("span", {
      class: this.config.classNames.menu.value
    });
    return e.appendChild(createElement$1("span", {
      class: this.config.classNames.menu.badge
    }, t)), e;
  },
  createButton(t, e) {
    const n = extend$4({}, e);
    let r = toCamelCase$1(t);
    const i = {
      element: "button",
      toggle: !1,
      label: null,
      icon: null,
      labelPressed: null,
      iconPressed: null
    };
    switch (["element", "icon", "label"].forEach(a => {
      Object.keys(n).includes(a) && (i[a] = n[a], delete n[a]);
    }), i.element !== "button" || Object.keys(n).includes("type") || (n.type = "button"), Object.keys(n).includes("class") ? n.class.split(" ").some(a => a === this.config.classNames.control) || extend$4(n, {
      class: `${n.class} ${this.config.classNames.control}`
    }) : n.class = this.config.classNames.control, t) {
      case "play":
        i.toggle = !0, i.label = "play", i.labelPressed = "pause", i.icon = "play", i.iconPressed = "pause";
        break;
      case "mute":
        i.toggle = !0, i.label = "mute", i.labelPressed = "unmute", i.icon = "volume", i.iconPressed = "muted";
        break;
      case "captions":
        i.toggle = !0, i.label = "enableCaptions", i.labelPressed = "disableCaptions", i.icon = "captions-off", i.iconPressed = "captions-on";
        break;
      case "fullscreen":
        i.toggle = !0, i.label = "enterFullscreen", i.labelPressed = "exitFullscreen", i.icon = "enter-fullscreen", i.iconPressed = "exit-fullscreen";
        break;
      case "play-large":
        n.class += ` ${this.config.classNames.control}--overlaid`, r = "play", i.label = "play", i.icon = "play";
        break;
      default:
        x.empty(i.label) && (i.label = r), x.empty(i.icon) && (i.icon = t);
    }
    const s = createElement$1(i.element);
    return i.toggle ? (s.appendChild(ee.createIcon.call(this, i.iconPressed, {
      class: "icon--pressed"
    })), s.appendChild(ee.createIcon.call(this, i.icon, {
      class: "icon--not-pressed"
    })), s.appendChild(ee.createLabel.call(this, i.labelPressed, {
      class: "label--pressed"
    })), s.appendChild(ee.createLabel.call(this, i.label, {
      class: "label--not-pressed"
    }))) : (s.appendChild(ee.createIcon.call(this, i.icon)), s.appendChild(ee.createLabel.call(this, i.label))), extend$4(n, getAttributesFromSelector(this.config.selectors.buttons[r], n)), setAttributes(s, n), r === "play" ? (x.array(this.elements.buttons[r]) || (this.elements.buttons[r] = []), this.elements.buttons[r].push(s)) : this.elements.buttons[r] = s, s;
  },
  createRange(t, e) {
    const n = createElement$1("input", extend$4(getAttributesFromSelector(this.config.selectors.inputs[t]), {
      type: "range",
      min: 0,
      max: 100,
      step: .01,
      value: 0,
      autocomplete: "off",
      role: "slider",
      "aria-label": ot.get(t, this.config),
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": 0
    }, e));
    return this.elements.inputs[t] = n, ee.updateRangeFill.call(this, n), yA.setup(n), n;
  },
  createProgress(t, e) {
    const n = createElement$1("progress", extend$4(getAttributesFromSelector(this.config.selectors.display[t]), {
      min: 0,
      max: 100,
      value: 0,
      role: "progressbar",
      "aria-hidden": !0
    }, e));
    if (t !== "volume") {
      n.appendChild(createElement$1("span", null, "0"));
      const r = {
          played: "played",
          buffer: "buffered"
        }[t],
        i = r ? ot.get(r, this.config) : "";
      n.innerText = `% ${i.toLowerCase()}`;
    }
    return this.elements.display[t] = n, n;
  },
  createTime(t, e) {
    const n = getAttributesFromSelector(this.config.selectors.display[t], e),
      r = createElement$1("div", extend$4(n, {
        class: `${n.class ? n.class : ""} ${this.config.classNames.display.time} `.trim(),
        "aria-label": ot.get(t, this.config),
        role: "timer"
      }), "00:00");
    return this.elements.display[t] = r, r;
  },
  bindMenuItemShortcuts(t, e) {
    on$1.call(this, t, "keydown keyup", n => {
      if (![" ", "ArrowUp", "ArrowDown", "ArrowRight"].includes(n.key) || (n.preventDefault(), n.stopPropagation(), n.type === "keydown")) return;
      const r = matches$1(t, '[role="menuitemradio"]');
      if (!r && [" ", "ArrowRight"].includes(n.key)) ee.showMenuPanel.call(this, e, !0);else {
        let i;
        n.key !== " " && (n.key === "ArrowDown" || r && n.key === "ArrowRight" ? (i = t.nextElementSibling, x.element(i) || (i = t.parentNode.firstElementChild)) : (i = t.previousElementSibling, x.element(i) || (i = t.parentNode.lastElementChild)), setFocus.call(this, i, !0));
      }
    }, !1), on$1.call(this, t, "keyup", n => {
      n.key === "Return" && ee.focusFirstMenuItem.call(this, null, !0);
    });
  },
  createMenuItem({
    value: t,
    list: e,
    type: n,
    title: r,
    badge: i = null,
    checked: s = !1
  }) {
    const a = getAttributesFromSelector(this.config.selectors.inputs[n]),
      l = createElement$1("button", extend$4(a, {
        type: "button",
        role: "menuitemradio",
        class: `${this.config.classNames.control} ${a.class ? a.class : ""}`.trim(),
        "aria-checked": s,
        value: t
      })),
      u = createElement$1("span");
    u.innerHTML = r, x.element(i) && u.appendChild(i), l.appendChild(u), Object.defineProperty(l, "checked", {
      enumerable: !0,
      get: () => l.getAttribute("aria-checked") === "true",
      set(c) {
        c && Array.from(l.parentNode.children).filter(p => matches$1(p, '[role="menuitemradio"]')).forEach(p => p.setAttribute("aria-checked", "false")), l.setAttribute("aria-checked", c ? "true" : "false");
      }
    }), this.listeners.bind(l, "click keyup", c => {
      if (!x.keyboardEvent(c) || c.key === " ") {
        switch (c.preventDefault(), c.stopPropagation(), l.checked = !0, n) {
          case "language":
            this.currentTrack = Number(t);
            break;
          case "quality":
            this.quality = t;
            break;
          case "speed":
            this.speed = parseFloat(t);
        }
        ee.showMenuPanel.call(this, "home", x.keyboardEvent(c));
      }
    }, n, !1), ee.bindMenuItemShortcuts.call(this, l, n), e.appendChild(l);
  },
  formatTime(t = 0, e = !1) {
    return x.number(t) ? formatTime(t, getHours(this.duration) > 0, e) : t;
  },
  updateTimeDisplay(t = null, e = 0, n = !1) {
    x.element(t) && x.number(e) && (t.innerText = ee.formatTime(e, n));
  },
  updateVolume() {
    this.supported.ui && (x.element(this.elements.inputs.volume) && ee.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), x.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || this.volume === 0));
  },
  setRange(t, e = 0) {
    x.element(t) && (t.value = e, ee.updateRangeFill.call(this, t));
  },
  updateProgress(t) {
    if (!this.supported.ui || !x.event(t)) return;
    let e = 0;
    const i = o((r, i) => {
      const s = x.number(i) ? i : 0,
        a = x.element(r) ? r : this.elements.display.buffer;
      if (x.element(a)) {
        a.value = s;
        const l = a.getElementsByTagName("span")[0];
        x.element(l) && (l.childNodes[0].nodeValue = s);
      }
    }, "i");
    if (t) switch (t.type) {
      case "timeupdate":
      case "seeking":
      case "seeked":
        e = getPercentage(this.currentTime, this.duration), t.type === "timeupdate" && ee.setRange.call(this, this.elements.inputs.seek, e);
        break;
      case "playing":
      case "progress":
        i(this.elements.display.buffer, 100 * this.buffered);
    }
  },
  updateRangeFill(t) {
    const e = x.event(t) ? t.target : t;
    if (x.element(e) && e.getAttribute("type") === "range") {
      if (matches$1(e, this.config.selectors.inputs.seek)) {
        e.setAttribute("aria-valuenow", this.currentTime);
        const n = ee.formatTime(this.currentTime),
          r = ee.formatTime(this.duration),
          i = ot.get("seekLabel", this.config);
        e.setAttribute("aria-valuetext", i.replace("{currentTime}", n).replace("{duration}", r));
      } else if (matches$1(e, this.config.selectors.inputs.volume)) {
        const n = 100 * e.value;
        e.setAttribute("aria-valuenow", n), e.setAttribute("aria-valuetext", `${n.toFixed(1)}%`);
      } else e.setAttribute("aria-valuenow", e.value);
      (at.isWebKit || at.isIPadOS) && e.style.setProperty("--value", e.value / e.max * 100 + "%");
    }
  },
  updateSeekTooltip(t) {
    var e, n;
    if (!this.config.tooltips.seek || !x.element(this.elements.inputs.seek) || !x.element(this.elements.display.seekTooltip) || this.duration === 0) return;
    const r = this.elements.display.seekTooltip,
      i = `${this.config.classNames.tooltip}--visible`,
      r$2 = o(p => toggleClass(r, i, p), "r");
    if (this.touch) return void r$2(!1);
    let a = 0;
    const l = this.elements.progress.getBoundingClientRect();
    if (x.event(t)) a = 100 / l.width * (t.pageX - l.left);else {
      if (!hasClass$1(r, i)) return;
      a = parseFloat(r.style.left, 10);
    }
    a < 0 ? a = 0 : a > 100 && (a = 100);
    const u = this.duration / 100 * a;
    r.innerText = ee.formatTime(u);
    const c = (e = this.config.markers) === null || e === void 0 || (n = e.points) === null || n === void 0 ? void 0 : n.find(({
      time: p
    }) => p === Math.round(u));
    c && r.insertAdjacentHTML("afterbegin", `${c.label}<br>`), r.style.left = `${a}%`, x.event(t) && ["mouseenter", "mouseleave"].includes(t.type) && r$2(t.type === "mouseenter");
  },
  timeUpdate(t) {
    const e = !x.element(this.elements.display.duration) && this.config.invertTime;
    ee.updateTimeDisplay.call(this, this.elements.display.currentTime, e ? this.duration - this.currentTime : this.currentTime, e), t && t.type === "timeupdate" && this.media.seeking || ee.updateProgress.call(this, t);
  },
  durationUpdate() {
    if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
    if (this.duration >= 2 ** 32) return toggleHidden(this.elements.display.currentTime, !0), void toggleHidden(this.elements.progress, !0);
    x.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
    const t = x.element(this.elements.display.duration);
    !t && this.config.displayDuration && this.paused && ee.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), t && ee.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && ee.setMarkers.call(this), ee.updateSeekTooltip.call(this);
  },
  toggleMenuButton(t, e) {
    toggleHidden(this.elements.settings.buttons[t], !e);
  },
  updateSetting(t, e, n) {
    const r = this.elements.settings.panels[t];
    let i = null,
      s = e;
    if (t === "captions") i = this.currentTrack;else {
      if (i = x.empty(n) ? this[t] : n, x.empty(i) && (i = this.config[t].default), !x.empty(this.options[t]) && !this.options[t].includes(i)) return void this.debug.warn(`Unsupported value of '${i}' for ${t}`);
      if (!this.config[t].options.includes(i)) return void this.debug.warn(`Disabled value of '${i}' for ${t}`);
    }
    if (x.element(s) || (s = r && r.querySelector('[role="menu"]')), !x.element(s)) return;
    this.elements.settings.buttons[t].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = ee.getLabel.call(this, t, i);
    const a = s && s.querySelector(`[value="${i}"]`);
    x.element(a) && (a.checked = !0);
  },
  getLabel(t, e) {
    switch (t) {
      case "speed":
        return e === 1 ? ot.get("normal", this.config) : `${e}&times;`;
      case "quality":
        if (x.number(e)) {
          const n = ot.get(`qualityLabel.${e}`, this.config);
          return n.length ? n : `${e}p`;
        }
        return toTitleCase(e);
      case "captions":
        return Ce.getLabel.call(this);
      default:
        return null;
    }
  },
  setQualityMenu(t) {
    if (!x.element(this.elements.settings.panels.quality)) return;
    const e = "quality",
      n = this.elements.settings.panels.quality.querySelector('[role="menu"]');
    x.array(t) && (this.options.quality = dedupe(t).filter(s => this.config.quality.options.includes(s)));
    const r = !x.empty(this.options.quality) && this.options.quality.length > 1;
    if (ee.toggleMenuButton.call(this, e, r), emptyElement(n), ee.checkMenu.call(this), !r) return;
    const n$1 = o(s => {
      const a = ot.get(`qualityBadge.${s}`, this.config);
      return a.length ? ee.createBadge.call(this, a) : null;
    }, "n");
    this.options.quality.sort((s, a) => {
      const l = this.config.quality.options;
      return l.indexOf(s) > l.indexOf(a) ? 1 : -1;
    }).forEach(s => {
      ee.createMenuItem.call(this, {
        value: s,
        list: n,
        type: e,
        title: ee.getLabel.call(this, "quality", s),
        badge: n$1(s)
      });
    }), ee.updateSetting.call(this, e, n);
  },
  setCaptionsMenu() {
    if (!x.element(this.elements.settings.panels.captions)) return;
    const t = "captions",
      e = this.elements.settings.panels.captions.querySelector('[role="menu"]'),
      n = Ce.getTracks.call(this),
      r = !!n.length;
    if (ee.toggleMenuButton.call(this, t, r), emptyElement(e), ee.checkMenu.call(this), !r) return;
    const i = n.map((s, a) => ({
      value: a,
      checked: this.captions.toggled && this.currentTrack === a,
      title: Ce.getLabel.call(this, s),
      badge: s.language && ee.createBadge.call(this, s.language.toUpperCase()),
      list: e,
      type: "language"
    }));
    i.unshift({
      value: -1,
      checked: !this.captions.toggled,
      title: ot.get("disabled", this.config),
      list: e,
      type: "language"
    }), i.forEach(ee.createMenuItem.bind(this)), ee.updateSetting.call(this, t, e);
  },
  setSpeedMenu() {
    if (!x.element(this.elements.settings.panels.speed)) return;
    const t = "speed",
      e = this.elements.settings.panels.speed.querySelector('[role="menu"]');
    this.options.speed = this.options.speed.filter(r => r >= this.minimumSpeed && r <= this.maximumSpeed);
    const n = !x.empty(this.options.speed) && this.options.speed.length > 1;
    ee.toggleMenuButton.call(this, t, n), emptyElement(e), ee.checkMenu.call(this), n && (this.options.speed.forEach(r => {
      ee.createMenuItem.call(this, {
        value: r,
        list: e,
        type: t,
        title: ee.getLabel.call(this, "speed", r)
      });
    }), ee.updateSetting.call(this, t, e));
  },
  checkMenu() {
    const {
        buttons: t
      } = this.elements.settings,
      e = !x.empty(t) && Object.values(t).some(n => !n.hidden);
    toggleHidden(this.elements.settings.menu, !e);
  },
  focusFirstMenuItem(t, e = !1) {
    if (this.elements.settings.popup.hidden) return;
    let n = t;
    x.element(n) || (n = Object.values(this.elements.settings.panels).find(i => !i.hidden));
    const r = n.querySelector('[role^="menuitem"]');
    setFocus.call(this, r, e);
  },
  toggleMenu(t) {
    const {
        popup: e
      } = this.elements.settings,
      n = this.elements.buttons.settings;
    if (!x.element(e) || !x.element(n)) return;
    const {
      hidden: r
    } = e;
    let i = r;
    if (x.boolean(t)) i = t;else if (x.keyboardEvent(t) && t.key === "Escape") i = !1;else if (x.event(t)) {
      const s = x.function(t.composedPath) ? t.composedPath()[0] : t.target,
        a = e.contains(s);
      if (a || !a && t.target !== n && i) return;
    }
    n.setAttribute("aria-expanded", i), toggleHidden(e, !i), toggleClass(this.elements.container, this.config.classNames.menu.open, i), i && x.keyboardEvent(t) ? ee.focusFirstMenuItem.call(this, null, !0) : i || r || setFocus.call(this, n, x.keyboardEvent(t));
  },
  getMenuSize(t) {
    const e = t.cloneNode(!0);
    e.style.position = "absolute", e.style.opacity = 0, e.removeAttribute("hidden"), t.parentNode.appendChild(e);
    const n = e.scrollWidth,
      r = e.scrollHeight;
    return removeElement$1(e), {
      width: n,
      height: r
    };
  },
  showMenuPanel(t = "", e = !1) {
    const n = this.elements.container.querySelector(`#plyr-settings-${this.id}-${t}`);
    if (!x.element(n)) return;
    const r = n.parentNode,
      i = Array.from(r.children).find(s => !s.hidden);
    if (Xe.transitions && !Xe.reducedMotion) {
      r.style.width = `${i.scrollWidth}px`, r.style.height = `${i.scrollHeight}px`;
      const s = ee.getMenuSize.call(this, n),
        t$1 = o(l => {
          l.target === r && ["width", "height"].includes(l.propertyName) && (r.style.width = "", r.style.height = "", off.call(this, r, Ff, t$1));
        }, "t");
      on$1.call(this, r, Ff, t$1), r.style.width = `${s.width}px`, r.style.height = `${s.height}px`;
    }
    toggleHidden(i, !0), toggleHidden(n, !1), ee.focusFirstMenuItem.call(this, n, e);
  },
  setDownloadUrl() {
    const t = this.elements.buttons.download;
    x.element(t) && t.setAttribute("href", this.download);
  },
  create(t) {
    const {
      bindMenuItemShortcuts: e,
      createButton: n,
      createProgress: r,
      createRange: i,
      createTime: s,
      setQualityMenu: a,
      setSpeedMenu: l,
      showMenuPanel: u
    } = ee;
    this.elements.controls = null, x.array(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(n.call(this, "play-large"));
    const c = createElement$1("div", getAttributesFromSelector(this.config.selectors.controls.wrapper));
    this.elements.controls = c;
    const p = {
      class: "plyr__controls__item"
    };
    return dedupe(x.array(this.config.controls) ? this.config.controls : []).forEach(m => {
      if (m === "restart" && c.appendChild(n.call(this, "restart", p)), m === "rewind" && c.appendChild(n.call(this, "rewind", p)), m === "play" && c.appendChild(n.call(this, "play", p)), m === "fast-forward" && c.appendChild(n.call(this, "fast-forward", p)), m === "progress") {
        const d = createElement$1("div", {
            class: `${p.class} plyr__progress__container`
          }),
          y = createElement$1("div", getAttributesFromSelector(this.config.selectors.progress));
        if (y.appendChild(i.call(this, "seek", {
          id: `plyr-seek-${t.id}`
        })), y.appendChild(r.call(this, "buffer")), this.config.tooltips.seek) {
          const S = createElement$1("span", {
            class: this.config.classNames.tooltip
          }, "00:00");
          y.appendChild(S), this.elements.display.seekTooltip = S;
        }
        this.elements.progress = y, d.appendChild(this.elements.progress), c.appendChild(d);
      }
      if (m === "current-time" && c.appendChild(s.call(this, "currentTime", p)), m === "duration" && c.appendChild(s.call(this, "duration", p)), m === "mute" || m === "volume") {
        let {
          volume: d
        } = this.elements;
        if (x.element(d) && c.contains(d) || (d = createElement$1("div", extend$4({}, p, {
          class: `${p.class} plyr__volume`.trim()
        })), this.elements.volume = d, c.appendChild(d)), m === "mute" && d.appendChild(n.call(this, "mute")), m === "volume" && !at.isIos && !at.isIPadOS) {
          const y = {
            max: 1,
            step: .05,
            value: this.config.volume
          };
          d.appendChild(i.call(this, "volume", extend$4(y, {
            id: `plyr-volume-${t.id}`
          })));
        }
      }
      if (m === "captions" && c.appendChild(n.call(this, "captions", p)), m === "settings" && !x.empty(this.config.settings)) {
        const d = createElement$1("div", extend$4({}, p, {
          class: `${p.class} plyr__menu`.trim(),
          hidden: ""
        }));
        d.appendChild(n.call(this, "settings", {
          "aria-haspopup": !0,
          "aria-controls": `plyr-settings-${t.id}`,
          "aria-expanded": !1
        }));
        const y = createElement$1("div", {
            class: "plyr__menu__container",
            id: `plyr-settings-${t.id}`,
            hidden: ""
          }),
          S = createElement$1("div"),
          w = createElement$1("div", {
            id: `plyr-settings-${t.id}-home`
          }),
          g = createElement$1("div", {
            role: "menu"
          });
        w.appendChild(g), S.appendChild(w), this.elements.settings.panels.home = w, this.config.settings.forEach(h => {
          const f = createElement$1("button", extend$4(getAttributesFromSelector(this.config.selectors.buttons.settings), {
            type: "button",
            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
            role: "menuitem",
            "aria-haspopup": !0,
            hidden: ""
          }));
          e.call(this, f, h), on$1.call(this, f, "click", () => {
            u.call(this, h, !1);
          });
          const v = createElement$1("span", null, ot.get(h, this.config)),
            E = createElement$1("span", {
              class: this.config.classNames.menu.value
            });
          E.innerHTML = t[h], v.appendChild(E), f.appendChild(v), g.appendChild(f);
          const b = createElement$1("div", {
              id: `plyr-settings-${t.id}-${h}`,
              hidden: ""
            }),
            P = createElement$1("button", {
              type: "button",
              class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
            });
          P.appendChild(createElement$1("span", {
            "aria-hidden": !0
          }, ot.get(h, this.config))), P.appendChild(createElement$1("span", {
            class: this.config.classNames.hidden
          }, ot.get("menuBack", this.config))), on$1.call(this, b, "keydown", T => {
            T.key === "ArrowLeft" && (T.preventDefault(), T.stopPropagation(), u.call(this, "home", !0));
          }, !1), on$1.call(this, P, "click", () => {
            u.call(this, "home", !1);
          }), b.appendChild(P), b.appendChild(createElement$1("div", {
            role: "menu"
          })), S.appendChild(b), this.elements.settings.buttons[h] = f, this.elements.settings.panels[h] = b;
        }), y.appendChild(S), d.appendChild(y), c.appendChild(d), this.elements.settings.popup = y, this.elements.settings.menu = d;
      }
      if (m === "pip" && Xe.pip && c.appendChild(n.call(this, "pip", p)), m === "airplay" && Xe.airplay && c.appendChild(n.call(this, "airplay", p)), m === "download") {
        const d = extend$4({}, p, {
          element: "a",
          href: this.download,
          target: "_blank"
        });
        this.isHTML5 && (d.download = "");
        const {
          download: y
        } = this.config.urls;
        !x.url(y) && this.isEmbed && extend$4(d, {
          icon: `logo-${this.provider}`,
          label: this.provider
        }), c.appendChild(n.call(this, "download", d));
      }
      m === "fullscreen" && c.appendChild(n.call(this, "fullscreen", p));
    }), this.isHTML5 && a.call(this, Kn.getQualityOptions.call(this)), l.call(this), c;
  },
  inject() {
    if (this.config.loadSprite) {
      const i = ee.getIconUrl.call(this);
      i.cors && loadSprite(i.url, "sprite-plyr");
    }
    this.id = Math.floor(1e4 * Math.random());
    let t = null;
    this.elements.controls = null;
    const e = {
      id: this.id,
      seektime: this.config.seekTime,
      title: this.config.title
    };
    let n = !0;
    x.function(this.config.controls) && (this.config.controls = this.config.controls.call(this, e)), this.config.controls || (this.config.controls = []), x.element(this.config.controls) || x.string(this.config.controls) ? t = this.config.controls : (t = ee.create.call(this, {
      id: this.id,
      seektime: this.config.seekTime,
      speed: this.speed,
      quality: this.quality,
      captions: Ce.getLabel.call(this)
    }), n = !1);
    let r;
    if (n && x.string(this.config.controls) && (t = (i => {
      let s = i;
      return Object.entries(e).forEach(([a, l]) => {
        s = replaceAll(s, `{${a}}`, l);
      }), s;
    })(t)), x.string(this.config.selectors.controls.container) && (r = document.querySelector(this.config.selectors.controls.container)), x.element(r) || (r = this.elements.container), r[x.element(t) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", t), x.element(this.elements.controls) || ee.findElements.call(this), !x.empty(this.elements.buttons)) {
      const e$2 = o(s => {
        const a = this.config.classNames.controlPressed;
        s.setAttribute("aria-pressed", "false"), Object.defineProperty(s, "pressed", {
          configurable: !0,
          enumerable: !0,
          get: () => hasClass$1(s, a),
          set(l = !1) {
            toggleClass(s, a, l), s.setAttribute("aria-pressed", l ? "true" : "false");
          }
        });
      }, "e");
      Object.values(this.elements.buttons).filter(Boolean).forEach(s => {
        x.array(s) || x.nodeList(s) ? Array.from(s).filter(Boolean).forEach(e$2) : e$2(s);
      });
    }
    if (at.isEdge && repaint(r), this.config.tooltips.controls) {
      const {
          classNames: i,
          selectors: s
        } = this.config,
        a = `${s.controls.wrapper} ${s.labels} .${i.hidden}`,
        l = getElements.call(this, a);
      Array.from(l).forEach(u => {
        toggleClass(u, this.config.classNames.hidden, !1), toggleClass(u, this.config.classNames.tooltip, !0);
      });
    }
  },
  setMediaMetadata() {
    try {
      "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({
        title: this.config.mediaMetadata.title,
        artist: this.config.mediaMetadata.artist,
        album: this.config.mediaMetadata.album,
        artwork: this.config.mediaMetadata.artwork
      }));
    } catch {}
  },
  setMarkers() {
    var t, e;
    if (!this.duration || this.elements.markers) return;
    const n = (t = this.config.markers) === null || t === void 0 || (e = t.points) === null || e === void 0 ? void 0 : e.filter(({
      time: u
    }) => u > 0 && u < this.duration);
    if (n == null || !n.length) return;
    const r = document.createDocumentFragment(),
      i = document.createDocumentFragment();
    let s = null;
    const a = `${this.config.classNames.tooltip}--visible`,
      o$1 = o(u => toggleClass(s, a, u), "o");
    n.forEach(u => {
      const c = createElement$1("span", {
          class: this.config.classNames.marker
        }, ""),
        p = u.time / this.duration * 100 + "%";
      s && (c.addEventListener("mouseenter", () => {
        u.label || (s.style.left = p, s.innerHTML = u.label, o$1(!0));
      }), c.addEventListener("mouseleave", () => {
        o$1(!1);
      })), c.addEventListener("click", () => {
        this.currentTime = u.time;
      }), c.style.left = p, i.appendChild(c);
    }), r.appendChild(i), this.config.tooltips.seek || (s = createElement$1("span", {
      class: this.config.classNames.tooltip
    }, ""), r.appendChild(s)), this.elements.markers = {
      points: i,
      tip: s
    }, this.elements.progress.appendChild(r);
  }
};
function parseUrl$1(t, e = !0) {
  let n = t;
  if (e) {
    const r = document.createElement("a");
    r.href = n, n = r.href;
  }
  try {
    return new URL(n);
  } catch {
    return null;
  }
}
o(parseUrl$1, "parseUrl");
function buildUrlParams(t) {
  const e = new URLSearchParams();
  return x.object(t) && Object.entries(t).forEach(([n, r]) => {
    e.set(n, r);
  }), e;
}
o(buildUrlParams, "buildUrlParams");
const Ce = {
    setup() {
      if (!this.supported.ui) return;
      if (!this.isVideo || this.isYouTube || this.isHTML5 && !Xe.textTracks) return void (x.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && ee.setCaptionsMenu.call(this));
      if (x.element(this.elements.captions) || (this.elements.captions = createElement$1("div", getAttributesFromSelector(this.config.selectors.captions)), this.elements.captions.setAttribute("dir", "auto"), insertAfter(this.elements.captions, this.elements.wrapper)), at.isIE && window.URL) {
        const r = this.media.querySelectorAll("track");
        Array.from(r).forEach(i => {
          const blob = i.getAttribute("src"),
            a = parseUrl$1(blob);
          a !== null && a.hostname !== window.location.href.hostname && ["http:", "https:"].includes(a.protocol) && fetch$1(blob, "blob").then(l => {
            i.setAttribute("src", window.URL.createObjectURL(l));
          }).catch(() => {
            removeElement$1(i);
          });
        });
      }
      const t = dedupe((navigator.languages || [navigator.language || navigator.userLanguage || "en"]).map(r => r.split("-")[0]));
      let e = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
      e === "auto" && ([e] = t);
      let n = this.storage.get("captions");
      if (x.boolean(n) || ({
        active: n
      } = this.config.captions), Object.assign(this.captions, {
        toggled: !1,
        active: n,
        language: e,
        languages: t
      }), this.isHTML5) {
        const r = this.config.captions.update ? "addtrack removetrack" : "removetrack";
        on$1.call(this, this.media.textTracks, r, Ce.update.bind(this));
      }
      setTimeout(Ce.update.bind(this), 0);
    },
    update() {
      const t = Ce.getTracks.call(this, !0),
        {
          active: e,
          language: n,
          meta: r,
          currentTrackNode: i
        } = this.captions,
        s = !!t.find(a => a.language === n);
      this.isHTML5 && this.isVideo && t.filter(a => !r.get(a)).forEach(a => {
        this.debug.log("Track added", a), r.set(a, {
          default: a.mode === "showing"
        }), a.mode === "showing" && (a.mode = "hidden"), on$1.call(this, a, "cuechange", () => Ce.updateCues.call(this));
      }), (s && this.language !== n || !t.includes(i)) && (Ce.setLanguage.call(this, n), Ce.toggle.call(this, e && s)), this.elements && toggleClass(this.elements.container, this.config.classNames.captions.enabled, !x.empty(t)), x.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && ee.setCaptionsMenu.call(this);
    },
    toggle(t, e = !0) {
      if (!this.supported.ui) return;
      const {
          toggled: n
        } = this.captions,
        r = this.config.classNames.captions.active,
        i = x.nullOrUndefined(t) ? !n : t;
      if (i !== n) {
        if (e || (this.captions.active = i, this.storage.set({
          captions: i
        })), !this.language && i && !e) {
          const s = Ce.getTracks.call(this),
            a = Ce.findTrack.call(this, [this.captions.language, ...this.captions.languages], !0);
          return this.captions.language = a.language, void Ce.set.call(this, s.indexOf(a));
        }
        this.elements.buttons.captions && (this.elements.buttons.captions.pressed = i), toggleClass(this.elements.container, r, i), this.captions.toggled = i, ee.updateSetting.call(this, "captions"), triggerEvent.call(this, this.media, i ? "captionsenabled" : "captionsdisabled");
      }
      setTimeout(() => {
        i && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
      });
    },
    set(t, e = !0) {
      const n = Ce.getTracks.call(this);
      if (t !== -1) {
        if (x.number(t)) {
          if (t in n) {
            if (this.captions.currentTrack !== t) {
              this.captions.currentTrack = t;
              const r = n[t],
                {
                  language: i
                } = r || {};
              this.captions.currentTrackNode = r, ee.updateSetting.call(this, "captions"), e || (this.captions.language = i, this.storage.set({
                language: i
              })), this.isVimeo && this.embed.enableTextTrack(i), triggerEvent.call(this, this.media, "languagechange");
            }
            Ce.toggle.call(this, !0, e), this.isHTML5 && this.isVideo && Ce.updateCues.call(this);
          } else this.debug.warn("Track not found", t);
        } else this.debug.warn("Invalid caption argument", t);
      } else Ce.toggle.call(this, !1, e);
    },
    setLanguage(t, e = !0) {
      if (!x.string(t)) return void this.debug.warn("Invalid language argument", t);
      const n = t.toLowerCase();
      this.captions.language = n;
      const r = Ce.getTracks.call(this),
        i = Ce.findTrack.call(this, [n]);
      Ce.set.call(this, r.indexOf(i), e);
    },
    getTracks(t = !1) {
      return Array.from((this.media || {}).textTracks || []).filter(e => !this.isHTML5 || t || this.captions.meta.has(e)).filter(e => ["captions", "subtitles"].includes(e.kind));
    },
    findTrack(t, e = !1) {
      const n = Ce.getTracks.call(this),
        s$2 = o(a => Number((this.captions.meta.get(a) || {}).default), "s"),
        i = Array.from(n).sort((a, l) => s$2(l) - s$2(a));
      let s;
      return t.every(a => (s = i.find(l => l.language === a), !s)), s || (e ? i[0] : void 0);
    },
    getCurrentTrack() {
      return Ce.getTracks.call(this)[this.currentTrack];
    },
    getLabel(t) {
      let e = t;
      return !x.track(e) && Xe.textTracks && this.captions.toggled && (e = Ce.getCurrentTrack.call(this)), x.track(e) ? x.empty(e.label) ? x.empty(e.language) ? ot.get("enabled", this.config) : t.language.toUpperCase() : e.label : ot.get("disabled", this.config);
    },
    updateCues(t) {
      if (!this.supported.ui) return;
      if (!x.element(this.elements.captions)) return void this.debug.warn("No captions element to render to");
      if (!x.nullOrUndefined(t) && !Array.isArray(t)) return void this.debug.warn("updateCues: Invalid input", t);
      let e = t;
      if (!e) {
        const r = Ce.getCurrentTrack.call(this);
        e = Array.from((r || {}).activeCues || []).map(i => i.getCueAsHTML()).map(getHTML);
      }
      const n = e.map(r => r.trim()).join(`
`);
      if (n !== this.elements.captions.innerHTML) {
        emptyElement(this.elements.captions);
        const r = createElement$1("span", getAttributesFromSelector(this.config.selectors.caption));
        r.innerHTML = n, this.elements.captions.appendChild(r), triggerEvent.call(this, this.media, "cuechange");
      }
    }
  },
  Ob = {
    enabled: !0,
    title: "",
    debug: !1,
    autoplay: !1,
    autopause: !0,
    playsinline: !0,
    seekTime: 10,
    volume: 1,
    muted: !1,
    duration: null,
    displayDuration: !0,
    invertTime: !0,
    toggleInvert: !0,
    ratio: null,
    clickToPlay: !0,
    hideControls: !0,
    resetOnEnd: !1,
    disableContextMenu: !0,
    loadSprite: !0,
    iconPrefix: "plyr",
    iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg",
    blankVideo: "https://cdn.plyr.io/static/blank.mp4",
    quality: {
      default: 576,
      options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240],
      forced: !1,
      onChange: null
    },
    loop: {
      active: !1
    },
    speed: {
      selected: 1,
      options: [.5, .75, 1, 1.25, 1.5, 1.75, 2, 4]
    },
    keyboard: {
      focused: !0,
      global: !1
    },
    tooltips: {
      controls: !1,
      seek: !0
    },
    captions: {
      active: !1,
      language: "auto",
      update: !1
    },
    fullscreen: {
      enabled: !0,
      fallback: !0,
      iosNative: !1
    },
    storage: {
      enabled: !0,
      key: "plyr"
    },
    controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen"],
    settings: ["captions", "quality", "speed"],
    i18n: {
      restart: "Restart",
      rewind: "Rewind {seektime}s",
      play: "Play",
      pause: "Pause",
      fastForward: "Forward {seektime}s",
      seek: "Seek",
      seekLabel: "{currentTime} of {duration}",
      played: "Played",
      buffered: "Buffered",
      currentTime: "Current time",
      duration: "Duration",
      volume: "Volume",
      mute: "Mute",
      unmute: "Unmute",
      enableCaptions: "Enable captions",
      disableCaptions: "Disable captions",
      download: "Download",
      enterFullscreen: "Enter fullscreen",
      exitFullscreen: "Exit fullscreen",
      frameTitle: "Player for {title}",
      captions: "Captions",
      settings: "Settings",
      pip: "PIP",
      menuBack: "Go back to previous menu",
      speed: "Speed",
      normal: "Normal",
      quality: "Quality",
      loop: "Loop",
      start: "Start",
      end: "End",
      all: "All",
      reset: "Reset",
      disabled: "Disabled",
      enabled: "Enabled",
      advertisement: "Ad",
      qualityBadge: {
        2160: "4K",
        1440: "HD",
        1080: "HD",
        720: "HD",
        576: "SD",
        480: "SD"
      }
    },
    urls: {
      download: null,
      vimeo: {
        sdk: "https://player.vimeo.com/api/player.js",
        iframe: "https://player.vimeo.com/video/{0}?{1}",
        api: "https://vimeo.com/api/oembed.json?url={0}"
      },
      youtube: {
        sdk: "https://www.youtube.com/iframe_api",
        api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
      },
      googleIMA: {
        sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
      }
    },
    listeners: {
      seek: null,
      play: null,
      pause: null,
      restart: null,
      rewind: null,
      fastForward: null,
      mute: null,
      volume: null,
      captions: null,
      download: null,
      fullscreen: null,
      pip: null,
      airplay: null,
      speed: null,
      quality: null,
      loop: null,
      language: null
    },
    events: ["ended", "progress", "stalled", "playing", "waiting", "canplay", "canplaythrough", "loadstart", "loadeddata", "loadedmetadata", "timeupdate", "volumechange", "play", "pause", "error", "seeking", "seeked", "emptied", "ratechange", "cuechange", "download", "enterfullscreen", "exitfullscreen", "captionsenabled", "captionsdisabled", "languagechange", "controlshidden", "controlsshown", "ready", "statechange", "qualitychange", "adsloaded", "adscontentpause", "adscontentresume", "adstarted", "adsmidpoint", "adscomplete", "adsallcomplete", "adsimpression", "adsclick"],
    selectors: {
      editable: "input, textarea, select, [contenteditable]",
      container: ".plyr",
      controls: {
        container: null,
        wrapper: ".plyr__controls"
      },
      labels: "[data-plyr]",
      buttons: {
        play: '[data-plyr="play"]',
        pause: '[data-plyr="pause"]',
        restart: '[data-plyr="restart"]',
        rewind: '[data-plyr="rewind"]',
        fastForward: '[data-plyr="fast-forward"]',
        mute: '[data-plyr="mute"]',
        captions: '[data-plyr="captions"]',
        download: '[data-plyr="download"]',
        fullscreen: '[data-plyr="fullscreen"]',
        pip: '[data-plyr="pip"]',
        airplay: '[data-plyr="airplay"]',
        settings: '[data-plyr="settings"]',
        loop: '[data-plyr="loop"]'
      },
      inputs: {
        seek: '[data-plyr="seek"]',
        volume: '[data-plyr="volume"]',
        speed: '[data-plyr="speed"]',
        language: '[data-plyr="language"]',
        quality: '[data-plyr="quality"]'
      },
      display: {
        currentTime: ".plyr__time--current",
        duration: ".plyr__time--duration",
        buffer: ".plyr__progress__buffer",
        loop: ".plyr__progress__loop",
        volume: ".plyr__volume--display"
      },
      progress: ".plyr__progress",
      captions: ".plyr__captions",
      caption: ".plyr__caption"
    },
    classNames: {
      type: "plyr--{0}",
      provider: "plyr--{0}",
      video: "plyr__video-wrapper",
      embed: "plyr__video-embed",
      videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
      embedContainer: "plyr__video-embed__container",
      poster: "plyr__poster",
      posterEnabled: "plyr__poster-enabled",
      ads: "plyr__ads",
      control: "plyr__control",
      controlPressed: "plyr__control--pressed",
      playing: "plyr--playing",
      paused: "plyr--paused",
      stopped: "plyr--stopped",
      loading: "plyr--loading",
      hover: "plyr--hover",
      tooltip: "plyr__tooltip",
      cues: "plyr__cues",
      marker: "plyr__progress__marker",
      hidden: "plyr__sr-only",
      hideControls: "plyr--hide-controls",
      isTouch: "plyr--is-touch",
      uiSupported: "plyr--full-ui",
      noTransition: "plyr--no-transition",
      display: {
        time: "plyr__time"
      },
      menu: {
        value: "plyr__menu__value",
        badge: "plyr__badge",
        open: "plyr--menu-open"
      },
      captions: {
        enabled: "plyr--captions-enabled",
        active: "plyr--captions-active"
      },
      fullscreen: {
        enabled: "plyr--fullscreen-enabled",
        fallback: "plyr--fullscreen-fallback"
      },
      pip: {
        supported: "plyr--pip-supported",
        active: "plyr--pip-active"
      },
      airplay: {
        supported: "plyr--airplay-supported",
        active: "plyr--airplay-active"
      },
      previewThumbnails: {
        thumbContainer: "plyr__preview-thumb",
        thumbContainerShown: "plyr__preview-thumb--is-shown",
        imageContainer: "plyr__preview-thumb__image-container",
        timeContainer: "plyr__preview-thumb__time-container",
        scrubbingContainer: "plyr__preview-scrubbing",
        scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
      }
    },
    attributes: {
      embed: {
        provider: "data-plyr-provider",
        id: "data-plyr-embed-id",
        hash: "data-plyr-embed-hash"
      }
    },
    ads: {
      enabled: !1,
      publisherId: "",
      tagUrl: ""
    },
    previewThumbnails: {
      enabled: !1,
      src: ""
    },
    vimeo: {
      byline: !1,
      portrait: !1,
      title: !1,
      speed: !0,
      transparent: !1,
      customControls: !0,
      referrerPolicy: null,
      premium: !1
    },
    youtube: {
      rel: 0,
      showinfo: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      customControls: !0,
      noCookie: !1
    },
    mediaMetadata: {
      title: "",
      artist: "",
      album: "",
      artwork: []
    },
    markers: {
      enabled: !1,
      points: []
    }
  },
  kc = {
    active: "picture-in-picture",
    inactive: "inline"
  },
  qn = {
    html5: "html5",
    youtube: "youtube",
    vimeo: "vimeo"
  },
  _c = {
    audio: "audio",
    video: "video"
  };
function getProviderByUrl(t) {
  return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t) ? qn.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(t) ? qn.vimeo : null;
}
o(getProviderByUrl, "getProviderByUrl");
const noop$2 = o(() => {}, "noop");
class Console {
  constructor(e = !1) {
    this.enabled = window.console && e, this.enabled && this.log("Debugging enabled");
  }
  get log() {
    return this.enabled ? Function.prototype.bind.call(console.log, console) : noop$2;
  }
  get warn() {
    return this.enabled ? Function.prototype.bind.call(console.warn, console) : noop$2;
  }
  get error() {
    return this.enabled ? Function.prototype.bind.call(console.error, console) : noop$2;
  }
}
o(Console, "Console");
class Fullscreen {
  constructor(e) {
    _defineProperty(this, "onChange", () => {
      if (!this.supported) return;
      const n = this.player.elements.buttons.fullscreen;
      x.element(n) && (n.pressed = this.active);
      const r = this.target === this.player.media ? this.target : this.player.elements.container;
      triggerEvent.call(this.player, r, this.active ? "enterfullscreen" : "exitfullscreen", !0);
    }), _defineProperty(this, "toggleFallback", (n = !1) => {
      if (n ? this.scrollPosition = {
        x: window.scrollX ?? 0,
        y: window.scrollY ?? 0
      } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = n ? "hidden" : "", toggleClass(this.target, this.player.config.classNames.fullscreen.fallback, n), at.isIos) {
        let r = document.head.querySelector('meta[name="viewport"]');
        const i = "viewport-fit=cover";
        r || (r = document.createElement("meta"), r.setAttribute("name", "viewport"));
        const s = x.string(r.content) && r.content.includes(i);
        n ? (this.cleanupViewport = !s, s || (r.content += `,${i}`)) : this.cleanupViewport && (r.content = r.content.split(",").filter(a => a.trim() !== i).join(","));
      }
      this.onChange();
    }), _defineProperty(this, "trapFocus", n => {
      if (at.isIos || at.isIPadOS || !this.active || n.key !== "Tab") return;
      const r = document.activeElement,
        i = getElements.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"),
        [s] = i,
        a = i[i.length - 1];
      r !== a || n.shiftKey ? r === s && n.shiftKey && (a.focus(), n.preventDefault()) : (s.focus(), n.preventDefault());
    }), _defineProperty(this, "update", () => {
      if (this.supported) {
        let n;
        n = this.forceFallback ? "Fallback (forced)" : Fullscreen.nativeSupported ? "Native" : "Fallback", this.player.debug.log(`${n} fullscreen enabled`);
      } else this.player.debug.log("Fullscreen not supported and fallback disabled");
      toggleClass(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
    }), _defineProperty(this, "enter", () => {
      this.supported && (at.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !Fullscreen.nativeSupported || this.forceFallback ? this.toggleFallback(!0) : this.prefix ? x.empty(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({
        navigationUI: "hide"
      }));
    }), _defineProperty(this, "exit", () => {
      if (this.supported) if (at.isIos && this.player.config.fullscreen.iosNative) this.player.isVimeo ? this.player.embed.exitFullscreen() : this.target.webkitEnterFullscreen(), silencePromise(this.player.play());else if (!Fullscreen.nativeSupported || this.forceFallback) this.toggleFallback(!1);else if (this.prefix) {
        if (!x.empty(this.prefix)) {
          const n = this.prefix === "moz" ? "Cancel" : "Exit";
          document[`${this.prefix}${n}${this.property}`]();
        }
      } else (document.cancelFullScreen || document.exitFullscreen).call(document);
    }), _defineProperty(this, "toggle", () => {
      this.active ? this.exit() : this.enter();
    }), this.player = e, this.prefix = Fullscreen.prefix, this.property = Fullscreen.property, this.scrollPosition = {
      x: 0,
      y: 0
    }, this.forceFallback = e.config.fullscreen.fallback === "force", this.player.elements.fullscreen = e.config.fullscreen.container && closest$1(this.player.elements.container, e.config.fullscreen.container), on$1.call(this.player, document, this.prefix === "ms" ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, () => {
      this.onChange();
    }), on$1.call(this.player, this.player.elements.container, "dblclick", n => {
      x.element(this.player.elements.controls) && this.player.elements.controls.contains(n.target) || this.player.listeners.proxy(n, this.toggle, "fullscreen");
    }), on$1.call(this, this.player.elements.container, "keydown", n => this.trapFocus(n)), this.update();
  }
  static get nativeSupported() {
    return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
  }
  get useNative() {
    return Fullscreen.nativeSupported && !this.forceFallback;
  }
  static get prefix() {
    if (x.function(document.exitFullscreen)) return "";
    let e = "";
    return ["webkit", "moz", "ms"].some(n => !(!x.function(document[`${n}ExitFullscreen`]) && !x.function(document[`${n}CancelFullScreen`])) && (e = n, !0)), e;
  }
  static get property() {
    return this.prefix === "moz" ? "FullScreen" : "Fullscreen";
  }
  get supported() {
    return [this.player.config.fullscreen.enabled, this.player.isVideo, Fullscreen.nativeSupported || this.player.config.fullscreen.fallback, !this.player.isYouTube || Fullscreen.nativeSupported || !at.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative].every(Boolean);
  }
  get active() {
    if (!this.supported) return !1;
    if (!Fullscreen.nativeSupported || this.forceFallback) return hasClass$1(this.target, this.player.config.classNames.fullscreen.fallback);
    const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
    return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
  }
  get target() {
    return at.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen ?? this.player.elements.container;
  }
}
o(Fullscreen, "Fullscreen");
function loadImage$1(t, e = 1) {
  return new Promise((n, r) => {
    const i = new Image(),
      r$3 = o(() => {
        delete i.onload, delete i.onerror, (i.naturalWidth >= e ? n : r)(i);
      }, "r");
    Object.assign(i, {
      onload: r$3,
      onerror: r$3,
      src: t
    });
  });
}
o(loadImage$1, "loadImage");
const Ae = {
  addStyleHook() {
    toggleClass(this.elements.container, this.config.selectors.container.replace(".", ""), !0), toggleClass(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
  },
  toggleNativeControls(t = !1) {
    t && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
  },
  build() {
    if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void Ae.toggleNativeControls.call(this, !0);
    x.element(this.elements.controls) || (ee.inject.call(this), this.listeners.controls()), Ae.toggleNativeControls.call(this), this.isHTML5 && Ce.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, ee.updateVolume.call(this), ee.timeUpdate.call(this), ee.durationUpdate.call(this), Ae.checkPlaying.call(this), toggleClass(this.elements.container, this.config.classNames.pip.supported, Xe.pip && this.isHTML5 && this.isVideo), toggleClass(this.elements.container, this.config.classNames.airplay.supported, Xe.airplay && this.isHTML5), toggleClass(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(() => {
      triggerEvent.call(this, this.media, "ready");
    }, 0), Ae.setTitle.call(this), this.poster && Ae.setPoster.call(this, this.poster, !1).catch(() => {}), this.config.duration && ee.durationUpdate.call(this), this.config.mediaMetadata && ee.setMediaMetadata.call(this);
  },
  setTitle() {
    let t = ot.get("play", this.config);
    if (x.string(this.config.title) && !x.empty(this.config.title) && (t += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach(e => {
      e.setAttribute("aria-label", t);
    }), this.isEmbed) {
      const e = getElement.call(this, "iframe");
      if (!x.element(e)) return;
      const n = x.empty(this.config.title) ? "video" : this.config.title,
        r = ot.get("frameTitle", this.config);
      e.setAttribute("title", r.replace("{title}", n));
    }
  },
  togglePoster(t) {
    toggleClass(this.elements.container, this.config.classNames.posterEnabled, t);
  },
  setPoster(t, e = !0) {
    return e && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", t), this.elements.poster.removeAttribute("hidden"), ready.call(this).then(() => loadImage$1(t)).catch(n => {
      throw t === this.poster && Ae.togglePoster.call(this, !1), n;
    }).then(() => {
      if (t !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
    }).then(() => (Object.assign(this.elements.poster.style, {
      backgroundImage: `url('${t}')`,
      backgroundSize: ""
    }), Ae.togglePoster.call(this, !0), t)));
  },
  checkPlaying(t) {
    toggleClass(this.elements.container, this.config.classNames.playing, this.playing), toggleClass(this.elements.container, this.config.classNames.paused, this.paused), toggleClass(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach(e => {
      Object.assign(e, {
        pressed: this.playing
      }), e.setAttribute("aria-label", ot.get(this.playing ? "pause" : "play", this.config));
    }), x.event(t) && t.type === "timeupdate" || Ae.toggleControls.call(this);
  },
  checkLoading(t) {
    this.loading = ["stalled", "waiting"].includes(t.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(() => {
      toggleClass(this.elements.container, this.config.classNames.loading, this.loading), Ae.toggleControls.call(this);
    }, this.loading ? 250 : 0);
  },
  toggleControls(t) {
    const {
      controls: e
    } = this.elements;
    if (e && this.config.hideControls) {
      const n = this.touch && this.lastSeekTime + 2e3 > Date.now();
      this.toggleControls(!!(t || this.loading || this.paused || e.pressed || e.hover || n));
    }
  },
  migrateStyles() {
    Object.values({
      ...this.media.style
    }).filter(t => !x.empty(t) && x.string(t) && t.startsWith("--plyr")).forEach(t => {
      this.elements.container.style.setProperty(t, this.media.style.getPropertyValue(t)), this.media.style.removeProperty(t);
    }), x.empty(this.media.style) && this.media.removeAttribute("style");
  }
};
class Listeners {
  constructor(e) {
    _defineProperty(this, "firstTouch", () => {
      const {
          player: n
        } = this,
        {
          elements: r
        } = n;
      n.touch = !0, toggleClass(r.container, n.config.classNames.isTouch, !0);
    }), _defineProperty(this, "global", (n = !0) => {
      const {
        player: r
      } = this;
      r.config.keyboard.global && toggleListener.call(r, window, "keydown keyup", this.handleKey, n, !1), toggleListener.call(r, document.body, "click", this.toggleMenu, n), once.call(r, document.body, "touchstart", this.firstTouch);
    }), _defineProperty(this, "container", () => {
      const {
          player: n
        } = this,
        {
          config: r,
          elements: i,
          timers: s
        } = n;
      !r.keyboard.global && r.keyboard.focused && on$1.call(n, i.container, "keydown keyup", this.handleKey, !1), on$1.call(n, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", u => {
        const {
          controls: c
        } = i;
        c && u.type === "enterfullscreen" && (c.pressed = !1, c.hover = !1);
        let p = 0;
        ["touchstart", "touchmove", "mousemove"].includes(u.type) && (Ae.toggleControls.call(n, !0), p = n.touch ? 3e3 : 2e3), clearTimeout(s.controls), s.controls = setTimeout(() => Ae.toggleControls.call(n, !1), p);
      });
      const n$2 = o(() => {
          if (!n.isVimeo || n.config.vimeo.premium) return;
          const u = i.wrapper,
            {
              active: c
            } = n.fullscreen,
            [p, m] = getAspectRatio.call(n),
            d = supportsCSS(`aspect-ratio: ${p} / ${m}`);
          if (!c) return void (d ? (u.style.width = null, u.style.height = null) : (u.style.maxWidth = null, u.style.margin = null));
          const [y, S] = getViewportSize(),
            w = y / S > p / m;
          d ? (u.style.width = w ? "auto" : "100%", u.style.height = w ? "100%" : "auto") : (u.style.maxWidth = w ? S / m * p + "px" : null, u.style.margin = w ? "0 auto" : null);
        }, "n"),
        r$4 = o(() => {
          clearTimeout(s.resized), s.resized = setTimeout(n$2, 50);
        }, "r");
      on$1.call(n, i.container, "enterfullscreen exitfullscreen", u => {
        const {
          target: c
        } = n.fullscreen;
        c === i.container && (!n.isEmbed && x.empty(n.config.ratio) || (n$2(), (u.type === "enterfullscreen" ? on$1 : off).call(n, window, "resize", r$4)));
      });
    }), _defineProperty(this, "media", () => {
      const {
          player: n
        } = this,
        {
          elements: r
        } = n;
      if (on$1.call(n, n.media, "timeupdate seeking seeked", s => ee.timeUpdate.call(n, s)), on$1.call(n, n.media, "durationchange loadeddata loadedmetadata", s => ee.durationUpdate.call(n, s)), on$1.call(n, n.media, "ended", () => {
        n.isHTML5 && n.isVideo && n.config.resetOnEnd && (n.restart(), n.pause());
      }), on$1.call(n, n.media, "progress playing seeking seeked", s => ee.updateProgress.call(n, s)), on$1.call(n, n.media, "volumechange", s => ee.updateVolume.call(n, s)), on$1.call(n, n.media, "playing play pause ended emptied timeupdate", s => Ae.checkPlaying.call(n, s)), on$1.call(n, n.media, "waiting canplay seeked playing", s => Ae.checkLoading.call(n, s)), n.supported.ui && n.config.clickToPlay && !n.isAudio) {
        const s = getElement.call(n, `.${n.config.classNames.video}`);
        if (!x.element(s)) return;
        on$1.call(n, r.container, "click", a => {
          ([r.container, s].includes(a.target) || s.contains(a.target)) && (n.touch && n.config.hideControls || (n.ended ? (this.proxy(a, n.restart, "restart"), this.proxy(a, () => {
            silencePromise(n.play());
          }, "play")) : this.proxy(a, () => {
            silencePromise(n.togglePlay());
          }, "play")));
        });
      }
      n.supported.ui && n.config.disableContextMenu && on$1.call(n, r.wrapper, "contextmenu", s => {
        s.preventDefault();
      }, !1), on$1.call(n, n.media, "volumechange", () => {
        n.storage.set({
          volume: n.volume,
          muted: n.muted
        });
      }), on$1.call(n, n.media, "ratechange", () => {
        ee.updateSetting.call(n, "speed"), n.storage.set({
          speed: n.speed
        });
      }), on$1.call(n, n.media, "qualitychange", s => {
        ee.updateSetting.call(n, "quality", null, s.detail.quality);
      }), on$1.call(n, n.media, "ready qualitychange", () => {
        ee.setDownloadUrl.call(n);
      });
      const i = n.config.events.concat(["keyup", "keydown"]).join(" ");
      on$1.call(n, n.media, i, s => {
        let {
          detail: a = {}
        } = s;
        s.type === "error" && (a = n.media.error), triggerEvent.call(n, r.container, s.type, !0, a);
      });
    }), _defineProperty(this, "proxy", (n, r, i) => {
      const {
          player: s
        } = this,
        a = s.config.listeners[i];
      let l = !0;
      x.function(a) && (l = a.call(s, n)), l !== !1 && x.function(r) && r.call(s, n);
    }), _defineProperty(this, "bind", (n, r, i, s, a = !0) => {
      const {
          player: l
        } = this,
        u = l.config.listeners[s],
        c = x.function(u);
      on$1.call(l, n, r, p => this.proxy(p, i, s), a && !c);
    }), _defineProperty(this, "controls", () => {
      const {
          player: n
        } = this,
        {
          elements: r
        } = n,
        i = at.isIE ? "change" : "input";
      if (r.buttons.play && Array.from(r.buttons.play).forEach(s => {
        this.bind(s, "click", () => {
          silencePromise(n.togglePlay());
        }, "play");
      }), this.bind(r.buttons.restart, "click", n.restart, "restart"), this.bind(r.buttons.rewind, "click", () => {
        n.lastSeekTime = Date.now(), n.rewind();
      }, "rewind"), this.bind(r.buttons.fastForward, "click", () => {
        n.lastSeekTime = Date.now(), n.forward();
      }, "fastForward"), this.bind(r.buttons.mute, "click", () => {
        n.muted = !n.muted;
      }, "mute"), this.bind(r.buttons.captions, "click", () => n.toggleCaptions()), this.bind(r.buttons.download, "click", () => {
        triggerEvent.call(n, n.media, "download");
      }, "download"), this.bind(r.buttons.fullscreen, "click", () => {
        n.fullscreen.toggle();
      }, "fullscreen"), this.bind(r.buttons.pip, "click", () => {
        n.pip = "toggle";
      }, "pip"), this.bind(r.buttons.airplay, "click", n.airplay, "airplay"), this.bind(r.buttons.settings, "click", s => {
        s.stopPropagation(), s.preventDefault(), ee.toggleMenu.call(n, s);
      }, null, !1), this.bind(r.buttons.settings, "keyup", s => {
        [" ", "Enter"].includes(s.key) && (s.key !== "Enter" ? (s.preventDefault(), s.stopPropagation(), ee.toggleMenu.call(n, s)) : ee.focusFirstMenuItem.call(n, null, !0));
      }, null, !1), this.bind(r.settings.menu, "keydown", s => {
        s.key === "Escape" && ee.toggleMenu.call(n, s);
      }), this.bind(r.inputs.seek, "mousedown mousemove", s => {
        const a = r.progress.getBoundingClientRect(),
          l = 100 / a.width * (s.pageX - a.left);
        s.currentTarget.setAttribute("seek-value", l);
      }), this.bind(r.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", s => {
        const a = s.currentTarget,
          l = "play-on-seeked";
        if (x.keyboardEvent(s) && !["ArrowLeft", "ArrowRight"].includes(s.key)) return;
        n.lastSeekTime = Date.now();
        const u = a.hasAttribute(l),
          c = ["mouseup", "touchend", "keyup"].includes(s.type);
        u && c ? (a.removeAttribute(l), silencePromise(n.play())) : !c && n.playing && (a.setAttribute(l, ""), n.pause());
      }), at.isIos) {
        const s = getElements.call(n, 'input[type="range"]');
        Array.from(s).forEach(a => this.bind(a, i, l => repaint(l.target)));
      }
      this.bind(r.inputs.seek, i, s => {
        const a = s.currentTarget;
        let l = a.getAttribute("seek-value");
        x.empty(l) && (l = a.value), a.removeAttribute("seek-value"), n.currentTime = l / a.max * n.duration;
      }, "seek"), this.bind(r.progress, "mouseenter mouseleave mousemove", s => ee.updateSeekTooltip.call(n, s)), this.bind(r.progress, "mousemove touchmove", s => {
        const {
          previewThumbnails: a
        } = n;
        a && a.loaded && a.startMove(s);
      }), this.bind(r.progress, "mouseleave touchend click", () => {
        const {
          previewThumbnails: s
        } = n;
        s && s.loaded && s.endMove(!1, !0);
      }), this.bind(r.progress, "mousedown touchstart", s => {
        const {
          previewThumbnails: a
        } = n;
        a && a.loaded && a.startScrubbing(s);
      }), this.bind(r.progress, "mouseup touchend", s => {
        const {
          previewThumbnails: a
        } = n;
        a && a.loaded && a.endScrubbing(s);
      }), at.isWebKit && Array.from(getElements.call(n, 'input[type="range"]')).forEach(s => {
        this.bind(s, "input", a => ee.updateRangeFill.call(n, a.target));
      }), n.config.toggleInvert && !x.element(r.display.duration) && this.bind(r.display.currentTime, "click", () => {
        n.currentTime !== 0 && (n.config.invertTime = !n.config.invertTime, ee.timeUpdate.call(n));
      }), this.bind(r.inputs.volume, i, s => {
        n.volume = s.target.value;
      }, "volume"), this.bind(r.controls, "mouseenter mouseleave", s => {
        r.controls.hover = !n.touch && s.type === "mouseenter";
      }), r.fullscreen && Array.from(r.fullscreen.children).filter(s => !s.contains(r.container)).forEach(s => {
        this.bind(s, "mouseenter mouseleave", a => {
          r.controls && (r.controls.hover = !n.touch && a.type === "mouseenter");
        });
      }), this.bind(r.controls, "mousedown mouseup touchstart touchend touchcancel", s => {
        r.controls.pressed = ["mousedown", "touchstart"].includes(s.type);
      }), this.bind(r.controls, "focusin", () => {
        const {
          config: s,
          timers: a
        } = n;
        toggleClass(r.controls, s.classNames.noTransition, !0), Ae.toggleControls.call(n, !0), setTimeout(() => {
          toggleClass(r.controls, s.classNames.noTransition, !1);
        }, 0);
        const l = this.touch ? 3e3 : 4e3;
        clearTimeout(a.controls), a.controls = setTimeout(() => Ae.toggleControls.call(n, !1), l);
      }), this.bind(r.inputs.volume, "wheel", s => {
        const a = s.webkitDirectionInvertedFromDevice,
          [l, u] = [s.deltaX, -s.deltaY].map(m => a ? -m : m),
          c = Math.sign(Math.abs(l) > Math.abs(u) ? l : u);
        n.increaseVolume(c / 50);
        const {
          volume: p
        } = n.media;
        (c === 1 && p < 1 || c === -1 && p > 0) && s.preventDefault();
      }, "volume", !1);
    }), this.player = e, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this);
  }
  handleKey(e) {
    const {
        player: n
      } = this,
      {
        elements: r
      } = n,
      {
        key: i,
        type: s,
        altKey: a,
        ctrlKey: l,
        metaKey: u,
        shiftKey: c
      } = e,
      p = s === "keydown",
      m = p && i === this.lastKey;
    if (!(a || l || u || c) && i) {
      if (p) {
        const y = document.activeElement;
        if (x.element(y)) {
          const {
              editable: S
            } = n.config.selectors,
            {
              seek: w
            } = r.inputs;
          if (y !== w && matches$1(y, S) || e.key === " " && matches$1(y, 'button, [role^="menuitem"]')) return;
        }
        switch ([" ", "ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "c", "f", "k", "l", "m"].includes(i) && (e.preventDefault(), e.stopPropagation()), i) {
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9":
            m || (d = parseInt(i, 10), n.currentTime = n.duration / 10 * d);
            break;
          case " ":
          case "k":
            m || silencePromise(n.togglePlay());
            break;
          case "ArrowUp":
            n.increaseVolume(.1);
            break;
          case "ArrowDown":
            n.decreaseVolume(.1);
            break;
          case "m":
            m || (n.muted = !n.muted);
            break;
          case "ArrowRight":
            n.forward();
            break;
          case "ArrowLeft":
            n.rewind();
            break;
          case "f":
            n.fullscreen.toggle();
            break;
          case "c":
            m || n.toggleCaptions();
            break;
          case "l":
            n.loop = !n.loop;
        }
        i === "Escape" && !n.fullscreen.usingNative && n.fullscreen.active && n.fullscreen.toggle(), this.lastKey = i;
      } else this.lastKey = null;
      var d;
    }
  }
  toggleMenu(e) {
    ee.toggleMenu.call(this.player, e);
  }
}
o(Listeners, "Listeners");
function createCommonjsModule(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}
o(createCommonjsModule, "createCommonjsModule");
var JA = createCommonjsModule(function (t, e) {
  t.exports = function () {
    var e$3 = o(function () {}, "e"),
      r = {},
      i = {},
      s = {};
    function n$3(d, y) {
      d = d.push ? d : [d];
      var S,
        w,
        g,
        h = [],
        f = d.length,
        v = f;
      for (S = o(function (E, b) {
        b.length && h.push(E), --v || y(h);
      }, "n"); f--;) w = d[f], (g = i[w]) ? S(w, g) : (s[w] = s[w] || []).push(S);
    }
    o(n$3, "n");
    function r$5(d, y) {
      if (d) {
        var S = s[d];
        if (i[d] = y, S) for (; S.length;) S[0](d, y), S.splice(0, 1);
      }
    }
    o(r$5, "r");
    function a$1(d, y) {
      d.call && (d = {
        success: d
      }), y.length ? (d.error || e$3)(y) : (d.success || e$3)(d);
    }
    o(a$1, "a");
    function o$1(d, y, S, w) {
      var g,
        h,
        f = document,
        v = S.async,
        E = (S.numRetries || 0) + 1,
        b = S.before || e$3,
        P = d.replace(/[\?|#].*$/, ""),
        T = d.replace(/^(css|img)!/, "");
      w = w || 0, /(^css!|\.css$)/.test(P) ? ((h = f.createElement("link")).rel = "stylesheet", h.href = T, (g = "hideFocus" in h) && h.relList && (g = 0, h.rel = "preload", h.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(P) ? (h = f.createElement("img")).src = T : ((h = f.createElement("script")).src = d, h.async = v === void 0 || v), h.onload = h.onerror = h.onbeforeload = function (O) {
        var M = O.type[0];
        if (g) try {
          h.sheet.cssText.length || (M = "e");
        } catch (I) {
          I.code != 18 && (M = "e");
        }
        if (M == "e") {
          if ((w += 1) < E) return o$1(d, y, S, w);
        } else if (h.rel == "preload" && h.as == "style") return h.rel = "stylesheet";
        y(d, M, O.defaultPrevented);
      }, b(d, h) !== !1 && f.head.appendChild(h);
    }
    o(o$1, "o");
    function l$1(d, y, S) {
      var w,
        g,
        h = (d = d.push ? d : [d]).length,
        f = h,
        v = [];
      for (w = o(function (E, b, P) {
        if (b == "e" && v.push(E), b == "b") {
          if (!P) return;
          v.push(E);
        }
        --h || y(v);
      }, "s"), g = 0; g < f; g++) o$1(d[g], w, S);
    }
    o(l$1, "l");
    function c$2(d, y, S) {
      var w, g;
      if (y && y.trim && (w = y), g = (w ? S : y) || {}, w) {
        if (w in r) throw "LoadJS";
        r[w] = !0;
      }
      function c$1(f, v) {
        l$1(d, function (E) {
          a$1(g, E), f && a$1({
            success: f,
            error: v
          }, E), r$5(w, E);
        }, g);
      }
      if (o(c$1, "c"), g.returnPromise) return new Promise(c$1);
      c$1();
    }
    return o(c$2, "c"), c$2.ready = function (d, y) {
      return n$3(d, function (S) {
        a$1(y, S);
      }), c$2;
    }, c$2.done = function (d) {
      r$5(d, []);
    }, c$2.reset = function () {
      r = {}, i = {}, s = {};
    }, c$2.isDefined = function (d) {
      return d in r;
    }, c$2;
  }();
});
function loadScript(t) {
  return new Promise((e, n) => {
    JA(t, {
      success: e,
      error: n
    });
  });
}
o(loadScript, "loadScript");
function parseId(t) {
  return x.empty(t) ? null : x.number(Number(t)) ? t : t.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : t;
}
o(parseId, "parseId$1");
function parseHash(t) {
  const e = t.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
  return e && e.length === 5 ? e[4] : null;
}
o(parseHash, "parseHash");
function assurePlaybackState(t) {
  t && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === t && (this.media.paused = !t, triggerEvent.call(this, this.media, t ? "play" : "pause"));
}
o(assurePlaybackState, "assurePlaybackState$1");
const Hf = {
  setup() {
    const t = this;
    toggleClass(t.elements.wrapper, t.config.classNames.embed, !0), t.options.speed = t.config.speed.options, setAspectRatio.call(t), x.object(window.Vimeo) ? Hf.ready.call(t) : loadScript(t.config.urls.vimeo.sdk).then(() => {
      Hf.ready.call(t);
    }).catch(e => {
      t.debug.warn("Vimeo SDK (player.js) failed to load", e);
    });
  },
  ready() {
    const t = this,
      e = t.config.vimeo,
      {
        premium: n,
        referrerPolicy: r,
        ...i
      } = e;
    let s = t.media.getAttribute("src"),
      a = "";
    x.empty(s) ? (s = t.media.getAttribute(t.config.attributes.embed.id), a = t.media.getAttribute(t.config.attributes.embed.hash)) : a = parseHash(s);
    const l = a ? {
      h: a
    } : {};
    n && Object.assign(i, {
      controls: !1,
      sidedock: !1
    });
    const u = buildUrlParams({
        loop: t.config.loop.active,
        autoplay: t.autoplay,
        muted: t.muted,
        gesture: "media",
        playsinline: t.config.playsinline,
        ...l,
        ...i
      }),
      c = parseId(s),
      p = createElement$1("iframe"),
      m = format(t.config.urls.vimeo.iframe, c, u);
    if (p.setAttribute("src", m), p.setAttribute("allowfullscreen", ""), p.setAttribute("allow", ["autoplay", "fullscreen", "picture-in-picture", "encrypted-media", "accelerometer", "gyroscope"].join("; ")), x.empty(r) || p.setAttribute("referrerPolicy", r), n || !e.customControls) p.setAttribute("data-poster", t.poster), t.media = replaceElement(p, t.media);else {
      const f = createElement$1("div", {
        class: t.config.classNames.embedContainer,
        "data-poster": t.poster
      });
      f.appendChild(p), t.media = replaceElement(f, t.media);
    }
    e.customControls || fetch$1(format(t.config.urls.vimeo.api, m)).then(f => {
      !x.empty(f) && f.thumbnail_url && Ae.setPoster.call(t, f.thumbnail_url).catch(() => {});
    }), t.embed = new window.Vimeo.Player(p, {
      autopause: t.config.autopause,
      muted: t.muted
    }), t.media.paused = !0, t.media.currentTime = 0, t.supported.ui && t.embed.disableTextTrack(), t.media.play = () => (assurePlaybackState.call(t, !0), t.embed.play()), t.media.pause = () => (assurePlaybackState.call(t, !1), t.embed.pause()), t.media.stop = () => {
      t.pause(), t.currentTime = 0;
    };
    let {
      currentTime: d
    } = t.media;
    Object.defineProperty(t.media, "currentTime", {
      get: () => d,
      set(f) {
        const {
            embed: v,
            media: E,
            paused: b,
            volume: P
          } = t,
          T = b && !v.hasPlayed;
        E.seeking = !0, triggerEvent.call(t, E, "seeking"), Promise.resolve(T && v.setVolume(0)).then(() => v.setCurrentTime(f)).then(() => T && v.pause()).then(() => T && v.setVolume(P)).catch(() => {});
      }
    });
    let y = t.config.speed.selected;
    Object.defineProperty(t.media, "playbackRate", {
      get: () => y,
      set(f) {
        t.embed.setPlaybackRate(f).then(() => {
          y = f, triggerEvent.call(t, t.media, "ratechange");
        }).catch(() => {
          t.options.speed = [1];
        });
      }
    });
    let {
      volume: S
    } = t.config;
    Object.defineProperty(t.media, "volume", {
      get: () => S,
      set(f) {
        t.embed.setVolume(f).then(() => {
          S = f, triggerEvent.call(t, t.media, "volumechange");
        });
      }
    });
    let {
      muted: w
    } = t.config;
    Object.defineProperty(t.media, "muted", {
      get: () => w,
      set(f) {
        const v = !!x.boolean(f) && f;
        t.embed.setMuted(!!v || t.config.muted).then(() => {
          w = v, triggerEvent.call(t, t.media, "volumechange");
        });
      }
    });
    let g,
      {
        loop: h
      } = t.config;
    Object.defineProperty(t.media, "loop", {
      get: () => h,
      set(f) {
        const v = x.boolean(f) ? f : t.config.loop.active;
        t.embed.setLoop(v).then(() => {
          h = v;
        });
      }
    }), t.embed.getVideoUrl().then(f => {
      g = f, ee.setDownloadUrl.call(t);
    }).catch(f => {
      this.debug.warn(f);
    }), Object.defineProperty(t.media, "currentSrc", {
      get: () => g
    }), Object.defineProperty(t.media, "ended", {
      get: () => t.currentTime === t.duration
    }), Promise.all([t.embed.getVideoWidth(), t.embed.getVideoHeight()]).then(f => {
      const [v, E] = f;
      t.embed.ratio = roundAspectRatio(v, E), setAspectRatio.call(this);
    }), t.embed.setAutopause(t.config.autopause).then(f => {
      t.config.autopause = f;
    }), t.embed.getVideoTitle().then(f => {
      t.config.title = f, Ae.setTitle.call(this);
    }), t.embed.getCurrentTime().then(f => {
      d = f, triggerEvent.call(t, t.media, "timeupdate");
    }), t.embed.getDuration().then(f => {
      t.media.duration = f, triggerEvent.call(t, t.media, "durationchange");
    }), t.embed.getTextTracks().then(f => {
      t.media.textTracks = f, Ce.setup.call(t);
    }), t.embed.on("cuechange", ({
      cues: f = []
    }) => {
      const v = f.map(E => stripHTML(E.text));
      Ce.updateCues.call(t, v);
    }), t.embed.on("loaded", () => {
      t.embed.getPaused().then(f => {
        assurePlaybackState.call(t, !f), f || triggerEvent.call(t, t.media, "playing");
      }), x.element(t.embed.element) && t.supported.ui && t.embed.element.setAttribute("tabindex", -1);
    }), t.embed.on("bufferstart", () => {
      triggerEvent.call(t, t.media, "waiting");
    }), t.embed.on("bufferend", () => {
      triggerEvent.call(t, t.media, "playing");
    }), t.embed.on("play", () => {
      assurePlaybackState.call(t, !0), triggerEvent.call(t, t.media, "playing");
    }), t.embed.on("pause", () => {
      assurePlaybackState.call(t, !1);
    }), t.embed.on("timeupdate", f => {
      t.media.seeking = !1, d = f.seconds, triggerEvent.call(t, t.media, "timeupdate");
    }), t.embed.on("progress", f => {
      t.media.buffered = f.percent, triggerEvent.call(t, t.media, "progress"), parseInt(f.percent, 10) === 1 && triggerEvent.call(t, t.media, "canplaythrough"), t.embed.getDuration().then(v => {
        v !== t.media.duration && (t.media.duration = v, triggerEvent.call(t, t.media, "durationchange"));
      });
    }), t.embed.on("seeked", () => {
      t.media.seeking = !1, triggerEvent.call(t, t.media, "seeked");
    }), t.embed.on("ended", () => {
      t.media.paused = !0, triggerEvent.call(t, t.media, "ended");
    }), t.embed.on("error", f => {
      t.media.error = f, triggerEvent.call(t, t.media, "error");
    }), e.customControls && setTimeout(() => Ae.build.call(t), 0);
  }
};
function parseId$1(t) {
  return x.empty(t) ? null : t.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : t;
}
o(parseId$1, "parseId");
function assurePlaybackState$1(t) {
  t && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === t && (this.media.paused = !t, triggerEvent.call(this, this.media, t ? "play" : "pause"));
}
o(assurePlaybackState$1, "assurePlaybackState");
function getHost(t) {
  return t.noCookie ? "https://www.youtube-nocookie.com" : window.location.protocol === "http:" ? "http://www.youtube.com" : void 0;
}
o(getHost, "getHost");
const Sa = {
    setup() {
      if (toggleClass(this.elements.wrapper, this.config.classNames.embed, !0), x.object(window.YT) && x.function(window.YT.Player)) Sa.ready.call(this);else {
        const t = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
          x.function(t) && t(), Sa.ready.call(this);
        }, loadScript(this.config.urls.youtube.sdk).catch(e => {
          this.debug.warn("YouTube API failed to load", e);
        });
      }
    },
    getTitle(t) {
      fetch$1(format(this.config.urls.youtube.api, t)).then(e => {
        if (x.object(e)) {
          const {
            title: n,
            height: r,
            width: i
          } = e;
          this.config.title = n, Ae.setTitle.call(this), this.embed.ratio = roundAspectRatio(i, r);
        }
        setAspectRatio.call(this);
      }).catch(() => {
        setAspectRatio.call(this);
      });
    },
    ready() {
      const t = this,
        e = t.config.youtube,
        n = t.media && t.media.getAttribute("id");
      if (!x.empty(n) && n.startsWith("youtube-")) return;
      let r = t.media.getAttribute("src");
      x.empty(r) && (r = t.media.getAttribute(this.config.attributes.embed.id));
      const i = parseId$1(r),
        s = createElement$1("div", {
          id: generateId(t.provider),
          "data-poster": e.customControls ? t.poster : void 0
        });
      if (t.media = replaceElement(s, t.media), e.customControls) {
        const t$2 = o(l => `https://i.ytimg.com/vi/${i}/${l}default.jpg`, "t");
        loadImage$1(t$2("maxres"), 121).catch(() => loadImage$1(t$2("sd"), 121)).catch(() => loadImage$1(t$2("hq"))).then(l => Ae.setPoster.call(t, l.src)).then(l => {
          l.includes("maxres") || (t.elements.poster.style.backgroundSize = "cover");
        }).catch(() => {});
      }
      t.embed = new window.YT.Player(t.media, {
        videoId: i,
        host: getHost(e),
        playerVars: extend$4({}, {
          autoplay: t.config.autoplay ? 1 : 0,
          hl: t.config.hl,
          controls: t.supported.ui && e.customControls ? 0 : 1,
          disablekb: 1,
          playsinline: t.config.playsinline && !t.config.fullscreen.iosNative ? 1 : 0,
          cc_load_policy: t.captions.active ? 1 : 0,
          cc_lang_pref: t.config.captions.language,
          widget_referrer: window ? window.location.href : null
        }, e),
        events: {
          onError(a) {
            if (!t.media.error) {
              const l = a.data,
                u = {
                  2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                  5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                  100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                  101: "The owner of the requested video does not allow it to be played in embedded players.",
                  150: "The owner of the requested video does not allow it to be played in embedded players."
                }[l] || "An unknown error occurred";
              t.media.error = {
                code: l,
                message: u
              }, triggerEvent.call(t, t.media, "error");
            }
          },
          onPlaybackRateChange(a) {
            const l = a.target;
            t.media.playbackRate = l.getPlaybackRate(), triggerEvent.call(t, t.media, "ratechange");
          },
          onReady(a) {
            if (x.function(t.media.play)) return;
            const l = a.target;
            Sa.getTitle.call(t, i), t.media.play = () => {
              assurePlaybackState$1.call(t, !0), l.playVideo();
            }, t.media.pause = () => {
              assurePlaybackState$1.call(t, !1), l.pauseVideo();
            }, t.media.stop = () => {
              l.stopVideo();
            }, t.media.duration = l.getDuration(), t.media.paused = !0, t.media.currentTime = 0, Object.defineProperty(t.media, "currentTime", {
              get: () => Number(l.getCurrentTime()),
              set(m) {
                t.paused && !t.embed.hasPlayed && t.embed.mute(), t.media.seeking = !0, triggerEvent.call(t, t.media, "seeking"), l.seekTo(m);
              }
            }), Object.defineProperty(t.media, "playbackRate", {
              get: () => l.getPlaybackRate(),
              set(m) {
                l.setPlaybackRate(m);
              }
            });
            let {
              volume: u
            } = t.config;
            Object.defineProperty(t.media, "volume", {
              get: () => u,
              set(m) {
                u = m, l.setVolume(100 * u), triggerEvent.call(t, t.media, "volumechange");
              }
            });
            let {
              muted: c
            } = t.config;
            Object.defineProperty(t.media, "muted", {
              get: () => c,
              set(m) {
                const d = x.boolean(m) ? m : c;
                c = d, l[d ? "mute" : "unMute"](), l.setVolume(100 * u), triggerEvent.call(t, t.media, "volumechange");
              }
            }), Object.defineProperty(t.media, "currentSrc", {
              get: () => l.getVideoUrl()
            }), Object.defineProperty(t.media, "ended", {
              get: () => t.currentTime === t.duration
            });
            const p = l.getAvailablePlaybackRates();
            t.options.speed = p.filter(m => t.config.speed.options.includes(m)), t.supported.ui && e.customControls && t.media.setAttribute("tabindex", -1), triggerEvent.call(t, t.media, "timeupdate"), triggerEvent.call(t, t.media, "durationchange"), clearInterval(t.timers.buffering), t.timers.buffering = setInterval(() => {
              t.media.buffered = l.getVideoLoadedFraction(), (t.media.lastBuffered === null || t.media.lastBuffered < t.media.buffered) && triggerEvent.call(t, t.media, "progress"), t.media.lastBuffered = t.media.buffered, t.media.buffered === 1 && (clearInterval(t.timers.buffering), triggerEvent.call(t, t.media, "canplaythrough"));
            }, 200), e.customControls && setTimeout(() => Ae.build.call(t), 50);
          },
          onStateChange(a) {
            const l = a.target;
            switch (clearInterval(t.timers.playing), t.media.seeking && [1, 2].includes(a.data) && (t.media.seeking = !1, triggerEvent.call(t, t.media, "seeked")), a.data) {
              case -1:
                triggerEvent.call(t, t.media, "timeupdate"), t.media.buffered = l.getVideoLoadedFraction(), triggerEvent.call(t, t.media, "progress");
                break;
              case 0:
                assurePlaybackState$1.call(t, !1), t.media.loop ? (l.stopVideo(), l.playVideo()) : triggerEvent.call(t, t.media, "ended");
                break;
              case 1:
                e.customControls && !t.config.autoplay && t.media.paused && !t.embed.hasPlayed ? t.media.pause() : (assurePlaybackState$1.call(t, !0), triggerEvent.call(t, t.media, "playing"), t.timers.playing = setInterval(() => {
                  triggerEvent.call(t, t.media, "timeupdate");
                }, 50), t.media.duration !== l.getDuration() && (t.media.duration = l.getDuration(), triggerEvent.call(t, t.media, "durationchange")));
                break;
              case 2:
                t.muted || t.embed.unMute(), assurePlaybackState$1.call(t, !1);
                break;
              case 3:
                triggerEvent.call(t, t.media, "waiting");
            }
            triggerEvent.call(t, t.elements.container, "statechange", !1, {
              code: a.data
            });
          }
        }
      });
    }
  },
  Mb = {
    setup() {
      this.media ? (toggleClass(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), toggleClass(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && toggleClass(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = createElement$1("div", {
        class: this.config.classNames.video
      }), wrap(this.media, this.elements.wrapper), this.elements.poster = createElement$1("div", {
        class: this.config.classNames.poster
      }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? Kn.setup.call(this) : this.isYouTube ? Sa.setup.call(this) : this.isVimeo && Hf.setup.call(this)) : this.debug.warn("No media element found!");
    }
  };
class Ads {
  constructor(e) {
    _defineProperty(this, "load", () => {
      this.enabled && (x.object(window.google) && x.object(window.google.ima) ? this.ready() : loadScript(this.player.config.urls.googleIMA.sdk).then(() => {
        this.ready();
      }).catch(() => {
        this.trigger("error", new Error("Google IMA SDK failed to load"));
      }));
    }), _defineProperty(this, "ready", () => {
      var n;
      this.enabled || ((n = this).manager && n.manager.destroy(), n.elements.displayContainer && n.elements.displayContainer.destroy(), n.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(() => {
        this.clearSafetyTimer("onAdsManagerLoaded()");
      }), this.listeners(), this.setupIMA();
    }), _defineProperty(this, "setupIMA", () => {
      this.elements.container = createElement$1("div", {
        class: this.player.config.classNames.ads
      }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, n => this.onAdsManagerLoaded(n), !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, n => this.onAdError(n), !1), this.requestAds();
    }), _defineProperty(this, "requestAds", () => {
      const {
        container: n
      } = this.player.elements;
      try {
        const r = new google.ima.AdsRequest();
        r.adTagUrl = this.tagUrl, r.linearAdSlotWidth = n.offsetWidth, r.linearAdSlotHeight = n.offsetHeight, r.nonLinearAdSlotWidth = n.offsetWidth, r.nonLinearAdSlotHeight = n.offsetHeight, r.forceNonLinearFullSlot = !1, r.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(r);
      } catch (r) {
        this.onAdError(r);
      }
    }), _defineProperty(this, "pollCountdown", (n = !1) => {
      if (!n) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
      this.countdownTimer = setInterval(() => {
        const r = formatTime(Math.max(this.manager.getRemainingTime(), 0)),
          i = `${ot.get("advertisement", this.player.config)} - ${r}`;
        this.elements.container.setAttribute("data-badge-text", i);
      }, 100);
    }), _defineProperty(this, "onAdsManagerLoaded", n => {
      if (!this.enabled) return;
      const r = new google.ima.AdsRenderingSettings();
      r.restoreCustomPlaybackStateOnAdBreakComplete = !0, r.enablePreloading = !0, this.manager = n.getAdsManager(this.player, r), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, i => this.onAdError(i)), Object.keys(google.ima.AdEvent.Type).forEach(i => {
        this.manager.addEventListener(google.ima.AdEvent.Type[i], s => this.onAdEvent(s));
      }), this.trigger("loaded");
    }), _defineProperty(this, "addCuePoints", () => {
      x.empty(this.cuePoints) || this.cuePoints.forEach(n => {
        if (n !== 0 && n !== -1 && n < this.player.duration) {
          const r = this.player.elements.progress;
          if (x.element(r)) {
            const i = 100 / this.player.duration * n,
              s = createElement$1("span", {
                class: this.player.config.classNames.cues
              });
            s.style.left = `${i.toString()}%`, r.appendChild(s);
          }
        }
      });
    }), _defineProperty(this, "onAdEvent", n => {
      const {
          container: r
        } = this.player.elements,
        i = n.getAd(),
        s = n.getAdData();
      switch ((a => {
        triggerEvent.call(this.player, this.player.media, `ads${a.replace(/_/g, "").toLowerCase()}`);
      })(n.type), n.type) {
        case google.ima.AdEvent.Type.LOADED:
          this.trigger("loaded"), this.pollCountdown(!0), i.isLinear() || (i.width = r.offsetWidth, i.height = r.offsetHeight);
          break;
        case google.ima.AdEvent.Type.STARTED:
          this.manager.setVolume(this.player.volume);
          break;
        case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
          this.player.ended ? this.loadAds() : this.loader.contentComplete();
          break;
        case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
          this.pauseContent();
          break;
        case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
          this.pollCountdown(), this.resumeContent();
          break;
        case google.ima.AdEvent.Type.LOG:
          s.adError && this.player.debug.warn(`Non-fatal ad error: ${s.adError.getMessage()}`);
      }
    }), _defineProperty(this, "onAdError", n => {
      this.cancel(), this.player.debug.warn("Ads error", n);
    }), _defineProperty(this, "listeners", () => {
      const {
        container: n
      } = this.player.elements;
      let r;
      this.player.on("canplay", () => {
        this.addCuePoints();
      }), this.player.on("ended", () => {
        this.loader.contentComplete();
      }), this.player.on("timeupdate", () => {
        r = this.player.currentTime;
      }), this.player.on("seeked", () => {
        const i = this.player.currentTime;
        x.empty(this.cuePoints) || this.cuePoints.forEach((s, a) => {
          r < s && s < i && (this.manager.discardAdBreak(), this.cuePoints.splice(a, 1));
        });
      }), window.addEventListener("resize", () => {
        this.manager && this.manager.resize(n.offsetWidth, n.offsetHeight, google.ima.ViewMode.NORMAL);
      });
    }), _defineProperty(this, "play", () => {
      const {
        container: n
      } = this.player.elements;
      this.managerPromise || this.resumeContent(), this.managerPromise.then(() => {
        this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
        try {
          this.initialized || (this.manager.init(n.offsetWidth, n.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = !0;
        } catch (r) {
          this.onAdError(r);
        }
      }).catch(() => {});
    }), _defineProperty(this, "resumeContent", () => {
      this.elements.container.style.zIndex = "", this.playing = !1, silencePromise(this.player.media.play());
    }), _defineProperty(this, "pauseContent", () => {
      this.elements.container.style.zIndex = 3, this.playing = !0, this.player.media.pause();
    }), _defineProperty(this, "cancel", () => {
      this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
    }), _defineProperty(this, "loadAds", () => {
      this.managerPromise.then(() => {
        this.manager && this.manager.destroy(), this.managerPromise = new Promise(n => {
          this.on("loaded", n), this.player.debug.log(this.manager);
        }), this.initialized = !1, this.requestAds();
      }).catch(() => {});
    }), _defineProperty(this, "trigger", (n, ...r) => {
      const i = this.events[n];
      x.array(i) && i.forEach(s => {
        x.function(s) && s.apply(this, r);
      });
    }), _defineProperty(this, "on", (n, r) => (x.array(this.events[n]) || (this.events[n] = []), this.events[n].push(r), this)), _defineProperty(this, "startSafetyTimer", (n, r) => {
      this.player.debug.log(`Safety timer invoked from: ${r}`), this.safetyTimer = setTimeout(() => {
        this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
      }, n);
    }), _defineProperty(this, "clearSafetyTimer", n => {
      x.nullOrUndefined(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${n}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
    }), this.player = e, this.config = e.config.ads, this.playing = !1, this.initialized = !1, this.elements = {
      container: null,
      displayContainer: null
    }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((n, r) => {
      this.on("loaded", n), this.on("error", r);
    }), this.load();
  }
  get enabled() {
    const {
      config: e
    } = this;
    return this.player.isHTML5 && this.player.isVideo && e.enabled && (!x.empty(e.publisherId) || x.url(e.tagUrl));
  }
  get tagUrl() {
    const {
      config: e
    } = this;
    return x.url(e.tagUrl) ? e.tagUrl : `https://go.aniview.com/api/adserver6/vast/?${buildUrlParams({
      AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
      AV_CHANNELID: "5a0458dc28a06145e4519d21",
      AV_URL: window.location.hostname,
      cb: Date.now(),
      AV_WIDTH: 640,
      AV_HEIGHT: 480,
      AV_CDIM2: e.publisherId
    })}`;
  }
}
o(Ads, "Ads");
function clamp(t = 0, e = 0, n = 255) {
  return Math.min(Math.max(t, e), n);
}
o(clamp, "clamp");
const parseVtt = o(t => {
    const e = [];
    return t.split(/\r\n\r\n|\n\n|\r\r/).forEach(n => {
      const r = {};
      n.split(/\r\n|\n|\r/).forEach(i => {
        if (x.number(r.startTime)) {
          if (!x.empty(i.trim()) && x.empty(r.text)) {
            const s = i.trim().split("#xywh=");
            [r.text] = s, s[1] && ([r.x, r.y, r.w, r.h] = s[1].split(","));
          }
        } else {
          const s = i.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
          s && (r.startTime = 60 * Number(s[1] || 0) * 60 + 60 * Number(s[2]) + Number(s[3]) + +`0.${s[4]}`, r.endTime = 60 * Number(s[6] || 0) * 60 + 60 * Number(s[7]) + Number(s[8]) + +`0.${s[9]}`);
        }
      }), r.text && e.push(r);
    }), e;
  }, "parseVtt"),
  fitRatio = o((t, e) => {
    const n = {};
    return t > e.width / e.height ? (n.width = e.width, n.height = 1 / t * e.width) : (n.height = e.height, n.width = t * e.height), n;
  }, "fitRatio");
class PreviewThumbnails {
  constructor(e) {
    _defineProperty(this, "load", () => {
      this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(() => {
        this.enabled && (this.render(), this.determineContainerAutoSizing(), this.listeners(), this.loaded = !0);
      });
    }), _defineProperty(this, "getThumbnails", () => new Promise(n => {
      const {
        src: r
      } = this.player.config.previewThumbnails;
      if (x.empty(r)) throw new Error("Missing previewThumbnails.src config attribute");
      const i = o(() => {
        this.thumbnails.sort((s, a) => s.height - a.height), this.player.debug.log("Preview thumbnails", this.thumbnails), n();
      }, "i");
      if (x.function(r)) r(s => {
        this.thumbnails = s, i();
      });else {
        const s = (x.string(r) ? [r] : r).map(a => this.getThumbnail(a));
        Promise.all(s).then(i);
      }
    })), _defineProperty(this, "getThumbnail", n => new Promise(r => {
      fetch$1(n).then(i => {
        const s = {
          frames: parseVtt(i),
          height: null,
          urlPrefix: ""
        };
        s.frames[0].text.startsWith("/") || s.frames[0].text.startsWith("http://") || s.frames[0].text.startsWith("https://") || (s.urlPrefix = n.substring(0, n.lastIndexOf("/") + 1));
        const a = new Image();
        a.onload = () => {
          s.height = a.naturalHeight, s.width = a.naturalWidth, this.thumbnails.push(s), r();
        }, a.src = s.urlPrefix + s.frames[0].text;
      });
    })), _defineProperty(this, "startMove", n => {
      if (this.loaded && x.event(n) && ["touchmove", "mousemove"].includes(n.type) && this.player.media.duration) {
        if (n.type === "touchmove") this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);else {
          var r, i;
          const s = this.player.elements.progress.getBoundingClientRect(),
            a = 100 / s.width * (n.pageX - s.left);
          this.seekTime = this.player.media.duration * (a / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = n.pageX, this.elements.thumb.time.innerText = formatTime(this.seekTime);
          const l = (r = this.player.config.markers) === null || r === void 0 || (i = r.points) === null || i === void 0 ? void 0 : i.find(({
            time: u
          }) => u === Math.round(this.seekTime));
          l && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${l.label}<br>`);
        }
        this.showImageAtCurrentTime();
      }
    }), _defineProperty(this, "endMove", () => {
      this.toggleThumbContainer(!1, !0);
    }), _defineProperty(this, "startScrubbing", n => {
      (x.nullOrUndefined(n.button) || n.button === !1 || n.button === 0) && (this.mouseDown = !0, this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
    }), _defineProperty(this, "endScrubbing", () => {
      this.mouseDown = !1, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(!1) : once.call(this.player, this.player.media, "timeupdate", () => {
        this.mouseDown || this.toggleScrubbingContainer(!1);
      });
    }), _defineProperty(this, "listeners", () => {
      this.player.on("play", () => {
        this.toggleThumbContainer(!1, !0);
      }), this.player.on("seeked", () => {
        this.toggleThumbContainer(!1);
      }), this.player.on("timeupdate", () => {
        this.lastTime = this.player.media.currentTime;
      });
    }), _defineProperty(this, "render", () => {
      this.elements.thumb.container = createElement$1("div", {
        class: this.player.config.classNames.previewThumbnails.thumbContainer
      }), this.elements.thumb.imageContainer = createElement$1("div", {
        class: this.player.config.classNames.previewThumbnails.imageContainer
      }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
      const n = createElement$1("div", {
        class: this.player.config.classNames.previewThumbnails.timeContainer
      });
      this.elements.thumb.time = createElement$1("span", {}, "00:00"), n.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(n), x.element(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = createElement$1("div", {
        class: this.player.config.classNames.previewThumbnails.scrubbingContainer
      }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
    }), _defineProperty(this, "destroy", () => {
      this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
    }), _defineProperty(this, "showImageAtCurrentTime", () => {
      this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
      const n = this.thumbnails[0].frames.findIndex(s => this.seekTime >= s.startTime && this.seekTime <= s.endTime),
        r = n >= 0;
      let i = 0;
      this.mouseDown || this.toggleThumbContainer(r), r && (this.thumbnails.forEach((s, a) => {
        this.loadedImages.includes(s.frames[n].text) && (i = a);
      }), n !== this.showingThumb && (this.showingThumb = n, this.loadImage(i)));
    }), _defineProperty(this, "loadImage", (n = 0) => {
      const r = this.showingThumb,
        i = this.thumbnails[n],
        {
          urlPrefix: s
        } = i,
        a = i.frames[r],
        l = i.frames[r].text,
        u = s + l;
      if (this.currentImageElement && this.currentImageElement.dataset.filename === l) this.showImage(this.currentImageElement, a, n, r, l, !1), this.currentImageElement.dataset.index = r, this.removeOldImages(this.currentImageElement);else {
        this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
        const c = new Image();
        c.src = u, c.dataset.index = r, c.dataset.filename = l, this.showingThumbFilename = l, this.player.debug.log(`Loading image: ${u}`), c.onload = () => this.showImage(c, a, n, r, l, !0), this.loadingImage = c, this.removeOldImages(c);
      }
    }), _defineProperty(this, "showImage", (n, r, i, s, a, l = !0) => {
      this.player.debug.log(`Showing thumb: ${a}. num: ${s}. qual: ${i}. newimg: ${l}`), this.setImageSizeAndOffset(n, r), l && (this.currentImageContainer.appendChild(n), this.currentImageElement = n, this.loadedImages.includes(a) || this.loadedImages.push(a)), this.preloadNearby(s, !0).then(this.preloadNearby(s, !1)).then(this.getHigherQuality(i, n, r, a));
    }), _defineProperty(this, "removeOldImages", n => {
      Array.from(this.currentImageContainer.children).forEach(r => {
        if (r.tagName.toLowerCase() !== "img") return;
        const i = this.usingSprites ? 500 : 1e3;
        if (r.dataset.index !== n.dataset.index && !r.dataset.deleting) {
          r.dataset.deleting = !0;
          const {
            currentImageContainer: s
          } = this;
          setTimeout(() => {
            s.removeChild(r), this.player.debug.log(`Removing thumb: ${r.dataset.filename}`);
          }, i);
        }
      });
    }), _defineProperty(this, "preloadNearby", (n, r = !0) => new Promise(i => {
      setTimeout(() => {
        const s = this.thumbnails[0].frames[n].text;
        if (this.showingThumbFilename === s) {
          let a;
          a = r ? this.thumbnails[0].frames.slice(n) : this.thumbnails[0].frames.slice(0, n).reverse();
          let l = !1;
          a.forEach(u => {
            const c = u.text;
            if (c !== s && !this.loadedImages.includes(c)) {
              l = !0, this.player.debug.log(`Preloading thumb filename: ${c}`);
              const {
                  urlPrefix: p
                } = this.thumbnails[0],
                m = p + c,
                d = new Image();
              d.src = m, d.onload = () => {
                this.player.debug.log(`Preloaded thumb filename: ${c}`), this.loadedImages.includes(c) || this.loadedImages.push(c), i();
              };
            }
          }), l || i();
        }
      }, 300);
    })), _defineProperty(this, "getHigherQuality", (n, r, i, s) => {
      if (n < this.thumbnails.length - 1) {
        let a = r.naturalHeight;
        this.usingSprites && (a = i.h), a < this.thumbContainerHeight && setTimeout(() => {
          this.showingThumbFilename === s && (this.player.debug.log(`Showing higher quality thumb for: ${s}`), this.loadImage(n + 1));
        }, 300);
      }
    }), _defineProperty(this, "toggleThumbContainer", (n = !1, r = !1) => {
      const i = this.player.config.classNames.previewThumbnails.thumbContainerShown;
      this.elements.thumb.container.classList.toggle(i, n), !n && r && (this.showingThumb = null, this.showingThumbFilename = null);
    }), _defineProperty(this, "toggleScrubbingContainer", (n = !1) => {
      const r = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
      this.elements.scrubbing.container.classList.toggle(r, n), n || (this.showingThumb = null, this.showingThumbFilename = null);
    }), _defineProperty(this, "determineContainerAutoSizing", () => {
      (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
    }), _defineProperty(this, "setThumbContainerSizeAndPos", () => {
      const {
        imageContainer: n
      } = this.elements.thumb;
      if (this.sizeSpecifiedInCSS) {
        if (n.clientHeight > 20 && n.clientWidth < 20) {
          const r = Math.floor(n.clientHeight * this.thumbAspectRatio);
          n.style.width = `${r}px`;
        } else if (n.clientHeight < 20 && n.clientWidth > 20) {
          const r = Math.floor(n.clientWidth / this.thumbAspectRatio);
          n.style.height = `${r}px`;
        }
      } else {
        const r = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
        n.style.height = `${this.thumbContainerHeight}px`, n.style.width = `${r}px`;
      }
      this.setThumbContainerPos();
    }), _defineProperty(this, "setThumbContainerPos", () => {
      const n = this.player.elements.progress.getBoundingClientRect(),
        r = this.player.elements.container.getBoundingClientRect(),
        {
          container: i
        } = this.elements.thumb,
        s = r.left - n.left + 10,
        a = r.right - n.left - i.clientWidth - 10,
        l = this.mousePosX - n.left - i.clientWidth / 2,
        u = clamp(l, s, a);
      i.style.left = `${u}px`, i.style.setProperty("--preview-arrow-offset", l - u + "px");
    }), _defineProperty(this, "setScrubbingContainerSize", () => {
      const {
        width: n,
        height: r
      } = fitRatio(this.thumbAspectRatio, {
        width: this.player.media.clientWidth,
        height: this.player.media.clientHeight
      });
      this.elements.scrubbing.container.style.width = `${n}px`, this.elements.scrubbing.container.style.height = `${r}px`;
    }), _defineProperty(this, "setImageSizeAndOffset", (n, r) => {
      if (!this.usingSprites) return;
      const i = this.thumbContainerHeight / r.h;
      n.style.height = n.naturalHeight * i + "px", n.style.width = n.naturalWidth * i + "px", n.style.left = `-${r.x * i}px`, n.style.top = `-${r.y * i}px`;
    }), this.player = e, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = {
      thumb: {},
      scrubbing: {}
    }, this.load();
  }
  get enabled() {
    return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
  }
  get currentImageContainer() {
    return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
  }
  get usingSprites() {
    return Object.keys(this.thumbnails[0].frames[0]).includes("w");
  }
  get thumbAspectRatio() {
    return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
  }
  get thumbContainerHeight() {
    if (this.mouseDown) {
      const {
        height: e
      } = fitRatio(this.thumbAspectRatio, {
        width: this.player.media.clientWidth,
        height: this.player.media.clientHeight
      });
      return e;
    }
    return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
  }
  get currentImageElement() {
    return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
  }
  set currentImageElement(e) {
    this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
  }
}
o(PreviewThumbnails, "PreviewThumbnails");
const Uf = {
  insertElements(t, e) {
    x.string(e) ? insertElement(t, this.media, {
      src: e
    }) : x.array(e) && e.forEach(n => {
      insertElement(t, this.media, n);
    });
  },
  change(t) {
    getDeep(t, "sources.length") ? (Kn.cancelRequests.call(this), this.destroy.call(this, () => {
      this.options.quality = [], removeElement$1(this.media), this.media = null, x.element(this.elements.container) && this.elements.container.removeAttribute("class");
      const {
          sources: e,
          type: n
        } = t,
        [{
          provider: r = qn.html5,
          src: i
        }] = e,
        s = r === "html5" ? n : "div",
        a = r === "html5" ? {} : {
          src: i
        };
      Object.assign(this, {
        provider: r,
        type: n,
        supported: Xe.check(n, r, this.config.playsinline),
        media: createElement$1(s, a)
      }), this.elements.container.appendChild(this.media), x.boolean(t.autoplay) && (this.config.autoplay = t.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), x.empty(t.poster) || (this.poster = t.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), Ae.addStyleHook.call(this), this.isHTML5 && Uf.insertElements.call(this, "source", e), this.config.title = t.title, Mb.setup.call(this), this.isHTML5 && Object.keys(t).includes("tracks") && Uf.insertElements.call(this, "track", t.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Ae.build.call(this), this.isHTML5 && this.media.load(), x.empty(t.previewThumbnails) || (Object.assign(this.config.previewThumbnails, t.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new PreviewThumbnails(this))), this.fullscreen.update();
    }, !0)) : this.debug.warn("Invalid source format");
  }
};
class Plyr {
  constructor(e, n) {
    if (_defineProperty(this, "play", () => x.function(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(() => this.ads.play()).catch(() => silencePromise(this.media.play())), this.media.play()) : null), _defineProperty(this, "pause", () => this.playing && x.function(this.media.pause) ? this.media.pause() : null), _defineProperty(this, "togglePlay", l => (x.boolean(l) ? l : !this.playing) ? this.play() : this.pause()), _defineProperty(this, "stop", () => {
      this.isHTML5 ? (this.pause(), this.restart()) : x.function(this.media.stop) && this.media.stop();
    }), _defineProperty(this, "restart", () => {
      this.currentTime = 0;
    }), _defineProperty(this, "rewind", l => {
      this.currentTime -= x.number(l) ? l : this.config.seekTime;
    }), _defineProperty(this, "forward", l => {
      this.currentTime += x.number(l) ? l : this.config.seekTime;
    }), _defineProperty(this, "increaseVolume", l => {
      const u = this.media.muted ? 0 : this.volume;
      this.volume = u + (x.number(l) ? l : 0);
    }), _defineProperty(this, "decreaseVolume", l => {
      this.increaseVolume(-l);
    }), _defineProperty(this, "airplay", () => {
      Xe.airplay && this.media.webkitShowPlaybackTargetPicker();
    }), _defineProperty(this, "toggleControls", l => {
      if (this.supported.ui && !this.isAudio) {
        const u = hasClass$1(this.elements.container, this.config.classNames.hideControls),
          c = l === void 0 ? void 0 : !l,
          p = toggleClass(this.elements.container, this.config.classNames.hideControls, c);
        if (p && x.array(this.config.controls) && this.config.controls.includes("settings") && !x.empty(this.config.settings) && ee.toggleMenu.call(this, !1), p !== u) {
          const m = p ? "controlshidden" : "controlsshown";
          triggerEvent.call(this, this.media, m);
        }
        return !p;
      }
      return !1;
    }), _defineProperty(this, "on", (l, u) => {
      on$1.call(this, this.elements.container, l, u);
    }), _defineProperty(this, "once", (l, u) => {
      once.call(this, this.elements.container, l, u);
    }), _defineProperty(this, "off", (l, u) => {
      off(this.elements.container, l, u);
    }), _defineProperty(this, "destroy", (l, u = !1) => {
      if (!this.ready) return;
      const i$1 = o(() => {
        document.body.style.overflow = "", this.embed = null, u ? (Object.keys(this.elements).length && (removeElement$1(this.elements.buttons.play), removeElement$1(this.elements.captions), removeElement$1(this.elements.controls), removeElement$1(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), x.function(l) && l()) : (unbindListeners.call(this), Kn.cancelRequests.call(this), replaceElement(this.elements.original, this.elements.container), triggerEvent.call(this, this.elements.original, "destroyed", !0), x.function(l) && l.call(this.elements.original), this.ready = !1, setTimeout(() => {
          this.elements = null, this.media = null;
        }, 200));
      }, "i");
      this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (Ae.toggleNativeControls.call(this, !0), i$1()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), this.embed !== null && x.function(this.embed.destroy) && this.embed.destroy(), i$1()) : this.isVimeo && (this.embed !== null && this.embed.unload().then(i$1), setTimeout(i$1, 200));
    }), _defineProperty(this, "supports", l => Xe.mime.call(this, l)), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = Xe.touch, this.media = e, x.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || x.nodeList(this.media) || x.array(this.media)) && (this.media = this.media[0]), this.config = extend$4({}, Ob, Plyr.defaults, n || {}, (() => {
      try {
        return JSON.parse(this.media.getAttribute("data-plyr-config"));
      } catch {
        return {};
      }
    })()), this.elements = {
      container: null,
      fullscreen: null,
      captions: null,
      buttons: {},
      display: {},
      progress: {},
      inputs: {},
      settings: {
        popup: null,
        menu: null,
        panels: {},
        buttons: {}
      }
    }, this.captions = {
      active: null,
      currentTrack: -1,
      meta: new WeakMap()
    }, this.fullscreen = {
      active: !1
    }, this.options = {
      speed: [],
      quality: []
    }, this.debug = new Console(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", Xe), x.nullOrUndefined(this.media) || !x.element(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
    if (this.media.plyr) return void this.debug.warn("Target already setup");
    if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
    if (!Xe.check().api) return void this.debug.error("Setup failed: no support");
    const r = this.media.cloneNode(!0);
    r.autoplay = !1, this.elements.original = r;
    const i = this.media.tagName.toLowerCase();
    let s = null,
      a = null;
    switch (i) {
      case "div":
        if (s = this.media.querySelector("iframe"), x.element(s)) {
          if (a = parseUrl$1(s.getAttribute("src")), this.provider = getProviderByUrl(a.toString()), this.elements.container = this.media, this.media = s, this.elements.container.className = "", a.search.length) {
            const l = ["1", "true"];
            l.includes(a.searchParams.get("autoplay")) && (this.config.autoplay = !0), l.includes(a.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = l.includes(a.searchParams.get("playsinline")), this.config.youtube.hl = a.searchParams.get("hl")) : this.config.playsinline = !0;
          }
        } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
        if (x.empty(this.provider) || !Object.values(qn).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
        this.type = _c.video;
        break;
      case "video":
      case "audio":
        this.type = i, this.provider = qn.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
        break;
      default:
        return void this.debug.error("Setup failed: unsupported type");
    }
    this.supported = Xe.check(this.type, this.provider), this.supported.api ? (this.eventListeners = [], this.listeners = new Listeners(this), this.storage = new Storage(this), this.media.plyr = this, x.element(this.elements.container) || (this.elements.container = createElement$1("div"), wrap(this.media, this.elements.container)), Ae.migrateStyles.call(this), Ae.addStyleHook.call(this), Mb.setup.call(this), this.config.debug && on$1.call(this, this.elements.container, this.config.events.join(" "), l => {
      this.debug.log(`event: ${l.type}`);
    }), this.fullscreen = new Fullscreen(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Ae.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new Ads(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", () => silencePromise(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new PreviewThumbnails(this))) : this.debug.error("Setup failed: no support");
  }
  get isHTML5() {
    return this.provider === qn.html5;
  }
  get isEmbed() {
    return this.isYouTube || this.isVimeo;
  }
  get isYouTube() {
    return this.provider === qn.youtube;
  }
  get isVimeo() {
    return this.provider === qn.vimeo;
  }
  get isVideo() {
    return this.type === _c.video;
  }
  get isAudio() {
    return this.type === _c.audio;
  }
  get playing() {
    return !!(this.ready && !this.paused && !this.ended);
  }
  get paused() {
    return !!this.media.paused;
  }
  get stopped() {
    return !!(this.paused && this.currentTime === 0);
  }
  get ended() {
    return !!this.media.ended;
  }
  set currentTime(e) {
    if (!this.duration) return;
    const n = x.number(e) && e > 0;
    this.media.currentTime = n ? Math.min(e, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
  }
  get currentTime() {
    return Number(this.media.currentTime);
  }
  get buffered() {
    const {
      buffered: e
    } = this.media;
    return x.number(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
  }
  get seeking() {
    return !!this.media.seeking;
  }
  get duration() {
    const e = parseFloat(this.config.duration),
      n = (this.media || {}).duration,
      r = x.number(n) && n !== 1 / 0 ? n : 0;
    return e || r;
  }
  set volume(e) {
    let n = e;
    x.string(n) && (n = Number(n)), x.number(n) || (n = this.storage.get("volume")), x.number(n) || ({
      volume: n
    } = this.config), n > 1 && (n = 1), n < 0 && (n = 0), this.config.volume = n, this.media.volume = n, !x.empty(e) && this.muted && n > 0 && (this.muted = !1);
  }
  get volume() {
    return Number(this.media.volume);
  }
  set muted(e) {
    let n = e;
    x.boolean(n) || (n = this.storage.get("muted")), x.boolean(n) || (n = this.config.muted), this.config.muted = n, this.media.muted = n;
  }
  get muted() {
    return !!this.media.muted;
  }
  get hasAudio() {
    return !this.isHTML5 || !!this.isAudio || !!this.media.mozHasAudio || !!this.media.webkitAudioDecodedByteCount || !!(this.media.audioTracks && this.media.audioTracks.length);
  }
  set speed(e) {
    let n = null;
    x.number(e) && (n = e), x.number(n) || (n = this.storage.get("speed")), x.number(n) || (n = this.config.speed.selected);
    const {
      minimumSpeed: r,
      maximumSpeed: i
    } = this;
    n = clamp(n, r, i), this.config.speed.selected = n, setTimeout(() => {
      this.media && (this.media.playbackRate = n);
    }, 0);
  }
  get speed() {
    return Number(this.media.playbackRate);
  }
  get minimumSpeed() {
    return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? .5 : .0625;
  }
  get maximumSpeed() {
    return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
  }
  set quality(e) {
    const n = this.config.quality,
      r = this.options.quality;
    if (!r.length) return;
    let i = [!x.empty(e) && Number(e), this.storage.get("quality"), n.selected, n.default].find(x.number),
      s = !0;
    if (!r.includes(i)) {
      const a = closest$2(r, i);
      this.debug.warn(`Unsupported quality option: ${i}, using ${a} instead`), i = a, s = !1;
    }
    n.selected = i, this.media.quality = i, s && this.storage.set({
      quality: i
    });
  }
  get quality() {
    return this.media.quality;
  }
  set loop(e) {
    const n = x.boolean(e) ? e : this.config.loop.active;
    this.config.loop.active = n, this.media.loop = n;
  }
  get loop() {
    return !!this.media.loop;
  }
  set source(e) {
    Uf.change.call(this, e);
  }
  get source() {
    return this.media.currentSrc;
  }
  get download() {
    const {
      download: e
    } = this.config.urls;
    return x.url(e) ? e : this.source;
  }
  set download(e) {
    x.url(e) && (this.config.urls.download = e, ee.setDownloadUrl.call(this));
  }
  set poster(e) {
    this.isVideo ? Ae.setPoster.call(this, e, !1).catch(() => {}) : this.debug.warn("Poster can only be set for video");
  }
  get poster() {
    return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
  }
  get ratio() {
    if (!this.isVideo) return null;
    const e = reduceAspectRatio(getAspectRatio.call(this));
    return x.array(e) ? e.join(":") : e;
  }
  set ratio(e) {
    this.isVideo ? x.string(e) && validateAspectRatio(e) ? (this.config.ratio = reduceAspectRatio(e), setAspectRatio.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`) : this.debug.warn("Aspect ratio can only be set for video");
  }
  set autoplay(e) {
    this.config.autoplay = x.boolean(e) ? e : this.config.autoplay;
  }
  get autoplay() {
    return !!this.config.autoplay;
  }
  toggleCaptions(e) {
    Ce.toggle.call(this, e, !1);
  }
  set currentTrack(e) {
    Ce.set.call(this, e, !1), Ce.setup.call(this);
  }
  get currentTrack() {
    const {
      toggled: e,
      currentTrack: n
    } = this.captions;
    return e ? n : -1;
  }
  set language(e) {
    Ce.setLanguage.call(this, e, !1);
  }
  get language() {
    return (Ce.getCurrentTrack.call(this) || {}).language;
  }
  set pip(e) {
    if (!Xe.pip) return;
    const n = x.boolean(e) ? e : !this.pip;
    x.function(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(n ? kc.active : kc.inactive), x.function(this.media.requestPictureInPicture) && (!this.pip && n ? this.media.requestPictureInPicture() : this.pip && !n && document.exitPictureInPicture());
  }
  get pip() {
    return Xe.pip ? x.empty(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === kc.active : null;
  }
  setPreviewThumbnails(e) {
    this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new PreviewThumbnails(this));
  }
  static supported(e, n) {
    return Xe.check(e, n);
  }
  static loadSprite(e, n) {
    return loadSprite(e, n);
  }
  static setup(e, n = {}) {
    let r = null;
    return x.string(e) ? r = Array.from(document.querySelectorAll(e)) : x.nodeList(e) ? r = Array.from(e) : x.array(e) && (r = e.filter(x.element)), x.empty(r) ? null : r.map(i => new Plyr(i, n));
  }
}
o(Plyr, "Plyr");
Plyr.defaults = cloneDeep(Ob);
export { Autoplay, BaseCart, BaseComponent, Controller, EffectFade, HashNavigation, Loader, Mousewheel, Navigation, Pagination, Plyr, Scrollbar, Swiper, Thumb, Zoom, axios, biggerPicture, debounce, dist, isNumber, main, noUiSlider, queryString, throttle };